(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.ar.Y === region.az.Y)
	{
		return 'on line ' + region.ar.Y;
	}
	return 'on lines ' + region.ar.Y + ' through ' + region.az.Y;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cv,
		impl.dF,
		impl.dq,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		cN: func(record.cN),
		as: record.as,
		ao: record.ao
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.cN;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.as;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ao) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cv,
		impl.dF,
		impl.dq,
		function(sendToApp, initialModel) {
			var view = impl.dI;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cv,
		impl.dF,
		impl.dq,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aq && impl.aq(sendToApp)
			var view = impl.dI;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.bI);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.dy) && (_VirtualDom_doc.title = title = doc.dy);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.cY;
	var onUrlRequest = impl.cZ;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aq: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.aW === next.aW
							&& curr.aG === next.aG
							&& curr.aT.a === next.aT.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		cv: function(flags)
		{
			return A3(impl.cv, flags, _Browser_getUrl(), key);
		},
		dI: impl.dI,
		dF: impl.dF,
		dq: impl.dq
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { cm: 'hidden', bO: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { cm: 'mozHidden', bO: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { cm: 'msHidden', bO: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { cm: 'webkitHidden', bO: 'webkitvisibilitychange' }
		: { cm: 'hidden', bO: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		a3: _Browser_getScene(),
		dJ: {
			bl: _Browser_window.pageXOffset,
			bm: _Browser_window.pageYOffset,
			bk: _Browser_doc.documentElement.clientWidth,
			aE: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bk: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		aE: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			a3: {
				bk: node.scrollWidth,
				aE: node.scrollHeight
			},
			dJ: {
				bl: node.scrollLeft,
				bm: node.scrollTop,
				bk: node.clientWidth,
				aE: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			a3: _Browser_getScene(),
			dJ: {
				bl: x,
				bm: y,
				bk: _Browser_doc.documentElement.clientWidth,
				aE: _Browser_doc.documentElement.clientHeight
			},
			b1: {
				bl: x + rect.left,
				bm: y + rect.top,
				bk: rect.width,
				aE: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.b5.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.b5.b, xhr)); });
		$elm$core$Maybe$isJust(request.be) && _Http_track(router, xhr, request.be.a);

		try {
			xhr.open(request.cO, request.dG, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.dG));
		}

		_Http_configureRequest(xhr, request);

		request.bI.a && xhr.setRequestHeader('Content-Type', request.bI.a);
		xhr.send(request.bI.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.aD; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.dx.a || 0;
	xhr.responseType = request.b5.d;
	xhr.withCredentials = request.bp;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		dG: xhr.responseURL,
		dk: xhr.status,
		dl: xhr.statusText,
		aD: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			dd: event.loaded,
			a7: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			c5: event.loaded,
			a7: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}var $author$project$Domain$Types$LinkClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $MartinSStewart$elm_audio$Audio$UserMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.a) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.c),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.c);
		} else {
			var treeLen = builder.a * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.d) : builder.d;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.a);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.c) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.c);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{d: nodeList, a: (len / $elm$core$Array$branchFactor) | 0, c: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {aB: fragment, aG: host, aR: path, aT: port_, aW: protocol, aX: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $MartinSStewart$elm_audio$Audio$AudioData = $elm$core$Basics$identity;
var $MartinSStewart$elm_audio$Audio$audioData = function (_v0) {
	var model = _v0;
	return {q: model.q};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $MartinSStewart$elm_audio$Audio$getUserModel = function (_v0) {
	var model = _v0;
	return model.z;
};
var $MartinSStewart$elm_audio$Audio$Model = $elm$core$Basics$identity;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $MartinSStewart$elm_audio$Audio$audioSourceBufferId = function (_v0) {
	var audioSource = _v0;
	return audioSource.V;
};
var $ianmackenzie$elm_units$Duration$inSeconds = function (_v0) {
	var numSeconds = _v0;
	return numSeconds;
};
var $ianmackenzie$elm_units$Duration$inMilliseconds = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) * 1000;
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$core$Basics$round = _Basics_round;
var $ianmackenzie$elm_units$Duration$addTo = F2(
	function (time, duration) {
		return $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(time) + $elm$core$Basics$round(
				$ianmackenzie$elm_units$Duration$inMilliseconds(duration)));
	});
var $MartinSStewart$elm_audio$Audio$audioStartTime = function (audio_) {
	return A2($ianmackenzie$elm_units$Duration$addTo, audio_.aa, audio_.O);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $MartinSStewart$elm_audio$Audio$encodeBufferId = function (_v0) {
	var bufferId = _v0;
	return $elm$json$Json$Encode$int(bufferId);
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $MartinSStewart$elm_audio$Audio$encodeDuration = A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Duration$inMilliseconds, $elm$json$Json$Encode$float);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $MartinSStewart$elm_audio$Audio$encodeLoopConfig = function (maybeLoop) {
	if (!maybeLoop.$) {
		var loop = maybeLoop.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'loopStart',
					$MartinSStewart$elm_audio$Audio$encodeDuration(loop.aM)),
					_Utils_Tuple2(
					'loopEnd',
					$MartinSStewart$elm_audio$Audio$encodeDuration(loop.aL))
				]));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $MartinSStewart$elm_audio$Audio$encodeTime = A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int);
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $mgold$elm_nonempty_list$List$Nonempty$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $MartinSStewart$elm_audio$Audio$encodeVolumeTimeline = function (volumeTimeline) {
	return A2(
		$elm$json$Json$Encode$list,
		function (_v0) {
			var time = _v0.a;
			var volume = _v0.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'time',
						$MartinSStewart$elm_audio$Audio$encodeTime(time)),
						_Utils_Tuple2(
						'volume',
						$elm$json$Json$Encode$float(volume))
					]));
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(volumeTimeline));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mgold$elm_nonempty_list$List$Nonempty$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			f(x),
			A2($elm$core$List$map, f, xs));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $MartinSStewart$elm_audio$Audio$volumeTimelines = function (audio_) {
	return A2(
		$elm$core$List$map,
		$mgold$elm_nonempty_list$List$Nonempty$map(
			$elm$core$Tuple$mapFirst(
				function (a) {
					return A2($ianmackenzie$elm_units$Duration$addTo, a, audio_.O);
				})),
		audio_.af);
};
var $MartinSStewart$elm_audio$Audio$encodeStartSound = F2(
	function (nodeGroupId, audio_) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string('startSound')),
					_Utils_Tuple2(
					'nodeGroupId',
					$elm$json$Json$Encode$int(nodeGroupId)),
					_Utils_Tuple2(
					'bufferId',
					$MartinSStewart$elm_audio$Audio$encodeBufferId(
						$MartinSStewart$elm_audio$Audio$audioSourceBufferId(audio_.I))),
					_Utils_Tuple2(
					'startTime',
					$MartinSStewart$elm_audio$Audio$encodeTime(
						$MartinSStewart$elm_audio$Audio$audioStartTime(audio_))),
					_Utils_Tuple2(
					'startAt',
					$MartinSStewart$elm_audio$Audio$encodeDuration(audio_.x)),
					_Utils_Tuple2(
					'volume',
					$elm$json$Json$Encode$float(audio_.S)),
					_Utils_Tuple2(
					'volumeTimelines',
					A2(
						$elm$json$Json$Encode$list,
						$MartinSStewart$elm_audio$Audio$encodeVolumeTimeline,
						$MartinSStewart$elm_audio$Audio$volumeTimelines(audio_))),
					_Utils_Tuple2(
					'loop',
					$MartinSStewart$elm_audio$Audio$encodeLoopConfig(audio_.C)),
					_Utils_Tuple2(
					'playbackRate',
					$elm$json$Json$Encode$float(audio_.E))
				]));
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Quantity$plus = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return x + y;
	});
var $ianmackenzie$elm_units$Quantity$zero = 0;
var $MartinSStewart$elm_audio$Audio$flattenAudio = function (audio_) {
	switch (audio_.$) {
		case 0:
			var group_ = audio_.a;
			return $elm$core$List$concat(
				A2($elm$core$List$map, $MartinSStewart$elm_audio$Audio$flattenAudio, group_));
		case 1:
			var source = audio_.a.I;
			var startTime = audio_.a.aa;
			var settings = audio_.a.de;
			return _List_fromArray(
				[
					{C: settings.C, O: $ianmackenzie$elm_units$Quantity$zero, E: settings.E, I: source, x: settings.x, aa: startTime, S: 1, af: _List_Nil}
				]);
		default:
			var effect = audio_.a;
			var _v1 = effect.ag;
			switch (_v1.$) {
				case 0:
					var scaleVolume_ = _v1.a;
					return A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_update(
								a,
								{S: scaleVolume_.a2 * a.S});
						},
						$MartinSStewart$elm_audio$Audio$flattenAudio(effect.bA));
				case 1:
					var volumeAt = _v1.a.bj;
					return A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_update(
								a,
								{
									af: A2($elm$core$List$cons, volumeAt, a.af)
								});
						},
						$MartinSStewart$elm_audio$Audio$flattenAudio(effect.bA));
				default:
					var duration = _v1.a;
					return A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_update(
								a,
								{
									O: A2($ianmackenzie$elm_units$Quantity$plus, duration, a.O)
								});
						},
						$MartinSStewart$elm_audio$Audio$flattenAudio(effect.bA));
			}
	}
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $MartinSStewart$elm_audio$Audio$encodeSetLoopConfig = F2(
	function (nodeGroupId, loop) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nodeGroupId',
					$elm$json$Json$Encode$int(nodeGroupId)),
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string('setLoopConfig')),
					_Utils_Tuple2(
					'loop',
					$MartinSStewart$elm_audio$Audio$encodeLoopConfig(loop))
				]));
	});
var $MartinSStewart$elm_audio$Audio$encodeSetPlaybackRate = F2(
	function (nodeGroupId, playbackRate) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nodeGroupId',
					$elm$json$Json$Encode$int(nodeGroupId)),
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string('setPlaybackRate')),
					_Utils_Tuple2(
					'playbackRate',
					$elm$json$Json$Encode$float(playbackRate))
				]));
	});
var $MartinSStewart$elm_audio$Audio$encodeSetVolume = F2(
	function (nodeGroupId, volume) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nodeGroupId',
					$elm$json$Json$Encode$int(nodeGroupId)),
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string('setVolume')),
					_Utils_Tuple2(
					'volume',
					$elm$json$Json$Encode$float(volume))
				]));
	});
var $MartinSStewart$elm_audio$Audio$encodeSetVolumeAt = F2(
	function (nodeGroupId, volumeTimelines_) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'nodeGroupId',
					$elm$json$Json$Encode$int(nodeGroupId)),
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string('setVolumeAt')),
					_Utils_Tuple2(
					'volumeAt',
					A2($elm$json$Json$Encode$list, $MartinSStewart$elm_audio$Audio$encodeVolumeTimeline, volumeTimelines_))
				]));
	});
var $MartinSStewart$elm_audio$Audio$encodeStopSound = function (nodeGroupId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('stopSound')),
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId))
			]));
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $MartinSStewart$elm_audio$Audio$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $MartinSStewart$elm_audio$Audio$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var tail = $elm$core$List$tail(
				A2($elm$core$List$drop, index, l));
			var head = A2($elm$core$List$take, index, l);
			if (tail.$ === 1) {
				return l;
			} else {
				var t = tail.a;
				return A2($elm$core$List$append, head, t);
			}
		}
	});
var $MartinSStewart$elm_audio$Audio$updateAudioState = F2(
	function (_v0, _v1) {
		var nodeGroupId = _v0.a;
		var audioGroup = _v0.b;
		var flattenedAudio = _v1.a;
		var audioState = _v1.b;
		var json = _v1.c;
		var validAudio = A2(
			$elm$core$List$filter,
			function (_v7) {
				var a = _v7.b;
				return _Utils_eq(a.I, audioGroup.I) && (_Utils_eq(
					$MartinSStewart$elm_audio$Audio$audioStartTime(a),
					$MartinSStewart$elm_audio$Audio$audioStartTime(audioGroup)) && _Utils_eq(a.x, audioGroup.x));
			},
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, flattenedAudio));
		var _v2 = A2(
			$MartinSStewart$elm_audio$Audio$find,
			function (_v3) {
				var a = _v3.b;
				return _Utils_eq(a, audioGroup);
			},
			validAudio);
		if (!_v2.$) {
			var _v4 = _v2.a;
			var index = _v4.a;
			return _Utils_Tuple3(
				A2($MartinSStewart$elm_audio$Audio$removeAt, index, flattenedAudio),
				audioState,
				json);
		} else {
			if (validAudio.b) {
				var _v6 = validAudio.a;
				var index = _v6.a;
				var a = _v6.b;
				var encodeValue = F2(
					function (getter, encoder) {
						return _Utils_eq(
							getter(audioGroup),
							getter(a)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								encoder,
								nodeGroupId,
								getter(a)));
					});
				var effects = A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							encodeValue,
							function ($) {
								return $.S;
							},
							$MartinSStewart$elm_audio$Audio$encodeSetVolume),
							A2(
							encodeValue,
							function ($) {
								return $.C;
							},
							$MartinSStewart$elm_audio$Audio$encodeSetLoopConfig),
							A2(
							encodeValue,
							function ($) {
								return $.E;
							},
							$MartinSStewart$elm_audio$Audio$encodeSetPlaybackRate),
							A2(encodeValue, $MartinSStewart$elm_audio$Audio$volumeTimelines, $MartinSStewart$elm_audio$Audio$encodeSetVolumeAt)
						]));
				return _Utils_Tuple3(
					A2($MartinSStewart$elm_audio$Audio$removeAt, index, flattenedAudio),
					A3($elm$core$Dict$insert, nodeGroupId, a, audioState),
					_Utils_ap(effects, json));
			} else {
				return _Utils_Tuple3(
					flattenedAudio,
					A2($elm$core$Dict$remove, nodeGroupId, audioState),
					A2(
						$elm$core$List$cons,
						$MartinSStewart$elm_audio$Audio$encodeStopSound(nodeGroupId),
						json));
			}
		}
	});
var $MartinSStewart$elm_audio$Audio$diffAudioState = F3(
	function (nodeGroupIdCounter, audioState, newAudio) {
		var _v0 = A3(
			$elm$core$List$foldl,
			$MartinSStewart$elm_audio$Audio$updateAudioState,
			_Utils_Tuple3(
				$MartinSStewart$elm_audio$Audio$flattenAudio(newAudio),
				audioState,
				_List_Nil),
			$elm$core$Dict$toList(audioState));
		var newAudioLeft = _v0.a;
		var newAudioState = _v0.b;
		var json2 = _v0.c;
		var _v1 = A3(
			$elm$core$List$foldl,
			F2(
				function (audioLeft, _v2) {
					var counter = _v2.a;
					var audioState_ = _v2.b;
					var json_ = _v2.c;
					return _Utils_Tuple3(
						counter + 1,
						A3($elm$core$Dict$insert, counter, audioLeft, audioState_),
						A2(
							$elm$core$List$cons,
							A2($MartinSStewart$elm_audio$Audio$encodeStartSound, counter, audioLeft),
							json_));
				}),
			_Utils_Tuple3(nodeGroupIdCounter, newAudioState, json2),
			newAudioLeft);
		var newNodeGroupIdCounter = _v1.a;
		var newAudioState2 = _v1.b;
		var json3 = _v1.c;
		return _Utils_Tuple3(newAudioState2, newNodeGroupIdCounter, json3);
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $MartinSStewart$elm_audio$Audio$encodeAudioLoadRequest = F2(
	function (index, audioLoad) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'audioUrl',
					$elm$json$Json$Encode$string(audioLoad.U)),
					_Utils_Tuple2(
					'requestId',
					$elm$json$Json$Encode$int(index))
				]));
	});
var $MartinSStewart$elm_audio$Audio$flattenAudioCmd = function (audioCmd) {
	if (!audioCmd.$) {
		var data = audioCmd.a;
		return _List_fromArray(
			[data]);
	} else {
		var list = audioCmd.a;
		return $elm$core$List$concat(
			A2($elm$core$List$map, $MartinSStewart$elm_audio$Audio$flattenAudioCmd, list));
	}
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $MartinSStewart$elm_audio$Audio$encodeAudioCmd = F2(
	function (_v0, audioCmd) {
		var model = _v0;
		var flattenedAudioCmd = $MartinSStewart$elm_audio$Audio$flattenAudioCmd(audioCmd);
		var newPendingRequests = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, request) {
					return _Utils_Tuple2(model.G + index, request);
				}),
			flattenedAudioCmd);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					f: A2(
						$elm$core$Dict$union,
						model.f,
						$elm$core$Dict$fromList(newPendingRequests)),
					G: model.G + $elm$core$List$length(flattenedAudioCmd)
				}),
			A2(
				$elm$json$Json$Encode$list,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var index = _v1.a;
						var value = _v1.b;
						return A2($MartinSStewart$elm_audio$Audio$encodeAudioLoadRequest, index, value);
					},
					newPendingRequests)));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $MartinSStewart$elm_audio$Audio$initHelper = F3(
	function (audioPort, audioFunc, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		var audioCmds = _v0.c;
		var _v1 = A3(
			$MartinSStewart$elm_audio$Audio$diffAudioState,
			0,
			$elm$core$Dict$empty,
			A2(
				audioFunc,
				{q: $elm$core$Dict$empty},
				model));
		var audioState = _v1.a;
		var newNodeGroupIdCounter = _v1.b;
		var json = _v1.c;
		var initialModel = {K: audioState, N: newNodeGroupIdCounter, f: $elm$core$Dict$empty, G: 0, H: $elm$core$Maybe$Nothing, q: $elm$core$Dict$empty, z: model};
		var _v2 = A2($MartinSStewart$elm_audio$Audio$encodeAudioCmd, initialModel, audioCmds);
		var initialModel2 = _v2.a;
		var audioRequests = _v2.b;
		var portMessage = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'audio',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, json)),
					_Utils_Tuple2('audioCmds', audioRequests)
				]));
		return _Utils_Tuple2(
			initialModel2,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $MartinSStewart$elm_audio$Audio$UserMsg, cmds),
						audioPort(portMessage)
					])));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $MartinSStewart$elm_audio$Audio$FromJSMsg = function (a) {
	return {$: 0, a: a};
};
var $MartinSStewart$elm_audio$Audio$JsonParseError = function (a) {
	return {$: 3, a: a};
};
var $MartinSStewart$elm_audio$Audio$AudioLoadFailed = function (a) {
	return {$: 1, a: a};
};
var $MartinSStewart$elm_audio$Audio$AudioLoadSuccess = function (a) {
	return {$: 0, a: a};
};
var $MartinSStewart$elm_audio$Audio$InitAudioContext = function (a) {
	return {$: 2, a: a};
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $MartinSStewart$elm_audio$Audio$BufferId = $elm$core$Basics$identity;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $MartinSStewart$elm_audio$Audio$decodeBufferId = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $MartinSStewart$elm_audio$Audio$FailedToDecode = 0;
var $MartinSStewart$elm_audio$Audio$NetworkError = 1;
var $MartinSStewart$elm_audio$Audio$UnknownError = 2;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $MartinSStewart$elm_audio$Audio$decodeLoadError = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'NetworkError':
				return $elm$json$Json$Decode$succeed(1);
			case 'MediaDecodeAudioDataUnknownContentType':
				return $elm$json$Json$Decode$succeed(0);
			case 'DOMException: The buffer passed to decodeAudioData contains an unknown content type.':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $ianmackenzie$elm_units$Duration$seconds = function (numSeconds) {
	return numSeconds;
};
var $MartinSStewart$elm_audio$Audio$decodeFromJSMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 0:
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (requestId, error) {
							return $MartinSStewart$elm_audio$Audio$AudioLoadFailed(
								{X: error, ai: requestId});
						}),
					A2($elm$json$Json$Decode$field, 'requestId', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'error', $MartinSStewart$elm_audio$Audio$decodeLoadError));
			case 1:
				return A4(
					$elm$json$Json$Decode$map3,
					F3(
						function (requestId, bufferId, duration) {
							return $MartinSStewart$elm_audio$Audio$AudioLoadSuccess(
								{
									V: bufferId,
									W: $ianmackenzie$elm_units$Duration$seconds(duration),
									ai: requestId
								});
						}),
					A2($elm$json$Json$Decode$field, 'requestId', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'bufferId', $MartinSStewart$elm_audio$Audio$decodeBufferId),
					A2($elm$json$Json$Decode$field, 'durationInSeconds', $elm$json$Json$Decode$float));
			case 2:
				return A2(
					$elm$json$Json$Decode$map,
					function (samplesPerSecond) {
						return $MartinSStewart$elm_audio$Audio$InitAudioContext(
							{H: samplesPerSecond});
					},
					A2($elm$json$Json$Decode$field, 'samplesPerSecond', $elm$json$Json$Decode$int));
			default:
				return $elm$json$Json$Decode$succeed(
					$MartinSStewart$elm_audio$Audio$JsonParseError(
						{
							X: 'Type ' + ($elm$core$String$fromInt(value) + ' not handled.')
						}));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $MartinSStewart$elm_audio$Audio$fromJSPortSub = function (json) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $MartinSStewart$elm_audio$Audio$decodeFromJSMsg, json);
	if (!_v0.$) {
		var value = _v0.a;
		return $MartinSStewart$elm_audio$Audio$FromJSMsg(value);
	} else {
		var error = _v0.a;
		return $MartinSStewart$elm_audio$Audio$FromJSMsg(
			$MartinSStewart$elm_audio$Audio$JsonParseError(
				{
					X: $elm$json$Json$Decode$errorToString(error)
				}));
	}
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $MartinSStewart$elm_audio$Audio$subscriptions = F2(
	function (app, _v0) {
		var model = _v0;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$MartinSStewart$elm_audio$Audio$UserMsg,
					A2(
						app.dq,
						$MartinSStewart$elm_audio$Audio$audioData(model),
						model.z)),
					app.bD.ce($MartinSStewart$elm_audio$Audio$fromJSPortSub)
				]));
	});
var $MartinSStewart$elm_audio$Audio$File = $elm$core$Basics$identity;
var $MartinSStewart$elm_audio$Audio$flip = F3(
	function (func, a, b) {
		return A2(func, b, a);
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $mgold$elm_nonempty_list$List$Nonempty$head = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return x;
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $MartinSStewart$elm_audio$Audio$rawBufferId = function (_v0) {
	var bufferId = _v0;
	return bufferId;
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $MartinSStewart$elm_audio$Audio$updateHelper = F4(
	function (audioPort, audioFunc, userUpdate, _v0) {
		var model = _v0;
		var audioData_ = $MartinSStewart$elm_audio$Audio$audioData(model);
		var _v1 = A2(userUpdate, audioData_, model.z);
		var newUserModel = _v1.a;
		var userCmd = _v1.b;
		var audioCmds = _v1.c;
		var _v2 = A3(
			$MartinSStewart$elm_audio$Audio$diffAudioState,
			model.N,
			model.K,
			A2(audioFunc, audioData_, newUserModel));
		var audioState = _v2.a;
		var newNodeGroupIdCounter = _v2.b;
		var json = _v2.c;
		var newModel = _Utils_update(
			model,
			{K: audioState, N: newNodeGroupIdCounter, z: newUserModel});
		var _v3 = A2($MartinSStewart$elm_audio$Audio$encodeAudioCmd, newModel, audioCmds);
		var newModel2 = _v3.a;
		var audioRequests = _v3.b;
		var portMessage = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'audio',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, json)),
					_Utils_Tuple2('audioCmds', audioRequests)
				]));
		return _Utils_Tuple2(
			newModel2,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $MartinSStewart$elm_audio$Audio$UserMsg, userCmd),
						audioPort(portMessage)
					])));
	});
var $MartinSStewart$elm_audio$Audio$update = F3(
	function (app, msg, _v0) {
		var model = _v0;
		if (msg.$ === 1) {
			var userMsg = msg.a;
			return A4(
				$MartinSStewart$elm_audio$Audio$updateHelper,
				app.bD.dz,
				app.bA,
				A2($MartinSStewart$elm_audio$Audio$flip, app.dF, userMsg),
				model);
		} else {
			var response = msg.a;
			switch (response.$) {
				case 0:
					var requestId = response.a.ai;
					var bufferId = response.a.V;
					var duration = response.a.W;
					var _v3 = A2($elm$core$Dict$get, requestId, model.f);
					if (!_v3.$) {
						var pendingRequest = _v3.a;
						var sourceData = A3(
							$elm$core$Dict$insert,
							$MartinSStewart$elm_audio$Audio$rawBufferId(bufferId),
							{W: duration},
							model.q);
						var source = $elm$core$Result$Ok(
							{V: bufferId});
						var maybeUserMsg = A2(
							$MartinSStewart$elm_audio$Audio$find,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(source)),
							$mgold$elm_nonempty_list$List$Nonempty$toList(pendingRequest.A));
						if (!maybeUserMsg.$) {
							var _v5 = maybeUserMsg.a;
							var userMsg = _v5.b;
							return A4(
								$MartinSStewart$elm_audio$Audio$updateHelper,
								app.bD.dz,
								app.bA,
								A2($MartinSStewart$elm_audio$Audio$flip, app.dF, userMsg),
								_Utils_update(
									model,
									{
										f: A2($elm$core$Dict$remove, requestId, model.f),
										q: sourceData
									}));
						} else {
							return A4(
								$MartinSStewart$elm_audio$Audio$updateHelper,
								app.bD.dz,
								app.bA,
								A2(
									$MartinSStewart$elm_audio$Audio$flip,
									app.dF,
									$mgold$elm_nonempty_list$List$Nonempty$head(pendingRequest.A).b),
								_Utils_update(
									model,
									{
										f: A2($elm$core$Dict$remove, requestId, model.f),
										q: sourceData
									}));
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 1:
					var requestId = response.a.ai;
					var error = response.a.X;
					var _v6 = A2($elm$core$Dict$get, requestId, model.f);
					if (!_v6.$) {
						var pendingRequest = _v6.a;
						var a = $elm$core$Result$Err(error);
						var b = A2(
							$MartinSStewart$elm_audio$Audio$find,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(a)),
							$mgold$elm_nonempty_list$List$Nonempty$toList(pendingRequest.A));
						if (!b.$) {
							var _v8 = b.a;
							var userMsg = _v8.b;
							return A4(
								$MartinSStewart$elm_audio$Audio$updateHelper,
								app.bD.dz,
								app.bA,
								A2($MartinSStewart$elm_audio$Audio$flip, app.dF, userMsg),
								_Utils_update(
									model,
									{
										f: A2($elm$core$Dict$remove, requestId, model.f)
									}));
						} else {
							return A4(
								$MartinSStewart$elm_audio$Audio$updateHelper,
								app.bD.dz,
								app.bA,
								A2(
									$MartinSStewart$elm_audio$Audio$flip,
									app.dF,
									$mgold$elm_nonempty_list$List$Nonempty$head(pendingRequest.A).b),
								_Utils_update(
									model,
									{
										f: A2($elm$core$Dict$remove, requestId, model.f)
									}));
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 2:
					var samplesPerSecond = response.a.H;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(samplesPerSecond)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					var error = response.a.X;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $ianmackenzie$elm_units$Duration$milliseconds = function (numMilliseconds) {
	return $ianmackenzie$elm_units$Duration$seconds(0.001 * numMilliseconds);
};
var $MartinSStewart$elm_audio$Audio$Effect = function (a) {
	return {$: 2, a: a};
};
var $MartinSStewart$elm_audio$Audio$Offset = function (a) {
	return {$: 2, a: a};
};
var $MartinSStewart$elm_audio$Audio$offsetBy = F2(
	function (offset_, audio_) {
		return $MartinSStewart$elm_audio$Audio$Effect(
			{
				bA: audio_,
				ag: $MartinSStewart$elm_audio$Audio$Offset(offset_)
			});
	});
var $MartinSStewart$elm_audio$Audio$withAudioOffset = function (app) {
	return _Utils_update(
		app,
		{
			bA: F2(
				function (audioData_, model) {
					return A2(
						$MartinSStewart$elm_audio$Audio$offsetBy,
						$ianmackenzie$elm_units$Duration$milliseconds(50),
						A2(app.bA, audioData_, model));
				})
		});
};
var $MartinSStewart$elm_audio$Audio$applicationWithAudio = A2(
	$elm$core$Basics$composeR,
	$MartinSStewart$elm_audio$Audio$withAudioOffset,
	function (app) {
		return $elm$browser$Browser$application(
			{
				cv: F3(
					function (flags, url, key) {
						return A3(
							$MartinSStewart$elm_audio$Audio$initHelper,
							app.bD.dz,
							app.bA,
							A3(app.cv, flags, url, key));
					}),
				cY: A2($elm$core$Basics$composeR, app.cY, $MartinSStewart$elm_audio$Audio$UserMsg),
				cZ: A2($elm$core$Basics$composeR, app.cZ, $MartinSStewart$elm_audio$Audio$UserMsg),
				dq: $MartinSStewart$elm_audio$Audio$subscriptions(app),
				dF: $MartinSStewart$elm_audio$Audio$update(app),
				dI: function (model) {
					var _v0 = A2(
						app.dI,
						$MartinSStewart$elm_audio$Audio$audioData(model),
						$MartinSStewart$elm_audio$Audio$getUserModel(model));
					var title = _v0.dy;
					var body = _v0.bI;
					return {
						bI: A2(
							$elm$core$List$map,
							$elm$html$Html$map($MartinSStewart$elm_audio$Audio$UserMsg),
							body),
						dy: title
					};
				}
			});
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $MartinSStewart$elm_audio$Audio$audioDefaultConfig = {C: $elm$core$Maybe$Nothing, E: 1, x: $ianmackenzie$elm_units$Quantity$zero};
var $MartinSStewart$elm_audio$Audio$BasicAudio = function (a) {
	return {$: 1, a: a};
};
var $MartinSStewart$elm_audio$Audio$audioWithConfig = F3(
	function (audioSettings, source, startTime) {
		return $MartinSStewart$elm_audio$Audio$BasicAudio(
			{de: audioSettings, I: source, aa: startTime});
	});
var $MartinSStewart$elm_audio$Audio$audio = F2(
	function (source, startTime) {
		return A3($MartinSStewart$elm_audio$Audio$audioWithConfig, $MartinSStewart$elm_audio$Audio$audioDefaultConfig, source, startTime);
	});
var $MartinSStewart$elm_audio$Audio$ScaleVolumeAt = function (a) {
	return {$: 1, a: a};
};
var $mgold$elm_nonempty_list$List$Nonempty$singleton = function (x) {
	return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, _List_Nil);
};
var $mgold$elm_nonempty_list$List$Nonempty$fromElement = $mgold$elm_nonempty_list$List$Nonempty$singleton;
var $mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
	if (ys.b) {
		var x = ys.a;
		var xs = ys.b;
		return $elm$core$Maybe$Just(
			A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $mgold$elm_nonempty_list$List$Nonempty$insertWith = F3(
	function (cmp, hd, aList) {
		if (aList.b) {
			var x = aList.a;
			var xs = aList.b;
			return (!A2(cmp, x, hd)) ? A2(
				$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
				x,
				A2(
					$elm$core$List$sortWith,
					cmp,
					A2($elm$core$List$cons, hd, xs))) : A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, aList);
		} else {
			return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, _List_Nil);
		}
	});
var $elm$core$List$sortBy = _List_sortBy;
var $mgold$elm_nonempty_list$List$Nonempty$sortBy = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$mgold$elm_nonempty_list$List$Nonempty$insertWith,
			F2(
				function (a, b) {
					return A2(
						$elm$core$Basics$compare,
						f(a),
						f(b));
				}),
			x,
			A2($elm$core$List$sortBy, f, xs));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $MartinSStewart$elm_audio$Audio$scaleVolumeAt = F2(
	function (volumeAt, audio_) {
		return $MartinSStewart$elm_audio$Audio$Effect(
			{
				bA: audio_,
				ag: $MartinSStewart$elm_audio$Audio$ScaleVolumeAt(
					{
						bj: A2(
							$mgold$elm_nonempty_list$List$Nonempty$sortBy,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$time$Time$posixToMillis),
							A2(
								$mgold$elm_nonempty_list$List$Nonempty$map,
								$elm$core$Tuple$mapSecond(
									$elm$core$Basics$max(0)),
								A2(
									$elm$core$Maybe$withDefault,
									$mgold$elm_nonempty_list$List$Nonempty$fromElement(
										_Utils_Tuple2(
											$elm$time$Time$millisToPosix(0),
											1)),
									$mgold$elm_nonempty_list$List$Nonempty$fromList(volumeAt))))
					})
			});
	});
var $MartinSStewart$elm_audio$Audio$Group = function (a) {
	return {$: 0, a: a};
};
var $MartinSStewart$elm_audio$Audio$group = function (audios) {
	return $MartinSStewart$elm_audio$Audio$Group(audios);
};
var $MartinSStewart$elm_audio$Audio$silence = $MartinSStewart$elm_audio$Audio$group(_List_Nil);
var $author$project$Main$audioStateToAudio = function (audioState) {
	if (audioState.$ === 1) {
		var loadedAudio = audioState.a;
		var _v1 = loadedAudio.c2;
		switch (_v1.$) {
			case 0:
				return $MartinSStewart$elm_audio$Audio$silence;
			case 1:
				var time = _v1.a;
				return A2($MartinSStewart$elm_audio$Audio$audio, loadedAudio.di, time);
			default:
				var startTime = _v1.a;
				var stopTime = _v1.b;
				return A2(
					$MartinSStewart$elm_audio$Audio$scaleVolumeAt,
					_List_fromArray(
						[
							_Utils_Tuple2(stopTime, 1),
							_Utils_Tuple2(
							A2(
								$ianmackenzie$elm_units$Duration$addTo,
								stopTime,
								$ianmackenzie$elm_units$Duration$seconds(2)),
							0)
						]),
					A2($MartinSStewart$elm_audio$Audio$audio, loadedAudio.di, startTime));
		}
	} else {
		return $MartinSStewart$elm_audio$Audio$silence;
	}
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Main$audio = F2(
	function (_v0, _v1) {
		var currentSounds = _v1.bW;
		var audioModel = _v1.bC;
		var wordAudio = A2(
			$elm$core$List$map,
			function (_v7) {
				var audioState = _v7.b;
				return $author$project$Main$audioStateToAudio(audioState);
			},
			$elm$core$Dict$toList(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v6) {
							return A2(
								$elm$core$List$any,
								function (soundName) {
									return _Utils_eq(soundName, key);
								},
								currentSounds);
						}),
					audioModel.dK)));
		var soundEffectsAudio = A2(
			$elm$core$List$map,
			function (_v5) {
				var audioState = _v5.b;
				return $author$project$Main$audioStateToAudio(audioState);
			},
			$elm$core$Dict$toList(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v4) {
							return A2(
								$elm$core$List$any,
								function (soundName) {
									return _Utils_eq(soundName, key);
								},
								currentSounds);
						}),
					audioModel.dj)));
		var kanaAudio = A2(
			$elm$core$List$map,
			function (_v3) {
				var audioState = _v3.b;
				return $author$project$Main$audioStateToAudio(audioState);
			},
			$elm$core$Dict$toList(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v2) {
							return A2(
								$elm$core$List$any,
								function (soundName) {
									return _Utils_eq(soundName, key);
								},
								currentSounds);
						}),
					audioModel.cF)));
		return $MartinSStewart$elm_audio$Audio$group(
			A2(
				$elm$core$List$append,
				soundEffectsAudio,
				A2($elm$core$List$append, wordAudio, kanaAudio)));
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Subscriptions$audioPortFromJS = _Platform_incomingPort('audioPortFromJS', $elm$json$Json$Decode$value);
var $author$project$Subscriptions$audioPortToJS = _Platform_outgoingPort('audioPortToJS', $elm$core$Basics$identity);
var $author$project$Domain$Types$DomMessage = function (a) {
	return {$: 15, a: a};
};
var $author$project$Domain$Types$GotViewport = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$Initial = 1;
var $author$project$Domain$Types$Model = function (boardItems) {
	return function (filledHoles) {
		return function (fillSwaps) {
			return function (topUpBoardItems) {
				return function (swapState) {
					return function (chains) {
						return function (explodedKana) {
							return function (animatedScores) {
								return function (shuffle) {
									return function (currentTime) {
										return function (idleTime) {
											return function (isIdle) {
												return function (comboMultiplier) {
													return function (level) {
														return function (currentWord) {
															return function (kanaToColorLookup) {
																return function (applicationState) {
																	return function (settings) {
																		return function (currentSounds) {
																			return function (animatedKanawordData) {
																				return function (boardItemsAnimatingToKanaWord) {
																					return function (shrinkingBoardItems) {
																						return function (removedBoardItemsCount) {
																							return function (imageMatchState) {
																								return function (score) {
																									return function (modals) {
																										return function (navigationKey) {
																											return function (randomSeeds) {
																												return function (isBoardAnimating) {
																													return function (gesture) {
																														return function (viewport) {
																															return function (device) {
																																return function (inputState) {
																																	return function (audioModel) {
																																		return {bw: animatedKanawordData, bx: animatedScores, by: applicationState, bC: audioModel, bG: boardItems, bH: boardItemsAnimatingToKanaWord, bN: chains, bS: comboMultiplier, bW: currentSounds, bX: currentTime, bY: currentWord, b$: device, b7: explodedKana, ca: fillSwaps, cb: filledHoles, cg: gesture, cq: idleTime, ct: imageMatchState, cx: inputState, cA: isBoardAnimating, cC: isIdle, cG: kanaToColorLookup, cK: level, cQ: modals, cW: navigationKey, c4: randomSeeds, c8: removedBoardItemsCount, da: score, de: settings, dg: shrinkingBoardItems, a5: shuffle, ds: swapState, dC: topUpBoardItems, dJ: viewport};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Domain$Types$Phone = 0;
var $author$project$Domain$Types$Portrait = 0;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Services$Swipe$None = {$: 0};
var $author$project$Services$Swipe$blanco = $author$project$Services$Swipe$None;
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $author$project$Domain$Types$AudioModel = F3(
	function (soundEffects, kanaSounds, wordSounds) {
		return {cF: kanaSounds, dj: soundEffects, dK: wordSounds};
	});
var $author$project$Services$Audio$init = A3($author$project$Domain$Types$AudioModel, $elm$core$Dict$empty, $elm$core$Dict$empty, $elm$core$Dict$empty);
var $author$project$Domain$Types$ImageMatchState = F3(
	function (selectedImageID, wrongImageIDsSelected, completedWordsCount) {
		return {bT: completedWordsCount, dc: selectedImageID, dM: wrongImageIDsSelected};
	});
var $author$project$Services$ImageMatch$init = A3($author$project$Domain$Types$ImageMatchState, $elm$core$Maybe$Nothing, _List_Nil, 0);
var $author$project$Services$Input$init = {cB: false, cR: $elm$core$Maybe$Nothing, cS: $elm$core$Maybe$Nothing, cT: $elm$core$Maybe$Nothing};
var $author$project$Domain$Types$AnimatedKanaWordData = F5(
	function (animatedKanaRecords, currentAnimatingKanaIndex, animateScaleUpIndex, animateToCenter, finishedAnimating) {
		return {bq: animateScaleUpIndex, bu: animateToCenter, bv: animatedKanaRecords, bV: currentAnimatingKanaIndex, cc: finishedAnimating};
	});
var $author$project$Services$Kanaword$init = A5($author$project$Domain$Types$AnimatedKanaWordData, _List_Nil, 0, $elm$core$Maybe$Nothing, false, false);
var $author$project$Domain$Types$Level = F9(
	function (episodeNumber, id, movesCount, numberOfKanaToCompleteAnimation, oneStarScore, threeStarScore, twoStarScore, tiles, kanaWords) {
		return {b3: episodeNumber, cp: id, cI: kanaWords, cU: movesCount, cX: numberOfKanaToCompleteAnimation, c$: oneStarScore, du: threeStarScore, dw: tiles, dE: twoStarScore};
	});
var $author$project$Services$Level$init = A9($author$project$Domain$Types$Level, 0, 0, 0, 0, 0, 0, 0, $elm$core$Array$empty, _List_Nil);
var $author$project$Domain$Types$Dismissed = 1;
var $author$project$Domain$Types$LevelModalState = F2(
	function (imageIndex, modalState) {
		return {cr: imageIndex, aO: modalState};
	});
var $author$project$Domain$Types$ModalState = F6(
	function (levelModalState, victoryModalState, defeatModalState, errorModalState, settingsModalState, levelCompleteBanner) {
		return {b_: defeatModalState, b4: errorModalState, cL: levelCompleteBanner, cM: levelModalState, df: settingsModalState, dH: victoryModalState};
	});
var $author$project$Services$Modal$init = A6(
	$author$project$Domain$Types$ModalState,
	A2($author$project$Domain$Types$LevelModalState, 0, 1),
	1,
	1,
	1,
	1,
	1);
var $author$project$Domain$Types$RandomSeeds = F4(
	function (refill, shuffle, kanawords, imageMatch) {
		return {cs: imageMatch, cJ: kanawords, c7: refill, a5: shuffle};
	});
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $author$project$Extras$Random$defaultSeed = $elm$random$Random$initialSeed(0);
var $author$project$Services$Random$init = A4($author$project$Domain$Types$RandomSeeds, $author$project$Extras$Random$defaultSeed, $author$project$Extras$Random$defaultSeed, $author$project$Extras$Random$defaultSeed, $author$project$Extras$Random$defaultSeed);
var $author$project$Domain$Types$Score = F8(
	function (oneStarPercentComplete, twoStarPercentComplete, threeStarPercentComplete, animateStarOne, animateStarTwo, animateStarThree, gameScore, highScore) {
		return {br: animateStarOne, bs: animateStarThree, bt: animateStarTwo, cf: gameScore, cn: highScore, c_: oneStarPercentComplete, dt: threeStarPercentComplete, dD: twoStarPercentComplete};
	});
var $author$project$Services$Score$init = A8($author$project$Domain$Types$Score, 0, 0, 0, false, false, false, 0, $elm$core$Maybe$Nothing);
var $author$project$Domain$Types$Settings = F4(
	function (soundEffectsEnabled, textAudioEnabled, musicEnabled, hintsEnabled) {
		return {aF: hintsEnabled, aQ: musicEnabled, a8: soundEffectsEnabled, bd: textAudioEnabled};
	});
var $author$project$Services$Settings$init = A4($author$project$Domain$Types$Settings, true, true, true, true);
var $author$project$Domain$Types$NotShuffling = 2;
var $author$project$Domain$Types$Shuffle = function (shuffleState) {
	return {dh: shuffleState};
};
var $author$project$Services$Shuffle$init = $author$project$Domain$Types$Shuffle(2);
var $author$project$Domain$Types$SwapState = F7(
	function (swap, invalidClickSwap, invalidDragSwap, hintSwap, firstClickedCoordinates, secondClickedCoordinates, possibleSwaps) {
		return {cd: firstClickedCoordinates, co: hintSwap, cy: invalidClickSwap, cz: invalidDragSwap, c3: possibleSwaps, db: secondClickedCoordinates, dr: swap};
	});
var $author$project$Services$Swap$init = A7($author$project$Domain$Types$SwapState, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _List_Nil);
var $MartinSStewart$elm_audio$Audio$AudioCmdGroup = function (a) {
	return {$: 1, a: a};
};
var $MartinSStewart$elm_audio$Audio$cmdBatch = function (audioCmds) {
	return $MartinSStewart$elm_audio$Audio$AudioCmdGroup(audioCmds);
};
var $author$project$Services$Audio$AudioFile = F3(
	function (name, path, audioType) {
		return {al: audioType, cV: name, aR: path};
	});
var $author$project$Domain$Types$SoundEffect = 0;
var $author$project$Services$Audio$soundEffectsPath = function (fileName) {
	return '../Audio/SoundEffects/' + fileName;
};
var $author$project$Services$Audio$correctAnswer = A3(
	$author$project$Services$Audio$AudioFile,
	'correctAnswer',
	$author$project$Services$Audio$soundEffectsPath('Correct Answer.wav'),
	0);
var $author$project$Services$Audio$currentKanaSoundFile = A3(
	$author$project$Services$Audio$AudioFile,
	'CurrentKanaSound',
	$author$project$Services$Audio$soundEffectsPath('CurrentKanaSound.wav'),
	0);
var $author$project$Services$Audio$invalidSwap = A3(
	$author$project$Services$Audio$AudioFile,
	'invalidClickSwap',
	$author$project$Services$Audio$soundEffectsPath('Error.wav'),
	0);
var $author$project$Services$Audio$matchAudioPath = '../Audio/SoundEffects/Match/';
var $author$project$Services$Audio$matchAudioFile = function (matchLevel) {
	var matchFileName = 'Match' + $elm$core$String$fromInt(matchLevel);
	return A3($author$project$Services$Audio$AudioFile, matchFileName, $author$project$Services$Audio$matchAudioPath + (matchFileName + '.wav'), 0);
};
var $author$project$Domain$Types$LoadingMessage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Domain$Types$SoundLoaded = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $MartinSStewart$elm_audio$Audio$AudioLoadRequest = function (a) {
	return {$: 0, a: a};
};
var $MartinSStewart$elm_audio$Audio$ErrorThatHappensWhenYouLoadMoreThan1000SoundsDueToHackyWorkAroundToMakeThisPackageBehaveMoreLikeAnEffectPackage = 3;
var $MartinSStewart$elm_audio$Audio$enumeratedResults = A2(
	$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
	$elm$core$Result$Err(3),
	_Utils_ap(
		_List_fromArray(
			[
				$elm$core$Result$Err(0),
				$elm$core$Result$Err(1),
				$elm$core$Result$Err(2)
			]),
		A2(
			$elm$core$List$map,
			function (bufferId) {
				return $elm$core$Result$Ok(
					{V: bufferId});
			},
			A2($elm$core$List$range, 0, 1000))));
var $MartinSStewart$elm_audio$Audio$loadAudio = F2(
	function (userMsg, url) {
		return $MartinSStewart$elm_audio$Audio$AudioLoadRequest(
			{
				U: url,
				A: A2(
					$mgold$elm_nonempty_list$List$Nonempty$map,
					function (results) {
						return _Utils_Tuple2(
							results,
							userMsg(results));
					},
					$MartinSStewart$elm_audio$Audio$enumeratedResults)
			});
	});
var $author$project$Services$Audio$toLoadAudioCommand = function (audioFile) {
	return A2(
		$MartinSStewart$elm_audio$Audio$loadAudio,
		function (result) {
			return $author$project$Domain$Types$LoadingMessage(
				A3($author$project$Domain$Types$SoundLoaded, audioFile.al, audioFile.cV, result));
		},
		audioFile.aR);
};
var $author$project$Services$Audio$victoryAudioFile = A3(
	$author$project$Services$Audio$AudioFile,
	'victory',
	$author$project$Services$Audio$soundEffectsPath('Victory Jingle.wav'),
	0);
var $author$project$Services$Audio$loadInitialAudioCommand = $MartinSStewart$elm_audio$Audio$cmdBatch(
	_List_fromArray(
		[
			$author$project$Services$Audio$toLoadAudioCommand($author$project$Services$Audio$correctAnswer),
			$author$project$Services$Audio$toLoadAudioCommand(
			$author$project$Services$Audio$matchAudioFile(1)),
			$author$project$Services$Audio$toLoadAudioCommand(
			$author$project$Services$Audio$matchAudioFile(2)),
			$author$project$Services$Audio$toLoadAudioCommand(
			$author$project$Services$Audio$matchAudioFile(3)),
			$author$project$Services$Audio$toLoadAudioCommand(
			$author$project$Services$Audio$matchAudioFile(4)),
			$author$project$Services$Audio$toLoadAudioCommand(
			$author$project$Services$Audio$matchAudioFile(5)),
			$author$project$Services$Audio$toLoadAudioCommand($author$project$Services$Audio$invalidSwap),
			$author$project$Services$Audio$toLoadAudioCommand($author$project$Services$Audio$victoryAudioFile),
			$author$project$Services$Audio$toLoadAudioCommand($author$project$Services$Audio$currentKanaSoundFile)
		]));
var $author$project$Domain$Types$BoardRefillSeed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$GotLevel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$ImageMatchSeed = {$: 3};
var $author$project$Domain$Types$KanawordsSeed = {$: 0};
var $author$project$Domain$Types$RandomMessage = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Domain$Types$ShuffleSeed = {$: 2};
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $author$project$Extras$Random$anyInt = A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt);
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.dk));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {aZ: reqs, ba: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.be;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.aZ));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.ba)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					bp: r.bp,
					bI: r.bI,
					b5: A2(_Http_mapExpect, func, r.b5),
					aD: r.aD,
					cO: r.cO,
					dx: r.dx,
					be: r.be,
					dG: r.dG
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{bp: false, bI: r.bI, b5: r.b5, aD: r.aD, cO: r.cO, dx: r.dx, be: r.be, dG: r.dG}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{bI: $elm$http$Http$emptyBody, b5: r.b5, aD: _List_Nil, cO: 'GET', dx: $elm$core$Maybe$Nothing, be: $elm$core$Maybe$Nothing, dG: r.dG});
};
var $author$project$Services$APIClient$apiBaseURL = 'https://api.kanaparty.com/';
var $author$project$Services$APIClient$apiVersion = 'v1/';
var $author$project$Services$APIClient$levelByIDEndpoint = function (levelID) {
	return $author$project$Services$APIClient$apiBaseURL + ($author$project$Services$APIClient$apiVersion + ('level/' + $elm$core$String$fromInt(levelID)));
};
var $author$project$Decoders$JsonLevel$JsonLevel = F9(
	function (episodeNumber, id, movesCount, numberOfKanaToCompleteAnimation, oneStarScore, threeStarScore, tiles, twoStarScore, kanaWords) {
		return {b3: episodeNumber, cp: id, cI: kanaWords, cU: movesCount, cX: numberOfKanaToCompleteAnimation, c$: oneStarScore, du: threeStarScore, dw: tiles, dE: twoStarScore};
	});
var $author$project$Decoders$JsonKanaWord$JsonKanaWord = F6(
	function (categoryID, englishTranslation, id, initialKana, kanaWordString, kanaToColorLookup) {
		return {bM: categoryID, b2: englishTranslation, cp: id, cw: initialKana, cG: kanaToColorLookup, cH: kanaWordString};
	});
var $author$project$Decoders$JsonKanaToColorLookup$JsonKanaToColorLookup = F2(
	function (colornumber, kana) {
		return {bR: colornumber, cE: kana};
	});
var $author$project$Decoders$JsonKanaWord$kanaToColorLookupDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Decoders$JsonKanaToColorLookup$JsonKanaToColorLookup,
	A2($elm$json$Json$Decode$field, 'colornumber', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'kana', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Decoders$JsonKanaWord$kanaWordDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Decoders$JsonKanaWord$JsonKanaWord,
	A2($elm$json$Json$Decode$field, 'categoryID', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'englishTranslation', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'initialKana',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'kanaWordString', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'kanaToColorLookup',
		$elm$json$Json$Decode$list($author$project$Decoders$JsonKanaWord$kanaToColorLookupDecoder)));
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Decoders$JsonLevel$levelDecoder = function () {
	var fieldSet = A9(
		$elm$json$Json$Decode$map8,
		$author$project$Decoders$JsonLevel$JsonLevel,
		A2($elm$json$Json$Decode$field, 'episodeNumber', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'movesCount', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'numberOfKanaToCompleteAnimation', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'oneStarScore', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'threeStarScore', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'tiles', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'twoStarScore', $elm$json$Json$Decode$int));
	return A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Basics$apL,
		fieldSet,
		A2(
			$elm$json$Json$Decode$field,
			'kanaWords',
			$elm$json$Json$Decode$list($author$project$Decoders$JsonKanaWord$kanaWordDecoder)));
}();
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Services$APIClient$loadLevelCommand = F2(
	function (navigationKey, levelID) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$elm$http$Http$get(
					{
						b5: A2(
							$elm$http$Http$expectJson,
							function (result) {
								return $author$project$Domain$Types$LoadingMessage(
									$author$project$Domain$Types$GotLevel(result));
							},
							$author$project$Decoders$JsonLevel$levelDecoder),
						dG: $author$project$Services$APIClient$levelByIDEndpoint(levelID)
					}),
					A2(
					$elm$browser$Browser$Navigation$pushUrl,
					navigationKey,
					'/?level=' + $elm$core$String$fromInt(levelID)),
					A2(
					$elm$random$Random$generate,
					$author$project$Domain$Types$RandomMessage($author$project$Domain$Types$KanawordsSeed),
					$author$project$Extras$Random$anyInt),
					A2(
					$elm$random$Random$generate,
					$author$project$Domain$Types$RandomMessage(
						$author$project$Domain$Types$BoardRefillSeed($elm$core$Platform$Cmd$none)),
					$author$project$Extras$Random$anyInt),
					A2(
					$elm$random$Random$generate,
					$author$project$Domain$Types$RandomMessage($author$project$Domain$Types$ShuffleSeed),
					$author$project$Extras$Random$anyInt),
					A2(
					$elm$random$Random$generate,
					$author$project$Domain$Types$RandomMessage($author$project$Domain$Types$ImageMatchSeed),
					$author$project$Extras$Random$anyInt)
				]));
	});
var $author$project$Services$UrlParser$defaultLevelID = 1;
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Extras$Maybe$flatten = function (maybeValue) {
	return A2(
		$elm$core$Maybe$andThen,
		function (value) {
			return value;
		},
		maybeValue);
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {B: frag, D: params, y: unvisited, u: value, J: visited};
	});
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.J;
		var unvisited = _v1.y;
		var params = _v1.D;
		var frag = _v1.B;
		var value = _v1.u;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $author$project$Services$UrlParser$levelIDParser = $elm$url$Url$Parser$query(
	$elm$url$Url$Parser$Query$int('level'));
var $author$project$Services$UrlParser$maxLevelID = 300;
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.y;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.u);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.u);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.aR),
					$elm$url$Url$Parser$prepareQuery(url.aX),
					url.aB,
					$elm$core$Basics$identity)));
	});
var $author$project$Services$UrlParser$parseUrlLevelIDWithDefault = function (url) {
	var _v0 = $author$project$Extras$Maybe$flatten(
		A2($elm$url$Url$Parser$parse, $author$project$Services$UrlParser$levelIDParser, url));
	if (!_v0.$) {
		var levelID = _v0.a;
		return ((levelID > 0) && (_Utils_cmp(levelID, $author$project$Services$UrlParser$maxLevelID) < 1)) ? levelID : $author$project$Services$UrlParser$defaultLevelID;
	} else {
		return $author$project$Services$UrlParser$defaultLevelID;
	}
};
var $author$project$Init$init = F3(
	function (_v0, url, navigationKey) {
		return _Utils_Tuple3(
			$author$project$Domain$Types$Model($elm$core$Array$empty)($elm$core$Array$empty)(_List_Nil)(_List_Nil)($author$project$Services$Swap$init)(_List_Nil)(_List_Nil)(_List_Nil)($author$project$Services$Shuffle$init)(
				$elm$time$Time$millisToPosix(0))(
				$elm$time$Time$millisToPosix(0))(false)(1)($author$project$Services$Level$init)($elm$core$Maybe$Nothing)($elm$core$Dict$empty)(1)($author$project$Services$Settings$init)(_List_Nil)($author$project$Services$Kanaword$init)(_List_Nil)(_List_Nil)(0)($author$project$Services$ImageMatch$init)($author$project$Services$Score$init)($author$project$Services$Modal$init)(navigationKey)($author$project$Services$Random$init)(false)($author$project$Services$Swipe$blanco)($elm$core$Maybe$Nothing)(
				{bP: 0, c1: 0})($author$project$Services$Input$init)($author$project$Services$Audio$init),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Services$APIClient$loadLevelCommand,
						navigationKey,
						$author$project$Services$UrlParser$parseUrlLevelIDWithDefault(url)),
						A2(
						$elm$core$Task$attempt,
						function (result) {
							return $author$project$Domain$Types$DomMessage(
								$author$project$Domain$Types$GotViewport(result));
						},
						$elm$browser$Browser$Dom$getViewport)
					])),
			$author$project$Services$Audio$loadInitialAudioCommand);
	});
var $author$project$Domain$Types$LocalStorageMessage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Domain$Types$ReceivedHighScoreFromLocalStorage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Types$ReceivedSettingsFromLocalStorage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$WindowResized = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ports$highScoresPortFromJS = _Platform_incomingPort('highScoresPortFromJS', $elm$json$Json$Decode$string);
var $author$project$Domain$Types$MouseMove = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Domain$Types$SwapMessage = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {aS: pids, ba: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {aA: event, aJ: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.aS,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.aJ;
		var event = _v0.aA;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.ba);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $author$project$Subscriptions$mouseMoveSubscription = function (model) {
	return (!model.cx.cB) ? $elm$core$Platform$Sub$none : $elm$browser$Browser$Events$onMouseMove(
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (clientX, clientY) {
					return $author$project$Domain$Types$SwapMessage(
						A2($author$project$Domain$Types$MouseMove, clientX, clientY));
				}),
			A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float)));
};
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Ports$settingsPortFromJS = _Platform_incomingPort(
	'settingsPortFromJS',
	A2(
		$elm$json$Json$Decode$andThen,
		function (textAudioEnabled) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (soundEffectsEnabled) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (musicEnabled) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (hintsEnabled) {
									return $elm$json$Json$Decode$succeed(
										{aF: hintsEnabled, aQ: musicEnabled, a8: soundEffectsEnabled, bd: textAudioEnabled});
								},
								A2(
									$elm$json$Json$Decode$field,
									'hintsEnabled',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)
											]))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'musicEnabled',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)
									]))));
				},
				A2(
					$elm$json$Json$Decode$field,
					'soundEffectsEnabled',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)
							]))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'textAudioEnabled',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)
					])))));
var $author$project$Subscriptions$subscriptions = F2(
	function (_v0, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ports$highScoresPortFromJS(
					function (score) {
						return $author$project$Domain$Types$LocalStorageMessage(
							$author$project$Domain$Types$ReceivedHighScoreFromLocalStorage(score));
					}),
					$author$project$Ports$settingsPortFromJS(
					function (settings) {
						return $author$project$Domain$Types$LocalStorageMessage(
							$author$project$Domain$Types$ReceivedSettingsFromLocalStorage(settings));
					}),
					$elm$browser$Browser$Events$onResize(
					F2(
						function (width, height) {
							return $author$project$Domain$Types$DomMessage(
								A2($author$project$Domain$Types$WindowResized, width, height));
						})),
					$author$project$Subscriptions$mouseMoveSubscription(model)
				]));
	});
var $MartinSStewart$elm_audio$Audio$cmdNone = $MartinSStewart$elm_audio$Audio$AudioCmdGroup(_List_Nil);
var $author$project$Services$Time$refreshIdleTime = function (model) {
	return _Utils_update(
		model,
		{cq: model.bX, cC: false});
};
var $author$project$Services$UrlParser$parseUrlLevelID = function (url) {
	return $author$project$Extras$Maybe$flatten(
		A2($elm$url$Url$Parser$parse, $author$project$Services$UrlParser$levelIDParser, url));
};
var $author$project$Ports$highScoresPortToJS = _Platform_outgoingPort('highScoresPortToJS', $elm$json$Json$Encode$string);
var $author$project$Ports$messageTypeKey = 'messageType';
var $author$project$Ports$requestHighScore = function (levelID) {
	return $author$project$Ports$highScoresPortToJS(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Ports$messageTypeKey,
						$elm$json$Json$Encode$string('requestScoreByLevelID')),
						_Utils_Tuple2(
						'levelID',
						$elm$json$Json$Encode$int(levelID))
					]))));
};
var $author$project$Services$Score$requestHighScoreCommand = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2(
			$elm$core$Maybe$andThen,
			function (levelID) {
				return $elm$core$Maybe$Just(
					$author$project$Ports$requestHighScore(levelID));
			},
			$author$project$Services$UrlParser$parseUrlLevelID(url)));
};
var $author$project$Ports$settingsPortToJS = _Platform_outgoingPort('settingsPortToJS', $elm$json$Json$Encode$string);
var $author$project$Ports$requestSettingsCommand = $author$project$Ports$settingsPortToJS(
	A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Ports$messageTypeKey,
					$elm$json$Json$Encode$string('requestSettings'))
				]))));
var $author$project$Domain$Types$PlaySoundEffectAndGotTime = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Domain$Types$SoundMessage = function (a) {
	return {$: 11, a: a};
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Domain$Types$LoadedAudio = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$Playing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Audio$updateToPlayingSoundState = F2(
	function (time, audioState) {
		if (audioState.$ === 1) {
			var loadedAudio = audioState.a;
			return $author$project$Domain$Types$LoadedAudio(
				_Utils_update(
					loadedAudio,
					{
						c2: $author$project$Domain$Types$Playing(time)
					}));
		} else {
			return audioState;
		}
	});
var $author$project$Services$Audio$activateKanaSoundAtTime = F3(
	function (audioID, time, model) {
		var audioModel = model.bC;
		return _Utils_update(
			model,
			{
				bC: _Utils_update(
					audioModel,
					{
						cF: A3(
							$elm$core$Dict$update,
							audioID,
							$elm$core$Maybe$map(
								$author$project$Services$Audio$updateToPlayingSoundState(time)),
							audioModel.cF)
					}),
				bW: A2($elm$core$List$cons, audioID, model.bW)
			});
	});
var $author$project$Services$Audio$activateKanawordSoundAtTime = F3(
	function (audioID, time, model) {
		var audioModel = model.bC;
		return _Utils_update(
			model,
			{
				bC: _Utils_update(
					audioModel,
					{
						dK: A3(
							$elm$core$Dict$update,
							audioID,
							$elm$core$Maybe$map(
								$author$project$Services$Audio$updateToPlayingSoundState(time)),
							audioModel.dK)
					}),
				bW: A2($elm$core$List$cons, audioID, model.bW)
			});
	});
var $author$project$Services$Audio$activateSoundEffectAtTime = F3(
	function (soundName, time, model) {
		var audioModel = model.bC;
		return _Utils_update(
			model,
			{
				bC: _Utils_update(
					audioModel,
					{
						dj: A3(
							$elm$core$Dict$update,
							soundName,
							$elm$core$Maybe$map(
								$author$project$Services$Audio$updateToPlayingSoundState(time)),
							audioModel.dj)
					}),
				bW: A2($elm$core$List$cons, soundName, model.bW)
			});
	});
var $author$project$Services$Kana$katakanaToHiraganaLookup = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('ア', 'あ'),
			_Utils_Tuple2('イ', 'い'),
			_Utils_Tuple2('ウ', 'う'),
			_Utils_Tuple2('エ', 'え'),
			_Utils_Tuple2('オ', 'お'),
			_Utils_Tuple2('カ', 'か'),
			_Utils_Tuple2('キ', 'き'),
			_Utils_Tuple2('ク', 'く'),
			_Utils_Tuple2('ケ', 'け'),
			_Utils_Tuple2('コ', 'こ'),
			_Utils_Tuple2('サ', 'さ'),
			_Utils_Tuple2('シ', 'し'),
			_Utils_Tuple2('ス', 'す'),
			_Utils_Tuple2('セ', 'せ'),
			_Utils_Tuple2('ソ', 'そ'),
			_Utils_Tuple2('タ', 'た'),
			_Utils_Tuple2('チ', 'ち'),
			_Utils_Tuple2('ツ', 'つ'),
			_Utils_Tuple2('テ', 'て'),
			_Utils_Tuple2('ト', 'と'),
			_Utils_Tuple2('ナ', 'な'),
			_Utils_Tuple2('ニ', 'に'),
			_Utils_Tuple2('ヌ', 'ぬ'),
			_Utils_Tuple2('ネ', 'ね'),
			_Utils_Tuple2('ノ', 'の'),
			_Utils_Tuple2('ハ', 'は'),
			_Utils_Tuple2('ヒ', 'ひ'),
			_Utils_Tuple2('フ', 'ふ'),
			_Utils_Tuple2('ヘ', 'へ'),
			_Utils_Tuple2('ホ', 'ほ'),
			_Utils_Tuple2('マ', 'ま'),
			_Utils_Tuple2('ミ', 'み'),
			_Utils_Tuple2('ム', 'む'),
			_Utils_Tuple2('メ', 'め'),
			_Utils_Tuple2('モ', 'も'),
			_Utils_Tuple2('ヤ', 'や'),
			_Utils_Tuple2('ユ', 'ゆ'),
			_Utils_Tuple2('ヨ', 'よ'),
			_Utils_Tuple2('ラ', 'ら'),
			_Utils_Tuple2('リ', 'り'),
			_Utils_Tuple2('ル', 'る'),
			_Utils_Tuple2('レ', 'れ'),
			_Utils_Tuple2('ロ', 'ろ'),
			_Utils_Tuple2('ガ', 'が'),
			_Utils_Tuple2('ギ', 'ぎ'),
			_Utils_Tuple2('グ', 'ぐ'),
			_Utils_Tuple2('ゲ', 'げ'),
			_Utils_Tuple2('ゴ', 'ご'),
			_Utils_Tuple2('ザ', 'ざ'),
			_Utils_Tuple2('ジ', 'じ'),
			_Utils_Tuple2('ズ', 'ず'),
			_Utils_Tuple2('ゼ', 'ぜ'),
			_Utils_Tuple2('ゾ', 'ぞ'),
			_Utils_Tuple2('ダ', 'だ'),
			_Utils_Tuple2('ヂ', 'ぢ'),
			_Utils_Tuple2('ヅ', 'づ'),
			_Utils_Tuple2('デ', 'で'),
			_Utils_Tuple2('ド', 'ど'),
			_Utils_Tuple2('バ', 'ば'),
			_Utils_Tuple2('ビ', 'び'),
			_Utils_Tuple2('ブ', 'ぶ'),
			_Utils_Tuple2('ベ', 'べ'),
			_Utils_Tuple2('ボ', 'ぼ'),
			_Utils_Tuple2('パ', 'ぱ'),
			_Utils_Tuple2('ピ', 'ぴ'),
			_Utils_Tuple2('プ', 'ぷ'),
			_Utils_Tuple2('ペ', 'ぺ'),
			_Utils_Tuple2('ポ', 'ぽ'),
			_Utils_Tuple2('ワ', 'わ'),
			_Utils_Tuple2('ヲ', 'を'),
			_Utils_Tuple2('キャ', 'きゃ'),
			_Utils_Tuple2('キュ', 'きゅ'),
			_Utils_Tuple2('キョ', 'きょ'),
			_Utils_Tuple2('シャ', 'しゃ'),
			_Utils_Tuple2('シュ', 'しゅ'),
			_Utils_Tuple2('ショ', 'しょ'),
			_Utils_Tuple2('チャ', 'ちゃ'),
			_Utils_Tuple2('チュ', 'ちゅ'),
			_Utils_Tuple2('チョ', 'ちょ'),
			_Utils_Tuple2('ニャ', 'にゃ'),
			_Utils_Tuple2('ニュ', 'にゅ'),
			_Utils_Tuple2('ニョ', 'にょ'),
			_Utils_Tuple2('ヒャ', 'ひゃ'),
			_Utils_Tuple2('ヒュ', 'ひゅ'),
			_Utils_Tuple2('ヒョ', 'ひょ'),
			_Utils_Tuple2('ミャ', 'みゃ'),
			_Utils_Tuple2('ミュ', 'みゅ'),
			_Utils_Tuple2('ミョ', 'みょ'),
			_Utils_Tuple2('リャ', 'りゃ'),
			_Utils_Tuple2('リュ', 'りゅ'),
			_Utils_Tuple2('リョ', 'りょ'),
			_Utils_Tuple2('ギャ', 'ぎゃ'),
			_Utils_Tuple2('ギュ', 'ぎゅ'),
			_Utils_Tuple2('ギョ', 'ぎょ'),
			_Utils_Tuple2('ジャ', 'じゃ'),
			_Utils_Tuple2('ジュ', 'じゅ'),
			_Utils_Tuple2('ジョ', 'じょ'),
			_Utils_Tuple2('ヂャ', 'ぢゃ'),
			_Utils_Tuple2('ヂュ', 'ぢゅ'),
			_Utils_Tuple2('ヂョ', 'ぢょ'),
			_Utils_Tuple2('ビャ', 'びゃ'),
			_Utils_Tuple2('ビュ', 'びゅ'),
			_Utils_Tuple2('ビョ', 'びょ'),
			_Utils_Tuple2('ピャ', 'ぴゃ'),
			_Utils_Tuple2('ピュ', 'ぴゅ'),
			_Utils_Tuple2('ピョ', 'ぴょ'),
			_Utils_Tuple2('ッキ', 'っき'),
			_Utils_Tuple2('ン', 'ん')
		]));
var $author$project$Services$Kana$katakanaToHiragana = function (katakana) {
	return A2(
		$elm$core$Maybe$withDefault,
		katakana,
		A2($elm$core$Dict$get, katakana, $author$project$Services$Kana$katakanaToHiraganaLookup));
};
var $author$project$Services$Audio$updateAudioState = F2(
	function (message, model) {
		if (!message.$) {
			var audioType = message.a;
			var soundName = message.b;
			return _Utils_Tuple3(
				model,
				A2(
					$elm$core$Task$perform,
					function (posixTime) {
						return $author$project$Domain$Types$SoundMessage(
							A3(
								$author$project$Domain$Types$PlaySoundEffectAndGotTime,
								audioType,
								$author$project$Services$Kana$katakanaToHiragana(soundName),
								posixTime));
					},
					$elm$time$Time$now),
				$MartinSStewart$elm_audio$Audio$cmdNone);
		} else {
			var audioType = message.a;
			var soundName = message.b;
			var time = message.c;
			return _Utils_Tuple3(
				function () {
					switch (audioType) {
						case 1:
							return A3($author$project$Services$Audio$activateKanaSoundAtTime, soundName, time, model);
						case 2:
							return A3($author$project$Services$Audio$activateKanawordSoundAtTime, soundName, time, model);
						default:
							return A3($author$project$Services$Audio$activateSoundEffectAtTime, soundName, time, model);
					}
				}(),
				$elm$core$Platform$Cmd$none,
				$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$BoardMessage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Domain$Types$RefillBoard = 2;
var $author$project$Services$Kana$numberOfStrokesPerKana = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('あ', 3),
			_Utils_Tuple2('い', 2),
			_Utils_Tuple2('う', 2),
			_Utils_Tuple2('え', 2),
			_Utils_Tuple2('お', 3),
			_Utils_Tuple2('か', 3),
			_Utils_Tuple2('き', 4),
			_Utils_Tuple2('く', 1),
			_Utils_Tuple2('け', 3),
			_Utils_Tuple2('こ', 2),
			_Utils_Tuple2('さ', 3),
			_Utils_Tuple2('し', 1),
			_Utils_Tuple2('す', 2),
			_Utils_Tuple2('せ', 3),
			_Utils_Tuple2('そ', 1),
			_Utils_Tuple2('た', 4),
			_Utils_Tuple2('ち', 2),
			_Utils_Tuple2('つ', 1),
			_Utils_Tuple2('て', 1),
			_Utils_Tuple2('と', 2),
			_Utils_Tuple2('な', 4),
			_Utils_Tuple2('に', 3),
			_Utils_Tuple2('ぬ', 2),
			_Utils_Tuple2('ね', 2),
			_Utils_Tuple2('の', 1),
			_Utils_Tuple2('は', 3),
			_Utils_Tuple2('ひ', 1),
			_Utils_Tuple2('ふ', 4),
			_Utils_Tuple2('へ', 1),
			_Utils_Tuple2('ほ', 4),
			_Utils_Tuple2('ま', 3),
			_Utils_Tuple2('み', 2),
			_Utils_Tuple2('む', 3),
			_Utils_Tuple2('め', 2),
			_Utils_Tuple2('も', 3),
			_Utils_Tuple2('や', 3),
			_Utils_Tuple2('ゆ', 2),
			_Utils_Tuple2('よ', 2),
			_Utils_Tuple2('ら', 2),
			_Utils_Tuple2('り', 2),
			_Utils_Tuple2('る', 1),
			_Utils_Tuple2('れ', 2),
			_Utils_Tuple2('ろ', 1),
			_Utils_Tuple2('が', 5),
			_Utils_Tuple2('ぎ', 6),
			_Utils_Tuple2('ぐ', 3),
			_Utils_Tuple2('げ', 5),
			_Utils_Tuple2('ご', 4),
			_Utils_Tuple2('ざ', 5),
			_Utils_Tuple2('じ', 3),
			_Utils_Tuple2('ず', 4),
			_Utils_Tuple2('ぜ', 5),
			_Utils_Tuple2('ぞ', 3),
			_Utils_Tuple2('だ', 6),
			_Utils_Tuple2('ぢ', 4),
			_Utils_Tuple2('づ', 3),
			_Utils_Tuple2('で', 3),
			_Utils_Tuple2('ど', 4),
			_Utils_Tuple2('ば', 5),
			_Utils_Tuple2('び', 3),
			_Utils_Tuple2('ぶ', 6),
			_Utils_Tuple2('べ', 3),
			_Utils_Tuple2('ぼ', 6),
			_Utils_Tuple2('ぱ', 4),
			_Utils_Tuple2('ぴ', 2),
			_Utils_Tuple2('ぷ', 5),
			_Utils_Tuple2('ぺ', 2),
			_Utils_Tuple2('ぽ', 5),
			_Utils_Tuple2('わ', 2),
			_Utils_Tuple2('を', 3),
			_Utils_Tuple2('ん', 1),
			_Utils_Tuple2('ゃ', 3),
			_Utils_Tuple2('ゅ', 2),
			_Utils_Tuple2('ょ', 2),
			_Utils_Tuple2('ア', 2),
			_Utils_Tuple2('イ', 2),
			_Utils_Tuple2('ウ', 3),
			_Utils_Tuple2('エ', 3),
			_Utils_Tuple2('オ', 3),
			_Utils_Tuple2('カ', 2),
			_Utils_Tuple2('キ', 3),
			_Utils_Tuple2('ク', 2),
			_Utils_Tuple2('ケ', 3),
			_Utils_Tuple2('コ', 2),
			_Utils_Tuple2('サ', 3),
			_Utils_Tuple2('シ', 3),
			_Utils_Tuple2('ス', 2),
			_Utils_Tuple2('セ', 2),
			_Utils_Tuple2('ソ', 2),
			_Utils_Tuple2('タ', 3),
			_Utils_Tuple2('チ', 3),
			_Utils_Tuple2('ツ', 3),
			_Utils_Tuple2('テ', 3),
			_Utils_Tuple2('ト', 2),
			_Utils_Tuple2('ナ', 2),
			_Utils_Tuple2('ニ', 2),
			_Utils_Tuple2('ヌ', 2),
			_Utils_Tuple2('ネ', 4),
			_Utils_Tuple2('ノ', 1),
			_Utils_Tuple2('ハ', 2),
			_Utils_Tuple2('ヒ', 2),
			_Utils_Tuple2('フ', 1),
			_Utils_Tuple2('ヘ', 1),
			_Utils_Tuple2('ホ', 4),
			_Utils_Tuple2('マ', 2),
			_Utils_Tuple2('ミ', 3),
			_Utils_Tuple2('ム', 2),
			_Utils_Tuple2('メ', 1),
			_Utils_Tuple2('モ', 3),
			_Utils_Tuple2('ヤ', 2),
			_Utils_Tuple2('ユ', 2),
			_Utils_Tuple2('ヨ', 3),
			_Utils_Tuple2('ラ', 2),
			_Utils_Tuple2('リ', 2),
			_Utils_Tuple2('ル', 2),
			_Utils_Tuple2('レ', 1),
			_Utils_Tuple2('ロ', 3),
			_Utils_Tuple2('ワ', 2),
			_Utils_Tuple2('ヰ', 4),
			_Utils_Tuple2('ヱ', 3),
			_Utils_Tuple2('ヲ', 3),
			_Utils_Tuple2('ン', 2),
			_Utils_Tuple2('ガ', 4),
			_Utils_Tuple2('ギ', 5),
			_Utils_Tuple2('グ', 4),
			_Utils_Tuple2('ゲ', 5),
			_Utils_Tuple2('ゴ', 4),
			_Utils_Tuple2('ザ', 5),
			_Utils_Tuple2('ジ', 5),
			_Utils_Tuple2('ズ', 4),
			_Utils_Tuple2('ゼ', 4),
			_Utils_Tuple2('ゾ', 4),
			_Utils_Tuple2('ダ', 5),
			_Utils_Tuple2('ヂ', 5),
			_Utils_Tuple2('ヅ', 5),
			_Utils_Tuple2('デ', 5),
			_Utils_Tuple2('ド', 4),
			_Utils_Tuple2('バ', 4),
			_Utils_Tuple2('ビ', 4),
			_Utils_Tuple2('ブ', 3),
			_Utils_Tuple2('ベ', 3),
			_Utils_Tuple2('ボ', 6),
			_Utils_Tuple2('パ', 3),
			_Utils_Tuple2('ピ', 3),
			_Utils_Tuple2('プ', 2),
			_Utils_Tuple2('ペ', 2),
			_Utils_Tuple2('ポ', 5),
			_Utils_Tuple2('ャ', 2),
			_Utils_Tuple2('ュ', 2),
			_Utils_Tuple2('ョ', 3),
			_Utils_Tuple2('ッ', 3)
		]));
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Extras$String$toStringList = function (string) {
	return A2(
		$elm$core$List$map,
		function (character) {
			return $elm$core$String$fromChar(character);
		},
		$elm$core$String$toList(string));
};
var $author$project$Services$BoardItem$doesItemStringMatchCurrentKanaString = F2(
	function (animatedKanaRecord, boardItemString) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				function (boardItemStringValue) {
					var _v0 = $author$project$Extras$String$toStringList(animatedKanaRecord.cD);
					_v0$2:
					while (true) {
						if (_v0.b) {
							if (!_v0.b.b) {
								var firstCharacter = _v0.a;
								return $elm$core$Maybe$Just(
									_Utils_eq(boardItemStringValue, firstCharacter));
							} else {
								if (!_v0.b.b.b) {
									var firstCharacter = _v0.a;
									var _v1 = _v0.b;
									var secondCharacter = _v1.a;
									var dashLimit = A2(
										$elm$core$Maybe$andThen,
										function (intValue) {
											return $elm$core$Maybe$Just(
												$elm$core$List$sum(
													A2($elm$core$List$take, intValue, animatedKanaRecord.$7)));
										},
										A2($elm$core$Dict$get, firstCharacter, $author$project$Services$Kana$numberOfStrokesPerKana));
									if (!dashLimit.$) {
										var dashLimitValue = dashLimit.a;
										return (_Utils_cmp(animatedKanaRecord.bZ, dashLimitValue) < 0) ? $elm$core$Maybe$Just(
											_Utils_eq(boardItemStringValue, firstCharacter)) : $elm$core$Maybe$Just(
											_Utils_eq(boardItemStringValue, secondCharacter));
									} else {
										return $elm$core$Maybe$Just(false);
									}
								} else {
									break _v0$2;
								}
							}
						} else {
							break _v0$2;
						}
					}
					return $elm$core$Maybe$Just(false);
				},
				boardItemString));
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Extras$List$elementAt = F2(
	function (index, list) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, list));
	});
var $author$project$Domain$Types$AnimatedKanaRecord = F7(
	function (audioID, strokePathStringList, strokeDashMaxList, strokeAnimationIndex, name, japaneseName, dashValue) {
		return {bB: audioID, bZ: dashValue, cD: japaneseName, cV: name, dn: strokeAnimationIndex, $7: strokeDashMaxList, dp: strokePathStringList};
	});
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$unknown = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	9999,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52', $elm$core$Maybe$Nothing, 10)
		]),
	_List_Nil,
	1,
	'unknown',
	'unknown',
	0);
var $author$project$Services$Kanaword$toCurrentAnimatedKanaRecord = function (animatedKanaData) {
	var currentAnimatingKanaIndex = animatedKanaData.bV;
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SVGs$AnimatedKanaTiles$Hiragana$unknown,
		A2($author$project$Extras$List$elementAt, currentAnimatingKanaIndex, animatedKanaData.bv));
};
var $author$project$Services$BoardItem$isBoardItemCurrentKana = F2(
	function (model, boardItemType) {
		var currentKanaRecord = $author$project$Services$Kanaword$toCurrentAnimatedKanaRecord(model.bw);
		switch (boardItemType.$) {
			case 9:
				var itemString = boardItemType.a;
				return A2($author$project$Services$BoardItem$doesItemStringMatchCurrentKanaString, currentKanaRecord, itemString);
			case 11:
				var itemString = boardItemType.a;
				return A2($author$project$Services$BoardItem$doesItemStringMatchCurrentKanaString, currentKanaRecord, itemString);
			case 7:
				var itemString = boardItemType.a;
				return A2($author$project$Services$BoardItem$doesItemStringMatchCurrentKanaString, currentKanaRecord, itemString);
			case 8:
				var itemString = boardItemType.a;
				return A2($author$project$Services$BoardItem$doesItemStringMatchCurrentKanaString, currentKanaRecord, itemString);
			case 10:
				var itemString = boardItemType.a;
				return A2($author$project$Services$BoardItem$doesItemStringMatchCurrentKanaString, currentKanaRecord, itemString);
			default:
				return false;
		}
	});
var $author$project$Services$BoardItem$doesChainContainCurrentKana = F2(
	function (model, chain) {
		return A2(
			$elm$core$List$any,
			function (boardItemType) {
				return A2($author$project$Services$BoardItem$isBoardItemCurrentKana, model, boardItemType);
			},
			A2(
				$elm$core$List$map,
				function (boardItem) {
					return boardItem.bF;
				},
				chain));
	});
var $author$project$Services$BoardItem$doesChainContainNoCurrentKana = F2(
	function (model, chain) {
		return !A2($author$project$Services$BoardItem$doesChainContainCurrentKana, model, chain);
	});
var $author$project$Services$Score$getAnimatedScores = function (model) {
	return A2(
		$elm$core$List$map,
		function (chain) {
			return _Utils_Tuple2(chain, model.bS);
		},
		A2(
			$elm$core$List$filter,
			$author$project$Services$BoardItem$doesChainContainNoCurrentKana(model),
			model.bN));
};
var $author$project$Services$Score$appendScoreAnimations = function (model) {
	return _Utils_update(
		model,
		{
			bx: _Utils_ap(
				model.bx,
				$author$project$Services$Score$getAnimatedScores(model))
		});
};
var $author$project$Services$BoardState$clearRefillItems = function (model) {
	return _Utils_update(
		model,
		{ca: _List_Nil, dC: _List_Nil});
};
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Services$Tile$hasTile = function (number) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$andThen,
			function (value) {
				return $elm$core$Maybe$Just(value === 1);
			},
			number));
};
var $author$project$Services$Tile$hasTileAtCoordinates = F2(
	function (_v0, tiles) {
		var row = _v0.a;
		var column = _v0.b;
		return $author$project$Services$Tile$hasTile(
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Array$get(column),
				A2($elm$core$Array$get, row, tiles)));
	});
var $author$project$Services$Tile$boardHasTileAt = F2(
	function (tiles, coordinates) {
		return A2($author$project$Services$Tile$hasTileAtCoordinates, coordinates, tiles);
	});
var $author$project$Services$Chain$chainsContainCoordinates = F2(
	function (coordinates, chains) {
		return A2(
			$elm$core$List$any,
			function (chain) {
				return A2(
					$elm$core$List$any,
					function (boardItem) {
						return _Utils_eq(boardItem.aw, coordinates);
					},
					chain);
			},
			chains);
	});
var $author$project$Domain$Types$Column = $elm$core$Basics$identity;
var $author$project$Domain$Types$Row = $elm$core$Basics$identity;
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $author$project$Extras$Array$indexedFoldLeft = F3(
	function (_function, initialValue, array) {
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (element, _v0) {
					var index = _v0.a;
					var acc = _v0.b;
					return _Utils_Tuple2(
						index + 1,
						A3(_function, index, acc, element));
				}),
			_Utils_Tuple2(0, initialValue),
			array).b;
	});
var $author$project$Services$Matrix$foldLeft = F3(
	function (_function, initialValue, matrix) {
		return A3(
			$author$project$Extras$Array$indexedFoldLeft,
			F3(
				function (row, chainList, array) {
					return A3(
						$author$project$Extras$Array$indexedFoldLeft,
						F3(
							function (column, chain, arrayItem) {
								return A3(
									_function,
									_Utils_Tuple2(row, column),
									chain,
									arrayItem);
							}),
						chainList,
						array);
				}),
			initialValue,
			matrix);
	});
var $author$project$Services$Chain$detectChains = F3(
	function (existingChains, detectChainFunction, matrix) {
		return A3(
			$author$project$Services$Matrix$foldLeft,
			F3(
				function (coordinates, chainList, _v0) {
					return A2($author$project$Services$Chain$chainsContainCoordinates, coordinates, chainList) ? chainList : A2(
						$elm$core$Maybe$withDefault,
						chainList,
						A2(
							$elm$core$Maybe$andThen,
							function (chain) {
								return $elm$core$Maybe$Just(
									_Utils_ap(
										chainList,
										_List_fromArray(
											[chain])));
							},
							A2(detectChainFunction, coordinates, matrix)));
				}),
			existingChains,
			matrix);
	});
var $author$project$Services$Chain$checkChainMinimumLength = F2(
	function (minimumChainLength, chain) {
		return (_Utils_cmp(
			$elm$core$List$length(chain),
			minimumChainLength) > -1) ? $elm$core$Maybe$Just(chain) : $elm$core$Maybe$Nothing;
	});
var $author$project$Services$Matrix$below = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return _Utils_Tuple2(row + 1, column);
};
var $author$project$Domain$Types$NoColor = 5;
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Services$BoardItem$boardItemsAreSameColor = F2(
	function (leftBoardItem, rightBoardItem) {
		return (leftBoardItem.bQ !== 5) && ((leftBoardItem.bQ !== 5) && _Utils_eq(leftBoardItem.bQ, rightBoardItem.bQ));
	});
var $author$project$Services$Board$valueAtRowAndColumn = F2(
	function (_v0, boardItems) {
		var row = _v0.a;
		var column = _v0.b;
		return $author$project$Extras$Maybe$flatten(
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Array$get(column),
				A2($elm$core$Array$get, row, boardItems)));
	});
var $author$project$Services$Chain$itemIsSameColorAtCoordinates = F3(
	function (coordinates, boardItems, item) {
		return A2(
			$elm$core$Maybe$andThen,
			function (compareToItem) {
				return $elm$core$Maybe$Just(
					A2($author$project$Services$BoardItem$boardItemsAreSameColor, item, compareToItem));
			},
			A2($author$project$Services$Board$valueAtRowAndColumn, coordinates, boardItems));
	});
var $author$project$Services$Chain$itemsAreSameColor = F3(
	function (coordinates1, coordinates2, boardItems) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2($author$project$Services$Chain$itemIsSameColorAtCoordinates, coordinates2, boardItems),
				A2($author$project$Services$Board$valueAtRowAndColumn, coordinates1, boardItems)));
	});
var $author$project$Services$Chain$itemsOfSameColorInDirection = F3(
	function (coordinates, directionFunction, boardItems) {
		var newCoordinates = directionFunction(coordinates);
		if (A3($author$project$Services$Chain$itemsAreSameColor, coordinates, newCoordinates, boardItems)) {
			var _v0 = A2($author$project$Services$Board$valueAtRowAndColumn, newCoordinates, boardItems);
			if (!_v0.$) {
				var boardItem = _v0.a;
				return A2(
					$elm$core$List$cons,
					boardItem,
					A3($author$project$Services$Chain$itemsOfSameColorInDirection, newCoordinates, directionFunction, boardItems));
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Services$Chain$itemsOfSameColorBelow = F2(
	function (coordinates, matrix) {
		return A3($author$project$Services$Chain$itemsOfSameColorInDirection, coordinates, $author$project$Services$Matrix$below, matrix);
	});
var $author$project$Services$Chain$getVerticalChain = F3(
	function (minimumLength, coordinates, boardItems) {
		return A2(
			$elm$core$Maybe$andThen,
			function (boardItem) {
				return A2(
					$author$project$Services$Chain$checkChainMinimumLength,
					minimumLength,
					A2(
						$elm$core$List$cons,
						boardItem,
						A2($author$project$Services$Chain$itemsOfSameColorBelow, coordinates, boardItems)));
			},
			A2($author$project$Services$Board$valueAtRowAndColumn, coordinates, boardItems));
	});
var $author$project$Services$Chain$detectVerticalChains = F3(
	function (minimumLength, existingChains, matrix) {
		return A3(
			$author$project$Services$Chain$detectChains,
			existingChains,
			$author$project$Services$Chain$getVerticalChain(minimumLength),
			matrix);
	});
var $author$project$Services$Chain$appendThreeInAColumnChains = F2(
	function (matrix, existingChains) {
		return A3($author$project$Services$Chain$detectVerticalChains, 3, existingChains, matrix);
	});
var $author$project$Services$Matrix$rightOf = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return _Utils_Tuple2(row, column + 1);
};
var $author$project$Services$Chain$itemsOfSameColorToTheRight = F2(
	function (coordinates, matrix) {
		return A3($author$project$Services$Chain$itemsOfSameColorInDirection, coordinates, $author$project$Services$Matrix$rightOf, matrix);
	});
var $author$project$Services$Chain$getHorizontalChain = F3(
	function (minimumLength, coordinates, boardItems) {
		return A2(
			$elm$core$Maybe$andThen,
			function (boardItem) {
				return A2(
					$author$project$Services$Chain$checkChainMinimumLength,
					minimumLength,
					A2(
						$elm$core$List$cons,
						boardItem,
						A2($author$project$Services$Chain$itemsOfSameColorToTheRight, coordinates, boardItems)));
			},
			A2($author$project$Services$Board$valueAtRowAndColumn, coordinates, boardItems));
	});
var $author$project$Services$Chain$detectHorizontalChains = F3(
	function (minimumLength, existingChains, matrix) {
		return A3(
			$author$project$Services$Chain$detectChains,
			existingChains,
			$author$project$Services$Chain$getHorizontalChain(minimumLength),
			matrix);
	});
var $author$project$Services$Chain$appendThreeInARowChains = F2(
	function (matrix, existingChains) {
		return A3($author$project$Services$Chain$detectHorizontalChains, 3, existingChains, matrix);
	});
var $author$project$Services$Chain$detectThreeInALineChains = function (boardItems) {
	return A2(
		$author$project$Services$Chain$appendThreeInAColumnChains,
		boardItems,
		A2($author$project$Services$Chain$appendThreeInARowChains, boardItems, _List_Nil));
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Services$Swap$isColumnOutOfBounds = F2(
	function (matrix, column) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$andThen,
				function (array) {
					return $elm$core$Maybe$Just(
						(column < 0) || (_Utils_cmp(
							column,
							$elm$core$Array$length(array)) > -1));
				},
				A2($elm$core$Array$get, 0, matrix)));
	});
var $author$project$Services$Swap$isRowOutOfBounds = F2(
	function (matrix, row) {
		return (row < 0) || (_Utils_cmp(
			row,
			$elm$core$Array$length(matrix)) > -1);
	});
var $author$project$Services$Swap$areCoordinatesOutOfBounds = F2(
	function (_v0, matrix) {
		var row = _v0.a;
		var column = _v0.b;
		return A2($author$project$Services$Swap$isColumnOutOfBounds, matrix, column) || A2($author$project$Services$Swap$isRowOutOfBounds, matrix, row);
	});
var $author$project$Services$Swap$isSwapOutOfBounds = F2(
	function (_v0, matrix) {
		var firstCoordinates = _v0.a;
		var secondCoordinates = _v0.b;
		return A2($author$project$Services$Swap$areCoordinatesOutOfBounds, firstCoordinates, matrix) || A2($author$project$Services$Swap$areCoordinatesOutOfBounds, secondCoordinates, matrix);
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$Services$Matrix$set = F3(
	function (_v0, newValue, boardItems) {
		var row = _v0.a;
		var column = _v0.b;
		return A3(
			$elm$core$Array$set,
			row,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Array$empty,
				A2(
					$elm$core$Maybe$andThen,
					function (array) {
						return $elm$core$Maybe$Just(
							A3($elm$core$Array$set, column, newValue, array));
					},
					A2($elm$core$Array$get, row, boardItems))),
			boardItems);
	});
var $author$project$Services$Swap$updateCoordinates = F2(
	function (coordinates, boardItem) {
		return A2(
			$elm$core$Maybe$andThen,
			function (item) {
				return $elm$core$Maybe$Just(
					_Utils_update(
						item,
						{aw: coordinates}));
			},
			boardItem);
	});
var $author$project$Services$Swap$performSwap = F2(
	function (swap, boardItems) {
		return A2($author$project$Services$Swap$isSwapOutOfBounds, swap, boardItems) ? boardItems : A3(
			$author$project$Services$Matrix$set,
			swap.b,
			A2(
				$author$project$Services$Swap$updateCoordinates,
				swap.b,
				A2($author$project$Services$Board$valueAtRowAndColumn, swap.a, boardItems)),
			A3(
				$author$project$Services$Matrix$set,
				swap.a,
				A2(
					$author$project$Services$Swap$updateCoordinates,
					swap.a,
					A2($author$project$Services$Board$valueAtRowAndColumn, swap.b, boardItems)),
				boardItems));
	});
var $author$project$Services$Swap$appendSwap = F4(
	function (hasTileAt, swap, matrix, existingSwaps) {
		var firstCoordinates = swap.a;
		var secondCoordinates = swap.b;
		if (hasTileAt(firstCoordinates) && hasTileAt(secondCoordinates)) {
			var _v0 = $elm$core$List$length(
				$author$project$Services$Chain$detectThreeInALineChains(
					A2($author$project$Services$Swap$performSwap, swap, matrix)));
			if (!_v0) {
				return existingSwaps;
			} else {
				return _Utils_ap(
					existingSwaps,
					_List_fromArray(
						[swap]));
			}
		} else {
			return existingSwaps;
		}
	});
var $author$project$Services$Swap$detectAllSwaps = F2(
	function (hasTileAt, matrix) {
		return A3(
			$author$project$Services$Matrix$foldLeft,
			F3(
				function (coordinates, swapList, _v0) {
					return A4(
						$author$project$Services$Swap$appendSwap,
						hasTileAt,
						_Utils_Tuple2(
							coordinates,
							$author$project$Services$Matrix$below(coordinates)),
						matrix,
						A4(
							$author$project$Services$Swap$appendSwap,
							hasTileAt,
							_Utils_Tuple2(
								coordinates,
								$author$project$Services$Matrix$rightOf(coordinates)),
							matrix,
							swapList));
				}),
			_List_Nil,
			matrix);
	});
var $author$project$Extras$Array$indexedFoldRight = F3(
	function (_function, initialValue, array) {
		return A3(
			$elm$core$Array$foldr,
			F2(
				function (element, _v0) {
					var index = _v0.a;
					var acc = _v0.b;
					return _Utils_Tuple2(
						index - 1,
						A3(_function, index, acc, element));
				}),
			_Utils_Tuple2(
				$elm$core$Array$length(array) - 1,
				initialValue),
			array).b;
	});
var $author$project$Extras$Array$getFirstElementIndexFromIndex = F2(
	function (index, array) {
		getFirstElementIndexFromIndex:
		while (true) {
			if ((index < 1) || (_Utils_cmp(
				index,
				$elm$core$Array$length(array)) > -1)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v0 = $author$project$Extras$Maybe$flatten(
					A2($elm$core$Array$get, index - 1, array));
				if (!_v0.$) {
					return $elm$core$Maybe$Just(index - 1);
				} else {
					var $temp$index = index - 1,
						$temp$array = array;
					index = $temp$index;
					array = $temp$array;
					continue getFirstElementIndexFromIndex;
				}
			}
		}
	});
var $author$project$Services$Chain$updateRowIndex = F2(
	function (rowIndex, _v0) {
		var row = _v0.a;
		var column = _v0.b;
		return _Utils_Tuple2(rowIndex, column);
	});
var $author$project$Services$Chain$updateCoordinates = F2(
	function (rowIndex, boardItem) {
		return A2(
			$elm$core$Maybe$andThen,
			function (item) {
				return $elm$core$Maybe$Just(
					_Utils_update(
						item,
						{
							aw: A2($author$project$Services$Chain$updateRowIndex, rowIndex, item.aw)
						}));
			},
			boardItem);
	});
var $author$project$Services$Chain$swapBoardItems = F3(
	function (firstIndex, secondIndex, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			array,
			A2(
				$elm$core$Maybe$andThen,
				function (firstElement) {
					return A2(
						$elm$core$Maybe$andThen,
						function (secondElement) {
							return $elm$core$Maybe$Just(
								A3(
									$elm$core$Array$set,
									secondIndex,
									A2($author$project$Services$Chain$updateCoordinates, secondIndex, firstElement),
									A3(
										$elm$core$Array$set,
										firstIndex,
										A2($author$project$Services$Chain$updateCoordinates, firstIndex, secondElement),
										array)));
						},
						A2($elm$core$Array$get, secondIndex, array));
				},
				A2($elm$core$Array$get, firstIndex, array)));
	});
var $author$project$Services$Chain$swapWithHole = F2(
	function (index, boardItemRow) {
		return A2(
			$elm$core$Maybe$withDefault,
			boardItemRow,
			A2(
				$elm$core$Maybe$andThen,
				function (foundIndex) {
					return $elm$core$Maybe$Just(
						A3($author$project$Services$Chain$swapBoardItems, index, foundIndex, boardItemRow));
				},
				A2($author$project$Extras$Array$getFirstElementIndexFromIndex, index, boardItemRow)));
	});
var $author$project$Services$Chain$fillColumnHoles = F3(
	function (columnIndex, hasTileAt, boardItemColumn) {
		return A3(
			$author$project$Extras$Array$indexedFoldRight,
			F3(
				function (rowIndex, row, _v0) {
					if (!A2(hasTileAt, rowIndex, columnIndex)) {
						return row;
					} else {
						var _v1 = $author$project$Extras$Maybe$flatten(
							A2($elm$core$Array$get, rowIndex, row));
						if (_v1.$ === 1) {
							return A2($author$project$Services$Chain$swapWithHole, rowIndex, row);
						} else {
							return row;
						}
					}
				}),
			boardItemColumn,
			boardItemColumn);
	});
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			d: _List_Nil,
			a: 0,
			c: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.a * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						d: A2($elm$core$List$cons, mappedLeaf, builder.d),
						a: builder.a + 1,
						c: builder.c
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $author$project$Extras$Array$firstArrayLength = function (matrix) {
	var _v0 = A2($elm$core$Array$get, 0, matrix);
	if (_v0.$ === 1) {
		return 0;
	} else {
		var row = _v0.a;
		return $elm$core$Array$length(row);
	}
};
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.c)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.c, tail);
		return (notAppended < 0) ? {
			d: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.d),
			a: builder.a + 1,
			c: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			d: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.d),
			a: builder.a + 1,
			c: $elm$core$Elm$JsArray$empty
		} : {d: builder.d, a: builder.a, c: appended});
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		d: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		a: (len / $elm$core$Array$branchFactor) | 0,
		c: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						d: _List_Nil,
						a: 0,
						c: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $author$project$Extras$Array$insertAt = F2(
	function (index, val) {
		return function (array) {
			if ((index >= 0) && (_Utils_cmp(
				index,
				$elm$core$Array$length(array)) < 1)) {
				var before = A3($elm$core$Array$slice, 0, index, array);
				var after = A3(
					$elm$core$Array$slice,
					index,
					$elm$core$Array$length(array),
					array);
				return A2(
					$elm$core$Array$append,
					A2($elm$core$Array$push, val, before),
					after);
			} else {
				return array;
			}
		};
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{d: nodeList, a: nodeListSize, c: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Extras$Array$map2 = F3(
	function (combineAb, aArray, bArray) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$List$map2,
				combineAb,
				$elm$core$Array$toList(aArray),
				$elm$core$Array$toList(bArray)));
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$Extras$Array$transposeRowsAndColumns = function (matrix) {
	return A3(
		$elm$core$Array$foldr,
		$author$project$Extras$Array$map2(
			$author$project$Extras$Array$insertAt(0)),
		A2(
			$elm$core$Array$repeat,
			$author$project$Extras$Array$firstArrayLength(matrix),
			$elm$core$Array$empty),
		matrix);
};
var $author$project$Services$Chain$fillMatrixHoles = F2(
	function (hasTileAt, matrix) {
		return $author$project$Extras$Array$transposeRowsAndColumns(
			A2(
				$elm$core$Array$indexedMap,
				function (columnIndex) {
					return A2($author$project$Services$Chain$fillColumnHoles, columnIndex, hasTileAt);
				},
				$author$project$Extras$Array$transposeRowsAndColumns(matrix)));
	});
var $author$project$Services$Tile$hasTileAt = F3(
	function (tiles, rowIndex, columnIndex) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			_Utils_Tuple2(rowIndex, columnIndex),
			tiles);
	});
var $author$project$Services$Chain$boardItemTypes = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 2, 3, 4]));
var $author$project$Domain$Types$BoardItem = F4(
	function (id, coordinates, color, boardItemType) {
		return {bF: boardItemType, bQ: color, aw: coordinates, cp: id};
	});
var $author$project$Domain$Types$DarkBlue = 1;
var $author$project$Domain$Types$FiveInARowBonus = {$: 1};
var $author$project$Domain$Types$LightBlue = 4;
var $author$project$Domain$Types$Purple = 3;
var $author$project$Domain$Types$Red = 0;
var $author$project$Domain$Types$Yellow = 2;
var $author$project$Domain$Types$DiamondWithKana = function (a) {
	return {$: 7, a: a};
};
var $author$project$Domain$Types$HexagonWithKana = function (a) {
	return {$: 8, a: a};
};
var $author$project$Domain$Types$OvalWithKana = function (a) {
	return {$: 9, a: a};
};
var $author$project$Domain$Types$SquareWithKana = function (a) {
	return {$: 11, a: a};
};
var $author$project$Domain$Types$TriangleWithKana = function (a) {
	return {$: 10, a: a};
};
var $author$project$Services$Board$boardKanaColorToShape = F4(
	function (id, boardKanaColor, kanaString, coordinates) {
		switch (boardKanaColor) {
			case 0:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$SquareWithKana(kanaString)));
			case 2:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$DiamondWithKana(kanaString)));
			case 1:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$OvalWithKana(kanaString)));
			case 3:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$TriangleWithKana(kanaString)));
			case 4:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$HexagonWithKana(kanaString)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Services$Board$characterToShapeKanaString = F2(
	function (character, kanaToColorLookup) {
		return A2(
			$elm$core$Maybe$andThen,
			function (intValue) {
				return A2($elm$core$Dict$get, intValue, kanaToColorLookup);
			},
			$elm$core$String$toInt(
				$elm$core$String$fromChar(character)));
	});
var $author$project$Services$Board$characterToBoardItem = F4(
	function (id, character, coordinates, kanaToColorLookup) {
		var kanaString = A2($author$project$Services$Board$characterToShapeKanaString, character, kanaToColorLookup);
		switch (character) {
			case '0':
				return A4($author$project$Services$Board$boardKanaColorToShape, id, 0, kanaString, coordinates);
			case '1':
				return A4($author$project$Services$Board$boardKanaColorToShape, id, 1, kanaString, coordinates);
			case '2':
				return A4($author$project$Services$Board$boardKanaColorToShape, id, 2, kanaString, coordinates);
			case '3':
				return A4($author$project$Services$Board$boardKanaColorToShape, id, 3, kanaString, coordinates);
			case '4':
				return A4($author$project$Services$Board$boardKanaColorToShape, id, 4, kanaString, coordinates);
			case '大':
				return $elm$core$Maybe$Just(
					A4($author$project$Domain$Types$BoardItem, id, coordinates, 5, $author$project$Domain$Types$FiveInARowBonus));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Domain$Types$BombBonus = {$: 0};
var $author$project$Domain$Types$Horizontal = 0;
var $author$project$Domain$Types$Vertical = 1;
var $author$project$Domain$Types$StripedDiamond = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Types$StripedHexagon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Types$StripedOval = function (a) {
	return {$: 4, a: a};
};
var $author$project$Domain$Types$StripedSquare = function (a) {
	return {$: 6, a: a};
};
var $author$project$Domain$Types$StripedTriangle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Board$boardKanaColorToStripedBonus = F4(
	function (id, boardKanaColor, coordinates, stripeDirection) {
		switch (boardKanaColor) {
			case 0:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$StripedSquare(stripeDirection)));
			case 2:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$StripedDiamond(stripeDirection)));
			case 1:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$StripedOval(stripeDirection)));
			case 3:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$StripedTriangle(stripeDirection)));
			case 4:
				return $elm$core$Maybe$Just(
					A4(
						$author$project$Domain$Types$BoardItem,
						id,
						coordinates,
						boardKanaColor,
						$author$project$Domain$Types$StripedHexagon(stripeDirection)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Services$Board$characterToBoardKanaColor = function (character) {
	switch (character) {
		case '0':
			return $elm$core$Maybe$Just(0);
		case '1':
			return $elm$core$Maybe$Just(1);
		case '2':
			return $elm$core$Maybe$Just(2);
		case '3':
			return $elm$core$Maybe$Just(3);
		case '4':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Board$charactersToBoardItem = F3(
	function (id, characters, coordinates) {
		_v0$3:
		while (true) {
			if (((characters.b && characters.b.b) && ('_' === characters.b.a)) && characters.b.b.b) {
				if (!characters.b.b.b.b) {
					if ('田' === characters.a) {
						var _v1 = characters.b;
						var _v2 = _v1.b;
						var color = _v2.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (boardKanaColor) {
								return $elm$core$Maybe$Just(
									A4($author$project$Domain$Types$BoardItem, id, coordinates, boardKanaColor, $author$project$Domain$Types$BombBonus));
							},
							$author$project$Services$Board$characterToBoardKanaColor(color));
					} else {
						break _v0$3;
					}
				} else {
					if (((('水' === characters.a) && ('_' === characters.b.b.b.a)) && characters.b.b.b.b.b) && (!characters.b.b.b.b.b.b)) {
						switch (characters.b.b.b.b.a) {
							case 'H':
								var _v3 = characters.b;
								var _v4 = _v3.b;
								var color = _v4.a;
								var _v5 = _v4.b;
								var _v6 = _v5.b;
								return A2(
									$elm$core$Maybe$andThen,
									function (boardKanaColor) {
										return A4($author$project$Services$Board$boardKanaColorToStripedBonus, id, boardKanaColor, coordinates, 0);
									},
									$author$project$Services$Board$characterToBoardKanaColor(color));
							case 'V':
								var _v7 = characters.b;
								var _v8 = _v7.b;
								var color = _v8.a;
								var _v9 = _v8.b;
								var _v10 = _v9.b;
								return A2(
									$elm$core$Maybe$andThen,
									function (boardKanaColor) {
										return A4($author$project$Services$Board$boardKanaColorToStripedBonus, id, boardKanaColor, coordinates, 1);
									},
									$author$project$Services$Board$characterToBoardKanaColor(color));
							default:
								break _v0$3;
						}
					} else {
						break _v0$3;
					}
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Services$Board$parseBoardItemString = F4(
	function (id, boardItemString, coordinates, kanaToColorLookup) {
		return A2(
			$elm$core$Maybe$andThen,
			function (value) {
				var _v0 = $elm$core$String$toList(value);
				_v0$3:
				while (true) {
					if (_v0.b) {
						if (!_v0.b.b) {
							var character = _v0.a;
							return A4($author$project$Services$Board$characterToBoardItem, id, character, coordinates, kanaToColorLookup);
						} else {
							if (_v0.b.b.b) {
								if (!_v0.b.b.b.b) {
									var characters = _v0;
									var _v1 = characters.b;
									var _v2 = _v1.b;
									return A3($author$project$Services$Board$charactersToBoardItem, id, characters, coordinates);
								} else {
									if (_v0.b.b.b.b.b && (!_v0.b.b.b.b.b.b)) {
										var characters = _v0;
										var _v3 = characters.b;
										var _v4 = _v3.b;
										var _v5 = _v4.b;
										var _v6 = _v5.b;
										return A3($author$project$Services$Board$charactersToBoardItem, id, characters, coordinates);
									} else {
										break _v0$3;
									}
								}
							} else {
								break _v0$3;
							}
						}
					} else {
						break _v0$3;
					}
				}
				return $elm$core$Maybe$Nothing;
			},
			boardItemString);
	});
var $author$project$Services$Board$indexGenerator = function (validNumberArray) {
	return A2(
		$elm$random$Random$int,
		0,
		$elm$core$Array$length(validNumberArray) - 1);
};
var $author$project$Services$KeyGenerator$characterAtIndex = F2(
	function (index, string) {
		return A3($elm$core$String$slice, index - 1, index, string);
	});
var $author$project$Services$KeyGenerator$characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var $author$project$Services$KeyGenerator$charactersCount = $elm$core$String$length($author$project$Services$KeyGenerator$characters);
var $author$project$Services$KeyGenerator$generateFromSeedInternal = F3(
	function (length, seed, existingString) {
		var _v0 = A2(
			$elm$random$Random$step,
			A2($elm$random$Random$int, 0, $author$project$Services$KeyGenerator$charactersCount),
			seed);
		var index = _v0.a;
		var nextSeed = _v0.b;
		var randomCharacter = A2($author$project$Services$KeyGenerator$characterAtIndex, index, $author$project$Services$KeyGenerator$characters);
		return (!length) ? _Utils_Tuple2(existingString, nextSeed) : A3(
			$author$project$Services$KeyGenerator$generateFromSeedInternal,
			length - 1,
			nextSeed,
			_Utils_ap(existingString, randomCharacter));
	});
var $author$project$Services$KeyGenerator$generateFromSeed = F2(
	function (length, seed) {
		return A3($author$project$Services$KeyGenerator$generateFromSeedInternal, length, seed, '');
	});
var $author$project$Services$KeyGenerator$seedToKey = function (seed) {
	return A2($author$project$Services$KeyGenerator$generateFromSeed, 6, seed);
};
var $author$project$Services$Board$randomBoardItemNumber = F2(
	function (seed, validNumberArray) {
		var _v0 = A2(
			$elm$random$Random$step,
			$author$project$Services$Board$indexGenerator(validNumberArray),
			seed);
		var index = _v0.a;
		var nextSeed = _v0.b;
		var selectedNumber = A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2($elm$core$Array$get, index, validNumberArray));
		var _v1 = $author$project$Services$KeyGenerator$seedToKey(seed);
		var id = _v1.a;
		return _Utils_Tuple3(id, selectedNumber, nextSeed);
	});
var $author$project$Services$Chain$topUpBoardItem = F5(
	function (kanaToColorLookup, hasTileAt, coordinates, _v0, boardItem) {
		var matrix = _v0.a;
		var seed = _v0.b;
		var _v1 = A2($author$project$Services$Board$randomBoardItemNumber, seed, $author$project$Services$Chain$boardItemTypes);
		var id = _v1.a;
		var randomNumber = _v1.b;
		var nextSeed = _v1.c;
		var _v2 = _Utils_Tuple2(
			boardItem,
			hasTileAt(coordinates));
		if ((_v2.a.$ === 1) && _v2.b) {
			var _v3 = _v2.a;
			return _Utils_Tuple2(
				A3(
					$author$project$Services$Matrix$set,
					coordinates,
					A4(
						$author$project$Services$Board$parseBoardItemString,
						id,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(randomNumber)),
						coordinates,
						kanaToColorLookup),
					matrix),
				nextSeed);
		} else {
			return _Utils_Tuple2(matrix, seed);
		}
	});
var $author$project$Services$Chain$topUpBoard = F4(
	function (kanaToColorLookup, hasTileAt, seed, matrix) {
		return A3(
			$author$project$Services$Matrix$foldLeft,
			A2($author$project$Services$Chain$topUpBoardItem, kanaToColorLookup, hasTileAt),
			_Utils_Tuple2(matrix, seed),
			matrix).a;
	});
var $author$project$Services$BoardState$refillBoard = function (model) {
	return A4(
		$author$project$Services$Chain$topUpBoard,
		model.cG,
		$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
		model.c4.c7,
		A2(
			$author$project$Services$Chain$fillMatrixHoles,
			$author$project$Services$Tile$hasTileAt(model.cK.dw),
			model.bG));
};
var $author$project$Services$BoardState$detectSwaps = function (model) {
	var swapState = model.ds;
	return _Utils_update(
		model,
		{
			ds: _Utils_update(
				swapState,
				{
					c3: A2(
						$author$project$Services$Swap$detectAllSwaps,
						$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
						$author$project$Services$BoardState$refillBoard(model))
				})
		});
};
var $author$project$Services$Chain$getHoleSwapWithHole = F3(
	function (rowIndex, columnIndex, stringArray) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				function (foundIndex) {
					return $elm$core$Maybe$Just(
						_List_fromArray(
							[
								_Utils_Tuple2(
								_Utils_Tuple2(foundIndex, columnIndex),
								_Utils_Tuple2(rowIndex, columnIndex))
							]));
				},
				A2($author$project$Extras$Array$getFirstElementIndexFromIndex, rowIndex, stringArray)));
	});
var $author$project$Services$Chain$getFillColumnSwaps = F3(
	function (hasTileAt, columnIndex, stringColumn) {
		return A3(
			$author$project$Extras$Array$indexedFoldRight,
			F3(
				function (rowIndex, _v0, _v1) {
					var boardItemRow = _v0.a;
					var swapList = _v0.b;
					var _v2 = $author$project$Extras$Maybe$flatten(
						A2($elm$core$Array$get, rowIndex, boardItemRow));
					if (_v2.$ === 1) {
						return A2(hasTileAt, rowIndex, columnIndex) ? _Utils_Tuple2(
							A2($author$project$Services$Chain$swapWithHole, rowIndex, boardItemRow),
							_Utils_ap(
								swapList,
								A3($author$project$Services$Chain$getHoleSwapWithHole, rowIndex, columnIndex, boardItemRow))) : _Utils_Tuple2(boardItemRow, swapList);
					} else {
						return _Utils_Tuple2(boardItemRow, swapList);
					}
				}),
			_Utils_Tuple2(stringColumn, _List_Nil),
			stringColumn).b;
	});
var $author$project$Services$Chain$getFillMatrixSwaps = F2(
	function (hasTileAt, matrix) {
		return A3(
			$author$project$Extras$Array$indexedFoldRight,
			F3(
				function (columnIndex, swaps, column) {
					return _Utils_ap(
						swaps,
						A3($author$project$Services$Chain$getFillColumnSwaps, hasTileAt, columnIndex, column));
				}),
			_List_Nil,
			$author$project$Extras$Array$transposeRowsAndColumns(matrix));
	});
var $author$project$Services$ShapeColor$black = {bE: 0, ch: 0, c6: 0};
var $author$project$Services$ShapeColor$darkBlue = {bE: 255, ch: 135, c6: 93};
var $author$project$Services$ShapeColor$lightBlue = {bE: 240, ch: 234, c6: 0};
var $author$project$Services$ShapeColor$purple = {bE: 241, ch: 111, c6: 188};
var $author$project$Services$ShapeColor$red = {bE: 0, ch: 0, c6: 255};
var $author$project$Services$ShapeColor$yellow = {bE: 0, ch: 215, c6: 255};
var $author$project$Services$Board$boardKanaColorToColor = function (boardKanaColor) {
	switch (boardKanaColor) {
		case 0:
			return $author$project$Services$ShapeColor$red;
		case 2:
			return $author$project$Services$ShapeColor$yellow;
		case 1:
			return $author$project$Services$ShapeColor$darkBlue;
		case 3:
			return $author$project$Services$ShapeColor$purple;
		case 4:
			return $author$project$Services$ShapeColor$lightBlue;
		default:
			return $author$project$Services$ShapeColor$black;
	}
};
var $author$project$Services$BoardItem$isBoardItemNotCurrentKana = F2(
	function (model, boardItemType) {
		return !A2($author$project$Services$BoardItem$isBoardItemCurrentKana, model, boardItemType);
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$BoardState$maxIndex = function (explodedKana) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var index = _v0.c;
					return index;
				},
				explodedKana)));
};
var $author$project$Services$BoardState$getExplodedKana = function (model) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, boardItem) {
				return _Utils_Tuple3(
					boardItem.aw,
					$author$project$Services$Board$boardKanaColorToColor(boardItem.bQ),
					($author$project$Services$BoardState$maxIndex(model.b7) + index) + 1);
			}),
		A2(
			$elm$core$List$filter,
			function (boardItem) {
				return A2($author$project$Services$BoardItem$isBoardItemNotCurrentKana, model, boardItem.bF);
			},
			$elm$core$List$concat(model.bN)));
};
var $author$project$Services$BoardState$initExplodedKana = function (model) {
	return _Utils_update(
		model,
		{
			b7: $author$project$Services$BoardState$getExplodedKana(model)
		});
};
var $author$project$Services$Score$initScoreAnimations = function (model) {
	return _Utils_update(
		model,
		{
			bx: $author$project$Services$Score$getAnimatedScores(model)
		});
};
var $author$project$Services$BoardState$isNotCurrentKanaFilter = F2(
	function (model, boardItem) {
		return A2($author$project$Services$BoardItem$isBoardItemNotCurrentKana, model, boardItem.bF);
	});
var $author$project$Services$BoardState$initShrinkingItems = function (model) {
	var chains = model.bN;
	return _Utils_update(
		model,
		{
			dg: A2(
				$elm$core$List$filter,
				$author$project$Services$BoardState$isNotCurrentKanaFilter(model),
				$elm$core$List$concat(chains))
		});
};
var $author$project$Domain$Types$ShowingBanner = 3;
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Services$Shuffle$performShuffle = function (model) {
	var shuffle = model.a5;
	return ($elm$core$List$isEmpty(model.ds.c3) && (model.cK.cU > 0)) ? _Utils_update(
		model,
		{
			a5: _Utils_update(
				shuffle,
				{dh: 3})
		}) : model;
};
var $author$project$Services$Swap$flipSwap = function (_v0) {
	var firstCoordinates = _v0.a;
	var secondCoordinates = _v0.b;
	return _Utils_Tuple2(secondCoordinates, firstCoordinates);
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Services$Swap$isValidSwap = F2(
	function (swap, swaps) {
		return A2($elm$core$List$member, swap, swaps) || A2(
			$elm$core$List$member,
			$author$project$Services$Swap$flipSwap(swap),
			swaps);
	});
var $author$project$Services$Swap$resetSwap = function (model) {
	var swapState = model.ds;
	return _Utils_update(
		model,
		{
			ds: _Utils_update(
				swapState,
				{dr: $elm$core$Maybe$Nothing})
		});
};
var $author$project$Services$BoardState$performSwapOnModel = function (model) {
	var boardItems = model.bG;
	var swapState = model.ds;
	return A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$andThen,
			function (model2) {
				return $elm$core$Maybe$Just(
					$author$project$Services$Swap$resetSwap(model2));
			},
			A2(
				$elm$core$Maybe$andThen,
				function (swapValue) {
					return A2($author$project$Services$Swap$isValidSwap, swapValue, swapState.c3) ? $elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bG: A2($author$project$Services$Swap$performSwap, swapValue, boardItems),
								ds: _Utils_update(
									swapState,
									{c3: _List_Nil})
							})) : $elm$core$Maybe$Just(model);
				},
				swapState.dr)));
};
var $author$project$Services$Chain$appendFiveInAColumnChains = F2(
	function (matrix, existingChains) {
		return A3($author$project$Services$Chain$detectVerticalChains, 5, existingChains, matrix);
	});
var $author$project$Services$Chain$appendFourInAColumnChains = F2(
	function (matrix, existingChains) {
		return A3($author$project$Services$Chain$detectVerticalChains, 4, existingChains, matrix);
	});
var $author$project$Services$Chain$appendFourInARowChains = F2(
	function (matrix, existingChains) {
		return A3($author$project$Services$Chain$detectHorizontalChains, 4, existingChains, matrix);
	});
var $author$project$Services$Chain$chainsIntersect = F2(
	function (chainOne, chainTwo) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (coordinates, isMember) {
					return isMember || A2($elm$core$List$member, coordinates, chainTwo);
				}),
			false,
			chainOne);
	});
var $author$project$Services$Chain$getIntersectingChain = F2(
	function (horizontalChain, verticalChain) {
		return A2($author$project$Services$Chain$chainsIntersect, horizontalChain, verticalChain) ? $elm$core$Maybe$Just(
			A3(
				$elm$core$List$foldl,
				F2(
					function (coordinates, existingChain) {
						return A2($elm$core$List$member, coordinates, existingChain) ? existingChain : _Utils_ap(
							existingChain,
							_List_fromArray(
								[coordinates]));
					}),
				verticalChain,
				horizontalChain)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Services$Chain$appendIntersectingChains = F2(
	function (matrix, existingChains) {
		var verticalChains = A2(
			$elm$core$List$drop,
			$elm$core$List$length(existingChains),
			A3($author$project$Services$Chain$detectVerticalChains, 3, existingChains, matrix));
		var horizontalChains = A2(
			$elm$core$List$drop,
			$elm$core$List$length(existingChains),
			A3($author$project$Services$Chain$detectHorizontalChains, 3, existingChains, matrix));
		return A3(
			$elm$core$List$foldl,
			F2(
				function (horizontalChain, chainList) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (verticalChain, intersectingChains) {
								var _v0 = A2($author$project$Services$Chain$getIntersectingChain, horizontalChain, verticalChain);
								if (!_v0.$) {
									var chain = _v0.a;
									return _Utils_ap(
										intersectingChains,
										_List_fromArray(
											[chain]));
								} else {
									return intersectingChains;
								}
							}),
						chainList,
						verticalChains);
				}),
			existingChains,
			horizontalChains);
	});
var $author$project$Services$Chain$detectFiveInARowChains = function (matrix) {
	return A3($author$project$Services$Chain$detectHorizontalChains, 5, _List_Nil, matrix);
};
var $author$project$Services$Chain$detectAllChains = function (matrix) {
	return A2(
		$author$project$Services$Chain$appendThreeInAColumnChains,
		matrix,
		A2(
			$author$project$Services$Chain$appendThreeInARowChains,
			matrix,
			A2(
				$author$project$Services$Chain$appendFourInAColumnChains,
				matrix,
				A2(
					$author$project$Services$Chain$appendFourInARowChains,
					matrix,
					A2(
						$author$project$Services$Chain$appendIntersectingChains,
						matrix,
						A2(
							$author$project$Services$Chain$appendFiveInAColumnChains,
							matrix,
							$author$project$Services$Chain$detectFiveInARowChains(matrix)))))));
};
var $author$project$Domain$Types$Active = 0;
var $author$project$Services$Modal$dropDownDefeatModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{b_: 0})
		});
};
var $author$project$Services$BoardState$enableBoardClickEvents = function (model) {
	return _Utils_update(
		model,
		{cA: false});
};
var $author$project$Services$BoardState$resetComboMultiplier = function (model) {
	return _Utils_update(
		model,
		{bS: 1});
};
var $author$project$Services$BoardState$resetCurrentSounds = function (model) {
	return _Utils_update(
		model,
		{bW: _List_Nil});
};
var $author$project$Services$BoardState$prepareForNextTurn = function (model) {
	return (model.cK.cU < 1) ? $author$project$Services$Modal$dropDownDefeatModal(model) : ($elm$core$List$isEmpty(
		$author$project$Services$Chain$detectAllChains(model.bG)) ? $author$project$Services$BoardState$enableBoardClickEvents(
		$author$project$Services$BoardState$resetCurrentSounds(
			$author$project$Services$BoardState$resetComboMultiplier(model))) : model);
};
var $author$project$Services$BoardState$refill = function (model) {
	return _Utils_update(
		model,
		{
			bG: $author$project$Services$BoardState$refillBoard(model)
		});
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Services$Time$delay = F2(
	function (timeInMilliseconds, message) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(message)),
				$elm$core$Process$sleep(timeInMilliseconds)));
	});
var $author$project$Services$Time$refillBoardDuration = 800;
var $author$project$Services$Time$refillBoardDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$refillBoardDuration, message);
};
var $author$project$Domain$Types$BoardItemsFinishedMovingToKanaWord = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Domain$Types$BoardItemsRemoved = 1;
var $author$project$Domain$Types$KanawordMessage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Domain$Types$ScoreProgressAnimationFinished = {$: 2};
var $author$project$Services$BoardItem$boardItemKanaString = function (boardItemType) {
	switch (boardItemType.$) {
		case 9:
			var itemString = boardItemType.a;
			return itemString;
		case 11:
			var itemString = boardItemType.a;
			return itemString;
		case 7:
			var itemString = boardItemType.a;
			return itemString;
		case 8:
			var itemString = boardItemType.a;
			return itemString;
		case 10:
			var itemString = boardItemType.a;
			return itemString;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Time$boardItemToKanawordAnimationDuration = 1250;
var $author$project$Services$Time$boardItemToKanawordDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$boardItemToKanawordAnimationDuration, message);
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Extras$List$isNotEmpty = function (list) {
	return !$elm$core$List$isEmpty(list);
};
var $author$project$Services$Chain$chainsContain = F2(
	function (filter, chains) {
		return $author$project$Extras$List$isNotEmpty(
			A2(
				$elm$core$List$filter,
				filter,
				$elm$core$List$concat(chains)));
	});
var $author$project$Services$BoardState$isCurrentKanaFilter = F2(
	function (model, boardItem) {
		return A2($author$project$Services$BoardItem$isBoardItemCurrentKana, model, boardItem.bF);
	});
var $author$project$Services$BoardState$chainsContainCurrentKana = function (model) {
	return A2(
		$author$project$Services$Chain$chainsContain,
		$author$project$Services$BoardState$isCurrentKanaFilter(model),
		model.bN);
};
var $author$project$Extras$Task$toCommandMessage = function (message) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(message),
		$elm$core$Task$succeed(0));
};
var $author$project$Domain$Types$PlaySoundEffect = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Services$Audio$toPlayAudioMessage = function (audioFile) {
	return $author$project$Domain$Types$SoundMessage(
		A2($author$project$Domain$Types$PlaySoundEffect, audioFile.al, audioFile.cV));
};
var $author$project$Services$Audio$toPlayAudioCommand = function (audioFile) {
	return $author$project$Extras$Task$toCommandMessage(
		$author$project$Services$Audio$toPlayAudioMessage(audioFile));
};
var $author$project$Services$Audio$comboMultiplierToSoundEffectCommand = F3(
	function (hasNonCurrentKana, _v0, comboMultiplier) {
		var settings = _v0.de;
		if (settings.a8 && hasNonCurrentKana) {
			switch (comboMultiplier) {
				case 1:
					return $author$project$Services$Audio$toPlayAudioCommand(
						$author$project$Services$Audio$matchAudioFile(1));
				case 2:
					return $author$project$Services$Audio$toPlayAudioCommand(
						$author$project$Services$Audio$matchAudioFile(2));
				case 3:
					return $author$project$Services$Audio$toPlayAudioCommand(
						$author$project$Services$Audio$matchAudioFile(3));
				case 4:
					return $author$project$Services$Audio$toPlayAudioCommand(
						$author$project$Services$Audio$matchAudioFile(4));
				default:
					return $author$project$Services$Audio$toPlayAudioCommand(
						$author$project$Services$Audio$matchAudioFile(5));
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Services$BoardState$getBoardItemsAnimatingToKanaWord = function (model) {
	return A2(
		$elm$core$List$filter,
		$author$project$Services$BoardState$isCurrentKanaFilter(model),
		$elm$core$List$concat(model.bN));
};
var $author$project$Services$Time$itemsRemovedDuration = 200;
var $author$project$Services$Time$itemsRemovedDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$itemsRemovedDuration, message);
};
var $author$project$Services$Audio$toPlayAudioWithDelayCommand = F2(
	function (delayAmount, audioFile) {
		return A2(
			$author$project$Services$Time$delay,
			delayAmount,
			$author$project$Services$Audio$toPlayAudioMessage(audioFile));
	});
var $author$project$Services$Audio$playCurrentKanaSoundEffectCommand = F2(
	function (chainsContainCurrentKana, _v0) {
		var settings = _v0.de;
		return (settings.a8 && chainsContainCurrentKana) ? A2($author$project$Services$Audio$toPlayAudioWithDelayCommand, 200, $author$project$Services$Audio$currentKanaSoundFile) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Domain$Types$ResetTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$TimerMessage = function (a) {
	return {$: 14, a: a};
};
var $author$project$Services$Time$resetIdleCommand = A2(
	$elm$core$Task$perform,
	function (posixTime) {
		return $author$project$Domain$Types$TimerMessage(
			$author$project$Domain$Types$ResetTime(posixTime));
	},
	$elm$time$Time$now);
var $author$project$Services$Time$scoreProgressDuration = 750;
var $author$project$Services$Time$scoreProgressDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$scoreProgressDuration, message);
};
var $author$project$Services$BoardState$chainCommands = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Services$Audio$playCurrentKanaSoundEffectCommand,
				$author$project$Services$BoardState$chainsContainCurrentKana(model),
				model),
				A3(
				$author$project$Services$Audio$comboMultiplierToSoundEffectCommand,
				A2(
					$author$project$Services$Chain$chainsContain,
					$author$project$Services$BoardState$isNotCurrentKanaFilter(model),
					model.bN),
				model,
				model.bS),
				A2(
				$elm$random$Random$generate,
				$author$project$Domain$Types$RandomMessage(
					$author$project$Domain$Types$BoardRefillSeed(
						$author$project$Services$Time$itemsRemovedDelay(
							$author$project$Domain$Types$BoardMessage(1)))),
				$author$project$Extras$Random$anyInt),
				$author$project$Services$Time$resetIdleCommand,
				$author$project$Services$Time$scoreProgressDelay($author$project$Domain$Types$ScoreProgressAnimationFinished),
				function () {
				if (!$author$project$Services$BoardState$chainsContainCurrentKana(model)) {
					return $elm$core$Platform$Cmd$none;
				} else {
					var _v0 = $author$project$Services$BoardState$getBoardItemsAnimatingToKanaWord(model);
					if (_v0.b) {
						var boardItemType = _v0.a.bF;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$andThen,
								function (kanaString) {
									return $elm$core$Maybe$Just(
										$author$project$Services$Time$boardItemToKanawordDelay(
											$author$project$Domain$Types$KanawordMessage(
												A2(
													$author$project$Domain$Types$BoardItemsFinishedMovingToKanaWord,
													$elm$core$List$length(
														$author$project$Services$BoardState$getBoardItemsAnimatingToKanaWord(model)),
													kanaString))));
								},
								$author$project$Services$BoardItem$boardItemKanaString(boardItemType)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}
			}()
			]));
};
var $author$project$Services$BoardState$refillCommand = function (model) {
	return $author$project$Extras$List$isNotEmpty(model.bN) ? $author$project$Services$BoardState$chainCommands(model) : $author$project$Services$Time$resetIdleCommand;
};
var $author$project$Services$Chain$removeBoardItem = F2(
	function (boardItem, matrix) {
		return A3($author$project$Services$Matrix$set, boardItem.aw, $elm$core$Maybe$Nothing, matrix);
	});
var $author$project$Services$Chain$removeChain = F2(
	function (chain, matrix) {
		return A3($elm$core$List$foldl, $author$project$Services$Chain$removeBoardItem, matrix, chain);
	});
var $author$project$Services$Chain$removeChains = function (model) {
	var boardItems = model.bG;
	var chains = model.bN;
	return _Utils_update(
		model,
		{
			bG: A3($elm$core$List$foldl, $author$project$Services$Chain$removeChain, boardItems, chains),
			bN: _List_Nil
		});
};
var $author$project$Services$Chain$areCoordinatesBelow = F2(
	function (_v0, _v1) {
		var row1 = _v0.a;
		var column1 = _v0.b;
		var row2 = _v1.a;
		var column2 = _v1.b;
		return _Utils_eq(column1, column2) && (_Utils_cmp(row2, row1) > 0);
	});
var $author$project$Services$Chain$isBelow = F2(
	function (itemOne, itemTwo) {
		var _v0 = _Utils_Tuple2(itemOne, itemTwo);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var valueOne = _v0.a.a;
			var valueTwo = _v0.b.a;
			return A2($author$project$Services$Chain$areCoordinatesBelow, valueOne.aw, valueTwo.aw);
		} else {
			return false;
		}
	});
var $author$project$Services$Chain$numberOfItemsBelow = F2(
	function (boardItems, boardItem) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (currentItem) {
					return A2($author$project$Services$Chain$isBelow, boardItem.a, currentItem);
				},
				A2($elm$core$List$map, $elm$core$Tuple$first, boardItems)));
	});
var $author$project$Services$Chain$assignDropInIndex = function (topUps) {
	return A2(
		$elm$core$List$map,
		function (boardItem) {
			return A2(
				$elm$core$Tuple$mapSecond,
				function (_v0) {
					var row = _v0.a;
					var column = _v0.b;
					return _Utils_Tuple2(
						row - A2($author$project$Services$Chain$numberOfItemsBelow, topUps, boardItem),
						column);
				},
				boardItem);
		},
		topUps);
};
var $author$project$Services$Chain$generateRandomBoardItem = F3(
	function (coordinates, kanaToColorLookup, seed) {
		var _v0 = A2($author$project$Services$Board$randomBoardItemNumber, seed, $author$project$Services$Chain$boardItemTypes);
		var id = _v0.a;
		var randomInt = _v0.b;
		var nextSeed = _v0.c;
		return _Utils_Tuple2(
			A4(
				$author$project$Services$Board$parseBoardItemString,
				id,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(randomInt)),
				coordinates,
				kanaToColorLookup),
			nextSeed);
	});
var $author$project$Services$Chain$columnAtIndex = F2(
	function (columnIndex, matrix) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Array$empty,
			A2(
				$elm$core$Array$get,
				columnIndex,
				$author$project$Extras$Array$transposeRowsAndColumns(matrix)));
	});
var $author$project$Services$Chain$firstEmptyTileFromTheTopIndexInternal = F5(
	function (count, rowIndex, columnIndex, hasTileAt, column) {
		if (column.b) {
			var tail = column.b;
			return A2(hasTileAt, rowIndex + 1, columnIndex) ? 0 : (1 + A5($author$project$Services$Chain$firstEmptyTileFromTheTopIndexInternal, count, rowIndex + 1, columnIndex, hasTileAt, tail));
		} else {
			return 0;
		}
	});
var $author$project$Services$Chain$firstEmptyTileFromTheTopIndex = F3(
	function (columnIndex, hasTileAt, boardItems) {
		return A5(
			$author$project$Services$Chain$firstEmptyTileFromTheTopIndexInternal,
			0,
			0,
			columnIndex,
			hasTileAt,
			$elm$core$Array$toList(
				A2($author$project$Services$Chain$columnAtIndex, columnIndex, boardItems)));
	});
var $author$project$Services$Chain$getTopUpRowIndex = F3(
	function (_v0, hasTileAt, boardItems) {
		var row = _v0.a;
		var column = _v0.b;
		return A3($author$project$Services$Chain$firstEmptyTileFromTheTopIndex, column, hasTileAt, boardItems);
	});
var $author$project$Services$Chain$getTopUpBoardItem = F6(
	function (kanaToColorLookup, boardItems, hasTileAt, coordinates, _v0, boardItem) {
		var rowIndex = coordinates.a;
		var columnIndex = coordinates.b;
		var matrix = _v0.a;
		var seed = _v0.b;
		var newBoardItems = _v0.c;
		if (_Utils_eq(boardItem, $elm$core$Maybe$Nothing) && A2(hasTileAt, rowIndex, columnIndex)) {
			var _v1 = A3($author$project$Services$Chain$generateRandomBoardItem, coordinates, kanaToColorLookup, seed);
			var newBoardItem = _v1.a;
			var nextSeed = _v1.b;
			return _Utils_Tuple3(
				A3($author$project$Services$Matrix$set, coordinates, newBoardItem, matrix),
				nextSeed,
				_Utils_ap(
					newBoardItems,
					_List_fromArray(
						[
							_Utils_Tuple2(
							newBoardItem,
							_Utils_Tuple2(
								A3($author$project$Services$Chain$getTopUpRowIndex, coordinates, hasTileAt, boardItems),
								columnIndex))
						])));
		} else {
			return _Utils_Tuple3(matrix, seed, newBoardItems);
		}
	});
var $author$project$Extras$Tuple$third = function (_v0) {
	var c = _v0.c;
	return c;
};
var $author$project$Services$Chain$topUpBoardItems = F4(
	function (kanaToColorLookup, hasTileAt, seed, matrix) {
		var topUps = $author$project$Services$Chain$assignDropInIndex(
			$author$project$Extras$Tuple$third(
				A3(
					$author$project$Services$Matrix$foldLeft,
					A3($author$project$Services$Chain$getTopUpBoardItem, kanaToColorLookup, matrix, hasTileAt),
					_Utils_Tuple3(matrix, seed, _List_Nil),
					matrix)));
		return topUps;
	});
var $author$project$Domain$Types$ImageMatch = 6;
var $author$project$Services$BoardState$transitionToImageMatch = function (model) {
	return (model.bw.cc && (!model.cA)) ? _Utils_update(
		model,
		{by: 6}) : model;
};
var $author$project$Services$BoardState$updateBoardItemsAnimatingToKanaWord = function (model) {
	return _Utils_update(
		model,
		{
			bH: A2(
				$elm$core$List$append,
				model.bH,
				$author$project$Services$BoardState$getBoardItemsAnimatingToKanaWord(model))
		});
};
var $author$project$Services$BoardState$updateChains = function (model) {
	var boardItems = model.bG;
	return _Utils_update(
		model,
		{
			bN: $author$project$Services$Chain$detectAllChains(boardItems)
		});
};
var $author$project$Services$BoardState$incrementComboMultiplier = function (model) {
	return _Utils_update(
		model,
		{bS: model.bS + 1});
};
var $author$project$Services$BoardState$updateComboMultiplier = function (model) {
	return $author$project$Extras$List$isNotEmpty(model.dg) ? $author$project$Services$BoardState$incrementComboMultiplier(model) : model;
};
var $author$project$Services$BoardState$updateExplodedKana = function (model) {
	return _Utils_update(
		model,
		{
			b7: _Utils_ap(
				model.b7,
				$author$project$Services$BoardState$getExplodedKana(model))
		});
};
var $author$project$Services$Score$addToScore = F2(
	function (amountToAdd, score) {
		return _Utils_update(
			score,
			{cf: score.cf + amountToAdd});
	});
var $author$project$Services$Score$oneStarScorePercent = F2(
	function (gameScore, oneStarScore) {
		return (_Utils_cmp(gameScore, oneStarScore) > -1) ? 1 : (gameScore / oneStarScore);
	});
var $author$project$Services$Score$threeStarScorePercent = F3(
	function (gameScore, twoStarScore, threeStarScore) {
		return (_Utils_cmp(gameScore, twoStarScore) < 0) ? 0 : ((_Utils_cmp(gameScore, threeStarScore) > -1) ? 1 : ((gameScore - twoStarScore) / (threeStarScore - twoStarScore)));
	});
var $author$project$Services$Score$twoStarScorePercent = F3(
	function (gameScore, oneStarScore, twoStarScore) {
		return (_Utils_cmp(gameScore, oneStarScore) < 0) ? 0 : ((_Utils_cmp(gameScore, twoStarScore) > -1) ? 1 : ((gameScore - oneStarScore) / (twoStarScore - oneStarScore)));
	});
var $author$project$Services$Score$updateScoreStarProgressPercentages = function (model) {
	var score = model.da;
	return _Utils_update(
		model,
		{
			da: _Utils_update(
				score,
				{
					c_: A2($author$project$Services$Score$oneStarScorePercent, model.da.cf, model.cK.c$),
					dt: model.da.bt ? A3($author$project$Services$Score$threeStarScorePercent, model.da.cf, model.cK.dE, model.cK.du) : 0,
					dD: model.da.br ? A3($author$project$Services$Score$twoStarScorePercent, model.da.cf, model.cK.c$, model.cK.dE) : 0
				})
		});
};
var $author$project$Services$Score$addScore = F2(
	function (amountToAdd, model) {
		return $author$project$Services$Score$updateScoreStarProgressPercentages(
			_Utils_update(
				model,
				{
					da: A2($author$project$Services$Score$addToScore, amountToAdd, model.da)
				}));
	});
var $author$project$Services$Score$baseScore = 60;
var $author$project$Services$Score$fiveInALineScore = 200;
var $author$project$Services$Score$fourInALineScore = 120;
var $author$project$Services$Score$scoreForChain = F2(
	function (chain, comboMultiplier) {
		var _v0 = $elm$core$List$length(chain);
		switch (_v0) {
			case 3:
				return $author$project$Services$Score$baseScore * comboMultiplier;
			case 4:
				return $author$project$Services$Score$fourInALineScore * comboMultiplier;
			case 5:
				return $author$project$Services$Score$fiveInALineScore * comboMultiplier;
			case 6:
				return $author$project$Services$Score$fiveInALineScore * comboMultiplier;
			default:
				return 0;
		}
	});
var $author$project$Services$Score$scoreForChains = F2(
	function (comboMultiplier, chains) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (chain, total) {
					return total + A2($author$project$Services$Score$scoreForChain, chain, comboMultiplier);
				}),
			0,
			chains);
	});
var $author$project$Services$Score$updateScore = function (model) {
	var chains = model.bN;
	var comboMultiplier = model.bS;
	return A2(
		$author$project$Services$Score$addScore,
		A2($author$project$Services$Score$scoreForChains, comboMultiplier, chains),
		model);
};
var $author$project$Services$BoardState$updateBoardState = F2(
	function (message, model) {
		switch (message) {
			case 0:
				return _Utils_Tuple3(
					$author$project$Services$Chain$removeChains(
						$author$project$Services$Score$initScoreAnimations(
							$author$project$Services$BoardState$initExplodedKana(
								$author$project$Services$BoardState$updateBoardItemsAnimatingToKanaWord(
									$author$project$Services$BoardState$initShrinkingItems(
										$author$project$Services$Score$updateScore(
											$author$project$Services$BoardState$updateChains(
												$author$project$Services$BoardState$performSwapOnModel(model)))))))),
					$author$project$Services$BoardState$refillCommand(
						$author$project$Services$BoardState$updateBoardItemsAnimatingToKanaWord(
							$author$project$Services$BoardState$updateChains(
								$author$project$Services$BoardState$performSwapOnModel(model)))),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				var updatedModel = _Utils_update(
					model,
					{
						ca: A2(
							$author$project$Services$Chain$getFillMatrixSwaps,
							$author$project$Services$Tile$hasTileAt(model.cK.dw),
							model.bG),
						dC: A4(
							$author$project$Services$Chain$topUpBoardItems,
							model.cG,
							$author$project$Services$Tile$hasTileAt(model.cK.dw),
							model.c4.c7,
							A2(
								$author$project$Services$Chain$fillMatrixHoles,
								$author$project$Services$Tile$hasTileAt(model.cK.dw),
								model.bG))
					});
				return _Utils_Tuple3(
					updatedModel,
					$author$project$Services$Time$refillBoardDelay(
						$author$project$Domain$Types$BoardMessage(2)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				var updatedModel = $author$project$Services$BoardState$transitionToImageMatch(
					$author$project$Services$BoardState$prepareForNextTurn(
						$author$project$Services$Shuffle$performShuffle(
							$author$project$Services$Score$appendScoreAnimations(
								$author$project$Services$BoardState$updateExplodedKana(
									$author$project$Services$BoardState$updateComboMultiplier(
										$author$project$Services$BoardState$updateBoardItemsAnimatingToKanaWord(
											$author$project$Services$BoardState$initShrinkingItems(
												$author$project$Services$Score$updateScore(
													$author$project$Services$BoardState$updateChains(
														$author$project$Services$BoardState$detectSwaps(
															$author$project$Services$BoardState$refill(
																$author$project$Services$BoardState$clearRefillItems(model)))))))))))));
				return _Utils_Tuple3(
					$author$project$Services$Chain$removeChains(updatedModel),
					$author$project$Services$BoardState$refillCommand(updatedModel),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$BigDesktop = 3;
var $author$project$Domain$Types$Desktop = 2;
var $author$project$Domain$Types$Landscape = 1;
var $author$project$Domain$Types$Tablet = 1;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Services$Dom$classifyDevice = function (window) {
	return {
		bP: function () {
			var shortSide = A2($elm$core$Basics$min, window.bk, window.aE);
			return (shortSide < 768) ? 0 : ((window.aE <= 820) ? 1 : ((window.aE < 1080) ? 2 : 3));
		}(),
		c1: (_Utils_cmp(window.bk, window.aE) < 0) ? 0 : 1
	};
};
var $author$project$Services$Dom$deviceByViewport = function (viewport) {
	return $author$project$Services$Dom$classifyDevice(
		{
			aE: $elm$core$Basics$round(viewport.dJ.aE),
			bk: $elm$core$Basics$round(viewport.dJ.bk)
		});
};
var $author$project$Services$Dom$deviceCssSelectorByDevice = function (device) {
	var _v0 = device.bP;
	switch (_v0) {
		case 0:
			return 'phone';
		case 1:
			return 'tablet';
		case 2:
			return 'desktop';
		default:
			return 'big-desktop';
	}
};
var $author$project$Ports$deviceClassPortToJS = _Platform_outgoingPort('deviceClassPortToJS', $elm$json$Json$Encode$string);
var $author$project$Ports$setDeviceClass = function (deviceClass) {
	return $author$project$Ports$deviceClassPortToJS(deviceClass);
};
var $author$project$Services$Dom$updateTileWidthAndHeightByDevice = function (device) {
	return $author$project$Ports$setDeviceClass(
		$author$project$Services$Dom$deviceCssSelectorByDevice(device));
};
var $author$project$Services$Dom$updateViewportDimensions = F3(
	function (width, height, viewPort) {
		var scene = viewPort.a3;
		var viewport = viewPort.dJ;
		return _Utils_update(
			viewPort,
			{
				a3: _Utils_update(
					scene,
					{aE: height, bk: width}),
				dJ: _Utils_update(
					viewport,
					{aE: height, bk: width})
			});
	});
var $author$project$Services$Dom$updateDomState = F2(
	function (message, model) {
		if (message.$ === 1) {
			var result = message.a;
			if (!result.$) {
				var viewport = result.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							b$: $author$project$Services$Dom$deviceByViewport(viewport),
							dJ: $elm$core$Maybe$Just(viewport)
						}),
					$author$project$Services$Dom$updateTileWidthAndHeightByDevice(
						$author$project$Services$Dom$deviceByViewport(viewport)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dJ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			}
		} else {
			var width = message.a;
			var height = message.b;
			var newViewport = A2(
				$elm$core$Maybe$andThen,
				function (viewportValue) {
					return $elm$core$Maybe$Just(
						A3($author$project$Services$Dom$updateViewportDimensions, width, height, viewportValue));
				},
				model.dJ);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						b$: A2(
							$elm$core$Maybe$withDefault,
							{bP: 0, c1: 0},
							A2(
								$elm$core$Maybe$andThen,
								function (viewport) {
									return $elm$core$Maybe$Just(
										$author$project$Services$Dom$deviceByViewport(viewport));
								},
								newViewport)),
						dJ: newViewport
					}),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$andThen,
						function (viewportValue) {
							return $elm$core$Maybe$Just(
								$author$project$Services$Dom$updateTileWidthAndHeightByDevice(
									$author$project$Services$Dom$deviceByViewport(viewportValue)));
						},
						model.dJ)),
				$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$GenerateHintSeed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Types$HintMessage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Domain$Types$UpdateHint = function (a) {
	return {$: 1, a: a};
};
var $author$project$Extras$Random$listIndex = function (list) {
	return A2(
		$elm$random$Random$int,
		0,
		$elm$core$List$length(list) - 1);
};
var $author$project$Services$Hint$updateHintState = F2(
	function (message, model) {
		var swapState = model.ds;
		switch (message.$) {
			case 2:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$random$Random$generate,
						function (integer) {
							return $author$project$Domain$Types$HintMessage(
								$author$project$Domain$Types$GenerateHintSeed(integer));
						},
						$author$project$Extras$Random$listIndex(model.ds.c3)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 0:
				var randomInteger = message.a;
				return _Utils_Tuple3(
					$author$project$Services$Time$refreshIdleTime(model),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							$author$project$Domain$Types$HintMessage(
								$author$project$Domain$Types$UpdateHint(
									A2($author$project$Extras$List$elementAt, randomInteger, model.ds.c3)))),
						$elm$core$Task$succeed(
							A2($author$project$Extras$List$elementAt, randomInteger, model.ds.c3))),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				var possibleSwap = message.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ds: _Utils_update(
								swapState,
								{co: possibleSwap})
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$KanaMatching = 5;
var $author$project$Domain$Types$LevelCompleted = 7;
var $author$project$Services$Modal$dropDownLevelCompleteNotification = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{cL: 0})
		});
};
var $author$project$Services$ImageMatch$findNextKanaWord = F2(
	function (currentKanaWord, kanawords) {
		var _v0 = _Utils_Tuple2(kanawords, currentKanaWord);
		if ((((_v0.a.b && _v0.a.b.b) && _v0.a.b.b.b) && _v0.a.b.b.b.b) && (!_v0.a.b.b.b.b.b)) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var first = _v1.a;
				var _v2 = _v1.b;
				var _v3 = _v2.b;
				var _v4 = _v3.b;
				var _v5 = _v0.b;
				return $elm$core$Maybe$Just(first);
			} else {
				var _v6 = _v0.a;
				var first = _v6.a;
				var _v7 = _v6.b;
				var second = _v7.a;
				var _v8 = _v7.b;
				var third = _v8.a;
				var _v9 = _v8.b;
				var fourth = _v9.a;
				var word = _v0.b.a;
				return _Utils_eq(word, first) ? $elm$core$Maybe$Just(second) : (_Utils_eq(word, second) ? $elm$core$Maybe$Just(third) : (_Utils_eq(word, third) ? $elm$core$Maybe$Just(fourth) : $elm$core$Maybe$Nothing));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Services$Matrix$coordinatesMap = F2(
	function (_function, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			F2(
				function (rowIndex, row) {
					return A2(
						$elm$core$Array$indexedMap,
						F2(
							function (columnIndex, value) {
								return A2(
									_function,
									_Utils_Tuple2(rowIndex, columnIndex),
									value);
							}),
						row);
				}),
			matrix);
	});
var $author$project$Services$Board$allShapes = $elm$core$Array$fromList(
	A2($elm$core$List$range, 0, 4));
var $author$project$Extras$Array$filterOutFunction = F3(
	function (_function, item, newArray) {
		return _function(item) ? newArray : A2($elm$core$Array$push, item, newArray);
	});
var $author$project$Extras$Array$filterOut = F2(
	function (_function, array) {
		return A3(
			$elm$core$Array$foldl,
			$author$project$Extras$Array$filterOutFunction(_function),
			$elm$core$Array$empty,
			array);
	});
var $author$project$Services$Board$filterOutFunction = F3(
	function (areTwoTheSame, compareToItem, arrayItem) {
		return areTwoTheSame && _Utils_eq(arrayItem, compareToItem);
	});
var $author$project$Services$Board$valueAtCoordinates = F2(
	function (_v0, boardItems) {
		var row = _v0.a;
		var column = _v0.b;
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Array$get(column),
			A2($elm$core$Array$get, row, boardItems));
	});
var $author$project$Services$Board$getValidNumberArray = F3(
	function (matrix, currentRow, allBoardItems) {
		var currentRowNumber = $elm$core$Array$length(matrix);
		var currentColumnNumber = $elm$core$Array$length(currentRow);
		var leftItem = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$author$project$Extras$Maybe$flatten(
				A2(
					$elm$core$Maybe$andThen,
					function (_v3) {
						var maybeInt = _v3.b;
						return $elm$core$Maybe$Just(maybeInt);
					},
					A2($elm$core$Array$get, currentColumnNumber - 1, currentRow))));
		var leftLeftItem = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$author$project$Extras$Maybe$flatten(
				A2(
					$elm$core$Maybe$andThen,
					function (_v2) {
						var maybeInt = _v2.b;
						return $elm$core$Maybe$Just(maybeInt);
					},
					A2($elm$core$Array$get, currentColumnNumber - 2, currentRow))));
		var leftTwoAreTheSame = (leftItem >= 0) && ((leftLeftItem >= 0) && _Utils_eq(leftItem, leftLeftItem));
		var aboveItem = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$author$project$Extras$Maybe$flatten(
				A2(
					$elm$core$Maybe$andThen,
					function (_v1) {
						var maybeInt = _v1.b;
						return $elm$core$Maybe$Just(maybeInt);
					},
					A2(
						$author$project$Services$Board$valueAtCoordinates,
						_Utils_Tuple2(currentRowNumber - 1, currentColumnNumber),
						matrix))));
		var aboveAboveItem = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$author$project$Extras$Maybe$flatten(
				A2(
					$elm$core$Maybe$andThen,
					function (_v0) {
						var maybeInt = _v0.b;
						return $elm$core$Maybe$Just(maybeInt);
					},
					A2(
						$author$project$Services$Board$valueAtCoordinates,
						_Utils_Tuple2(currentRowNumber - 2, currentColumnNumber),
						matrix))));
		var aboveTwoAreTheSame = (aboveItem >= 0) && ((aboveAboveItem >= 0) && _Utils_eq(aboveItem, aboveAboveItem));
		return A2(
			$author$project$Extras$Array$filterOut,
			A2($author$project$Services$Board$filterOutFunction, aboveTwoAreTheSame, aboveItem),
			A2(
				$author$project$Extras$Array$filterOut,
				A2($author$project$Services$Board$filterOutFunction, leftTwoAreTheSame, leftItem),
				allBoardItems));
	});
var $author$project$Services$Board$randomBoardRow = F4(
	function (seed, numberOfColumns, matrix, array) {
		var _v0 = A2(
			$author$project$Services$Board$randomBoardItemNumber,
			seed,
			A3($author$project$Services$Board$getValidNumberArray, matrix, array, $author$project$Services$Board$allShapes));
		var id = _v0.a;
		var randomInteger = _v0.b;
		var nextSeed = _v0.c;
		return (_Utils_cmp(
			$elm$core$Array$length(array),
			numberOfColumns) < 0) ? A4(
			$author$project$Services$Board$randomBoardRow,
			nextSeed,
			numberOfColumns,
			matrix,
			A2(
				$elm$core$Array$push,
				_Utils_Tuple2(
					id,
					$elm$core$Maybe$Just(randomInteger)),
				array)) : _Utils_Tuple2(array, nextSeed);
	});
var $author$project$Services$Board$randomBoardInternal = F5(
	function (seed, numberOfRows, numberOfColumns, hasTileAt, matrix) {
		if (_Utils_cmp(
			$elm$core$Array$length(matrix),
			numberOfRows) < 0) {
			var _v0 = A4($author$project$Services$Board$randomBoardRow, seed, numberOfColumns, matrix, $elm$core$Array$empty);
			var next = _v0.a;
			var nextSeed = _v0.b;
			return A5(
				$author$project$Services$Board$randomBoardInternal,
				nextSeed,
				numberOfRows,
				numberOfColumns,
				hasTileAt,
				A2($elm$core$Array$push, next, matrix));
		} else {
			return matrix;
		}
	});
var $author$project$Services$Board$randomBoard = F5(
	function (seed, numberOfRows, numberOfColumns, hasTileAt, kanaToColorLookup) {
		return A2(
			$author$project$Services$Matrix$coordinatesMap,
			F2(
				function (coordinates, _v0) {
					var id = _v0.a;
					var maybeInt = _v0.b;
					return hasTileAt(coordinates) ? A2(
						$elm$core$Maybe$andThen,
						function (intValue) {
							return A4(
								$author$project$Services$Board$parseBoardItemString,
								id,
								$elm$core$Maybe$Just(
									$elm$core$String$fromInt(intValue)),
								coordinates,
								kanaToColorLookup);
						},
						maybeInt) : $elm$core$Maybe$Nothing;
				}),
			A5($author$project$Services$Board$randomBoardInternal, seed, numberOfRows, numberOfColumns, hasTileAt, $elm$core$Array$empty));
	});
var $author$project$Services$ImageMatch$advanceToNextKanaWord = function (model) {
	var level = model.cK;
	var swapState = model.ds;
	var nextKanaword = A2($author$project$Services$ImageMatch$findNextKanaWord, model.bY, level.cI);
	if (!nextKanaword.$) {
		var nextWord = nextKanaword.a;
		var _v1 = nextWord.cw;
		if (!_v1.$) {
			var initialBoardItems = _v1.a;
			return _Utils_update(
				model,
				{
					by: 5,
					bG: initialBoardItems,
					bY: nextKanaword,
					cG: nextWord.cG,
					ds: _Utils_update(
						swapState,
						{
							c3: A2(
								$author$project$Services$Swap$detectAllSwaps,
								$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
								initialBoardItems)
						})
				});
		} else {
			var newRandomBoard = A5(
				$author$project$Services$Board$randomBoard,
				model.c4.c7,
				10,
				10,
				$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
				nextWord.cG);
			return _Utils_update(
				model,
				{
					by: 5,
					bG: newRandomBoard,
					bY: nextKanaword,
					cG: nextWord.cG,
					ds: _Utils_update(
						swapState,
						{
							c3: A2(
								$author$project$Services$Swap$detectAllSwaps,
								$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
								newRandomBoard)
						})
				});
		}
	} else {
		return $author$project$Services$Modal$dropDownLevelCompleteNotification(
			_Utils_update(
				model,
				{by: 7}));
	}
};
var $author$project$Services$Audio$correctAnswerCommand = F2(
	function (_v0, isCorrectAnswer) {
		var settings = _v0.de;
		return (settings.a8 && isCorrectAnswer) ? $author$project$Services$Audio$toPlayAudioCommand($author$project$Services$Audio$correctAnswer) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Services$Audio$playVictorySoundEffectCommand = function (_v0) {
	var settings = _v0.de;
	var imageMatchState = _v0.ct;
	var level = _v0.cK;
	return (settings.a8 && _Utils_eq(
		imageMatchState.bT,
		$elm$core$List$length(level.cI))) ? $author$project$Services$Audio$toPlayAudioCommand($author$project$Services$Audio$victoryAudioFile) : $elm$core$Platform$Cmd$none;
};
var $author$project$Services$ImageMatch$resetForNextWord = function (imageMatchState) {
	return _Utils_update(
		imageMatchState,
		{dc: $elm$core$Maybe$Nothing, dM: _List_Nil});
};
var $author$project$Services$ImageMatch$resetImageMatchForNextWord = function (model) {
	return _Utils_update(
		model,
		{
			bx: _List_Nil,
			bH: _List_Nil,
			b7: _List_Nil,
			ct: $author$project$Services$ImageMatch$resetForNextWord(model.ct)
		});
};
var $author$project$Services$ImageMatch$selectedImageScore = F3(
	function (imageID, correctImageID, imageMatchState) {
		var _v0 = _Utils_Tuple2(
			_Utils_eq(
				imageID,
				$elm$core$Maybe$Just(correctImageID)),
			$elm$core$List$length(imageMatchState.dM));
		if (_v0.a) {
			if (!_v0.b) {
				return 2000;
			} else {
				return 500;
			}
		} else {
			return 0;
		}
	});
var $author$project$Services$Random$stepSeed = function (seed) {
	return A2($elm$random$Random$step, $author$project$Extras$Random$anyInt, seed).b;
};
var $author$project$Services$Random$stepRandomSeed = F2(
	function (message, model) {
		var randomSeeds = model.c4;
		switch (message.$) {
			case 0:
				return _Utils_update(
					model,
					{
						c4: _Utils_update(
							randomSeeds,
							{
								cJ: $author$project$Services$Random$stepSeed(randomSeeds.cJ)
							})
					});
			case 1:
				return _Utils_update(
					model,
					{
						c4: _Utils_update(
							randomSeeds,
							{
								c7: $author$project$Services$Random$stepSeed(randomSeeds.c7)
							})
					});
			case 2:
				return _Utils_update(
					model,
					{
						c4: _Utils_update(
							randomSeeds,
							{
								a5: $author$project$Services$Random$stepSeed(randomSeeds.a5)
							})
					});
			default:
				return _Utils_update(
					model,
					{
						c4: _Utils_update(
							randomSeeds,
							{
								cs: $author$project$Services$Random$stepSeed(randomSeeds.cs)
							})
					});
		}
	});
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$a = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	1,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.33,27.81 C 40.52,33.93 66.51,29.66 70.93,27.62', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 57.6,16.78 C 54.28,19.33 40.62,61.41 48.47,72.26', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 66.65,42.26 C 66.65,48.37 47.98,88.06 31.81,80.99 17.23,74.61 26.31,47.91 50.01,46.92 71.33,47.76 83.35,66.05 69.83,83.94', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[39, 58, 162]),
	1,
	'a',
	'あ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$a = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	1,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21,22 L 79,22 C 79,22 72.81,35.81 59.67,46.55', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 48.84,35.81 C 48.84,35.81 51.16,70.33 30.28,78', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[90, 49]),
	1,
	'a',
	'ア',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ba = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	61,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.13,23.16 C 26.12,31.04 9.34,80.92 18.65,85.48 23.8,87.99 26.7,75.05 30.07,72.53', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.85,36.2 C 53.99,38.06 72.35,33.17 76.77,33.41', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 64.91,21.78 C 65.53,37.64 75.69,84.82 56.54,83.39 47.24,82.69 40.94,79.76 41.9,72.69 43.71,59.34 65.34,67.55 76.15,77.08', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,16 C 75.31,16 77.98,16 80.64,19 83.31,22 83.31,25 83.31,25',
			$elm$core$Maybe$Just('M 73.13,15.06 C 72.83,15.35 72.99,15.53 74.27,16.3 76.68,17.76 79.7,21.22 81.95,25.13 82.8,26.59 83.52,27.16 84.31,26.96 85.95,26.56 85.48,21.6 83.57,19.32 82.69,18.26 79.52,16.67 76.37,15.7 73.69,14.89 73.37,14.82 73.13,15.06 Z M 73.13,15.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,10 C 80.31,10 82.98,10 85.64,13 88.31,16 88.31,19 88.31,19',
			$elm$core$Maybe$Just('M 78.13,9.06 C 77.83,9.35 77.99,9.53 79.27,10.3 81.68,11.76 84.7,15.22 86.95,19.13 87.8,20.59 88.52,21.16 89.31,20.96 90.95,20.56 90.48,15.6 88.57,13.32 87.69,12.26 84.52,10.67 81.37,9.7 78.69,8.89 78.37,8.82 78.13,9.06 Z M 78.13,9.06'),
			5)
		]),
	_List_fromArray(
		[83, 32, 130, 14, 14]),
	1,
	'ba',
	'ば',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ba = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	61,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.71,28.52 C 36.71,28.52 34.43,55.81 20,74', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 59.49,27 C 59.49,27 74.68,46.71 80,74', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53',
			$elm$core$Maybe$Just('M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59'),
			5),
			_Utils_Tuple3(
			'M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53',
			$elm$core$Maybe$Just('M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59'),
			5)
		]),
	_List_fromArray(
		[50, 53, 14, 14]),
	1,
	'ba',
	'バ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$be = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	64,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,60.06 C 25.32,54.85 30.91,43.44 34.64,38.78 41.18,44.42 62.75,56.65 80.86,63.16', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 65.31,24 C 65.31,24 67.98,24 70.64,27 73.31,30 73.31,33 73.31,33',
			$elm$core$Maybe$Just('M 63.13,23.06 C 62.83,23.35 62.99,23.53 64.27,24.3 66.68,25.76 69.7,29.22 71.95,33.13 72.8,34.59 73.52,35.16 74.31,34.96 75.95,34.56 75.48,29.6 73.57,27.32 72.69,26.26 69.52,24.67 66.37,23.7 63.69,22.89 63.37,22.82 63.13,23.06 Z M 63.13,23.06'),
			5),
			_Utils_Tuple3(
			'M 70.31,18 C 70.31,18 72.98,18 75.64,21 78.31,24 78.31,27 78.31,27',
			$elm$core$Maybe$Just('M 68.13,17.06 C 67.83,17.35 67.99,17.53 69.27,18.3 71.68,19.76 74.7,23.22 76.95,27.13 77.8,28.59 78.52,29.16 79.31,28.96 80.95,28.56 80.48,23.6 78.57,21.32 77.69,20.26 74.52,18.67 71.37,17.7 68.69,16.89 68.37,16.82 68.13,17.06 Z M 68.13,17.06'),
			5)
		]),
	_List_fromArray(
		[81, 14, 14]),
	1,
	'be',
	'べ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$be = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	64,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17,55.49 C 17,55.49 35.46,31 40.27,31 45.09,31 82,71 82,71', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 62.31,23.79 C 62.31,23.79 64.97,23.79 67.64,26.79 70.31,29.79 70.31,32.79 70.31,32.79',
			$elm$core$Maybe$Just('M 60.12,22.86 C 59.83,23.14 59.99,23.32 61.27,24.09 63.68,25.55 66.69,29.02 68.94,32.92 69.8,34.38 70.52,34.95 71.3,34.76 72.95,34.36 72.47,29.39 70.56,27.12 69.68,26.06 66.51,24.47 63.36,23.5 60.68,22.68 60.37,22.61 60.12,22.86 Z M 60.12,22.86'),
			5),
			_Utils_Tuple3(
			'M 67.31,17.79 C 67.31,17.79 69.97,17.79 72.64,20.79 75.31,23.79 75.31,26.79 75.31,26.79',
			$elm$core$Maybe$Just('M 65.12,16.86 C 64.83,17.14 64.99,17.32 66.27,18.09 68.68,19.55 71.69,23.02 73.94,26.92 74.8,28.38 75.52,28.95 76.3,28.76 77.95,28.36 77.47,23.39 75.56,21.12 74.68,20.06 71.51,18.47 68.36,17.5 65.68,16.68 65.37,16.61 65.12,16.86 Z M 65.12,16.86'),
			5)
		]),
	_List_fromArray(
		[92, 14, 14]),
	1,
	'be',
	'ベ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$bi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	62,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30',
			$elm$core$Maybe$Just('M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24',
			$elm$core$Maybe$Just('M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06'),
			5)
		]),
	_List_fromArray(
		[168, 14, 14]),
	1,
	'bi',
	'び',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$bi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	62,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53',
			$elm$core$Maybe$Just('M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59'),
			5),
			_Utils_Tuple3(
			'M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53',
			$elm$core$Maybe$Just('M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59'),
			5)
		]),
	_List_fromArray(
		[47, 110, 14, 14]),
	1,
	'bi',
	'ビ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$bo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	65,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23.68,27.78 C 18.01,35.26 15.15,80.9 21.03,81.29 24.7,81.54 29.19,67.25 29.19,67.25', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 49.48,29.62 C 56.47,28.12 72.83,29.46 76.82,30.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 48.95,48.19 C 56,52.38 73.17,49.27 77.31,47.5', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 62.91,30.6 C 65.68,56.03 74.11,88.55 49.19,82.27 39.34,79.79 43.01,63.22 52.13,64.64 65.86,66.78 72.9,69.49 77.8,77.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 78.31,15 C 78.31,15 80.98,15 83.64,18 86.31,21 86.31,24 86.31,24',
			$elm$core$Maybe$Just('M 76.13,14.06 C 75.83,14.35 75.99,14.53 77.27,15.3 79.68,16.76 82.7,20.22 84.95,24.13 85.8,25.59 86.52,26.16 87.31,25.96 88.95,25.56 88.48,20.6 86.57,18.32 85.69,17.26 82.52,15.67 79.37,14.7 76.69,13.89 76.37,13.82 76.13,14.06 Z M 76.13,14.06'),
			5),
			_Utils_Tuple3(
			'M 83.31,9 C 83.31,9 85.98,9 88.64,12 91.31,15 91.31,18 91.31,18',
			$elm$core$Maybe$Just('M 81.13,8.06 C 80.83,8.35 80.99,8.53 82.27,9.3 84.68,10.76 87.7,14.22 89.95,18.13 90.8,19.59 91.52,20.16 92.31,19.96 93.95,19.56 93.48,14.6 91.57,12.32 90.69,11.26 87.52,9.67 84.37,8.7 81.69,7.89 81.37,7.82 81.13,8.06 Z M 81.13,8.06'),
			5)
		]),
	_List_fromArray(
		[72, 28, 29, 120, 14, 14]),
	1,
	'bo',
	'ぼ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$bo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	65,
	_List_fromArray(
		[
			_Utils_Tuple3('M 24.09,35.78 L 76.64,35.78', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50,21 L 50,76.32 C 50,76.32 49.64,78.79 46.35,80.11 43.07,81.44 38.32,78.6 38.32,78.6', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.95,52.07 C 33.95,52.07 32.49,61.17 23,72.53', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 65.32,52.07 C 65.32,52.07 68.97,63.44 77,72.53', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 74.66,18.34 C 74.66,18.34 77.33,18.34 79.99,21.34 82.66,24.34 82.66,27.34 82.66,27.34',
			$elm$core$Maybe$Just('M 72.48,17.4 C 72.18,17.69 72.34,17.86 73.62,18.64 76.03,20.09 79.05,23.56 81.3,27.47 82.15,28.92 82.87,29.5 83.66,29.3 85.3,28.9 84.83,23.93 82.92,21.66 82.04,20.6 78.87,19.01 75.72,18.04 73.04,17.22 72.72,17.16 72.48,17.4 Z M 72.48,17.4'),
			5),
			_Utils_Tuple3(
			'M 79.66,12.34 C 79.66,12.34 82.33,12.34 84.99,15.34 87.66,18.34 87.66,21.34 87.66,21.34',
			$elm$core$Maybe$Just('M 77.48,11.4 C 77.18,11.69 77.34,11.86 78.62,12.64 81.03,14.09 84.05,17.56 86.3,21.47 87.15,22.92 87.87,23.5 88.66,23.3 90.3,22.9 89.83,17.93 87.92,15.66 87.04,14.6 83.87,13.01 80.72,12.04 78.04,11.22 77.72,11.16 77.48,11.4 Z M 77.48,11.4'),
			5)
		]),
	_List_fromArray(
		[53, 70, 24, 24, 14, 14]),
	1,
	'bo',
	'ボ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$bu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	63,
	_List_fromArray(
		[
			_Utils_Tuple3('M 44.09,19.78 C 45.89,23.85 48.42,26.98 50.73,28.5 L 46.37,30.78', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 46.58,45.21 C 58.43,50.96 57.51,79.75 47.2,80.88 41.54,81.51 38.7,74.66 38.7,74.66', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.4,49.39 C 29.36,54.79 25.55,64.17 18.78,68.02', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 70.99,45.55 C 76.87,54.76 82.64,67.33 80.49,69.2 77.39,71.9 72.78,65.61 71.47,64.91', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 69.31,18 C 69.31,18 71.98,18 74.64,21 77.31,24 77.31,27 77.31,27',
			$elm$core$Maybe$Just('M 67.13,17.06 C 66.83,17.35 66.99,17.53 68.27,18.3 70.68,19.76 73.7,23.22 75.95,27.13 76.8,28.59 77.52,29.16 78.31,28.96 79.95,28.56 79.48,23.6 77.57,21.32 76.69,20.26 73.52,18.67 70.37,17.7 67.69,16.89 67.37,16.82 67.13,17.06 Z M 67.13,17.06'),
			5),
			_Utils_Tuple3(
			'M 74.31,12 C 74.31,12 76.98,12 79.64,15 82.31,18 82.31,21 82.31,21',
			$elm$core$Maybe$Just('M 72.13,11.06 C 71.83,11.35 71.99,11.53 73.27,12.3 75.68,13.76 78.7,17.22 80.95,21.13 81.8,22.59 82.52,23.16 83.31,22.96 84.95,22.56 84.48,17.6 82.57,15.32 81.69,14.26 78.52,12.67 75.37,11.7 72.69,10.89 72.37,10.82 72.13,11.06 Z M 72.13,11.06'),
			5)
		]),
	_List_fromArray(
		[16, 53, 23, 37, 14, 14]),
	1,
	'bu',
	'ぶ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$bu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	63,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23,32 L 77,32 C 77,32 73.58,68.28 33.65,87', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 77.66,15.44 C 77.66,15.44 80.33,15.44 83,18.44 85.66,21.44 85.66,24.44 85.66,24.44',
			$elm$core$Maybe$Just('M 75.48,14.5 C 75.19,14.79 75.35,14.96 76.63,15.74 79.04,17.19 82.05,20.66 84.3,24.57 85.16,26.02 85.88,26.6 86.66,26.4 88.31,26 87.83,21.03 85.92,18.76 85.04,17.7 81.87,16.11 78.72,15.14 76.04,14.32 75.73,14.26 75.48,14.5 Z M 75.48,14.5'),
			5),
			_Utils_Tuple3(
			'M 82.66,9.44 C 82.66,9.44 85.33,9.44 88,12.44 90.66,15.44 90.66,18.44 90.66,18.44',
			$elm$core$Maybe$Just('M 80.48,8.5 C 80.19,8.79 80.35,8.96 81.63,9.74 84.04,11.19 87.05,14.66 89.3,18.57 90.16,20.02 90.88,20.6 91.66,20.4 93.31,20 92.83,15.03 90.92,12.76 90.04,11.7 86.87,10.11 83.72,9.14 81.04,8.32 80.73,8.26 80.48,8.5 Z M 80.48,8.5'),
			5)
		]),
	_List_fromArray(
		[127, 14, 14]),
	1,
	'bu',
	'ブ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$bya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	98,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30',
			$elm$core$Maybe$Just('M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24',
			$elm$core$Maybe$Just('M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06'),
			5),
			_Utils_Tuple3('M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 14, 14, 56, 17, 40]),
	1,
	'bya',
	'びゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$bya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	98,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.31,17.7 C 82.31,17.7 84.97,17.7 87.64,20.7 90.31,23.7 90.31,26.7 90.31,26.7',
			$elm$core$Maybe$Just('M 80.12,16.76 C 79.83,17.05 79.99,17.22 81.27,17.99 83.68,19.45 86.69,22.92 88.94,26.83 89.8,28.28 90.52,28.86 91.3,28.66 92.95,28.26 92.47,23.29 90.56,21.02 89.68,19.96 86.51,18.37 83.36,17.4 80.68,16.58 80.37,16.52 80.12,16.76 Z M 80.12,16.76'),
			5),
			_Utils_Tuple3(
			'M 87.31,11.7 C 87.31,11.7 89.97,11.7 92.64,14.7 95.31,17.7 95.31,20.7 95.31,20.7',
			$elm$core$Maybe$Just('M 85.12,10.76 C 84.83,11.05 84.99,11.22 86.27,11.99 88.68,13.45 91.69,16.92 93.94,20.83 94.8,22.28 95.52,22.86 96.3,22.66 97.95,22.26 97.47,17.29 95.56,15.02 94.68,13.96 91.51,12.37 88.36,11.4 85.68,10.58 85.37,10.52 85.12,10.76 Z M 85.12,10.76'),
			5),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 14, 14, 55, 39]),
	1,
	'bya',
	'ビャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$byo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	100,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30',
			$elm$core$Maybe$Just('M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24',
			$elm$core$Maybe$Just('M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06'),
			5),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 14, 14, 13, 113]),
	1,
	'byo',
	'びょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$byo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	100,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53',
			$elm$core$Maybe$Just('M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59'),
			5),
			_Utils_Tuple3(
			'M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53',
			$elm$core$Maybe$Just('M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59'),
			5),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 14, 14, 72, 32, 34]),
	1,
	'byo',
	'ビョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$byu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	99,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30',
			$elm$core$Maybe$Just('M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24',
			$elm$core$Maybe$Just('M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06'),
			5),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 14, 14, 107, 47]),
	1,
	'byu',
	'びゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$byu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	99,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 71.47,20.53 C 71.47,20.53 74.14,20.53 76.8,23.53 79.47,26.53 79.47,29.53 79.47,29.53',
			$elm$core$Maybe$Just('M 69.29,19.59 C 68.99,19.88 69.15,20.05 70.43,20.82 72.84,22.28 75.86,25.75 78.11,29.66 78.96,31.11 79.68,31.69 80.47,31.49 82.11,31.09 81.64,26.12 79.73,23.85 78.85,22.79 75.68,21.2 72.53,20.23 69.85,19.41 69.53,19.35 69.29,19.59 Z M 69.29,19.59'),
			5),
			_Utils_Tuple3(
			'M 76.47,14.53 C 76.47,14.53 79.14,14.53 81.8,17.53 84.47,20.53 84.47,23.53 84.47,23.53',
			$elm$core$Maybe$Just('M 74.29,13.59 C 73.99,13.88 74.15,14.05 75.43,14.82 77.84,16.28 80.86,19.75 83.11,23.66 83.96,25.11 84.68,25.69 85.47,25.49 87.11,25.09 86.64,20.12 84.73,17.85 83.85,16.79 80.68,15.2 77.53,14.23 74.85,13.41 74.53,13.35 74.29,13.59 Z M 74.29,13.59'),
			5),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 14, 14, 57, 42]),
	1,
	'byu',
	'ビュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$cha = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	77,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 92.78,56.64 C 98.35,59.29 125.25,44.95 128.64,48.53 134.07,54.28 125.51,61.36 123.61,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 114.24,42.78 C 114.24,47.06 116.78,55.36 118.59,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 97.81,46.03 C 100.39,48.09 113.29,76.39 113.02,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[49, 138, 56, 17, 40]),
	1,
	'cha',
	'ちゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$cha = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	77,
	_List_fromArray(
		[
			_Utils_Tuple3('M 73.61,20 C 52.01,28.33 31.23,28.33 31.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,47.08 L 84,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 55.33,27.5 L 55.33,49.17 C 55.33,49.17 54.5,72.5 37.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 100,57.44 C 100,57.44 134.04,51.92 135.75,51.52 137.45,51.13 130.21,60.59 124.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110.35,43.46 L 118.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[44, 60, 60, 55, 39]),
	1,
	'cha',
	'チャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$chi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	17,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[49, 138]),
	1,
	'chi',
	'ち',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$chi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	17,
	_List_fromArray(
		[
			_Utils_Tuple3('M 68.61,20 C 47.01,28.33 26.23,28.33 26.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,47.08 L 79,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50.33,27.5 L 50.33,49.17 C 50.33,49.17 49.5,72.5 32.05,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[44, 60, 60]),
	1,
	'chi',
	'チ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$cho = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	79,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[49, 138, 13, 113]),
	1,
	'cho',
	'ちょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$cho = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	79,
	_List_fromArray(
		[
			_Utils_Tuple3('M 78.61,20 C 57.01,28.33 36.23,28.33 36.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 30,47.08 L 89,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 60.33,27.5 L 60.33,49.17 C 60.33,49.17 59.5,72.5 42.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[44, 60, 60, 72, 32, 34]),
	1,
	'cho',
	'チョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$chu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	78,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[49, 138, 107, 47]),
	1,
	'chu',
	'ちゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$chu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	78,
	_List_fromArray(
		[
			_Utils_Tuple3('M 78.61,20 C 57.01,28.33 36.23,28.33 36.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 30,47.08 L 89,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 60.33,27.5 L 60.33,49.17 C 60.33,49.17 59.5,72.5 42.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[44, 60, 60, 57, 42]),
	1,
	'chu',
	'チュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$da = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	57,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.53,35.58 C 35.03,40.2 60.03,37.28 65.03,35.82', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 49.28,18.78 C 44.53,26.33 30.53,69.65 23.78,81.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 51.78,53.34 C 55.78,55.53 70.68,48.07 76.53,52.37', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 48.78,75.49 C 54.78,79.87 66.03,83.28 77.03,79.63', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,21 C 75.31,21 77.98,21 80.64,24 83.31,27 83.31,30 83.31,30',
			$elm$core$Maybe$Just('M 73.13,20.06 C 72.83,20.35 72.99,20.53 74.27,21.3 76.68,22.76 79.7,26.22 81.95,30.13 82.8,31.59 83.52,32.16 84.31,31.96 85.95,31.56 85.48,26.6 83.57,24.32 82.69,23.26 79.52,21.67 76.37,20.7 73.69,19.89 73.37,19.82 73.13,20.06 Z M 73.13,20.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,15 C 80.31,15 82.98,15 85.64,18 88.31,21 88.31,24 88.31,24',
			$elm$core$Maybe$Just('M 78.13,14.06 C 77.83,14.35 77.99,14.53 79.27,15.3 81.68,16.76 84.7,20.22 86.95,24.13 87.8,25.59 88.52,26.16 89.31,25.96 90.95,25.56 90.48,20.6 88.57,18.32 87.69,17.26 84.52,15.67 81.37,14.7 78.69,13.89 78.37,13.82 78.13,14.06 Z M 78.13,14.06'),
			5)
		]),
	_List_fromArray(
		[39, 68, 26, 30, 14, 14]),
	1,
	'da',
	'だ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$da = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	57,
	_List_fromArray(
		[
			_Utils_Tuple3('M 48.32,25 C 48.32,25 43.47,42.86 28.21,54.29', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 47.28,33.21 L 75.71,33.21 C 75.71,33.21 73.98,69.29 35.15,85', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 45.9,51.07 C 55.95,55 67.74,65.71 67.74,65.71', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[37, 98, 27, 14, 14]),
	1,
	'da',
	'ダ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$de = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	59,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.78,22.5 C 29.99,28.78 71.55,20.78 78.64,20.78 51.59,34.58 32.17,54.16 56.94,79.04', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 75.31,39 C 75.31,39 77.98,39 80.64,42 83.31,45 83.31,48 83.31,48',
			$elm$core$Maybe$Just('M 73.13,38.06 C 72.83,38.35 72.99,38.53 74.27,39.3 76.68,40.76 79.7,44.22 81.95,48.13 82.8,49.59 83.52,50.16 84.31,49.96 85.95,49.56 85.48,44.6 83.57,42.32 82.69,41.26 79.52,39.67 76.37,38.7 73.69,37.89 73.37,37.82 73.13,38.06 Z M 73.13,38.06'),
			5),
			_Utils_Tuple3(
			'M 80.31,33 C 80.31,33 82.98,33 85.64,36 88.31,39 88.31,42 88.31,42',
			$elm$core$Maybe$Just('M 78.13,32.06 C 77.83,32.35 77.99,32.53 79.27,33.3 81.68,34.76 84.7,38.22 86.95,42.13 87.8,43.59 88.52,44.16 89.31,43.96 90.95,43.56 90.48,38.6 88.57,36.32 87.69,35.26 84.52,33.67 81.37,32.7 78.69,31.89 78.37,31.82 78.13,32.06 Z M 78.13,32.06'),
			5)
		]),
	_List_fromArray(
		[136, 14, 14]),
	1,
	'de',
	'で',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$de = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	59,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.5,26 L 71,26', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,47.09 L 80,47.09', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.5,49.73 C 51.5,49.73 51.12,74.96 31.62,84', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 78.75,16.22 C 78.75,16.22 81.42,16.22 84.08,19.22 86.75,22.22 86.75,25.22 86.75,25.22',
			$elm$core$Maybe$Just('M 76.57,15.28 C 76.27,15.57 76.43,15.74 77.71,16.52 80.12,17.97 83.14,21.44 85.39,25.35 86.24,26.8 86.96,27.38 87.75,27.18 89.39,26.78 88.92,21.82 87.01,19.54 86.13,18.48 82.96,16.89 79.81,15.92 77.13,15.1 76.81,15.04 76.57,15.28 Z M 76.57,15.28'),
			5),
			_Utils_Tuple3(
			'M 83.75,10.22 C 83.75,10.22 86.42,10.22 89.08,13.22 91.75,16.22 91.75,19.22 91.75,19.22',
			$elm$core$Maybe$Just('M 81.57,9.28 C 81.27,9.57 81.43,9.74 82.71,10.52 85.12,11.97 88.14,15.44 90.39,19.35 91.24,20.8 91.96,21.38 92.75,21.18 94.39,20.78 93.92,15.82 92.01,13.54 91.13,12.48 87.96,10.89 84.81,9.92 82.13,9.1 81.81,9.04 81.57,9.28 Z M 81.57,9.28'),
			5)
		]),
	_List_fromArray(
		[44, 60, 42, 14, 14]),
	1,
	'de',
	'デ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$do = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	60,
	_List_fromArray(
		[
			_Utils_Tuple3('M 19.78,22.78 C 21.99,28.66 29.38,44.46 34.32,47.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 64.21,31.56 C 44.35,47.91 18.85,54.41 20.33,71.69 21.5,85.41 42.38,83.86 67.52,83.01', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 70.31,21 C 70.31,21 72.98,21 75.64,24 78.31,27 78.31,30 78.31,30',
			$elm$core$Maybe$Just('M 68.13,20.06 C 67.83,20.35 67.99,20.53 69.27,21.3 71.68,22.76 74.7,26.22 76.95,30.13 77.8,31.59 78.52,32.16 79.31,31.96 80.95,31.56 80.48,26.6 78.57,24.32 77.69,23.26 74.52,21.67 71.37,20.7 68.69,19.89 68.37,19.82 68.13,20.06 Z M 68.13,20.06'),
			5),
			_Utils_Tuple3(
			'M 75.31,15 C 75.31,15 77.98,15 80.64,18 83.31,21 83.31,24 83.31,24',
			$elm$core$Maybe$Just('M 73.13,14.06 C 72.83,14.35 72.99,14.53 74.27,15.3 76.68,16.76 79.7,20.22 81.95,24.13 82.8,25.59 83.52,26.16 84.31,25.96 85.95,25.56 85.48,20.6 83.57,18.32 82.69,17.26 79.52,15.67 76.37,14.7 73.69,13.89 73.37,13.82 73.13,14.06 Z M 73.13,14.06'),
			5)
		]),
	_List_fromArray(
		[31, 116, 14, 14]),
	1,
	'do',
	'ど',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$do = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	60,
	_List_fromArray(
		[
			_Utils_Tuple3('M 40,20 L 40,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 42.57,44.22 C 42.57,44.22 56.13,46.75 73,53.98', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 61.48,26.29 C 61.48,26.29 64.15,26.29 66.81,29.29 69.48,32.29 69.48,35.29 69.48,35.29',
			$elm$core$Maybe$Just('M 59.3,25.35 C 59,25.64 59.16,25.82 60.44,26.59 62.85,28.05 65.87,31.51 68.12,35.42 68.97,36.88 69.69,37.45 70.48,37.25 72.12,36.86 71.65,31.89 69.74,29.62 68.86,28.56 65.69,26.97 62.54,25.99 59.86,25.18 59.54,25.11 59.3,25.35 Z M 59.3,25.35'),
			5),
			_Utils_Tuple3(
			'M 66.48,20.29 C 66.48,20.29 69.15,20.29 71.81,23.29 74.48,26.29 74.48,29.29 74.48,29.29',
			$elm$core$Maybe$Just('M 64.3,19.35 C 64,19.64 64.16,19.82 65.44,20.59 67.85,22.05 70.87,25.51 73.12,29.42 73.97,30.88 74.69,31.45 75.48,31.25 77.12,30.86 76.65,25.89 74.74,23.62 73.86,22.56 70.69,20.97 67.54,19.99 64.86,19.18 64.54,19.11 64.3,19.35 Z M 64.3,19.35'),
			5)
		]),
	_List_fromArray(
		[60, 33, 14, 14]),
	1,
	'do',
	'ド',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$dzi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	53,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26',
			$elm$core$Maybe$Just('M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20',
			$elm$core$Maybe$Just('M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06'),
			5)
		]),
	_List_fromArray(
		[49, 138, 14, 14]),
	1,
	'dzi',
	'ぢ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$e = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	4,
	_List_fromArray(
		[
			_Utils_Tuple3('M 40.22,17.78 C 44.73,22.86 48.48,24.32 53.32,25.52', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 33.11,42.78 C 40.43,40.64 62.82,36.07 62.82,36.07 49.55,54.44 25.58,81.47 25.78,81.25 32.57,73.73 43.59,57.24 49.91,57.24 58.73,57.24 52.21,82.05 57.78,82.03 64.47,82.01 70.86,81.34 74.52,81.76', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[17, 170]),
	1,
	'e',
	'え',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$e = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	4,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.38,26 L 74.62,26', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50,29.89 L 50,71.89', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,75 L 80,75', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[50, 42, 60]),
	1,
	'e',
	'エ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$hu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	28,
	_List_fromArray(
		[
			_Utils_Tuple3('M 44.09,19.78 C 45.89,23.85 48.42,26.98 50.73,28.5 L 46.37,30.78', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 46.58,45.21 C 58.43,50.96 57.51,79.75 47.2,80.88 41.54,81.51 38.7,74.66 38.7,74.66', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.4,49.39 C 29.36,54.79 25.55,64.17 18.78,68.02', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 70.99,45.55 C 76.87,54.76 82.64,67.33 80.49,69.2 77.39,71.9 72.78,65.61 71.47,64.91', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[16, 53, 23, 37]),
	1,
	'hu',
	'ふ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$fu = _Utils_update(
	$author$project$SVGs$AnimatedKanaTiles$Hiragana$hu,
	{cV: 'fu'});
var $author$project$SVGs$AnimatedKanaTiles$Katakana$fu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	28,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23,26 L 77,26 C 77,26 73.58,62.28 33.65,81', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[127]),
	1,
	'fu',
	'フ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ga = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	47,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.08,36.21 C 36.34,38.7 61.54,25.96 61.6,45.03 61.68,69.85 53.93,75.36 47.41,81.82 47.41,81.82 47.25,77.4 41.52,72.88', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 50.89,20 C 43.09,34.87 28.46,62.28 20,74.41', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 74.24,32.14 C 79.65,34.13 84.55,46.06 85.81,50.4', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 79,20 C 79,20 81.67,20 84.33,23 87,26 87,29 87,29',
			$elm$core$Maybe$Just('M 76.82,19.06 C 76.52,19.35 76.68,19.53 77.96,20.3 80.37,21.76 83.39,25.22 85.64,29.13 86.49,30.59 87.21,31.16 88,30.96 89.64,30.56 89.17,25.6 87.26,23.32 86.38,22.26 83.21,20.67 80.06,19.7 77.38,18.89 77.06,18.82 76.82,19.06 Z M 76.82,19.06'),
			5),
			_Utils_Tuple3(
			'M 84,14 C 84,14 86.67,14 89.33,17 92,20 92,23 92,23',
			$elm$core$Maybe$Just('M 81.82,13.06 C 81.52,13.35 81.68,13.53 82.96,14.3 85.37,15.76 88.39,19.22 90.64,23.13 91.49,24.59 92.21,25.16 93,24.96 94.64,24.56 94.17,19.6 92.26,17.32 91.38,16.26 88.21,14.67 85.06,13.7 82.38,12.89 82.06,12.82 81.82,13.06 Z M 81.82,13.06'),
			5)
		]),
	_List_fromArray(
		[101, 64, 24, 14, 14]),
	1,
	'ga',
	'が',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ga = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	47,
	_List_fromArray(
		[
			_Utils_Tuple3('M 19,35.62 L 69.5,35.62 69.5,66.07 C 69.5,66.07 67.54,85.59 51.1,79.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44.84,20 C 44.84,20 47.19,67.63 21.35,79.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[108, 68, 14, 14]),
	1,
	'ga',
	'ガ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ge = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	50,
	_List_fromArray(
		[
			_Utils_Tuple3('M 31.56,20.79 C 24.41,31.08 19.68,71.19 25.19,82.09 25.38,82.47 31.48,75.91 37.17,68.81', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 42.63,38.47 C 49.91,34.84 70.31,31.22 77.29,34.24', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 61.62,17.78 C 64.56,26.43 71.47,61.29 60.97,82.75', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 77.31,16 C 77.31,16 79.98,16 82.64,19 85.31,22 85.31,25 85.31,25',
			$elm$core$Maybe$Just('M 75.13,15.06 C 74.83,15.35 74.99,15.53 76.27,16.3 78.68,17.76 81.7,21.22 83.95,25.13 84.8,26.59 85.52,27.16 86.31,26.96 87.95,26.56 87.48,21.6 85.57,19.32 84.69,18.26 81.52,16.67 78.37,15.7 75.69,14.89 75.37,14.82 75.13,15.06 Z M 75.13,15.06'),
			5),
			_Utils_Tuple3(
			'M 82.31,10 C 82.31,10 84.98,10 87.64,13 90.31,16 90.31,19 90.31,19',
			$elm$core$Maybe$Just('M 80.13,9.06 C 79.83,9.35 79.99,9.53 81.27,10.3 83.68,11.76 86.7,15.22 88.95,19.13 89.8,20.59 90.52,21.16 91.31,20.96 92.95,20.56 92.48,15.6 90.57,13.32 89.69,12.26 86.52,10.67 83.37,9.7 80.69,8.89 80.37,8.82 80.13,9.06 Z M 80.13,9.06'),
			5)
		]),
	_List_fromArray(
		[81, 36, 67, 14, 14]),
	1,
	'ge',
	'げ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ge = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	50,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.2,21 C 39.2,21 35.2,39.37 20,51.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 35.2,35.38 L 80,35.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 58.8,38.97 C 58.8,38.97 57.2,70.12 33.2,80.5', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[37, 46, 52, 14, 14]),
	1,
	'ge',
	'ゲ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$gi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	48,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25',
			$elm$core$Maybe$Just('M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06'),
			5),
			_Utils_Tuple3(
			'M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19',
			$elm$core$Maybe$Just('M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06'),
			5)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 14, 14]),
	1,
	'gi',
	'ぎ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$gi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	48,
	_List_fromArray(
		[
			_Utils_Tuple3('M 16.64,37.84 L 67.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 15,59.73 L 74,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 39.58,20 L 47.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[52, 60, 61, 14, 14]),
	1,
	'gi',
	'ギ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$go = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	51,
	_List_fromArray(
		[
			_Utils_Tuple3('M 32.45,27.06 C 38.11,30.47 56.01,18.26 66.26,24.68 72.94,28.87 64.28,33.19 61.89,36', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.78,66.21 C 34.95,77.97 60.4,79.19 68.58,74.56', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 77.31,16 C 77.31,16 79.98,16 82.64,19 85.31,22 85.31,25 85.31,25',
			$elm$core$Maybe$Just('M 75.13,15.06 C 74.83,15.35 74.99,15.53 76.27,16.3 78.68,17.76 81.7,21.22 83.95,25.13 84.8,26.59 85.52,27.16 86.31,26.96 87.95,26.56 87.48,21.6 85.57,19.32 84.69,18.26 81.52,16.67 78.37,15.7 75.69,14.89 75.37,14.82 75.13,15.06 Z M 75.13,15.06'),
			5),
			_Utils_Tuple3(
			'M 82.31,10 C 82.31,10 84.98,10 87.64,13 90.31,16 90.31,19 90.31,19',
			$elm$core$Maybe$Just('M 80.13,9.06 C 79.83,9.35 79.99,9.53 81.27,10.3 83.68,11.76 86.7,15.22 88.95,19.13 89.8,20.59 90.52,21.16 91.31,20.96 92.95,20.56 92.48,15.6 90.57,13.32 89.69,12.26 86.52,10.67 83.37,9.7 80.69,8.89 80.37,8.82 80.13,9.06 Z M 80.13,9.06'),
			5)
		]),
	_List_fromArray(
		[51, 43, 14, 14]),
	1,
	'go',
	'ご',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$go = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	51,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.73,34 L 70,34 70,84', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 21,80.15 L 70,80.15', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[99, 49, 14, 14]),
	1,
	'go',
	'ゴ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$gu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	49,
	_List_fromArray(
		[
			_Utils_Tuple3('M 53.89,18.78 C 46.37,32.23 25.7,51.06 20.78,52.04 26.98,55.14 48.45,73.99 52.18,83.11', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 67.31,16 C 67.31,16 69.98,16 72.64,19 75.31,22 75.31,25 75.31,25',
			$elm$core$Maybe$Just('M 65.13,15.06 C 64.83,15.35 64.99,15.53 66.27,16.3 68.68,17.76 71.7,21.22 73.95,25.13 74.8,26.59 75.52,27.16 76.31,26.96 77.95,26.56 77.48,21.6 75.57,19.32 74.69,18.26 71.52,16.67 68.37,15.7 65.69,14.89 65.37,14.82 65.13,15.06 Z M 65.13,15.06'),
			5),
			_Utils_Tuple3(
			'M 72.31,10 C 72.31,10 74.98,10 77.64,13 80.31,16 80.31,19 80.31,19',
			$elm$core$Maybe$Just('M 70.13,9.06 C 69.83,9.35 69.99,9.53 71.27,10.3 73.68,11.76 76.7,15.22 78.95,19.13 79.8,20.59 80.52,21.16 81.31,20.96 82.95,20.56 82.48,15.6 80.57,13.32 79.69,12.26 76.52,10.67 73.37,9.7 70.69,8.89 70.37,8.82 70.13,9.06 Z M 70.13,9.06'),
			5)
		]),
	_List_fromArray(
		[93, 14, 14]),
	1,
	'gu',
	'ぐ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$gu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	49,
	_List_fromArray(
		[
			_Utils_Tuple3('M 42.06,20 C 42.06,20 35.44,36.83 20,50', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 39.85,29.51 L 70,29.51 C 70,29.51 68.53,63.17 31.03,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[38, 97, 14, 14]),
	1,
	'gu',
	'グ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$gya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	92,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25',
			$elm$core$Maybe$Just('M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06'),
			5),
			_Utils_Tuple3(
			'M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19',
			$elm$core$Maybe$Just('M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06'),
			5),
			_Utils_Tuple3('M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 14, 14, 56, 17, 40]),
	1,
	'gya',
	'ぎゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$gya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	92,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.64,37.84 L 79.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,59.73 L 86,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.58,20 L 59.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 84.33,15.22 C 84.33,15.22 87,15.22 89.66,18.22 92.33,21.22 92.33,24.22 92.33,24.22',
			$elm$core$Maybe$Just('M 82.14,14.28 C 81.85,14.57 82.01,14.75 83.29,15.52 85.7,16.98 88.72,20.44 90.97,24.35 91.82,25.81 92.54,26.38 93.33,26.18 94.97,25.78 94.5,20.82 92.59,18.54 91.71,17.48 88.54,15.89 85.39,14.92 82.71,14.11 82.39,14.04 82.14,14.28 Z M 82.14,14.28'),
			5),
			_Utils_Tuple3(
			'M 89.33,9.22 C 89.33,9.22 92,9.22 94.66,12.22 97.33,15.22 97.33,18.22 97.33,18.22',
			$elm$core$Maybe$Just('M 87.14,8.28 C 86.85,8.57 87.01,8.75 88.29,9.52 90.7,10.98 93.72,14.44 95.97,18.35 96.82,19.81 97.54,20.38 98.33,20.18 99.97,19.78 99.5,14.82 97.59,12.54 96.71,11.48 93.54,9.89 90.39,8.92 87.71,8.11 87.39,8.04 87.14,8.28 Z M 87.14,8.28'),
			5),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[52, 60, 61, 14, 14, 55, 39]),
	1,
	'gya',
	'ギャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$gyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	94,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25',
			$elm$core$Maybe$Just('M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06'),
			5),
			_Utils_Tuple3(
			'M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19',
			$elm$core$Maybe$Just('M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06'),
			5),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 14, 14, 13, 113]),
	1,
	'gyo',
	'ぎょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$gyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	94,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.64,37.84 L 79.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,59.73 L 86,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.58,20 L 59.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74',
			$elm$core$Maybe$Just('M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81'),
			5),
			_Utils_Tuple3(
			'M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74',
			$elm$core$Maybe$Just('M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81'),
			5),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[52, 60, 61, 14, 14, 72, 32, 34]),
	1,
	'gyo',
	'ギョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$gyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	93,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 73,16 C 73,16 75.67,16 78.33,19 81,22 81,25 81,25',
			$elm$core$Maybe$Just('M 70.82,15.06 C 70.52,15.35 70.68,15.53 71.96,16.3 74.37,17.76 77.39,21.22 79.64,25.13 80.49,26.59 81.21,27.16 82,26.96 83.64,26.56 83.17,21.6 81.26,19.32 80.38,18.26 77.21,16.67 74.06,15.7 71.38,14.89 71.06,14.82 70.82,15.06 Z M 70.82,15.06'),
			5),
			_Utils_Tuple3(
			'M 78,10 C 78,10 80.67,10 83.33,13 86,16 86,19 86,19',
			$elm$core$Maybe$Just('M 75.82,9.06 C 75.52,9.35 75.68,9.53 76.96,10.3 79.37,11.76 82.39,15.22 84.64,19.13 85.49,20.59 86.21,21.16 87,20.96 88.64,20.56 88.17,15.6 86.26,13.32 85.38,12.26 82.21,10.67 79.06,9.7 76.38,8.89 76.06,8.82 75.82,9.06 Z M 75.82,9.06'),
			5),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 14, 14, 107, 47]),
	1,
	'gyu',
	'ぎゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$gyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	93,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.64,37.84 L 79.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,59.73 L 86,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.58,20 L 59.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74',
			$elm$core$Maybe$Just('M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81'),
			5),
			_Utils_Tuple3(
			'M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74',
			$elm$core$Maybe$Just('M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81'),
			5),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[52, 60, 61, 14, 14, 57, 42]),
	1,
	'gyu',
	'ギュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ha = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	26,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.13,19.16 C 30.12,27.04 13.34,76.92 22.65,81.48 27.8,83.99 30.7,71.05 34.07,68.53', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 49.85,32.2 C 57.99,34.06 76.35,29.17 80.77,29.41', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 68.91,17.78 C 69.53,33.64 79.69,80.82 60.54,79.39 51.24,78.69 44.94,75.76 45.9,68.69 47.71,55.34 69.34,63.55 80.15,73.08', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[83, 32, 130]),
	1,
	'ha',
	'は',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ha = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	26,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.71,28.52 C 36.71,28.52 34.43,55.81 20,74', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 59.49,27 C 59.49,27 74.68,46.71 80,74', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[50, 53]),
	1,
	'ha',
	'ハ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$he = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	29,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,60.06 C 25.32,54.85 30.91,43.44 34.64,38.78 41.18,44.42 62.75,56.65 80.86,63.16', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[81]),
	1,
	'he',
	'へ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$he = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	29,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17,55.49 C 17,55.49 35.46,31 40.27,31 45.09,31 82,71 82,71', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[92]),
	1,
	'he',
	'ヘ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$hi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	27,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[168]),
	1,
	'hi',
	'ひ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$hi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	27,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[47, 110]),
	1,
	'hi',
	'ヒ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ho = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	30,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.68,22.78 C 20.01,30.26 17.15,75.9 23.03,76.29 26.7,76.54 31.19,62.25 31.19,62.25', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 51.48,24.62 C 58.47,23.12 74.83,24.46 78.82,25.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 50.95,43.19 C 58,47.38 75.17,44.27 79.31,42.5', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 64.91,25.6 C 67.68,51.03 76.11,83.55 51.19,77.27 41.34,74.79 45.01,58.22 54.13,59.64 67.86,61.78 74.9,64.49 79.8,72.09', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[72, 28, 29, 120]),
	1,
	'ho',
	'ほ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ho = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	30,
	_List_fromArray(
		[
			_Utils_Tuple3('M 24.09,35.78 L 76.64,35.78', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50,21 L 50,76.32 C 50,76.32 49.64,78.79 46.35,80.11 43.07,81.44 38.32,78.6 38.32,78.6', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.95,52.07 C 33.95,52.07 32.49,61.17 23,72.53', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 65.32,52.07 C 65.32,52.07 68.97,63.44 77,72.53', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[53, 70, 24, 24]),
	1,
	'ho',
	'ホ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$hya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	83,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 102,56.64 C 107.57,59.29 134.47,44.95 137.85,48.53 143.28,54.28 134.73,61.36 132.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 123.46,42.78 C 123.46,47.06 125.99,55.36 127.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,46.03 C 109.61,48.09 122.51,76.39 122.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 56, 17, 40]),
	1,
	'hya',
	'ひゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$hya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	83,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 55, 39]),
	1,
	'hya',
	'ヒャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$hyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	85,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 13, 113]),
	1,
	'hyo',
	'ひょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$hyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	85,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 72, 32, 34]),
	1,
	'hyo',
	'ヒョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$hyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	84,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,33.93 C 25.52,32.69 34.52,29.36 41.95,23.78 34.7,35.87 24.01,77.75 45.09,78.05 71.78,78.43 68.67,32.07 68.67,32.07 70.07,35.57 76.31,43.5 80.79,46.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 107, 47]),
	1,
	'hyu',
	'ひゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$hyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	84,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 57, 42]),
	1,
	'hyu',
	'ヒュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$i = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	2,
	_List_fromArray(
		[
			_Utils_Tuple3('M 32.13,24.78 C 21.03,34.79 21.33,73.07 31.1,73.39 36.59,73.58 39.13,67.18 43.22,58.03', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 67.33,26.05 C 78.28,32.31 80.83,68.61 65.99,74.26', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[75, 56]),
	1,
	'i',
	'い',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$i = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	2,
	_List_fromArray(
		[
			_Utils_Tuple3('M 75,20 C 75,20 54.75,40.25 24,55.25', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 54,41.75 L 54,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[63, 39]),
	1,
	'i',
	'イ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ja = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	95,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26',
			$elm$core$Maybe$Just('M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20',
			$elm$core$Maybe$Just('M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06'),
			5),
			_Utils_Tuple3('M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[111, 14, 14, 56, 17, 40]),
	1,
	'ja',
	'じゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ja = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	95,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.29,80 C 38.29,80 72.91,72.21 91,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 84.33,15.22 C 84.33,15.22 87,15.22 89.66,18.22 92.33,21.22 92.33,24.22 92.33,24.22',
			$elm$core$Maybe$Just('M 82.14,14.28 C 81.85,14.57 82.01,14.75 83.29,15.52 85.7,16.98 88.72,20.44 90.97,24.35 91.82,25.81 92.54,26.38 93.33,26.18 94.97,25.78 94.5,20.82 92.59,18.54 91.71,17.48 88.54,15.89 85.39,14.92 82.71,14.11 82.39,14.04 82.14,14.28 Z M 82.14,14.28'),
			5),
			_Utils_Tuple3(
			'M 89.33,9.22 C 89.33,9.22 92,9.22 94.66,12.22 97.33,15.22 97.33,18.22 97.33,18.22',
			$elm$core$Maybe$Just('M 87.14,8.28 C 86.85,8.57 87.01,8.75 88.29,9.52 90.7,10.98 93.72,14.44 95.97,18.35 96.82,19.81 97.54,20.38 98.33,20.18 99.97,19.78 99.5,14.82 97.59,12.54 96.71,11.48 93.54,9.89 90.39,8.92 87.71,8.11 87.39,8.04 87.14,8.28 Z M 87.14,8.28'),
			5),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[20, 20, 70, 14, 14, 55, 39]),
	1,
	'ja',
	'ジャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ja2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	95,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26',
			$elm$core$Maybe$Just('M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20',
			$elm$core$Maybe$Just('M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06'),
			5),
			_Utils_Tuple3('M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[49, 138, 14, 14, 56, 17, 40]),
	1,
	'ja2',
	'ぢゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ja2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	95,
	_List_fromArray(
		[
			_Utils_Tuple3('M 75.61,20 C 54.01,28.33 33.23,28.33 33.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,47.08 L 86,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 57.33,27.5 L 57.33,49.17 C 57.33,49.17 56.5,72.5 39.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 81.46,28.52 C 81.46,28.52 84.12,28.52 86.79,31.52 89.46,34.52 89.46,37.52 89.46,37.52',
			$elm$core$Maybe$Just('M 79.27,27.59 C 78.98,27.87 79.14,28.05 80.42,28.82 82.83,30.28 85.84,33.75 88.09,37.65 88.95,39.11 89.67,39.69 90.46,39.49 92.1,39.09 91.63,34.12 89.71,31.85 88.84,30.79 85.66,29.2 82.51,28.23 79.84,27.41 79.52,27.34 79.27,27.59 Z M 79.27,27.59'),
			5),
			_Utils_Tuple3(
			'M 86.46,22.52 C 86.46,22.52 89.12,22.52 91.79,25.52 94.46,28.52 94.46,31.52 94.46,31.52',
			$elm$core$Maybe$Just('M 84.27,21.59 C 83.98,21.87 84.14,22.05 85.42,22.82 87.83,24.28 90.84,27.75 93.09,31.65 93.95,33.11 94.67,33.69 95.46,33.49 97.1,33.09 96.63,28.12 94.71,25.85 93.84,24.79 90.66,23.2 87.51,22.23 84.84,21.41 84.52,21.34 84.27,21.59 Z M 84.27,21.59'),
			5),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[44, 60, 60, 14, 14, 55, 39]),
	1,
	'ja',
	'ヂャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ji = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	53,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26',
			$elm$core$Maybe$Just('M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20',
			$elm$core$Maybe$Just('M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06'),
			5)
		]),
	_List_fromArray(
		[111, 14, 14]),
	1,
	'ji',
	'じ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ji = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	53,
	_List_fromArray(
		[
			_Utils_Tuple3('M 32.87,20 C 32.87,20 43.09,22.34 50.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,38.7 C 25,38.7 35.23,41.04 43.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 31.29,80 C 31.29,80 65.91,72.21 84,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[20, 20, 70, 14, 14]),
	1,
	'ji',
	'ジ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$jo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	97,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26',
			$elm$core$Maybe$Just('M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20',
			$elm$core$Maybe$Just('M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06'),
			5),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[111, 14, 14, 13, 113]),
	1,
	'jo',
	'じょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$jo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	97,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.29,80 C 38.29,80 72.91,72.21 91,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74',
			$elm$core$Maybe$Just('M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81'),
			5),
			_Utils_Tuple3(
			'M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74',
			$elm$core$Maybe$Just('M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81'),
			5),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[20, 20, 70, 14, 14, 72, 32, 34]),
	1,
	'jo',
	'ジョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$jo2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	97,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26',
			$elm$core$Maybe$Just('M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20',
			$elm$core$Maybe$Just('M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06'),
			5),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[49, 138, 14, 14, 13, 113]),
	1,
	'jo2',
	'ぢょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$jo2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	97,
	_List_fromArray(
		[
			_Utils_Tuple3('M 75.61,20 C 54.01,28.33 33.23,28.33 33.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,47.08 L 86,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 57.33,27.5 L 57.33,49.17 C 57.33,49.17 56.5,72.5 39.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.83,28.71 C 82.83,28.71 85.5,28.71 88.17,31.71 90.83,34.71 90.83,37.71 90.83,37.71',
			$elm$core$Maybe$Just('M 80.65,27.77 C 80.36,28.06 80.51,28.23 81.8,29.01 84.2,30.46 87.22,33.93 89.47,37.84 90.32,39.3 91.04,39.87 91.83,39.67 93.47,39.27 93,34.31 91.09,32.03 90.21,30.97 87.04,29.38 83.89,28.41 81.21,27.59 80.9,27.53 80.65,27.77 Z M 80.65,27.77'),
			5),
			_Utils_Tuple3(
			'M 87.83,22.71 C 87.83,22.71 90.5,22.71 93.17,25.71 95.83,28.71 95.83,31.71 95.83,31.71',
			$elm$core$Maybe$Just('M 85.65,21.77 C 85.36,22.06 85.51,22.23 86.8,23.01 89.2,24.46 92.22,27.93 94.47,31.84 95.32,33.3 96.04,33.87 96.83,33.67 98.47,33.27 98,28.31 96.09,26.03 95.21,24.97 92.04,23.38 88.89,22.41 86.21,21.59 85.9,21.53 85.65,21.77 Z M 85.65,21.77'),
			5),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[44, 60, 60, 14, 14, 72, 32, 34]),
	1,
	'jo',
	'ヂョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ju = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	96,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 57.31,17 C 57.31,17 59.98,17 62.64,20 65.31,23 65.31,26 65.31,26',
			$elm$core$Maybe$Just('M 55.13,16.06 C 54.83,16.35 54.99,16.53 56.27,17.3 58.68,18.76 61.7,22.22 63.95,26.13 64.8,27.59 65.52,28.16 66.31,27.96 67.95,27.56 67.48,22.6 65.57,20.32 64.69,19.26 61.52,17.67 58.37,16.7 55.69,15.89 55.37,15.82 55.13,16.06 Z M 55.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 62.31,11 C 62.31,11 64.98,11 67.64,14 70.31,17 70.31,20 70.31,20',
			$elm$core$Maybe$Just('M 60.13,10.06 C 59.83,10.35 59.99,10.53 61.27,11.3 63.68,12.76 66.7,16.22 68.95,20.13 69.8,21.59 70.52,22.16 71.31,21.96 72.95,21.56 72.48,16.6 70.57,14.32 69.69,13.26 66.52,11.67 63.37,10.7 60.69,9.89 60.37,9.82 60.13,10.06 Z M 60.13,10.06'),
			5),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[111, 14, 14, 107, 47]),
	1,
	'ju',
	'じゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ju = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	96,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.29,80 C 38.29,80 72.91,72.21 91,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.87,14.74 C 82.87,14.74 85.53,14.74 88.2,17.74 90.87,20.74 90.87,23.74 90.87,23.74',
			$elm$core$Maybe$Just('M 80.68,13.81 C 80.39,14.09 80.55,14.27 81.83,15.04 84.24,16.5 87.25,19.97 89.5,23.87 90.36,25.33 91.08,25.9 91.87,25.71 93.51,25.31 93.04,20.34 91.12,18.07 90.25,17.01 87.07,15.42 83.92,14.45 81.25,13.63 80.93,13.56 80.68,13.81 Z M 80.68,13.81'),
			5),
			_Utils_Tuple3(
			'M 87.87,8.74 C 87.87,8.74 90.53,8.74 93.2,11.74 95.87,14.74 95.87,17.74 95.87,17.74',
			$elm$core$Maybe$Just('M 85.68,7.81 C 85.39,8.09 85.55,8.27 86.83,9.04 89.24,10.5 92.25,13.97 94.5,17.87 95.36,19.33 96.08,19.9 96.87,19.71 98.51,19.31 98.04,14.34 96.12,12.07 95.25,11.01 92.07,9.42 88.92,8.45 86.25,7.63 85.93,7.56 85.68,7.81 Z M 85.68,7.81'),
			5),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[20, 20, 70, 14, 14, 57, 42]),
	1,
	'ju',
	'ジュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ju2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	96,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.78,33.07 C 32.55,36.94 69.9,34.52 73.66,31.86', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 54.86,18.78 C 50.35,23.87 30.29,60.42 30.29,60.42 30.29,60.42 58.84,36.63 69.15,53.88 77.95,68.61 58.86,81.16 44.83,81.48', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26',
			$elm$core$Maybe$Just('M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20',
			$elm$core$Maybe$Just('M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06'),
			5),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[49, 138, 14, 14, 107, 47]),
	1,
	'ju2',
	'ぢゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ju2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	96,
	_List_fromArray(
		[
			_Utils_Tuple3('M 75.61,20 C 54.01,28.33 33.23,28.33 33.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,47.08 L 86,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 57.33,27.5 L 57.33,49.17 C 57.33,49.17 56.5,72.5 39.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 82.83,28.71 C 82.83,28.71 85.5,28.71 88.17,31.71 90.83,34.71 90.83,37.71 90.83,37.71',
			$elm$core$Maybe$Just('M 80.65,27.77 C 80.36,28.06 80.51,28.23 81.8,29.01 84.2,30.46 87.22,33.93 89.47,37.84 90.32,39.3 91.04,39.87 91.83,39.67 93.47,39.27 93,34.31 91.09,32.03 90.21,30.97 87.04,29.38 83.89,28.41 81.21,27.59 80.9,27.53 80.65,27.77 Z M 80.65,27.77'),
			5),
			_Utils_Tuple3(
			'M 87.83,22.71 C 87.83,22.71 90.5,22.71 93.17,25.71 95.83,28.71 95.83,31.71 95.83,31.71',
			$elm$core$Maybe$Just('M 85.65,21.77 C 85.36,22.06 85.51,22.23 86.8,23.01 89.2,24.46 92.22,27.93 94.47,31.84 95.32,33.3 96.04,33.87 96.83,33.67 98.47,33.27 98,28.31 96.09,26.03 95.21,24.97 92.04,23.38 88.89,22.41 86.21,21.59 85.9,21.53 85.65,21.77 Z M 85.65,21.77'),
			5),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[44, 60, 60, 14, 14, 57, 42]),
	1,
	'ju',
	'ヂュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ka = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	6,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.08,36.21 C 36.34,38.7 61.54,25.96 61.6,45.03 61.68,69.85 53.93,75.36 47.41,81.82 47.41,81.82 47.25,77.4 41.52,72.88', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 50.89,20 C 43.09,34.87 28.46,62.28 20,74.41', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 74.24,32.14 C 79.65,34.13 84.55,46.06 85.81,50.4', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[101, 64, 24]),
	1,
	'ka',
	'か',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ka = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	6,
	_List_fromArray(
		[
			_Utils_Tuple3('M 24,35.62 L 74.5,35.62 74.5,66.07 C 74.5,66.07 72.54,85.59 56.1,79.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 49.84,20 C 49.84,20 52.19,67.63 26.35,79.35', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[108, 68]),
	1,
	'ka',
	'カ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ke = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	9,
	_List_fromArray(
		[
			_Utils_Tuple3('M 31.56,20.79 C 24.41,31.08 19.68,71.19 25.19,82.09 25.38,82.47 31.48,75.91 37.17,68.81', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 42.63,38.47 C 49.91,34.84 70.31,31.22 77.29,34.24', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 61.62,17.78 C 64.56,26.43 71.47,61.29 60.97,82.75', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[81, 36, 67]),
	1,
	'ke',
	'け',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ke = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	9,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.2,21 C 39.2,21 35.2,39.37 20,51.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 35.2,35.38 L 80,35.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 58.8,38.97 C 58.8,38.97 57.2,70.12 33.2,80.5', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[37, 46, 52]),
	1,
	'ke',
	'ケ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ki = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	7,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[30, 42, 55, 34]),
	1,
	'ki',
	'き',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ki = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	7,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.64,37.84 L 72.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,59.73 L 79,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44.58,20 L 52.78,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[52, 60, 61]),
	1,
	'ki',
	'キ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$kki = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	7,
	_List_fromArray(
		[
			_Utils_Tuple3('M 20,49.17 C 20,49.17 23.38,53.94 25.8,59.19', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 32.57,44.88 C 32.57,44.88 35.95,49.65 38.37,54.89', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 56.5,46.07 C 56.5,46.07 53.12,72.79 29.91,81.37', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 83.94,37.84 L 134.75,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 82.3,59.73 L 141.3,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 106.88,20 L 115.08,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[12, 12, 47, 52, 60, 61]),
	1,
	'kki',
	'ッキ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ko = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	10,
	_List_fromArray(
		[
			_Utils_Tuple3('M 32.45,27.06 C 38.11,30.47 56.01,18.26 66.26,24.68 72.94,28.87 64.28,33.19 61.89,36', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.78,66.21 C 34.95,77.97 60.4,79.19 68.58,74.56', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[51, 43]),
	1,
	'ko',
	'こ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ko = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	10,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.73,25 L 74,25 74,75', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,71.15 L 74,71.15', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[99, 49]),
	1,
	'ko',
	'コ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ku = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	8,
	_List_fromArray(
		[
			_Utils_Tuple3('M 65.89,18.78 C 58.37,32.23 37.7,51.06 32.78,52.04 38.98,55.14 60.45,73.99 64.18,83.11', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[93]),
	1,
	'ku',
	'く',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ku = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	8,
	_List_fromArray(
		[
			_Utils_Tuple3('M 47.06,20 C 47.06,20 40.44,36.83 25,50', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44.85,29.51 L 75,29.51 C 75,29.51 73.53,63.17 36.03,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[38, 97]),
	1,
	'ku',
	'ク',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$kya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	71,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 92.78,56.64 C 98.35,59.29 125.25,44.95 128.64,48.53 134.07,54.28 125.51,61.36 123.61,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 114.24,42.78 C 114.24,47.06 116.78,55.36 118.59,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 97.81,46.03 C 100.39,48.09 113.29,76.39 113.02,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 56, 17, 40]),
	1,
	'kya',
	'きゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$kya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	71,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.64,37.84 L 72.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,59.73 L 79,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44.58,20 L 52.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 100,57.44 C 100,57.44 134.04,51.92 135.75,51.52 137.45,51.13 130.21,60.59 124.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110.35,43.46 L 118.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[52, 60, 61, 55, 39]),
	1,
	'kya',
	'キャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$kyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	73,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 13, 113]),
	1,
	'kyo',
	'きょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$kyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	73,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.64,37.84 L 79.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,59.73 L 86,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.58,20 L 59.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[52, 60, 61, 72, 32, 34]),
	1,
	'kyo',
	'キョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$kyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	72,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.76,26.76 C 37.13,29.38 58.27,27.28 63.18,25.97', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.5,41.63 C 37.63,43.83 66.05,43.73 71.86,40.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 45.64,17.78 C 45.64,21.87 60.08,49.86 64.05,56.5 64.97,58.05 54.51,62.23 54.51,62.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 28.78,68.94 C 36.65,79.55 42.05,82.91 57.37,82.12', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 42, 55, 34, 107, 47]),
	1,
	'kyu',
	'きゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$kyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	72,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.64,37.84 L 79.44,31.35', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 27,59.73 L 86,52.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.58,20 L 59.78,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[52, 60, 61, 57, 42]),
	1,
	'kyu',
	'キュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ma = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	31,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.91,33.28 C 45.18,34.93 65.34,25.88 71,28', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 37.27,49.64 C 43.88,54.71 66.29,52.84 69.71,49.16', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 51.28,17.78 C 52.65,32.76 70.47,83 46,83 35,83 29.31,80.82 29.81,72.69 30.69,58.29 67.76,71.91 75,80', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[38, 34, 147]),
	1,
	'ma',
	'ま',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ma = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	31,
	_List_fromArray(
		[
			_Utils_Tuple3('M 20,23 L 80,23 C 80,23 69.88,41.21 52.25,57.93', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 31.25,46.78 C 50,60.16 67.25,78 67.25,78', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[105, 48]),
	1,
	'ma',
	'マ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$me = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	34,
	_List_fromArray(
		[
			_Utils_Tuple3('M 31.71,26.18 C 32.78,31.34 45.05,63.27 50.99,70.3', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 72.23,23.78 C 70.93,28.75 48.72,73.19 34.81,75.91 27.84,77.27 20.96,72.91 21.86,61.67 22.38,55.26 28.59,48.84 38.16,43.68 65.36,29 90.78,55.65 70.57,77.06', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[50, 185]),
	1,
	'me',
	'め',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$me = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	34,
	_List_fromArray(
		[
			_Utils_Tuple3('M 68.21,20 C 68.21,20 59.63,63.08 23,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.13,36.92 C 33.13,36.92 56.12,45 76,65.38', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[78, 52]),
	1,
	'me',
	'メ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$mi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	32,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[160, 41]),
	1,
	'mi',
	'み',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$mi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	32,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.02,20 C 28.02,20 49.88,21.52 71.74,26.84', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 31.03,42.78 C 31.03,42.78 49.88,45.06 68.72,51.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,69.37 C 25,69.37 49.12,72.41 74,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[45, 39, 51]),
	1,
	'mi',
	'ミ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$mo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	35,
	_List_fromArray(
		[
			_Utils_Tuple3('M 51.62,18.79 C 49.38,34.17 29.38,79.57 45.48,81.79 59.18,83.68 63.85,74.52 66.96,67', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 36.13,27.06 C 46.65,34.87 56.03,32.53 59.28,28.4', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 32.79,48.36 C 37.53,51.62 51.33,57.09 59,50.59', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[97, 26, 28]),
	1,
	'mo',
	'も',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$mo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	35,
	_List_fromArray(
		[
			_Utils_Tuple3('M 24.11,21 L 74.25,21', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,45.58 L 80,45.58', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44.66,21 L 44.66,70.19 C 44.66,70.19 45.48,80 57.81,80 70.14,80 77.53,79.18 77.53,79.18', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[51, 60, 87]),
	1,
	'mo',
	'モ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$mu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	33,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.65,30.62 C 29.13,33.07 41.55,31.23 41.55,31.23', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 34.79,20.79 C 36.3,42.08 38.78,62.89 32.18,61.94 18.81,60.02 22.46,43.84 26.52,43.51 47.14,41.87 27.64,70.42 37.24,75.85 49.76,82.94 72.47,79.36 75.63,73.36 78.59,67.75 72.82,59.59 69.8,54.92', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 63.97,27.62 C 66.33,31.5 70.53,35.41 75.87,37.08', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[17, 169, 16]),
	1,
	'mu',
	'む',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$mu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	33,
	_List_fromArray(
		[
			_Utils_Tuple3('M 43.77,21 L 23,75.46 68.84,71.22', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 57.38,48.59 C 57.38,48.59 70.99,66.98 76,79', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[105, 36]),
	1,
	'mu',
	'ム',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$mya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	86,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 102,56.64 C 107.57,59.29 134.47,44.95 137.85,48.53 143.28,54.28 134.73,61.36 132.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 123.46,42.78 C 123.46,47.06 125.99,55.36 127.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,46.03 C 109.61,48.09 122.51,76.39 122.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[160, 41, 56, 17, 40]),
	1,
	'mya',
	'みゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$mya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	86,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.02,20 C 28.02,20 49.88,21.52 71.74,26.84', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 31.03,42.78 C 31.03,42.78 49.88,45.06 68.72,51.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,69.37 C 25,69.37 49.12,72.41 74,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[45, 39, 51, 55, 39]),
	1,
	'mya',
	'ミャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$myo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	88,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 120.93,43.15 C 122.8,44.07 131.77,41.31 131.77,41.31', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 117.01,32.5 C 119.44,38.93 121.94,72.25 108.52,76.13 94.09,80.3 90.36,74.66 97.58,67.75 104.86,60.77 130.25,69.72 135.32,75.28', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[160, 41, 13, 113]),
	1,
	'myo',
	'みょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$myo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	88,
	_List_fromArray(
		[
			_Utils_Tuple3('M 35.02,20 C 35.02,20 56.88,21.52 78.74,26.84', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.03,42.78 C 38.03,42.78 56.88,45.06 75.72,51.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,69.37 C 32,69.37 56.12,72.41 81,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[45, 39, 51, 72, 32, 34]),
	1,
	'myo',
	'ミョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$myu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	87,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.35,27.32 C 39.21,29.61 49.62,22.78 49.62,22.78 49.81,34.5 40.02,72.77 27.18,71.73 14.23,70.67 20.26,55.05 30.17,51.72 52.5,44.23 75.8,60.03 80.81,68.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 73.73,40.14 C 74.52,52.04 70.62,69.52 62.16,77.1', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[160, 41, 107, 47]),
	1,
	'myu',
	'みゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$myu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	87,
	_List_fromArray(
		[
			_Utils_Tuple3('M 35.02,20 C 35.02,20 56.88,21.52 78.74,26.84', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.03,42.78 C 38.03,42.78 56.88,45.06 75.72,51.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,69.37 C 32,69.37 56.12,72.41 81,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[45, 39, 51, 57, 42]),
	1,
	'myu',
	'ミュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$n = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	46,
	_List_fromArray(
		[
			_Utils_Tuple3('M 46.56,21.78 C 41.81,45.37 21.78,79.42 21.78,79.42 21.78,79.42 38.82,49.54 40.92,49.39 54.53,48.46 53.95,78.25 60.89,78.24 73.35,78.22 74.69,59.42 77.71,54.81', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[171]),
	1,
	'n',
	'ん',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$n = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	46,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.62,22 C 21.62,22 31.92,28.42 41.89,38.46', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,79 C 64.59,68.56 80,27.62 80,27.62', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[27, 82]),
	1,
	'n',
	'ン',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$na = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	21,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.4,29 C 33.69,33.08 51.96,28.68 56.26,27.39', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 44.13,17.78 C 39.6,28.49 28.03,53.65 21.78,65.99', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 69.01,33.62 C 72.08,37.54 78.28,41.56 78.28,41.56 77.1,42.94 74.98,42.92 73.35,47.03', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 57.55,41.54 C 58.19,58.01 65.66,83.67 48.1,82.97 39.92,82.64 38.52,75.76 41.07,70.9 47.37,58.94 71.18,69.36 77.19,73.65', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[31, 54, 20, 106]),
	1,
	'na',
	'な',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$na = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	21,
	_List_fromArray(
		[
			_Utils_Tuple3('M 20,40.61 L 80,40.61', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50.82,20 L 50.82,54.62 C 50.82,54.62 50.41,75.23 33.15,81', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[60, 69]),
	1,
	'na',
	'ナ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ne = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	24,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.13,19.79 C 34.3,30.36 31.39,75.46 32.3,80.57', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 21.14,34.56 C 29.15,35.05 37.16,32.83 37.16,32.83 L 18.79,69.72 C 18.79,69.72 48.99,27.67 66.84,26.14 79.76,25.04 75.54,77.01 62.13,77.15 52.14,77.25 46.81,69.53 52.71,62.29 58.36,55.36 77.07,67.42 81.21,75.41', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[62, 241]),
	1,
	'ne',
	'ね',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ne = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	24,
	_List_fromArray(
		[
			_Utils_Tuple3('M 47.6,20 L 47.6,26.4', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25.2,29.6 L 70.8,29.6 C 70.8,29.6 48.4,58.4 22,68', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 47.6,54.4 L 47.6,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 59.6,58.4 C 59.6,58.4 69.2,62.4 78,69.6', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[7, 109, 26, 22]),
	1,
	'ne',
	'ネ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ni = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	22,
	_List_fromArray(
		[
			_Utils_Tuple3('M 29.65,21.78 C 22.67,33.23 20.35,71.25 25.8,79.09 26.48,74.06 31.38,64.46 34.81,61.13', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.68,30.43 C 56.82,27.16 64.05,21.31 76.42,31.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.96,66.61 C 56.17,76.84 66.62,78.19 76.03,74.95', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[80, 32, 33]),
	1,
	'ni',
	'に',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ni = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	22,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.33,29 L 72.83,29', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 17,71 L 82,71', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[48, 65]),
	1,
	'ni',
	'ニ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$no = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	25,
	_List_fromArray(
		[
			_Utils_Tuple3('M 47.6,30.6 C 48.44,55.92 35.33,74.66 24.57,71.83 13.89,69.01 20.33,30.78 51.56,26.11 79.15,21.98 89.15,58.35 68.42,73.96', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[186]),
	1,
	'no',
	'の',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$no = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	25,
	_List_fromArray(
		[
			_Utils_Tuple3('M 73,20 C 73,20 65.07,59.74 27,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[78]),
	1,
	'no',
	'ノ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$nu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	23,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.95,24.06 C 29.55,38.39 36.5,64.32 43.39,73.06', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 63.81,19.79 C 53.12,37.9 43.07,79.51 31.24,79.86 24.98,80.04 19.06,76.96 19.86,67.96 20.46,61.22 21.36,52.36 31,47 56.13,33.04 81.32,54.08 73.15,72.58 67.1,86.29 57.35,79.58 59.42,71.68 62.34,60.59 73.03,65.6 80.76,80.28', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[53, 234]),
	1,
	'nu',
	'ぬ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$nu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	23,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.91,20 L 75.36,20 C 75.36,20 63.09,60.54 23,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 36.91,39.46 C 36.91,39.46 59.82,50.81 77,70.27', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[130, 51]),
	1,
	'nu',
	'ヌ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$nya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	80,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.65,21.78 C 32.67,33.23 30.35,71.25 35.8,79.09 36.48,74.06 41.38,64.46 44.81,61.13', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 57.68,30.43 C 66.82,27.16 74.05,21.31 86.42,31.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 57.96,66.61 C 66.17,76.84 76.62,78.19 86.03,74.95', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 102,56.64 C 107.57,59.29 134.47,44.95 137.85,48.53 143.28,54.28 134.73,61.36 132.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 123.46,42.78 C 123.46,47.06 125.99,55.36 127.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,46.03 C 109.61,48.09 122.51,76.39 122.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[80, 32, 33, 56, 17, 40]),
	1,
	'nya',
	'にゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$nya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	80,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.33,29 L 72.83,29', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 17,71 L 82,71', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[48, 65, 55, 39]),
	1,
	'nya',
	'ニャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$nyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	82,
	_List_fromArray(
		[
			_Utils_Tuple3('M 29.65,21.78 C 22.67,33.23 20.35,71.25 25.8,79.09 26.48,74.06 31.38,64.46 34.81,61.13', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.68,30.43 C 56.82,27.16 64.05,21.31 76.42,31.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.96,66.61 C 56.17,76.84 66.62,78.19 76.03,74.95', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[80, 32, 33, 13, 113]),
	1,
	'nyo',
	'にょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$nyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	82,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.82,35.4 L 81.32,35.4', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25.49,77.4 L 90.49,77.4', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[48, 65, 72, 32, 34]),
	1,
	'nyo',
	'ニョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$nyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	81,
	_List_fromArray(
		[
			_Utils_Tuple3('M 29.65,21.78 C 22.67,33.23 20.35,71.25 25.8,79.09 26.48,74.06 31.38,64.46 34.81,61.13', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.68,30.43 C 56.82,27.16 64.05,21.31 76.42,31.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.96,66.61 C 56.17,76.84 66.62,78.19 76.03,74.95', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[80, 32, 33, 107, 47]),
	1,
	'nyu',
	'にゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$nyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	81,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.82,35.4 L 81.32,35.4', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25.49,77.4 L 90.49,77.4', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[48, 65, 57, 42]),
	1,
	'nyu',
	'ニュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$o = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	5,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.5,27.7 C 35.33,32.09 53.46,27.03 53.46,27.03', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 43.14,17.78 C 39.77,50.22 41.81,91.53 24.64,80.9 13.47,73.98 21.01,57.96 53.23,46.51 77.52,37.88 82.35,69.46 65.48,81.95', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 69.36,21.27 C 74.34,23.68 80.52,25.86 80.16,32.59', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[26, 185, 17]),
	1,
	'o',
	'お',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$o = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	5,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23.77,35.4 L 76,35.4', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 58.33,20 L 58.33,73.12 C 58.33,73.12 59.1,79.28 53.72,80.05 48.35,80.82 45.28,78.51 45.28,78.51', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 58.33,35.4 C 58.33,35.4 42.2,57.72 23,72.35', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[53, 72, 52]),
	1,
	'o',
	'オ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pa = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	66,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23.13,25.16 C 28.12,33.04 11.34,82.92 20.65,87.48 25.8,89.99 28.7,77.05 32.07,74.53', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.85,38.2 C 55.99,40.06 74.35,35.17 78.77,35.41', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 66.91,23.78 C 67.53,39.64 77.69,86.82 58.54,85.39 49.24,84.69 42.94,81.76 43.9,74.69 45.71,61.34 67.34,69.55 78.15,79.08', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 85,11 C 88.87,11 92,14.13 92,18 92,21.87 88.87,25 85,25 81.13,25 78,21.87 78,18 78,14.13 81.13,11 85,11 Z M 85,11', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[83, 32, 130, 47]),
	1,
	'pa',
	'ぱ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pa = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	66,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.71,28.52 C 36.71,28.52 34.43,55.81 20,74', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 59.49,27 C 59.49,27 74.68,46.71 80,74', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 78.47,13.32 C 82.34,13.32 85.47,16.46 85.47,20.32 85.47,24.19 82.34,27.32 78.47,27.32 74.61,27.32 71.47,24.19 71.47,20.32 71.47,16.46 74.61,13.32 78.47,13.32 Z M 78.47,13.32', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[50, 53, 47]),
	1,
	'pa',
	'パ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pe = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	69,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.78,60.06 C 25.32,54.85 30.91,43.44 34.64,38.78 41.18,44.42 62.75,56.65 80.86,63.16', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 72,20 C 75.87,20 79,23.13 79,27 79,30.87 75.87,34 72,34 68.13,34 65,30.87 65,27 65,23.13 68.13,20 72,20 Z M 72,20', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[81, 47]),
	1,
	'pe',
	'ぺ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pe = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	69,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17,55.49 C 17,55.49 35.46,31 40.27,31 45.09,31 82,71 82,71', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 64.77,15.22 C 68.63,15.22 71.77,18.36 71.77,22.22 71.77,26.09 68.63,29.22 64.77,29.22 60.9,29.22 57.77,26.09 57.77,22.22 57.77,18.36 60.9,15.22 64.77,15.22 Z M 64.77,15.22', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[92, 47]),
	1,
	'pe',
	'ペ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	67,
	_List_fromArray(
		[
			_Utils_Tuple3('M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[168, 47]),
	1,
	'pi',
	'ぴ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	67,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.15,50.86 C 27.15,50.86 49.58,48.43 71.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 26.32,20 C 26.32,20 18.85,71.17 26.32,77.67 33.8,84.17 77,77.67 77,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 81.92,10.83 C 85.79,10.83 88.92,13.96 88.92,17.83 88.92,21.69 85.79,24.83 81.92,24.83 78.06,24.83 74.92,21.69 74.92,17.83 74.92,13.96 78.06,10.83 81.92,10.83 Z M 81.92,10.83', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[47, 110, 47]),
	1,
	'pi',
	'ピ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$po = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	70,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23.68,28.78 C 18.01,36.26 15.15,81.9 21.03,82.29 24.7,82.54 29.19,68.25 29.19,68.25', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 49.48,30.62 C 56.47,29.12 72.83,30.46 76.82,31.6', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 48.95,49.19 C 56,53.38 73.17,50.27 77.31,48.5', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 62.91,31.6 C 65.68,57.03 74.11,89.55 49.19,83.27 39.34,80.79 43.01,64.22 52.13,65.64 65.86,67.78 72.9,70.49 77.8,78.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 85,11 C 88.87,11 92,14.13 92,18 92,21.87 88.87,25 85,25 81.13,25 78,21.87 78,18 78,14.13 81.13,11 85,11 Z M 85,11', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[72, 28, 29, 120, 47]),
	1,
	'po',
	'ぽ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$po = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	70,
	_List_fromArray(
		[
			_Utils_Tuple3('M 24.09,35.78 L 76.64,35.78', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50,21 L 50,76.32 C 50,76.32 49.64,78.79 46.35,80.11 43.07,81.44 38.32,78.6 38.32,78.6', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.95,52.07 C 33.95,52.07 32.49,61.17 23,72.53', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 65.32,52.07 C 65.32,52.07 68.97,63.44 77,72.53', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 69.4,9.64 C 73.27,9.64 76.4,12.77 76.4,16.64 76.4,20.51 73.27,23.64 69.4,23.64 65.54,23.64 62.4,20.51 62.4,16.64 62.4,12.77 65.54,9.64 69.4,9.64 Z M 69.4,9.64', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[53, 70, 24, 24, 47]),
	1,
	'po',
	'ポ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	68,
	_List_fromArray(
		[
			_Utils_Tuple3('M 44.09,19.78 C 45.89,23.85 48.42,26.98 50.73,28.5 L 46.37,30.78', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 46.58,45.21 C 58.43,50.96 57.51,79.75 47.2,80.88 41.54,81.51 38.7,74.66 38.7,74.66', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 30.4,49.39 C 29.36,54.79 25.55,64.17 18.78,68.02', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 70.99,45.55 C 76.87,54.76 82.64,67.33 80.49,69.2 77.39,71.9 72.78,65.61 71.47,64.91', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 75,15.04 C 78.87,15.04 82,18.18 82,22.04 82,25.91 78.87,29.04 75,29.04 71.13,29.04 68,25.91 68,22.04 68,18.18 71.13,15.04 75,15.04 Z M 75,15.04', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[16, 53, 23, 37, 47]),
	1,
	'pu',
	'ぷ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	68,
	_List_fromArray(
		[
			_Utils_Tuple3('M 17.63,30.92 L 71.63,30.92 C 71.63,30.92 68.21,67.2 28.28,85.92', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 81.92,10.83 C 85.79,10.83 88.92,13.96 88.92,17.83 88.92,21.69 85.79,24.83 81.92,24.83 78.06,24.83 74.92,21.69 74.92,17.83 74.92,13.96 78.06,10.83 81.92,10.83 Z M 81.92,10.83', $elm$core$Maybe$Nothing, 5)
		]),
	_List_fromArray(
		[127, 47]),
	1,
	'pu',
	'プ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	101,
	_List_fromArray(
		[
			_Utils_Tuple3('M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04', $elm$core$Maybe$Nothing, 5),
			_Utils_Tuple3('M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 47, 56, 17, 40]),
	1,
	'pya',
	'ぴゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	101,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 87.99,12.09 C 91.86,12.09 94.99,15.22 94.99,19.09 94.99,22.95 91.86,26.09 87.99,26.09 84.13,26.09 80.99,22.95 80.99,19.09 80.99,15.22 84.13,12.09 87.99,12.09 Z M 87.99,12.09', $elm$core$Maybe$Nothing, 5),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 47, 55, 39]),
	1,
	'pya',
	'ピャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	103,
	_List_fromArray(
		[
			_Utils_Tuple3('M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04', $elm$core$Maybe$Nothing, 5),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 47, 13, 113]),
	1,
	'pyo',
	'ぴょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pyo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	103,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 87.99,12.09 C 91.86,12.09 94.99,15.22 94.99,19.09 94.99,22.95 91.86,26.09 87.99,26.09 84.13,26.09 80.99,22.95 80.99,19.09 80.99,15.22 84.13,12.09 87.99,12.09 Z M 87.99,12.09', $elm$core$Maybe$Nothing, 5),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 47, 72, 32, 34]),
	1,
	'pyo',
	'ピョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$pyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	102,
	_List_fromArray(
		[
			_Utils_Tuple3('M 13.78,36.93 C 21.52,35.69 30.52,32.36 37.95,26.78 30.7,38.87 20.01,80.75 41.09,81.05 67.78,81.43 64.67,35.07 64.67,35.07 66.07,38.57 72.31,46.5 76.79,49.7', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 81,17.04 C 84.87,17.04 88,20.18 88,24.04 88,27.91 84.87,31.04 81,31.04 77.13,31.04 74,27.91 74,24.04 74,20.18 77.13,17.04 81,17.04 Z M 81,17.04', $elm$core$Maybe$Nothing, 5),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[168, 47, 107, 47]),
	1,
	'pyu',
	'ぴゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$pyu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	102,
	_List_fromArray(
		[
			_Utils_Tuple3('M 34.15,50.86 C 34.15,50.86 56.58,48.43 78.18,35.43', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 33.32,20 C 33.32,20 25.85,71.17 33.32,77.67 40.8,84.17 84,77.67 84,77.67', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 87.99,12.09 C 91.86,12.09 94.99,15.22 94.99,19.09 94.99,22.95 91.86,26.09 87.99,26.09 84.13,26.09 80.99,22.95 80.99,19.09 80.99,15.22 84.13,12.09 87.99,12.09 Z M 87.99,12.09', $elm$core$Maybe$Nothing, 5),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[47, 110, 47, 57, 42]),
	1,
	'pyu',
	'ピュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ra = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	39,
	_List_fromArray(
		[
			_Utils_Tuple3('M 43.84,19.78 C 46.8,23.94 53.73,26.94 58.23,28.54', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 40.5,33.55 C 34.87,42.94 32.78,62.75 32.78,62.75 32.78,62.75 47.43,40.69 61.57,51.49 74.94,61.71 62.61,82.07 48.43,80.9', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[19, 109]),
	1,
	'ra',
	'ら',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ra = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	39,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26,20 L 72.4,20', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 22,37.37 L 78,37.37 C 78,37.37 78.75,67.37 36.19,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[47, 120]),
	1,
	'ra',
	'ラ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$re = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	42,
	_List_fromArray(
		[
			_Utils_Tuple3('M 40.19,18.78 C 37.38,42.75 36.47,60.32 38.5,80.55', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 25.12,32 C 31.66,34.1 45.19,27.3 45.19,27.3 38.51,42.91 35.38,56.72 20.78,74.91 44.51,46.01 61.83,21.69 75.67,27.8 67.88,47.15 66.61,73.64 78.47,79.81', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[63, 207]),
	1,
	're',
	'れ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$re = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	42,
	_List_fromArray(
		[
			_Utils_Tuple3('M 35,20 L 35,80 C 35,80 59.92,75 81,50.77', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[116]),
	1,
	're',
	'レ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ri = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	40,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.59,18.89 C 36.04,25.9 35.82,41.79 39.15,46.91', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 61.25,18.79 C 70.01,47.51 54.78,74.87 46.39,81.82', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[30, 69]),
	1,
	'ri',
	'り',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ri = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	40,
	_List_fromArray(
		[
			_Utils_Tuple3('M 29,21.54 L 29,55.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 70,20 L 70,43.85 C 70,43.85 69.23,76.15 43.7,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[34, 73]),
	1,
	'ri',
	'リ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ro = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	43,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.14,19.87 C 49.26,24.67 61.89,19.78 61.89,19.78 54.39,26.63 38.48,42.79 26.78,54.29 26.78,54.29 59.6,24.16 69.21,39.16 79.73,55.6 63.36,75.45 46.31,79.7', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[186]),
	1,
	'ro',
	'ろ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ro = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	43,
	_List_fromArray(
		[
			_Utils_Tuple3('M 20,21 L 20,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,21 L 80,21 80,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20.88,75.6 L 80,75.6', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[59, 120, 59]),
	1,
	'ro',
	'ロ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ru = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	41,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.42,21.9 C 49.97,22.61 64.01,19.78 64.01,19.78 64.01,19.78 27.67,50.37 26.01,51.94 22.54,55.24 59.79,26.4 70.31,44.29 77.92,57.25 61.77,80.07 46.59,80.34 35,80.55 36.92,68.49 43.21,65.86 51.87,62.24 55.69,69.48 59.43,71.75', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[218]),
	1,
	'ru',
	'る',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ru = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	41,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.75,22.82 C 33.75,22.82 37.5,73.55 20,78.5', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 56.67,22 L 56.67,76.44 C 56.67,76.44 75,71.9 85,52.93', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[61, 94]),
	1,
	'ru',
	'ル',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$rya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	89,
	_List_fromArray(
		[
			_Utils_Tuple3('M 49.59,18.89 C 46.04,25.9 45.82,41.79 49.15,46.91', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 71.25,18.79 C 80.01,47.51 64.78,74.87 56.39,81.82', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,56.64 C 100.57,59.29 127.47,44.95 130.85,48.53 136.28,54.28 127.73,61.36 125.83,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 116.46,42.78 C 116.46,47.06 118.99,55.36 120.8,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 100.02,46.03 C 102.61,48.09 115.51,76.39 115.23,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 69, 56, 17, 40]),
	1,
	'rya',
	'りゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$rya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	89,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36,21.54 L 36,55.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 77,20 L 77,43.85 C 77,43.85 76.23,76.15 50.7,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 105,57.44 C 105,57.44 139.04,51.92 140.75,51.52 142.45,51.13 135.21,60.59 129.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.35,43.46 L 123.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[34, 73, 55, 39]),
	1,
	'rya',
	'リャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ryo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	91,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.59,18.89 C 36.04,25.9 35.82,41.79 39.15,46.91', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 61.25,18.79 C 70.01,47.51 54.78,74.87 46.39,81.82', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 69, 13, 113]),
	1,
	'ryo',
	'りょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ryo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	91,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36,21.54 L 36,55.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 77,20 L 77,43.85 C 77,43.85 76.23,76.15 50.7,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[34, 73, 72, 32, 34]),
	1,
	'ryo',
	'リョ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ryu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	90,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.59,18.89 C 36.04,25.9 35.82,41.79 39.15,46.91', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 61.25,18.79 C 70.01,47.51 54.78,74.87 46.39,81.82', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[30, 69, 107, 47]),
	1,
	'ryu',
	'りゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ryu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	90,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36,21.54 L 36,55.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 77,20 L 77,43.85 C 77,43.85 76.23,76.15 50.7,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[34, 73, 57, 42]),
	1,
	'ryu',
	'リュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$sa = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	11,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.78,34.46 C 33.37,38.49 69,36.15 74.08,33.2', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.99,17.78 C 47.99,21.8 60.65,47.48 63.88,54 64.63,55.52 55.22,61.42 55.22,61.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 31.92,67.95 C 34.87,77.86 47.45,83.64 60.84,82.84', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[49, 52, 35]),
	1,
	'sa',
	'さ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$sa = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	11,
	_List_fromArray(
		[
			_Utils_Tuple3('M 20,36.91 L 79.5,36.91', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 34.59,21.78 L 34.59,54.38', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 65.3,21 L 65.3,55.16 C 65.3,55.16 63.38,75.73 44.57,80', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[60, 34, 69]),
	1,
	'sa',
	'サ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$se = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	14,
	_List_fromArray(
		[
			_Utils_Tuple3('M 18.78,46.19 C 24.68,49.66 75.53,42.96 80.73,40.88', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 66.95,21.58 C 68.69,28.87 64.56,51.81 62.41,57.71', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 34.48,19.78 C 38.46,30.3 27.24,70.84 39.94,77.72 48.27,82.23 68.11,77.37 68.11,77.37', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[63, 37, 89]),
	1,
	'se',
	'せ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$se = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	14,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21,43.89 L 79,35.2 C 79,35.2 70.05,51.49 59.67,59.09', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.9,20 L 38.19,72.49 C 38.19,72.49 38.9,85.16 76.49,78.28', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[90, 94]),
	1,
	'se',
	'セ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$sha = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	74,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 92.78,56.64 C 98.35,59.29 125.25,44.95 128.64,48.53 134.07,54.28 125.51,61.36 123.61,64.75', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 114.24,42.78 C 114.24,47.06 116.78,55.36 118.59,58.11', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 97.81,46.03 C 100.39,48.09 113.29,76.39 113.02,82.73', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[111, 56, 17, 40]),
	1,
	'sha',
	'しゃ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$sha = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	74,
	_List_fromArray(
		[
			_Utils_Tuple3('M 32.87,20 C 32.87,20 43.09,22.34 50.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,38.7 C 25,38.7 35.23,41.04 43.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 31.29,80 C 31.29,80 65.91,72.21 84,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 100,57.44 C 100,57.44 134.04,51.92 135.75,51.52 137.45,51.13 130.21,60.59 124.26,64.92', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110.35,43.46 L 118.45,81.46', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[20, 20, 70, 55, 39]),
	1,
	'sha',
	'シャ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$shi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	12,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[111]),
	1,
	'shi',
	'し',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$shi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	12,
	_List_fromArray(
		[
			_Utils_Tuple3('M 32.87,20 C 32.87,20 43.09,22.34 50.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,38.7 C 25,38.7 35.23,41.04 43.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 31.29,80 C 31.29,80 65.91,72.21 84,37.14', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[20, 20, 70]),
	1,
	'shi',
	'シ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$sho = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	76,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 118.93,48.65 C 120.8,49.57 129.77,46.81 129.77,46.81', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.01,38 C 117.44,44.43 119.94,77.75 106.52,81.63 92.09,85.8 88.36,80.16 95.58,73.25 102.86,66.27 128.25,75.22 133.32,80.78', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[111, 13, 113]),
	1,
	'sho',
	'しょ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$sho = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	76,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.29,80 C 38.29,80 72.91,72.21 91,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 110.52,45 L 144,45 144,83', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 111.57,62.7 L 142.95,62.7', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 110,80.4 L 143.48,80.4', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[20, 20, 70, 72, 32, 34]),
	1,
	'sho',
	'ショ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$shu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	75,
	_List_fromArray(
		[
			_Utils_Tuple3('M 36.53,18.78 C 40.51,31.36 21.51,82.64 43.95,82.57 62.18,82.52 65.79,57.3 65.69,57.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 95,50.13 C 99.35,56.67 98.34,66.6 98.34,66.6 100.65,49.17 133.89,36.11 134.91,55.11 135.67,69.24 114.04,78.07 107.56,70.07', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 115.51,40 C 121.72,57.24 120.44,79.14 116.15,85.34', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[111, 107, 47]),
	1,
	'shu',
	'しゅ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$shu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	75,
	_List_fromArray(
		[
			_Utils_Tuple3('M 39.87,20 C 39.87,20 50.09,22.34 57.96,27.79', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 32,38.7 C 32,38.7 42.23,41.04 50.09,46.49', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.29,80 C 38.29,80 72.91,72.21 91,37.14', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 112.73,48.63 L 140.23,48.63 137.64,77.53', $elm$core$Maybe$Nothing, 7),
			_Utils_Tuple3('M 107.02,80.13 L 148.02,80.13', $elm$core$Maybe$Nothing, 7)
		]),
	_List_fromArray(
		[20, 20, 70, 57, 42]),
	1,
	'shu',
	'シュ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$so = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	15,
	_List_fromArray(
		[
			_Utils_Tuple3('M 38.01,17.78 C 44.31,23.61 64.91,18.71 64.91,18.98 64.91,18.98 39.66,36.29 27.78,47.31 51.44,41.14 62.09,44.1 72.34,45.11 53.34,55.2 41.51,70.92 53.06,81.69', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[171]),
	1,
	'so',
	'そ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$so = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	15,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26,26.97 C 26,26.97 34,35.53 38.67,46.71', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 74,25 C 74,25 68,61.18 35.33,75', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[24, 66]),
	1,
	'so',
	'ソ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$su = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	13,
	_List_fromArray(
		[
			_Utils_Tuple3('M 22.78,27.69 C 29.68,32.52 73.2,29.36 78.1,27.55', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 55.98,16.78 C 55.21,24.27 63.56,60.21 46.95,61.15 41.95,61.42 36.79,55.86 38.69,50.05 41.84,40.41 58.24,40.5 57.78,53.41 57.43,63.23 58.5,76.46 47.72,83.19', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[57, 128]),
	1,
	'su',
	'す',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$su = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	13,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.18,23 L 66.65,23 C 66.65,23 56.28,60.57 18,77', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 53.49,53.91 C 53.49,53.91 68.64,64.09 81,76.22', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[117, 36]),
	1,
	'su',
	'ス',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ta = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	16,
	_List_fromArray(
		[
			_Utils_Tuple3('M 26.53,35.58 C 35.03,40.2 60.03,37.28 65.03,35.82', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 49.28,18.78 C 44.53,26.33 30.53,69.65 23.78,81.09', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 51.78,53.34 C 55.78,55.53 70.68,48.07 76.53,52.37', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 48.78,75.49 C 54.78,79.87 66.03,83.28 77.03,79.63', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[39, 68, 26, 30]),
	1,
	'ta',
	'た',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ta = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	16,
	_List_fromArray(
		[
			_Utils_Tuple3('M 46.11,20 C 46.11,20 41.26,37.86 26,49.29', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 45.07,28.21 L 73.5,28.21 C 73.5,28.21 71.77,64.29 32.93,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 43.68,46.07 C 53.74,50 65.53,60.71 65.53,60.71', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[37, 98, 27]),
	1,
	'ta',
	'タ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$te = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	19,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.78,22.5 C 29.99,28.78 71.55,20.78 78.64,20.78 51.59,34.58 32.17,54.16 56.94,79.04', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[136]),
	1,
	'te',
	'て',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$te = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	19,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.5,21 L 71,21', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,42.09 L 80,42.09', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 51.5,44.73 C 51.5,44.73 51.12,69.96 31.62,79', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[44, 60, 42]),
	1,
	'te',
	'テ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$to = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	20,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.78,19.78 C 27.99,25.66 35.38,41.46 40.32,44.85', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 70.21,28.56 C 50.35,44.91 24.85,51.41 26.33,68.69 27.5,82.41 48.38,80.86 73.52,80.01', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[31, 116]),
	1,
	'to',
	'と',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$to = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	20,
	_List_fromArray(
		[
			_Utils_Tuple3('M 40,20 L 40,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 42.57,44.22 C 42.57,44.22 56.13,46.75 73,53.98', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[60, 33]),
	1,
	'to',
	'ト',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$tsu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	18,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[112]),
	1,
	'tsu',
	'つ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$tsu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	18,
	_List_fromArray(
		[
			_Utils_Tuple3('M 22,34.41 C 22,34.41 27.15,41.54 30.82,49.37', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 41.11,28 C 41.11,28 46.26,35.12 49.93,42.96', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 77.5,29.78 C 77.5,29.78 72.35,69.68 37.07,82.5', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[18, 18, 70]),
	1,
	'tsu',
	'ツ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$u = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	3,
	_List_fromArray(
		[
			_Utils_Tuple3('M 43.89,16.78 C 50.22,19.5 55.18,20.76 56.94,23.52', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 34.78,43.76 C 43.52,31.89 65.39,33.6 65.56,48.69 65.7,60.69 59,68.69 49.09,82.64', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[16, 80]),
	1,
	'u',
	'う',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$u = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	3,
	_List_fromArray(
		[
			_Utils_Tuple3('M 52.19,17 L 52.19,28.18', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,32.17 L 25,51.34', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25.81,31.77 L 81,31.77 C 81,31.77 81.81,70.92 42.86,84.5', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[12, 20, 125]),
	1,
	'u',
	'ウ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$wa = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	44,
	_List_fromArray(
		[
			_Utils_Tuple3('M 41.28,20.78 C 41.41,33.41 38.62,61.69 38.7,78.57', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 26.16,34.93 C 30.9,34.73 39.53,38.29 39.53,38.29 L 20.78,73.88 C 20.78,73.88 48.25,29.14 68.51,29.73 84.53,30.2 83.02,74.16 66.51,79.04', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[59, 181]),
	1,
	'wa',
	'わ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$wa = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	44,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25,20.89 L 25,44.31', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25,20.5 L 74.51,20.5 C 74.51,20.5 76.81,70.07 36.13,81', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[24, 127]),
	1,
	'wa',
	'ワ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$we = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	9999,
	_List_fromArray(
		[
			_Utils_Tuple3('M 20.71,25 L 79.64,25 C 79.64,25 72.96,40.45 57.25,51.27', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44,42.39 L 44,73.3', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 19,76 C 22.57,76 79,76 79,76', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[94, 32, 60]),
	1,
	'we',
	'ヱ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$wi = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	9999,
	_List_fromArray(
		[
			_Utils_Tuple3('M 22.27,31.34 L 78.59,31.34', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 35.07,33.47 L 35.07,63.27', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 18,65.82 L 82,65.82', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 61.52,19 L 61.52,82', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[57, 30, 64, 64]),
	1,
	'wi',
	'ヰ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$wo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	45,
	_List_fromArray(
		[
			_Utils_Tuple3('M 33.43,31.3 C 39.64,31.98 57.86,27.66 57.86,27.66', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 51.42,18.78 C 37.07,46.85 41.88,38.29 34.76,49.27 39.46,46.06 39.28,44.21 46.31,43.81 52.05,43.48 59.32,50.69 58.97,58.14', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 65.63,39.49 C 60.52,42.67 26.2,67.74 32.57,76.34 38.18,83.91 67.98,78.39 67.98,78.39', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[25, 69, 89]),
	1,
	'wo',
	'を',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$wo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	45,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23,21 L 75.01,21', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 26.2,45 L 71.01,45', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 75.01,21 C 75.01,21 77.41,66.6 39.8,81', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[53, 46, 74]),
	1,
	'wo',
	'ヲ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	36,
	_List_fromArray(
		[
			_Utils_Tuple3('M 18.78,40.92 C 27.9,44.97 71.95,23.09 77.5,28.55 86.4,37.33 72.39,48.12 69.27,53.29', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 53.92,19.78 C 53.92,26.3 58.08,38.97 61.04,43.17', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 27.01,24.73 C 31.24,27.88 52.37,71.06 51.92,80.73', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[90, 26, 62]),
	1,
	'ya',
	'や',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ya = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	36,
	_List_fromArray(
		[
			_Utils_Tuple3('M 37.39,20 L 50.21,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 21,42.06 C 21,42.06 74.9,33.35 77.6,32.72 80.29,32.1 68.84,47.04 59.41,53.88', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[62, 86]),
	1,
	'ya',
	'ヤ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$yo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	38,
	_List_fromArray(
		[
			_Utils_Tuple3('M 57.72,32.5 C 60.09,33.69 71.44,30.14 71.44,30.14', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 52.75,18.78 C 55.83,27.06 59,70 42,75 23.73,80.37 19.01,73.11 28.15,64.2 37.37,55.21 69.52,66.75 75.94,73.9', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[17, 170]),
	1,
	'yo',
	'よ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$yo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	38,
	_List_fromArray(
		[
			_Utils_Tuple3('M 23.82,20 L 76,20 76,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 25.45,47.95 L 74.37,47.95', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 23,75.89 L 75.18,75.89', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[113, 50, 52]),
	1,
	'yo',
	'ヨ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$yu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	37,
	_List_fromArray(
		[
			_Utils_Tuple3('M 22.79,32.71 C 28.77,41.7 27.38,55.36 27.38,55.36 30.56,31.39 76.28,13.43 77.69,39.57 78.74,58.99 48.98,71.13 40.07,60.13', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 51.01,18.79 C 59.54,42.49 57.79,72.61 51.88,81.12', $elm$core$Maybe$Nothing, 9.47)
		]),
	_List_fromArray(
		[148, 65]),
	1,
	'yu',
	'ゆ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$yu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	37,
	_List_fromArray(
		[
			_Utils_Tuple3('M 27.63,27 L 69.23,27 65.3,69.66', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 19,73.5 L 81,73.5', $elm$core$Maybe$Nothing, 10)
		]),
	_List_fromArray(
		[85, 62]),
	1,
	'yu',
	'ユ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$za = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	52,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.78,34.46 C 33.37,38.49 69,36.15 74.08,33.2', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 47.99,17.78 C 47.99,21.8 60.65,47.48 63.88,54 64.63,55.52 55.22,61.42 55.22,61.42', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 31.92,67.95 C 34.87,77.86 47.45,83.64 60.84,82.84', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 77.31,16 C 77.31,16 79.98,16 82.64,19 85.31,22 85.31,25 85.31,25',
			$elm$core$Maybe$Just('M 75.13,15.06 C 74.83,15.35 74.99,15.53 76.27,16.3 78.68,17.76 81.7,21.22 83.95,25.13 84.8,26.59 85.52,27.16 86.31,26.96 87.95,26.56 87.48,21.6 85.57,19.32 84.69,18.26 81.52,16.67 78.37,15.7 75.69,14.89 75.37,14.82 75.13,15.06 Z M 75.13,15.06'),
			5),
			_Utils_Tuple3(
			'M 82.31,10 C 82.31,10 84.98,10 87.64,13 90.31,16 90.31,19 90.31,19',
			$elm$core$Maybe$Just('M 80.13,9.06 C 79.83,9.35 79.99,9.53 81.27,10.3 83.68,11.76 86.7,15.22 88.95,19.13 89.8,20.59 90.52,21.16 91.31,20.96 92.95,20.56 92.48,15.6 90.57,13.32 89.69,12.26 86.52,10.67 83.37,9.7 80.69,8.89 80.37,8.82 80.13,9.06 Z M 80.13,9.06'),
			5)
		]),
	_List_fromArray(
		[49, 52, 35, 14, 14]),
	1,
	'za',
	'ざ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$za = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	52,
	_List_fromArray(
		[
			_Utils_Tuple3('M 16.2,41.71 L 75.7,41.71', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 30.79,26.57 L 30.79,59.18', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 61.5,25.8 L 61.5,59.95 C 61.5,59.95 59.58,80.53 40.77,84.8', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[60, 34, 69, 14, 14]),
	1,
	'za',
	'ザ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$ze = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	55,
	_List_fromArray(
		[
			_Utils_Tuple3('M 18.78,46.19 C 24.68,49.66 75.53,42.96 80.73,40.88', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 66.95,21.58 C 68.69,28.87 64.56,51.81 62.41,57.71', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 34.48,19.78 C 38.46,30.3 27.24,70.84 39.94,77.72 48.27,82.23 68.11,77.37 68.11,77.37', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 77.31,15 C 77.31,15 79.98,15 82.64,18 85.31,21 85.31,24 85.31,24',
			$elm$core$Maybe$Just('M 75.13,14.06 C 74.83,14.35 74.99,14.53 76.27,15.3 78.68,16.76 81.7,20.22 83.95,24.13 84.8,25.59 85.52,26.16 86.31,25.96 87.95,25.56 87.48,20.6 85.57,18.32 84.69,17.26 81.52,15.67 78.37,14.7 75.69,13.89 75.37,13.82 75.13,14.06 Z M 75.13,14.06'),
			5),
			_Utils_Tuple3(
			'M 82.31,9 C 82.31,9 84.98,9 87.64,12 90.31,15 90.31,18 90.31,18',
			$elm$core$Maybe$Just('M 80.13,8.06 C 79.83,8.35 79.99,8.53 81.27,9.3 83.68,10.76 86.7,14.22 88.95,18.13 89.8,19.59 90.52,20.16 91.31,19.96 92.95,19.56 92.48,14.6 90.57,12.32 89.69,11.26 86.52,9.67 83.37,8.7 80.69,7.89 80.37,7.82 80.13,8.06 Z M 80.13,8.06'),
			5)
		]),
	_List_fromArray(
		[63, 37, 89, 14, 14]),
	1,
	'ze',
	'ぜ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$ze = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	55,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21,43.89 L 79,35.2 C 79,35.2 70.05,51.49 59.67,59.09', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 38.9,20 L 38.19,72.49 C 38.19,72.49 38.9,85.16 76.49,78.28', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[90, 94, 14, 14]),
	1,
	'ze',
	'ゼ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$zi2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	53,
	_List_fromArray(
		[
			_Utils_Tuple3('M 68.61,20 C 47.01,28.33 26.23,28.33 26.23,28.33', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 20,47.08 L 79,47.08', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 50.33,27.5 L 50.33,49.17 C 50.33,49.17 49.5,72.5 32.05,80', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,29.06 C 72.31,29.06 74.98,29.06 77.64,32.06 80.31,35.06 80.31,38.06 80.31,38.06',
			$elm$core$Maybe$Just('M 70.13,28.12 C 69.83,28.41 69.99,28.59 71.27,29.36 73.68,30.82 76.7,34.28 78.95,38.19 79.8,39.65 80.52,40.22 81.31,40.02 82.95,39.63 82.48,34.66 80.57,32.38 79.69,31.33 76.52,29.74 73.37,28.76 70.69,27.95 70.37,27.88 70.13,28.12 Z M 70.13,28.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,23.06 C 77.31,23.06 79.98,23.06 82.64,26.06 85.31,29.06 85.31,32.06 85.31,32.06',
			$elm$core$Maybe$Just('M 75.13,22.12 C 74.83,22.41 74.99,22.59 76.27,23.36 78.68,24.82 81.7,28.28 83.95,32.19 84.8,33.65 85.52,34.22 86.31,34.02 87.95,33.63 87.48,28.66 85.57,26.38 84.69,25.33 81.52,23.74 78.37,22.76 75.69,21.95 75.37,21.88 75.13,22.12 Z M 75.13,22.12'),
			5)
		]),
	_List_fromArray(
		[44, 60, 60, 14, 14]),
	1,
	'zi',
	'ヂ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$zo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	56,
	_List_fromArray(
		[
			_Utils_Tuple3('M 38.01,17.78 C 44.31,23.61 64.91,18.71 64.91,18.98 64.91,18.98 39.66,36.29 27.78,47.31 51.44,41.14 62.09,44.1 72.34,45.11 53.34,55.2 41.51,70.92 53.06,81.69', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 77.31,15 C 77.31,15 79.98,15 82.64,18 85.31,21 85.31,24 85.31,24',
			$elm$core$Maybe$Just('M 75.13,14.06 C 74.83,14.35 74.99,14.53 76.27,15.3 78.68,16.76 81.7,20.22 83.95,24.13 84.8,25.59 85.52,26.16 86.31,25.96 87.95,25.56 87.48,20.6 85.57,18.32 84.69,17.26 81.52,15.67 78.37,14.7 75.69,13.89 75.37,13.82 75.13,14.06 Z M 75.13,14.06'),
			5),
			_Utils_Tuple3(
			'M 82.31,9 C 82.31,9 84.98,9 87.64,12 90.31,15 90.31,18 90.31,18',
			$elm$core$Maybe$Just('M 80.13,8.06 C 79.83,8.35 79.99,8.53 81.27,9.3 83.68,10.76 86.7,14.22 88.95,18.13 89.8,19.59 90.52,20.16 91.31,19.96 92.95,19.56 92.48,14.6 90.57,12.32 89.69,11.26 86.52,9.67 83.37,8.7 80.69,7.89 80.37,7.82 80.13,8.06 Z M 80.13,8.06'),
			5)
		]),
	_List_fromArray(
		[171, 14, 14]),
	1,
	'zo',
	'ぞ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$zo = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	56,
	_List_fromArray(
		[
			_Utils_Tuple3('M 28.21,35.31 C 28.21,35.31 36.21,43.87 40.88,55.05', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 76.21,33.34 C 76.21,33.34 70.21,69.52 37.55,83.34', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[24, 66, 14, 14]),
	1,
	'zo',
	'ゾ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$zu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	54,
	_List_fromArray(
		[
			_Utils_Tuple3('M 22.78,32.69 C 29.68,37.52 73.2,34.36 78.1,32.55', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3('M 55.98,21.78 C 55.21,29.27 63.56,65.21 46.95,66.15 41.95,66.42 36.79,60.86 38.69,55.05 41.84,45.41 58.24,45.5 57.78,58.41 57.43,68.23 58.5,81.46 47.72,88.19', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 77.31,15 C 77.31,15 79.98,15 82.64,18 85.31,21 85.31,24 85.31,24',
			$elm$core$Maybe$Just('M 75.13,14.06 C 74.83,14.35 74.99,14.53 76.27,15.3 78.68,16.76 81.7,20.22 83.95,24.13 84.8,25.59 85.52,26.16 86.31,25.96 87.95,25.56 87.48,20.6 85.57,18.32 84.69,17.26 81.52,15.67 78.37,14.7 75.69,13.89 75.37,13.82 75.13,14.06 Z M 75.13,14.06'),
			5),
			_Utils_Tuple3(
			'M 82.31,9 C 82.31,9 84.98,9 87.64,12 90.31,15 90.31,18 90.31,18',
			$elm$core$Maybe$Just('M 80.13,8.06 C 79.83,8.35 79.99,8.53 81.27,9.3 83.68,10.76 86.7,14.22 88.95,18.13 89.8,19.59 90.52,20.16 91.31,19.96 92.95,19.56 92.48,14.6 90.57,12.32 89.69,11.26 86.52,9.67 83.37,8.7 80.69,7.89 80.37,7.82 80.13,8.06 Z M 80.13,8.06'),
			5)
		]),
	_List_fromArray(
		[57, 128, 14, 14]),
	1,
	'zu',
	'ず',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$zu = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	54,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.18,23 L 66.65,23 C 66.65,23 56.28,60.57 18,77', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 53.49,53.91 C 53.49,53.91 68.64,64.09 81,76.22', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[117, 36, 14, 14]),
	1,
	'zu',
	'ズ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Hiragana$zu2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	58,
	_List_fromArray(
		[
			_Utils_Tuple3('M 21.78,38.74 C 30.41,46.04 67.51,19.79 75.18,36.4 84.42,56.4 56.84,70.78 43.9,70.52', $elm$core$Maybe$Nothing, 9.47),
			_Utils_Tuple3(
			'M 78.31,17 C 78.31,17 80.98,17 83.64,20 86.31,23 86.31,26 86.31,26',
			$elm$core$Maybe$Just('M 76.13,16.06 C 75.83,16.35 75.99,16.53 77.27,17.3 79.68,18.76 82.7,22.22 84.95,26.13 85.8,27.59 86.52,28.16 87.31,27.96 88.95,27.56 88.48,22.6 86.57,20.32 85.69,19.26 82.52,17.67 79.37,16.7 76.69,15.89 76.37,15.82 76.13,16.06 Z M 76.13,16.06'),
			5),
			_Utils_Tuple3(
			'M 83.31,11 C 83.31,11 85.98,11 88.64,14 91.31,17 91.31,20 91.31,20',
			$elm$core$Maybe$Just('M 81.13,10.06 C 80.83,10.35 80.99,10.53 82.27,11.3 84.68,12.76 87.7,16.22 89.95,20.13 90.8,21.59 91.52,22.16 92.31,21.96 93.95,21.56 93.48,16.6 91.57,14.32 90.69,13.26 87.52,11.67 84.37,10.7 81.69,9.89 81.37,9.82 81.13,10.06 Z M 81.13,10.06'),
			5)
		]),
	_List_fromArray(
		[112, 14, 14]),
	1,
	'zu',
	'づ',
	0);
var $author$project$SVGs$AnimatedKanaTiles$Katakana$zu2 = A7(
	$author$project$Domain$Types$AnimatedKanaRecord,
	58,
	_List_fromArray(
		[
			_Utils_Tuple3('M 25.23,39.41 C 25.23,39.41 30.38,46.54 34.06,54.37', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 44.35,33 C 44.35,33 49.49,40.12 53.17,47.96', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3('M 80.73,34.78 C 80.73,34.78 75.59,74.68 40.3,87.5', $elm$core$Maybe$Nothing, 10),
			_Utils_Tuple3(
			'M 72.31,17.06 C 72.31,17.06 74.98,17.06 77.64,20.06 80.31,23.06 80.31,26.06 80.31,26.06',
			$elm$core$Maybe$Just('M 70.13,16.12 C 69.83,16.41 69.99,16.59 71.27,17.36 73.68,18.82 76.7,22.28 78.95,26.19 79.8,27.65 80.52,28.22 81.31,28.02 82.95,27.63 82.48,22.66 80.57,20.38 79.69,19.33 76.52,17.74 73.37,16.76 70.69,15.95 70.37,15.88 70.13,16.12 Z M 70.13,16.12'),
			5),
			_Utils_Tuple3(
			'M 77.31,11.06 C 77.31,11.06 79.98,11.06 82.64,14.06 85.31,17.06 85.31,20.06 85.31,20.06',
			$elm$core$Maybe$Just('M 75.13,10.12 C 74.83,10.41 74.99,10.59 76.27,11.36 78.68,12.82 81.7,16.28 83.95,20.19 84.8,21.65 85.52,22.22 86.31,22.02 87.95,21.63 87.48,16.66 85.57,14.38 84.69,13.33 81.52,11.74 78.37,10.76 75.69,9.95 75.37,9.88 75.13,10.12 Z M 75.13,10.12'),
			5)
		]),
	_List_fromArray(
		[18, 18, 70, 14, 14]),
	1,
	'zu',
	'ヅ',
	0);
var $author$project$Services$Kana$animatedKanaLookup = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('あ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$a),
			_Utils_Tuple2('い', $author$project$SVGs$AnimatedKanaTiles$Hiragana$i),
			_Utils_Tuple2('う', $author$project$SVGs$AnimatedKanaTiles$Hiragana$u),
			_Utils_Tuple2('え', $author$project$SVGs$AnimatedKanaTiles$Hiragana$e),
			_Utils_Tuple2('お', $author$project$SVGs$AnimatedKanaTiles$Hiragana$o),
			_Utils_Tuple2('か', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ka),
			_Utils_Tuple2('き', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ki),
			_Utils_Tuple2('く', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ku),
			_Utils_Tuple2('け', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ke),
			_Utils_Tuple2('こ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ko),
			_Utils_Tuple2('さ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$sa),
			_Utils_Tuple2('し', $author$project$SVGs$AnimatedKanaTiles$Hiragana$shi),
			_Utils_Tuple2('す', $author$project$SVGs$AnimatedKanaTiles$Hiragana$su),
			_Utils_Tuple2('せ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$se),
			_Utils_Tuple2('そ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$so),
			_Utils_Tuple2('た', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ta),
			_Utils_Tuple2('ち', $author$project$SVGs$AnimatedKanaTiles$Hiragana$chi),
			_Utils_Tuple2('つ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$tsu),
			_Utils_Tuple2('て', $author$project$SVGs$AnimatedKanaTiles$Hiragana$te),
			_Utils_Tuple2('と', $author$project$SVGs$AnimatedKanaTiles$Hiragana$to),
			_Utils_Tuple2('な', $author$project$SVGs$AnimatedKanaTiles$Hiragana$na),
			_Utils_Tuple2('に', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ni),
			_Utils_Tuple2('ぬ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$nu),
			_Utils_Tuple2('ね', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ne),
			_Utils_Tuple2('の', $author$project$SVGs$AnimatedKanaTiles$Hiragana$no),
			_Utils_Tuple2('は', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ha),
			_Utils_Tuple2('ひ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$hi),
			_Utils_Tuple2('ふ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$fu),
			_Utils_Tuple2('へ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$he),
			_Utils_Tuple2('ほ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ho),
			_Utils_Tuple2('ま', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ma),
			_Utils_Tuple2('み', $author$project$SVGs$AnimatedKanaTiles$Hiragana$mi),
			_Utils_Tuple2('む', $author$project$SVGs$AnimatedKanaTiles$Hiragana$mu),
			_Utils_Tuple2('め', $author$project$SVGs$AnimatedKanaTiles$Hiragana$me),
			_Utils_Tuple2('も', $author$project$SVGs$AnimatedKanaTiles$Hiragana$mo),
			_Utils_Tuple2('や', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ya),
			_Utils_Tuple2('ゆ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$yu),
			_Utils_Tuple2('よ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$yo),
			_Utils_Tuple2('ら', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ra),
			_Utils_Tuple2('り', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ri),
			_Utils_Tuple2('る', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ru),
			_Utils_Tuple2('れ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$re),
			_Utils_Tuple2('ろ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ro),
			_Utils_Tuple2('が', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ga),
			_Utils_Tuple2('ぎ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$gi),
			_Utils_Tuple2('ぐ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$gu),
			_Utils_Tuple2('げ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ge),
			_Utils_Tuple2('ご', $author$project$SVGs$AnimatedKanaTiles$Hiragana$go),
			_Utils_Tuple2('ざ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$za),
			_Utils_Tuple2('じ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ji),
			_Utils_Tuple2('ず', $author$project$SVGs$AnimatedKanaTiles$Hiragana$zu),
			_Utils_Tuple2('ぜ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ze),
			_Utils_Tuple2('ぞ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$zo),
			_Utils_Tuple2('だ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$da),
			_Utils_Tuple2('ぢ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$dzi),
			_Utils_Tuple2('づ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$zu2),
			_Utils_Tuple2('で', $author$project$SVGs$AnimatedKanaTiles$Hiragana$de),
			_Utils_Tuple2('ど', $author$project$SVGs$AnimatedKanaTiles$Hiragana$do),
			_Utils_Tuple2('ば', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ba),
			_Utils_Tuple2('び', $author$project$SVGs$AnimatedKanaTiles$Hiragana$bi),
			_Utils_Tuple2('ぶ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$bu),
			_Utils_Tuple2('べ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$be),
			_Utils_Tuple2('ぼ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$bo),
			_Utils_Tuple2('ぱ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pa),
			_Utils_Tuple2('ぴ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pi),
			_Utils_Tuple2('ぷ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pu),
			_Utils_Tuple2('ぺ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pe),
			_Utils_Tuple2('ぽ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$po),
			_Utils_Tuple2('わ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$wa),
			_Utils_Tuple2('を', $author$project$SVGs$AnimatedKanaTiles$Hiragana$wo),
			_Utils_Tuple2('きゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$kya),
			_Utils_Tuple2('きゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$kyu),
			_Utils_Tuple2('きょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$kyo),
			_Utils_Tuple2('しゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$sha),
			_Utils_Tuple2('しゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$shu),
			_Utils_Tuple2('しょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$sho),
			_Utils_Tuple2('ちゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$cha),
			_Utils_Tuple2('ちゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$chu),
			_Utils_Tuple2('ちょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$cho),
			_Utils_Tuple2('にゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$nya),
			_Utils_Tuple2('にゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$nyu),
			_Utils_Tuple2('にょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$nyo),
			_Utils_Tuple2('ひゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$hya),
			_Utils_Tuple2('ひゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$hyu),
			_Utils_Tuple2('ひょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$hyo),
			_Utils_Tuple2('みゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$mya),
			_Utils_Tuple2('みゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$myu),
			_Utils_Tuple2('みょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$myo),
			_Utils_Tuple2('りゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$rya),
			_Utils_Tuple2('りゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ryu),
			_Utils_Tuple2('りょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ryo),
			_Utils_Tuple2('ぎゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$gya),
			_Utils_Tuple2('ぎゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$gyu),
			_Utils_Tuple2('ぎょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$gyo),
			_Utils_Tuple2('じゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ja),
			_Utils_Tuple2('じゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ju),
			_Utils_Tuple2('じょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$jo),
			_Utils_Tuple2('ぢゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ja2),
			_Utils_Tuple2('ぢゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$ju2),
			_Utils_Tuple2('ぢょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$jo2),
			_Utils_Tuple2('びゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$bya),
			_Utils_Tuple2('びゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$byu),
			_Utils_Tuple2('びょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$byo),
			_Utils_Tuple2('ぴゃ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pya),
			_Utils_Tuple2('ぴゅ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pyu),
			_Utils_Tuple2('ぴょ', $author$project$SVGs$AnimatedKanaTiles$Hiragana$pyo),
			_Utils_Tuple2('ん', $author$project$SVGs$AnimatedKanaTiles$Hiragana$n),
			_Utils_Tuple2('ア', $author$project$SVGs$AnimatedKanaTiles$Katakana$a),
			_Utils_Tuple2('イ', $author$project$SVGs$AnimatedKanaTiles$Katakana$i),
			_Utils_Tuple2('ウ', $author$project$SVGs$AnimatedKanaTiles$Katakana$u),
			_Utils_Tuple2('エ', $author$project$SVGs$AnimatedKanaTiles$Katakana$e),
			_Utils_Tuple2('オ', $author$project$SVGs$AnimatedKanaTiles$Katakana$o),
			_Utils_Tuple2('カ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ka),
			_Utils_Tuple2('キ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ki),
			_Utils_Tuple2('ク', $author$project$SVGs$AnimatedKanaTiles$Katakana$ku),
			_Utils_Tuple2('ケ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ke),
			_Utils_Tuple2('コ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ko),
			_Utils_Tuple2('サ', $author$project$SVGs$AnimatedKanaTiles$Katakana$sa),
			_Utils_Tuple2('シ', $author$project$SVGs$AnimatedKanaTiles$Katakana$shi),
			_Utils_Tuple2('ス', $author$project$SVGs$AnimatedKanaTiles$Katakana$su),
			_Utils_Tuple2('セ', $author$project$SVGs$AnimatedKanaTiles$Katakana$se),
			_Utils_Tuple2('ソ', $author$project$SVGs$AnimatedKanaTiles$Katakana$so),
			_Utils_Tuple2('タ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ta),
			_Utils_Tuple2('チ', $author$project$SVGs$AnimatedKanaTiles$Katakana$chi),
			_Utils_Tuple2('ツ', $author$project$SVGs$AnimatedKanaTiles$Katakana$tsu),
			_Utils_Tuple2('テ', $author$project$SVGs$AnimatedKanaTiles$Katakana$te),
			_Utils_Tuple2('ト', $author$project$SVGs$AnimatedKanaTiles$Katakana$to),
			_Utils_Tuple2('ナ', $author$project$SVGs$AnimatedKanaTiles$Katakana$na),
			_Utils_Tuple2('ニ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ni),
			_Utils_Tuple2('ヌ', $author$project$SVGs$AnimatedKanaTiles$Katakana$nu),
			_Utils_Tuple2('ネ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ne),
			_Utils_Tuple2('ノ', $author$project$SVGs$AnimatedKanaTiles$Katakana$no),
			_Utils_Tuple2('ハ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ha),
			_Utils_Tuple2('ヒ', $author$project$SVGs$AnimatedKanaTiles$Katakana$hi),
			_Utils_Tuple2('フ', $author$project$SVGs$AnimatedKanaTiles$Katakana$fu),
			_Utils_Tuple2('ヘ', $author$project$SVGs$AnimatedKanaTiles$Katakana$he),
			_Utils_Tuple2('ホ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ho),
			_Utils_Tuple2('マ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ma),
			_Utils_Tuple2('ミ', $author$project$SVGs$AnimatedKanaTiles$Katakana$mi),
			_Utils_Tuple2('ム', $author$project$SVGs$AnimatedKanaTiles$Katakana$mu),
			_Utils_Tuple2('メ', $author$project$SVGs$AnimatedKanaTiles$Katakana$me),
			_Utils_Tuple2('モ', $author$project$SVGs$AnimatedKanaTiles$Katakana$mo),
			_Utils_Tuple2('ヤ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ya),
			_Utils_Tuple2('ユ', $author$project$SVGs$AnimatedKanaTiles$Katakana$yu),
			_Utils_Tuple2('ヨ', $author$project$SVGs$AnimatedKanaTiles$Katakana$yo),
			_Utils_Tuple2('ラ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ra),
			_Utils_Tuple2('リ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ri),
			_Utils_Tuple2('ル', $author$project$SVGs$AnimatedKanaTiles$Katakana$ru),
			_Utils_Tuple2('レ', $author$project$SVGs$AnimatedKanaTiles$Katakana$re),
			_Utils_Tuple2('ロ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ro),
			_Utils_Tuple2('ワ', $author$project$SVGs$AnimatedKanaTiles$Katakana$wa),
			_Utils_Tuple2('ヰ', $author$project$SVGs$AnimatedKanaTiles$Katakana$wi),
			_Utils_Tuple2('ヱ', $author$project$SVGs$AnimatedKanaTiles$Katakana$we),
			_Utils_Tuple2('ヲ', $author$project$SVGs$AnimatedKanaTiles$Katakana$wo),
			_Utils_Tuple2('ン', $author$project$SVGs$AnimatedKanaTiles$Katakana$n),
			_Utils_Tuple2('ガ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ga),
			_Utils_Tuple2('ギ', $author$project$SVGs$AnimatedKanaTiles$Katakana$gi),
			_Utils_Tuple2('グ', $author$project$SVGs$AnimatedKanaTiles$Katakana$gu),
			_Utils_Tuple2('ゲ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ge),
			_Utils_Tuple2('ゴ', $author$project$SVGs$AnimatedKanaTiles$Katakana$go),
			_Utils_Tuple2('ザ', $author$project$SVGs$AnimatedKanaTiles$Katakana$za),
			_Utils_Tuple2('ジ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ji),
			_Utils_Tuple2('ズ', $author$project$SVGs$AnimatedKanaTiles$Katakana$zu),
			_Utils_Tuple2('ゼ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ze),
			_Utils_Tuple2('ゾ', $author$project$SVGs$AnimatedKanaTiles$Katakana$zo),
			_Utils_Tuple2('ダ', $author$project$SVGs$AnimatedKanaTiles$Katakana$da),
			_Utils_Tuple2('ヂ', $author$project$SVGs$AnimatedKanaTiles$Katakana$zi2),
			_Utils_Tuple2('ヅ', $author$project$SVGs$AnimatedKanaTiles$Katakana$zu2),
			_Utils_Tuple2('デ', $author$project$SVGs$AnimatedKanaTiles$Katakana$de),
			_Utils_Tuple2('ド', $author$project$SVGs$AnimatedKanaTiles$Katakana$do),
			_Utils_Tuple2('バ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ba),
			_Utils_Tuple2('ビ', $author$project$SVGs$AnimatedKanaTiles$Katakana$bi),
			_Utils_Tuple2('ブ', $author$project$SVGs$AnimatedKanaTiles$Katakana$bu),
			_Utils_Tuple2('ベ', $author$project$SVGs$AnimatedKanaTiles$Katakana$be),
			_Utils_Tuple2('ボ', $author$project$SVGs$AnimatedKanaTiles$Katakana$bo),
			_Utils_Tuple2('パ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pa),
			_Utils_Tuple2('ピ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pi),
			_Utils_Tuple2('プ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pu),
			_Utils_Tuple2('ペ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pe),
			_Utils_Tuple2('ポ', $author$project$SVGs$AnimatedKanaTiles$Katakana$po),
			_Utils_Tuple2('キャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$kya),
			_Utils_Tuple2('キュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$kyu),
			_Utils_Tuple2('キョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$kyo),
			_Utils_Tuple2('シャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$sha),
			_Utils_Tuple2('シュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$shu),
			_Utils_Tuple2('ショ', $author$project$SVGs$AnimatedKanaTiles$Katakana$sho),
			_Utils_Tuple2('チャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$cha),
			_Utils_Tuple2('チュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$chu),
			_Utils_Tuple2('チョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$cho),
			_Utils_Tuple2('ニャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$nya),
			_Utils_Tuple2('ニュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$nyu),
			_Utils_Tuple2('ニョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$nyo),
			_Utils_Tuple2('ヒャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$hya),
			_Utils_Tuple2('ヒュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$hyu),
			_Utils_Tuple2('ヒョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$hyo),
			_Utils_Tuple2('ミャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$mya),
			_Utils_Tuple2('ミュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$myu),
			_Utils_Tuple2('ミョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$myo),
			_Utils_Tuple2('リャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$rya),
			_Utils_Tuple2('リュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ryu),
			_Utils_Tuple2('リョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ryo),
			_Utils_Tuple2('ギャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$gya),
			_Utils_Tuple2('ギュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$gyu),
			_Utils_Tuple2('ギョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$gyo),
			_Utils_Tuple2('ジャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ja),
			_Utils_Tuple2('ジュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ju),
			_Utils_Tuple2('ジョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$jo),
			_Utils_Tuple2('ヂャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ja2),
			_Utils_Tuple2('ヂュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$ju2),
			_Utils_Tuple2('ヂョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$jo2),
			_Utils_Tuple2('ビャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$bya),
			_Utils_Tuple2('ビュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$byu),
			_Utils_Tuple2('ビョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$byo),
			_Utils_Tuple2('ピャ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pya),
			_Utils_Tuple2('ピュ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pyu),
			_Utils_Tuple2('ピョ', $author$project$SVGs$AnimatedKanaTiles$Katakana$pyo),
			_Utils_Tuple2('ッキ', $author$project$SVGs$AnimatedKanaTiles$Katakana$kki)
		]));
var $author$project$Services$Kana$toAnimatedKanaRecord = function (kana) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SVGs$AnimatedKanaTiles$Hiragana$unknown,
		A2($elm$core$Dict$get, kana, $author$project$Services$Kana$animatedKanaLookup));
};
var $author$project$Services$Kana$toAnimatedKanaListInternal = function (kanaStringList) {
	_v0$8:
	while (true) {
		if (kanaStringList.b) {
			if (kanaStringList.b.b) {
				switch (kanaStringList.b.a) {
					case 'ゃ':
						var kana = kanaStringList.a;
						var _v1 = kanaStringList.b;
						var restOfTheList = _v1.b;
						return A2(
							$elm$core$List$cons,
							$author$project$Services$Kana$toAnimatedKanaRecord(kana + 'ゃ'),
							$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
					case 'ゅ':
						var kana = kanaStringList.a;
						var _v2 = kanaStringList.b;
						var restOfTheList = _v2.b;
						return A2(
							$elm$core$List$cons,
							$author$project$Services$Kana$toAnimatedKanaRecord(kana + 'ゅ'),
							$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
					case 'ょ':
						var kana = kanaStringList.a;
						var _v3 = kanaStringList.b;
						var restOfTheList = _v3.b;
						return A2(
							$elm$core$List$cons,
							$author$project$Services$Kana$toAnimatedKanaRecord(kana + 'ょ'),
							$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
					case 'ャ':
						var kana = kanaStringList.a;
						var _v4 = kanaStringList.b;
						var restOfTheList = _v4.b;
						return A2(
							$elm$core$List$cons,
							$author$project$Services$Kana$toAnimatedKanaRecord(kana + 'ャ'),
							$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
					case 'ュ':
						var kana = kanaStringList.a;
						var _v5 = kanaStringList.b;
						var restOfTheList = _v5.b;
						return A2(
							$elm$core$List$cons,
							$author$project$Services$Kana$toAnimatedKanaRecord(kana + 'ュ'),
							$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
					case 'ョ':
						var kana = kanaStringList.a;
						var _v6 = kanaStringList.b;
						var restOfTheList = _v6.b;
						return A2(
							$elm$core$List$cons,
							$author$project$Services$Kana$toAnimatedKanaRecord(kana + 'ョ'),
							$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
					default:
						switch (kanaStringList.a) {
							case 'ッ':
								var _v7 = kanaStringList.b;
								var kana = _v7.a;
								var restOfTheList = _v7.b;
								return A2(
									$elm$core$List$cons,
									$author$project$Services$Kana$toAnimatedKanaRecord('ッ' + kana),
									$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
							case 'っ':
								var _v8 = kanaStringList.b;
								var kana = _v8.a;
								var restOfTheList = _v8.b;
								return A2(
									$elm$core$List$cons,
									$author$project$Services$Kana$toAnimatedKanaRecord('っ' + kana),
									$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
							default:
								break _v0$8;
						}
				}
			} else {
				break _v0$8;
			}
		} else {
			return _List_Nil;
		}
	}
	var kana = kanaStringList.a;
	var restOfTheList = kanaStringList.b;
	return A2(
		$elm$core$List$cons,
		$author$project$Services$Kana$toAnimatedKanaRecord(kana),
		$author$project$Services$Kana$toAnimatedKanaListInternal(restOfTheList));
};
var $author$project$Services$Kana$toAnimatedKanaList = function (kanaWordString) {
	return $author$project$Services$Kana$toAnimatedKanaListInternal(
		A2($elm$core$String$split, '', kanaWordString));
};
var $author$project$Services$Kanaword$initAnimatingKanaRecords = F2(
	function (kanaWordString, animatingKanaData) {
		return _Utils_update(
			animatingKanaData,
			{
				bq: $elm$core$Maybe$Nothing,
				bu: true,
				bv: $author$project$Services$Kana$toAnimatedKanaList(kanaWordString),
				bV: 0
			});
	});
var $author$project$Services$Kanaword$updateAnimatingKanaData = function (model) {
	var _v0 = model.bY;
	if (!_v0.$) {
		var word = _v0.a;
		return _Utils_update(
			model,
			{
				bw: A2($author$project$Services$Kanaword$initAnimatingKanaRecords, word.cH, model.bw)
			});
	} else {
		return model;
	}
};
var $author$project$Services$ImageMatch$updateSelectedImageID = F2(
	function (imageID, imageMatchState) {
		return _Utils_update(
			imageMatchState,
			{
				dc: $elm$core$Maybe$Just(imageID)
			});
	});
var $author$project$Services$ImageMatch$updateWrongImages = F2(
	function (imageID, imageMatchState) {
		return A2(
			$elm$core$Maybe$withDefault,
			imageMatchState,
			A2(
				$elm$core$Maybe$andThen,
				function (imageIDValue) {
					return $elm$core$Maybe$Just(
						_Utils_update(
							imageMatchState,
							{
								dM: A2($elm$core$List$cons, imageIDValue, imageMatchState.dM)
							}));
				},
				imageID));
	});
var $author$project$Services$ImageMatch$updateImageMatchState = F2(
	function (imageMatchMessage, model) {
		switch (imageMatchMessage.$) {
			case 0:
				var imageID = imageMatchMessage.a;
				var correctImageID = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$andThen,
						function (word) {
							return $elm$core$Maybe$Just(word.cp);
						},
						model.bY));
				return _Utils_Tuple3(
					A2(
						$author$project$Services$Score$addScore,
						A3(
							$author$project$Services$ImageMatch$selectedImageScore,
							$elm$core$Maybe$Just(imageID),
							correctImageID,
							model.ct),
						_Utils_update(
							model,
							{
								ct: A2($author$project$Services$ImageMatch$updateSelectedImageID, imageID, model.ct)
							})),
					A2(
						$author$project$Services$Audio$correctAnswerCommand,
						model,
						_Utils_eq(imageID, correctImageID)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ct: A2($author$project$Services$ImageMatch$updateWrongImages, model.ct.dc, model.ct)
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				return _Utils_Tuple3(
					A2(
						$author$project$Services$Random$stepRandomSeed,
						$author$project$Domain$Types$ImageMatchSeed,
						$author$project$Services$Kanaword$updateAnimatingKanaData(
							$author$project$Services$ImageMatch$advanceToNextKanaWord(
								$author$project$Services$ImageMatch$resetImageMatchForNextWord(model)))),
					$author$project$Services$Audio$playVictorySoundEffectCommand(model),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$AnimatedKanaStrokeFinished = {$: 3};
var $author$project$Services$Kanaword$isCorrectImageSelected = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$andThen,
			function (word) {
				return $elm$core$Maybe$Just(
					_Utils_eq(
						model.ct.dc,
						$elm$core$Maybe$Just(word.cp)));
			},
			model.bY));
};
var $author$project$Domain$Types$KanaSound = 1;
var $author$project$Services$Audio$kanaSoundsPath = function (soundFileName) {
	return '../Audio/KanaSounds/' + soundFileName;
};
var $author$project$Services$Audio$kanaAudioURL = function (audioID) {
	return $author$project$Services$Audio$kanaSoundsPath(
		$elm$core$String$fromInt(audioID) + '.mp3');
};
var $author$project$Services$Audio$kanaPlayAudioCommandByAudioID = F2(
	function (_v0, audioID) {
		var settings = _v0.de;
		return settings.bd ? $author$project$Extras$Task$toCommandMessage(
			$author$project$Services$Audio$toPlayAudioMessage(
				A3(
					$author$project$Services$Audio$AudioFile,
					$elm$core$String$fromInt(audioID),
					$author$project$Services$Audio$kanaAudioURL(audioID),
					1))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Services$Kanaword$getAudioCommandAtIndex = F2(
	function (maybeIndex, model) {
		var animatedKanawordData = model.bw;
		if ((!model.de.bd) || $author$project$Services$Kanaword$isCorrectImageSelected(model)) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var _v0 = _Utils_Tuple3(
				maybeIndex,
				$elm$core$List$isEmpty(model.bN),
				animatedKanawordData.cc);
			if (((!_v0.a.$) && _v0.b) && _v0.c) {
				var index = _v0.a.a;
				var _v1 = A2($author$project$Extras$List$elementAt, index, animatedKanawordData.bv);
				if (!_v1.$) {
					var value = _v1.a;
					return A2($author$project$Services$Audio$kanaPlayAudioCommandByAudioID, model, value.bB);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}
	});
var $author$project$Domain$Types$WordSound = 2;
var $author$project$Services$Audio$imageSoundsPath = function (soundFileName) {
	return '../Audio/ImageSounds/' + soundFileName;
};
var $author$project$Services$Audio$kanawordAudioURL = function (id) {
	return $author$project$Services$Audio$imageSoundsPath(
		$elm$core$String$fromInt(id) + '.mp3');
};
var $author$project$Services$Audio$kanawordPlayAudioMessageByImageID = function (id) {
	return $author$project$Services$Audio$toPlayAudioMessage(
		A3(
			$author$project$Services$Audio$AudioFile,
			$elm$core$String$fromInt(id),
			$author$project$Services$Audio$kanawordAudioURL(id),
			2));
};
var $author$project$Services$Audio$getKanawordPlayCommand = function (_v0) {
	var currentWord = _v0.bY;
	var settings = _v0.de;
	return settings.bd ? $author$project$Extras$Task$toCommandMessage(
		$author$project$Services$Audio$kanawordPlayAudioMessageByImageID(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$andThen,
					function (word) {
						return $elm$core$Maybe$Just(word.cp);
					},
					currentWord)))) : $elm$core$Platform$Cmd$none;
};
var $author$project$Services$Kanaword$incrementAnimateScaleUpIndex = function (animatedKanaWordData) {
	return _Utils_update(
		animatedKanaWordData,
		{
			bq: A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return $elm$core$Maybe$Just(value + 1);
				},
				animatedKanaWordData.bq)
		});
};
var $author$project$Services$Kanaword$incrementCorrectWords = function (imageMatchState) {
	return _Utils_update(
		imageMatchState,
		{bT: imageMatchState.bT + 1});
};
var $author$project$Services$Kanaword$incrementCompletedWordCount = function (model) {
	return _Utils_update(
		model,
		{
			ct: $author$project$Services$Kanaword$incrementCorrectWords(model.ct)
		});
};
var $author$project$Services$Kanaword$kanaProgress = function (itemCount) {
	return 20 * itemCount;
};
var $author$project$Services$Kanaword$dashMaxLimited = F3(
	function (kanaString, animatedKanaRecord, dashValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				function (intValue) {
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$Basics$min,
							$elm$core$List$sum(
								A2($elm$core$List$take, intValue, animatedKanaRecord.$7)),
							animatedKanaRecord.bZ + dashValue));
				},
				A2($elm$core$Dict$get, kanaString, $author$project$Services$Kana$numberOfStrokesPerKana)));
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Services$Kana$toNumberOfStrokesList = function (kanaString) {
	return A2(
		$elm$core$List$map,
		function (kanaCharacter) {
			return A2($elm$core$Dict$get, kanaCharacter, $author$project$Services$Kana$numberOfStrokesPerKana);
		},
		$author$project$Extras$String$toStringList(kanaString));
};
var $author$project$Services$Kanaword$isKanaStringMatch = F2(
	function (kanaString, animatedKanaRecord) {
		var _v0 = $author$project$Services$Kana$toNumberOfStrokesList(animatedKanaRecord.cD);
		if (!_v0.b) {
			return false;
		} else {
			if (!_v0.b.b) {
				return _Utils_eq(animatedKanaRecord.cD, kanaString);
			} else {
				if (!_v0.b.b.b) {
					var firstCharacterStrokeCount = _v0.a;
					var _v1 = _v0.b;
					var secondCharacterStrokeCount = _v1.a;
					var _v2 = _Utils_Tuple2(firstCharacterStrokeCount, secondCharacterStrokeCount);
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var firstCount = _v2.a.a;
						return (_Utils_cmp(
							animatedKanaRecord.bZ,
							$elm$core$List$sum(
								A2($elm$core$List$take, firstCount, animatedKanaRecord.$7))) < 0) ? A2($elm$core$String$startsWith, kanaString, animatedKanaRecord.cD) : A2($elm$core$String$endsWith, kanaString, animatedKanaRecord.cD);
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		}
	});
var $author$project$Services$Kanaword$addToAnimatedKanaRecordDash = F3(
	function (kanaString, dashValue, animatedKanaRecord) {
		return A2($author$project$Services$Kanaword$isKanaStringMatch, kanaString, animatedKanaRecord) ? ((($elm$core$String$length(animatedKanaRecord.cD) === 1) || A2($elm$core$String$endsWith, kanaString, animatedKanaRecord.cD)) ? _Utils_update(
			animatedKanaRecord,
			{bZ: animatedKanaRecord.bZ + dashValue}) : _Utils_update(
			animatedKanaRecord,
			{
				bZ: A3($author$project$Services$Kanaword$dashMaxLimited, kanaString, animatedKanaRecord, dashValue)
			})) : animatedKanaRecord;
	});
var $author$project$Extras$List$updateAtIndex = F3(
	function (index, updateFunction, list) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (elementIndex, element) {
					return _Utils_eq(elementIndex, index) ? updateFunction(element) : element;
				}),
			list);
	});
var $author$project$Services$Kanaword$updateStrokeDash = F3(
	function (kanaString, dashValue, animatingKanaData) {
		return _Utils_update(
			animatingKanaData,
			{
				bv: A3(
					$author$project$Extras$List$updateAtIndex,
					animatingKanaData.bV,
					A2($author$project$Services$Kanaword$addToAnimatedKanaRecordDash, kanaString, dashValue),
					animatingKanaData.bv)
			});
	});
var $author$project$Services$Kanaword$incrementKanaProgress = F3(
	function (itemCount, kanaString, model) {
		return _Utils_update(
			model,
			{
				bw: A3(
					$author$project$Services$Kanaword$updateStrokeDash,
					kanaString,
					$author$project$Services$Kanaword$kanaProgress(itemCount),
					model.bw)
			});
	});
var $author$project$Services$Kanaword$isAnimatingSingleKana = function (animatedKanawordData) {
	return A2(
		$elm$core$Maybe$andThen,
		function (value) {
			return $elm$core$Maybe$Just(
				_Utils_cmp(
					value,
					$elm$core$List$length(animatedKanawordData.bv)) < 0);
		},
		animatedKanawordData.bq);
};
var $author$project$Services$Kanaword$numberOfCompleteStrokesByDashValue = function (kanaRecord) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (dashMax, _v0) {
				var dashMaxTotal = _v0.a;
				var completeStrokeCount = _v0.b;
				return (_Utils_cmp(kanaRecord.bZ, dashMaxTotal + dashMax) > -1) ? _Utils_Tuple2(dashMaxTotal + dashMax, completeStrokeCount + 1) : _Utils_Tuple2(dashMaxTotal + dashMax, completeStrokeCount);
			}),
		_Utils_Tuple2(0, 0),
		kanaRecord.$7).b;
};
var $author$project$Services$Kanaword$numberOfCompleteStrokes = function (_v0) {
	var animatedKanawordData = _v0.bw;
	return $author$project$Services$Kanaword$numberOfCompleteStrokesByDashValue(
		$author$project$Services$Kanaword$toCurrentAnimatedKanaRecord(animatedKanawordData));
};
var $author$project$Services$Kanaword$resetForNextWord = function (animatingKanaData) {
	return _Utils_update(
		animatingKanaData,
		{bu: false, cc: false});
};
var $author$project$Services$Kanaword$resetAnimatingKanaDataForNextWord = function (model) {
	var _v0 = model.bY;
	if (!_v0.$) {
		return _Utils_update(
			model,
			{
				bw: $author$project$Services$Kanaword$resetForNextWord(model.bw)
			});
	} else {
		return model;
	}
};
var $author$project$Services$Time$strokeProgressDuration = 1000;
var $author$project$Services$Time$strokeProgressDelay = F2(
	function (completedStrokeCount, message) {
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				function (durationMultiplier) {
					return A2($author$project$Services$Time$delay, durationMultiplier * $author$project$Services$Time$strokeProgressDuration, message);
				},
				A2($elm$core$List$range, 1, completedStrokeCount)));
	});
var $author$project$Services$Kanaword$transitionToImageMatch = function (model) {
	return (model.bw.cc && (!model.cA)) ? _Utils_update(
		model,
		{by: 6}) : model;
};
var $author$project$Services$Kanaword$updateAnimateScaleUpIndex = F2(
	function (index, animatedKanaWordData) {
		return _Utils_update(
			animatedKanaWordData,
			{
				bq: $elm$core$Maybe$Just(index)
			});
	});
var $author$project$Services$Kanaword$updateAnimateScaleUp = F2(
	function (index, model) {
		return _Utils_update(
			model,
			{
				bw: A2($author$project$Services$Kanaword$updateAnimateScaleUpIndex, index, model.bw)
			});
	});
var $author$project$Services$Kanaword$incrementAnimatingKanaIndex = function (animatingKanaData) {
	return (_Utils_cmp(
		animatingKanaData.bV,
		$elm$core$List$length(animatingKanaData.bv) - 1) < 0) ? _Utils_update(
		animatingKanaData,
		{bV: animatingKanaData.bV + 1}) : _Utils_update(
		animatingKanaData,
		{cc: true});
};
var $author$project$Services$Kanaword$incrementStrokeIndex = function (animatingKanaData) {
	return _Utils_update(
		animatingKanaData,
		{
			bv: A3(
				$author$project$Extras$List$updateAtIndex,
				animatingKanaData.bV,
				function (animatedKanaRecord) {
					return _Utils_update(
						animatedKanaRecord,
						{dn: animatedKanaRecord.dn + 1});
				},
				animatingKanaData.bv)
		});
};
var $author$project$Services$Kanaword$updateKanaAnimationState = function (model) {
	var currentAnimatingKana = $author$project$Services$Kanaword$toCurrentAnimatedKanaRecord(model.bw);
	var index = currentAnimatingKana.dn;
	var isKanaDashCompleted = _Utils_cmp(
		currentAnimatingKana.bZ,
		$elm$core$List$sum(currentAnimatingKana.$7)) > -1;
	var strokePathCount = $elm$core$List$length(currentAnimatingKana.dp);
	return ((_Utils_cmp(index, strokePathCount) > -1) && isKanaDashCompleted) ? _Utils_update(
		model,
		{
			bw: $author$project$Services$Kanaword$incrementAnimatingKanaIndex(model.bw)
		}) : ((_Utils_cmp(index, strokePathCount) < 0) ? _Utils_update(
		model,
		{
			bw: $author$project$Services$Kanaword$incrementStrokeIndex(model.bw)
		}) : model);
};
var $author$project$Services$Kanaword$updateKanawordState = F2(
	function (message, model) {
		switch (message.$) {
			case 3:
				return _Utils_Tuple3(
					$author$project$Services$Kanaword$transitionToImageMatch(
						$author$project$Services$Kanaword$updateKanaAnimationState(model)),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 0:
				var itemCount = message.a;
				var kanaString = message.b;
				var updatedModel = A3($author$project$Services$Kanaword$incrementKanaProgress, itemCount, kanaString, model);
				var completedStrokeCount = $author$project$Services$Kanaword$numberOfCompleteStrokes(updatedModel) - $author$project$Services$Kanaword$numberOfCompleteStrokes(model);
				return _Utils_Tuple3(
					updatedModel,
					(completedStrokeCount > 0) ? A2(
						$author$project$Services$Time$strokeProgressDelay,
						completedStrokeCount,
						$author$project$Domain$Types$KanawordMessage($author$project$Domain$Types$AnimatedKanaStrokeFinished)) : $elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				return _Utils_Tuple3(
					A2($author$project$Services$Kanaword$updateAnimateScaleUp, 0, model),
					A2(
						$author$project$Services$Kanaword$getAudioCommandAtIndex,
						$elm$core$Maybe$Just(0),
						model),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 4:
				var animatedKanawordDataUpdate = $author$project$Services$Kanaword$incrementAnimateScaleUpIndex(model.bw);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bw: animatedKanawordDataUpdate}),
					function () {
						var _v1 = $author$project$Services$Kanaword$isAnimatingSingleKana(animatedKanawordDataUpdate);
						if (!_v1.$) {
							if (_v1.a) {
								return A2($author$project$Services$Kanaword$getAudioCommandAtIndex, animatedKanawordDataUpdate.bq, model);
							} else {
								return $author$project$Services$Audio$getKanawordPlayCommand(model);
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				return _Utils_Tuple3(
					$author$project$Services$Kanaword$resetAnimatingKanaDataForNextWord(
						$author$project$Services$Kanaword$incrementCompletedWordCount(model)),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$LoadLevelFailure = 0;
var $author$project$Domain$Types$LoadedLevel = 4;
var $author$project$Domain$Types$NotPlaying = {$: 0};
var $author$project$Domain$Types$UpdateLoadingState = {$: 2};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$Services$Modal$dropDownErrorsModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{b4: 0})
		});
};
var $author$project$Services$Modal$activateModal = function (modalState) {
	return _Utils_update(
		modalState,
		{aO: 0});
};
var $author$project$Services$Modal$dropDownLevelPreviewModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{
					cM: $author$project$Services$Modal$activateModal(modals.cM)
				})
		});
};
var $author$project$Services$Loading$initializeBoardItems = function (model) {
	var level = model.cK;
	var swapState = model.ds;
	var _v0 = level.cI;
	if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
		var firstKanaWord = _v0.a;
		var _v1 = _v0.b;
		var _v2 = _v1.b;
		var _v3 = _v2.b;
		var _v4 = firstKanaWord.cw;
		if (!_v4.$) {
			var initialBoardItems = _v4.a;
			return _Utils_update(
				model,
				{
					bG: initialBoardItems,
					bY: $elm$core$Maybe$Just(firstKanaWord),
					cG: firstKanaWord.cG,
					ds: _Utils_update(
						swapState,
						{
							c3: A2(
								$author$project$Services$Swap$detectAllSwaps,
								$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
								initialBoardItems)
						})
				});
		} else {
			var newRandomBoard = A5(
				$author$project$Services$Board$randomBoard,
				model.c4.c7,
				10,
				10,
				$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
				firstKanaWord.cG);
			return _Utils_update(
				model,
				{
					bG: newRandomBoard,
					bY: $elm$core$Maybe$Just(firstKanaWord),
					cG: firstKanaWord.cG,
					ds: _Utils_update(
						swapState,
						{
							c3: A2(
								$author$project$Services$Swap$detectAllSwaps,
								$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
								newRandomBoard)
						})
				});
		}
	} else {
		return model;
	}
};
var $author$project$Services$Audio$kanaLoadAudioCommandByID = function (audioID) {
	return $author$project$Services$Audio$toLoadAudioCommand(
		A3(
			$author$project$Services$Audio$AudioFile,
			$elm$core$String$fromInt(audioID),
			$author$project$Services$Audio$kanaAudioURL(audioID),
			1));
};
var $author$project$Services$Audio$loadKanaAudio = function (audioIDList) {
	return $MartinSStewart$elm_audio$Audio$cmdBatch(
		A2($elm$core$List$map, $author$project$Services$Audio$kanaLoadAudioCommandByID, audioIDList));
};
var $author$project$Services$Audio$kanawordLoadAudioCommandByID = function (id) {
	return $author$project$Services$Audio$toLoadAudioCommand(
		A3(
			$author$project$Services$Audio$AudioFile,
			$elm$core$String$fromInt(id),
			$author$project$Services$Audio$kanawordAudioURL(id),
			2));
};
var $author$project$Services$Audio$loadKanawordsAudio = function (kanawordIDs) {
	return $MartinSStewart$elm_audio$Audio$cmdBatch(
		A2($elm$core$List$map, $author$project$Services$Audio$kanawordLoadAudioCommandByID, kanawordIDs));
};
var $author$project$Extras$List$removeAt = F2(
	function (index, list) {
		if (index < 0) {
			return list;
		} else {
			var _v0 = A2($elm$core$List$drop, index, list);
			if (!_v0.b) {
				return list;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					rest);
			}
		}
	});
var $author$project$Extras$List$shuffleListHelper = F3(
	function (seed, source, result) {
		shuffleListHelper:
		while (true) {
			if ($elm$core$List$isEmpty(source)) {
				return result;
			} else {
				var indexGenerator = A2(
					$elm$random$Random$int,
					0,
					$elm$core$List$length(source) - 1);
				var _v0 = A2($elm$random$Random$step, indexGenerator, seed);
				var index = _v0.a;
				var nextSeed = _v0.b;
				var sourceWithoutIndex = A2($author$project$Extras$List$removeAt, index, source);
				var valAtIndex = A2($author$project$Extras$List$elementAt, index, source);
				if (!valAtIndex.$) {
					var val = valAtIndex.a;
					var $temp$seed = nextSeed,
						$temp$source = sourceWithoutIndex,
						$temp$result = A2($elm$core$List$cons, val, result);
					seed = $temp$seed;
					source = $temp$source;
					result = $temp$result;
					continue shuffleListHelper;
				} else {
					return _List_Nil;
				}
			}
		}
	});
var $author$project$Extras$List$shuffle = F2(
	function (seed, list) {
		return A3($author$project$Extras$List$shuffleListHelper, seed, list, _List_Nil);
	});
var $author$project$Services$Level$shuffleLevelKanawords = F2(
	function (seed, level) {
		var kanaWords = level.cI;
		return _Utils_update(
			level,
			{
				cI: A2($author$project$Extras$List$shuffle, seed, kanaWords)
			});
	});
var $author$project$Services$Level$shuffleKanawords = F2(
	function (seed, model) {
		var level = model.cK;
		return _Utils_update(
			model,
			{
				cK: A2($author$project$Services$Level$shuffleLevelKanawords, seed, level)
			});
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Services$Loading$finishedLoadingIndividualKanaSounds = F2(
	function (model, dictionary) {
		return A2(
			$elm$core$List$all,
			function (hiragana) {
				return A2($elm$core$Dict$member, hiragana, dictionary);
			},
			A2(
				$elm$core$List$map,
				function (animatedKanaRecord) {
					return $elm$core$String$fromInt(animatedKanaRecord.bB);
				},
				A2(
					$elm$core$List$concatMap,
					function (kanaWord) {
						return $author$project$Services$Kana$toAnimatedKanaList(kanaWord.cH);
					},
					model.cK.cI)));
	});
var $author$project$Services$Loading$finishedLoadingWords = F2(
	function (model, dictionary) {
		return A2(
			$elm$core$List$all,
			function (idString) {
				return A2($elm$core$Dict$member, idString, dictionary);
			},
			A2(
				$elm$core$List$map,
				function (word) {
					return $elm$core$String$fromInt(word.cp);
				},
				model.cK.cI));
	});
var $author$project$Services$Loading$soundsFinishedLoading = function (model) {
	var audioModel = model.bC;
	return A2($author$project$Services$Loading$finishedLoadingWords, model, audioModel.dK) && A2($author$project$Services$Loading$finishedLoadingIndividualKanaSounds, model, audioModel.cF);
};
var $author$project$Domain$Types$LoadingLevelAudio = 3;
var $author$project$Domain$Types$KanaWord = F6(
	function (categoryID, englishTranslation, id, initialKana, kanaWordString, kanaToColorLookup) {
		return {bM: categoryID, b2: englishTranslation, cp: id, cw: initialKana, cG: kanaToColorLookup, cH: kanaWordString};
	});
var $elm$json$Json$Decode$array = _Json_decodeArray;
var $author$project$Extras$Array$appendElement = F2(
	function (element, array) {
		return A2(
			$elm$core$Array$append,
			array,
			$elm$core$Array$fromList(
				_List_fromArray(
					[element])));
	});
var $author$project$Extras$Array$keyedFoldLeft = F4(
	function (seed, _function, initialValue, array) {
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (arrayElement, _v0) {
					var randomSeed = _v0.a;
					var newArray = _v0.b;
					var _v1 = $author$project$Services$KeyGenerator$seedToKey(randomSeed);
					var key = _v1.a;
					var nextSeed = _v1.b;
					return _Utils_Tuple2(
						nextSeed,
						A3(_function, key, arrayElement, newArray));
				}),
			_Utils_Tuple2(seed, initialValue),
			array).b;
	});
var $author$project$Extras$Array$mapWithKey = F3(
	function (seed, _function, array) {
		return A4(
			$author$project$Extras$Array$keyedFoldLeft,
			seed,
			F3(
				function (key, arrayItem, newArray) {
					return A2(
						$author$project$Extras$Array$appendElement,
						A2(_function, key, arrayItem),
						newArray);
				}),
			$elm$core$Array$empty,
			array);
	});
var $author$project$Services$Matrix$mapWithKey = F3(
	function (seed, _function, matrix) {
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (array, _v0) {
					var randomSeed = _v0.a;
					var newMatrix = _v0.b;
					var _v1 = A2($elm$random$Random$step, $author$project$Extras$Random$anyInt, randomSeed);
					var nextSeed = _v1.b;
					return _Utils_Tuple2(
						nextSeed,
						A2(
							$author$project$Extras$Array$appendElement,
							A3($author$project$Extras$Array$mapWithKey, nextSeed, _function, array),
							newMatrix));
				}),
			_Utils_Tuple2(seed, $elm$core$Array$empty),
			matrix).b;
	});
var $author$project$Services$Board$parseBoardItemRow = F4(
	function (hasTileAtCoordinates, row, rowIndex, kanaToColorLookup) {
		return A2(
			$elm$core$Array$indexedMap,
			F2(
				function (columnIndex, _v0) {
					var id = _v0.a;
					var boardItemString = _v0.b;
					return hasTileAtCoordinates(
						_Utils_Tuple2(rowIndex, columnIndex)) ? A4(
						$author$project$Services$Board$parseBoardItemString,
						id,
						boardItemString,
						_Utils_Tuple2(rowIndex, columnIndex),
						kanaToColorLookup) : $elm$core$Maybe$Nothing;
				}),
			row);
	});
var $author$project$Services$Board$parseBoardItems = F3(
	function (hasTileAtCoordinates, kanaToColorLookup, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			F2(
				function (rowIndex, row) {
					return A4($author$project$Services$Board$parseBoardItemRow, hasTileAtCoordinates, row, rowIndex, kanaToColorLookup);
				}),
			matrix);
	});
var $author$project$Services$Board$parseInitialKana = F4(
	function (seed, hasTileAtCoordinates, kanaToColorLookup, initialKanaString) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeString,
			$elm$json$Json$Decode$array(
				$elm$json$Json$Decode$array($elm$json$Json$Decode$string)),
			initialKanaString);
		if (!_v0.$) {
			var boardMatrix = _v0.a;
			return A3(
				$author$project$Services$Board$parseBoardItems,
				hasTileAtCoordinates,
				kanaToColorLookup,
				A3(
					$author$project$Services$Matrix$mapWithKey,
					seed,
					F2(
						function (key, value) {
							return _Utils_Tuple2(
								key,
								$elm$core$Maybe$Just(value));
						}),
					boardMatrix));
		} else {
			return $elm$core$Array$empty;
		}
	});
var $author$project$Services$Board$parseJsonInitialKana = F4(
	function (seed, hasTileAtCoordinates, kanaToColorLookup, initialKanaString) {
		if (!initialKanaString.$) {
			var value = initialKanaString.a;
			return $elm$core$Maybe$Just(
				A4($author$project$Services$Board$parseInitialKana, seed, hasTileAtCoordinates, kanaToColorLookup, value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Decoders$JsonKanaWord$parseJsonKanaToColorLookup = function (jsonKanaToColorLookup) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (lookupItem) {
				return _Utils_Tuple2(lookupItem.bR, lookupItem.cE);
			},
			jsonKanaToColorLookup));
};
var $author$project$Services$Loading$jsonKanaWordToKanaWord = F3(
	function (seed, hasTileAtCoordinates, jsonKanaWord) {
		var kanaToColorLookup = $author$project$Decoders$JsonKanaWord$parseJsonKanaToColorLookup(jsonKanaWord.cG);
		return A6(
			$author$project$Domain$Types$KanaWord,
			jsonKanaWord.bM,
			jsonKanaWord.b2,
			jsonKanaWord.cp,
			A4($author$project$Services$Board$parseJsonInitialKana, seed, hasTileAtCoordinates, kanaToColorLookup, jsonKanaWord.cw),
			jsonKanaWord.cH,
			kanaToColorLookup);
	});
var $author$project$Services$Tile$parseTiles = function (tiles) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		tiles);
	if (!_v0.$) {
		var result = _v0.a;
		return $elm$core$Array$fromList(
			A3(
				$elm$core$List$foldl,
				F2(
					function (intList, newList) {
						return _Utils_ap(
							newList,
							_List_fromArray(
								[
									$elm$core$Array$fromList(intList)
								]));
					}),
				_List_Nil,
				result));
	} else {
		return $elm$core$Array$fromList(_List_Nil);
	}
};
var $author$project$Services$Loading$jsonLevelToLevel = F2(
	function (seed, jsonLevel) {
		var parsedTiles = $author$project$Services$Tile$parseTiles(jsonLevel.dw);
		return {
			b3: jsonLevel.b3,
			cp: jsonLevel.cp,
			cI: A2(
				$elm$core$List$map,
				A2(
					$author$project$Services$Loading$jsonKanaWordToKanaWord,
					seed,
					$author$project$Services$Tile$boardHasTileAt(parsedTiles)),
				jsonLevel.cI),
			cU: jsonLevel.cU,
			cX: jsonLevel.cX,
			c$: jsonLevel.c$,
			du: jsonLevel.du,
			dw: parsedTiles,
			dE: jsonLevel.dE
		};
	});
var $author$project$Services$ImageMatch$resetImageMatchForNextLevel = function (model) {
	return _Utils_update(
		model,
		{ct: $author$project$Services$ImageMatch$init});
};
var $author$project$Services$Score$resetScoreForNextLevel = F2(
	function (highScore, model) {
		return _Utils_update(
			model,
			{
				da: A8($author$project$Domain$Types$Score, 0, 0, 0, false, false, false, 0, highScore)
			});
	});
var $author$project$Services$Loading$updateLevel = F2(
	function (jsonLevel, model) {
		return A2(
			$author$project$Services$Score$resetScoreForNextLevel,
			model.da.cn,
			$author$project$Services$ImageMatch$resetImageMatchForNextLevel(
				_Utils_update(
					model,
					{
						by: 3,
						cK: A2($author$project$Services$Loading$jsonLevelToLevel, model.c4.c7, jsonLevel)
					})));
	});
var $author$project$Services$Time$updateLoadingDuration = 500;
var $author$project$Services$Time$updateLoadingDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$updateLoadingDuration, message);
};
var $author$project$Services$Loading$updateLoadingState = F2(
	function (message, model) {
		var audioModel = model.bC;
		switch (message.$) {
			case 0:
				var levelNumber = message.a;
				return _Utils_Tuple3(
					model,
					A2($author$project$Services$APIClient$loadLevelCommand, model.cW, levelNumber),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				var levelResult = message.a;
				if (!levelResult.$) {
					var jsonLevel = levelResult.a;
					return _Utils_Tuple3(
						$author$project$Services$Kanaword$updateAnimatingKanaData(
							$author$project$Services$Loading$initializeBoardItems(
								A2(
									$author$project$Services$Level$shuffleKanawords,
									model.c4.cJ,
									A2($author$project$Services$Loading$updateLevel, jsonLevel, model)))),
						$elm$core$Platform$Cmd$none,
						$MartinSStewart$elm_audio$Audio$cmdBatch(
							_List_fromArray(
								[
									$author$project$Services$Audio$loadKanawordsAudio(
									A2(
										$elm$core$List$map,
										function (kanaWord) {
											return kanaWord.cp;
										},
										jsonLevel.cI)),
									$author$project$Services$Audio$loadKanaAudio(
									A2(
										$elm$core$List$map,
										function (animatedKanaRecord) {
											return animatedKanaRecord.bB;
										},
										A2(
											$elm$core$List$concatMap,
											function (kanaWord) {
												return $author$project$Services$Kana$toAnimatedKanaList(kanaWord.cH);
											},
											jsonLevel.cI)))
								])));
				} else {
					return _Utils_Tuple3(
						$author$project$Services$Modal$dropDownErrorsModal(
							_Utils_update(
								model,
								{by: 0})),
						$elm$core$Platform$Cmd$none,
						$MartinSStewart$elm_audio$Audio$cmdNone);
				}
			case 2:
				var isFinishedLoadingSounds = $author$project$Services$Loading$soundsFinishedLoading(model);
				return _Utils_Tuple3(
					isFinishedLoadingSounds ? $author$project$Services$Modal$dropDownLevelPreviewModal(
						_Utils_update(
							model,
							{by: 4})) : model,
					isFinishedLoadingSounds ? $elm$core$Platform$Cmd$none : $author$project$Services$Time$updateLoadingDelay(
						$author$project$Domain$Types$LoadingMessage($author$project$Domain$Types$UpdateLoadingState)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				var audioType = message.a;
				var fileName = message.b;
				var result = message.c;
				if (!result.$) {
					var sound = result.a;
					switch (audioType) {
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bC: _Utils_update(
											audioModel,
											{
												dj: A3(
													$elm$core$Dict$insert,
													fileName,
													$author$project$Domain$Types$LoadedAudio(
														{c2: $author$project$Domain$Types$NotPlaying, di: sound}),
													audioModel.dj)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$MartinSStewart$elm_audio$Audio$cmdNone);
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bC: _Utils_update(
											audioModel,
											{
												cF: A3(
													$elm$core$Dict$insert,
													fileName,
													$author$project$Domain$Types$LoadedAudio(
														{c2: $author$project$Domain$Types$NotPlaying, di: sound}),
													audioModel.cF)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$MartinSStewart$elm_audio$Audio$cmdNone);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bC: _Utils_update(
											audioModel,
											{
												dK: A3(
													$elm$core$Dict$insert,
													fileName,
													$author$project$Domain$Types$LoadedAudio(
														{c2: $author$project$Domain$Types$NotPlaying, di: sound}),
													audioModel.dK)
											})
									}),
								$elm$core$Platform$Cmd$none,
								$MartinSStewart$elm_audio$Audio$cmdNone);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $MartinSStewart$elm_audio$Audio$cmdNone);
				}
		}
	});
var $author$project$Services$Settings$isEnabled = F2(
	function (setting, _v0) {
		var settings = _v0.de;
		switch (setting) {
			case 0:
				return settings.a8;
			case 1:
				return settings.aQ;
			case 2:
				return settings.bd;
			default:
				return settings.aF;
		}
	});
var $author$project$Ports$intFromBool = function (boolValue) {
	return boolValue ? 1 : 0;
};
var $author$project$Ports$saveSettingEncoder = F3(
	function (messageTypeString, settingString, settingEnabled) {
		return $author$project$Ports$settingsPortToJS(
			A2(
				$elm$json$Json$Encode$encode,
				0,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Ports$messageTypeKey,
							$elm$json$Json$Encode$string(messageTypeString)),
							_Utils_Tuple2(
							settingString,
							$elm$json$Json$Encode$int(settingEnabled))
						]))));
	});
var $author$project$Ports$saveSetting = F2(
	function (settingEnabled, setting) {
		switch (setting) {
			case 0:
				return A3(
					$author$project$Ports$saveSettingEncoder,
					'saveSoundEffectsEnabled',
					'soundEffectsEnabled',
					$author$project$Ports$intFromBool(settingEnabled));
			case 1:
				return A3(
					$author$project$Ports$saveSettingEncoder,
					'saveMusicEnabled',
					'musicEnabled',
					$author$project$Ports$intFromBool(settingEnabled));
			case 2:
				return A3(
					$author$project$Ports$saveSettingEncoder,
					'saveTextAudioEnabled',
					'textAudioEnabled',
					$author$project$Ports$intFromBool(settingEnabled));
			default:
				return A3(
					$author$project$Ports$saveSettingEncoder,
					'saveHintsEnabled',
					'hintsEnabled',
					$author$project$Ports$intFromBool(settingEnabled));
		}
	});
var $author$project$Services$Settings$toggleHintsInternal = function (settings) {
	return _Utils_update(
		settings,
		{aF: !settings.aF});
};
var $author$project$Services$Settings$toggleHints = function (model) {
	return _Utils_update(
		model,
		{
			de: $author$project$Services$Settings$toggleHintsInternal(model.de)
		});
};
var $author$project$Services$Settings$toggleMusicInternal = function (settings) {
	return _Utils_update(
		settings,
		{aQ: !settings.aQ});
};
var $author$project$Services$Settings$toggleMusic = function (model) {
	return _Utils_update(
		model,
		{
			de: $author$project$Services$Settings$toggleMusicInternal(model.de)
		});
};
var $author$project$Services$Settings$toggleSoundEffectsInternal = function (settings) {
	return _Utils_update(
		settings,
		{a8: !settings.a8});
};
var $author$project$Services$Settings$toggleSoundEffects = function (model) {
	return _Utils_update(
		model,
		{
			de: $author$project$Services$Settings$toggleSoundEffectsInternal(model.de)
		});
};
var $author$project$Services$Settings$toggleTextAudioInternal = function (settings) {
	return _Utils_update(
		settings,
		{bd: !settings.bd});
};
var $author$project$Services$Settings$toggleTextAudio = function (model) {
	return _Utils_update(
		model,
		{
			de: $author$project$Services$Settings$toggleTextAudioInternal(model.de)
		});
};
var $author$project$Services$Settings$toggleSetting = F2(
	function (setting, model) {
		switch (setting) {
			case 0:
				return $author$project$Services$Settings$toggleSoundEffects(model);
			case 1:
				return $author$project$Services$Settings$toggleMusic(model);
			case 2:
				return $author$project$Services$Settings$toggleTextAudio(model);
			default:
				return $author$project$Services$Settings$toggleHints(model);
		}
	});
var $author$project$Services$Settings$updateFromJsonSettings = F2(
	function (_v0, model) {
		var soundEffectsEnabled = _v0.a8;
		var textAudioEnabled = _v0.bd;
		var musicEnabled = _v0.aQ;
		var hintsEnabled = _v0.aF;
		var settings = model.de;
		return _Utils_update(
			model,
			{
				de: _Utils_update(
					settings,
					{
						aF: A2($elm$core$Maybe$withDefault, model.de.aF, hintsEnabled),
						aQ: A2($elm$core$Maybe$withDefault, model.de.aQ, musicEnabled),
						a8: A2($elm$core$Maybe$withDefault, model.de.a8, soundEffectsEnabled),
						bd: A2($elm$core$Maybe$withDefault, model.de.bd, textAudioEnabled)
					})
			});
	});
var $author$project$Services$Score$updateHighScore = F2(
	function (newHighScore, model) {
		var score = model.da;
		return _Utils_update(
			model,
			{
				da: _Utils_update(
					score,
					{
						cn: $elm$core$String$toInt(newHighScore)
					})
			});
	});
var $author$project$Services$LocalStorage$updateLocalStorageState = F2(
	function (message, model) {
		switch (message.$) {
			case 0:
				var score = message.a;
				return _Utils_Tuple3(
					A2($author$project$Services$Score$updateHighScore, score, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				var jsonSettings = message.a;
				return _Utils_Tuple3(
					A2($author$project$Services$Settings$updateFromJsonSettings, jsonSettings, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				var setting = message.a;
				var updatedModel = A2($author$project$Services$Settings$toggleSetting, setting, model);
				return _Utils_Tuple3(
					updatedModel,
					A2(
						$author$project$Ports$saveSetting,
						A2($author$project$Services$Settings$isEnabled, setting, updatedModel),
						setting),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$LoadLevel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Types$ModalMessage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Types$PlayLevelClickedAndDismissed = {$: 3};
var $author$project$Services$Modal$decrementImageIndex = function (levelModalState) {
	return (levelModalState.cr > 0) ? (levelModalState.cr - 1) : 3;
};
var $author$project$Services$Modal$dismissDefeatModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{b_: 1})
		});
};
var $author$project$Services$Modal$dismissErrorModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{b4: 1})
		});
};
var $author$project$Services$Modal$dismissModal = function (modalState) {
	return _Utils_update(
		modalState,
		{aO: 1});
};
var $author$project$Services$Modal$dismissLevelModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{
					cM: $author$project$Services$Modal$dismissModal(modals.cM)
				})
		});
};
var $author$project$Services$Time$dismissModalDuration = 350;
var $author$project$Services$Time$dismissModalDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$dismissModalDuration, message);
};
var $author$project$Services$Modal$dismissSettingsModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{df: 1})
		});
};
var $author$project$Services$Modal$dismissVictoryModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{dH: 1})
		});
};
var $author$project$Services$Modal$dropDownVictoryModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{dH: 0})
		});
};
var $author$project$Services$Modal$incrementImageIndex = function (levelModalState) {
	return (levelModalState.cr < 3) ? (levelModalState.cr + 1) : 0;
};
var $author$project$Services$Audio$kanawordPlayAudioCommandByImageID = function (id) {
	return $author$project$Extras$Task$toCommandMessage(
		$author$project$Services$Audio$kanawordPlayAudioMessageByImageID(id));
};
var $author$project$Services$Modal$resetLevelCompleteNotification = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{cL: 1})
		});
};
var $author$project$Ports$saveHighScoreEncoder = function (_v0) {
	var levelID = _v0.a;
	var highScore = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Ports$messageTypeKey,
				$elm$json$Json$Encode$string('saveScoreByLevelID')),
				_Utils_Tuple2(
				$elm$core$String$fromInt(levelID),
				$elm$json$Json$Encode$int(highScore))
			]));
};
var $author$project$Ports$saveHighScore = function (_v0) {
	var level = _v0.cK;
	var score = _v0.da;
	return $author$project$Ports$highScoresPortToJS(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Ports$saveHighScoreEncoder(
				_Utils_Tuple2(level.cp, score.cf))));
};
var $author$project$Services$Modal$toggleModalStatus = function (modalStatus) {
	return (!modalStatus) ? 1 : 0;
};
var $author$project$Services$Modal$toggleSettingsModal = function (model) {
	var modals = model.cQ;
	return _Utils_update(
		model,
		{
			cQ: _Utils_update(
				modals,
				{
					df: $author$project$Services$Modal$toggleModalStatus(model.cQ.df)
				})
		});
};
var $author$project$Services$Modal$newImageIndex = F2(
	function (newIndex, levelModalState) {
		return _Utils_update(
			levelModalState,
			{cr: newIndex});
	});
var $author$project$Services$Modal$updateImageIndex = F2(
	function (newIndex, model) {
		var modals = model.cQ;
		return _Utils_update(
			model,
			{
				cQ: _Utils_update(
					modals,
					{
						cM: A2($author$project$Services$Modal$newImageIndex, newIndex, modals.cM)
					})
			});
	});
var $author$project$Services$Modal$updateModalState = F2(
	function (modalMessage, model) {
		switch (modalMessage.$) {
			case 0:
				return _Utils_Tuple3(
					$author$project$Services$Modal$toggleSettingsModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 10:
				return _Utils_Tuple3(
					A2(
						$author$project$Services$Modal$updateImageIndex,
						$author$project$Services$Modal$decrementImageIndex(model.cQ.cM),
						model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 9:
				return _Utils_Tuple3(
					A2(
						$author$project$Services$Modal$updateImageIndex,
						$author$project$Services$Modal$incrementImageIndex(model.cQ.cM),
						model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 8:
				var imageID = modalMessage.a;
				return _Utils_Tuple3(
					model,
					$author$project$Services$Audio$kanawordPlayAudioCommandByImageID(imageID),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 4:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissVictoryModal(model),
					$author$project$Services$Time$dismissModalDelay(
						$author$project$Domain$Types$LoadingMessage(
							$author$project$Domain$Types$LoadLevel(model.cK.cp + 1))),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				var levelID = modalMessage.a;
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissErrorModal(model),
					$author$project$Services$Time$dismissModalDelay(
						$author$project$Domain$Types$LoadingMessage(
							$author$project$Domain$Types$LoadLevel(levelID))),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 2:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissLevelModal(model),
					$author$project$Services$Time$dismissModalDelay(
						$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$PlayLevelClickedAndDismissed)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 3:
				return _Utils_Tuple3(
					A2(
						$author$project$Services$Modal$updateImageIndex,
						0,
						_Utils_update(
							model,
							{by: 5})),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 5:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissDefeatModal(model),
					$author$project$Services$Time$dismissModalDelay(
						$author$project$Domain$Types$LoadingMessage(
							$author$project$Domain$Types$LoadLevel(model.cK.cp))),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 7:
				var index = modalMessage.a;
				return _Utils_Tuple3(
					A2($author$project$Services$Modal$updateImageIndex, index, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 6:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissSettingsModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 12:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissLevelModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 11:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissSettingsModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 15:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissVictoryModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 13:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissDefeatModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 14:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dismissErrorModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dropDownVictoryModal(
						$author$project$Services$Modal$resetLevelCompleteNotification(model)),
					$author$project$Ports$saveHighScore(model),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Services$Random$updateImageMatchSeed = F2(
	function (randomNumber, model) {
		var randomSeeds = model.c4;
		return _Utils_update(
			model,
			{
				c4: _Utils_update(
					randomSeeds,
					{
						cs: $elm$random$Random$initialSeed(randomNumber)
					})
			});
	});
var $author$project$Services$Random$updateKanawordSeed = F2(
	function (randomNumber, model) {
		var randomSeeds = model.c4;
		return _Utils_update(
			model,
			{
				c4: _Utils_update(
					randomSeeds,
					{
						cJ: $elm$random$Random$initialSeed(randomNumber)
					})
			});
	});
var $author$project$Services$Random$updateRefillSeed = F2(
	function (randomNumber, model) {
		var randomSeeds = model.c4;
		return _Utils_update(
			model,
			{
				c4: _Utils_update(
					randomSeeds,
					{
						c7: $elm$random$Random$initialSeed(randomNumber)
					})
			});
	});
var $author$project$Services$Random$updateShuffleSeed = F2(
	function (randomNumber, model) {
		var randomSeeds = model.c4;
		return _Utils_update(
			model,
			{
				c4: _Utils_update(
					randomSeeds,
					{
						a5: $elm$random$Random$initialSeed(randomNumber)
					})
			});
	});
var $author$project$Services$Random$updateRandomSeeds = F3(
	function (message, randomNumber, model) {
		switch (message.$) {
			case 0:
				return _Utils_Tuple3(
					A2($author$project$Services$Random$updateKanawordSeed, randomNumber, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				var command = message.a;
				return _Utils_Tuple3(
					A2($author$project$Services$Random$updateRefillSeed, randomNumber, model),
					command,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 2:
				return _Utils_Tuple3(
					A2($author$project$Services$Random$updateShuffleSeed, randomNumber, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				return _Utils_Tuple3(
					A2($author$project$Services$Random$updateImageMatchSeed, randomNumber, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Services$Score$updateScoreStarAnimations = function (model) {
	var score = model.da;
	return _Utils_update(
		model,
		{
			da: _Utils_update(
				score,
				{
					br: _Utils_cmp(score.cf, model.cK.c$) > -1,
					bs: score.bt && (_Utils_cmp(score.cf, model.cK.du) > -1),
					bt: score.br && (_Utils_cmp(score.cf, model.cK.dE) > -1)
				})
		});
};
var $author$project$Domain$Types$AnimateFromCenter = 3;
var $author$project$Domain$Types$FinishedMovingToCenter = 2;
var $author$project$Domain$Types$HideBanner = 5;
var $author$project$Domain$Types$HidingBanner = 4;
var $author$project$Domain$Types$MovingFromCenter = 1;
var $author$project$Domain$Types$MovingToCenter = 0;
var $author$project$Domain$Types$ShuffleMessage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Time$shuffleItemsFromCenterDuration = 1250;
var $author$project$Services$Time$animateShuffleItemsFromCenterDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$shuffleItemsFromCenterDuration, message);
};
var $author$project$Services$Time$shuffleItemsToCenterDuration = 750;
var $author$project$Services$Time$animateShuffleItemsToCenterDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$shuffleItemsToCenterDuration, message);
};
var $author$project$Services$Time$performShuffleDuration = 10;
var $author$project$Services$Time$performShuffleDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$performShuffleDuration, message);
};
var $author$project$Services$Shuffle$isInvalidRandomLocation = F3(
	function (coordinates, randomCoordinates, hasTileAt) {
		return _Utils_eq(coordinates, randomCoordinates) || (!hasTileAt(randomCoordinates));
	});
var $author$project$Services$Shuffle$getRandomLocationFrom = F4(
	function (randomSeed, hasTileAt, coordinates, boardItems) {
		var _v0 = A2(
			$elm$random$Random$step,
			A2(
				$elm$random$Random$int,
				0,
				$elm$core$Array$length(boardItems) - 1),
			randomSeed);
		var randomRow = _v0.a;
		var nextSeed = _v0.b;
		var _v1 = A2(
			$elm$random$Random$step,
			A2(
				$elm$random$Random$int,
				0,
				$elm$core$Array$length(boardItems) - 1),
			nextSeed);
		var randomColumn = _v1.a;
		var nextNextSeed = _v1.b;
		return A3(
			$author$project$Services$Shuffle$isInvalidRandomLocation,
			coordinates,
			_Utils_Tuple2(randomRow, randomColumn),
			hasTileAt) ? A4($author$project$Services$Shuffle$getRandomLocationFrom, nextNextSeed, hasTileAt, coordinates, boardItems) : _Utils_Tuple2(
			_Utils_Tuple2(randomRow, randomColumn),
			nextNextSeed);
	});
var $author$project$Services$Shuffle$swapIfNoChains = F2(
	function (swap, matrix) {
		return $elm$core$List$isEmpty(
			$author$project$Services$Chain$detectThreeInALineChains(
				A2($author$project$Services$Swap$performSwap, swap, matrix))) ? A2($author$project$Services$Swap$performSwap, swap, matrix) : matrix;
	});
var $author$project$Services$Shuffle$shuffleBoardItems = F3(
	function (randomSeed, hasTileAt, boardItems) {
		return A3(
			$author$project$Services$Matrix$foldLeft,
			F3(
				function (coordinates, _v0, _v1) {
					var matrix = _v0.a;
					var seed = _v0.b;
					var _v2 = A4($author$project$Services$Shuffle$getRandomLocationFrom, seed, hasTileAt, coordinates, matrix);
					var randomCoordinates = _v2.a;
					var nextSeed = _v2.b;
					return (!hasTileAt(coordinates)) ? _Utils_Tuple2(matrix, randomSeed) : _Utils_Tuple2(
						A2(
							$author$project$Services$Shuffle$swapIfNoChains,
							_Utils_Tuple2(coordinates, randomCoordinates),
							matrix),
						nextSeed);
				}),
			_Utils_Tuple2(boardItems, randomSeed),
			boardItems).a;
	});
var $author$project$Services$Shuffle$performShuffleInternal = F2(
	function (seed, model) {
		var swapState = model.ds;
		var shuffledBoard = A3(
			$author$project$Services$Shuffle$shuffleBoardItems,
			seed,
			$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
			model.bG);
		return _Utils_update(
			model,
			{
				bG: shuffledBoard,
				ds: _Utils_update(
					swapState,
					{
						c3: A2(
							$author$project$Services$Swap$detectAllSwaps,
							$author$project$Services$Tile$boardHasTileAt(model.cK.dw),
							shuffledBoard)
					})
			});
	});
var $author$project$Services$Shuffle$resetShuffleState = function (model) {
	var shuffle = model.a5;
	return _Utils_update(
		model,
		{
			a5: _Utils_update(
				shuffle,
				{dh: 2})
		});
};
var $author$project$Services$Shuffle$updateShuffleState = F2(
	function (shuffleMessage, model) {
		var shuffle = model.a5;
		var randomSeeds = model.c4;
		switch (shuffleMessage) {
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a5: _Utils_update(
								shuffle,
								{dh: 3})
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a5: _Utils_update(
								shuffle,
								{dh: 0})
						}),
					$author$project$Services$Time$animateShuffleItemsToCenterDelay(
						$author$project$Domain$Types$ShuffleMessage(2)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 2:
				return _Utils_Tuple3(
					A2($author$project$Services$Shuffle$performShuffleInternal, randomSeeds.a5, model),
					$author$project$Services$Time$performShuffleDelay(
						$author$project$Domain$Types$ShuffleMessage(3)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a5: _Utils_update(
								shuffle,
								{dh: 1})
						}),
					$author$project$Services$Time$animateShuffleItemsFromCenterDelay(
						$author$project$Domain$Types$ShuffleMessage(5)),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a5: _Utils_update(
								shuffle,
								{dh: 4})
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				return _Utils_Tuple3(
					$author$project$Services$Shuffle$resetShuffleState(model),
					A2(
						$elm$random$Random$generate,
						$author$project$Domain$Types$RandomMessage($author$project$Domain$Types$ShuffleSeed),
						$author$project$Extras$Random$anyInt),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Domain$Types$InvalidDragSwapFinished = {$: 2};
var $author$project$Services$Time$invalidDragSwapDuration = 500;
var $author$project$Services$Time$invalidDragDelay = function (message) {
	return A2($author$project$Services$Time$delay, $author$project$Services$Time$invalidDragSwapDuration, message);
};
var $author$project$Services$Audio$invalidSwapSoundCommand = function (model) {
	var settings = model.de;
	return (settings.a8 && (!_Utils_eq(model.ds.cy, $elm$core$Maybe$Nothing))) ? $author$project$Services$Audio$toPlayAudioCommand($author$project$Services$Audio$invalidSwap) : $elm$core$Platform$Cmd$none;
};
var $author$project$Domain$Types$BoardItemsSwapped = 0;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Services$Dimensions$numericalTileWidthAndHeight = function (deviceClass) {
	switch (deviceClass) {
		case 0:
			return 42;
		case 1:
			return 48;
		case 2:
			return 50;
		default:
			return 60;
	}
};
var $author$project$Services$Swap$mouseUpCommand = function (_v0) {
	var device = _v0.b$;
	var inputState = _v0.cx;
	var swapState = _v0.ds;
	var tileWidthAndHeight = $author$project$Services$Dimensions$numericalTileWidthAndHeight(device.bP);
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var deltaX = _v1.a;
				var deltaY = _v1.b;
				return (!_Utils_eq(swapState.cz, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
					$author$project$Services$Time$invalidDragDelay(
						$author$project$Domain$Types$SwapMessage($author$project$Domain$Types$InvalidDragSwapFinished))) : (((_Utils_cmp(
					$elm$core$Basics$abs(deltaX),
					tileWidthAndHeight) > -1) || (_Utils_cmp(
					$elm$core$Basics$abs(deltaY),
					tileWidthAndHeight) > -1)) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Services$Time$delay,
						1,
						$author$project$Domain$Types$BoardMessage(0))) : $elm$core$Maybe$Just($elm$core$Platform$Cmd$none));
			},
			inputState.cR));
};
var $author$project$Services$Swap$dragSensitivity = 3;
var $author$project$Services$Swap$assignFirstSwapCoordinates = F2(
	function (coordinates, model) {
		var swapState = model.ds;
		var _v0 = model.cx.cR;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var deltaX = _v1.a;
			var deltaY = _v1.b;
			return ((_Utils_cmp(
				$elm$core$Basics$abs(deltaX),
				$author$project$Services$Swap$dragSensitivity) < 1) && (_Utils_cmp(
				$elm$core$Basics$abs(deltaY),
				$author$project$Services$Swap$dragSensitivity) < 1)) ? _Utils_update(
				model,
				{
					ds: _Utils_update(
						swapState,
						{
							cd: $elm$core$Maybe$Just(coordinates),
							db: $elm$core$Maybe$Nothing
						})
				}) : model;
		} else {
			return _Utils_update(
				model,
				{
					ds: _Utils_update(
						swapState,
						{
							cd: $elm$core$Maybe$Just(coordinates),
							db: $elm$core$Maybe$Nothing
						})
				});
		}
	});
var $author$project$Services$Swap$disableBoardClickEvents = function (model) {
	return _Utils_update(
		model,
		{cA: true, cC: false});
};
var $author$project$Services$Matrix$above = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return _Utils_Tuple2(row - 1, column);
};
var $author$project$Services$Matrix$leftOf = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return _Utils_Tuple2(row, column - 1);
};
var $author$project$Services$Matrix$isNextTo = F2(
	function (firstCoordinates, secondCoordinates) {
		return A2(
			$elm$core$List$member,
			secondCoordinates,
			_List_fromArray(
				[
					$author$project$Services$Matrix$leftOf(firstCoordinates),
					$author$project$Services$Matrix$rightOf(firstCoordinates),
					$author$project$Services$Matrix$above(firstCoordinates),
					$author$project$Services$Matrix$below(firstCoordinates)
				]));
	});
var $author$project$Services$Swap$resetSelectedCoordinates = function (model) {
	var swapState = model.ds;
	return _Utils_update(
		model,
		{
			ds: _Utils_update(
				swapState,
				{cd: $elm$core$Maybe$Nothing, db: $elm$core$Maybe$Nothing})
		});
};
var $author$project$Services$Swap$setInvalidSwap = F3(
	function (firstCoordinates, secondCoordinates, model) {
		var swapState = model.ds;
		return _Utils_update(
			model,
			{
				ds: _Utils_update(
					swapState,
					{
						cy: $elm$core$Maybe$Just(
							_Utils_Tuple2(firstCoordinates, secondCoordinates))
					})
			});
	});
var $author$project$Services$Swap$setSwap = F3(
	function (firstCoordinates, secondCoordinates, model) {
		var swapState = model.ds;
		return _Utils_update(
			model,
			{
				ds: _Utils_update(
					swapState,
					{
						dr: $elm$core$Maybe$Just(
							_Utils_Tuple2(firstCoordinates, secondCoordinates))
					})
			});
	});
var $author$project$Services$Swap$assignSecondSwapCoordinates = F3(
	function (secondCoordinates, firstCoordinates, model) {
		var _v0 = _Utils_Tuple3(
			A2($author$project$Services$Tile$hasTileAtCoordinates, firstCoordinates, model.cK.dw) && A2($author$project$Services$Tile$hasTileAtCoordinates, secondCoordinates, model.cK.dw),
			A2($author$project$Services$Matrix$isNextTo, firstCoordinates, secondCoordinates),
			A2(
				$author$project$Services$Swap$isValidSwap,
				_Utils_Tuple2(firstCoordinates, secondCoordinates),
				model.ds.c3));
		_v0$3:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					if (_v0.c) {
						return $author$project$Services$Swap$disableBoardClickEvents(
							A3(
								$author$project$Services$Swap$setSwap,
								firstCoordinates,
								secondCoordinates,
								$author$project$Services$Swap$resetSelectedCoordinates(model)));
					} else {
						return $author$project$Services$Swap$disableBoardClickEvents(
							A3(
								$author$project$Services$Swap$setInvalidSwap,
								firstCoordinates,
								secondCoordinates,
								$author$project$Services$Swap$resetSelectedCoordinates(model)));
					}
				} else {
					if (!_v0.c) {
						return A2($author$project$Services$Swap$assignFirstSwapCoordinates, secondCoordinates, model);
					} else {
						break _v0$3;
					}
				}
			} else {
				break _v0$3;
			}
		}
		return $author$project$Services$Swap$resetSelectedCoordinates(model);
	});
var $author$project$Services$Swap$processClickedCoordinates = F2(
	function (coordinates, model) {
		var _v0 = _Utils_Tuple2(model.ds.cd, model.ds.db);
		if (!_v0.a.$) {
			if (_v0.b.$ === 1) {
				var firstCoordinates = _v0.a.a;
				var _v3 = _v0.b;
				return A3($author$project$Services$Swap$assignSecondSwapCoordinates, coordinates, firstCoordinates, model);
			} else {
				return A2($author$project$Services$Swap$assignFirstSwapCoordinates, coordinates, model);
			}
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return A2($author$project$Services$Swap$assignFirstSwapCoordinates, coordinates, model);
			} else {
				var _v4 = _v0.a;
				return $author$project$Services$Swap$resetSelectedCoordinates(model);
			}
		}
	});
var $author$project$Services$Swap$mouseDragSensitivity = 25;
var $author$project$Services$Swap$inputStateToSwap = F3(
	function (inputDirectionFunction, directionFunction, model) {
		var swapState = model.ds;
		var _v0 = model.cx.cS;
		if (!_v0.$) {
			var firstCoordinates = _v0.a;
			var swap = _Utils_Tuple2(
				firstCoordinates,
				directionFunction(firstCoordinates));
			return (A2(inputDirectionFunction, $author$project$Services$Swap$mouseDragSensitivity, model.cx) && A2($author$project$Services$Swap$isValidSwap, swap, model.ds.c3)) ? $author$project$Services$Swap$disableBoardClickEvents(
				_Utils_update(
					model,
					{
						ds: _Utils_update(
							swapState,
							{
								dr: $elm$core$Maybe$Just(swap)
							})
					})) : (A2(inputDirectionFunction, $author$project$Services$Swap$dragSensitivity, model.cx) ? $author$project$Services$Swap$disableBoardClickEvents(
				_Utils_update(
					model,
					{
						ds: _Utils_update(
							swapState,
							{
								cz: $elm$core$Maybe$Just(swap)
							})
					})) : model);
		} else {
			return model;
		}
	});
var $author$project$Services$Input$isDownSwap = F2(
	function (sensitivity, _v0) {
		var mouseDelta = _v0.cR;
		if (!mouseDelta.$) {
			var _v2 = mouseDelta.a;
			var deltaX = _v2.a;
			var deltaY = _v2.b;
			return (_Utils_cmp(
				$elm$core$Basics$abs(deltaY),
				$elm$core$Basics$abs(deltaX)) > 0) && (_Utils_cmp(deltaY, sensitivity) > 0);
		} else {
			return false;
		}
	});
var $author$project$Services$Input$isLeftSwap = F2(
	function (sensitivity, _v0) {
		var mouseDelta = _v0.cR;
		if (!mouseDelta.$) {
			var _v2 = mouseDelta.a;
			var deltaX = _v2.a;
			var deltaY = _v2.b;
			return (_Utils_cmp(
				$elm$core$Basics$abs(deltaX),
				$elm$core$Basics$abs(deltaY)) > 0) && ((deltaX < 0) && (_Utils_cmp(
				$elm$core$Basics$abs(deltaX),
				sensitivity) > 0));
		} else {
			return false;
		}
	});
var $author$project$Services$Input$isRightSwap = F2(
	function (sensitivity, _v0) {
		var mouseDelta = _v0.cR;
		if (!mouseDelta.$) {
			var _v2 = mouseDelta.a;
			var deltaX = _v2.a;
			var deltaY = _v2.b;
			return (_Utils_cmp(
				$elm$core$Basics$abs(deltaX),
				$elm$core$Basics$abs(deltaY)) > 0) && (_Utils_cmp(deltaX, sensitivity) > 0);
		} else {
			return false;
		}
	});
var $author$project$Services$Input$isUpSwap = F2(
	function (sensitivity, _v0) {
		var mouseDelta = _v0.cR;
		if (!mouseDelta.$) {
			var _v2 = mouseDelta.a;
			var deltaX = _v2.a;
			var deltaY = _v2.b;
			return (_Utils_cmp(
				$elm$core$Basics$abs(deltaY),
				$elm$core$Basics$abs(deltaX)) > 0) && ((deltaY < 0) && (_Utils_cmp(
				$elm$core$Basics$abs(deltaY),
				sensitivity) > 0));
		} else {
			return false;
		}
	});
var $author$project$Services$Swap$processFinishedMouseDrag = function (model) {
	return A3(
		$author$project$Services$Swap$inputStateToSwap,
		$author$project$Services$Input$isRightSwap,
		$author$project$Services$Matrix$rightOf,
		A3(
			$author$project$Services$Swap$inputStateToSwap,
			$author$project$Services$Input$isLeftSwap,
			$author$project$Services$Matrix$leftOf,
			A3(
				$author$project$Services$Swap$inputStateToSwap,
				$author$project$Services$Input$isDownSwap,
				$author$project$Services$Matrix$below,
				A3($author$project$Services$Swap$inputStateToSwap, $author$project$Services$Input$isUpSwap, $author$project$Services$Matrix$above, model))));
};
var $author$project$Services$Input$updateIsDragging = F2(
	function (isDragging, model) {
		var inputState = model.cx;
		return _Utils_update(
			model,
			{
				cx: _Utils_update(
					inputState,
					{cB: isDragging})
			});
	});
var $author$project$Services$Swap$processMouseDrag = function (model) {
	var tileWidthAndHeight = $author$project$Services$Dimensions$numericalTileWidthAndHeight(model.b$.bP);
	return A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var deltaX = _v0.a;
				var deltaY = _v0.b;
				return ((_Utils_cmp(
					$elm$core$Basics$abs(deltaX),
					tileWidthAndHeight) > -1) || (_Utils_cmp(
					$elm$core$Basics$abs(deltaY),
					tileWidthAndHeight) > -1)) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Services$Input$updateIsDragging,
						false,
						$author$project$Services$Swap$processFinishedMouseDrag(model))) : $elm$core$Maybe$Just(model);
			},
			model.cx.cR));
};
var $author$project$Services$Tile$isEmptyTile = function (number) {
	return !$author$project$Services$Tile$hasTile(number);
};
var $author$project$Services$Tile$isBlankTileAt = F2(
	function (_v0, tiles) {
		var row = _v0.a;
		var column = _v0.b;
		return $author$project$Services$Tile$isEmptyTile(
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Array$get(column),
				A2($elm$core$Array$get, row, tiles)));
	});
var $author$project$Services$Swap$isSwapToBlankTile = F2(
	function (_v0, model) {
		var firstCoordinates = _v0.a;
		var secondCoordinates = _v0.b;
		return A2($author$project$Services$Tile$isBlankTileAt, firstCoordinates, model.cK.dw) || A2($author$project$Services$Tile$isBlankTileAt, secondCoordinates, model.cK.dw);
	});
var $author$project$Services$Swipe$isTap = function (gesture) {
	if (gesture.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Services$Swipe$EndGesture = function (a) {
	return {$: 3, a: a};
};
var $author$project$Services$Swipe$EndTap = function (a) {
	return {$: 4, a: a};
};
var $author$project$Services$Swipe$Moved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Services$Swipe$Started = function (a) {
	return {$: 1, a: a};
};
var $author$project$Services$Swipe$addToTrail = F2(
	function (coordinate, _v0) {
		var from = _v0.M;
		var to = _v0.Q;
		var through = _v0.ak;
		return {
			M: from,
			ak: A2($elm$core$List$cons, to, through),
			Q: coordinate
		};
	});
var $author$project$Services$Swipe$record = F2(
	function (_v0, gesture) {
		var eventType = _v0.a;
		var coordinate = _v0.b;
		var _v1 = _Utils_Tuple2(eventType, gesture);
		switch (_v1.a) {
			case 0:
				var _v2 = _v1.a;
				return $author$project$Services$Swipe$Started(coordinate);
			case 1:
				switch (_v1.b.$) {
					case 1:
						var _v3 = _v1.a;
						var prev = _v1.b.a;
						return $author$project$Services$Swipe$Moved(
							{M: prev, ak: _List_Nil, Q: coordinate});
					case 2:
						var _v4 = _v1.a;
						var trail = _v1.b.a;
						return $author$project$Services$Swipe$Moved(
							A2($author$project$Services$Swipe$addToTrail, coordinate, trail));
					default:
						var _v5 = _v1.a;
						return $author$project$Services$Swipe$Started(coordinate);
				}
			default:
				if (_v1.b.$ === 2) {
					var _v6 = _v1.a;
					var trail = _v1.b.a;
					return $author$project$Services$Swipe$EndGesture(
						A2($author$project$Services$Swipe$addToTrail, coordinate, trail));
				} else {
					var _v7 = _v1.a;
					return $author$project$Services$Swipe$EndTap(coordinate);
				}
		}
	});
var $author$project$Services$Swipe$deltaY = function (gesture) {
	if (gesture.$ === 3) {
		var from = gesture.a.M;
		var to = gesture.a.Q;
		return $elm$core$Maybe$Just(to.bm - from.bm);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Swipe$isSwipeType = F2(
	function (delta, predicate) {
		return A2(
			$elm$core$Basics$composeR,
			delta,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(predicate),
				$elm$core$Maybe$withDefault(false)));
	});
var $author$project$Services$Swipe$isDownSwipe = function (sensitivity) {
	return A2(
		$author$project$Services$Swipe$isSwipeType,
		$author$project$Services$Swipe$deltaY,
		function (dY) {
			return _Utils_cmp(dY, sensitivity) > -1;
		});
};
var $author$project$Services$Swipe$deltaX = function (gesture) {
	if (gesture.$ === 3) {
		var from = gesture.a.M;
		var to = gesture.a.Q;
		return $elm$core$Maybe$Just(to.bl - from.bl);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Services$Swipe$isLeftSwipe = function (sensitivity) {
	return A2(
		$author$project$Services$Swipe$isSwipeType,
		$author$project$Services$Swipe$deltaX,
		function (dX) {
			return _Utils_cmp(dX, -sensitivity) < 1;
		});
};
var $author$project$Services$Swipe$isRightSwipe = function (sensitivity) {
	return A2(
		$author$project$Services$Swipe$isSwipeType,
		$author$project$Services$Swipe$deltaX,
		function (dX) {
			return _Utils_cmp(dX, sensitivity) > -1;
		});
};
var $author$project$Services$Swipe$isUpSwipe = function (sensitivity) {
	return A2(
		$author$project$Services$Swipe$isSwipeType,
		$author$project$Services$Swipe$deltaY,
		function (dY) {
			return _Utils_cmp(dY, -sensitivity) < 1;
		});
};
var $author$project$Services$Swap$swipeSensitivity = 25;
var $author$project$Services$Swap$swipeToSwap = F3(
	function (row, column, gesture) {
		return A2($author$project$Services$Swipe$isDownSwipe, $author$project$Services$Swap$swipeSensitivity, gesture) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_Tuple2(row, column),
				_Utils_Tuple2(row + 1, column))) : (A2($author$project$Services$Swipe$isUpSwipe, $author$project$Services$Swap$swipeSensitivity, gesture) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_Tuple2(row, column),
				_Utils_Tuple2(row - 1, column))) : (A2($author$project$Services$Swipe$isLeftSwipe, $author$project$Services$Swap$swipeSensitivity, gesture) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_Tuple2(row, column - 1),
				_Utils_Tuple2(row, column))) : (A2($author$project$Services$Swipe$isRightSwipe, $author$project$Services$Swap$swipeSensitivity, gesture) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				_Utils_Tuple2(row, column + 1),
				_Utils_Tuple2(row, column))) : $elm$core$Maybe$Nothing)));
	});
var $author$project$Services$Swap$processSwipe = F4(
	function (row, column, touch, model) {
		var swapState = model.ds;
		return $author$project$Services$Swipe$isTap(
			A2($author$project$Services$Swipe$record, touch, model.cg)) ? A2(
			$author$project$Services$Swap$processClickedCoordinates,
			_Utils_Tuple2(row, column),
			model) : A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$andThen,
				function (swapValue) {
					return A2($author$project$Services$Swap$isSwapToBlankTile, swapValue, model) ? $elm$core$Maybe$Just(model) : (A2($author$project$Services$Swap$isValidSwap, swapValue, model.ds.c3) ? $elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								cg: $author$project$Services$Swipe$blanco,
								ds: _Utils_update(
									swapState,
									{
										dr: $elm$core$Maybe$Just(swapValue)
									})
							})) : $elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								cg: $author$project$Services$Swipe$blanco,
								ds: _Utils_update(
									swapState,
									{
										cy: $elm$core$Maybe$Just(swapValue)
									})
							})));
				},
				A3(
					$author$project$Services$Swap$swipeToSwap,
					row,
					column,
					A2($author$project$Services$Swipe$record, touch, model.cg))));
	});
var $author$project$Services$Input$minimumDragDelta = 3;
var $author$project$Services$Input$updateMouseDelta = F3(
	function (clientX, clientY, model) {
		var inputState = model.cx;
		var swapState = model.ds;
		var _v0 = inputState.cT;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var mouseDownX = _v1.a;
			var mouseDownY = _v1.b;
			return _Utils_update(
				model,
				{
					cx: _Utils_update(
						inputState,
						{
							cR: $elm$core$Maybe$Just(
								_Utils_Tuple2(clientX - mouseDownX, clientY - mouseDownY))
						}),
					ds: _Utils_update(
						swapState,
						{
							cd: ((_Utils_cmp(
								$elm$core$Basics$abs(clientX - mouseDownX),
								$author$project$Services$Input$minimumDragDelta) > 0) || (_Utils_cmp(
								$elm$core$Basics$abs(clientY - mouseDownY),
								$author$project$Services$Input$minimumDragDelta) > 0)) ? $elm$core$Maybe$Nothing : swapState.cd
						})
				});
		} else {
			return model;
		}
	});
var $author$project$Services$Input$updateMouseDown = F4(
	function (coordinates, clientX, clientY, model) {
		var inputState = model.cx;
		return _Utils_update(
			model,
			{
				cx: _Utils_update(
					inputState,
					{
						cB: true,
						cR: $elm$core$Maybe$Just(
							_Utils_Tuple2(0, 0)),
						cS: $elm$core$Maybe$Just(coordinates),
						cT: $elm$core$Maybe$Just(
							_Utils_Tuple2(clientX, clientY))
					})
			});
	});
var $author$project$Services$Level$decrementMoves = function (level) {
	return _Utils_update(
		level,
		{cU: level.cU - 1});
};
var $author$project$Services$Swap$updateMovesCount = function (model) {
	return (!_Utils_eq(model.ds.dr, $elm$core$Maybe$Nothing)) ? _Utils_update(
		model,
		{
			cK: $author$project$Services$Level$decrementMoves(model.cK)
		}) : model;
};
var $author$project$Services$Swap$updateSwapState = F2(
	function (message, model) {
		var swapState = model.ds;
		var inputState = model.cx;
		switch (message.$) {
			case 0:
				var coordinates = message.a;
				var newModel = $author$project$Services$Time$refreshIdleTime(
					$author$project$Services$Swap$updateMovesCount(
						A2($author$project$Services$Swap$processClickedCoordinates, coordinates, model)));
				return _Utils_Tuple3(
					newModel,
					$author$project$Services$Audio$invalidSwapSoundCommand(newModel),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cx: _Utils_update(
								inputState,
								{cR: $elm$core$Maybe$Nothing}),
							cA: false,
							ds: _Utils_update(
								swapState,
								{cy: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cA: false,
							ds: _Utils_update(
								swapState,
								{cz: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 3:
				var touch = message.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cg: A2($author$project$Services$Swipe$record, touch, model.cg)
						}),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 4:
				var row = message.a;
				var column = message.b;
				var touch = message.c;
				return _Utils_Tuple3(
					$author$project$Services$Swap$updateMovesCount(
						A4($author$project$Services$Swap$processSwipe, row, column, touch, model)),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 5:
				var coordinates = message.a;
				var clientX = message.b;
				var clientY = message.c;
				return _Utils_Tuple3(
					A4($author$project$Services$Input$updateMouseDown, coordinates, clientX, clientY, model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 6:
				var clientX = message.a;
				var clientY = message.b;
				var updatedModel = $author$project$Services$Swap$updateMovesCount(
					$author$project$Services$Swap$processMouseDrag(
						A3(
							$author$project$Services$Input$updateMouseDelta,
							clientX,
							clientY,
							A2($author$project$Services$Input$updateIsDragging, true, model))));
				return _Utils_Tuple3(
					updatedModel,
					(!_Utils_eq(updatedModel.ds.cz, $elm$core$Maybe$Nothing)) ? $author$project$Services$Time$invalidDragDelay(
						$author$project$Domain$Types$SwapMessage($author$project$Domain$Types$InvalidDragSwapFinished)) : $elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				var clientX = message.a;
				var clientY = message.b;
				var updateModel = $author$project$Services$Swap$updateMovesCount(
					$author$project$Services$Swap$processFinishedMouseDrag(
						A3(
							$author$project$Services$Input$updateMouseDelta,
							clientX,
							clientY,
							A2($author$project$Services$Input$updateIsDragging, false, model))));
				return _Utils_Tuple3(
					updateModel,
					$author$project$Services$Swap$mouseUpCommand(updateModel),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Services$TestUpdates$updateTestState = F2(
	function (message, model) {
		switch (message) {
			case 4:
				var kanawordData = model.bw;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bw: _Utils_update(
								kanawordData,
								{cc: true}),
							by: 6
						}),
					A2(
						$author$project$Services$Kanaword$getAudioCommandAtIndex,
						$elm$core$Maybe$Just(0),
						model),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 3:
				return _Utils_Tuple3(
					A2($author$project$Services$Score$addScore, 4000, model),
					$author$project$Services$Time$scoreProgressDelay($author$project$Domain$Types$ScoreProgressAnimationFinished),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 0:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dropDownDefeatModal(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				return _Utils_Tuple3(
					$author$project$Services$Modal$dropDownLevelCompleteNotification(
						_Utils_update(
							model,
							{by: 7})),
					$author$project$Services$Audio$playVictorySoundEffectCommand(model),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			default:
				var currentAnimatedKana = $author$project$Services$Kanaword$toCurrentAnimatedKanaRecord(model.bw);
				var firstCharacterDashTotal = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$andThen,
						function (intValue) {
							return $elm$core$Maybe$Just(
								$elm$core$List$sum(
									A2($elm$core$List$take, intValue, currentAnimatedKana.$7)));
						},
						A2(
							$elm$core$Dict$get,
							A3($elm$core$String$slice, 0, 1, currentAnimatedKana.cD),
							$author$project$Services$Kana$numberOfStrokesPerKana)));
				var kanaString = (_Utils_cmp(currentAnimatedKana.bZ, firstCharacterDashTotal) > -1) ? A3($elm$core$String$slice, 1, 1, currentAnimatedKana.cD) : A3($elm$core$String$slice, 0, 1, currentAnimatedKana.cD);
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Services$Time$delay,
						1,
						$author$project$Domain$Types$KanawordMessage(
							A2($author$project$Domain$Types$BoardItemsFinishedMovingToKanaWord, 25, kanaString))),
					$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Services$Time$clearAnimations = F2(
	function (idle, model) {
		return idle ? _Utils_update(
			model,
			{bx: _List_Nil, bH: _List_Nil, b7: _List_Nil}) : model;
	});
var $author$project$Services$Time$idleDuration = F2(
	function (newTime, idleTime) {
		return $elm$time$Time$posixToMillis(newTime) - $elm$time$Time$posixToMillis(idleTime);
	});
var $author$project$Services$AnimationDurations$timeToIdle = 3000;
var $author$project$Services$Time$isIdle = F2(
	function (newTime, _v0) {
		var idleTime = _v0.cq;
		var isBoardAnimating = _v0.cA;
		return (!isBoardAnimating) && (_Utils_cmp(
			A2($author$project$Services$Time$idleDuration, newTime, idleTime),
			$author$project$Services$AnimationDurations$timeToIdle) > 0);
	});
var $author$project$Services$Time$updateTimerState = F2(
	function (message, model) {
		if (message.$ === 1) {
			var resetTime = message.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bX: resetTime, cq: resetTime}),
				$elm$core$Platform$Cmd$none,
				$MartinSStewart$elm_audio$Audio$cmdNone);
		} else {
			var newTime = message.a;
			return _Utils_Tuple3(
				A2(
					$author$project$Services$Time$clearAnimations,
					A2($author$project$Services$Time$isIdle, newTime, model),
					_Utils_update(
						model,
						{
							bX: newTime,
							cC: A2($author$project$Services$Time$isIdle, newTime, model)
						})),
				$elm$core$Platform$Cmd$none,
				$MartinSStewart$elm_audio$Audio$cmdNone);
		}
	});
var $author$project$Update$update = F3(
	function (_v0, message, model) {
		switch (message.$) {
			case 0:
				var url = message.a;
				return _Utils_Tuple3(
					$author$project$Services$Time$refreshIdleTime(model),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Services$Score$requestHighScoreCommand(url),
								$author$project$Ports$requestSettingsCommand
							])),
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 1:
				return _Utils_Tuple3(
					$author$project$Services$Time$refreshIdleTime(model),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 2:
				return _Utils_Tuple3(
					$author$project$Services$Score$updateScoreStarProgressPercentages(
						$author$project$Services$Score$updateScoreStarAnimations(model)),
					$elm$core$Platform$Cmd$none,
					$MartinSStewart$elm_audio$Audio$cmdNone);
			case 8:
				var boardMessage = message.a;
				return A2($author$project$Services$BoardState$updateBoardState, boardMessage, model);
			case 14:
				var timerMessage = message.a;
				return A2($author$project$Services$Time$updateTimerState, timerMessage, model);
			case 13:
				var hintMessage = message.a;
				return A2($author$project$Services$Hint$updateHintState, hintMessage, model);
			case 12:
				var localStorageMessage = message.a;
				return A2($author$project$Services$LocalStorage$updateLocalStorageState, localStorageMessage, model);
			case 11:
				var soundMessage = message.a;
				return A2($author$project$Services$Audio$updateAudioState, soundMessage, model);
			case 10:
				var loadingMessage = message.a;
				return A2($author$project$Services$Loading$updateLoadingState, loadingMessage, model);
			case 9:
				var swapMesage = message.a;
				return A2($author$project$Services$Swap$updateSwapState, swapMesage, model);
			case 7:
				var kanawordMessage = message.a;
				return A2($author$project$Services$Kanaword$updateKanawordState, kanawordMessage, model);
			case 6:
				var imageMatchMessage = message.a;
				return A2($author$project$Services$ImageMatch$updateImageMatchState, imageMatchMessage, model);
			case 3:
				var modalMessage = message.a;
				return A2($author$project$Services$Modal$updateModalState, modalMessage, model);
			case 4:
				var shuffleMessage = message.a;
				return A2($author$project$Services$Shuffle$updateShuffleState, shuffleMessage, model);
			case 5:
				var randomMessage = message.a;
				var randomNumber = message.b;
				return A3($author$project$Services$Random$updateRandomSeeds, randomMessage, randomNumber, model);
			case 15:
				var domMessage = message.a;
				return A2($author$project$Services$Dom$updateDomState, domMessage, model);
			default:
				var testMessage = message.a;
				return A2($author$project$Services$TestUpdates$updateTestState, testMessage, model);
		}
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Services$CssSelector$animatedScoreSelector = $elm$svg$Svg$Attributes$class('animatedScore');
var $author$project$Services$ShapeColor$getColorString = function (color) {
	return 'rgb(' + ($elm$core$String$fromInt(color.c6) + (', ' + ($elm$core$String$fromInt(color.ch) + (', ' + ($elm$core$String$fromInt(color.bE) + ')')))));
};
var $author$project$SVGs$Animations$ScoreAnimation$chainColorString = function (chain) {
	if (chain.b) {
		var firstBoardItem = chain.a;
		return $author$project$Services$ShapeColor$getColorString(
			$author$project$Services$Board$boardKanaColorToColor(firstBoardItem.bQ));
	} else {
		return '';
	}
};
var $author$project$SVGs$Animations$ScoreAnimation$chainItemCountAtColumn = F2(
	function (chain, columnIndex) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var coordinates = _v0.aw;
					var _v1 = coordinates;
					var column = _v1.b;
					return _Utils_eq(column, columnIndex);
				},
				chain));
	});
var $author$project$SVGs$Animations$ScoreAnimation$chainItemCountAtRow = F2(
	function (chain, rowIndex) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var coordinates = _v0.aw;
					var _v1 = coordinates;
					var row = _v1.a;
					return _Utils_eq(row, rowIndex);
				},
				chain));
	});
var $author$project$SVGs$Animations$ScoreAnimation$intersectingChainCoordinates = function (chain) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(0, 0),
		A2(
			$elm$core$Maybe$andThen,
			function (boardItem) {
				return $elm$core$Maybe$Just(boardItem.aw);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var coordinates = _v0.aw;
						var _v1 = coordinates;
						var row = _v1.a;
						var column = _v1.b;
						return (A2($author$project$SVGs$Animations$ScoreAnimation$chainItemCountAtRow, chain, row) >= 3) && (A2($author$project$SVGs$Animations$ScoreAnimation$chainItemCountAtColumn, chain, column) >= 3);
					},
					chain))));
};
var $author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameColumn = F2(
	function (boardItem1, boardItem2) {
		return _Utils_eq(boardItem1.aw.b, boardItem2.aw.b);
	});
var $author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameRow = F2(
	function (boardItem1, boardItem2) {
		return _Utils_eq(boardItem1.aw.a, boardItem2.aw.a);
	});
var $author$project$SVGs$Animations$ScoreAnimation$isFiveInARowOrColumnChain = function (chain) {
	if (((((chain.b && chain.b.b) && chain.b.b.b) && chain.b.b.b.b) && chain.b.b.b.b.b) && (!chain.b.b.b.b.b.b)) {
		var boardItem1 = chain.a;
		var _v1 = chain.b;
		var boardItem2 = _v1.a;
		var _v2 = _v1.b;
		var boardItem3 = _v2.a;
		var _v3 = _v2.b;
		var boardItem4 = _v3.a;
		var _v4 = _v3.b;
		var boardItem5 = _v4.a;
		return (A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameRow, boardItem1, boardItem2) && (A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameRow, boardItem2, boardItem3) && (A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameRow, boardItem3, boardItem4) && A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameRow, boardItem4, boardItem5)))) || (A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameColumn, boardItem1, boardItem2) && (A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameColumn, boardItem2, boardItem3) && (A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameColumn, boardItem3, boardItem4) && A2($author$project$SVGs$Animations$ScoreAnimation$boardItemsHaveSameColumn, boardItem4, boardItem5))));
	} else {
		return false;
	}
};
var $author$project$SVGs$Animations$ScoreAnimation$chainScoreCoordinates = function (chain) {
	_v0$4:
	while (true) {
		if ((chain.b && chain.b.b) && chain.b.b.b) {
			if (!chain.b.b.b.b) {
				var _v1 = chain.b;
				var boardItem = _v1.a;
				var _v2 = _v1.b;
				return boardItem.aw;
			} else {
				if (!chain.b.b.b.b.b) {
					var _v3 = chain.b;
					var _v4 = _v3.b;
					var boardItem = _v4.a;
					var _v5 = _v4.b;
					return boardItem.aw;
				} else {
					if (!chain.b.b.b.b.b.b) {
						var _v6 = chain.b;
						var _v7 = _v6.b;
						var boardItem3 = _v7.a;
						var _v8 = _v7.b;
						var _v9 = _v8.b;
						return $author$project$SVGs$Animations$ScoreAnimation$isFiveInARowOrColumnChain(chain) ? boardItem3.aw : $author$project$SVGs$Animations$ScoreAnimation$intersectingChainCoordinates(chain);
					} else {
						if (!chain.b.b.b.b.b.b.b) {
							var _v10 = chain.b;
							var _v11 = _v10.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							return $author$project$SVGs$Animations$ScoreAnimation$intersectingChainCoordinates(chain);
						} else {
							break _v0$4;
						}
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return _Utils_Tuple2(0, 0);
};
var $author$project$SVGs$Animations$ScoreAnimation$coordinatesToSvgAttributes = function (_v0) {
	var rowIndex = _v0.a;
	var columnIndex = _v0.b;
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$class(
			'row' + $elm$core$String$fromInt(rowIndex)),
			$elm$svg$Svg$Attributes$class(
			'column' + $elm$core$String$fromInt(columnIndex))
		]);
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $author$project$Services$Score$scoreForChainString = F2(
	function (chain, comboMultiplier) {
		return $elm$core$String$fromInt(
			A2($author$project$Services$Score$scoreForChain, chain, comboMultiplier));
	});
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $author$project$SVGs$Animations$ScoreAnimation$svgCenterX = $elm$svg$Svg$Attributes$x('50%');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$SVGs$Animations$ScoreAnimation$svgCenterY = $elm$svg$Svg$Attributes$y('50%');
var $author$project$SVGs$Animations$ScoreAnimation$centeredText = 'middle';
var $elm$svg$Svg$Attributes$dominantBaseline = _VirtualDom_attribute('dominant-baseline');
var $author$project$SVGs$Animations$ScoreAnimation$svgCenteredHorizontalText = $elm$svg$Svg$Attributes$dominantBaseline($author$project$SVGs$Animations$ScoreAnimation$centeredText);
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $author$project$SVGs$Animations$ScoreAnimation$svgCenteredVerticalText = $elm$svg$Svg$Attributes$textAnchor($author$project$SVGs$Animations$ScoreAnimation$centeredText);
var $author$project$SVGs$Animations$ScoreAnimation$svgWhiteFill = $elm$svg$Svg$Attributes$fill('rgb(0, 0, 0)');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$SVGs$Animations$ScoreAnimation$animatedChainScore = F2(
	function (chain, comboMultiplier) {
		return A2(
			$elm$svg$Svg$svg,
			A2(
				$elm$core$List$cons,
				$author$project$Services$CssSelector$animatedScoreSelector,
				$author$project$SVGs$Animations$ScoreAnimation$coordinatesToSvgAttributes(
					$author$project$SVGs$Animations$ScoreAnimation$chainScoreCoordinates(chain))),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$author$project$SVGs$Animations$ScoreAnimation$svgCenterX,
							$author$project$SVGs$Animations$ScoreAnimation$svgCenterY,
							$author$project$SVGs$Animations$ScoreAnimation$svgCenteredVerticalText,
							$author$project$SVGs$Animations$ScoreAnimation$svgCenteredHorizontalText,
							$author$project$SVGs$Animations$ScoreAnimation$svgWhiteFill,
							$elm$svg$Svg$Attributes$fill(
							$author$project$SVGs$Animations$ScoreAnimation$chainColorString(chain))
						]),
					_List_fromArray(
						[
							$elm$svg$Svg$text(
							A2($author$project$Services$Score$scoreForChainString, chain, comboMultiplier))
						]))
				]));
	});
var $author$project$Extras$List$appendElement = F2(
	function (element, list) {
		return _Utils_ap(
			list,
			_List_fromArray(
				[element]));
	});
var $author$project$Extras$List$appendElementIf = F3(
	function (shouldAppend, element, list) {
		return shouldAppend ? A2($author$project$Extras$List$appendElement, element, list) : list;
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Services$Board$coordinatesToString = function (_v0) {
	var rowIndex = _v0.a;
	var columnIndex = _v0.b;
	return _Utils_ap(
		$elm$core$String$fromInt(rowIndex),
		$elm$core$String$fromInt(columnIndex));
};
var $author$project$View$chainToKey = function (chain) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var coordinates = _v0.aw;
				return $author$project$Services$Board$coordinatesToString(coordinates);
			},
			chain));
};
var $author$project$Extras$List$contains = F2(
	function (element, list) {
		return A2($elm$core$List$member, element, list);
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Extras$Html$keyedDiv = F2(
	function (attributes, children) {
		return A3($elm$html$Html$Keyed$node, 'div', attributes, children);
	});
var $author$project$View$animatedScoresLayer = F2(
	function (model, viewElements) {
		var animatedScores = model.bx;
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('animatedScores')
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var chain = _v0.a;
						var comboMultiplier = _v0.b;
						return _Utils_Tuple2(
							$author$project$View$chainToKey(chain),
							A2($author$project$SVGs$Animations$ScoreAnimation$animatedChainScore, chain, comboMultiplier));
					},
					animatedScores)),
			viewElements);
	});
var $author$project$Domain$Types$GetRandomHintClicked = {$: 2};
var $author$project$Domain$Types$LoadingLevel = 2;
var $author$project$Domain$Types$SettingsCogClicked = {$: 0};
var $author$project$Services$CssSelector$backgroundImage = $elm$svg$Svg$Attributes$class('background-image');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$View$hintButton = F3(
	function (onClickMessage, model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('hint-button'),
						$elm$html$Html$Events$onClick(onClickMessage)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('🤔')
					])),
			viewElements);
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$dx = _VirtualDom_attribute('dx');
var $elm$svg$Svg$Attributes$dy = _VirtualDom_attribute('dy');
var $elm$svg$Svg$feComposite = $elm$svg$Svg$trustedNode('feComposite');
var $elm$svg$Svg$feFlood = $elm$svg$Svg$trustedNode('feFlood');
var $elm$svg$Svg$feGaussianBlur = $elm$svg$Svg$trustedNode('feGaussianBlur');
var $elm$svg$Svg$feOffset = $elm$svg$Svg$trustedNode('feOffset');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$filter = $elm$svg$Svg$trustedNode('filter');
var $elm$svg$Svg$Attributes$filter = _VirtualDom_attribute('filter');
var $elm$svg$Svg$Attributes$filterUnits = _VirtualDom_attribute('filterUnits');
var $elm$svg$Svg$Attributes$floodColor = _VirtualDom_attribute('flood-color');
var $elm$svg$Svg$Attributes$floodOpacity = _VirtualDom_attribute('flood-opacity');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$in2 = _VirtualDom_attribute('in2');
var $elm$svg$Svg$Attributes$in_ = _VirtualDom_attribute('in');
var $elm$svg$Svg$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$Attributes$operator = _VirtualDom_attribute('operator');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$result = _VirtualDom_attribute('result');
var $elm$svg$Svg$Attributes$stdDeviation = _VirtualDom_attribute('stdDeviation');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeMiterlimit = _VirtualDom_attribute('stroke-miterlimit');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$SVGs$Elements$SettingsCog$greyCog = function (onClickMessage) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('settings-button'),
				$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
				$elm$svg$Svg$Attributes$width('75'),
				$elm$svg$Svg$Attributes$height('75'),
				$elm$svg$Svg$Events$onClick(onClickMessage)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$defs,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$filter,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasGearOpenMenu2-shadow-outer'),
								$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$feGaussianBlur,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stdDeviation('2.5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feOffset,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$dx('2'),
										$elm$svg$Svg$Attributes$dy('2'),
										$elm$svg$Svg$Attributes$result('blur')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feFlood,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
										$elm$svg$Svg$Attributes$floodOpacity('0.7')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feComposite,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in2('blur'),
										$elm$svg$Svg$Attributes$operator('in'),
										$elm$svg$Svg$Attributes$result('colorShadow')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$feComposite,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$in_('SourceGraphic'),
										$elm$svg$Svg$Attributes$in2('colorShadow'),
										$elm$svg$Svg$Attributes$operator('over')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasGearOpenMenu2-group4'),
						$elm$svg$Svg$Attributes$filter('url(#canvasGearOpenMenu2-shadow-outer)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasGearOpenMenu2-oval'),
								$elm$svg$Svg$Attributes$stroke('rgb(85, 85, 85)'),
								$elm$svg$Svg$Attributes$strokeWidth('3'),
								$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
								$elm$svg$Svg$Attributes$fill('rgb(225, 225, 225)'),
								$elm$svg$Svg$Attributes$cx('50'),
								$elm$svg$Svg$Attributes$cy('50'),
								$elm$svg$Svg$Attributes$r('45')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasGearOpenMenu2-bezier2'),
								$elm$svg$Svg$Attributes$fillRule('evenodd'),
								$elm$svg$Svg$Attributes$stroke('rgb(85, 85, 85)'),
								$elm$svg$Svg$Attributes$strokeWidth('2'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round'),
								$elm$svg$Svg$Attributes$strokeMiterlimit('1.41'),
								$elm$svg$Svg$Attributes$fill('rgb(170, 170, 170)'),
								$elm$svg$Svg$Attributes$d('M 54.17,14.35 C 50.84,13.9 47.47,13.9 44.15,14.35 L 40.81,20.67 C 37.16,21.67 33.73,23.32 30.67,25.54 L 23.63,24.2 C 21.2,26.51 19.1,29.14 17.38,32.02 L 20.25,38.56 C 18.77,42.03 17.92,45.74 17.75,49.51 L 12.32,54.16 C 12.61,57.5 13.36,60.77 14.54,63.9 L 21.47,65.75 C 23.26,69.07 25.63,72.04 28.48,74.52 L 28.74,81.66 C 31.54,83.51 34.58,84.97 37.77,86 L 43.53,81.75 C 47.25,82.43 51.06,82.43 54.78,81.75 L 60.54,86 C 63.74,84.97 66.77,83.51 69.57,81.66 L 69.83,74.52 C 72.68,72.04 75.06,69.07 76.85,65.75 L 83.77,63.9 C 84.95,60.77 85.7,57.5 86,54.16 L 80.57,49.51 C 80.4,45.74 79.55,42.03 78.06,38.56 L 80.93,32.02 C 79.22,29.14 77.11,26.51 74.69,24.2 L 67.65,25.54 C 64.59,23.32 61.15,21.67 57.51,20.67 L 54.17,14.35 Z M 49.16,30.62 C 60.38,30.62 69.49,39.71 69.49,50.9 69.49,62.09 60.38,71.18 49.16,71.18 37.94,71.18 28.83,62.09 28.83,50.9 28.83,39.71 37.94,30.62 49.16,30.62 Z M 49.16,30.62')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$SVGs$Elements$SettingsCog$settingsCogButton = F3(
	function (onClickMessage, model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			$author$project$SVGs$Elements$SettingsCog$greyCog(onClickMessage),
			viewElements);
	});
var $author$project$View$springBackgroundURL = '../Images/Backdrops/Spring.svg';
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$View$background = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[2, 3, 4, 5, 6, 7])),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Services$CssSelector$backgroundImage]),
				A3(
					$author$project$View$hintButton,
					$author$project$Domain$Types$HintMessage($author$project$Domain$Types$GetRandomHintClicked),
					model,
					A3(
						$author$project$SVGs$Elements$SettingsCog$settingsCogButton,
						$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$SettingsCogClicked),
						model,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src($author$project$View$springBackgroundURL)
									]),
								_List_Nil)
							])))),
			viewElements);
	});
var $author$project$Domain$Types$AnimateToCenter = 1;
var $author$project$Domain$Types$Finished = 0;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Extras$Events$isPropertyName = F3(
	function (message, propertyName, name) {
		return _Utils_eq(name, propertyName) ? $elm$json$Json$Decode$succeed(message) : $elm$json$Json$Decode$fail('');
	});
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Extras$Events$transitionPropertyNameDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['propertyName']),
	$elm$json$Json$Decode$string);
var $author$project$Extras$Events$onTransitionEnd = F2(
	function (propertyName, message) {
		return A2(
			$elm$svg$Svg$Events$on,
			'transitionend',
			A2(
				$elm$json$Json$Decode$andThen,
				A2($author$project$Extras$Events$isPropertyName, message, propertyName),
				$author$project$Extras$Events$transitionPropertyNameDecoder));
	});
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Services$TransitionProperty$top = 'top';
var $author$project$SVGs$Elements$Shuffling$activeAttribute = F2(
	function (shuffleState, attributes) {
		return A2(
			$author$project$Extras$List$contains,
			shuffleState,
			_List_fromArray(
				[3, 0, 1])) ? A2(
			$elm$core$List$cons,
			$elm$svg$Svg$Attributes$class('active'),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Extras$Events$onTransitionEnd,
					$author$project$Services$TransitionProperty$top,
					$author$project$Domain$Types$ShuffleMessage(1)),
				attributes)) : ((shuffleState === 4) ? A2(
			$elm$core$List$cons,
			$elm$svg$Svg$Attributes$style('transition-delay: 250ms; transition-timing-function: ease-in;'),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Extras$Events$onTransitionEnd,
					$author$project$Services$TransitionProperty$top,
					$author$project$Domain$Types$ShuffleMessage(0)),
				attributes)) : attributes);
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$gradientUnits = _VirtualDom_attribute('gradientUnits');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$stopOpacity = _VirtualDom_attribute('stop-opacity');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$SVGs$Elements$Shuffling$definitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-levelCompleteOuterShadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('3'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-lightStripeGradiantBottom-rectangle4'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('97'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('100'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(70, 146, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor('rgb(92, 188, 168)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-lightStripeGradiantTop-rectangle6'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('-2.5'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('97.5'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.94'),
							$elm$svg$Svg$Attributes$stopColor('rgb(92, 188, 168)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(70, 146, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-darkStripeGradiantBottom-bottomShade'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('97'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('100'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(60, 126, 109)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor('rgb(71, 148, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-darkStripeGradiantTop-topShade'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('-3'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('97'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.93'),
							$elm$svg$Svg$Attributes$stopColor('rgb(71, 148, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(60, 126, 109)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-highlight-rectangle2'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('6'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('24'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(251, 251, 248)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.25'),
							$elm$svg$Svg$Attributes$stopColor('rgb(126, 126, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.58'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-reverseHighlight-rectangle3'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('-0'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('6'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.43'),
							$elm$svg$Svg$Attributes$stopColor('rgb(126, 126, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(251, 251, 248)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-levelCompleteInnerShadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('shuffleDrawing-gradient3-beigeStipeShadow'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('86.5'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('89.63'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(252, 246, 213)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.68'),
							$elm$svg$Svg$Attributes$stopColor('rgb(211, 208, 192)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(170, 170, 170)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]));
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$SVGs$Elements$Shuffling$shufflingNotification = function (shuffleState) {
	return A2(
		$elm$svg$Svg$svg,
		A2(
			$author$project$SVGs$Elements$Shuffling$activeAttribute,
			shuffleState,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('471'),
					$elm$svg$Svg$Attributes$viewBox('0 0 375 120'),
					$elm$svg$Svg$Attributes$id('shuffling-notification')
				])),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$Shuffling$definitions,
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('shuffleDrawing-group2'),
						$elm$svg$Svg$Attributes$clipPath('url(#shuffleDrawing-rectangle)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$clipPath,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('shuffleDrawing-rectangle')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('-120'),
										$elm$svg$Svg$Attributes$width('375'),
										$elm$svg$Svg$Attributes$height('120'),
										$elm$svg$Svg$Attributes$transform('translate(0, 120)')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('shuffleDrawing-stripesBackground'),
								$elm$svg$Svg$Attributes$filter('url(#shuffleDrawing-levelCompleteOuterShadow-outer)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-rectangle4'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-lightStripeGradiantBottom-rectangle4)'),
										$elm$svg$Svg$Attributes$x('-86'),
										$elm$svg$Svg$Attributes$y('97'),
										$elm$svg$Svg$Attributes$width('547'),
										$elm$svg$Svg$Attributes$height('3')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-rectangle6'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-lightStripeGradiantTop-rectangle6)'),
										$elm$svg$Svg$Attributes$x('-86'),
										$elm$svg$Svg$Attributes$y('-2.5'),
										$elm$svg$Svg$Attributes$width('547'),
										$elm$svg$Svg$Attributes$height('100')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-group3'),
										$elm$svg$Svg$Attributes$clipPath('url(#shuffleDrawing-rectangle5)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$clipPath,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('shuffleDrawing-rectangle5')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$rect,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$x('0'),
														$elm$svg$Svg$Attributes$y('0'),
														$elm$svg$Svg$Attributes$width('375'),
														$elm$svg$Svg$Attributes$height('120')
													]),
												_List_Nil)
											])),
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('shuffleDrawing-group5'),
												$elm$svg$Svg$Attributes$clipPath('url(#shuffleDrawing-bezier)')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$clipPath,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('shuffleDrawing-bezier')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$d('M 21.2,100 L 48.17,100 139.86,-0 112.89,-0 21.2,100 Z M 74.68,100 L 101.65,100 193.34,-0 166.38,-0 74.68,100 Z M 128.17,100 L 155.14,100 246.83,-0 219.86,-0 128.17,100 Z M -32.29,100 L -5.32,100 86.37,-0 59.4,-0 -32.29,100 Z M 235.37,100 L 262.34,100 354.03,-0 327.06,-0 235.37,100 Z M 288.85,100 L 315.82,100 407.51,-0 380.55,-0 288.85,100 Z M 342.34,100 L 369.31,100 461,-0 434.03,-0 342.34,100 Z M 181.88,100 L 208.85,100 300.54,-0 273.57,-0 181.88,100 Z M -86,100 L -59.03,100 32.66,-0 5.69,-0 -86,100 Z M -86,100')
															]),
														_List_Nil)
													])),
												A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('shuffleDrawing-group6')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$rect,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('shuffleDrawing-bottomShade'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-darkStripeGradiantBottom-bottomShade)'),
																$elm$svg$Svg$Attributes$x('-86'),
																$elm$svg$Svg$Attributes$y('97'),
																$elm$svg$Svg$Attributes$width('547'),
																$elm$svg$Svg$Attributes$height('3')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$rect,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('shuffleDrawing-topShade'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-darkStripeGradiantTop-topShade)'),
																$elm$svg$Svg$Attributes$x('-86'),
																$elm$svg$Svg$Attributes$y('-3'),
																$elm$svg$Svg$Attributes$width('547'),
																$elm$svg$Svg$Attributes$height('100')
															]),
														_List_Nil)
													]))
											]))
									]))
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('shuffleDrawing-topHighlight'),
								$elm$svg$Svg$Attributes$opacity('0.6'),
								$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-rectangle2'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-highlight-rectangle2)'),
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('6'),
										$elm$svg$Svg$Attributes$width('375'),
										$elm$svg$Svg$Attributes$height('18')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-rectangle3'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-reverseHighlight-rectangle3)'),
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$width('375'),
										$elm$svg$Svg$Attributes$height('6')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('shuffleDrawing-group4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('shuffleDrawing-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-beigeBackground'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(252, 246, 213)'),
										$elm$svg$Svg$Attributes$filter('url(#shuffleDrawing-levelCompleteInnerShadow-outer)'),
										$elm$svg$Svg$Attributes$x('-94'),
										$elm$svg$Svg$Attributes$y('12'),
										$elm$svg$Svg$Attributes$width('555'),
										$elm$svg$Svg$Attributes$height('77.5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-bottomBeigeStipe'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(251, 225, 173)'),
										$elm$svg$Svg$Attributes$d('M -94,81.73 L 461,81.73 461,84.42 -94,84.42 -94,81.73 Z M -94,81.73')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('shuffleDrawing-topBeigeStripe'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(251, 225, 173)'),
										$elm$svg$Svg$Attributes$d('M -94,16.59 L 461,16.59 461,19.28 -94,19.28 -94,16.59 Z M -94,16.59')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('shuffleDrawing-beigeStipeShadow'),
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('url(#shuffleDrawing-gradient3-beigeStipeShadow)'),
								$elm$svg$Svg$Attributes$d('M 0.07,86.5 L 374.93,86.5 374.93,89.63 0.07,89.63 0.07,86.5 Z M 0.07,86.5')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('shuffleDrawing-textShuffling'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill('rgb(71, 148, 129)'),
						$elm$svg$Svg$Attributes$d('M 146.31,60.32 C 144.7,59.34 143.29,58.85 142.09,58.85 141.17,58.85 140.46,59.05 139.96,59.45 139.46,59.85 139.18,60.37 139.11,61 139.06,61.65 139.34,62.22 139.94,62.72 140.54,63.23 141.39,63.72 142.49,64.2 143.69,64.73 144.63,65.36 145.32,66.07 146.02,66.79 146.36,67.78 146.36,69.05 146.36,70 146.13,70.9 145.65,71.76 145.17,72.62 144.48,73.32 143.55,73.85 142.62,74.38 141.5,74.65 140.19,74.65 138.97,74.65 137.81,74.45 136.71,74.05 135.61,73.65 134.64,73.08 133.79,72.35 L 135.34,70.18 C 135.94,70.73 136.67,71.18 137.54,71.54 138.4,71.9 139.22,72.07 139.99,72.07 140.89,72.07 141.65,71.85 142.28,71.4 142.9,70.95 143.25,70.33 143.31,69.55 143.36,68.9 143.13,68.33 142.62,67.84 142.12,67.35 141.41,66.9 140.51,66.5 139.58,66.07 138.82,65.66 138.24,65.29 137.65,64.91 137.15,64.42 136.71,63.81 136.28,63.2 136.06,62.48 136.06,61.62 136.06,60.52 136.32,59.57 136.85,58.75 137.38,57.93 138.1,57.31 139.01,56.89 139.93,56.46 140.96,56.26 142.11,56.28 143.31,56.33 144.35,56.52 145.21,56.85 146.08,57.18 146.91,57.63 147.71,58.2 L 146.31,60.32 Z M 157.14,63.47 C 158.07,63.47 158.82,63.74 159.4,64.26 159.98,64.79 160.26,65.47 160.26,66.3 L 160.24,66.65 159.29,74.5 156.49,74.5 157.31,67.62 C 157.35,67.07 157.24,66.65 156.99,66.34 156.74,66.03 156.33,65.88 155.76,65.88 154.88,65.88 154.11,66.25 153.46,66.99 152.81,67.73 152.42,68.67 152.29,69.82 L 151.71,74.5 148.91,74.5 151.29,55 154.04,55 152.76,65.6 C 153.25,64.95 153.86,64.43 154.61,64.05 155.36,63.67 156.2,63.47 157.14,63.47 Z M 174.64,63.93 L 173.31,74.5 170.79,74.5 170.84,72.7 C 170.37,73.38 169.75,73.93 168.99,74.34 168.22,74.75 167.39,74.95 166.49,74.95 165.59,74.95 164.86,74.7 164.3,74.19 163.74,73.68 163.46,73.01 163.46,72.18 163.46,72.01 163.47,71.88 163.49,71.8 L 164.44,63.93 167.24,63.93 166.39,70.8 C 166.35,71.33 166.46,71.75 166.7,72.06 166.94,72.37 167.34,72.53 167.89,72.55 168.72,72.55 169.46,72.18 170.1,71.43 170.74,70.67 171.12,69.73 171.24,68.6 L 171.81,63.93 174.64,63.93 Z M 179.04,66.38 L 177.24,66.38 177.56,63.9 179.36,63.9 179.86,59.75 C 180.05,58.27 180.56,57.11 181.41,56.28 182.26,55.44 183.39,55.03 184.79,55.03 185.2,55.03 185.65,55.09 186.11,55.21 186.58,55.34 186.98,55.52 187.31,55.75 L 185.86,57.78 C 185.63,57.47 185.28,57.32 184.81,57.32 183.6,57.32 182.88,58.16 182.66,59.82 L 182.16,63.9 185.46,63.9 185.14,66.38 181.84,66.38 180.86,74.5 178.06,74.5 179.04,66.38 Z M 201.11,55 L 198.74,74.5 195.94,74.5 198.31,55 201.11,55 Z M 189.09,66.38 L 187.29,66.38 187.61,63.9 189.41,63.9 189.91,59.75 C 190.1,58.27 190.61,57.11 191.46,56.28 192.31,55.44 193.44,55.03 194.84,55.03 195.25,55.03 195.7,55.09 196.16,55.21 196.63,55.34 197.03,55.52 197.36,55.75 L 195.91,57.78 C 195.68,57.47 195.33,57.32 194.86,57.32 193.65,57.32 192.93,58.16 192.71,59.82 L 192.21,63.9 195.11,63.9 194.81,66.38 191.89,66.38 190.91,74.5 188.11,74.5 189.09,66.38 Z M 206.69,63.93 L 205.39,74.5 202.59,74.5 203.89,63.93 206.69,63.93 Z M 204.09,60.28 C 204.1,59.82 204.27,59.45 204.59,59.15 204.9,58.85 205.3,58.7 205.79,58.7 206.2,58.7 206.57,58.82 206.88,59.05 207.18,59.28 207.34,59.62 207.34,60.07 207.34,60.53 207.18,60.9 206.85,61.21 206.52,61.52 206.12,61.68 205.64,61.68 205.24,61.66 204.88,61.53 204.56,61.3 204.25,61.07 204.09,60.73 204.09,60.28 Z M 217.46,63.47 C 218.41,63.47 219.17,63.73 219.75,64.25 220.33,64.77 220.61,65.44 220.61,66.28 220.61,66.44 220.6,66.57 220.59,66.65 L 219.64,74.5 216.84,74.5 217.69,67.65 C 217.72,67.08 217.6,66.65 217.34,66.34 217.07,66.03 216.64,65.88 216.04,65.88 215.17,65.88 214.42,66.25 213.79,66.99 213.15,67.73 212.77,68.67 212.64,69.82 L 212.06,74.5 209.26,74.5 210.54,63.93 213.06,63.93 213.09,65.62 C 213.55,64.96 214.17,64.43 214.93,64.05 215.68,63.67 216.53,63.47 217.46,63.47 Z M 236.31,63.93 L 234.91,75.05 C 234.75,76.5 234.09,77.65 232.94,78.5 231.79,79.35 230.36,79.78 228.66,79.78 227.38,79.78 226.34,79.59 225.54,79.21 224.74,78.84 223.97,78.3 223.24,77.6 L 225.14,75.7 C 225.65,76.23 226.21,76.64 226.8,76.91 227.39,77.19 228.1,77.32 228.91,77.32 229.81,77.32 230.56,77.08 231.15,76.59 231.74,76.1 232.09,75.43 232.19,74.57 L 232.39,72.88 C 231.99,73.46 231.45,73.92 230.78,74.26 230.1,74.6 229.32,74.78 228.44,74.78 227.45,74.78 226.57,74.55 225.79,74.11 225,73.67 224.39,73.04 223.94,72.21 223.49,71.39 223.26,70.42 223.26,69.3 223.26,68.47 223.49,67.6 223.95,66.69 224.41,65.78 225.1,65.01 226.03,64.39 226.95,63.76 228.06,63.45 229.36,63.45 230.3,63.45 231.11,63.6 231.81,63.91 232.51,64.22 233.02,64.64 233.34,65.18 L 233.74,63.93 236.31,63.93 Z M 232.99,68 C 232.84,67.32 232.48,66.77 231.91,66.36 231.35,65.95 230.66,65.75 229.86,65.75 229.01,65.75 228.31,65.94 227.75,66.31 227.19,66.69 226.78,67.15 226.53,67.7 226.27,68.25 226.14,68.78 226.14,69.3 226.14,70.27 226.43,71.04 227.03,71.61 227.62,72.19 228.41,72.47 229.41,72.47 230.1,72.47 230.74,72.28 231.34,71.89 231.94,71.5 232.4,70.97 232.71,70.3 L 232.99,68 Z M 238.41,73.15 C 238.41,72.68 238.59,72.28 238.95,71.95 239.31,71.62 239.7,71.45 240.14,71.45 240.47,71.45 240.77,71.59 241.03,71.86 241.28,72.14 241.41,72.47 241.41,72.85 241.41,73.32 241.24,73.71 240.89,74.03 240.54,74.34 240.16,74.5 239.76,74.5 239.4,74.5 239.08,74.38 238.81,74.12 238.55,73.87 238.41,73.55 238.41,73.15 Z M 238.41,73.15')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('shuffleDrawing-textNoMoreSwaps'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill('rgb(71, 148, 129)'),
						$elm$svg$Svg$Attributes$d('M 72.31,26.53 L 70.08,44.62 70.01,44.62 58.92,32.38 57.55,44 54.74,44 56.95,25.93 57.07,25.93 68.11,38.34 69.5,26.53 72.31,26.53 Z M 79.75,44.26 C 78.87,44.26 78.01,44.08 77.17,43.7 76.33,43.32 75.64,42.76 75.1,42 74.55,41.24 74.28,40.32 74.28,39.25 74.28,38.32 74.48,37.41 74.89,36.52 75.3,35.64 75.95,34.9 76.84,34.3 77.72,33.71 78.85,33.42 80.21,33.42 81.15,33.42 82.04,33.62 82.87,34.02 83.7,34.42 84.38,35 84.89,35.76 85.4,36.52 85.66,37.41 85.66,38.43 85.66,39.26 85.47,40.13 85.09,41.02 84.72,41.92 84.09,42.68 83.21,43.32 82.33,43.95 81.18,44.26 79.75,44.26 Z M 79.82,42.03 C 80.53,42.03 81.11,41.85 81.58,41.49 82.04,41.13 82.38,40.69 82.6,40.16 82.81,39.63 82.92,39.1 82.92,38.55 82.92,37.85 82.77,37.28 82.48,36.85 82.18,36.42 81.82,36.1 81.38,35.91 80.95,35.72 80.53,35.62 80.11,35.62 79.41,35.62 78.82,35.8 78.36,36.16 77.9,36.52 77.55,36.97 77.33,37.51 77.1,38.04 76.99,38.58 76.99,39.13 76.99,40.1 77.28,40.83 77.86,41.31 78.43,41.79 79.09,42.03 79.82,42.03 Z M 109.56,33.39 C 110.47,33.39 111.19,33.63 111.71,34.11 112.23,34.59 112.49,35.24 112.49,36.06 112.49,36.22 112.48,36.34 112.46,36.44 L 111.55,44 108.86,44 109.68,37.47 C 109.71,36.93 109.64,36.51 109.48,36.21 109.31,35.92 108.98,35.75 108.5,35.72 107.67,35.72 106.95,36.09 106.34,36.84 105.74,37.58 105.37,38.45 105.24,39.44 L 104.66,44 101.98,44 102.77,37.47 102.79,37.11 C 102.79,36.25 102.38,35.78 101.57,35.72 100.75,35.72 100.04,36.09 99.43,36.84 98.82,37.58 98.46,38.45 98.33,39.44 L 97.78,44 95.09,44 96.31,33.85 98.74,33.85 98.71,35.6 C 99.21,34.9 99.8,34.35 100.5,33.97 101.2,33.58 101.98,33.39 102.84,33.39 103.66,33.39 104.31,33.57 104.81,33.92 105.3,34.27 105.59,34.79 105.67,35.48 106.2,34.84 106.8,34.33 107.48,33.96 108.16,33.58 108.86,33.39 109.56,33.39 Z M 120.5,44.26 C 119.62,44.26 118.76,44.08 117.92,43.7 117.08,43.32 116.39,42.76 115.85,42 115.3,41.24 115.03,40.32 115.03,39.25 115.03,38.32 115.24,37.41 115.64,36.52 116.05,35.64 116.7,34.9 117.59,34.3 118.48,33.71 119.6,33.42 120.96,33.42 121.9,33.42 122.79,33.62 123.62,34.02 124.46,34.42 125.13,35 125.64,35.76 126.15,36.52 126.41,37.41 126.41,38.43 126.41,39.26 126.22,40.13 125.84,41.02 125.47,41.92 124.84,42.68 123.96,43.32 123.08,43.95 121.93,44.26 120.5,44.26 Z M 120.58,42.03 C 121.28,42.03 121.86,41.85 122.33,41.49 122.79,41.13 123.13,40.69 123.35,40.16 123.56,39.63 123.67,39.1 123.67,38.55 123.67,37.85 123.52,37.28 123.23,36.85 122.93,36.42 122.57,36.1 122.14,35.91 121.7,35.72 121.28,35.62 120.86,35.62 120.16,35.62 119.58,35.8 119.11,36.16 118.65,36.52 118.3,36.97 118.08,37.51 117.86,38.04 117.74,38.58 117.74,39.13 117.74,40.1 118.03,40.83 118.61,41.31 119.18,41.79 119.84,42.03 120.58,42.03 Z M 132.14,36.22 C 132.62,35.36 133.3,34.67 134.16,34.16 135.02,33.65 135.82,33.39 136.54,33.39 L 136.08,36.08 C 135.34,36.02 134.67,36.15 134.05,36.48 133.44,36.8 132.94,37.25 132.55,37.82 132.17,38.39 131.94,38.99 131.86,39.63 L 131.3,44 128.64,44 129.86,33.85 132.29,33.85 132.14,36.22 Z M 143.11,41.96 C 143.77,41.96 144.45,41.74 145.15,41.29 L 146.11,43.38 C 145.6,43.65 145.06,43.86 144.48,44.01 143.9,44.16 143.35,44.24 142.82,44.24 141.16,44.24 139.84,43.79 138.85,42.9 137.87,42 137.38,40.72 137.38,39.06 137.38,38.16 137.6,37.28 138.04,36.4 138.48,35.53 139.14,34.82 140.04,34.26 140.94,33.7 142.02,33.42 143.3,33.42 146.28,33.42 148.02,35.06 148.51,38.36 L 140.47,40.5 C 140.73,40.99 141.1,41.36 141.58,41.6 142.06,41.84 142.57,41.96 143.11,41.96 Z M 143.23,35.53 C 142.24,35.53 141.46,35.84 140.9,36.48 140.34,37.11 140.06,37.86 140.06,38.74 L 140.06,38.91 145.61,37.4 C 145.43,36.82 145.14,36.37 144.72,36.03 144.3,35.7 143.81,35.53 143.23,35.53 Z M 165.07,33.39 C 165.94,33.39 166.73,33.58 167.45,33.97 168.17,34.35 168.74,34.89 169.15,35.59 169.57,36.28 169.78,37.09 169.78,38 169.78,39.12 169.51,40.16 168.98,41.12 168.46,42.08 167.72,42.84 166.76,43.41 165.81,43.98 164.71,44.26 163.46,44.26 162.89,44.26 162.32,44.16 161.75,43.94 161.18,43.72 160.71,43.43 160.34,43.06 L 159.7,48.87 157.03,48.87 158.93,33.66 161.26,33.66 161.23,34.83 C 162.62,33.87 163.9,33.39 165.07,33.39 Z M 163.39,42.01 C 164.1,42.01 164.73,41.84 165.29,41.5 165.85,41.17 166.28,40.72 166.58,40.17 166.89,39.62 167.04,39.03 167.04,38.41 167.04,37.58 166.75,36.89 166.18,36.34 165.6,35.8 164.92,35.53 164.14,35.53 163.45,35.53 162.83,35.72 162.29,36.09 161.74,36.47 161.3,37 160.97,37.69 L 160.7,39.8 C 160.86,40.42 161.16,40.95 161.6,41.37 162.04,41.8 162.64,42.01 163.39,42.01 Z M 177.19,44.26 C 176.31,44.26 175.45,44.08 174.61,43.7 173.77,43.32 173.08,42.76 172.54,42 171.99,41.24 171.72,40.32 171.72,39.25 171.72,38.32 171.92,37.41 172.33,36.52 172.74,35.64 173.39,34.9 174.28,34.3 175.16,33.71 176.29,33.42 177.65,33.42 178.59,33.42 179.48,33.62 180.31,34.02 181.14,34.42 181.82,35 182.33,35.76 182.84,36.52 183.1,37.41 183.1,38.43 183.1,39.26 182.91,40.13 182.53,41.02 182.16,41.92 181.53,42.68 180.65,43.32 179.77,43.95 178.62,44.26 177.19,44.26 Z M 177.26,42.03 C 177.97,42.03 178.55,41.85 179.02,41.49 179.48,41.13 179.82,40.69 180.04,40.16 180.25,39.63 180.36,39.1 180.36,38.55 180.36,37.85 180.21,37.28 179.92,36.85 179.62,36.42 179.26,36.1 178.82,35.91 178.39,35.72 177.97,35.62 177.55,35.62 176.85,35.62 176.26,35.8 175.8,36.16 175.34,36.52 174.99,36.97 174.77,37.51 174.54,38.04 174.43,38.58 174.43,39.13 174.43,40.1 174.72,40.83 175.3,41.31 175.87,41.79 176.53,42.03 177.26,42.03 Z M 188.64,44.22 C 187.98,44.22 187.27,44.08 186.49,43.81 185.72,43.54 185.06,43.05 184.54,42.34 L 185.86,40.9 C 186.34,41.48 186.8,41.86 187.26,42.04 187.72,42.23 188.18,42.32 188.64,42.32 189.14,42.32 189.5,42.2 189.73,41.96 189.96,41.72 190.08,41.46 190.08,41.17 190.08,40.9 189.98,40.67 189.79,40.5 189.6,40.32 189.4,40.19 189.18,40.1 188.96,40.01 188.56,39.86 187.97,39.63 186.48,39.04 185.74,38.1 185.74,36.8 185.74,36.32 185.86,35.82 186.1,35.31 186.34,34.8 186.74,34.36 187.31,34 187.88,33.64 188.61,33.46 189.5,33.46 191.1,33.46 192.38,33.9 193.34,34.78 L 192.12,36.34 C 191.8,35.99 191.45,35.73 191.06,35.56 190.68,35.4 190.29,35.31 189.89,35.31 189.42,35.31 189.07,35.42 188.83,35.64 188.59,35.85 188.47,36.11 188.47,36.42 188.49,36.74 188.63,36.99 188.9,37.17 189.18,37.36 189.58,37.55 190.13,37.76 190.24,37.79 190.41,37.86 190.63,37.95 191.34,38.27 191.88,38.64 192.25,39.06 192.63,39.47 192.82,40.02 192.82,40.69 192.82,41.28 192.66,41.84 192.36,42.38 192.06,42.92 191.59,43.36 190.97,43.7 190.34,44.04 189.57,44.22 188.64,44.22 Z M 198.82,44.22 C 198.16,44.22 197.44,44.08 196.67,43.81 195.89,43.54 195.24,43.05 194.71,42.34 L 196.03,40.9 C 196.51,41.48 196.98,41.86 197.44,42.04 197.89,42.23 198.35,42.32 198.82,42.32 199.31,42.32 199.68,42.2 199.91,41.96 200.14,41.72 200.26,41.46 200.26,41.17 200.26,40.9 200.16,40.67 199.97,40.5 199.78,40.32 199.57,40.19 199.36,40.1 199.14,40.01 198.74,39.86 198.14,39.63 196.66,39.04 195.91,38.1 195.91,36.8 195.91,36.32 196.03,35.82 196.27,35.31 196.51,34.8 196.92,34.36 197.48,34 198.05,33.64 198.78,33.46 199.68,33.46 201.28,33.46 202.56,33.9 203.52,34.78 L 202.3,36.34 C 201.98,35.99 201.62,35.73 201.24,35.56 200.86,35.4 200.46,35.31 200.06,35.31 199.6,35.31 199.25,35.42 199.01,35.64 198.77,35.85 198.65,36.11 198.65,36.42 198.66,36.74 198.81,36.99 199.08,37.17 199.35,37.36 199.76,37.55 200.3,37.76 200.42,37.79 200.58,37.86 200.81,37.95 201.51,38.27 202.05,38.64 202.43,39.06 202.8,39.47 202.99,40.02 202.99,40.69 202.99,41.28 202.84,41.84 202.54,42.38 202.23,42.92 201.77,43.36 201.14,43.7 200.52,44.04 199.74,44.22 198.82,44.22 Z M 209.59,33.85 L 208.34,44 205.66,44 206.9,33.85 209.59,33.85 Z M 207.1,30.34 C 207.11,29.91 207.27,29.55 207.58,29.26 207.88,28.98 208.26,28.83 208.73,28.83 209.13,28.83 209.48,28.94 209.77,29.17 210.07,29.39 210.22,29.72 210.22,30.15 210.22,30.58 210.06,30.95 209.75,31.24 209.44,31.54 209.05,31.69 208.58,31.69 208.2,31.67 207.86,31.55 207.55,31.33 207.25,31.1 207.1,30.78 207.1,30.34 Z M 219.62,33.39 C 220.5,33.39 221.31,33.58 222.04,33.97 222.76,34.35 223.34,34.92 223.76,35.68 224.19,36.44 224.4,37.38 224.4,38.48 224.4,39.49 224.16,40.44 223.67,41.32 223.18,42.21 222.49,42.92 221.59,43.46 220.7,44 219.66,44.26 218.5,44.26 217.7,44.26 217,44.12 216.4,43.82 215.8,43.52 215.3,43.12 214.92,42.61 L 214.73,44 212.04,44 214.34,25.28 217.01,25.28 215.83,34.9 C 216.26,34.46 216.81,34.09 217.48,33.81 218.14,33.53 218.86,33.39 219.62,33.39 Z M 218.18,41.98 C 218.97,41.98 219.62,41.81 220.14,41.47 220.66,41.12 221.04,40.7 221.28,40.18 221.52,39.67 221.64,39.16 221.64,38.65 221.64,37.67 221.37,36.9 220.84,36.34 220.3,35.78 219.58,35.5 218.66,35.5 217.96,35.5 217.33,35.69 216.78,36.07 216.23,36.44 215.82,36.94 215.54,37.57 L 215.26,39.75 C 215.48,40.39 215.82,40.92 216.29,41.35 216.75,41.77 217.38,41.98 218.18,41.98 Z M 231.6,25.28 L 229.32,44 226.63,44 228.91,25.28 231.6,25.28 Z M 238.54,41.96 C 239.19,41.96 239.87,41.74 240.58,41.29 L 241.54,43.38 C 241.02,43.65 240.48,43.86 239.9,44.01 239.33,44.16 238.78,44.24 238.25,44.24 236.58,44.24 235.26,43.79 234.28,42.9 233.29,42 232.8,40.72 232.8,39.06 232.8,38.16 233.02,37.28 233.46,36.4 233.9,35.53 234.57,34.82 235.46,34.26 236.36,33.7 237.45,33.42 238.73,33.42 241.7,33.42 243.44,35.06 243.94,38.36 L 235.9,40.5 C 236.15,40.99 236.52,41.36 237,41.6 237.48,41.84 237.99,41.96 238.54,41.96 Z M 238.66,35.53 C 237.66,35.53 236.89,35.84 236.33,36.48 235.77,37.11 235.49,37.86 235.49,38.74 L 235.49,38.91 241.03,37.4 C 240.86,36.82 240.56,36.37 240.14,36.03 239.73,35.7 239.23,35.53 238.66,35.53 Z M 256.39,44.22 C 255.74,44.22 255.02,44.08 254.24,43.81 253.47,43.54 252.82,43.05 252.29,42.34 L 253.61,40.9 C 254.09,41.48 254.56,41.86 255.01,42.04 255.47,42.23 255.93,42.32 256.39,42.32 256.89,42.32 257.25,42.2 257.48,41.96 257.72,41.72 257.83,41.46 257.83,41.17 257.83,40.9 257.74,40.67 257.54,40.5 257.35,40.32 257.15,40.19 256.93,40.1 256.72,40.01 256.31,39.86 255.72,39.63 254.23,39.04 253.49,38.1 253.49,36.8 253.49,36.32 253.61,35.82 253.85,35.31 254.09,34.8 254.49,34.36 255.06,34 255.63,33.64 256.36,33.46 257.26,33.46 258.86,33.46 260.14,33.9 261.1,34.78 L 259.87,36.34 C 259.55,35.99 259.2,35.73 258.82,35.56 258.43,35.4 258.04,35.31 257.64,35.31 257.18,35.31 256.82,35.42 256.58,35.64 256.34,35.85 256.22,36.11 256.22,36.42 256.24,36.74 256.38,36.99 256.66,37.17 256.93,37.36 257.34,37.55 257.88,37.76 257.99,37.79 258.16,37.86 258.38,37.95 259.09,38.27 259.63,38.64 260,39.06 260.38,39.47 260.57,40.02 260.57,40.69 260.57,41.28 260.42,41.84 260.11,42.38 259.81,42.92 259.34,43.36 258.72,43.7 258.1,44.04 257.32,44.22 256.39,44.22 Z M 278.47,33.85 L 272.64,44.31 272.47,44.31 270.12,37.57 266.4,44.29 266.23,44.29 262.92,33.85 265.56,33.85 267.26,39.06 269.42,35.31 268.92,33.85 271.25,33.85 272.98,39.25 275.83,33.85 278.47,33.85 Z M 291.43,33.85 L 290.21,44 287.52,44 287.69,42.54 C 287.27,42.97 286.72,43.36 286.02,43.71 285.32,44.06 284.5,44.23 283.56,44.22 282.82,44.23 282.12,44.04 281.46,43.64 280.8,43.24 280.26,42.66 279.86,41.9 279.46,41.14 279.26,40.26 279.26,39.27 279.26,38.3 279.5,37.36 279.97,36.45 280.44,35.55 281.11,34.81 281.98,34.24 282.84,33.68 283.83,33.39 284.95,33.39 286.65,33.39 287.86,34.02 288.58,35.26 L 288.96,33.85 291.43,33.85 Z M 288.26,37.76 C 288.15,37.1 287.84,36.58 287.32,36.19 286.8,35.8 286.17,35.6 285.43,35.6 284.66,35.6 284.03,35.78 283.52,36.13 283.02,36.48 282.65,36.92 282.41,37.44 282.17,37.96 282.05,38.46 282.05,38.96 282.05,39.89 282.32,40.64 282.88,41.2 283.43,41.77 284.15,42.06 285.05,42.06 285.67,42.06 286.25,41.87 286.78,41.5 287.3,41.14 287.71,40.62 288,39.97 L 288.26,37.76 Z M 301.34,33.39 C 302.21,33.39 303,33.58 303.72,33.97 304.44,34.35 305.01,34.89 305.42,35.59 305.84,36.28 306.05,37.09 306.05,38 306.05,39.12 305.78,40.16 305.26,41.12 304.73,42.08 303.99,42.84 303.04,43.41 302.08,43.98 300.98,44.26 299.74,44.26 299.16,44.26 298.59,44.16 298.02,43.94 297.45,43.72 296.98,43.43 296.62,43.06 L 295.97,48.87 293.3,48.87 295.2,33.66 297.53,33.66 297.5,34.83 C 298.9,33.87 300.18,33.39 301.34,33.39 Z M 299.66,42.01 C 300.37,42.01 301,41.84 301.56,41.5 302.12,41.17 302.55,40.72 302.86,40.17 303.16,39.62 303.31,39.03 303.31,38.41 303.31,37.58 303.02,36.89 302.45,36.34 301.87,35.8 301.19,35.53 300.41,35.53 299.72,35.53 299.1,35.72 298.56,36.09 298.02,36.47 297.58,37 297.24,37.69 L 296.98,39.8 C 297.14,40.42 297.44,40.95 297.88,41.37 298.32,41.8 298.91,42.01 299.66,42.01 Z M 311.54,44.22 C 310.89,44.22 310.17,44.08 309.4,43.81 308.62,43.54 307.97,43.05 307.44,42.34 L 308.76,40.9 C 309.24,41.48 309.71,41.86 310.16,42.04 310.62,42.23 311.08,42.32 311.54,42.32 312.04,42.32 312.4,42.2 312.64,41.96 312.87,41.72 312.98,41.46 312.98,41.17 312.98,40.9 312.89,40.67 312.7,40.5 312.5,40.32 312.3,40.19 312.08,40.1 311.87,40.01 311.46,39.86 310.87,39.63 309.38,39.04 308.64,38.1 308.64,36.8 308.64,36.32 308.76,35.82 309,35.31 309.24,34.8 309.64,34.36 310.21,34 310.78,33.64 311.51,33.46 312.41,33.46 314.01,33.46 315.29,33.9 316.25,34.78 L 315.02,36.34 C 314.7,35.99 314.35,35.73 313.97,35.56 313.58,35.4 313.19,35.31 312.79,35.31 312.33,35.31 311.98,35.42 311.74,35.64 311.5,35.85 311.38,36.11 311.38,36.42 311.39,36.74 311.54,36.99 311.81,37.17 312.08,37.36 312.49,37.55 313.03,37.76 313.14,37.79 313.31,37.86 313.54,37.95 314.24,38.27 314.78,38.64 315.16,39.06 315.53,39.47 315.72,40.02 315.72,40.69 315.72,41.28 315.57,41.84 315.26,42.38 314.96,42.92 314.5,43.36 313.87,43.7 313.25,44.04 312.47,44.22 311.54,44.22 Z M 322.51,25.9 L 320.83,39.58 318.43,39.58 320.11,25.9 322.51,25.9 Z M 319.15,44.19 C 318.69,44.19 318.32,44.07 318.05,43.83 317.78,43.59 317.64,43.29 317.64,42.92 317.64,42.5 317.79,42.15 318.08,41.86 318.38,41.58 318.75,41.43 319.2,41.43 319.65,41.43 320,41.56 320.27,41.8 320.53,42.05 320.66,42.35 320.66,42.7 320.66,42.85 320.66,42.95 320.64,43.02 320.58,43.38 320.41,43.67 320.14,43.88 319.86,44.09 319.54,44.19 319.15,44.19 Z M 319.15,44.19')
					]),
				_List_Nil)
			]));
};
var $author$project$View$bannerNotifications = function (model) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'shuffling-notification',
			$author$project$SVGs$Elements$Shuffling$shufflingNotification(model.a5.dh))
		]);
};
var $author$project$Services$CssSelector$boardItemsContainer = $elm$svg$Svg$Attributes$id('boardItemsContainer');
var $author$project$Extras$Array$concat = function (twoDimensionalArray) {
	return A3(
		$elm$core$Array$foldl,
		F2(
			function (item, newArray) {
				return A2($elm$core$Array$append, newArray, item);
			}),
		$elm$core$Array$empty,
		twoDimensionalArray);
};
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $author$project$Services$Matrix$map = F2(
	function (_function, matrix) {
		return A2(
			$elm$core$Array$map,
			$elm$core$Array$map(_function),
			matrix);
	});
var $author$project$Services$CssSelector$boardItemSelector = $elm$svg$Svg$Attributes$class('board-item');
var $author$project$Extras$Svg$ViewBox = F4(
	function (x, y, width, height) {
		return {aE: height, bk: width, bl: x, bm: y};
	});
var $author$project$Services$Shape$boardItemViewBox = A4($author$project$Extras$Svg$ViewBox, 0, 0, '200', '200');
var $author$project$Services$ShapeColor$highlightColorComponent = F2(
	function (component, amount) {
		return $elm$core$Basics$round((((component / 255) * (1 - amount)) + amount) * 255.0);
	});
var $author$project$Services$ShapeColor$colorWithHighlight = F2(
	function (color, amount) {
		return {
			bE: A2($author$project$Services$ShapeColor$highlightColorComponent, color.bE, amount),
			ch: A2($author$project$Services$ShapeColor$highlightColorComponent, color.ch, amount),
			c6: A2($author$project$Services$ShapeColor$highlightColorComponent, color.c6, amount)
		};
	});
var $author$project$Services$ShapeColor$bombColorDarker = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithHighlight, color, 0.2);
};
var $author$project$Services$ShapeColor$bombColorLighter = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithHighlight, color, 0.5);
};
var $elm$svg$Svg$Attributes$fx = _VirtualDom_attribute('fx');
var $elm$svg$Svg$Attributes$fy = _VirtualDom_attribute('fy');
var $author$project$Services$ShapeColor$getStopColorAttribute = function (color) {
	return $elm$svg$Svg$Attributes$stopColor(
		$author$project$Services$ShapeColor$getColorString(color));
};
var $author$project$Services$ShapeColor$highlightColor = {bE: 255, ch: 255, c6: 255};
var $author$project$Services$ShapeColor$highlightColorAttribute = function (attributeFunction) {
	return attributeFunction(
		$author$project$Services$ShapeColor$getColorString($author$project$Services$ShapeColor$highlightColor));
};
var $elm$svg$Svg$radialGradient = $elm$svg$Svg$trustedNode('radialGradient');
var $author$project$SVGs$Bonuses$BombBonus$definitions = function (color) {
	return A2(
		$elm$svg$Svg$defs,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$filter,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasBombDrawing-shadowCirlce-outer'),
						$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$feGaussianBlur,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stdDeviation('1.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feOffset,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$dx('2'),
								$elm$svg$Svg$Attributes$dy('2'),
								$elm$svg$Svg$Attributes$result('blur')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feFlood,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
								$elm$svg$Svg$Attributes$floodOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('blur'),
								$elm$svg$Svg$Attributes$operator('in'),
								$elm$svg$Svg$Attributes$result('colorShadow')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in_('SourceGraphic'),
								$elm$svg$Svg$Attributes$in2('colorShadow'),
								$elm$svg$Svg$Attributes$operator('over')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$radialGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasBombDrawing-bombGradient-bombBackground'),
						$elm$svg$Svg$Attributes$cx('77.1'),
						$elm$svg$Svg$Attributes$cy('80.21'),
						$elm$svg$Svg$Attributes$r('104.69'),
						$elm$svg$Svg$Attributes$fx('77.07'),
						$elm$svg$Svg$Attributes$fy('122.58'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.043'),
								$author$project$Services$ShapeColor$getStopColorAttribute(
								$author$project$Services$ShapeColor$bombColorDarker(color)),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$getStopColorAttribute(
								$author$project$Services$ShapeColor$bombColorLighter(color)),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasBombDrawing-gradient4-highlight'),
						$elm$svg$Svg$Attributes$x1('60.73'),
						$elm$svg$Svg$Attributes$y1('27.32'),
						$elm$svg$Svg$Attributes$x2('79.14'),
						$elm$svg$Svg$Attributes$y2('94.07'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.47'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$filter,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasBombDrawing-bombShadow-outer'),
						$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$feGaussianBlur,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stdDeviation('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feOffset,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$dx('0'),
								$elm$svg$Svg$Attributes$dy('2'),
								$elm$svg$Svg$Attributes$result('blur')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feFlood,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$floodColor('rgb(0, 0, 0)'),
								$elm$svg$Svg$Attributes$floodOpacity('0.8')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('blur'),
								$elm$svg$Svg$Attributes$operator('in'),
								$elm$svg$Svg$Attributes$result('colorShadow')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in_('SourceGraphic'),
								$elm$svg$Svg$Attributes$in2('colorShadow'),
								$elm$svg$Svg$Attributes$operator('over')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$SVGs$Bonuses$BombBonus$bombBonus = F2(
	function (attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return _Utils_Tuple2(
			id,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						$author$project$SVGs$Bonuses$BombBonus$definitions(
						$author$project$Services$Board$boardKanaColorToColor(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasBombDrawing-bomb')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasBombDrawing-background'),
										$elm$svg$Svg$Attributes$filter('url(#canvasBombDrawing-shadowCirlce-outer)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasBombDrawing-bombBackground'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#canvasBombDrawing-bombGradient-bombBackground)'),
												$elm$svg$Svg$Attributes$d('M 133.1,80.21 C 133.1,111.69 108.03,137.21 77.1,137.21 46.18,137.21 21.1,111.69 21.1,80.21 21.1,48.73 46.18,23.21 77.1,23.21 108.03,23.21 133.1,48.73 133.1,80.21 Z M 133.1,80.21')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasBombDrawing-highlight'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#canvasBombDrawing-gradient4-highlight)'),
												$elm$svg$Svg$Attributes$d('M 77.1,26.44 C 107.55,26.44 125.71,55.19 125.71,74 125.71,92.82 107.55,73.76 77.1,73.76 46.65,73.76 28.5,92.82 28.5,74 28.5,55.19 46.65,26.44 77.1,26.44 Z M 77.1,26.44')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasBombDrawing-groupFuse'),
										$elm$svg$Svg$Attributes$filter('url(#canvasBombDrawing-bombShadow-outer)'),
										$elm$svg$Svg$Attributes$transform('translate(16.64, 38.77) rotate(-36.26)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasBombDrawing-fuseBase'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('rgb(158, 161, 179)'),
												$elm$svg$Svg$Attributes$d('M 47.72,21.38 C 47.72,29.32 36.59,35.76 22.86,35.76 9.13,35.76 -2,29.32 -2,21.38 -2,13.44 9.13,7 22.86,7 36.59,7 47.72,13.44 47.72,21.38 Z M 47.72,21.38')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasBombDrawing-fuseShadow'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('rgb(69, 76, 104)'),
												$elm$svg$Svg$Attributes$d('M 47.49,22.28 C 47.49,26.07 47.49,29.19 47.49,29.19 47.49,29.27 47.49,29.37 47.49,29.37 47.49,37.66 36.48,44.39 22.91,44.39 9.33,44.39 -1.67,37.66 -1.67,29.37 -1.67,29.37 -1.67,29.27 -1.67,29.19 -1.67,29.17 -1.67,24.46 -1.67,22.28 L -1.55,22.28 C -0.65,30.08 9.98,36.23 22.97,36.23 35.95,36.23 46.58,30.08 47.48,22.28 L 47.49,22.28 Z M 47.49,22.28')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasBombDrawing-baseHighlight'),
												$elm$svg$Svg$Attributes$opacity('0.8'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$fill),
												$elm$svg$Svg$Attributes$d('M 40.04,1 C 44.96,7.7 40.07,19.64 29.12,27.67 18.17,35.7 5.32,36.77 0.4,30.08 0.26,29.88 0.13,29.68 -0,29.48 5.43,35.05 17.51,33.68 27.87,26.07 38.5,18.28 43.42,6.79 39.19,0 39.5,0.31 39.78,0.65 40.04,1 Z M 40.04,1'),
												$elm$svg$Svg$Attributes$transform('translate(15.75, -3.17) rotate(36.26)')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasBombDrawing-fuseString'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stroke),
												$elm$svg$Svg$Attributes$strokeWidth('10'),
												$elm$svg$Svg$Attributes$strokeLinecap('round'),
												$elm$svg$Svg$Attributes$strokeLinejoin('round'),
												$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
												$elm$svg$Svg$Attributes$fill('none'),
												$elm$svg$Svg$Attributes$d('M 6.26,23.31 C 6.26,23.31 -5.06,13.92 3.14,3.1'),
												$elm$svg$Svg$Attributes$transform('translate(29.94, -8.12) rotate(36.26)')
											]),
										_List_Nil)
									]))
							]))
					])));
	});
var $author$project$Services$ShapeColor$shadowColorComponent = F2(
	function (component, amount) {
		return $elm$core$Basics$round(((component / 255) * (1 - amount)) * 255);
	});
var $author$project$Services$ShapeColor$colorWithShadow = F2(
	function (color, amount) {
		return {
			bE: A2($author$project$Services$ShapeColor$shadowColorComponent, color.bE, amount),
			ch: A2($author$project$Services$ShapeColor$shadowColorComponent, color.ch, amount),
			c6: A2($author$project$Services$ShapeColor$shadowColorComponent, color.c6, amount)
		};
	});
var $author$project$Services$ShapeColor$backgroundShadowColor = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithShadow, color, 0.5);
};
var $author$project$Services$ShapeColor$getCenterGradientColor = F2(
	function (color1, color2) {
		return {
			bE: $elm$core$Basics$round((color1.bE + color2.bE) / 2),
			ch: $elm$core$Basics$round((color1.ch + color2.ch) / 2),
			c6: $elm$core$Basics$round((color1.c6 + color2.c6) / 2)
		};
	});
var $author$project$Services$ShapeColor$gradientKanaBackgroundColor = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithHighlight, color, 0.3);
};
var $author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute = function (color) {
	return $author$project$Services$ShapeColor$getStopColorAttribute(
		$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color));
};
var $elm$svg$Svg$Attributes$k2 = _VirtualDom_attribute('k2');
var $elm$svg$Svg$Attributes$k3 = _VirtualDom_attribute('k3');
var $author$project$Services$ShapeColor$kanaLightColor = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithHighlight, color, 0.7);
};
var $author$project$Services$ShapeColor$kanaShadowColor = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithShadow, color, 0.1);
};
var $author$project$Services$ShapeColor$kanaShadowColorAttribute = function (color) {
	return $author$project$Services$ShapeColor$getStopColorAttribute(
		$author$project$Services$ShapeColor$kanaShadowColor(color));
};
var $author$project$SVGs$Shapes$DiamondWithKana$definitions = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-diamondGradient-outerDiamond'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('5'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('195'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor(
							$author$project$Services$ShapeColor$getColorString(
								A2(
									$author$project$Services$ShapeColor$getCenterGradientColor,
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
									$author$project$Services$ShapeColor$kanaShadowColor(color)))),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-innerSquareGradient-innerDiamond'),
					$elm$svg$Svg$Attributes$x1('99'),
					$elm$svg$Svg$Attributes$y1('14'),
					$elm$svg$Svg$Attributes$x2('99'),
					$elm$svg$Svg$Attributes$y2('184'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor(
							$author$project$Services$ShapeColor$getColorString(
								A2(
									$author$project$Services$ShapeColor$getCenterGradientColor,
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
									color))),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$getStopColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-shadow2-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('1'),
							$elm$svg$Svg$Attributes$dy('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor(
							$author$project$Services$ShapeColor$getColorString(
								$author$project$Services$ShapeColor$kanaShadowColor(color))),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-squareBottomHighlight-outerDiamond2'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('5'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('195'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.44'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-diamondHighlightGradientReversed-bottom'),
					$elm$svg$Svg$Attributes$x1('101.18'),
					$elm$svg$Svg$Attributes$y1('136.66'),
					$elm$svg$Svg$Attributes$x2('101.18'),
					$elm$svg$Svg$Attributes$y2('186.71'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.26'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-diamondHighlightGradient-top'),
					$elm$svg$Svg$Attributes$x1('99'),
					$elm$svg$Svg$Attributes$y1('14'),
					$elm$svg$Svg$Attributes$x2('99'),
					$elm$svg$Svg$Attributes$y2('96'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.32'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-innerSquareGradiant-bezier2'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('25'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('175'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.19'),
							$elm$svg$Svg$Attributes$stopColor(
							$author$project$Services$ShapeColor$getColorString(
								A2(
									$author$project$Services$ShapeColor$getCenterGradientColor,
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
									$author$project$Services$ShapeColor$kanaLightColor(color)))),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$getStopColorAttribute(
							$author$project$Services$ShapeColor$kanaLightColor(color)),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-shadow3-inner'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceAlpha'),
							$elm$svg$Svg$Attributes$stdDeviation('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('SourceAlpha'),
							$elm$svg$Svg$Attributes$operator('arithmetic'),
							$elm$svg$Svg$Attributes$k2('-1.15'),
							$elm$svg$Svg$Attributes$k3('1.15'),
							$elm$svg$Svg$Attributes$result('shadowDiff')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor(
							$author$project$Services$ShapeColor$getColorString(color)),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('shadowDiff'),
							$elm$svg$Svg$Attributes$operator('in')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('SourceGraphic'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-diamondInnerHighlightGradientReversed-bezier4'),
					$elm$svg$Svg$Attributes$x1('99.68'),
					$elm$svg$Svg$Attributes$y1('117.66'),
					$elm$svg$Svg$Attributes$x2('99.68'),
					$elm$svg$Svg$Attributes$y2('167.71'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.58'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.82'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-diamondInnerHighlight-bezier'),
					$elm$svg$Svg$Attributes$x1('99.68'),
					$elm$svg$Svg$Attributes$y1('87.04'),
					$elm$svg$Svg$Attributes$x2('99.68'),
					$elm$svg$Svg$Attributes$y2('37'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.54'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.85'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]);
};
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$Attributes$fontWeight = _VirtualDom_attribute('font-weight');
var $author$project$Services$ShapeColor$kanaTextColor = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithShadow, color, 0.5);
};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $author$project$SVGs$Shapes$DiamondWithKana$innerDiamondWithText = F2(
	function (kanaString, color) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondWithKana-groupInnerDiamond')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('diamondWithKana-bezier2'),
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-innerSquareGradiant-bezier2)'),
							$elm$svg$Svg$Attributes$filter('url(#diamondWithKana-shadow3-inner)'),
							$elm$svg$Svg$Attributes$d('M 100,25 C 125,25 175,75 175,100 175,125 125,175 100,175 75,175 25,125 25,100 25,75 75,25 100,25 Z M 100,25')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('diamondWithKana-highlights')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('diamondWithKana-bezier4'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-diamondInnerHighlightGradientReversed-bezier4)'),
									$elm$svg$Svg$Attributes$d('M 99.68,117.66 C 115.12,117.66 146,125 146,133.34 146,141.68 115.12,167.71 99.68,167.71 84.24,167.71 53.37,141.68 53.37,133.34 53.37,125 84.24,117.66 99.68,117.66 Z M 99.68,117.66')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('diamondWithKana-bezier'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-diamondInnerHighlight-bezier)'),
									$elm$svg$Svg$Attributes$d('M 99.68,87.04 C 115.12,87.04 146,79.7 146,71.36 146,63.02 115.12,37 99.68,37 84.24,37 53.37,63.02 53.37,71.36 53.37,79.7 84.24,87.04 99.68,87.04 Z M 99.68,87.04')
								]),
							_List_Nil)
						])),
					A3(
					$elm$svg$Svg$node,
					'text',
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(
							$author$project$Services$ShapeColor$getColorString(
								$author$project$Services$ShapeColor$kanaTextColor(color))),
							$elm$svg$Svg$Attributes$fontFamily('Helvetica-Bold, Helvetica, sans-serif'),
							$elm$svg$Svg$Attributes$fontWeight('bold'),
							$elm$svg$Svg$Attributes$fontSize('95'),
							$elm$svg$Svg$Attributes$x('54'),
							$elm$svg$Svg$Attributes$y('47'),
							$elm$svg$Svg$Attributes$textAnchor('middle')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$tspan,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$x('50%'),
									$elm$svg$Svg$Attributes$y('70%')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(kanaString)
								]))
						]))
				]));
	});
var $author$project$SVGs$Shapes$DiamondWithKana$diamondWithKana = F3(
	function (kanaString, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return _Utils_Tuple2(
			id,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Shapes$DiamondWithKana$definitions(
							$author$project$Services$Board$boardKanaColorToColor(color))),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('diamondWithKana-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('diamondWithKana-group2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('diamondWithKana-group3'),
												$elm$svg$Svg$Attributes$transform('')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('diamondWithKana-group4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('diamondWithKana-diamondShadow'),
																$elm$svg$Svg$Attributes$fillRule('evenodd'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill(
																$author$project$Services$ShapeColor$getColorString(
																	$author$project$Services$ShapeColor$backgroundShadowColor(
																		$author$project$Services$Board$boardKanaColorToColor(color)))),
																$elm$svg$Svg$Attributes$d('M 102,7 C 133.67,7 197,70.33 197,102 197,133.67 133.67,197 102,197 70.33,197 7,133.67 7,102 7,70.33 70.33,7 102,7 Z M 102,7')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('diamondWithKana-outerDiamond'),
																$elm$svg$Svg$Attributes$fillRule('evenodd'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-diamondGradient-outerDiamond)'),
																$elm$svg$Svg$Attributes$d('M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('diamondWithKana-innerDiamond'),
																$elm$svg$Svg$Attributes$fillRule('evenodd'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-innerSquareGradient-innerDiamond)'),
																$elm$svg$Svg$Attributes$filter('url(#diamondWithKana-shadow2-outer)'),
																$elm$svg$Svg$Attributes$d('M 99,14 C 127.33,14 184,70.67 184,99 184,127.33 127.33,184 99,184 70.67,184 14,127.33 14,99 14,70.67 70.67,14 99,14 Z M 99,14')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$g,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('diamondWithKana-groupHighlights')
															]),
														_List_fromArray(
															[
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('diamondWithKana-outerDiamond2'),
																		$elm$svg$Svg$Attributes$fillRule('evenodd'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-squareBottomHighlight-outerDiamond2)'),
																		$elm$svg$Svg$Attributes$d('M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('diamondWithKana-bottom'),
																		$elm$svg$Svg$Attributes$opacity('0.4'),
																		$elm$svg$Svg$Attributes$fillRule('evenodd'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-diamondHighlightGradientReversed-bottom)'),
																		$elm$svg$Svg$Attributes$d('M 101.18,136.66 C 116.79,136.66 148,144 148,152.34 148,160.68 116.79,186.71 101.18,186.71 85.58,186.71 54.37,160.68 54.37,152.34 54.37,144 85.58,136.66 101.18,136.66 Z M 101.18,136.66')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('diamondWithKana-top'),
																		$elm$svg$Svg$Attributes$fillRule('evenodd'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#diamondWithKana-diamondHighlightGradient-top)'),
																		$elm$svg$Svg$Attributes$d('M 99,14 C 125.68,14 165,51.61 165,70.41 165,89.21 125.68,96 99,96 72.32,96 33,89.21 33,70.41 33,51.61 72.32,14 99,14 Z M 99,14')
																	]),
																_List_Nil)
															]))
													]))
											]))
									])),
								function () {
								if (!kanaString.$) {
									var text = kanaString.a;
									return A2(
										$author$project$SVGs$Shapes$DiamondWithKana$innerDiamondWithText,
										text,
										$author$project$Services$Board$boardKanaColorToColor(color));
								} else {
									return $elm$svg$Svg$text('');
								}
							}()
							]))
					])));
	});
var $author$project$SVGs$Bonuses$FiveInARowBonus$definitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-shadowCirlce-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('1.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('2'),
							$elm$svg$Svg$Attributes$dy('2'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-gradientGreen-ovalGreen'),
					$elm$svg$Svg$Attributes$x1('157.55'),
					$elm$svg$Svg$Attributes$y1('44.43'),
					$elm$svg$Svg$Attributes$x2('42.45'),
					$elm$svg$Svg$Attributes$y2('155.57'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.04'),
							$elm$svg$Svg$Attributes$stopColor('rgb(47, 225, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.25'),
							$elm$svg$Svg$Attributes$stopColor('rgb(24, 112, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.42'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-gradientBlue-ovalBlue'),
					$elm$svg$Svg$Attributes$x1('47.51'),
					$elm$svg$Svg$Attributes$y1('39.62'),
					$elm$svg$Svg$Attributes$x2('152.49'),
					$elm$svg$Svg$Attributes$y2('160.38'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.07'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 21, 255)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.35'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 11, 128)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.78'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-gradientYellow-ovalYellow'),
					$elm$svg$Svg$Attributes$x1('174.71'),
					$elm$svg$Svg$Attributes$y1('128.68'),
					$elm$svg$Svg$Attributes$x2('25.29'),
					$elm$svg$Svg$Attributes$y2('71.32'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.03'),
							$elm$svg$Svg$Attributes$stopColor('rgb(255, 240, 55)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.22'),
							$elm$svg$Svg$Attributes$stopColor('rgb(128, 120, 27)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.38'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-gradientRed-ovalRed'),
					$elm$svg$Svg$Attributes$x1('113.89'),
					$elm$svg$Svg$Attributes$y1('178.8'),
					$elm$svg$Svg$Attributes$x2('86.11'),
					$elm$svg$Svg$Attributes$y2('21.2'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(229, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.45'),
							$elm$svg$Svg$Attributes$stopColor('rgb(114, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.57'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-gradientPurple-ovalPurple'),
					$elm$svg$Svg$Attributes$x1('20.11'),
					$elm$svg$Svg$Attributes$y1('104.19'),
					$elm$svg$Svg$Attributes$x2('179.89'),
					$elm$svg$Svg$Attributes$y2('95.81'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.07'),
							$elm$svg$Svg$Attributes$stopColor('rgb(196, 93, 255)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.3'),
							$elm$svg$Svg$Attributes$stopColor('rgb(98, 47, 128)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.44'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-gradient4-bezier'),
					$elm$svg$Svg$Attributes$x1('76.61'),
					$elm$svg$Svg$Attributes$y1('25.76'),
					$elm$svg$Svg$Attributes$x2('102.91'),
					$elm$svg$Svg$Attributes$y2('119.44'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.47'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas3-kanjiShadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('1.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('1'),
							$elm$svg$Svg$Attributes$dy('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Bonuses$FiveInARowBonus$fiveInARowBonus = function (attributes) {
	return A2(
		$elm$svg$Svg$svg,
		attributes,
		_List_fromArray(
			[
				$author$project$SVGs$Bonuses$FiveInARowBonus$definitions,
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvas3-group2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvas3-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-oval2'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(53, 53, 53)'),
										$elm$svg$Svg$Attributes$filter('url(#canvas3-shadowCirlce-outer)'),
										$elm$svg$Svg$Attributes$cx('100'),
										$elm$svg$Svg$Attributes$cy('100'),
										$elm$svg$Svg$Attributes$r('80')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-ovalGreen'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#canvas3-gradientGreen-ovalGreen)'),
										$elm$svg$Svg$Attributes$cx('100'),
										$elm$svg$Svg$Attributes$cy('100'),
										$elm$svg$Svg$Attributes$r('80')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-ovalBlue'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#canvas3-gradientBlue-ovalBlue)'),
										$elm$svg$Svg$Attributes$cx('100'),
										$elm$svg$Svg$Attributes$cy('100'),
										$elm$svg$Svg$Attributes$r('80')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-ovalYellow'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#canvas3-gradientYellow-ovalYellow)'),
										$elm$svg$Svg$Attributes$cx('100'),
										$elm$svg$Svg$Attributes$cy('100'),
										$elm$svg$Svg$Attributes$r('80')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-ovalRed'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#canvas3-gradientRed-ovalRed)'),
										$elm$svg$Svg$Attributes$cx('100'),
										$elm$svg$Svg$Attributes$cy('100'),
										$elm$svg$Svg$Attributes$r('80')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-ovalPurple'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#canvas3-gradientPurple-ovalPurple)'),
										$elm$svg$Svg$Attributes$cx('100'),
										$elm$svg$Svg$Attributes$cy('100'),
										$elm$svg$Svg$Attributes$r('80')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-bezier'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#canvas3-gradient4-bezier)'),
										$elm$svg$Svg$Attributes$d('M 100,24.53 C 143.5,24.53 169.43,64.88 169.43,91.28 169.43,117.69 143.5,90.94 100,90.94 56.5,90.94 30.57,117.69 30.57,91.28 30.57,64.88 56.5,24.53 100,24.53 Z M 100,24.53')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvas3-text7'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$fill),
										$elm$svg$Svg$Attributes$filter('url(#canvas3-kanjiShadow-outer)'),
										$elm$svg$Svg$Attributes$d('M 147.27,83.87 C 149.47,83.87 150.68,81.91 150.68,79.52 150.68,77.23 149.47,75.38 147.27,75.38 L 103.68,75.38 C 104.23,68.85 104.45,61.88 104.45,54.26 104.45,51.87 102.8,50.56 100.04,50.56 97.4,50.56 95.53,51.65 95.53,54.26 95.53,62.32 95.31,69.29 94.87,75.38 L 55.02,75.38 C 52.82,75.38 51.61,77.23 51.61,79.52 51.61,81.91 52.82,83.87 55.02,83.87 L 93.99,83.87 C 92.56,94.33 90.03,102.49 85.51,110.66 78.47,123.61 68.12,132.43 52.82,139.29 51.28,140.05 50.4,141.36 50.4,142.88 50.4,143.65 50.62,144.52 51.06,145.28 52.05,147.24 53.59,148 55.13,148 55.79,148 56.56,147.78 57.33,147.46 72.2,140.81 84.96,129.49 92.78,115.34 96.3,109.02 98.83,102.49 100.59,95.2 103.79,105.76 108.85,115.12 115.12,123.07 122.94,132.98 133.84,141.79 144.4,146.91 145.29,147.35 146.28,147.56 147.16,147.56 148.7,147.56 150.24,146.8 151.12,145.28 151.67,144.41 152,143.32 152,142.34 152,140.81 151.23,139.4 149.47,138.64 139.89,134.28 129.87,126.99 121.73,117.41 114.13,108.48 107.86,97.27 104.56,83.87 L 147.27,83.87 Z M 147.27,83.87')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$SVGs$Shapes$HexagonWithKana$innerHexagonWithText = F2(
	function (kanaString, color) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('hexagonWithKana-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('hexagonWithKana-innerHexagon'),
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-innerSquareGradiant-innerHexagon)'),
							$elm$svg$Svg$Attributes$filter('url(#hexagonWithKana-shadow3-inner)'),
							$elm$svg$Svg$Attributes$d('M 168,99.93 C 168,103.38 167.11,106.78 165.43,109.77 L 140.96,153.16 C 137.54,159.23 131.16,163 124.32,163 L 75.39,163 C 68.55,163 62.17,159.23 58.75,153.16 L 34.29,109.77 C 32.6,106.78 31.71,103.38 31.71,99.93 31.71,96.48 32.6,93.07 34.29,90.08 L 58.75,46.69 C 62.17,40.62 68.55,36.85 75.39,36.85 L 124.32,36.85 C 131.16,36.85 137.54,40.62 140.96,46.69 L 165.43,90.08 C 167.11,93.07 168,96.48 168,99.93 Z M 168,99.93')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('hexagonWithKana-highlights')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier3'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-hexagonBottomInnerHighlightGradient-bezier3)'),
									$elm$svg$Svg$Attributes$d('M 168,99.93 C 168,103.38 167.11,106.78 165.42,109.77 L 140.96,153.16 C 137.54,159.23 131.16,163 124.32,163 L 75.39,163 C 68.55,163 62.17,159.23 58.75,153.16 L 34.28,109.77 C 32.6,106.78 31.71,103.38 31.71,99.93 31.71,96.48 32.6,93.07 34.28,90.08 L 58.75,46.69 C 62.17,40.62 68.55,36.85 75.39,36.85 L 124.32,36.85 C 131.16,36.85 137.54,40.62 140.96,46.69 L 165.42,90.08 C 167.11,93.07 168,96.48 168,99.93 Z M 168,99.93')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier'),
									$elm$svg$Svg$Attributes$opacity('0.9'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-hexagonInnerHighlight-bezier)'),
									$elm$svg$Svg$Attributes$d('M 163.56,102.23 C 163.56,105.44 162.73,108.61 161.16,111.39 L 138.4,151.76 C 135.21,157.41 129.28,160.92 122.91,160.92 L 77.39,160.92 C 71.02,160.92 65.08,157.41 61.9,151.76 L 39.14,111.39 C 37.57,108.61 36.74,105.44 36.74,102.23 36.74,99.02 37.57,95.86 39.14,93.08 L 61.9,52.7 C 65.08,47.06 71.02,43.55 77.39,43.55 L 122.91,43.55 C 129.28,43.55 135.21,47.06 138.4,52.7 L 161.16,93.08 C 162.73,95.86 163.56,99.02 163.56,102.23 Z M 163.56,102.23')
								]),
							_List_Nil)
						])),
					A3(
					$elm$svg$Svg$node,
					'text',
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(
							$author$project$Services$ShapeColor$getColorString(
								$author$project$Services$ShapeColor$kanaTextColor(color))),
							$elm$svg$Svg$Attributes$fontFamily('Helvetica-Bold, Helvetica, sans-serif'),
							$elm$svg$Svg$Attributes$fontWeight('bold'),
							$elm$svg$Svg$Attributes$fontSize('95'),
							$elm$svg$Svg$Attributes$x('52'),
							$elm$svg$Svg$Attributes$y('36'),
							$elm$svg$Svg$Attributes$textAnchor('middle')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$tspan,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$x('50%'),
									$elm$svg$Svg$Attributes$y('70%')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(kanaString)
								]))
						]))
				]));
	});
var $author$project$SVGs$Shapes$HexagonWithKana$hexagonWithKana = F3(
	function (kanaString, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return _Utils_Tuple2(
			id,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-innerSquareGradient-bezier4'),
										$elm$svg$Svg$Attributes$x1('101.08'),
										$elm$svg$Svg$Attributes$y1('25.3'),
										$elm$svg$Svg$Attributes$x2('101.08'),
										$elm$svg$Svg$Attributes$y2('174.46'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0'),
												$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(
												$author$project$Services$Board$boardKanaColorToColor(color)),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$kanaShadowColorAttribute(
												$author$project$Services$Board$boardKanaColorToColor(color)),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$filter,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-shadow2-outer'),
										$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$feGaussianBlur,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$stdDeviation('2')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feOffset,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$dx('1'),
												$elm$svg$Svg$Attributes$dy('1'),
												$elm$svg$Svg$Attributes$result('blur')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feFlood,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$floodColor(
												$author$project$Services$ShapeColor$getColorString(
													$author$project$Services$ShapeColor$kanaShadowColor(
														$author$project$Services$Board$boardKanaColorToColor(color)))),
												$elm$svg$Svg$Attributes$floodOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feComposite,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$in2('blur'),
												$elm$svg$Svg$Attributes$operator('in'),
												$elm$svg$Svg$Attributes$result('colorShadow')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feComposite,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$in_('SourceGraphic'),
												$elm$svg$Svg$Attributes$in2('colorShadow'),
												$elm$svg$Svg$Attributes$operator('over')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-squareBottomHighlight-bezier5'),
										$elm$svg$Svg$Attributes$x1('100.6'),
										$elm$svg$Svg$Attributes$y1('16.71'),
										$elm$svg$Svg$Attributes$x2('100.6'),
										$elm$svg$Svg$Attributes$y2('184'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.44'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-hexagonBottomHighlightGradient-bezier7'),
										$elm$svg$Svg$Attributes$x1('65.05'),
										$elm$svg$Svg$Attributes$y1('38.36'),
										$elm$svg$Svg$Attributes$x2('142.16'),
										$elm$svg$Svg$Attributes$y2('171.92'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.79'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-hexagonHighlightGradient-bezier8'),
										$elm$svg$Svg$Attributes$x1('100.6'),
										$elm$svg$Svg$Attributes$y1('24.71'),
										$elm$svg$Svg$Attributes$x2('100.6'),
										$elm$svg$Svg$Attributes$y2('164.42'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.23'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.53'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-innerSquareGradiant-innerHexagon'),
										$elm$svg$Svg$Attributes$x1('99.86'),
										$elm$svg$Svg$Attributes$y1('36.85'),
										$elm$svg$Svg$Attributes$x2('99.86'),
										$elm$svg$Svg$Attributes$y2('163'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0'),
												$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(
												$author$project$Services$Board$boardKanaColorToColor(color)),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.19'),
												$elm$svg$Svg$Attributes$stopColor(
												$author$project$Services$ShapeColor$getColorString(
													A2(
														$author$project$Services$ShapeColor$getCenterGradientColor,
														$author$project$Services$ShapeColor$gradientKanaBackgroundColor(
															$author$project$Services$Board$boardKanaColorToColor(color)),
														$author$project$Services$ShapeColor$kanaLightColor(
															$author$project$Services$Board$boardKanaColorToColor(color))))),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$getStopColorAttribute(
												$author$project$Services$ShapeColor$kanaLightColor(
													$author$project$Services$Board$boardKanaColorToColor(color))),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$filter,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-shadow3-inner'),
										$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$feGaussianBlur,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$in_('SourceAlpha'),
												$elm$svg$Svg$Attributes$stdDeviation('1'),
												$elm$svg$Svg$Attributes$result('blur')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feOffset,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$dx('0'),
												$elm$svg$Svg$Attributes$dy('6')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feComposite,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$in2('SourceAlpha'),
												$elm$svg$Svg$Attributes$operator('arithmetic'),
												$elm$svg$Svg$Attributes$k2('-1.15'),
												$elm$svg$Svg$Attributes$k3('1.15'),
												$elm$svg$Svg$Attributes$result('shadowDiff')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feFlood,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$floodColor(
												$author$project$Services$ShapeColor$getColorString(
													$author$project$Services$Board$boardKanaColorToColor(color))),
												$elm$svg$Svg$Attributes$floodOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feComposite,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$in2('shadowDiff'),
												$elm$svg$Svg$Attributes$operator('in')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$feComposite,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$in2('SourceGraphic'),
												$elm$svg$Svg$Attributes$operator('over')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-hexagonBottomInnerHighlightGradient-bezier3'),
										$elm$svg$Svg$Attributes$x1('65.17'),
										$elm$svg$Svg$Attributes$y1('39.85'),
										$elm$svg$Svg$Attributes$x2('134.54'),
										$elm$svg$Svg$Attributes$y2('160'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.74'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.97'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('1'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-hexagonInnerHighlight-bezier'),
										$elm$svg$Svg$Attributes$x1('100.15'),
										$elm$svg$Svg$Attributes$y1('43.55'),
										$elm$svg$Svg$Attributes$x2('100.15'),
										$elm$svg$Svg$Attributes$y2('160.92'),
										$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.22'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0.45'),
												$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('hexagonWithKana-group2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('hexagonWithKana-group3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('hexagonWithKana-group4'),
												$elm$svg$Svg$Attributes$transform('')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('hexagonWithKana-group5')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier6'),
																$elm$svg$Svg$Attributes$fillRule('evenodd'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill(
																$author$project$Services$ShapeColor$getColorString(
																	$author$project$Services$ShapeColor$backgroundShadowColor(
																		$author$project$Services$Board$boardKanaColorToColor(color)))),
																$elm$svg$Svg$Attributes$d('M 195.2,102.35 C 195.2,106.93 193.99,111.44 191.7,115.4 L 158.46,172.95 C 153.81,181 145.14,186 135.84,186 L 69.36,186 C 60.06,186 51.39,181 46.74,172.95 L 13.5,115.4 C 11.21,111.44 10,106.93 10,102.35 10,97.78 11.21,93.26 13.5,89.3 L 46.74,31.76 C 51.39,23.71 60.06,18.71 69.36,18.71 L 135.84,18.71 C 145.14,18.71 153.81,23.71 158.46,31.76 L 191.7,89.3 C 193.99,93.26 195.2,97.78 195.2,102.35 Z M 195.2,102.35')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier2'),
																$elm$svg$Svg$Attributes$fillRule('evenodd'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill(
																$author$project$Services$ShapeColor$getColorString(
																	$author$project$Services$Board$boardKanaColorToColor(color))),
																$elm$svg$Svg$Attributes$d('M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier4'),
																$elm$svg$Svg$Attributes$fillRule('evenodd'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-innerSquareGradient-bezier4)'),
																$elm$svg$Svg$Attributes$filter('url(#hexagonWithKana-shadow2-outer)'),
																$elm$svg$Svg$Attributes$d('M 183.67,99.88 C 183.67,103.96 182.59,107.98 180.55,111.51 L 150.9,162.82 C 146.75,170 139.02,174.46 130.72,174.46 L 71.43,174.46 C 63.14,174.46 55.41,170 51.26,162.82 L 21.61,111.51 C 19.57,107.98 18.49,103.96 18.49,99.88 18.49,95.8 19.57,91.77 21.61,88.24 L 51.26,36.93 C 55.41,29.76 63.14,25.3 71.43,25.3 L 130.72,25.3 C 139.02,25.3 146.75,29.76 150.9,36.93 L 180.55,88.24 C 182.59,91.77 183.67,95.8 183.67,99.88 Z M 183.67,99.88')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$g,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('hexagonWithKana-group6')
															]),
														_List_fromArray(
															[
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier5'),
																		$elm$svg$Svg$Attributes$fillRule('evenodd'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-squareBottomHighlight-bezier5)'),
																		$elm$svg$Svg$Attributes$d('M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier7'),
																		$elm$svg$Svg$Attributes$fillRule('evenodd'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-hexagonBottomHighlightGradient-bezier7)'),
																		$elm$svg$Svg$Attributes$d('M 180.2,105.14 C 180.2,108.96 179.2,112.73 177.31,116.04 L 149.81,164.1 C 145.96,170.82 138.79,175 131.1,175 L 76.1,175 C 68.41,175 61.24,170.82 57.39,164.1 L 29.89,116.04 C 28,112.73 27,108.96 27,105.14 27,101.32 28,97.55 29.89,94.24 L 57.39,46.19 C 61.24,39.46 68.41,35.29 76.1,35.29 L 131.1,35.29 C 138.79,35.29 145.96,39.46 149.81,46.19 L 177.31,94.24 C 179.2,97.55 180.2,101.32 180.2,105.14 Z M 180.2,105.14')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('hexagonWithKana-bezier8'),
																		$elm$svg$Svg$Attributes$opacity('0.9'),
																		$elm$svg$Svg$Attributes$fillRule('evenodd'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#hexagonWithKana-hexagonHighlightGradient-bezier8)'),
																		$elm$svg$Svg$Attributes$d('M 177.2,94.56 C 177.2,98.39 176.2,102.16 174.31,105.46 L 146.81,153.52 C 142.96,160.25 135.79,164.42 128.1,164.42 L 73.1,164.42 C 65.41,164.42 58.24,160.25 54.39,153.52 L 26.89,105.46 C 25,102.16 24,98.39 24,94.56 24,90.74 25,86.97 26.89,83.66 L 54.39,35.61 C 58.24,28.88 65.41,24.71 73.1,24.71 L 128.1,24.71 C 135.79,24.71 142.96,28.88 146.81,35.61 L 174.31,83.66 C 176.2,86.97 177.2,90.74 177.2,94.56 Z M 177.2,94.56')
																	]),
																_List_Nil)
															]))
													]))
											]))
									])),
								function () {
								if (!kanaString.$) {
									var text = kanaString.a;
									return A2(
										$author$project$SVGs$Shapes$HexagonWithKana$innerHexagonWithText,
										text,
										$author$project$Services$Board$boardKanaColorToColor(color));
								} else {
									return $elm$svg$Svg$text('');
								}
							}()
							]))
					])));
	});
var $author$project$SVGs$Shapes$OvalWithKana$definitions = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-squareGradient-outerOval'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('190'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-innerSquareGradient-innerOval4'),
					$elm$svg$Svg$Attributes$x1('100.16'),
					$elm$svg$Svg$Attributes$y1('20.39'),
					$elm$svg$Svg$Attributes$x2('100.16'),
					$elm$svg$Svg$Attributes$y2('179.22'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor(
							$author$project$Services$ShapeColor$getColorString(
								A2(
									$author$project$Services$ShapeColor$getCenterGradientColor,
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
									color))),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$getStopColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-shadow2-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('1'),
							$elm$svg$Svg$Attributes$dy('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor(
							$author$project$Services$ShapeColor$getColorString(
								$author$project$Services$ShapeColor$kanaShadowColor(color))),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-squareBottomHighlight-outerOval2'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('190'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.44'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-ovalBottomHighlightGradient-bottomRight'),
					$elm$svg$Svg$Attributes$x1('89.86'),
					$elm$svg$Svg$Attributes$y1('72.46'),
					$elm$svg$Svg$Attributes$x2('142.17'),
					$elm$svg$Svg$Attributes$y2('163.07'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.82'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-ovalHighlightGradient-top'),
					$elm$svg$Svg$Attributes$x1('100.89'),
					$elm$svg$Svg$Attributes$y1('21.21'),
					$elm$svg$Svg$Attributes$x2('100.89'),
					$elm$svg$Svg$Attributes$y2('126.93'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.36'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-innerSquareGradiant-innerOval'),
					$elm$svg$Svg$Attributes$x1('101.65'),
					$elm$svg$Svg$Attributes$y1('25'),
					$elm$svg$Svg$Attributes$x2('101.65'),
					$elm$svg$Svg$Attributes$y2('169.23'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.19'),
							$elm$svg$Svg$Attributes$stopColor(
							$author$project$Services$ShapeColor$getColorString(
								A2(
									$author$project$Services$ShapeColor$getCenterGradientColor,
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
									$author$project$Services$ShapeColor$kanaLightColor(color)))),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$getStopColorAttribute(
							$author$project$Services$ShapeColor$kanaLightColor(color)),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-shadow3-inner'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceAlpha'),
							$elm$svg$Svg$Attributes$stdDeviation('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('SourceAlpha'),
							$elm$svg$Svg$Attributes$operator('arithmetic'),
							$elm$svg$Svg$Attributes$k2('-1.15'),
							$elm$svg$Svg$Attributes$k3('1.15'),
							$elm$svg$Svg$Attributes$result('shadowDiff')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor(
							$author$project$Services$ShapeColor$getColorString(color)),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('shadowDiff'),
							$elm$svg$Svg$Attributes$operator('in')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('SourceGraphic'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-ovalInnerHighlight-innerOval2'),
					$elm$svg$Svg$Attributes$x1('100.92'),
					$elm$svg$Svg$Attributes$y1('42.4'),
					$elm$svg$Svg$Attributes$x2('100.92'),
					$elm$svg$Svg$Attributes$y2('128.24'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.26'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-ovalBottomInnerHighlightGradient2-innerOval3'),
					$elm$svg$Svg$Attributes$x1('49.24'),
					$elm$svg$Svg$Attributes$y1('44.6'),
					$elm$svg$Svg$Attributes$x2('154.18'),
					$elm$svg$Svg$Attributes$y2('149.54'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.73'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.93'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]);
};
var $author$project$SVGs$Shapes$OvalWithKana$innerOvalWithText = F2(
	function (text, color) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalWithKana-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('ovalWithKana-innerOval'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-innerSquareGradiant-innerOval)'),
							$elm$svg$Svg$Attributes$filter('url(#ovalWithKana-shadow3-inner)'),
							$elm$svg$Svg$Attributes$d('M 173.41,96.26 C 173.41,139.86 144.28,169.23 102.07,169.23 59.86,169.23 29.89,139.86 29.89,96.26 29.89,52.66 59.86,25 102.07,25 144.28,25 173.41,52.66 173.41,96.26 Z M 173.41,96.26')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('ovalWithKana-highlights')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('ovalWithKana-innerOval2'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-ovalInnerHighlight-innerOval2)'),
									$elm$svg$Svg$Attributes$d('M 157.76,84.81 C 157.76,110.76 134.69,128.24 101.26,128.24 67.82,128.24 44.08,110.76 44.08,84.81 44.08,58.86 67.82,42.4 101.26,42.4 134.69,42.4 157.76,58.86 157.76,84.81 Z M 157.76,84.81')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('ovalWithKana-innerOval3'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-ovalBottomInnerHighlightGradient2-innerOval3)'),
									$elm$svg$Svg$Attributes$d('M 174,96.64 C 174,140.47 144.58,170 101.93,170 59.28,170 29,140.47 29,96.64 29,52.81 59.28,25 101.93,25 144.58,25 174,52.81 174,96.64 Z M 174,96.64')
								]),
							_List_Nil)
						])),
					A3(
					$elm$svg$Svg$node,
					'text',
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(
							$author$project$Services$ShapeColor$getColorString(
								$author$project$Services$ShapeColor$kanaTextColor(color))),
							$elm$svg$Svg$Attributes$fontFamily('ArialMT, Arial, \'Helvetica Neue\', Helvetica, sans-serif'),
							$elm$svg$Svg$Attributes$fontSize('95'),
							$elm$svg$Svg$Attributes$x('53'),
							$elm$svg$Svg$Attributes$y('36'),
							$elm$svg$Svg$Attributes$textAnchor('middle')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$tspan,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$x('50%'),
									$elm$svg$Svg$Attributes$y('70%')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(text)
								]))
						]))
				]));
	});
var $author$project$SVGs$Shapes$OvalWithKana$ovalWithKana = F3(
	function (kanaString, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return _Utils_Tuple2(
			id,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Shapes$OvalWithKana$definitions(
							$author$project$Services$Board$boardKanaColorToColor(color))),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('ovalWithKana-group2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('ovalWithKana-group3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('ovalWithKana-group4'),
												$elm$svg$Svg$Attributes$transform('')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('ovalWithKana-group5')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('ovalWithKana-ovalShadow'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill(
																$author$project$Services$ShapeColor$getColorString(
																	$author$project$Services$ShapeColor$backgroundShadowColor(
																		$author$project$Services$Board$boardKanaColorToColor(color)))),
																$elm$svg$Svg$Attributes$d('M 192,100.93 C 192,155.35 155.47,192 102.53,192 49.59,192 12,155.35 12,100.93 12,46.52 49.59,12 102.53,12 155.47,12 192,46.52 192,100.93 Z M 192,100.93')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('ovalWithKana-outerOval'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-squareGradient-outerOval)'),
																$elm$svg$Svg$Attributes$d('M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('ovalWithKana-innerOval4'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-innerSquareGradient-innerOval4)'),
																$elm$svg$Svg$Attributes$filter('url(#ovalWithKana-shadow2-outer)'),
																$elm$svg$Svg$Attributes$d('M 179.57,98.87 C 179.57,146.88 147.34,179.22 100.63,179.22 53.91,179.22 20.74,146.88 20.74,98.87 20.74,50.86 53.91,20.39 100.63,20.39 147.34,20.39 179.57,50.86 179.57,98.87 Z M 179.57,98.87')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$g,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('ovalWithKana-groupHighlights')
															]),
														_List_fromArray(
															[
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('ovalWithKana-outerOval2'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-squareBottomHighlight-outerOval2)'),
																		$elm$svg$Svg$Attributes$d('M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('ovalWithKana-bottomRight'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-ovalBottomHighlightGradient-bottomRight)'),
																		$elm$svg$Svg$Attributes$d('M 167.39,117.34 C 167.39,148.33 146.44,169.21 116.09,169.21 85.73,169.21 64.18,148.33 64.18,117.34 64.18,86.34 85.73,66.67 116.09,66.67 146.44,66.67 167.39,86.34 167.39,117.34 Z M 167.39,117.34')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$id('ovalWithKana-top'),
																		$elm$svg$Svg$Attributes$opacity('0.9'),
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#ovalWithKana-ovalHighlightGradient-top)'),
																		$elm$svg$Svg$Attributes$d('M 167.39,73.45 C 167.39,105.4 140.4,126.93 101.28,126.93 62.16,126.93 34.39,105.4 34.39,73.45 34.39,41.49 62.16,21.21 101.28,21.21 140.4,21.21 167.39,41.49 167.39,73.45 Z M 167.39,73.45')
																	]),
																_List_Nil)
															]))
													]))
											]))
									])),
								function () {
								if (!kanaString.$) {
									var text = kanaString.a;
									return A2(
										$author$project$SVGs$Shapes$OvalWithKana$innerOvalWithText,
										text,
										$author$project$Services$Board$boardKanaColorToColor(color));
								} else {
									return A2($elm$svg$Svg$g, _List_Nil, _List_Nil);
								}
							}()
							]))
					])));
	});
var $author$project$Services$SVGConversion$renderOrEmpty = F3(
	function (render, hasTileAt, boardItem) {
		var coordinates = boardItem.aw;
		return hasTileAt(coordinates) ? A2(
			$elm$core$Array$initialize,
			1,
			$elm$core$Basics$always(
				render(boardItem))) : $elm$core$Array$empty;
	});
var $author$project$SVGs$Shapes$SquareWithKana$definitions = function (color) {
	return A2(
		$elm$svg$Svg$defs,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-squareGradient-outerSquare'),
						$elm$svg$Svg$Attributes$x1('98'),
						$elm$svg$Svg$Attributes$y1('8'),
						$elm$svg$Svg$Attributes$x2('98'),
						$elm$svg$Svg$Attributes$y2('188'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-innerSquareGradient-innerSquare'),
						$elm$svg$Svg$Attributes$x1('97.51'),
						$elm$svg$Svg$Attributes$y1('14.81'),
						$elm$svg$Svg$Attributes$x2('97.51'),
						$elm$svg$Svg$Attributes$y2('176.32'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$getStopColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$filter,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-shadow2-outer'),
						$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$feGaussianBlur,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stdDeviation('2')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feOffset,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$dx('1'),
								$elm$svg$Svg$Attributes$dy('1'),
								$elm$svg$Svg$Attributes$result('blur')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feFlood,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$floodColor(
								$author$project$Services$ShapeColor$getColorString(
									$author$project$Services$ShapeColor$kanaShadowColor(color))),
								$elm$svg$Svg$Attributes$floodOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('blur'),
								$elm$svg$Svg$Attributes$operator('in'),
								$elm$svg$Svg$Attributes$result('colorShadow')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in_('SourceGraphic'),
								$elm$svg$Svg$Attributes$in2('colorShadow'),
								$elm$svg$Svg$Attributes$operator('over')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-squareBottomHighlight-bottomHighligh'),
						$elm$svg$Svg$Attributes$x1('98'),
						$elm$svg$Svg$Attributes$y1('8'),
						$elm$svg$Svg$Attributes$x2('98'),
						$elm$svg$Svg$Attributes$y2('188'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.44'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-squareHighlightCorner-bottomRight2'),
						$elm$svg$Svg$Attributes$x1('49.24'),
						$elm$svg$Svg$Attributes$y1('11.96'),
						$elm$svg$Svg$Attributes$x2('145.78'),
						$elm$svg$Svg$Attributes$y2('179.17'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.92'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-squareHighlightGradient-top'),
						$elm$svg$Svg$Attributes$x1('97.51'),
						$elm$svg$Svg$Attributes$y1('14.81'),
						$elm$svg$Svg$Attributes$x2('97.51'),
						$elm$svg$Svg$Attributes$y2('90.7'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.24'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-innerSquareGradiant-rectangle3'),
						$elm$svg$Svg$Attributes$x1('100.5'),
						$elm$svg$Svg$Attributes$y1('33'),
						$elm$svg$Svg$Attributes$x2('100.5'),
						$elm$svg$Svg$Attributes$y2('168'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$elm$svg$Svg$Attributes$stopColor(
								$author$project$Services$ShapeColor$getColorString(
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color))),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.19'),
								$elm$svg$Svg$Attributes$stopColor(
								$author$project$Services$ShapeColor$getColorString(
									A2(
										$author$project$Services$ShapeColor$getCenterGradientColor,
										$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
										$author$project$Services$ShapeColor$kanaLightColor(color)))),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$elm$svg$Svg$Attributes$stopColor(
								$author$project$Services$ShapeColor$getColorString(
									$author$project$Services$ShapeColor$kanaLightColor(color))),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$filter,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-shadow3-inner'),
						$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$feGaussianBlur,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in_('SourceAlpha'),
								$elm$svg$Svg$Attributes$stdDeviation('1'),
								$elm$svg$Svg$Attributes$result('blur')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feOffset,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$dx('0'),
								$elm$svg$Svg$Attributes$dy('6')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('SourceAlpha'),
								$elm$svg$Svg$Attributes$operator('arithmetic'),
								$elm$svg$Svg$Attributes$k2('-1.15'),
								$elm$svg$Svg$Attributes$k3('1.15'),
								$elm$svg$Svg$Attributes$result('shadowDiff')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feFlood,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$floodColor(
								$author$project$Services$ShapeColor$getColorString(color)),
								$elm$svg$Svg$Attributes$floodOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('shadowDiff'),
								$elm$svg$Svg$Attributes$operator('in')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('SourceGraphic'),
								$elm$svg$Svg$Attributes$operator('over')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-innerSquareHighlight-topLeft'),
						$elm$svg$Svg$Attributes$x1('40'),
						$elm$svg$Svg$Attributes$y1('43'),
						$elm$svg$Svg$Attributes$x2('63.41'),
						$elm$svg$Svg$Attributes$y2('64.26'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.63'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-innerSquareHighlight-bottomRight'),
						$elm$svg$Svg$Attributes$x1('162'),
						$elm$svg$Svg$Attributes$y1('164'),
						$elm$svg$Svg$Attributes$x2('138.59'),
						$elm$svg$Svg$Attributes$y2('142.74'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.63'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareWithKana-innerSquareHighlightSmall-topRight'),
						$elm$svg$Svg$Attributes$x1('162'),
						$elm$svg$Svg$Attributes$y1('43'),
						$elm$svg$Svg$Attributes$x2('138.59'),
						$elm$svg$Svg$Attributes$y2('64.26'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$SVGs$Shapes$SquareWithKana$innerSquareWithText = F2(
	function (kanaString, color) {
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('url(#squareWithKana-innerSquareGradiant-rectangle3)'),
							$elm$svg$Svg$Attributes$filter('url(#squareWithKana-shadow3-inner)'),
							$elm$svg$Svg$Attributes$d('M 55.93,33 L 145.07,33 C 151.67,33 154.97,33 157.95,33.98 L 158.53,34.12 C 162.41,35.54 165.46,38.59 166.88,42.47 168,46.03 168,49.33 168,55.93 L 168,145.07 C 168,151.67 168,154.97 167.02,157.95 L 166.88,158.53 C 165.46,162.41 162.41,165.46 158.53,166.88 154.97,168 151.67,168 145.07,168 L 55.93,168 C 49.33,168 46.03,168 43.05,167.02 L 42.47,166.88 C 38.59,165.46 35.54,162.41 34.12,158.53 33,154.97 33,151.67 33,145.07 L 33,55.93 C 33,49.33 33,46.03 33.98,43.05 L 34.12,42.47 C 35.54,38.59 38.59,35.54 42.47,34.12 46.03,33 49.33,33 55.93,33 Z M 55.93,33')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#squareWithKana-innerSquareHighlight-topLeft)'),
									$elm$svg$Svg$Attributes$d('M 70.57,43 L 79.43,43 C 88.23,43 92.63,43 96.6,44.31 L 97.37,44.5 C 102.54,46.38 106.62,50.46 108.5,55.63 110,60.37 110,64.77 110,73.57 L 110,82.43 C 110,91.23 110,95.63 108.69,99.6 L 108.5,100.37 C 106.62,105.54 102.54,109.62 97.37,111.5 92.63,113 88.23,113 79.43,113 L 70.57,113 C 61.77,113 57.37,113 53.4,111.69 L 52.63,111.5 C 47.46,109.62 43.38,105.54 41.5,100.37 40,95.63 40,91.23 40,82.43 L 40,73.57 C 40,64.77 40,60.37 41.31,56.4 L 41.5,55.63 C 43.38,50.46 47.46,46.38 52.63,44.5 57.37,43 61.77,43 70.57,43 Z M 70.57,43')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#squareWithKana-innerSquareHighlight-bottomRight)'),
									$elm$svg$Svg$Attributes$d('M 122.57,94 L 131.43,94 C 140.23,94 144.63,94 148.6,95.31 L 149.37,95.5 C 154.54,97.38 158.62,101.46 160.5,106.63 162,111.37 162,115.77 162,124.58 L 162,133.43 C 162,142.23 162,146.64 160.69,150.6 L 160.5,151.37 C 158.62,156.55 154.54,160.62 149.37,162.5 144.63,164 140.23,164 131.43,164 L 122.57,164 C 113.77,164 109.37,164 105.4,162.69 L 104.63,162.5 C 99.46,160.62 95.38,156.55 93.5,151.37 92,146.64 92,142.23 92,133.43 L 92,124.58 C 92,115.77 92,111.37 93.31,107.4 L 93.5,106.63 C 95.38,101.46 99.46,97.38 104.63,95.5 109.37,94 113.77,94 122.57,94 Z M 122.57,94')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#squareWithKana-innerSquareHighlightSmall-topRight)'),
									$elm$svg$Svg$Attributes$d('M 122.57,43 L 131.43,43 C 140.23,43 144.63,43 148.6,44.31 L 149.37,44.5 C 154.54,46.38 158.62,50.46 160.5,55.63 162,60.37 162,64.77 162,73.57 L 162,82.43 C 162,91.23 162,95.63 160.69,99.6 L 160.5,100.37 C 158.62,105.54 154.54,109.62 149.37,111.5 144.63,113 140.23,113 131.43,113 L 122.57,113 C 113.77,113 109.37,113 105.4,111.69 L 104.63,111.5 C 99.46,109.62 95.38,105.54 93.5,100.37 92,95.63 92,91.23 92,82.43 L 92,73.57 C 92,64.77 92,60.37 93.31,56.4 L 93.5,55.63 C 95.38,50.46 99.46,46.38 104.63,44.5 109.37,43 113.77,43 122.57,43 Z M 122.57,43')
								]),
							_List_Nil)
						])),
					A3(
					$elm$svg$Svg$node,
					'text',
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(
							$author$project$Services$ShapeColor$getColorString(
								$author$project$Services$ShapeColor$kanaTextColor(color))),
							$elm$svg$Svg$Attributes$fontFamily('Helvetica-Bold, Helvetica, sans-serif'),
							$elm$svg$Svg$Attributes$fontWeight('bold'),
							$elm$svg$Svg$Attributes$fontSize('95'),
							$elm$svg$Svg$Attributes$x('53'),
							$elm$svg$Svg$Attributes$y('46'),
							$elm$svg$Svg$Attributes$textAnchor('middle')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$tspan,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$x('50%'),
									$elm$svg$Svg$Attributes$y('70%')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(kanaString)
								]))
						]))
				]));
	});
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $author$project$SVGs$Shapes$SquareWithKana$squareWithKana = F3(
	function (kanaString, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return _Utils_Tuple2(
			id,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						$author$project$SVGs$Shapes$SquareWithKana$definitions(
						$author$project$Services$Board$boardKanaColorToColor(color)),
						A2(
						$elm$svg$Svg$g,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$g,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$g,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$rect,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill(
																$author$project$Services$ShapeColor$getColorString(
																	$author$project$Services$ShapeColor$kanaTextColor(
																		$author$project$Services$Board$boardKanaColorToColor(color)))),
																$elm$svg$Svg$Attributes$x('10'),
																$elm$svg$Svg$Attributes$y('10'),
																$elm$svg$Svg$Attributes$width('180'),
																$elm$svg$Svg$Attributes$height('180'),
																$elm$svg$Svg$Attributes$rx('40')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$rect,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#squareWithKana-squareGradient-outerSquare)'),
																$elm$svg$Svg$Attributes$x('8'),
																$elm$svg$Svg$Attributes$y('8'),
																$elm$svg$Svg$Attributes$width('180'),
																$elm$svg$Svg$Attributes$height('180'),
																$elm$svg$Svg$Attributes$rx('40')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$g,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$svg$Svg$path,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$stroke('none'),
																		$elm$svg$Svg$Attributes$fill('url(#squareWithKana-innerSquareGradient-innerSquare)'),
																		$elm$svg$Svg$Attributes$filter('url(#squareWithKana-shadow2-outer)'),
																		$elm$svg$Svg$Attributes$d('M 75.28,14.81 L 119.75,14.81 C 136.88,14.81 145.45,14.81 153.17,17.36 L 154.67,17.73 C 164.73,21.39 172.66,29.32 176.33,39.39 179.24,48.61 179.24,57.17 179.24,74.3 L 179.24,116.83 C 179.24,133.96 179.24,142.53 176.69,150.25 L 176.33,151.75 C 172.66,161.81 164.73,169.74 154.67,173.41 145.45,176.32 136.88,176.32 119.75,176.32 L 75.28,176.32 C 58.15,176.32 49.58,176.32 41.86,173.78 L 40.36,173.41 C 30.29,169.74 22.36,161.81 18.7,151.75 15.78,142.53 15.78,133.96 15.78,116.83 L 15.78,74.3 C 15.78,57.17 15.78,48.61 18.33,40.88 L 18.7,39.39 C 22.36,29.32 30.29,21.39 40.36,17.73 49.58,14.81 58.15,14.81 75.28,14.81 Z M 75.28,14.81')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$g,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$svg$Svg$rect,
																		_List_fromArray(
																			[
																				$elm$svg$Svg$Attributes$opacity('0.8'),
																				$elm$svg$Svg$Attributes$stroke('none'),
																				$elm$svg$Svg$Attributes$fill('url(#squareWithKana-squareBottomHighlight-bottomHighligh)'),
																				$elm$svg$Svg$Attributes$x('8'),
																				$elm$svg$Svg$Attributes$y('8'),
																				$elm$svg$Svg$Attributes$width('180'),
																				$elm$svg$Svg$Attributes$height('180'),
																				$elm$svg$Svg$Attributes$rx('40')
																			]),
																		_List_Nil),
																		A2(
																		$elm$svg$Svg$path,
																		_List_fromArray(
																			[
																				$elm$svg$Svg$Attributes$stroke('none'),
																				$elm$svg$Svg$Attributes$fill('url(#squareWithKana-squareHighlightCorner-bottomRight2)'),
																				$elm$svg$Svg$Attributes$d('M 75.28,14.81 L 119.75,14.81 C 136.88,14.81 145.45,14.81 153.17,17.36 L 154.67,17.73 C 164.73,21.39 172.66,29.32 176.33,39.39 179.24,48.61 179.24,57.17 179.24,74.3 L 179.24,116.83 C 179.24,133.96 179.24,142.53 176.69,150.25 L 176.33,151.75 C 172.66,161.81 164.73,169.74 154.67,173.41 145.45,176.32 136.88,176.32 119.75,176.32 L 75.28,176.32 C 58.15,176.32 49.58,176.32 41.86,173.78 L 40.36,173.41 C 30.29,169.74 22.36,161.81 18.7,151.75 15.78,142.53 15.78,133.96 15.78,116.83 L 15.78,74.3 C 15.78,57.17 15.78,48.61 18.33,40.88 L 18.7,39.39 C 22.36,29.32 30.29,21.39 40.36,17.73 49.58,14.81 58.15,14.81 75.28,14.81 Z M 75.28,14.81')
																			]),
																		_List_Nil),
																		A2(
																		$elm$svg$Svg$path,
																		_List_fromArray(
																			[
																				$elm$svg$Svg$Attributes$stroke('none'),
																				$elm$svg$Svg$Attributes$fill('url(#squareWithKana-squareHighlightGradient-top)'),
																				$elm$svg$Svg$Attributes$d('M 65.58,14.81 L 119.75,14.81 C 138.65,14.81 147,14.81 154.53,17.3 L 155.99,17.65 C 169.95,22.73 179.24,36 179.24,50.86 179.24,52.76 179.24,52.76 179.24,52.76 L 179.24,52.76 179.24,52.76 179.24,54.65 C 179.24,69.51 169.95,82.78 155.99,87.86 147,90.7 138.65,90.7 121.95,90.7 L 75.28,90.7 C 56.38,90.7 48.02,90.7 40.49,88.22 L 39.03,87.86 C 25.08,82.78 15.78,69.51 15.78,54.65 15.78,52.76 15.78,52.76 15.78,52.76 L 15.78,52.76 15.78,52.76 15.78,50.86 C 15.78,36 25.08,22.73 39.03,17.65 48.02,14.81 56.38,14.81 73.08,14.81 L 75.28,14.81 65.58,14.81 Z M 65.58,14.81')
																			]),
																		_List_Nil)
																	]))
															]))
													]))
											]))
									])),
								function () {
								if (!kanaString.$) {
									var text = kanaString.a;
									return A2(
										$author$project$SVGs$Shapes$SquareWithKana$innerSquareWithText,
										text,
										$author$project$Services$Board$boardKanaColorToColor(color));
								} else {
									return $elm$svg$Svg$text('');
								}
							}()
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedDiamond$definitions = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondGradient-outerDiamond'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('5'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('195'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$getStopColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('squareBottomHighlight-outerDiamond2'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('5'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('195'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.44'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondHighlightGradientReversed-bottom'),
					$elm$svg$Svg$Attributes$x1('101.18'),
					$elm$svg$Svg$Attributes$y1('136.66'),
					$elm$svg$Svg$Attributes$x2('101.18'),
					$elm$svg$Svg$Attributes$y2('186.71'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.26'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('diamondHighlightGradient-top'),
					$elm$svg$Svg$Attributes$x1('99'),
					$elm$svg$Svg$Attributes$y1('14'),
					$elm$svg$Svg$Attributes$x2('99'),
					$elm$svg$Svg$Attributes$y2('96'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.32'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				]))
		]);
};
var $author$project$Services$ShapeColor$stripeColor = function (color) {
	return A2($author$project$Services$ShapeColor$colorWithShadow, color, 0.4);
};
var $author$project$SVGs$Bonuses$StripedDiamond$stripedDiamondHorizontal = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedDiamond$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-diamondShadow'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$backgroundShadowColor(color))),
										$elm$svg$Svg$Attributes$d('M 102,7 C 133.67,7 197,70.33 197,102 197,133.67 133.67,197 102,197 70.33,197 7,133.67 7,102 7,70.33 70.33,7 102,7 Z M 102,7')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-outerDiamond'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#diamondGradient-outerDiamond)'),
										$elm$svg$Svg$Attributes$d('M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-bezier'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$stripeColor(color))),
										$elm$svg$Svg$Attributes$d('M 168.19,50 L 31.81,50 C 38.05,42.93 44.97,36.1 52.08,30 L 147.92,30 C 155.03,36.1 161.95,42.93 168.19,50 Z M 193.31,90 L 6.69,90 C 8.6,83.82 12.03,77 16.52,70 L 183.48,70 C 187.97,77 191.4,83.82 193.31,90 Z M 193.31,110 C 191.4,116.18 187.97,123 183.48,130 L 16.52,130 C 12.03,123 8.6,116.18 6.69,110 L 193.31,110 Z M 168.19,150 C 161.95,157.07 155.03,163.9 147.92,170 L 52.08,170 C 44.97,163.9 38.05,157.07 31.81,150 L 168.19,150 Z M 168.19,150')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-groupHighlights')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-outerDiamond2'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#squareBottomHighlight-outerDiamond2)'),
												$elm$svg$Svg$Attributes$d('M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-bottom'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#diamondHighlightGradientReversed-bottom)'),
												$elm$svg$Svg$Attributes$d('M 101.18,136.66 C 116.79,136.66 148,144 148,152.34 148,160.68 116.79,186.71 101.18,186.71 85.58,186.71 54.37,160.68 54.37,152.34 54.37,144 85.58,136.66 101.18,136.66 Z M 101.18,136.66')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasDiamondHorizontalStripedDrawing-top'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#diamondHighlightGradient-top)'),
												$elm$svg$Svg$Attributes$d('M 99,14 C 125.68,14 165,51.61 165,70.41 165,89.21 125.68,96 99,96 72.32,96 33,89.21 33,70.41 33,51.61 72.32,14 99,14 Z M 99,14')
											]),
										_List_Nil)
									]))
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedDiamond$stripedDiamondVertical = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedDiamond$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-diamondShadow'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$backgroundShadowColor(color))),
										$elm$svg$Svg$Attributes$d('M 102,7 C 133.67,7 197,70.33 197,102 197,133.67 133.67,197 102,197 70.33,197 7,133.67 7,102 7,70.33 70.33,7 102,7 Z M 102,7')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-outerDiamond'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#diamondGradient-outerDiamond)'),
										$elm$svg$Svg$Attributes$d('M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-bezier2'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$stripeColor(color))),
										$elm$svg$Svg$Attributes$d('M 50,31.81 C 50,69.18 50,130.82 50,168.19 42.93,161.95 36.1,155.03 30,147.92 30,118.4 30,81.6 30,52.08 36.1,44.97 42.93,38.05 50,31.81 Z M 150,31.81 C 157.07,38.05 163.9,44.97 170,52.08 170,81.6 170,118.4 170,147.92 163.9,155.03 157.07,161.95 150,168.19 150,130.82 150,69.18 150,31.81 Z M 90,6.69 C 90,37.19 90,162.81 90,193.31 83.82,191.4 77,187.97 70,183.48 70,145.85 70,54.15 70,16.52 77,12.03 83.82,8.6 90,6.69 Z M 110,6.69 C 116.18,8.6 123,12.03 130,16.52 130,54.15 130,145.85 130,183.48 123,187.97 116.18,191.4 110,193.31 110,162.81 110,37.19 110,6.69 Z M 110,6.69')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-groupHighlights')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-outerDiamond2'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#squareBottomHighlight-outerDiamond2)'),
												$elm$svg$Svg$Attributes$d('M 100,5 C 131.67,5 195,68.33 195,100 195,131.67 131.67,195 100,195 68.33,195 5,131.67 5,100 5,68.33 68.33,5 100,5 Z M 100,5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-bottom'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#diamondHighlightGradientReversed-bottom)'),
												$elm$svg$Svg$Attributes$d('M 101.18,136.66 C 116.79,136.66 148,144 148,152.34 148,160.68 116.79,186.71 101.18,186.71 85.58,186.71 54.37,160.68 54.37,152.34 54.37,144 85.58,136.66 101.18,136.66 Z M 101.18,136.66')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasDiamondVerticalStripedDrawing-top'),
												$elm$svg$Svg$Attributes$fillRule('evenodd'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#diamondHighlightGradient-top)'),
												$elm$svg$Svg$Attributes$d('M 99,14 C 125.68,14 165,51.61 165,70.41 165,89.21 125.68,96 99,96 72.32,96 33,89.21 33,70.41 33,51.61 72.32,14 99,14 Z M 99,14')
											]),
										_List_Nil)
									]))
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedDiamond$stripedDiamond = F3(
	function (stripeDirection, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		if (!stripeDirection) {
			return A3(
				$author$project$SVGs$Bonuses$StripedDiamond$stripedDiamondHorizontal,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		} else {
			return A3(
				$author$project$SVGs$Bonuses$StripedDiamond$stripedDiamondVertical,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		}
	});
var $author$project$SVGs$Bonuses$StripedHexagon$definitions = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('innerSquareGradient-bezier'),
					$elm$svg$Svg$Attributes$x1('100.6'),
					$elm$svg$Svg$Attributes$y1('16.71'),
					$elm$svg$Svg$Attributes$x2('100.6'),
					$elm$svg$Svg$Attributes$y2('184'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('squareBottomHighlight-bezier5'),
					$elm$svg$Svg$Attributes$x1('100.6'),
					$elm$svg$Svg$Attributes$y1('16.71'),
					$elm$svg$Svg$Attributes$x2('100.6'),
					$elm$svg$Svg$Attributes$y2('184'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.44'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('hexagonBottomHighlightGradient-bezier4'),
					$elm$svg$Svg$Attributes$x1('65.05'),
					$elm$svg$Svg$Attributes$y1('38.36'),
					$elm$svg$Svg$Attributes$x2('142.16'),
					$elm$svg$Svg$Attributes$y2('171.92'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.79'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('hexagonHighlightGradient-bezier3'),
					$elm$svg$Svg$Attributes$x1('100.6'),
					$elm$svg$Svg$Attributes$y1('24.71'),
					$elm$svg$Svg$Attributes$x2('100.6'),
					$elm$svg$Svg$Attributes$y2('164.42'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.23'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.53'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				]))
		]);
};
var $author$project$SVGs$Bonuses$StripedHexagon$highlights = A2(
	$elm$svg$Svg$g,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-group')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-bezier5'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#squareBottomHighlight-bezier5)'),
					$elm$svg$Svg$Attributes$d('M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-bezier4'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#hexagonBottomHighlightGradient-bezier4)'),
					$elm$svg$Svg$Attributes$d('M 180.2,105.14 C 180.2,108.96 179.2,112.73 177.31,116.04 L 149.81,164.1 C 145.96,170.82 138.79,175 131.1,175 L 76.1,175 C 68.41,175 61.24,170.82 57.39,164.1 L 29.89,116.04 C 28,112.73 27,108.96 27,105.14 27,101.32 28,97.55 29.89,94.24 L 57.39,46.19 C 61.24,39.46 68.41,35.29 76.1,35.29 L 131.1,35.29 C 138.79,35.29 145.96,39.46 149.81,46.19 L 177.31,94.24 C 179.2,97.55 180.2,101.32 180.2,105.14 Z M 180.2,105.14')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-bezier3'),
					$elm$svg$Svg$Attributes$opacity('0.9'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#hexagonHighlightGradient-bezier3)'),
					$elm$svg$Svg$Attributes$d('M 177.2,94.56 C 177.2,98.39 176.2,102.16 174.31,105.46 L 146.81,153.52 C 142.96,160.25 135.79,164.42 128.1,164.42 L 73.1,164.42 C 65.41,164.42 58.24,160.25 54.39,153.52 L 26.89,105.46 C 25,102.16 24,98.39 24,94.56 24,90.74 25,86.97 26.89,83.66 L 54.39,35.61 C 58.24,28.88 65.41,24.71 73.1,24.71 L 128.1,24.71 C 135.79,24.71 142.96,28.88 146.81,35.61 L 174.31,83.66 C 176.2,86.97 177.2,90.74 177.2,94.56 Z M 177.2,94.56')
				]),
			_List_Nil)
		]));
var $author$project$SVGs$Bonuses$StripedHexagon$stripedHexagonHorizontal = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedHexagon$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasHexagonHorizontalStripedDrawing-group2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasHexagonHorizontalStripedDrawing-bezier6'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$backgroundShadowColor(color))),
										$elm$svg$Svg$Attributes$d('M 195.2,102.35 C 195.2,106.93 193.99,111.44 191.7,115.4 L 158.46,172.95 C 153.81,181 145.14,186 135.84,186 L 69.36,186 C 60.06,186 51.39,181 46.74,172.95 L 13.5,115.4 C 11.21,111.44 10,106.93 10,102.35 10,97.78 11.21,93.26 13.5,89.3 L 46.74,31.76 C 51.39,23.71 60.06,18.71 69.36,18.71 L 135.84,18.71 C 145.14,18.71 153.81,23.71 158.46,31.76 L 191.7,89.3 C 193.99,93.26 195.2,97.78 195.2,102.35 Z M 195.2,102.35')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasHexagonHorizontalStripedDrawing-bezier'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#innerSquareGradient-bezier)'),
										$elm$svg$Svg$Attributes$d('M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasHexagonHorizontalStripedDrawing-bezier2'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$stripeColor(color))),
										$elm$svg$Svg$Attributes$d('M 156.62,30.04 C 157.48,31.51 162.38,40 168.15,50 L 33.05,50 C 38.82,40 43.73,31.51 44.6,30 L 156.6,30 156.62,30.04 Z M 179.71,70 C 185.31,79.69 189.7,87.3 189.7,87.3 190.21,88.18 190.66,89.08 191.06,90 L 10.14,90 C 10.54,89.08 10.99,88.18 11.5,87.3 11.5,87.3 15.9,79.69 21.49,70 L 179.71,70 Z M 191.35,110 C 190.89,111.17 190.34,112.31 189.7,113.4 189.7,113.4 185.52,120.65 180.12,130 L 21.09,130 C 15.68,120.65 11.5,113.4 11.5,113.4 10.87,112.31 10.32,111.17 9.85,110 L 191.35,110 Z M 168.56,150 C 163.23,159.24 158.56,167.31 157.01,170 L 44.19,170 C 42.64,167.31 37.98,159.24 32.64,150 L 168.56,150 Z M 168.56,150')
									]),
								_List_Nil),
								$author$project$SVGs$Bonuses$StripedHexagon$highlights
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedHexagon$stripedHexagonVertical = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedHexagon$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-group2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-bezier6'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$backgroundShadowColor(color))),
										$elm$svg$Svg$Attributes$d('M 195.2,102.35 C 195.2,106.93 193.99,111.44 191.7,115.4 L 158.46,172.95 C 153.81,181 145.14,186 135.84,186 L 69.36,186 C 60.06,186 51.39,181 46.74,172.95 L 13.5,115.4 C 11.21,111.44 10,106.93 10,102.35 10,97.78 11.21,93.26 13.5,89.3 L 46.74,31.76 C 51.39,23.71 60.06,18.71 69.36,18.71 L 135.84,18.71 C 145.14,18.71 153.81,23.71 158.46,31.76 L 191.7,89.3 C 193.99,93.26 195.2,97.78 195.2,102.35 Z M 195.2,102.35')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-bezier'),
										$elm$svg$Svg$Attributes$fillRule('evenodd'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#innerSquareGradient-bezier)'),
										$elm$svg$Svg$Attributes$d('M 193.2,100.35 C 193.2,104.93 191.99,109.44 189.7,113.4 L 156.46,170.95 C 151.81,179 143.14,184 133.84,184 L 67.36,184 C 58.06,184 49.39,179 44.74,170.95 L 11.5,113.4 C 9.21,109.44 8,104.93 8,100.35 8,95.78 9.21,91.26 11.5,87.3 L 44.74,29.76 C 49.39,21.71 58.06,16.71 67.36,16.71 L 133.84,16.71 C 143.14,16.71 151.81,21.71 156.46,29.76 L 189.7,87.3 C 191.99,91.26 193.2,95.78 193.2,100.35 Z M 193.2,100.35')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasHexagonVerticalStripedDrawing-bezier2'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill(
										$author$project$Services$ShapeColor$getColorString(
											$author$project$Services$ShapeColor$stripeColor(color))),
										$elm$svg$Svg$Attributes$d('M 50,23.32 C 50,62.05 50,139.14 50,177.39 47.94,175.56 46.15,173.4 44.74,170.95 44.74,170.95 37.64,158.65 30,145.43 30,117.43 30,83.38 30,55.28 37.64,42.05 44.74,29.76 44.74,29.76 45.7,28.1 46.82,26.58 48.09,25.19 48.7,24.54 49.33,23.91 50,23.32 Z M 150,22.31 C 152.57,24.34 154.78,26.85 156.46,29.76 156.46,29.76 162.84,40.79 170,53.19 170,82.38 170,118.44 170,147.51 162.84,159.92 156.46,170.95 156.46,170.95 154.78,173.86 152.57,176.37 150,178.39 150,140.17 150,61.03 150,22.31 Z M 130,184 L 110,184 C 110,146.77 110,54.62 110,16.71 L 130,16.71 C 130,54.62 130,146.77 130,184 Z M 90,184 L 70,184 C 70,146.77 70,54.62 70,16.71 L 90,16.71 C 90,54.62 90,146.77 90,184 Z M 90,184')
									]),
								_List_Nil),
								$author$project$SVGs$Bonuses$StripedHexagon$highlights
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedHexagon$stripedHexagon = F3(
	function (stripeDirection, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		if (!stripeDirection) {
			return A3(
				$author$project$SVGs$Bonuses$StripedHexagon$stripedHexagonHorizontal,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		} else {
			return A3(
				$author$project$SVGs$Bonuses$StripedHexagon$stripedHexagonVertical,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		}
	});
var $author$project$SVGs$Bonuses$StripedOval$definitions = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('squareGradient-outerOval'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('190'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalBottomHighlight-bottomHighlight'),
					$elm$svg$Svg$Attributes$x1('100'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('100'),
					$elm$svg$Svg$Attributes$y2('190'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.75'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalBottomHighlightGradient-bottomRight'),
					$elm$svg$Svg$Attributes$x1('89.86'),
					$elm$svg$Svg$Attributes$y1('72.46'),
					$elm$svg$Svg$Attributes$x2('142.17'),
					$elm$svg$Svg$Attributes$y2('163.07'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.82'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('ovalHighlightGradient-top'),
					$elm$svg$Svg$Attributes$x1('100.89'),
					$elm$svg$Svg$Attributes$y1('21.21'),
					$elm$svg$Svg$Attributes$x2('100.89'),
					$elm$svg$Svg$Attributes$y2('126.93'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.36'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				]))
		]);
};
var $author$project$SVGs$Bonuses$StripedOval$highlights = A2(
	$elm$svg$Svg$g,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-groupHighlights')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-bottomHighlight'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#ovalBottomHighlight-bottomHighlight)'),
					$elm$svg$Svg$Attributes$d('M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-bottomRight'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#ovalBottomHighlightGradient-bottomRight)'),
					$elm$svg$Svg$Attributes$d('M 167.39,117.34 C 167.39,148.33 146.44,169.21 116.09,169.21 85.73,169.21 64.18,148.33 64.18,117.34 64.18,86.34 85.73,66.67 116.09,66.67 146.44,66.67 167.39,86.34 167.39,117.34 Z M 167.39,117.34')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-top'),
					$elm$svg$Svg$Attributes$opacity('0.9'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#ovalHighlightGradient-top)'),
					$elm$svg$Svg$Attributes$d('M 167.39,73.45 C 167.39,105.4 140.4,126.93 101.28,126.93 62.16,126.93 34.39,105.4 34.39,73.45 34.39,41.49 62.16,21.21 101.28,21.21 140.4,21.21 167.39,41.49 167.39,73.45 Z M 167.39,73.45')
				]),
			_List_Nil)
		]));
var $author$project$SVGs$Bonuses$StripedOval$horizontalStripes = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasOvalHorizontalStripedDrawing-bezier'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Services$ShapeColor$getColorString(
					$author$project$Services$ShapeColor$stripeColor(color))),
				$elm$svg$Svg$Attributes$d('M 177.59,50 L 22.7,50 C 27.35,42.32 33.16,35.61 39.97,30 L 160.63,30 C 167.34,35.61 173.05,42.32 177.59,50 Z M 189.66,90 L 10.35,90 C 10.91,82.94 12.13,76.26 13.97,70 L 186.13,70 C 187.92,76.26 189.12,82.94 189.66,90 Z M 189.48,110 C 188.8,117.03 187.48,123.72 185.57,130 L 14.55,130 C 12.59,123.72 11.23,117.03 10.54,110 L 189.48,110 Z M 176.68,150 C 172.04,157.65 166.28,164.37 159.55,170 L 41.07,170 C 34.24,164.37 28.37,157.65 23.63,150 L 176.68,150 Z M 176.68,150')
			]),
		_List_Nil);
};
var $author$project$SVGs$Bonuses$StripedOval$oval = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-outerOval'),
			$elm$svg$Svg$Attributes$stroke('none'),
			$elm$svg$Svg$Attributes$fill('url(#squareGradient-outerOval)'),
			$elm$svg$Svg$Attributes$d('M 190,98.93 C 190,153.35 153.47,190 100.53,190 47.59,190 10,153.35 10,98.93 10,44.52 47.59,10 100.53,10 153.47,10 190,44.52 190,98.93 Z M 190,98.93')
		]),
	_List_Nil);
var $author$project$SVGs$Bonuses$StripedOval$ovalShadow = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-ovalShadow'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Services$ShapeColor$getColorString(
					$author$project$Services$ShapeColor$backgroundShadowColor(color))),
				$elm$svg$Svg$Attributes$d('M 192,100.93 C 192,155.35 155.47,192 102.53,192 49.59,192 12,155.35 12,100.93 12,46.52 49.59,12 102.53,12 155.47,12 192,46.52 192,100.93 Z M 192,100.93')
			]),
		_List_Nil);
};
var $author$project$SVGs$Bonuses$StripedOval$stripedOvalHorizontal = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedOval$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasOvalHorizontalStripedDrawing-group')
							]),
						_List_fromArray(
							[
								$author$project$SVGs$Bonuses$StripedOval$ovalShadow(color),
								$author$project$SVGs$Bonuses$StripedOval$oval,
								$author$project$SVGs$Bonuses$StripedOval$horizontalStripes(color),
								$author$project$SVGs$Bonuses$StripedOval$highlights
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedOval$verticalStripes = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-bezier2'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Services$ShapeColor$getColorString(
					$author$project$Services$ShapeColor$stripeColor(color))),
				$elm$svg$Svg$Attributes$d('M 50,22.95 C 50,61.23 50,137.71 50,176.41 42.38,171.67 35.65,165.79 30,158.91 30,124.05 30,74.34 30,39.84 34.91,34.04 40.62,29 47.03,24.81 48.01,24.17 49,23.55 50,22.95 Z M 150,22.51 C 157.64,27.01 164.36,32.64 170,39.31 170,74.01 170,124.38 170,159.45 164.36,166.33 157.64,172.18 150,176.87 150,138.17 150,60.79 150,22.51 Z M 90,10.47 C 90,44.99 90,154.94 90,189.5 82.99,188.83 76.31,187.48 70,185.51 70,148.53 70,50.98 70,14.26 76.31,12.38 82.99,11.11 90,10.47 Z M 110,10.38 C 117.02,10.95 123.7,12.16 130,13.98 130,50.58 130,148.95 130,185.8 123.7,187.71 117.02,188.99 110,189.6 110,155.12 110,44.83 110,10.38 Z M 110,10.38')
			]),
		_List_Nil);
};
var $author$project$SVGs$Bonuses$StripedOval$stripedOvalVertical = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedOval$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasOvalVerticalStripedDrawing-group')
							]),
						_List_fromArray(
							[
								$author$project$SVGs$Bonuses$StripedOval$ovalShadow(color),
								$author$project$SVGs$Bonuses$StripedOval$oval,
								$author$project$SVGs$Bonuses$StripedOval$verticalStripes(color),
								$author$project$SVGs$Bonuses$StripedOval$highlights
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedOval$stripedOval = F3(
	function (stripeDirection, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		if (!stripeDirection) {
			return A3(
				$author$project$SVGs$Bonuses$StripedOval$stripedOvalHorizontal,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		} else {
			return A3(
				$author$project$SVGs$Bonuses$StripedOval$stripedOvalVertical,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		}
	});
var $author$project$SVGs$Bonuses$StripedSquare$definitions = function (color) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasSquareStriped-squareGradient-outerSquare'),
					$elm$svg$Svg$Attributes$x1('98'),
					$elm$svg$Svg$Attributes$y1('8'),
					$elm$svg$Svg$Attributes$x2('98'),
					$elm$svg$Svg$Attributes$y2('188'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasSquareStriped-squareBottomHighlight-bottomHighligh'),
					$elm$svg$Svg$Attributes$x1('98'),
					$elm$svg$Svg$Attributes$y1('8'),
					$elm$svg$Svg$Attributes$x2('98'),
					$elm$svg$Svg$Attributes$y2('188'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.44'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasSquareStriped-squareHighlightCorner-bottomRight'),
					$elm$svg$Svg$Attributes$x1('50.22'),
					$elm$svg$Svg$Attributes$y1('13.91'),
					$elm$svg$Svg$Attributes$x2('146.76'),
					$elm$svg$Svg$Attributes$y2('181.12'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.92'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasSquareStriped-squareHighlightGradient-top'),
					$elm$svg$Svg$Attributes$x1('98.49'),
					$elm$svg$Svg$Attributes$y1('16.76'),
					$elm$svg$Svg$Attributes$x2('98.49'),
					$elm$svg$Svg$Attributes$y2('92.65'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.24'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				]))
		]);
};
var $author$project$SVGs$Bonuses$StripedSquare$stripedSquareHorizontal = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedSquare$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasSquareStriped-group'),
								$elm$svg$Svg$Attributes$transform('')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasSquareStriped-group2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$rect,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-squareShadow'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill(
												$author$project$Services$ShapeColor$getColorString(
													$author$project$Services$ShapeColor$backgroundShadowColor(color))),
												$elm$svg$Svg$Attributes$x('10'),
												$elm$svg$Svg$Attributes$y('10'),
												$elm$svg$Svg$Attributes$width('180'),
												$elm$svg$Svg$Attributes$height('180'),
												$elm$svg$Svg$Attributes$rx('40')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$rect,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-outerSquare'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareGradient-outerSquare)'),
												$elm$svg$Svg$Attributes$x('8'),
												$elm$svg$Svg$Attributes$y('8'),
												$elm$svg$Svg$Attributes$width('180'),
												$elm$svg$Svg$Attributes$height('180'),
												$elm$svg$Svg$Attributes$rx('40')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-bezier'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill(
												$author$project$Services$ShapeColor$getColorString(
													$author$project$Services$ShapeColor$stripeColor(color))),
												$elm$svg$Svg$Attributes$d('M 185.08,32.58 C 186.7,37.68 187.42,42.59 187.74,48.86 L 8.23,48.86 C 8.52,42.82 9.15,38.32 10.55,34.07 L 10.92,32.58 C 11.31,31.49 11.75,30.44 12.24,29.41 L 183.76,29.41 C 184.25,30.44 184.69,31.49 185.08,32.58 Z M 188,87.78 L 8,87.78 C 8,78.6 8,70.81 8,68.32 L 188,68.32 C 188,70.81 188,78.6 188,87.78 Z M 188,107.24 C 188,115.86 188,123.38 188,126.7 L 8,126.7 C 8,123.38 8,115.86 8,107.24 L 188,107.24 Z M 187.81,146.16 C 187.55,152.7 186.93,157.45 185.45,161.93 L 185.08,163.42 C 184.81,164.17 184.52,164.9 184.2,165.62 L 11.8,165.62 C 11.48,164.9 11.19,164.17 10.92,163.42 9.22,158.05 8.51,152.91 8.21,146.16 L 187.81,146.16 Z M 187.81,146.16')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-groupHighlights')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$path,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('canvasSquareStriped-bottomRight'),
														$elm$svg$Svg$Attributes$stroke('none'),
														$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareHighlightCorner-bottomRight)'),
														$elm$svg$Svg$Attributes$d('M 76.25,16.76 L 120.72,16.76 C 137.85,16.76 146.42,16.76 154.14,19.31 L 155.64,19.67 C 165.71,23.34 173.64,31.27 177.3,41.33 180.22,50.55 180.22,59.12 180.22,76.25 L 180.22,118.78 C 180.22,135.91 180.22,144.47 177.67,152.2 L 177.3,153.69 C 173.64,163.76 165.71,171.69 155.64,175.35 146.42,178.27 137.85,178.27 120.72,178.27 L 76.25,178.27 C 59.12,178.27 50.55,178.27 42.83,175.72 L 41.33,175.35 C 31.27,171.69 23.34,163.76 19.67,153.69 16.76,144.47 16.76,135.91 16.76,118.78 L 16.76,76.25 C 16.76,59.12 16.76,50.55 19.31,42.83 L 19.67,41.33 C 23.34,31.27 31.27,23.34 41.33,19.67 50.55,16.76 59.12,16.76 76.25,16.76 Z M 76.25,16.76')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$path,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('canvasSquareStriped-top'),
														$elm$svg$Svg$Attributes$stroke('none'),
														$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareHighlightGradient-top)'),
														$elm$svg$Svg$Attributes$d('M 66.55,16.76 L 120.72,16.76 C 139.62,16.76 147.98,16.76 155.51,19.24 L 156.97,19.6 C 170.92,24.68 180.22,37.95 180.22,52.81 180.22,54.7 180.22,54.7 180.22,54.7 L 180.22,54.7 180.22,54.7 180.22,56.6 C 180.22,71.46 170.92,84.73 156.97,89.81 147.98,92.65 139.62,92.65 122.92,92.65 L 76.25,92.65 C 57.35,92.65 49,92.65 41.47,90.16 L 40.01,89.81 C 26.05,84.73 16.76,71.46 16.76,56.6 16.76,54.7 16.76,54.7 16.76,54.7 L 16.76,54.7 16.76,54.7 16.76,52.81 C 16.76,37.95 26.05,24.68 40.01,19.6 49,16.76 57.35,16.76 74.05,16.76 L 76.25,16.76 66.55,16.76 Z M 66.55,16.76')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$rect,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('canvasSquareStriped-bottomHighligh'),
														$elm$svg$Svg$Attributes$opacity('0.4'),
														$elm$svg$Svg$Attributes$stroke('none'),
														$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareBottomHighlight-bottomHighligh)'),
														$elm$svg$Svg$Attributes$x('8'),
														$elm$svg$Svg$Attributes$y('8'),
														$elm$svg$Svg$Attributes$width('180'),
														$elm$svg$Svg$Attributes$height('180'),
														$elm$svg$Svg$Attributes$rx('40')
													]),
												_List_Nil)
											]))
									]))
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedSquare$stripedSquareVertical = F3(
	function (attributes, color, key) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						$author$project$SVGs$Bonuses$StripedSquare$definitions(color)),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasSquareStriped-group3'),
								$elm$svg$Svg$Attributes$transform('')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('canvasSquareStriped-group4')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$rect,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-squareShadow'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$author$project$Services$ShapeColor$getStopColorAttribute(
												$author$project$Services$ShapeColor$backgroundShadowColor(color)),
												$elm$svg$Svg$Attributes$x('10'),
												$elm$svg$Svg$Attributes$y('10'),
												$elm$svg$Svg$Attributes$width('180'),
												$elm$svg$Svg$Attributes$height('180'),
												$elm$svg$Svg$Attributes$rx('40')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$rect,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-outerSquare'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareGradient-outerSquare)'),
												$elm$svg$Svg$Attributes$x('8'),
												$elm$svg$Svg$Attributes$y('8'),
												$elm$svg$Svg$Attributes$width('180'),
												$elm$svg$Svg$Attributes$height('180'),
												$elm$svg$Svg$Attributes$rx('40')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$path,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-bezier'),
												$elm$svg$Svg$Attributes$stroke('none'),
												$elm$svg$Svg$Attributes$fill(
												$author$project$Services$ShapeColor$getColorString(
													$author$project$Services$ShapeColor$stripeColor(color))),
												$elm$svg$Svg$Attributes$d('M 48.86,8.26 C 48.86,40.18 48.86,157.7 48.86,187.77 42.82,187.48 38.32,186.85 34.07,185.45 L 32.58,185.08 C 31.49,184.69 30.44,184.25 29.41,183.76 29.41,149.84 29.41,47.43 29.41,12.24 30.44,11.75 31.49,11.31 32.58,10.92 37.68,9.3 42.59,8.58 48.86,8.26 Z M 146.16,8.19 C 152.7,8.45 157.45,9.07 161.93,10.55 L 163.42,10.92 C 164.17,11.19 164.9,11.48 165.62,11.8 165.62,46.71 165.62,150.6 165.62,184.2 164.9,184.52 164.17,184.81 163.42,185.08 158.05,186.78 152.91,187.49 146.16,187.79 146.16,157.73 146.16,40.02 146.16,8.19 Z M 126.7,188 L 107.24,188 C 107.24,158.23 107.24,39.63 107.24,8 L 126.7,8 C 126.7,39.63 126.7,158.23 126.7,188 Z M 87.78,188 L 68.32,188 C 68.32,158.23 68.32,39.63 68.32,8 L 87.78,8 C 87.78,39.63 87.78,158.23 87.78,188 Z M 87.78,188')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('canvasSquareStriped-groupHighlights')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$rect,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('canvasSquareStriped-bottomHighligh'),
														$elm$svg$Svg$Attributes$opacity('0.4'),
														$elm$svg$Svg$Attributes$stroke('none'),
														$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareBottomHighlight-bottomHighligh)'),
														$elm$svg$Svg$Attributes$x('8'),
														$elm$svg$Svg$Attributes$y('8'),
														$elm$svg$Svg$Attributes$width('180'),
														$elm$svg$Svg$Attributes$height('180'),
														$elm$svg$Svg$Attributes$rx('40')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$path,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('canvasSquareStriped-bottomRight'),
														$elm$svg$Svg$Attributes$stroke('none'),
														$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareHighlightCorner-bottomRight)'),
														$elm$svg$Svg$Attributes$d('M 76.25,16.76 L 120.72,16.76 C 137.85,16.76 146.42,16.76 154.14,19.31 L 155.64,19.67 C 165.71,23.34 173.64,31.27 177.3,41.33 180.22,50.55 180.22,59.12 180.22,76.25 L 180.22,118.78 C 180.22,135.91 180.22,144.47 177.67,152.2 L 177.3,153.69 C 173.64,163.76 165.71,171.69 155.64,175.35 146.42,178.27 137.85,178.27 120.72,178.27 L 76.25,178.27 C 59.12,178.27 50.55,178.27 42.83,175.72 L 41.33,175.35 C 31.27,171.69 23.34,163.76 19.67,153.69 16.76,144.47 16.76,135.91 16.76,118.78 L 16.76,76.25 C 16.76,59.12 16.76,50.55 19.31,42.83 L 19.67,41.33 C 23.34,31.27 31.27,23.34 41.33,19.67 50.55,16.76 59.12,16.76 76.25,16.76 Z M 76.25,16.76')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$path,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('canvasSquareStriped-top'),
														$elm$svg$Svg$Attributes$stroke('none'),
														$elm$svg$Svg$Attributes$fill('url(#canvasSquareStriped-squareHighlightGradient-top)'),
														$elm$svg$Svg$Attributes$d('M 66.55,16.76 L 120.72,16.76 C 139.62,16.76 147.98,16.76 155.51,19.24 L 156.97,19.6 C 170.92,24.68 180.22,37.95 180.22,52.81 180.22,54.7 180.22,54.7 180.22,54.7 L 180.22,54.7 180.22,54.7 180.22,56.6 C 180.22,71.46 170.92,84.73 156.97,89.81 147.98,92.65 139.62,92.65 122.92,92.65 L 76.25,92.65 C 57.35,92.65 49,92.65 41.47,90.16 L 40.01,89.81 C 26.05,84.73 16.76,71.46 16.76,56.6 16.76,54.7 16.76,54.7 16.76,54.7 L 16.76,54.7 16.76,54.7 16.76,52.81 C 16.76,37.95 26.05,24.68 40.01,19.6 49,16.76 57.35,16.76 74.05,16.76 L 76.25,16.76 66.55,16.76 Z M 66.55,16.76')
													]),
												_List_Nil)
											]))
									]))
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedSquare$stripedSquare = F3(
	function (stripeDirection, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		if (!stripeDirection) {
			return A3(
				$author$project$SVGs$Bonuses$StripedSquare$stripedSquareHorizontal,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		} else {
			return A3(
				$author$project$SVGs$Bonuses$StripedSquare$stripedSquareVertical,
				attributes,
				$author$project$Services$Board$boardKanaColorToColor(color),
				id);
		}
	});
var $author$project$SVGs$Bonuses$StripedTriangle$horizontalStripes = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('bezier'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Services$ShapeColor$getColorString(
					$author$project$Services$ShapeColor$stripeColor(color))),
				$elm$svg$Svg$Attributes$d('M 152.28,50 L 46.72,50 C 51.66,42.55 56.99,35.76 62.61,30 L 136.39,30 C 142.01,35.76 147.34,42.55 152.28,50 Z M 172.91,90 L 26.09,90 C 28.78,83.25 31.81,76.52 35.13,70 L 163.87,70 C 167.19,76.52 170.22,83.25 172.91,90 Z M 184.82,130 L 14.18,130 C 15.37,123.66 17.02,116.92 19.1,110 L 179.9,110 C 181.98,116.92 183.63,123.66 184.82,130 Z M 186.93,150 C 186.95,156.8 186.02,162.44 184.03,166.42 183.4,167.66 182.57,168.86 181.54,170 L 17.46,170 C 16.43,168.86 15.6,167.66 14.97,166.42 12.98,162.44 12.05,156.8 12.07,150 L 186.93,150 Z M 186.93,150')
			]),
		_List_Nil);
};
var $author$project$SVGs$Bonuses$StripedTriangle$verticalStripes = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('bezier'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Services$ShapeColor$getColorString(
					$author$project$Services$ShapeColor$stripeColor(color))),
				$elm$svg$Svg$Attributes$d('M 150,46.65 C 157.63,57.59 164.4,70.15 170,83.01 170,117.53 170,154.83 170,177.81 164.45,180.35 157.64,182.46 150,184.14 150,154.76 150,90.87 150,46.65 Z M 50,45.24 C 50,89.6 50,154.76 50,184.35 42.41,182.74 35.61,180.71 30,178.25 30,154.82 30,116.11 30,80.74 35.65,68.12 42.41,55.86 50,45.24 Z M 110,12.58 C 116.9,14.64 123.61,18.63 130,24.03 130,66.79 130,154.65 130,187.36 123.54,188.08 116.81,188.57 110,188.81 110,154.2 110,49.01 110,12.58 Z M 90,12.3 C 90,48.47 90,154.18 90,188.85 83.19,188.63 76.47,188.17 70,187.47 70,154.63 70,65.69 70,23.2 76.4,17.96 83.11,14.16 90,12.3 Z M 90,12.3')
			]),
		_List_Nil);
};
var $author$project$SVGs$Bonuses$StripedTriangle$stripeDirectionToStripes = function (stripeDirection) {
	if (!stripeDirection) {
		return $author$project$SVGs$Bonuses$StripedTriangle$horizontalStripes;
	} else {
		return $author$project$SVGs$Bonuses$StripedTriangle$verticalStripes;
	}
};
var $author$project$SVGs$Bonuses$StripedTriangle$backgroundTriangle = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('backgroundTriangle'),
			$elm$svg$Svg$Attributes$fillRule('evenodd'),
			$elm$svg$Svg$Attributes$stroke('none'),
			$elm$svg$Svg$Attributes$fill('url(#squareGradient-backgroundTriangle)'),
			$elm$svg$Svg$Attributes$d('M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11')
		]),
	_List_Nil);
var $author$project$SVGs$Bonuses$StripedTriangle$definitions = function (color) {
	return A2(
		$elm$svg$Svg$defs,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('squareGradient-backgroundTriangle'),
						$elm$svg$Svg$Attributes$x1('99.5'),
						$elm$svg$Svg$Attributes$y1('11'),
						$elm$svg$Svg$Attributes$x2('99.5'),
						$elm$svg$Svg$Attributes$y2('189'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('triangleBottomHighlight-bottomHighlight'),
						$elm$svg$Svg$Attributes$x1('99.5'),
						$elm$svg$Svg$Attributes$y1('11'),
						$elm$svg$Svg$Attributes$x2('99.5'),
						$elm$svg$Svg$Attributes$y2('189'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.75'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('triangleBottomHighlightGradient-innerTriangleBottomHighlight'),
						$elm$svg$Svg$Attributes$x1('49.69'),
						$elm$svg$Svg$Attributes$y1('45.96'),
						$elm$svg$Svg$Attributes$x2('131.98'),
						$elm$svg$Svg$Attributes$y2('188.48'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.76'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('triangleHighlightGradient-triangleTopHighlight'),
						$elm$svg$Svg$Attributes$x1('100'),
						$elm$svg$Svg$Attributes$y1('23'),
						$elm$svg$Svg$Attributes$x2('100'),
						$elm$svg$Svg$Attributes$y2('93'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.41'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$SVGs$Bonuses$StripedTriangle$highlights = A2(
	$elm$svg$Svg$g,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('groupHighlights')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('bottomHighlight'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#triangleBottomHighlight-bottomHighlight)'),
					$elm$svg$Svg$Attributes$d('M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('innerTriangleBottomHighlight'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#triangleBottomHighlightGradient-innerTriangleBottomHighlight)'),
					$elm$svg$Svg$Attributes$d('M 99.43,23 C 150,23 187.46,134.23 174.13,160.96 160.79,187.68 38.06,187.68 24.73,160.96 11.39,134.23 48.86,23 99.43,23 Z M 99.43,23')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('triangleTopHighlight'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#triangleHighlightGradient-triangleTopHighlight)'),
					$elm$svg$Svg$Attributes$d('M 100,23 C 130,23 151.74,72.28 143.9,84.12 136.06,95.96 63.94,95.96 56.1,84.12 48.26,72.28 70,23 100,23 Z M 100,23')
				]),
			_List_Nil)
		]));
var $author$project$SVGs$Bonuses$StripedTriangle$triangleShadow = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('triangleShadow'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Services$ShapeColor$getColorString(
					$author$project$Services$ShapeColor$backgroundShadowColor(color))),
				$elm$svg$Svg$Attributes$d('M 101.5,13 C 155,13 201.11,138.31 186.03,168.42 170.94,198.53 32.06,198.53 16.97,168.42 1.89,138.31 48,13 101.5,13 Z M 101.5,13')
			]),
		_List_Nil);
};
var $author$project$SVGs$Bonuses$StripedTriangle$stripedTriangleDrawing = F4(
	function (attributes, color, key, stripes) {
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						$author$project$SVGs$Bonuses$StripedTriangle$definitions(color),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('group')
							]),
						_List_fromArray(
							[
								$author$project$SVGs$Bonuses$StripedTriangle$triangleShadow(color),
								$author$project$SVGs$Bonuses$StripedTriangle$backgroundTriangle,
								stripes(color),
								$author$project$SVGs$Bonuses$StripedTriangle$highlights
							]))
					])));
	});
var $author$project$SVGs$Bonuses$StripedTriangle$stripedTriangle = F3(
	function (stripeDirection, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return A4(
			$author$project$SVGs$Bonuses$StripedTriangle$stripedTriangleDrawing,
			attributes,
			$author$project$Services$Board$boardKanaColorToColor(color),
			id,
			$author$project$SVGs$Bonuses$StripedTriangle$stripeDirectionToStripes(stripeDirection));
	});
var $author$project$SVGs$Shapes$TriangleWithKana$definitions = function (color) {
	return A2(
		$elm$svg$Svg$defs,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-squareGradient-backgroundTriangle'),
						$elm$svg$Svg$Attributes$x1('99.5'),
						$elm$svg$Svg$Attributes$y1('11'),
						$elm$svg$Svg$Attributes$x2('99.5'),
						$elm$svg$Svg$Attributes$y2('189'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$kanaShadowColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-innerSquareGradient-innerTriangle2'),
						$elm$svg$Svg$Attributes$x1('99.43'),
						$elm$svg$Svg$Attributes$y1('23'),
						$elm$svg$Svg$Attributes$x2('99.43'),
						$elm$svg$Svg$Attributes$y2('181'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$gradientKanaBackgroundColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$getStopColorAttribute(color),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$filter,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-shadow2-outer'),
						$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$feGaussianBlur,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stdDeviation('2')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feOffset,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$dx('1'),
								$elm$svg$Svg$Attributes$dy('1'),
								$elm$svg$Svg$Attributes$result('blur')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feFlood,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$floodColor(
								$author$project$Services$ShapeColor$getColorString(
									$author$project$Services$ShapeColor$kanaShadowColor(color))),
								$elm$svg$Svg$Attributes$floodOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('blur'),
								$elm$svg$Svg$Attributes$operator('in'),
								$elm$svg$Svg$Attributes$result('colorShadow')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in_('SourceGraphic'),
								$elm$svg$Svg$Attributes$in2('colorShadow'),
								$elm$svg$Svg$Attributes$operator('over')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-squareBottomHighlight-backgroundTriangle2'),
						$elm$svg$Svg$Attributes$x1('99.5'),
						$elm$svg$Svg$Attributes$y1('11'),
						$elm$svg$Svg$Attributes$x2('99.5'),
						$elm$svg$Svg$Attributes$y2('189'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.44'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-triangleBottomHighlightGradient-innerTriangleBottomHighlight2'),
						$elm$svg$Svg$Attributes$x1('49.69'),
						$elm$svg$Svg$Attributes$y1('45.96'),
						$elm$svg$Svg$Attributes$x2('131.98'),
						$elm$svg$Svg$Attributes$y2('188.48'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.76'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-triangleHighlightGradient-triangleTopHighlight'),
						$elm$svg$Svg$Attributes$x1('100'),
						$elm$svg$Svg$Attributes$y1('23'),
						$elm$svg$Svg$Attributes$x2('100'),
						$elm$svg$Svg$Attributes$y2('93'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.41'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-innerSquareGradiant-innerTriangle'),
						$elm$svg$Svg$Attributes$x1('99.93'),
						$elm$svg$Svg$Attributes$y1('35.5'),
						$elm$svg$Svg$Attributes$x2('99.93'),
						$elm$svg$Svg$Attributes$y2('173.5'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$elm$svg$Svg$Attributes$stopColor(
								$author$project$Services$ShapeColor$getColorString(
									$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color))),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.19'),
								$elm$svg$Svg$Attributes$stopColor(
								$author$project$Services$ShapeColor$getColorString(
									A2(
										$author$project$Services$ShapeColor$getCenterGradientColor,
										$author$project$Services$ShapeColor$gradientKanaBackgroundColor(color),
										$author$project$Services$ShapeColor$kanaLightColor(color)))),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$elm$svg$Svg$Attributes$stopColor(
								$author$project$Services$ShapeColor$getColorString(
									$author$project$Services$ShapeColor$kanaLightColor(color))),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$filter,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-shadow3-inner'),
						$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$feGaussianBlur,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in_('SourceAlpha'),
								$elm$svg$Svg$Attributes$stdDeviation('1'),
								$elm$svg$Svg$Attributes$result('blur')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feOffset,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$dx('0'),
								$elm$svg$Svg$Attributes$dy('6')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('SourceAlpha'),
								$elm$svg$Svg$Attributes$operator('arithmetic'),
								$elm$svg$Svg$Attributes$k2('-1.15'),
								$elm$svg$Svg$Attributes$k3('1.15'),
								$elm$svg$Svg$Attributes$result('shadowDiff')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feFlood,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$floodColor(
								$author$project$Services$ShapeColor$getColorString(color)),
								$elm$svg$Svg$Attributes$floodOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('shadowDiff'),
								$elm$svg$Svg$Attributes$operator('in')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$feComposite,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$in2('SourceGraphic'),
								$elm$svg$Svg$Attributes$operator('over')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-triangleInnerHighlight-innerTriangleHighlight'),
						$elm$svg$Svg$Attributes$x1('100'),
						$elm$svg$Svg$Attributes$y1('45'),
						$elm$svg$Svg$Attributes$x2('100'),
						$elm$svg$Svg$Attributes$y2('111.5'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.26'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$linearGradient,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-triangleBottomInnerHighlightGradient-innerTriangleBottomHighlight'),
						$elm$svg$Svg$Attributes$x1('51.57'),
						$elm$svg$Svg$Attributes$y1('77.25'),
						$elm$svg$Svg$Attributes$x2('148.28'),
						$elm$svg$Svg$Attributes$y2('173.95'),
						$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('0.77'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$stop,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$offset('1'),
								$author$project$Services$ShapeColor$highlightColorAttribute($elm$svg$Svg$Attributes$stopColor),
								$elm$svg$Svg$Attributes$stopOpacity('1')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$SVGs$Shapes$TriangleWithKana$highlights = A2(
	$elm$svg$Svg$g,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-squareBottomHighlight-backgroundTriangle2)'),
					$elm$svg$Svg$Attributes$d('M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-triangleBottomHighlightGradient-innerTriangleBottomHighlight2)'),
					$elm$svg$Svg$Attributes$d('M 99.43,23 C 150,23 187.46,134.23 174.13,160.96 160.79,187.68 38.06,187.68 24.73,160.96 11.39,134.23 48.86,23 99.43,23 Z M 99.43,23')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-triangleHighlightGradient-triangleTopHighlight)'),
					$elm$svg$Svg$Attributes$d('M 100,23 C 130,23 151.74,72.28 143.9,84.12 136.06,95.96 63.94,95.96 56.1,84.12 48.26,72.28 70,23 100,23 Z M 100,23')
				]),
			_List_Nil)
		]));
var $author$project$SVGs$Shapes$TriangleWithKana$innerTriangle = A2(
	$elm$svg$Svg$g,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-innerSquareGradiant-innerTriangle)'),
					$elm$svg$Svg$Attributes$filter('url(#canvasTriangleWithKanaDrawing-shadow3-inner)'),
					$elm$svg$Svg$Attributes$d('M 99.93,35.5 C 140,35.5 177.04,132.65 165.36,155.99 153.68,179.34 46.17,179.34 34.49,155.99 22.82,132.65 59.86,35.5 99.93,35.5 Z M 99.93,35.5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-triangleInnerHighlight-innerTriangleHighlight)'),
					$elm$svg$Svg$Attributes$d('M 100,45 C 130,45 143.69,91.81 137.07,103.06 130.45,114.31 69.55,114.31 62.93,103.06 56.31,91.81 70,45 100,45 Z M 100,45')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-triangleBottomInnerHighlightGradient-innerTriangleBottomHighlight)'),
					$elm$svg$Svg$Attributes$d('M 99.93,35.5 C 123.29,35.5 177.04,132.65 165.36,155.99 153.68,179.34 46.17,179.34 34.49,155.99 22.82,132.65 76.57,35.5 99.93,35.5 Z M 99.93,35.5')
				]),
			_List_Nil)
		]));
var $author$project$SVGs$Shapes$TriangleWithKana$outerTriangle = function (color) {
	return A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-triangleShadow'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill(
						$author$project$Services$ShapeColor$getColorString(
							$author$project$Services$ShapeColor$kanaTextColor(color))),
						$elm$svg$Svg$Attributes$d('M 101.5,13 C 155,13 201.11,138.31 186.03,168.42 170.94,198.53 32.06,198.53 16.97,168.42 1.89,138.31 48,13 101.5,13 Z M 101.5,13')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-backgroundTriangle'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-squareGradient-backgroundTriangle)'),
						$elm$svg$Svg$Attributes$d('M 99.5,11 C 153,11 199.11,136.31 184.03,166.42 168.94,196.53 30.06,196.53 14.97,166.42 -0.11,136.31 46,11 99.5,11 Z M 99.5,11')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasTriangleWithKanaDrawing-innerTriangle2'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill('url(#canvasTriangleWithKanaDrawing-innerSquareGradient-innerTriangle2)'),
						$elm$svg$Svg$Attributes$filter('url(#canvasTriangleWithKanaDrawing-shadow2-outer)'),
						$elm$svg$Svg$Attributes$d('M 99.43,23 C 150,23 187.46,134.23 174.13,160.96 160.79,187.68 38.06,187.68 24.73,160.96 11.39,134.23 48.86,23 99.43,23 Z M 99.43,23')
					]),
				_List_Nil)
			]));
};
var $author$project$SVGs$Shapes$TriangleWithKana$triangleWithKana = F3(
	function (kanaString, attributes, _v0) {
		var id = _v0.cp;
		var color = _v0.bQ;
		return _Utils_Tuple2(
			id,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						$author$project$SVGs$Shapes$TriangleWithKana$definitions(
						$author$project$Services$Board$boardKanaColorToColor(color)),
						$author$project$SVGs$Shapes$TriangleWithKana$outerTriangle(
						$author$project$Services$Board$boardKanaColorToColor(color)),
						$author$project$SVGs$Shapes$TriangleWithKana$highlights,
						function () {
						if (!kanaString.$) {
							var textValue = kanaString.a;
							return A2(
								$elm$svg$Svg$g,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$SVGs$Shapes$TriangleWithKana$innerTriangle,
										A3(
										$elm$svg$Svg$node,
										'text',
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$fill(
												$author$project$Services$ShapeColor$getColorString(
													$author$project$Services$ShapeColor$kanaTextColor(
														$author$project$Services$Board$boardKanaColorToColor(color)))),
												$elm$svg$Svg$Attributes$fontFamily('Helvetica-Bold, Helvetica, sans-serif'),
												$elm$svg$Svg$Attributes$fontWeight('bold'),
												$elm$svg$Svg$Attributes$fontSize('95'),
												$elm$svg$Svg$Attributes$x('53'),
												$elm$svg$Svg$Attributes$y('55'),
												$elm$svg$Svg$Attributes$textAnchor('middle')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$tspan,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$x('50%'),
														$elm$svg$Svg$Attributes$y('75%')
													]),
												_List_fromArray(
													[
														$elm$svg$Svg$text(textValue)
													]))
											]))
									]));
						} else {
							return $elm$svg$Svg$text('');
						}
					}()
					])));
	});
var $author$project$Services$SVGConversion$generateBoardItemHtml = F3(
	function (boardItem, hasTileAt, attributes) {
		var _v0 = boardItem.bF;
		switch (_v0.$) {
			case 1:
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					$elm$core$Basics$always(
						_Utils_Tuple2(
							boardItem.cp,
							$author$project$SVGs$Bonuses$FiveInARowBonus$fiveInARowBonus(
								attributes(boardItem)))),
					hasTileAt,
					boardItem);
			case 0:
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					$author$project$SVGs$Bonuses$BombBonus$bombBonus(
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 2:
				var stripeDirection = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Bonuses$StripedDiamond$stripedDiamond,
						stripeDirection,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 3:
				var stripeDirection = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Bonuses$StripedHexagon$stripedHexagon,
						stripeDirection,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 4:
				var stripeDirection = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Bonuses$StripedOval$stripedOval,
						stripeDirection,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 5:
				var stripeDirection = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Bonuses$StripedTriangle$stripedTriangle,
						stripeDirection,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 6:
				var stripeDirection = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Bonuses$StripedSquare$stripedSquare,
						stripeDirection,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 7:
				var kanaString = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Shapes$DiamondWithKana$diamondWithKana,
						kanaString,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 8:
				var kanaString = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Shapes$HexagonWithKana$hexagonWithKana,
						kanaString,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 9:
				var kanaString = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Shapes$OvalWithKana$ovalWithKana,
						kanaString,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			case 10:
				var kanaString = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Shapes$TriangleWithKana$triangleWithKana,
						kanaString,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
			default:
				var kanaString = _v0.a;
				return A3(
					$author$project$Services$SVGConversion$renderOrEmpty,
					A2(
						$author$project$SVGs$Shapes$SquareWithKana$squareWithKana,
						kanaString,
						attributes(boardItem)),
					hasTileAt,
					boardItem);
		}
	});
var $author$project$Services$Swap$isItemAFillSwap = F2(
	function (coordinates, fillSwaps) {
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var firstCoordinates = _v0.a;
				return _Utils_eq(coordinates, firstCoordinates);
			},
			fillSwaps);
	});
var $author$project$Services$Swap$isItemNotAFillSwap = F2(
	function (coordinates, fillSwaps) {
		return !A2($author$project$Services$Swap$isItemAFillSwap, coordinates, fillSwaps);
	});
var $author$project$Services$CssSelector$columnToSelector = function (column) {
	return $elm$svg$Svg$Attributes$class(
		'column' + $elm$core$String$fromInt(column));
};
var $author$project$Services$CssSelector$rowToSelector = function (row) {
	return (row >= 0) ? $elm$svg$Svg$Attributes$class(
		'row' + $elm$core$String$fromInt(row)) : $elm$svg$Svg$Attributes$class(
		'row' + ($elm$core$String$fromInt(
			$elm$core$Basics$abs(row)) + 'Above'));
};
var $author$project$Services$Shape$defaultCoordinateAttributes = F2(
	function (_v0, existingAttributes) {
		var row = _v0.a;
		var column = _v0.b;
		if (!existingAttributes.b) {
			return _List_fromArray(
				[
					$author$project$Services$CssSelector$rowToSelector(row),
					$author$project$Services$CssSelector$columnToSelector(column)
				]);
		} else {
			return existingAttributes;
		}
	});
var $author$project$Services$CssSelector$hintAboveAnimation = $elm$svg$Svg$Attributes$class('hint-above-animation');
var $author$project$Services$CssAnimation$hintBelow = 'hint-below';
var $author$project$Services$CssSelector$hintBelowAnimation = $elm$svg$Svg$Attributes$class('hint-below-animation');
var $author$project$Services$CssAnimation$hintLeft = 'hint-left';
var $author$project$Services$CssSelector$hintLeftAnimation = $elm$svg$Svg$Attributes$class('hint-left-animation');
var $author$project$Services$CssSelector$hintRightAnimation = $elm$svg$Svg$Attributes$class('hint-right-animation');
var $author$project$Extras$Events$animationNameDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['animationName']),
	$elm$json$Json$Decode$string);
var $author$project$Extras$Events$onAnimationEnd = F2(
	function (animationName, message) {
		return A2(
			$elm$svg$Svg$Events$on,
			'animationend',
			A2(
				$elm$json$Json$Decode$andThen,
				A2($author$project$Extras$Events$isPropertyName, message, animationName),
				$author$project$Extras$Events$animationNameDecoder));
	});
var $author$project$Services$Shape$getHintSelector = function (_v0) {
	var firstSwapCoordinates = _v0.a;
	var secondSwapCoordinates = _v0.b;
	return _Utils_eq(
		$author$project$Services$Matrix$rightOf(firstSwapCoordinates),
		secondSwapCoordinates) ? _List_fromArray(
		[
			$author$project$Services$CssSelector$hintLeftAnimation,
			A2(
			$author$project$Extras$Events$onAnimationEnd,
			$author$project$Services$CssAnimation$hintLeft,
			$author$project$Domain$Types$HintMessage(
				$author$project$Domain$Types$UpdateHint($elm$core$Maybe$Nothing)))
		]) : (_Utils_eq(
		$author$project$Services$Matrix$leftOf(firstSwapCoordinates),
		secondSwapCoordinates) ? _List_fromArray(
		[$author$project$Services$CssSelector$hintRightAnimation]) : (_Utils_eq(
		$author$project$Services$Matrix$above(firstSwapCoordinates),
		secondSwapCoordinates) ? _List_fromArray(
		[
			$author$project$Services$CssSelector$hintBelowAnimation,
			A2(
			$author$project$Extras$Events$onAnimationEnd,
			$author$project$Services$CssAnimation$hintBelow,
			$author$project$Domain$Types$HintMessage(
				$author$project$Domain$Types$UpdateHint($elm$core$Maybe$Nothing)))
		]) : (_Utils_eq(
		$author$project$Services$Matrix$below(firstSwapCoordinates),
		secondSwapCoordinates) ? _List_fromArray(
		[$author$project$Services$CssSelector$hintAboveAnimation]) : _List_Nil)));
};
var $author$project$Services$Shape$hintSwapSelector = F2(
	function (coordinates, _v0) {
		var firstSwapCoordinates = _v0.a;
		var secondSwapCoordinates = _v0.b;
		var _v1 = _Utils_Tuple2(
			_Utils_eq(coordinates, firstSwapCoordinates),
			_Utils_eq(coordinates, secondSwapCoordinates));
		_v1$2:
		while (true) {
			if (_v1.a) {
				if (!_v1.b) {
					return $author$project$Services$Shape$getHintSelector(
						_Utils_Tuple2(secondSwapCoordinates, firstSwapCoordinates));
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b) {
					return $author$project$Services$Shape$getHintSelector(
						_Utils_Tuple2(firstSwapCoordinates, secondSwapCoordinates));
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Services$Shape$hintSwapAttributes = F3(
	function (_v0, coordinates, existingAttributes) {
		var swapState = _v0.ds;
		var row = coordinates.a;
		var column = coordinates.b;
		var _v1 = swapState.co;
		if (!_v1.$) {
			var hintSwapValue = _v1.a;
			return _Utils_ap(
				existingAttributes,
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Services$CssSelector$rowToSelector(row),
							$author$project$Services$CssSelector$columnToSelector(column)
						]),
					A2($author$project$Services$Shape$hintSwapSelector, coordinates, hintSwapValue)));
		} else {
			return existingAttributes;
		}
	});
var $author$project$Services$CssSelector$swapAnimationSelector = $elm$svg$Svg$Attributes$class('swap-animation');
var $author$project$Services$Shape$cssAnimationSelector = F2(
	function (coordinates, _v0) {
		var firstSwapCoordinates = _v0.a;
		var secondSwapCoordinates = _v0.b;
		var _v1 = _Utils_Tuple2(
			_Utils_eq(coordinates, firstSwapCoordinates),
			_Utils_eq(coordinates, secondSwapCoordinates));
		_v1$2:
		while (true) {
			if (_v1.a) {
				if (!_v1.b) {
					return _List_fromArray(
						[$author$project$Services$CssSelector$swapAnimationSelector]);
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b) {
					return _List_fromArray(
						[$author$project$Services$CssSelector$swapAnimationSelector]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Domain$Types$InvalidClickSwapFinished = {$: 1};
var $author$project$Services$CssSelector$invalidSwap = $elm$svg$Svg$Attributes$class('invalid-swap');
var $author$project$Services$CssSelector$invalidSwapAboveAnimation = $elm$svg$Svg$Attributes$class('invalid-swap-above-animation');
var $author$project$Services$CssAnimation$invalidSwapBelow = 'invalid-swap-below';
var $author$project$Services$CssSelector$invalidSwapBelowAnimation = $elm$svg$Svg$Attributes$class('invalid-swap-below-animation');
var $author$project$Services$CssAnimation$invalidSwapLeft = 'invalid-swap-left';
var $author$project$Services$CssSelector$invalidSwapLeftAnimation = $elm$svg$Svg$Attributes$class('invalid-swap-left-animation');
var $author$project$Services$CssSelector$invalidSwapRightAnimation = $elm$svg$Svg$Attributes$class('invalid-swap-right-animation');
var $author$project$Services$Shape$getInvalidSwapSelector = F2(
	function (firstSwapCoordinates, secondSwapCoordinates) {
		return _Utils_eq(
			$author$project$Services$Matrix$rightOf(firstSwapCoordinates),
			secondSwapCoordinates) ? _List_fromArray(
			[
				$author$project$Services$CssSelector$invalidSwap,
				$author$project$Services$CssSelector$invalidSwapLeftAnimation,
				A2(
				$author$project$Extras$Events$onAnimationEnd,
				$author$project$Services$CssAnimation$invalidSwapLeft,
				$author$project$Domain$Types$SwapMessage($author$project$Domain$Types$InvalidClickSwapFinished))
			]) : (_Utils_eq(
			$author$project$Services$Matrix$leftOf(firstSwapCoordinates),
			secondSwapCoordinates) ? _List_fromArray(
			[$author$project$Services$CssSelector$invalidSwap, $author$project$Services$CssSelector$invalidSwapRightAnimation]) : (_Utils_eq(
			$author$project$Services$Matrix$above(firstSwapCoordinates),
			secondSwapCoordinates) ? _List_fromArray(
			[
				$author$project$Services$CssSelector$invalidSwap,
				$author$project$Services$CssSelector$invalidSwapBelowAnimation,
				A2(
				$author$project$Extras$Events$onAnimationEnd,
				$author$project$Services$CssAnimation$invalidSwapBelow,
				$author$project$Domain$Types$SwapMessage($author$project$Domain$Types$InvalidClickSwapFinished))
			]) : (_Utils_eq(
			$author$project$Services$Matrix$below(firstSwapCoordinates),
			secondSwapCoordinates) ? _List_fromArray(
			[$author$project$Services$CssSelector$invalidSwap, $author$project$Services$CssSelector$invalidSwapAboveAnimation]) : _List_Nil)));
	});
var $author$project$Services$Shape$invalidClickSwapSelector = F2(
	function (coordinates, _v0) {
		var firstSwapCoordinates = _v0.a;
		var secondSwapCoordinates = _v0.b;
		var _v1 = _Utils_Tuple2(
			_Utils_eq(coordinates, firstSwapCoordinates),
			_Utils_eq(coordinates, secondSwapCoordinates));
		_v1$2:
		while (true) {
			if (_v1.a) {
				if (!_v1.b) {
					return A2($author$project$Services$Shape$getInvalidSwapSelector, secondSwapCoordinates, firstSwapCoordinates);
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b) {
					return A2($author$project$Services$Shape$getInvalidSwapSelector, firstSwapCoordinates, secondSwapCoordinates);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Services$CssSelector$invalidDragSwap = $elm$svg$Svg$Attributes$class('invalid-drag-swap');
var $author$project$Services$Shape$invalidDragSwapSelector = F2(
	function (coordinates, _v0) {
		var firstSwapCoordinates = _v0.a;
		var secondSwapCoordinates = _v0.b;
		var _v1 = _Utils_Tuple2(
			_Utils_eq(coordinates, firstSwapCoordinates),
			_Utils_eq(coordinates, secondSwapCoordinates));
		_v1$2:
		while (true) {
			if (_v1.a) {
				if (!_v1.b) {
					return _List_fromArray(
						[$author$project$Services$CssSelector$invalidDragSwap]);
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b) {
					return _List_fromArray(
						[$author$project$Services$CssSelector$invalidDragSwap]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Services$Shape$invalidSwapAttributes = F3(
	function (_v0, coordinates, existingAttributes) {
		var swapState = _v0.ds;
		var inputState = _v0.cx;
		var row = coordinates.a;
		var column = coordinates.b;
		var _v1 = _Utils_Tuple3(swapState.cy, swapState.cz, inputState.cR);
		_v1$3:
		while (true) {
			if (_v1.a.$ === 1) {
				if ((!_v1.b.$) && (!_v1.c.$)) {
					var _v2 = _v1.a;
					var invalidDragSwapValue = _v1.b.a;
					var _v3 = _v1.c.a;
					return _Utils_ap(
						existingAttributes,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Services$CssSelector$rowToSelector(row),
									$author$project$Services$CssSelector$columnToSelector(column)
								]),
							A2($author$project$Services$Shape$invalidDragSwapSelector, coordinates, invalidDragSwapValue)));
				} else {
					break _v1$3;
				}
			} else {
				if (_v1.b.$ === 1) {
					if (_v1.c.$ === 1) {
						var invalidSwapValue = _v1.a.a;
						var _v4 = _v1.b;
						var _v5 = _v1.c;
						return _Utils_ap(
							existingAttributes,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Services$CssSelector$rowToSelector(row),
										$author$project$Services$CssSelector$columnToSelector(column)
									]),
								A2($author$project$Services$Shape$invalidClickSwapSelector, coordinates, invalidSwapValue)));
					} else {
						var invalidSwapValue = _v1.a.a;
						var _v6 = _v1.b;
						var _v7 = _v1.c.a;
						var deltaX = _v7.a;
						var deltaY = _v7.b;
						return ((_Utils_cmp(deltaX, $author$project$Services$Swap$dragSensitivity) < 0) && (_Utils_cmp(deltaY, $author$project$Services$Swap$dragSensitivity) < 0)) ? _Utils_ap(
							existingAttributes,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Services$CssSelector$rowToSelector(row),
										$author$project$Services$CssSelector$columnToSelector(column)
									]),
								A2($author$project$Services$Shape$invalidClickSwapSelector, coordinates, invalidSwapValue))) : _Utils_ap(
							existingAttributes,
							A2($author$project$Services$Shape$cssAnimationSelector, coordinates, invalidSwapValue));
					}
				} else {
					break _v1$3;
				}
			}
		}
		return existingAttributes;
	});
var $author$project$Services$CssSelector$boardCenter = $elm$svg$Svg$Attributes$class('boardCenter');
var $author$project$Services$Time$maximumShuffleDelay = 250;
var $author$project$Services$Time$movingFromCenterDelay = 500;
var $author$project$Services$CssSelector$shuffleAnimation = $elm$svg$Svg$Attributes$class('shuffleAnimation');
var $author$project$Services$Shape$transitionDelayAttribute = function (delayInMilliseconds) {
	return $elm$svg$Svg$Attributes$style(
		'transition-delay: ' + ($elm$core$String$fromInt(delayInMilliseconds) + 'ms;'));
};
var $author$project$Services$Shape$shuffleAttributes = F2(
	function (_v0, _v1) {
		var shuffle = _v0.a5;
		var row = _v1.a;
		var column = _v1.b;
		var _v2 = A2(
			$elm$random$Random$step,
			A2($elm$random$Random$int, 0, $author$project$Services$Time$maximumShuffleDelay),
			$elm$random$Random$initialSeed(row + column));
		var randomDelay = _v2.a;
		var _v3 = shuffle.dh;
		switch (_v3) {
			case 0:
				return _List_fromArray(
					[
						$author$project$Services$CssSelector$boardCenter,
						$author$project$Services$CssSelector$shuffleAnimation,
						$author$project$Services$Shape$transitionDelayAttribute(randomDelay)
					]);
			case 1:
				return _List_fromArray(
					[
						$author$project$Services$CssSelector$rowToSelector(row),
						$author$project$Services$CssSelector$columnToSelector(column),
						$author$project$Services$CssSelector$shuffleAnimation,
						$author$project$Services$Shape$transitionDelayAttribute($author$project$Services$Time$movingFromCenterDelay + randomDelay)
					]);
			case 2:
				return _List_Nil;
			case 3:
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$Services$Shape$getSwapPropertyName = function (_v0) {
	var _v1 = _v0.a;
	var rowIndex = _v1.a;
	var columnIndex = _v1.b;
	var _v2 = _v0.b;
	var rowIndex2 = _v2.a;
	var columnIndex2 = _v2.b;
	return _Utils_eq(rowIndex, rowIndex2) ? 'left' : 'top';
};
var $author$project$Services$Shape$swapCoordinates = F2(
	function (coordinates, _v0) {
		var firstCoordinates = _v0.a;
		var secondCoordinates = _v0.b;
		var _v1 = _Utils_Tuple2(
			_Utils_eq(coordinates, firstCoordinates),
			_Utils_eq(coordinates, secondCoordinates));
		_v1$2:
		while (true) {
			if (_v1.a) {
				if (!_v1.b) {
					return secondCoordinates;
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b) {
					return firstCoordinates;
				} else {
					break _v1$2;
				}
			}
		}
		return coordinates;
	});
var $author$project$Services$Shape$swapAttributes = F3(
	function (_v0, coordinates, existingAttributes) {
		var swapState = _v0.ds;
		var _v1 = swapState.dr;
		if (!_v1.$) {
			var swapValue = _v1.a;
			var _v2 = A2($author$project$Services$Shape$swapCoordinates, coordinates, swapValue);
			var animationRow = _v2.a;
			var animationColumn = _v2.b;
			return _Utils_ap(
				existingAttributes,
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Services$CssSelector$rowToSelector(animationRow),
							$author$project$Services$CssSelector$columnToSelector(animationColumn)
						]),
					_Utils_ap(
						A2($author$project$Services$Shape$cssAnimationSelector, coordinates, swapValue),
						_Utils_eq(swapValue.a, coordinates) ? _List_fromArray(
							[
								A2(
								$author$project$Extras$Events$onTransitionEnd,
								$author$project$Services$Shape$getSwapPropertyName(swapValue),
								$author$project$Domain$Types$BoardMessage(0))
							]) : _List_Nil)));
		} else {
			return existingAttributes;
		}
	});
var $author$project$Domain$Types$FirstItemAbove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Types$FirstItemBelow = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Types$FirstItemLeft = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Types$FirstItemRight = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$NotPartOfSwap = {$: 8};
var $author$project$Domain$Types$SecondItemAbove = function (a) {
	return {$: 6, a: a};
};
var $author$project$Domain$Types$SecondItemBelow = function (a) {
	return {$: 7, a: a};
};
var $author$project$Domain$Types$SecondItemLeft = function (a) {
	return {$: 4, a: a};
};
var $author$project$Domain$Types$SecondItemRight = function (a) {
	return {$: 5, a: a};
};
var $author$project$Services$Matrix$isAbove = F2(
	function (coordinates1, coordinates2) {
		return _Utils_eq(
			coordinates1,
			$author$project$Services$Matrix$above(coordinates2));
	});
var $author$project$Services$Swap$isAboveDelta = F2(
	function (deltaX, deltaY) {
		return (_Utils_cmp(
			$elm$core$Basics$abs(deltaY),
			$elm$core$Basics$abs(deltaX)) > 0) && (_Utils_cmp(deltaY, $author$project$Services$Swap$dragSensitivity) > 0);
	});
var $author$project$Services$Matrix$isBelow = F2(
	function (coordinates1, coordinates2) {
		return _Utils_eq(
			coordinates1,
			$author$project$Services$Matrix$below(coordinates2));
	});
var $author$project$Services$Swap$isBelowDelta = F2(
	function (deltaX, deltaY) {
		return (_Utils_cmp(
			$elm$core$Basics$abs(deltaY),
			$elm$core$Basics$abs(deltaX)) > 0) && (_Utils_cmp(deltaY, (-1) * $author$project$Services$Swap$dragSensitivity) < 0);
	});
var $author$project$Services$Swap$isLeftDelta = F2(
	function (deltaX, deltaY) {
		return (_Utils_cmp(
			$elm$core$Basics$abs(deltaX),
			$elm$core$Basics$abs(deltaY)) > 0) && (_Utils_cmp(deltaX, $author$project$Services$Swap$dragSensitivity) > 0);
	});
var $author$project$Services$Matrix$isLeftOf = F2(
	function (coordinates1, coordinates2) {
		return _Utils_eq(
			coordinates1,
			$author$project$Services$Matrix$leftOf(coordinates2));
	});
var $author$project$Services$Swap$isRightDelta = F2(
	function (deltaX, deltaY) {
		return (_Utils_cmp(
			$elm$core$Basics$abs(deltaX),
			$elm$core$Basics$abs(deltaY)) > 0) && (_Utils_cmp(deltaX, (-1) * $author$project$Services$Swap$dragSensitivity) < 0);
	});
var $author$project$Services$Matrix$isRightOf = F2(
	function (coordinates1, coordinates2) {
		return _Utils_eq(
			coordinates1,
			$author$project$Services$Matrix$rightOf(coordinates2));
	});
var $author$project$Services$Swap$getSwapItemLocation = F2(
	function (_v0, coordinates) {
		var mouseDownCoordinates = _v0.cS;
		var mouseDelta = _v0.cR;
		var _v1 = _Utils_Tuple2(mouseDownCoordinates, mouseDelta);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var mouseDownCoordinatesValue = _v1.a.a;
			var _v2 = _v1.b.a;
			var deltaX = _v2.a;
			var deltaY = _v2.b;
			return A2($author$project$Services$Swap$isRightDelta, deltaX, deltaY) ? (_Utils_eq(coordinates, mouseDownCoordinatesValue) ? $author$project$Domain$Types$FirstItemLeft(deltaX) : (A2($author$project$Services$Matrix$isRightOf, mouseDownCoordinatesValue, coordinates) ? $author$project$Domain$Types$SecondItemRight(deltaX) : $author$project$Domain$Types$NotPartOfSwap)) : (A2($author$project$Services$Swap$isLeftDelta, deltaX, deltaY) ? (_Utils_eq(coordinates, mouseDownCoordinatesValue) ? $author$project$Domain$Types$FirstItemRight(deltaX) : (A2($author$project$Services$Matrix$isLeftOf, mouseDownCoordinatesValue, coordinates) ? $author$project$Domain$Types$SecondItemLeft(deltaX) : $author$project$Domain$Types$NotPartOfSwap)) : (A2($author$project$Services$Swap$isAboveDelta, deltaX, deltaY) ? (_Utils_eq(coordinates, mouseDownCoordinatesValue) ? $author$project$Domain$Types$FirstItemBelow(deltaY) : (A2($author$project$Services$Matrix$isAbove, mouseDownCoordinatesValue, coordinates) ? $author$project$Domain$Types$SecondItemAbove(deltaY) : $author$project$Domain$Types$NotPartOfSwap)) : (A2($author$project$Services$Swap$isBelowDelta, deltaX, deltaY) ? (_Utils_eq(coordinates, mouseDownCoordinatesValue) ? $author$project$Domain$Types$FirstItemAbove(deltaY) : (A2($author$project$Services$Matrix$isBelow, mouseDownCoordinatesValue, coordinates) ? $author$project$Domain$Types$SecondItemBelow(deltaY) : $author$project$Domain$Types$NotPartOfSwap)) : $author$project$Domain$Types$NotPartOfSwap)));
		} else {
			return $author$project$Domain$Types$NotPartOfSwap;
		}
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Services$Shape$horizontalPosition = F2(
	function (columnIndex, deltaX) {
		return (deltaX >= 0) ? $elm$svg$Svg$Attributes$style(
			'left: min(calc(' + ($elm$core$String$fromInt(columnIndex) + (' * var(--tileWidthAndHeight)' + (' + ' + ($elm$core$String$fromFloat(deltaX) + ('px' + ('), ' + ($elm$core$String$fromInt(columnIndex + 1) + (' * var(--tileWidthAndHeight)' + ');'))))))))) : $elm$svg$Svg$Attributes$style(
			'left: max(calc(' + ($elm$core$String$fromInt(columnIndex) + (' * var(--tileWidthAndHeight)' + (' + ' + ($elm$core$String$fromFloat(deltaX) + ('px' + ('), ' + ($elm$core$String$fromInt(columnIndex - 1) + (' * var(--tileWidthAndHeight)' + ');')))))))));
	});
var $author$project$Services$Shape$verticalPosition = F2(
	function (rowIndex, deltaY) {
		return (deltaY >= 0) ? $elm$svg$Svg$Attributes$style(
			'top: min(calc(' + ($elm$core$String$fromInt(rowIndex) + (' * var(--tileWidthAndHeight)' + (' + ' + ($elm$core$String$fromFloat(deltaY) + ('px' + ('), ' + ($elm$core$String$fromInt(rowIndex + 1) + (' * var(--tileWidthAndHeight)' + ');'))))))))) : $elm$svg$Svg$Attributes$style(
			'top: max(calc(' + ($elm$core$String$fromInt(rowIndex) + (' * var(--tileWidthAndHeight)' + (' + ' + ($elm$core$String$fromFloat(deltaY) + ('px' + ('), ' + ($elm$core$String$fromInt(rowIndex - 1) + (' * var(--tileWidthAndHeight)' + ');')))))))));
	});
var $author$project$Services$Shape$swapInMotionAttributes = F3(
	function (model, coordinates, existingAttributes) {
		var rowIndex = coordinates.a;
		var columnIndex = coordinates.b;
		if (($elm$core$List$length(existingAttributes) > 0) || (!model.cx.cB)) {
			return existingAttributes;
		} else {
			var _v0 = A2($author$project$Services$Swap$getSwapItemLocation, model.cx, coordinates);
			switch (_v0.$) {
				case 0:
					var deltaX = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$horizontalPosition, columnIndex, deltaX),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$rowToSelector(rowIndex),
							existingAttributes));
				case 1:
					var deltaX = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$horizontalPosition, columnIndex, deltaX),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$rowToSelector(rowIndex),
							existingAttributes));
				case 2:
					var deltaY = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$verticalPosition, rowIndex, deltaY),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$columnToSelector(columnIndex),
							existingAttributes));
				case 3:
					var deltaY = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$verticalPosition, rowIndex, deltaY),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$columnToSelector(columnIndex),
							existingAttributes));
				case 4:
					var deltaX = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$horizontalPosition, columnIndex, (-1) * deltaX),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$rowToSelector(rowIndex),
							existingAttributes));
				case 5:
					var deltaX = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$horizontalPosition, columnIndex, (-1) * deltaX),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$rowToSelector(rowIndex),
							existingAttributes));
				case 6:
					var deltaY = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$verticalPosition, rowIndex, (-1) * deltaY),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$columnToSelector(columnIndex),
							existingAttributes));
				case 7:
					var deltaY = _v0.a;
					return A2(
						$elm$core$List$cons,
						A2($author$project$Services$Shape$verticalPosition, rowIndex, (-1) * deltaY),
						A2(
							$elm$core$List$cons,
							$author$project$Services$CssSelector$columnToSelector(columnIndex),
							existingAttributes));
				default:
					return existingAttributes;
			}
		}
	});
var $author$project$Services$Shape$coordinatesToAttributes = F2(
	function (model, coordinates) {
		return A2(
			$author$project$Services$Shape$defaultCoordinateAttributes,
			coordinates,
			A3(
				$author$project$Services$Shape$swapInMotionAttributes,
				model,
				coordinates,
				A3(
					$author$project$Services$Shape$hintSwapAttributes,
					model,
					coordinates,
					A3(
						$author$project$Services$Shape$invalidSwapAttributes,
						model,
						coordinates,
						A3(
							$author$project$Services$Shape$swapAttributes,
							model,
							coordinates,
							A2($author$project$Services$Shape$shuffleAttributes, model, coordinates))))));
	});
var $author$project$Extras$Svg$getViewBoxString = function (viewBox) {
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$elm$core$String$fromInt(viewBox.bl),
				$elm$core$String$fromInt(viewBox.bm),
				viewBox.bk,
				viewBox.aE
			]));
};
var $author$project$Extras$Svg$viewBoxAttribute = function (viewBox) {
	return $elm$svg$Svg$Attributes$viewBox(
		$author$project$Extras$Svg$getViewBoxString(viewBox));
};
var $author$project$Services$Shape$svgBoardItemAttributes = F4(
	function (model, viewBox, cssSelector, _v0) {
		var coordinates = _v0.aw;
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$Extras$Svg$viewBoxAttribute(viewBox),
					cssSelector
				]),
			A2($author$project$Services$Shape$coordinatesToAttributes, model, coordinates));
	});
var $author$project$Services$SVGConversion$boardItemToHtml = F3(
	function (hasTileAt, model, boardItem) {
		return A2($author$project$Services$Swap$isItemNotAFillSwap, boardItem.aw, model.ca) ? A3(
			$author$project$Services$SVGConversion$generateBoardItemHtml,
			boardItem,
			hasTileAt,
			A3($author$project$Services$Shape$svgBoardItemAttributes, model, $author$project$Services$Shape$boardItemViewBox, $author$project$Services$CssSelector$boardItemSelector)) : $elm$core$Array$empty;
	});
var $author$project$View$rowItemToHtml = F3(
	function (hasTileAt, model, rowItem) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Array$empty,
			A2(
				$elm$core$Maybe$andThen,
				function (item) {
					return $elm$core$Maybe$Just(
						A3($author$project$Services$SVGConversion$boardItemToHtml, hasTileAt, model, item));
				},
				rowItem));
	});
var $author$project$View$boardItemsToHtml = F3(
	function (hasTileAt, model, boardItems) {
		return $author$project$Extras$Array$concat(
			A2(
				$author$project$Services$Matrix$map,
				function (boardItem) {
					return A3($author$project$View$rowItemToHtml, hasTileAt, model, boardItem);
				},
				boardItems));
	});
var $author$project$Services$CssSelector$opacity = function (isVisible) {
	return isVisible ? $elm$svg$Svg$Attributes$class('fadedIn') : $elm$svg$Svg$Attributes$class('fadedOut');
};
var $author$project$View$boardItemsLayer = F2(
	function (model, viewElements) {
		var boardItems = model.bG;
		var level = model.cK;
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[
						$author$project$Services$CssSelector$boardItemsContainer,
						$author$project$Services$CssSelector$opacity(model.by === 5)
					]),
				_Utils_ap(
					$elm$core$List$concat(
						$elm$core$Array$toList(
							A2(
								$elm$core$Array$map,
								function (row) {
									return $elm$core$Array$toList(row);
								},
								A3(
									$author$project$View$boardItemsToHtml,
									$author$project$Services$Tile$boardHasTileAt(level.dw),
									model,
									boardItems)))),
					$author$project$View$bannerNotifications(model))),
			viewElements);
	});
var $author$project$SVGs$Elements$Button$ButtonAttributes = F4(
	function (x, y, width, height) {
		return {aE: height, bk: width, bl: x, bm: y};
	});
var $author$project$Domain$Types$DefeatCloseClicked = {$: 13};
var $author$project$SVGs$Modals$Modal$Modal = F7(
	function (idString, closeMessage, modalState, height, viewBox, svgChildren, htmlChildren) {
		return {av: closeMessage, aE: height, aH: htmlChildren, aI: idString, aO: modalState, bb: svgChildren, bi: viewBox};
	});
var $author$project$SVGs$Modals$Modal$levelLabel = function (levelNumber) {
	return A3(
		$elm$svg$Svg$node,
		'text',
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(39, 90, 80)'),
				$elm$svg$Svg$Attributes$fontSize('30'),
				$elm$svg$Svg$Attributes$textAnchor('middle'),
				$elm$svg$Svg$Attributes$class('level-label')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$tspan,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('140'),
						$elm$svg$Svg$Attributes$y('75')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(
						'Level ' + $elm$core$String$fromInt(levelNumber))
					]))
			]));
};
var $author$project$SVGs$Modals$Defeat$messageText = function (text) {
	return A3(
		$elm$svg$Svg$node,
		'text',
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('red'),
				$elm$svg$Svg$Attributes$fontFamily('Josefin Sans, sans-serif'),
				$elm$svg$Svg$Attributes$fontSize('30'),
				$elm$svg$Svg$Attributes$x('79.53'),
				$elm$svg$Svg$Attributes$textAnchor('middle')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$tspan,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('50%'),
						$elm$svg$Svg$Attributes$y('130')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(text)
					]))
			]));
};
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$SVGs$Modals$Modal$closeButtonSize = $elm$core$String$fromInt(25);
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$Attributes$xmlSpace = A2(_VirtualDom_attributeNS, 'http://www.w3.org/XML/1998/namespace', 'xml:space');
var $author$project$SVGs$Modals$Modal$closeButton = function (closeMessage) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('225'),
				$elm$svg$Svg$Attributes$y('20'),
				$elm$svg$Svg$Attributes$width($author$project$SVGs$Modals$Modal$closeButtonSize),
				$elm$svg$Svg$Attributes$height($author$project$SVGs$Modals$Modal$closeButtonSize),
				$elm$svg$Svg$Attributes$xmlSpace('preserve'),
				$elm$svg$Svg$Attributes$id('canvasCloseButton'),
				$elm$svg$Svg$Attributes$viewBox('0 0 50 50'),
				$elm$html$Html$Events$onClick(closeMessage),
				$elm$svg$Svg$Attributes$id('modal-close-button'),
				$elm$svg$Svg$Attributes$fill('red')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$width('50'),
						$elm$svg$Svg$Attributes$height('50'),
						$elm$svg$Svg$Attributes$fillOpacity('0')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('rgb(47, 106, 93)'),
						$elm$svg$Svg$Attributes$d('M 43.35,7.35 L 8.35,42.35 7.65,41.65 42.65,6.65 43.35,7.35 Z M 42.65,6.65 L 43.35,7.35 8.35,42.35 7.65,41.65 42.65,6.65 Z M 8.35,6.65 L 43.35,41.65 42.65,42.35 7.65,7.35 8.35,6.65 Z M 8.35,6.65')
					]),
				_List_Nil)
			]));
};
var $author$project$SVGs$Modals$Modal$topAttribute = F2(
	function (modalState, existingAttributes) {
		if (!modalState) {
			return A2(
				$author$project$Extras$List$appendElement,
				$elm$html$Html$Attributes$class('active'),
				existingAttributes);
		} else {
			return A2(
				$author$project$Extras$List$appendElement,
				$elm$html$Html$Attributes$class('dismissed'),
				existingAttributes);
		}
	});
var $author$project$SVGs$Modals$Modal$windowBackgroundDefinitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasWindow-gradient-rectangle'),
					$elm$svg$Svg$Attributes$x1('137'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('137'),
					$elm$svg$Svg$Attributes$y2('470'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(181, 227, 150)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(92, 188, 168)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasWindow-shadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('3'),
							$elm$svg$Svg$Attributes$dy('3'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Modals$Modal$windowRectangle = function (height) {
	return A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('url(#canvasWindow-gradient-rectangle)'),
				$elm$svg$Svg$Attributes$filter('url(#canvasWindow-shadow-outer)'),
				$elm$svg$Svg$Attributes$x('12'),
				$elm$svg$Svg$Attributes$y('10'),
				$elm$svg$Svg$Attributes$width('250'),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(height)),
				$elm$svg$Svg$Attributes$rx('15')
			]),
		_List_Nil);
};
var $author$project$SVGs$Modals$Modal$modal = function (_v0) {
	var idString = _v0.aI;
	var closeMessage = _v0.av;
	var modalState = _v0.aO;
	var height = _v0.aE;
	var viewBox = _v0.bi;
	var svgChildren = _v0.bb;
	var htmlChildren = _v0.aH;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$SVGs$Modals$Modal$topAttribute,
			modalState,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(idString),
					$elm$html$Html$Attributes$class('modal')
				])),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$width('420'),
						$elm$svg$Svg$Attributes$height('680'),
						$author$project$Extras$Svg$viewBoxAttribute(viewBox)
					]),
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$SVGs$Modals$Modal$windowBackgroundDefinitions,
							$author$project$SVGs$Modals$Modal$windowRectangle(height),
							$author$project$SVGs$Modals$Modal$closeButton(closeMessage)
						]),
					svgChildren)),
			htmlChildren));
};
var $author$project$Domain$Types$RetryLevelClicked = {$: 5};
var $author$project$SVGs$Elements$Button$buttonText = function (text) {
	return A3(
		$elm$svg$Svg$node,
		'text',
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
				$elm$svg$Svg$Attributes$fontSize('30'),
				$elm$svg$Svg$Attributes$x('79.53'),
				$elm$svg$Svg$Attributes$textAnchor('middle')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$tspan,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('50%'),
						$elm$svg$Svg$Attributes$y('40')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(text)
					]))
			]));
};
var $author$project$SVGs$Elements$Button$buttonBackground = _List_fromArray(
	[
		A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(47, 106, 93)'),
				$elm$svg$Svg$Attributes$x('9.15'),
				$elm$svg$Svg$Attributes$y('4'),
				$elm$svg$Svg$Attributes$width('200'),
				$elm$svg$Svg$Attributes$height('50'),
				$elm$svg$Svg$Attributes$rx('10')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(35, 80, 70)'),
				$elm$svg$Svg$Attributes$d('M 209,36.46 C 209,38.4 209,39.71 209,39.71 209,44.12 209,46.32 208.56,48.3 L 208.5,48.69 C 207.87,51.27 206.51,53.31 204.79,54.25 203.21,55 201.74,55 198.81,55 L 19.19,55 C 16.26,55 14.79,55 13.47,54.35 L 13.21,54.25 C 11.49,53.31 10.13,51.27 9.5,48.69 9,46.32 9,44.12 9,39.71 9,39.71 9,38.4 9,36.46 9,38.4 9,39.71 9,39.71 9.01,39.7 9.5,45.43 9.5,45.43 10.13,48.02 11.49,50.05 13.21,51 L 13.47,51.09 C 14.79,51.74 16.26,51.74 19.19,51.74 L 198.81,51.74 C 201.74,51.74 203.21,51.74 204.79,51 206.51,50.05 207.87,48.02 208.5,45.43 L 208.56,45.04 208.99,39.69 C 209,39.71 209,38.4 209,36.46 Z M 209,36.46')
			]),
		_List_Nil)
	]);
var $author$project$SVGs$Elements$Button$modalButton = F3(
	function (_v0, message, children) {
		var x = _v0.bl;
		var y = _v0.bm;
		var width = _v0.bk;
		var height = _v0.aE;
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 220 60'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(width)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(height)),
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromFloat(y)),
					$elm$html$Html$Events$onClick(message),
					$elm$svg$Svg$Attributes$id('modal-button')
				]),
			_Utils_ap($author$project$SVGs$Elements$Button$buttonBackground, children));
	});
var $author$project$SVGs$Elements$Button$retryButton = function (buttonAttributes) {
	return A3(
		$author$project$SVGs$Elements$Button$modalButton,
		buttonAttributes,
		$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$RetryLevelClicked),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$Button$buttonText('Retry')
			]));
};
var $author$project$SVGs$Modals$Defeat$defeat = function (_v0) {
	var modals = _v0.cQ;
	var level = _v0.cK;
	return $author$project$SVGs$Modals$Modal$modal(
		A7(
			$author$project$SVGs$Modals$Modal$Modal,
			'defeatModal',
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$DefeatCloseClicked),
			modals.b_,
			220,
			A4($author$project$Extras$Svg$ViewBox, 0, 0, '275', '300'),
			_List_fromArray(
				[
					$author$project$SVGs$Modals$Modal$levelLabel(level.cp),
					$author$project$SVGs$Modals$Defeat$messageText('Out of Moves!'),
					$author$project$SVGs$Elements$Button$retryButton(
					A4($author$project$SVGs$Elements$Button$ButtonAttributes, 30, 160, 220, 60))
				]),
			_List_Nil));
};
var $author$project$Domain$Types$ErrorCloseClicked = {$: 14};
var $author$project$SVGs$Modals$Error$ErrorIconAttributes = F4(
	function (x, y, width, height) {
		return {aE: height, bk: width, bl: x, bm: y};
	});
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $author$project$SVGs$Modals$Error$errorIcon = function (errorIconAttributes) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(errorIconAttributes.bl)),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(errorIconAttributes.bm)),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(errorIconAttributes.bk)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(errorIconAttributes.aE)),
				$elm$svg$Svg$Attributes$viewBox('0 0 512 512')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('256'),
						$elm$svg$Svg$Attributes$cy('268'),
						$elm$svg$Svg$Attributes$r('244'),
						$elm$svg$Svg$Attributes$fill('#C0392B')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('256'),
						$elm$svg$Svg$Attributes$cy('244'),
						$elm$svg$Svg$Attributes$r('244'),
						$elm$svg$Svg$Attributes$fill('#E74C3C')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$polygon,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('#C0392B'),
						$elm$svg$Svg$Attributes$points('135.1,180.2 221.5,268 135.1,353.6 169.7,388.1 256,302.5 342.3,388.1 376.9,353.6 290.5,268 376.9,180.2 342.3,146.4 256,232 169.7,146.4')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$polygon,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('#ECF0F1'),
						$elm$svg$Svg$Attributes$points('135.1,156.2 221.5,244 135.1,329.6 169.7,363.4 256,277.8 342.3,363.4 376.9,329.6 290.5,244 376.9,156.2 342.3,121.6 256,207.2 169.7,121.6')
					]),
				_List_Nil)
			]));
};
var $author$project$Domain$Types$ErrorRetryClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$SVGs$Elements$Button$errorRetryButton = F2(
	function (levelID, buttonAttributes) {
		return A3(
			$author$project$SVGs$Elements$Button$modalButton,
			buttonAttributes,
			$author$project$Domain$Types$ModalMessage(
				$author$project$Domain$Types$ErrorRetryClicked(levelID)),
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Button$buttonText('Retry')
				]));
	});
var $author$project$SVGs$Modals$Error$messageText = function (text) {
	return A3(
		$elm$svg$Svg$node,
		'text',
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(35, 80, 70)'),
				$elm$svg$Svg$Attributes$fontFamily('Josefin Sans, sans-serif'),
				$elm$svg$Svg$Attributes$fontSize('18'),
				$elm$svg$Svg$Attributes$x('79.53'),
				$elm$svg$Svg$Attributes$textAnchor('middle')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$tspan,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('50%'),
						$elm$svg$Svg$Attributes$y('50%')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(text)
					]))
			]));
};
var $author$project$SVGs$Modals$Error$error = function (_v0) {
	var level = _v0.cK;
	var modals = _v0.cQ;
	return $author$project$SVGs$Modals$Modal$modal(
		A7(
			$author$project$SVGs$Modals$Modal$Modal,
			'errorModal',
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$ErrorCloseClicked),
			modals.b4,
			220,
			A4($author$project$Extras$Svg$ViewBox, 0, 0, '275', '300'),
			_List_fromArray(
				[
					A2(
					$author$project$SVGs$Elements$Button$errorRetryButton,
					level.cp,
					A4($author$project$SVGs$Elements$Button$ButtonAttributes, 30, 160, 220, 60)),
					$author$project$SVGs$Modals$Error$errorIcon(
					A4($author$project$SVGs$Modals$Error$ErrorIconAttributes, 100, 45, 75, 75)),
					$author$project$SVGs$Modals$Error$messageText('Unable to retrieve level!')
				]),
			_List_Nil));
};
var $author$project$SVGs$Elements$Fireworks$classAttribute = function (showFireworks) {
	return showFireworks ? $elm$html$Html$Attributes$class('firework firework-animated') : $elm$html$Html$Attributes$class('firework');
};
var $author$project$SVGs$Elements$Fireworks$firework = F2(
	function (showFireworks, fireworkNumber) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(
					'firework-' + $elm$core$String$fromInt(fireworkNumber)),
					$author$project$SVGs$Elements$Fireworks$classAttribute(showFireworks)
				]),
			_List_Nil);
	});
var $author$project$SVGs$Elements$Fireworks$fireworkList = function (showFireworks) {
	return A2(
		$elm$core$List$map,
		function (number) {
			return A2($author$project$SVGs$Elements$Fireworks$firework, showFireworks, number);
		},
		A2($elm$core$List$range, 1, 6));
};
var $author$project$SVGs$Elements$Fireworks$fireworks = F2(
	function (showFireworks, existingElements) {
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$SVGs$Elements$Fireworks$fireworkList(showFireworks)),
			existingElements);
	});
var $author$project$Services$CssSelector$bottomLeftImage = $elm$svg$Svg$Attributes$class('bottomLeftImage');
var $author$project$Services$CssSelector$bottomRightImage = $elm$svg$Svg$Attributes$class('bottomRightImage');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Services$CssSelector$animateToCenter = $elm$svg$Svg$Attributes$class('animateToCenter');
var $author$project$View$ImageMatch$centerCorrectImageAttribute = F3(
	function (isCorrectImage, animateToCenter, attributes) {
		return (isCorrectImage && animateToCenter) ? A2($elm$core$List$cons, $author$project$Services$CssSelector$animateToCenter, attributes) : attributes;
	});
var $author$project$Services$CssSelector$animateImageCheck = $elm$svg$Svg$Attributes$class('animated-image-check');
var $author$project$SVGs$Elements$ImageMatch$animateCheckAttribute = F2(
	function (isSelected, attributes) {
		return isSelected ? A2($elm$core$List$cons, $author$project$Services$CssSelector$animateImageCheck, attributes) : attributes;
	});
var $elm$svg$Svg$Attributes$visibility = _VirtualDom_attribute('visibility');
var $author$project$SVGs$Elements$ImageMatch$visibilityAttribute = function (isVisible) {
	return isVisible ? $elm$svg$Svg$Attributes$visibility('visible') : $elm$svg$Svg$Attributes$visibility('hidden');
};
var $author$project$SVGs$Elements$ImageMatch$check = function (isSelected) {
	return A2(
		$elm$svg$Svg$svg,
		A2(
			$author$project$SVGs$Elements$ImageMatch$animateCheckAttribute,
			isSelected,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
					$author$project$SVGs$Elements$ImageMatch$visibilityAttribute(isSelected),
					$elm$svg$Svg$Attributes$class('image-check')
				])),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('rgb(255, 255, 255)'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('1.5'),
						$elm$svg$Svg$Attributes$fill('rgb(35, 168, 17)'),
						$elm$svg$Svg$Attributes$d('M 11.5,59.72 C 22.26,62.73 32.42,69.99 41.13,80 57.15,54.38 77.48,33.06 91,27.94 85.14,23.92 80.46,19.77 76.92,15.5 64.79,23.08 50.32,43.3 40.27,63.17 35.7,56.64 29.74,50.91 22.53,47.26 19.04,51.53 15.37,55.69 11.5,59.72 Z M 11.5,59.72')
					]),
				_List_Nil)
			]));
};
var $author$project$Domain$Types$ImageMatchMessage = function (a) {
	return {$: 6, a: a};
};
var $author$project$Domain$Types$WrongImageSelected = {$: 2};
var $author$project$Services$CssSelector$animateWiggle = $elm$svg$Svg$Attributes$class('animateWiggle');
var $author$project$Services$CssAnimation$wiggle = 'wiggle';
var $author$project$SVGs$Elements$ImageMatch$wiggleAttribute = F2(
	function (isSelected, attributes) {
		return isSelected ? A2(
			$elm$core$List$cons,
			$author$project$Services$CssSelector$animateWiggle,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Extras$Events$onAnimationEnd,
					$author$project$Services$CssAnimation$wiggle,
					$author$project$Domain$Types$ImageMatchMessage($author$project$Domain$Types$WrongImageSelected)),
				attributes)) : attributes;
	});
var $author$project$SVGs$Elements$ImageMatch$x = function (isSelected) {
	return A2(
		$elm$svg$Svg$svg,
		A2(
			$author$project$SVGs$Elements$ImageMatch$wiggleAttribute,
			isSelected,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
					$elm$svg$Svg$Attributes$class('image-x')
				])),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$author$project$SVGs$Elements$ImageMatch$visibilityAttribute(isSelected),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('rgb(255, 255, 255)'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$fill('rgb(255, 47, 47)'),
						$elm$svg$Svg$Attributes$d('M 49.11,42.34 L 73.24,18.23 80.96,25.84 56.78,49.99 80.93,74.11 73.31,81.82 49.11,57.64 24.93,81.79 17.27,74.15 41.45,49.99 17.29,25.86 24.95,18.2 49.11,42.34 Z M 49.11,42.34')
					]),
				_List_Nil)
			]));
};
var $author$project$SVGs$Elements$ImageMatch$checkOrX = F2(
	function (isSelected, isCorrectAnswer) {
		return isCorrectAnswer ? $author$project$SVGs$Elements$ImageMatch$check(isSelected) : $author$project$SVGs$Elements$ImageMatch$x(isSelected);
	});
var $author$project$Services$CssSelector$animateFadeOut = $elm$svg$Svg$Attributes$class('animateFadeOut');
var $author$project$View$ImageMatch$fadeOutAttribute = F2(
	function (shouldFadeOut, attributes) {
		return shouldFadeOut ? A2($elm$core$List$cons, $author$project$Services$CssSelector$animateFadeOut, attributes) : attributes;
	});
var $author$project$View$ImageMatch$imageBorderURL = '../Images/ImageMatchBorder.svg';
var $author$project$View$ImageMatch$isClickableAttribute = F2(
	function (isClickable, attributes) {
		return isClickable ? attributes : attributes;
	});
var $author$project$Services$CssSelector$kanaImage = $elm$svg$Svg$Attributes$class('kana-image');
var $author$project$Services$CssSelector$kanaImageBorder = $elm$svg$Svg$Attributes$class('kana-image-border');
var $author$project$View$ImageMatch$kanaWordImageURL = function (imageID) {
	return '../Images/KanaWords/' + ($elm$core$String$fromInt(imageID) + '.svg');
};
var $elm$html$Html$object = _VirtualDom_node('object');
var $author$project$Domain$Types$ImageMatchImageClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$ImageMatch$onClickAttribute = F2(
	function (imageID, attributes) {
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$Events$onClick(
				$author$project$Domain$Types$ImageMatchMessage(
					$author$project$Domain$Types$ImageMatchImageClicked(imageID))),
			attributes);
	});
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$View$ImageMatch$imageMatchImage = F4(
	function (_v0, kanaWord, positionSelector, correctImageID) {
		var imageMatchState = _v0.ct;
		var applicationState = _v0.by;
		var isSelectedWrongImage = A2(
			$elm$core$List$any,
			function (id) {
				return _Utils_eq(id, kanaWord.cp);
			},
			imageMatchState.dM);
		var isSelectedImageCorrect = _Utils_eq(
			imageMatchState.dc,
			$elm$core$Maybe$Just(correctImageID));
		var isCorrectImage = _Utils_eq(kanaWord.cp, correctImageID);
		var shouldFadeOut = isSelectedWrongImage || (isSelectedImageCorrect && (!isCorrectImage));
		var isClickable = (!isSelectedWrongImage) && (applicationState !== 6);
		return _Utils_Tuple2(
			$elm$core$String$fromInt(kanaWord.cp),
			A2(
				$elm$html$Html$div,
				A2(
					$author$project$View$ImageMatch$isClickableAttribute,
					isClickable,
					A3(
						$author$project$View$ImageMatch$centerCorrectImageAttribute,
						isCorrectImage,
						isSelectedImageCorrect,
						A2(
							$author$project$View$ImageMatch$onClickAttribute,
							kanaWord.cp,
							A2(
								$author$project$View$ImageMatch$fadeOutAttribute,
								shouldFadeOut,
								_List_fromArray(
									[positionSelector]))))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$object,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data', $author$project$View$ImageMatch$imageBorderURL),
								$elm$html$Html$Attributes$type_('image/svg+xml'),
								$author$project$Services$CssSelector$kanaImageBorder
							]),
						_List_Nil),
						A2(
						$elm$html$Html$object,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$attribute,
								'data',
								$author$project$View$ImageMatch$kanaWordImageURL(kanaWord.cp)),
								$elm$html$Html$Attributes$type_('image/svg+xml'),
								$author$project$Services$CssSelector$kanaImage
							]),
						_List_Nil),
						A2(
						$author$project$SVGs$Elements$ImageMatch$checkOrX,
						_Utils_eq(
							imageMatchState.dc,
							$elm$core$Maybe$Just(kanaWord.cp)),
						isCorrectImage)
					])));
	});
var $author$project$Domain$Types$ImageMatchFinished = {$: 1};
var $author$project$Services$ShapeColor$green = {bE: 70, ch: 227, c6: 84};
var $author$project$Services$CssAnimation$imageScoreAnimation = 'image-score-animation';
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $author$project$SVGs$Elements$ImageMatch$imageScore = F3(
	function (isVisible, score, elements) {
		return (!isVisible) ? elements : A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'image-score',
				A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('image-score'),
							$elm$svg$Svg$Attributes$viewBox('0 0 600 75'),
							$elm$svg$Svg$Attributes$preserveAspectRatio('xMinYMid meet'),
							A2(
							$author$project$Extras$Events$onAnimationEnd,
							$author$project$Services$CssAnimation$imageScoreAnimation,
							$author$project$Domain$Types$ImageMatchMessage($author$project$Domain$Types$ImageMatchFinished))
						]),
					_List_fromArray(
						[
							A3(
							$elm$svg$Svg$node,
							'text',
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fill(
									$author$project$Services$ShapeColor$getColorString($author$project$Services$ShapeColor$green)),
									$elm$svg$Svg$Attributes$fontSize('175'),
									$elm$svg$Svg$Attributes$x('50%'),
									$elm$svg$Svg$Attributes$y('50%'),
									$elm$svg$Svg$Attributes$textAnchor('middle'),
									$elm$svg$Svg$Attributes$dominantBaseline('middle'),
									A2($elm$html$Html$Attributes$attribute, 'transform-origin', '50% 0px')
								]),
							_List_fromArray(
								[
									$elm$svg$Svg$text(
									'+' + ($elm$core$String$fromInt(score) + '!'))
								]))
						]))),
			elements);
	});
var $author$project$Services$CssSelector$topLeftImage = $elm$svg$Svg$Attributes$class('topLeftImage');
var $author$project$Services$CssSelector$topRightImage = $elm$svg$Svg$Attributes$class('topRightImage');
var $author$project$View$ImageMatch$imageMatchImages = function (model) {
	var correctImageID = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$andThen,
			function (word) {
				return $elm$core$Maybe$Just(word.cp);
			},
			model.bY));
	var _v0 = _Utils_Tuple2(
		A2($author$project$Extras$List$shuffle, model.c4.cs, model.cK.cI),
		model.by === 6);
	if (((((_v0.a.b && _v0.a.b.b) && _v0.a.b.b.b) && _v0.a.b.b.b.b) && (!_v0.a.b.b.b.b.b)) && _v0.b) {
		var _v1 = _v0.a;
		var topLeftImage = _v1.a;
		var _v2 = _v1.b;
		var topRightImage = _v2.a;
		var _v3 = _v2.b;
		var bottomLeftImage = _v3.a;
		var _v4 = _v3.b;
		var bottomRightImage = _v4.a;
		return A3(
			$author$project$SVGs$Elements$ImageMatch$imageScore,
			_Utils_eq(
				model.ct.dc,
				$elm$core$Maybe$Just(correctImageID)),
			A3($author$project$Services$ImageMatch$selectedImageScore, model.ct.dc, correctImageID, model.ct),
			_List_fromArray(
				[
					A4($author$project$View$ImageMatch$imageMatchImage, model, topLeftImage, $author$project$Services$CssSelector$topLeftImage, correctImageID),
					A4($author$project$View$ImageMatch$imageMatchImage, model, topRightImage, $author$project$Services$CssSelector$topRightImage, correctImageID),
					A4($author$project$View$ImageMatch$imageMatchImage, model, bottomLeftImage, $author$project$Services$CssSelector$bottomLeftImage, correctImageID),
					A4($author$project$View$ImageMatch$imageMatchImage, model, bottomRightImage, $author$project$Services$CssSelector$bottomRightImage, correctImageID)
				]));
	} else {
		return _List_Nil;
	}
};
var $author$project$Services$CssSelector$clickDisabled = $elm$svg$Svg$Attributes$class('clickDisabled');
var $author$project$Services$CssSelector$clickEnabled = $elm$svg$Svg$Attributes$class('clickEnabled');
var $author$project$View$ImageMatch$imagesActiveAttribute = function (applicationState) {
	return (applicationState === 6) ? $author$project$Services$CssSelector$clickEnabled : $author$project$Services$CssSelector$clickDisabled;
};
var $author$project$Services$CssSelector$kanaImagesContainer = $elm$svg$Svg$Attributes$class('kanaImagesContainer');
var $author$project$View$ImageMatch$imagesLayer = F2(
	function (model, viewElements) {
		var applicationState = model.by;
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[
						$author$project$Services$CssSelector$kanaImagesContainer,
						$author$project$View$ImageMatch$imagesActiveAttribute(applicationState),
						$author$project$Services$CssSelector$opacity(model.by === 6)
					]),
				$author$project$View$ImageMatch$imageMatchImages(model)),
			viewElements);
	});
var $author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord = F3(
	function (translateX, translateY, rotate) {
		return {a0: rotate, bf: translateX, bg: translateY};
	});
var $author$project$SVGs$Animations$KanaExplosion$Rotate = $elm$core$Basics$identity;
var $author$project$SVGs$Animations$KanaExplosion$TranslateX = $elm$core$Basics$identity;
var $author$project$SVGs$Animations$KanaExplosion$TranslateY = $elm$core$Basics$identity;
var $author$project$Services$CssSelector$kanaExplosion = $elm$svg$Svg$Attributes$class('kanaExplosion');
var $author$project$Services$CssSelector$kanaExplosionParticle = _List_fromArray(
	[
		$elm$svg$Svg$Attributes$class('kanaExplosionParticle'),
		$elm$svg$Svg$Attributes$class('kanaExplosionAnimation')
	]);
var $author$project$SVGs$Animations$KanaExplosion$particle = function (color) {
	return A2(
		$elm$svg$Svg$g,
		$author$project$Services$CssSelector$kanaExplosionParticle,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill(
						$author$project$Services$ShapeColor$getColorString(color)),
						$elm$svg$Svg$Attributes$d('M 10.75,0 C 10.75,5.94 5.94,10.75 0,10.75 -5.94,10.75 -10.75,5.94 -10.75,-0 -10.75,-5.94 -5.94,-10.75 0,-10.75 5.94,-10.75 10.75,-5.94 10.75,0 Z M 10.75,0')
					]),
				_List_Nil)
			]));
};
var $author$project$Extras$String$wrapInside = F3(
	function (value, left, right) {
		return _Utils_ap(
			left,
			_Utils_ap(value, right));
	});
var $author$project$Extras$String$wrapInsideParenthesis = function (value) {
	return A3($author$project$Extras$String$wrapInside, value, '(', ')');
};
var $author$project$SVGs$Animations$KanaExplosion$rotateString = function (rotate) {
	return 'rotate' + $author$project$Extras$String$wrapInsideParenthesis(
		$elm$core$String$fromFloat(rotate));
};
var $author$project$SVGs$Animations$KanaExplosion$floatPairString = function (_v0) {
	var firstFloat = _v0.a;
	var secondFloat = _v0.b;
	return $author$project$Extras$String$wrapInsideParenthesis(
		A2(
			$elm$core$String$join,
			',',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(firstFloat),
					$elm$core$String$fromFloat(secondFloat)
				])));
};
var $author$project$SVGs$Animations$KanaExplosion$translateString = F2(
	function (x, y) {
		return 'translate' + $author$project$SVGs$Animations$KanaExplosion$floatPairString(
			_Utils_Tuple2(x, y));
	});
var $author$project$SVGs$Animations$KanaExplosion$particleGroupTransformAttribute = function (_v0) {
	var translateX = _v0.bf;
	var translateY = _v0.bg;
	var rotate = _v0.a0;
	var _v1 = _Utils_Tuple3(translateX, translateY, rotate);
	var translateXValue = _v1.a;
	var translateYValue = _v1.b;
	var rotateValue = _v1.c;
	return $elm$svg$Svg$Attributes$transform(
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($author$project$SVGs$Animations$KanaExplosion$translateString, translateXValue, translateYValue),
					$author$project$SVGs$Animations$KanaExplosion$rotateString(rotateValue)
				])));
};
var $author$project$SVGs$Animations$KanaExplosion$particleGroup = F2(
	function (color, particleGroupRecord) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$SVGs$Animations$KanaExplosion$particleGroupTransformAttribute(particleGroupRecord)
				]),
			_List_fromArray(
				[
					$author$project$SVGs$Animations$KanaExplosion$particle(color)
				]));
	});
var $author$project$SVGs$Animations$KanaExplosion$kanaExplosion = F3(
	function (color, key, _v0) {
		var row = _v0.a;
		var column = _v0.b;
		return _Utils_Tuple2(
			key,
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$author$project$Services$CssSelector$kanaExplosion,
						$author$project$Extras$Svg$viewBoxAttribute(
						A4($author$project$Extras$Svg$ViewBox, 0, 0, '200', '200')),
						$elm$svg$Svg$Attributes$class(
						'row' + ($elm$core$String$fromInt(row) + 'KanaExplosion')),
						$elm$svg$Svg$Attributes$class(
						'column' + ($elm$core$String$fromInt(column) + 'KanaExplosion'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$author$project$SVGs$Animations$KanaExplosion$particleGroupTransformAttribute(
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 100, 100, 0))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -1.26, -18, 0)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -18.49, 0, -90)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -1.74, 19, -180)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 14.02, 0, -270)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -3.95, 11.35, -150)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -8.35, -6.74, -52)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 4.64, -11.36, -316)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -7.48, -3.11, -40)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 10.71, -17.39, 31)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 6.04, 7.3, -141)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, -29.03, -9.88, -54)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 13.69, -10.72, 132)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 22.36, -6.93, 117)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 1.82, 19.55, -162)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 3.28, 8.43, -125)),
								A2(
								$author$project$SVGs$Animations$KanaExplosion$particleGroup,
								color,
								A3($author$project$SVGs$Animations$KanaExplosion$ParticleGroupRecord, 5.24, -11.31, 62))
							]))
					])));
	});
var $author$project$View$kanaExplosionsLayer = F2(
	function (model, viewElements) {
		var explodedKana = model.b7;
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('kanaExplosions')
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var coordinates = _v0.a;
						var color = _v0.b;
						var key = _v0.c;
						return A3(
							$author$project$SVGs$Animations$KanaExplosion$kanaExplosion,
							color,
							$elm$core$String$fromInt(key),
							coordinates);
					},
					explodedKana)),
			viewElements);
	});
var $author$project$Services$CssSelector$kanaWordCenterAnimation = $elm$svg$Svg$Attributes$class('kana-word-center-animation');
var $author$project$Services$SVGConversion$boardItemAnimatingToKanawordHtml = function (boardItem) {
	var _v0 = boardItem.aw;
	var rowIndex = _v0.a;
	var columnIndex = _v0.b;
	var attributes = _List_fromArray(
		[
			$author$project$Services$CssSelector$boardItemSelector,
			$author$project$Extras$Svg$viewBoxAttribute($author$project$Services$Shape$boardItemViewBox),
			$author$project$Services$CssSelector$kanaWordCenterAnimation,
			$elm$svg$Svg$Attributes$class(
			'column' + $elm$core$String$fromInt(columnIndex)),
			$elm$svg$Svg$Attributes$class(
			'row' + $elm$core$String$fromInt(rowIndex))
		]);
	var _v1 = boardItem.bF;
	switch (_v1.$) {
		case 7:
			var kanaString = _v1.a;
			return _List_fromArray(
				[
					A3($author$project$SVGs$Shapes$DiamondWithKana$diamondWithKana, kanaString, attributes, boardItem)
				]);
		case 8:
			var kanaString = _v1.a;
			return _List_fromArray(
				[
					A3($author$project$SVGs$Shapes$HexagonWithKana$hexagonWithKana, kanaString, attributes, boardItem)
				]);
		case 9:
			var kanaString = _v1.a;
			return _List_fromArray(
				[
					A3($author$project$SVGs$Shapes$OvalWithKana$ovalWithKana, kanaString, attributes, boardItem)
				]);
		case 10:
			var kanaString = _v1.a;
			return _List_fromArray(
				[
					A3($author$project$SVGs$Shapes$TriangleWithKana$triangleWithKana, kanaString, attributes, boardItem)
				]);
		case 11:
			var kanaString = _v1.a;
			return _List_fromArray(
				[
					A3($author$project$SVGs$Shapes$SquareWithKana$squareWithKana, kanaString, attributes, boardItem)
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Services$CssSelector$kanaToKanawordAnimations = $elm$svg$Svg$Attributes$id('kanaToKanawordAnimations');
var $author$project$View$kanaToKanawordAnimationsLayer = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[$author$project$Services$CssSelector$kanaToKanawordAnimations]),
				A2($elm$core$List$concatMap, $author$project$Services$SVGConversion$boardItemAnimatingToKanawordHtml, model.bH)),
			viewElements);
	});
var $author$project$Services$AnimatedKana$backgroundPathID = F2(
	function (name, currentStrokeIndex) {
		return name + ('Stroke' + ($elm$core$String$fromInt(currentStrokeIndex) + 'Background'));
	});
var $author$project$Services$AnimatedKana$clipPathId = F2(
	function (name, strokeIndex) {
		return name + ('Stroke' + ($elm$core$String$fromInt(strokeIndex) + 'ClipPath'));
	});
var $author$project$Services$AnimatedKana$clipPathUrl = F2(
	function (name, strokeIndex) {
		return 'url(#' + (A2($author$project$Services$AnimatedKana$clipPathId, name, strokeIndex) + ')');
	});
var $author$project$Services$AnimatedKana$backgroundPath = F4(
	function (pathString, name, currentStrokeIndex, strokeWidth) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('background-path'),
					$elm$svg$Svg$Attributes$id(
					A2($author$project$Services$AnimatedKana$backgroundPathID, name, currentStrokeIndex)),
					$elm$svg$Svg$Attributes$clipPath(
					A2($author$project$Services$AnimatedKana$clipPathUrl, name, currentStrokeIndex)),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(strokeWidth)),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$d(pathString)
				]),
			_List_Nil);
	});
var $author$project$Services$AnimatedKana$backgroundPathsInternal = F2(
	function (currentStrokeIndex, animatedKanaRecord) {
		var strokePathStringList = animatedKanaRecord.dp;
		var name = animatedKanaRecord.cV;
		if (strokePathStringList.b) {
			var _v1 = strokePathStringList.a;
			var pathString = _v1.a;
			var strokeWidth = _v1.c;
			var remainingStrings = strokePathStringList.b;
			return A2(
				$elm$core$List$cons,
				A4($author$project$Services$AnimatedKana$backgroundPath, pathString, name, currentStrokeIndex, strokeWidth),
				A2(
					$author$project$Services$AnimatedKana$backgroundPathsInternal,
					currentStrokeIndex + 1,
					_Utils_update(
						animatedKanaRecord,
						{dp: remainingStrings})));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Services$AnimatedKana$backgroundPaths = function (animatedKanaRecord) {
	return A2($author$project$Services$AnimatedKana$backgroundPathsInternal, 1, animatedKanaRecord);
};
var $author$project$Services$AnimatedKana$dashedPathID = F2(
	function (name, currentStrokeIndex) {
		return name + ('Stroke' + $elm$core$String$fromInt(currentStrokeIndex));
	});
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $author$project$Services$AnimatedKana$toDashArrayString = F2(
	function (dashValue, dashMaximum) {
		return A2(
			$elm$core$String$join,
			',',
			_List_fromArray(
				[
					$elm$core$String$fromInt(
					A2($elm$core$Basics$min, dashValue, dashMaximum)),
					$elm$core$String$fromInt(dashMaximum)
				]));
	});
var $author$project$Services$AnimatedKana$toSvgVisibleAttribute = function (dashValue) {
	return (dashValue > 1) ? $elm$svg$Svg$Attributes$visibility('visible') : $elm$svg$Svg$Attributes$visibility('hidden');
};
var $author$project$Services$AnimatedKana$dashedPath = F6(
	function (name, strokeIndex, strokeWidth, pathString, dashValue, dashMaximum) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke('rgb(0, 0, 0)'),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(strokeWidth)),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$id(
					A2($author$project$Services$AnimatedKana$dashedPathID, name, strokeIndex)),
					$elm$svg$Svg$Attributes$clipPath(
					A2($author$project$Services$AnimatedKana$clipPathUrl, name, strokeIndex)),
					$elm$svg$Svg$Attributes$d(pathString),
					$elm$svg$Svg$Attributes$strokeDasharray(
					A2($author$project$Services$AnimatedKana$toDashArrayString, dashValue, dashMaximum)),
					$author$project$Services$AnimatedKana$toSvgVisibleAttribute(dashValue)
				]),
			_List_Nil);
	});
var $author$project$Services$AnimatedKana$toSvgClipPath = F3(
	function (strokeIndex, kanaName, clipPath) {
		if (!clipPath.$) {
			var clipPathString = clipPath.a;
			return _List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(
							A2($author$project$Services$AnimatedKana$clipPathId, kanaName, strokeIndex))
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d(clipPathString)
								]),
							_List_Nil)
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Services$AnimatedKana$zeroOutWhenNotCurrentStroke = F3(
	function (currentStrokeIndex, animatingStrokeIndex, dashValue) {
		return (_Utils_cmp(currentStrokeIndex, animatingStrokeIndex) > 0) ? 0 : dashValue;
	});
var $author$project$Services$AnimatedKana$dashedPathsInternal = F3(
	function (currentStrokeIndex, animatingStrokeIndex, animatedKanaRecord) {
		var dashValue = animatedKanaRecord.bZ;
		var strokePathStringList = animatedKanaRecord.dp;
		var strokeDashMaxList = animatedKanaRecord.$7;
		var name = animatedKanaRecord.cV;
		var _v0 = _Utils_Tuple2(strokePathStringList, strokeDashMaxList);
		if (_v0.a.b && _v0.b.b) {
			var _v1 = _v0.a;
			var _v2 = _v1.a;
			var pathString = _v2.a;
			var clipPath = _v2.b;
			var strokeWidth = _v2.c;
			var remainingPaths = _v1.b;
			var _v3 = _v0.b;
			var dashMax = _v3.a;
			var remainingDashMaxList = _v3.b;
			return A2(
				$elm$core$List$cons,
				A6(
					$author$project$Services$AnimatedKana$dashedPath,
					name,
					currentStrokeIndex,
					strokeWidth,
					pathString,
					A3($author$project$Services$AnimatedKana$zeroOutWhenNotCurrentStroke, currentStrokeIndex, animatingStrokeIndex, dashValue),
					dashMax),
				_Utils_ap(
					A3(
						$author$project$Services$AnimatedKana$dashedPathsInternal,
						currentStrokeIndex + 1,
						animatingStrokeIndex,
						_Utils_update(
							animatedKanaRecord,
							{bZ: dashValue - dashMax, $7: remainingDashMaxList, dp: remainingPaths})),
					A3($author$project$Services$AnimatedKana$toSvgClipPath, currentStrokeIndex, name, clipPath)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Services$AnimatedKana$dashedPaths = F2(
	function (animatingStrokeIndex, animatedKanaRecord) {
		return A3($author$project$Services$AnimatedKana$dashedPathsInternal, 1, animatingStrokeIndex, animatedKanaRecord);
	});
var $author$project$Services$CssSelector$kanaTileScaledUp = $elm$svg$Svg$Attributes$class('kanaTileScaledUp');
var $author$project$Services$AnimatedKana$isScaledUpAttribute = F2(
	function (isScaledUp, attributes) {
		return isScaledUp ? A2($elm$core$List$cons, $author$project$Services$CssSelector$kanaTileScaledUp, attributes) : attributes;
	});
var $author$project$Domain$Types$KanaScaleUpForImageMatchFinished = {$: 4};
var $author$project$Services$CssSelector$animateScaleUp = $elm$svg$Svg$Attributes$class('animate-scale-up');
var $author$project$Services$CssAnimation$kanaTileScaledUp = 'kanaTileScaledUp';
var $author$project$Services$AnimatedKana$isScaledUpForImageMatchAttribute = F2(
	function (isScaledUp, attributes) {
		if ((!isScaledUp.$) && isScaledUp.a) {
			return A2(
				$elm$core$List$cons,
				$author$project$Services$CssSelector$animateScaleUp,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Extras$Events$onAnimationEnd,
						$author$project$Services$CssAnimation$kanaTileScaledUp,
						$author$project$Domain$Types$KanawordMessage($author$project$Domain$Types$KanaScaleUpForImageMatchFinished)),
					attributes));
		} else {
			return attributes;
		}
	});
var $author$project$Services$Kana$yoon = _List_fromArray(
	['kya', 'kyu', 'kyo', 'sha', 'shu', 'sho', 'cha', 'chu', 'cho', 'nya', 'hya', 'hyu', 'hyo', 'nyu', 'nyo', 'mya', 'myu', 'myo', 'rya', 'ryu', 'ryo', 'gya', 'gyu', 'gyo', 'ja', 'ju', 'jo', 'ja2', 'ju2', 'jo2', 'bya', 'byu', 'byo', 'pya', 'pyu', 'pyo', 'kki']);
var $author$project$Services$Kana$isYoon = function (kanaString) {
	return A2(
		$elm$core$List$any,
		function (item) {
			return _Utils_eq(item, kanaString);
		},
		$author$project$Services$Kana$yoon);
};
var $author$project$Services$Kana$isYoonKana = function (kana) {
	return $author$project$Services$Kana$isYoon(kana.cV);
};
var $author$project$SVGs$Elements$KanaBackgroundTile$definitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasKanaWordKanaBackgroundDrawing-shadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('2'),
							$elm$svg$Svg$Attributes$dy('2'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('0.7')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Elements$KanaBackgroundTile$squareKanaBackground = F3(
	function (attributes, children, _v0) {
		return A2(
			$elm$svg$Svg$svg,
			attributes,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$SVGs$Elements$KanaBackgroundTile$definitions,
						A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('rgb(251, 251, 248)'),
								$elm$svg$Svg$Attributes$filter('url(#canvasKanaWordKanaBackgroundDrawing-shadow-outer)'),
								$elm$svg$Svg$Attributes$x('13'),
								$elm$svg$Svg$Attributes$y('13'),
								$elm$svg$Svg$Attributes$width('75'),
								$elm$svg$Svg$Attributes$height('75'),
								$elm$svg$Svg$Attributes$rx('10')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$SVGs$Elements$KanaBackgroundTile$fillAttributes = function (isFocused) {
	return isFocused ? $elm$svg$Svg$Attributes$fillOpacity('0') : $elm$svg$Svg$Attributes$fillOpacity('0');
};
var $author$project$SVGs$Elements$KanaBackgroundTile$wideKanaBackground = F3(
	function (attributes, children, isFocused) {
		return A2(
			$elm$svg$Svg$svg,
			attributes,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$SVGs$Elements$KanaBackgroundTile$definitions,
						A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('rgb(251, 251, 248)'),
								$elm$svg$Svg$Attributes$filter('url(#canvasKanaWordKanaBackgroundDrawing-shadow-outer)'),
								$elm$svg$Svg$Attributes$x('13'),
								$elm$svg$Svg$Attributes$y('13'),
								$elm$svg$Svg$Attributes$width('135'),
								$elm$svg$Svg$Attributes$height('75'),
								$elm$svg$Svg$Attributes$rx('10')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('rgb(0, 0, 0)'),
								$elm$svg$Svg$Attributes$filter('url(#canvasKanaWordKanaBackgroundDrawing-shadow-outer)'),
								$elm$svg$Svg$Attributes$x('13'),
								$elm$svg$Svg$Attributes$y('13'),
								$elm$svg$Svg$Attributes$width('135'),
								$elm$svg$Svg$Attributes$height('75'),
								$elm$svg$Svg$Attributes$rx('10'),
								$author$project$SVGs$Elements$KanaBackgroundTile$fillAttributes(isFocused)
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$SVGs$Elements$KanaBackgroundTile$kanaBackgroundTile = F4(
	function (attributes, children, isScaledUp, kanaString) {
		return $author$project$Services$Kana$isYoon(kanaString) ? A3($author$project$SVGs$Elements$KanaBackgroundTile$wideKanaBackground, attributes, children, isScaledUp) : A3($author$project$SVGs$Elements$KanaBackgroundTile$squareKanaBackground, attributes, children, isScaledUp);
	});
var $author$project$Services$AnimatedKana$kanaStrokesViewBox = function (isYoonKana) {
	return isYoonKana ? $elm$svg$Svg$Attributes$viewBox('0 0 160 100') : $elm$svg$Svg$Attributes$viewBox('0 0 100 100');
};
var $author$project$Services$CssSelector$kanaTile = function (isYoon) {
	return isYoon ? $elm$svg$Svg$Attributes$class('kana-tile-wider') : $elm$svg$Svg$Attributes$class('kana-tile');
};
var $author$project$Services$AnimatedKana$kanaStrokes = F3(
	function (isScaledUpForImageMatch, isScaledUpForKanaMatching, animatedKanaRecord) {
		var isYoon = $author$project$Services$Kana$isYoonKana(animatedKanaRecord);
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Services$AnimatedKana$isScaledUpForImageMatchAttribute,
				isScaledUpForImageMatch,
				A2(
					$author$project$Services$AnimatedKana$isScaledUpAttribute,
					isScaledUpForKanaMatching,
					_List_fromArray(
						[
							$author$project$Services$CssSelector$kanaTile(isYoon)
						]))),
			_List_fromArray(
				[
					A4(
					$author$project$SVGs$Elements$KanaBackgroundTile$kanaBackgroundTile,
					_List_fromArray(
						[
							$author$project$Services$AnimatedKana$kanaStrokesViewBox(isYoon)
						]),
					_List_Nil,
					isScaledUpForKanaMatching,
					animatedKanaRecord.cV),
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('strokes'),
							$author$project$Services$AnimatedKana$kanaStrokesViewBox(isYoon)
						]),
					_Utils_ap(
						$author$project$Services$AnimatedKana$backgroundPaths(animatedKanaRecord),
						A2($author$project$Services$AnimatedKana$dashedPaths, animatedKanaRecord.dn, animatedKanaRecord)))
				]));
	});
var $author$project$Domain$Types$WordFinishedAnimatingForImageMatch = {$: 1};
var $author$project$Services$Dimensions$widerWordkanaTileWidthCssVariable = 'var(--word-kana-tile-width-wider)';
var $author$project$Services$Dimensions$wordKanaTileWidthCssVariableRegular = 'var(--word-kana-tile-width)';
var $author$project$Services$Dimensions$wordKanaTileWidthCssVariable = function (isYoon) {
	return isYoon ? $author$project$Services$Dimensions$widerWordkanaTileWidthCssVariable : $author$project$Services$Dimensions$wordKanaTileWidthCssVariableRegular;
};
var $author$project$Services$Kanaword$currentKanaWidth = function (model) {
	return '( 0.5 * (' + (A2(
		$elm$core$Maybe$withDefault,
		$author$project$Services$Dimensions$wordKanaTileWidthCssVariableRegular,
		A2(
			$elm$core$Maybe$andThen,
			function (kanaRecord) {
				return $elm$core$Maybe$Just(
					$author$project$Services$Dimensions$wordKanaTileWidthCssVariable(
						$author$project$Services$Kana$isYoonKana(kanaRecord)));
			},
			A2($author$project$Extras$List$elementAt, model.bw.bV, model.bw.bv))) + '))');
};
var $author$project$Services$Kana$isNotYoonKana = function (kana) {
	return !$author$project$Services$Kana$isYoon(kana.cV);
};
var $author$project$Services$Kanaword$normalWidthsString = function (count) {
	switch (count) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Services$Dimensions$wordKanaTileWidthCssVariableRegular]);
		default:
			return _List_fromArray(
				[
					$elm$core$String$fromInt(count) + (' * ' + $author$project$Services$Dimensions$wordKanaTileWidthCssVariableRegular)
				]);
	}
};
var $author$project$Services$Kanaword$widerWidthsString = function (count) {
	switch (count) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Services$Dimensions$widerWordkanaTileWidthCssVariable]);
		default:
			return _List_fromArray(
				[
					$elm$core$String$fromInt(count) + (' * ' + $author$project$Services$Dimensions$widerWordkanaTileWidthCssVariable)
				]);
	}
};
var $author$project$Services$Kanaword$kanaWordWidthVars = function (animatedKanaRecords) {
	return $elm$core$List$isEmpty(animatedKanaRecords) ? '' : $author$project$Extras$String$wrapInsideParenthesis(
		A2(
			$elm$core$String$join,
			' + ',
			_Utils_ap(
				$author$project$Services$Kanaword$normalWidthsString(
					$elm$core$List$length(
						A2(
							$elm$core$List$filter,
							function (kanaRecord) {
								return $author$project$Services$Kana$isNotYoonKana(kanaRecord);
							},
							animatedKanaRecords))),
				$author$project$Services$Kanaword$widerWidthsString(
					$elm$core$List$length(
						A2(
							$elm$core$List$filter,
							function (kanaRecord) {
								return $author$project$Services$Kana$isYoonKana(kanaRecord);
							},
							animatedKanaRecords))))));
};
var $author$project$Services$TransitionProperty$left = 'left';
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$View$Kanaword$kanaWordLeftAttribute = F2(
	function (model, attributes) {
		return (!model.bw.bu) ? A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$style, 'left', '100vw'),
			attributes) : ((model.by === 5) ? A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$Attributes$style,
				'left',
				'calc( 0.5 * ' + ($author$project$Services$Kanaword$kanaWordWidthVars(model.bw.bv) + (' - ' + ($author$project$Services$Kanaword$currentKanaWidth(model) + ')')))),
			attributes) : ((model.by === 6) ? A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$style, 'left', '0'),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Extras$Events$onTransitionEnd,
					$author$project$Services$TransitionProperty$left,
					$author$project$Domain$Types$KanawordMessage($author$project$Domain$Types$WordFinishedAnimatingForImageMatch)),
				attributes)) : attributes));
	});
var $author$project$Services$CssSelector$scaledUpWord = $elm$svg$Svg$Attributes$class('scaledUpWord');
var $author$project$View$Kanaword$kanaWordViewScale = F2(
	function (model, attributes) {
		var _v0 = $author$project$Services$Kanaword$isAnimatingSingleKana(model.bw);
		if ((!_v0.$) && (!_v0.a)) {
			return A2($elm$core$List$cons, $author$project$Services$CssSelector$scaledUpWord, attributes);
		} else {
			return attributes;
		}
	});
var $author$project$Domain$Types$WordFinishedAnimatingToLabel = {$: 2};
var $author$project$Services$CssAnimation$animateToWordCountLabel = 'animate-to-word-count-label';
var $author$project$Services$Kanaword$calculateTranslation = function (model) {
	return 'translate(calc(-1 * ' + ($author$project$Services$Kanaword$kanaWordWidthVars(
		A2($elm$core$List$take, model.bw.bV, model.bw.bv)) + '), 0px)');
};
var $author$project$Services$Kanaword$shouldTranslateKanaword = function (model) {
	return (model.bw.bV > 0) && (model.by === 5);
};
var $author$project$Services$CssSelector$wordCountLabel = $elm$svg$Svg$Attributes$class('wordCountLabel');
var $author$project$View$Kanaword$kanaWordViewTranslation = F2(
	function (model, attributes) {
		return $author$project$Services$Kanaword$isCorrectImageSelected(model) ? A2(
			$elm$core$List$cons,
			$author$project$Services$CssSelector$wordCountLabel,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Extras$Events$onAnimationEnd,
					$author$project$Services$CssAnimation$animateToWordCountLabel,
					$author$project$Domain$Types$KanawordMessage($author$project$Domain$Types$WordFinishedAnimatingToLabel)),
				attributes)) : ($author$project$Services$Kanaword$shouldTranslateKanaword(model) ? A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$Attributes$style,
				'transform',
				$author$project$Services$Kanaword$calculateTranslation(model)),
			attributes) : attributes);
	});
var $author$project$View$Kanaword$kanaWordWidthAttribute = F2(
	function (model, attributes) {
		return $author$project$Extras$List$isNotEmpty(model.bw.bv) ? A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$Attributes$style,
				'width',
				'calc(' + ($author$project$Services$Kanaword$kanaWordWidthVars(model.bw.bv) + ')')),
			attributes) : attributes;
	});
var $author$project$View$Kanaword$kanaWordAttributes = function (model) {
	return A2(
		$author$project$View$Kanaword$kanaWordViewScale,
		model,
		A2(
			$author$project$View$Kanaword$kanaWordViewTranslation,
			model,
			A2(
				$author$project$View$Kanaword$kanaWordLeftAttribute,
				model,
				A2(
					$author$project$View$Kanaword$kanaWordWidthAttribute,
					model,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('wordContainer')
						])))));
};
var $author$project$Services$Kanaword$shouldScaleUpForImageMatch = F2(
	function (index, model) {
		var animatedKanawordData = model.bw;
		return $author$project$Services$Kanaword$isCorrectImageSelected(model) ? $elm$core$Maybe$Just(false) : A2(
			$elm$core$Maybe$andThen,
			function (indexValue) {
				return $elm$core$Maybe$Just(
					_Utils_eq(indexValue, index));
			},
			animatedKanawordData.bq);
	});
var $author$project$Services$Kanaword$shouldScaleUpForKanaMatching = F2(
	function (index, model) {
		var animatedKanawordData = model.bw;
		return _Utils_eq(animatedKanawordData.bV, index) && (model.by === 5);
	});
var $author$project$View$Kanaword$kanaWordView = F2(
	function (model, viewElements) {
		var animatedKanawordData = model.bw;
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$elm$html$Html$div,
				$author$project$View$Kanaword$kanaWordAttributes(model),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, record) {
							return A3(
								$author$project$Services$AnimatedKana$kanaStrokes,
								A2($author$project$Services$Kanaword$shouldScaleUpForImageMatch, index, model),
								A2($author$project$Services$Kanaword$shouldScaleUpForKanaMatching, index, model),
								record);
						}),
					animatedKanawordData.bv)),
			viewElements);
	});
var $author$project$Domain$Types$LevelCompleteNotificationFinishedAnimating = {$: 16};
var $author$project$SVGs$Elements$LevelComplete$activeAttribute = F2(
	function (isActive, attributes) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			isActive,
			$elm$svg$Svg$Attributes$class('active'),
			attributes);
	});
var $author$project$SVGs$Elements$LevelComplete$definitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-levelCompleteOuterShadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('3'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-lightStripeGradiantBottom-rectangle4'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('97'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('100'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(70, 146, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor('rgb(92, 188, 168)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-lightStripeGradiantTop-rectangle6'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('-2.5'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('97.5'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.94'),
							$elm$svg$Svg$Attributes$stopColor('rgb(92, 188, 168)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(70, 146, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-darkStripeGradiantBottom-bottomShade'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('97'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('100'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(60, 126, 109)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor('rgb(71, 148, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-darkStripeGradiantTop-topShade'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('-3'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('97'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.93'),
							$elm$svg$Svg$Attributes$stopColor('rgb(71, 148, 129)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(60, 126, 109)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(49, 104, 90)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-highlight-rectangle2'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('6'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('24'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(251, 251, 248)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.25'),
							$elm$svg$Svg$Attributes$stopColor('rgb(126, 126, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.58'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-reverseHighlight-rectangle3'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('-0'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('6'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$stopOpacity('0')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.43'),
							$elm$svg$Svg$Attributes$stopColor('rgb(126, 126, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(251, 251, 248)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-levelCompleteInnerShadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('levelCompleteDrawing-gradient3-beigeStipeShadow'),
					$elm$svg$Svg$Attributes$x1('187.5'),
					$elm$svg$Svg$Attributes$y1('81'),
					$elm$svg$Svg$Attributes$x2('187.5'),
					$elm$svg$Svg$Attributes$y2('84.13'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(252, 246, 213)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.68'),
							$elm$svg$Svg$Attributes$stopColor('rgb(211, 208, 192)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(170, 170, 170)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Services$CssAnimation$levelCompleteNotificationAnimation = 'level-complete-notification-animation';
var $author$project$SVGs$Elements$LevelComplete$levelComplete = function (isLevelComplete) {
	return A2(
		$elm$svg$Svg$svg,
		A2(
			$author$project$SVGs$Elements$LevelComplete$activeAttribute,
			isLevelComplete,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('471'),
					$elm$svg$Svg$Attributes$viewBox('0 0 375 120'),
					$elm$svg$Svg$Attributes$id('level-complete-notification'),
					A2(
					$author$project$Extras$Events$onAnimationEnd,
					$author$project$Services$CssAnimation$levelCompleteNotificationAnimation,
					$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$LevelCompleteNotificationFinishedAnimating))
				])),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$LevelComplete$definitions,
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('levelCompleteDrawing-group2'),
						$elm$svg$Svg$Attributes$clipPath('url(#levelCompleteDrawing-rectangle)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$clipPath,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('levelCompleteDrawing-rectangle')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('-120'),
										$elm$svg$Svg$Attributes$width('375'),
										$elm$svg$Svg$Attributes$height('120'),
										$elm$svg$Svg$Attributes$transform('translate(0, 120)')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('levelCompleteDrawing-stripesBackground'),
								$elm$svg$Svg$Attributes$filter('url(#levelCompleteDrawing-levelCompleteOuterShadow-outer)')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-rectangle4'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-lightStripeGradiantBottom-rectangle4)'),
										$elm$svg$Svg$Attributes$x('-86'),
										$elm$svg$Svg$Attributes$y('97'),
										$elm$svg$Svg$Attributes$width('547'),
										$elm$svg$Svg$Attributes$height('3')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-rectangle6'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-lightStripeGradiantTop-rectangle6)'),
										$elm$svg$Svg$Attributes$x('-86'),
										$elm$svg$Svg$Attributes$y('-2.5'),
										$elm$svg$Svg$Attributes$width('547'),
										$elm$svg$Svg$Attributes$height('100')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-group3'),
										$elm$svg$Svg$Attributes$clipPath('url(#levelCompleteDrawing-rectangle5)')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$clipPath,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('levelCompleteDrawing-rectangle5')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$rect,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$x('0'),
														$elm$svg$Svg$Attributes$y('0'),
														$elm$svg$Svg$Attributes$width('375'),
														$elm$svg$Svg$Attributes$height('120')
													]),
												_List_Nil)
											])),
										A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id('levelCompleteDrawing-group5'),
												$elm$svg$Svg$Attributes$clipPath('url(#levelCompleteDrawing-bezier)')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$clipPath,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('levelCompleteDrawing-bezier')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$path,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$d('M 21.2,100 L 48.17,100 139.86,-0 112.89,-0 21.2,100 Z M 74.68,100 L 101.65,100 193.34,-0 166.38,-0 74.68,100 Z M 128.17,100 L 155.14,100 246.83,-0 219.86,-0 128.17,100 Z M -32.29,100 L -5.32,100 86.37,-0 59.4,-0 -32.29,100 Z M 235.37,100 L 262.34,100 354.03,-0 327.06,-0 235.37,100 Z M 288.85,100 L 315.82,100 407.51,-0 380.55,-0 288.85,100 Z M 342.34,100 L 369.31,100 461,-0 434.03,-0 342.34,100 Z M 181.88,100 L 208.85,100 300.54,-0 273.57,-0 181.88,100 Z M -86,100 L -59.03,100 32.66,-0 5.69,-0 -86,100 Z M -86,100')
															]),
														_List_Nil)
													])),
												A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$id('levelCompleteDrawing-group6')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$rect,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('levelCompleteDrawing-bottomShade'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-darkStripeGradiantBottom-bottomShade)'),
																$elm$svg$Svg$Attributes$x('-86'),
																$elm$svg$Svg$Attributes$y('97'),
																$elm$svg$Svg$Attributes$width('547'),
																$elm$svg$Svg$Attributes$height('3')
															]),
														_List_Nil),
														A2(
														$elm$svg$Svg$rect,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$id('levelCompleteDrawing-topShade'),
																$elm$svg$Svg$Attributes$stroke('none'),
																$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-darkStripeGradiantTop-topShade)'),
																$elm$svg$Svg$Attributes$x('-86'),
																$elm$svg$Svg$Attributes$y('-3'),
																$elm$svg$Svg$Attributes$width('547'),
																$elm$svg$Svg$Attributes$height('100')
															]),
														_List_Nil)
													]))
											]))
									]))
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('levelCompleteDrawing-topHighlight'),
								$elm$svg$Svg$Attributes$opacity('0.6'),
								$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-rectangle2'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-highlight-rectangle2)'),
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('6'),
										$elm$svg$Svg$Attributes$width('375'),
										$elm$svg$Svg$Attributes$height('18')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-rectangle3'),
										$elm$svg$Svg$Attributes$style('mix-blend-mode: screen;'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-reverseHighlight-rectangle3)'),
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$width('375'),
										$elm$svg$Svg$Attributes$height('6')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('levelCompleteDrawing-group4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('levelCompleteDrawing-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$rect,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-beigeBackground'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(252, 246, 213)'),
										$elm$svg$Svg$Attributes$filter('url(#levelCompleteDrawing-levelCompleteInnerShadow-outer)'),
										$elm$svg$Svg$Attributes$x('-94'),
										$elm$svg$Svg$Attributes$y('16'),
										$elm$svg$Svg$Attributes$width('555'),
										$elm$svg$Svg$Attributes$height('68')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-bottomBeigeStipe'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(251, 225, 173)'),
										$elm$svg$Svg$Attributes$d('M -94,76.23 L 461,76.23 461,78.92 -94,78.92 -94,76.23 Z M -94,76.23')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('levelCompleteDrawing-topBeigeStripe'),
										$elm$svg$Svg$Attributes$stroke('none'),
										$elm$svg$Svg$Attributes$fill('rgb(251, 225, 173)'),
										$elm$svg$Svg$Attributes$d('M -94,23.09 L 461,23.09 461,25.78 -94,25.78 -94,23.09 Z M -94,23.09')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('levelCompleteDrawing-beigeStipeShadow'),
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('url(#levelCompleteDrawing-gradient3-beigeStipeShadow)'),
								$elm$svg$Svg$Attributes$d('M 0.07,81 L 374.93,81 374.93,84.13 0.07,84.13 0.07,81 Z M 0.07,81')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('levelCompleteDrawing-levelCompleteText'),
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('rgb(71, 148, 129)'),
								$elm$svg$Svg$Attributes$d('M 64.35,62.22 L 64.35,35.54 67.53,35.54 67.53,59.21 81.41,59.21 81.41,62.22 64.35,62.22 Z M 93.49,50.67 C 92.47,50.67 91.59,50.92 90.85,51.43 90.1,51.94 89.58,52.6 89.27,53.41 89.15,53.8 89.06,54.24 89,54.75 90.21,54.32 91.4,53.88 92.59,53.43 93.78,52.99 94.97,52.55 96.17,52.12 95.82,51.69 95.41,51.34 94.97,51.07 94.52,50.8 94.03,50.67 93.49,50.67 Z M 100.24,53.91 C 98.5,54.55 96.77,55.18 95.04,55.82 93.32,56.45 91.59,57.09 89.85,57.72 90.23,58.26 90.74,58.68 91.36,59 91.99,59.32 92.7,59.48 93.49,59.48 94.67,59.48 95.64,59.07 96.4,58.26 L 98.36,60.54 C 97.72,61.18 96.99,61.67 96.17,62.03 95.36,62.38 94.46,62.56 93.49,62.56 92.42,62.56 91.41,62.37 90.48,61.97 89.55,61.58 88.74,61.04 88.05,60.35 87.36,59.67 86.81,58.87 86.42,57.97 86.02,57.07 85.82,56.1 85.82,55.05 85.82,54.04 86.02,53.07 86.42,52.16 86.81,51.24 87.36,50.45 88.05,49.77 88.74,49.1 89.55,48.57 90.48,48.17 91.41,47.78 92.42,47.58 93.49,47.58 94.28,47.58 95.04,47.74 95.77,48.06 96.5,48.38 97.15,48.82 97.73,49.37 98.3,49.93 98.81,50.6 99.24,51.38 99.68,52.15 100.01,53 100.24,53.91 Z M 111.51,63.1 C 110.13,60.56 108.75,58.03 107.37,55.51 105.99,53 104.61,50.47 103.23,47.93 L 106.41,47.93 C 106.82,48.69 107.27,49.48 107.75,50.29 108.24,51.1 108.72,51.92 109.19,52.73 109.66,53.54 110.1,54.36 110.5,55.19 110.89,56.01 111.23,56.83 111.51,57.65 111.77,56.83 112.1,56.01 112.51,55.19 112.92,54.36 113.36,53.54 113.83,52.73 114.3,51.92 114.78,51.1 115.25,50.29 115.72,49.48 116.18,48.69 116.61,47.93 L 119.79,47.93 C 118.41,50.47 117.03,53 115.65,55.51 114.27,58.03 112.89,60.56 111.51,63.1 Z M 129.38,50.67 C 128.36,50.67 127.47,50.92 126.73,51.43 125.99,51.94 125.47,52.6 125.16,53.41 125.03,53.8 124.94,54.24 124.89,54.75 126.09,54.32 127.29,53.88 128.48,53.43 129.67,52.99 130.86,52.55 132.06,52.12 131.7,51.69 131.3,51.34 130.85,51.07 130.41,50.8 129.92,50.67 129.38,50.67 Z M 136.13,53.91 C 134.39,54.55 132.66,55.18 130.93,55.82 129.21,56.45 127.47,57.09 125.74,57.72 126.12,58.26 126.62,58.68 127.25,59 127.88,59.32 128.59,59.48 129.38,59.48 130.55,59.48 131.53,59.07 132.29,58.26 L 134.25,60.54 C 133.61,61.18 132.88,61.67 132.06,62.03 131.24,62.38 130.35,62.56 129.38,62.56 128.31,62.56 127.3,62.37 126.37,61.97 125.44,61.58 124.62,61.04 123.93,60.35 123.24,59.67 122.7,58.87 122.3,57.97 121.91,57.07 121.71,56.1 121.71,55.05 121.71,54.04 121.91,53.07 122.3,52.16 122.7,51.24 123.24,50.45 123.93,49.77 124.62,49.1 125.44,48.57 126.37,48.17 127.3,47.78 128.31,47.58 129.38,47.58 130.17,47.58 130.93,47.74 131.66,48.06 132.39,48.38 133.04,48.82 133.62,49.37 134.19,49.93 134.7,50.6 135.13,51.38 135.56,52.15 135.9,53 136.13,53.91 Z M 143.03,62.22 L 139.85,62.22 139.85,33.63 143.03,33.63 143.03,62.22 Z M 177.88,58.1 L 179.61,60.62 C 178.58,61.2 177.49,61.67 176.33,62.01 175.17,62.35 173.93,62.52 172.63,62.52 170.74,62.52 168.96,62.17 167.3,61.46 165.64,60.75 164.19,59.77 162.95,58.54 161.71,57.31 160.73,55.87 160.01,54.22 159.3,52.56 158.94,50.8 158.94,48.92 158.94,47.04 159.3,45.26 160.01,43.6 160.73,41.94 161.71,40.49 162.95,39.25 164.19,38.02 165.64,37.04 167.3,36.32 168.96,35.6 170.74,35.23 172.63,35.23 173.93,35.23 175.17,35.4 176.33,35.73 177.49,36.06 178.6,36.53 179.64,37.14 179.36,37.57 179.07,38 178.76,38.42 178.46,38.84 178.16,39.26 177.88,39.69 177.09,39.24 176.26,38.88 175.39,38.63 174.52,38.37 173.6,38.24 172.63,38.24 171.17,38.24 169.81,38.52 168.54,39.08 167.28,39.64 166.17,40.41 165.21,41.39 164.25,42.37 163.5,43.5 162.95,44.8 162.4,46.1 162.12,47.47 162.12,48.92 162.12,50.37 162.4,51.74 162.95,53.03 163.5,54.33 164.25,55.45 165.21,56.41 166.17,57.36 167.28,58.12 168.54,58.67 169.81,59.23 171.17,59.51 172.63,59.51 174.52,59.51 176.27,59.04 177.88,58.1 Z M 183.63,55.05 C 183.63,54.04 183.83,53.07 184.23,52.16 184.62,51.24 185.17,50.45 185.86,49.77 186.55,49.1 187.36,48.57 188.29,48.17 189.22,47.78 190.23,47.58 191.3,47.58 192.37,47.58 193.38,47.78 194.33,48.17 195.28,48.57 196.09,49.1 196.78,49.77 197.47,50.45 198.02,51.24 198.41,52.16 198.81,53.07 199.01,54.04 199.01,55.05 199.01,56.1 198.81,57.07 198.41,57.97 198.02,58.87 197.47,59.67 196.78,60.35 196.09,61.04 195.28,61.58 194.33,61.97 193.38,62.37 192.37,62.56 191.3,62.56 190.23,62.56 189.22,62.37 188.29,61.97 187.36,61.58 186.55,61.04 185.86,60.35 185.17,59.67 184.62,58.87 184.23,57.97 183.83,57.07 183.63,56.1 183.63,55.05 Z M 186.81,55.09 C 186.81,55.7 186.93,56.27 187.16,56.81 187.39,57.34 187.7,57.8 188.1,58.2 188.5,58.59 188.96,58.9 189.5,59.13 190.04,59.36 190.61,59.48 191.22,59.48 191.84,59.48 192.41,59.36 192.95,59.13 193.49,58.9 193.96,58.59 194.37,58.2 194.78,57.8 195.1,57.34 195.33,56.81 195.56,56.27 195.67,55.7 195.67,55.09 195.67,54.48 195.56,53.91 195.33,53.38 195.1,52.84 194.78,52.37 194.37,51.97 193.96,51.56 193.49,51.24 192.95,51.01 192.41,50.78 191.84,50.67 191.22,50.67 190.61,50.67 190.04,50.78 189.5,51.01 188.96,51.24 188.5,51.56 188.1,51.97 187.7,52.37 187.39,52.84 187.16,53.38 186.93,53.91 186.81,54.48 186.81,55.09 Z M 203.61,47.93 L 206.41,47.93 206.41,48.27 C 206.46,48.88 206.5,49.43 206.54,49.93 206.58,50.42 206.62,50.98 206.68,51.59 207.21,50.37 208.02,49.41 209.11,48.71 210.2,48.01 211.47,47.63 212.93,47.58 214.33,47.58 215.46,47.93 216.32,48.63 217.18,49.33 217.68,50.25 217.83,51.39 218.4,50.23 219.21,49.31 220.29,48.65 221.36,47.99 222.6,47.63 224.01,47.58 225.51,47.58 226.7,47.98 227.57,48.76 228.44,49.55 228.9,50.58 228.95,51.85 L 228.95,62.22 225.77,62.22 225.77,53.3 C 225.72,52.61 225.47,52.02 225.02,51.53 224.58,51.03 223.87,50.76 222.89,50.71 222.23,50.71 221.6,50.82 221,51.05 220.4,51.28 219.87,51.6 219.41,52 218.95,52.41 218.57,52.89 218.29,53.45 218.01,54.01 217.87,54.62 217.87,55.28 L 217.87,62.22 214.69,62.22 214.69,53.3 C 214.64,52.61 214.39,52.02 213.94,51.53 213.49,51.03 212.78,50.76 211.81,50.71 211.15,50.71 210.52,50.82 209.92,51.05 209.32,51.28 208.78,51.6 208.32,52 207.86,52.41 207.49,52.89 207.21,53.45 206.93,54.01 206.79,54.62 206.79,55.28 L 206.79,62.22 203.61,62.22 203.61,47.93 Z M 245.71,55.05 C 245.71,53.78 245.29,52.74 244.46,51.91 243.63,51.08 242.55,50.67 241.22,50.67 239.89,50.67 238.81,51.08 237.98,51.91 237.15,52.74 236.74,53.78 236.74,55.05 236.74,56.3 237.15,57.35 237.98,58.2 238.81,59.05 239.89,59.48 241.22,59.48 242.55,59.48 243.63,59.05 244.46,58.2 245.29,57.35 245.71,56.3 245.71,55.05 Z M 248.93,55.05 C 248.93,56.07 248.73,57.04 248.33,57.95 247.94,58.87 247.39,59.67 246.7,60.35 246.01,61.04 245.2,61.58 244.25,61.97 243.31,62.37 242.3,62.56 241.22,62.56 240.46,62.56 239.77,62.47 239.17,62.3 238.57,62.12 238.07,61.92 237.66,61.71 237.25,61.49 236.93,61.28 236.7,61.08 236.47,60.87 236.35,60.73 236.35,60.66 236.4,60.78 236.47,60.92 236.54,61.08 236.62,61.23 236.68,61.37 236.74,61.5 L 236.74,71.75 233.55,71.75 233.55,47.93 236.2,47.93 C 236.2,48.23 236.22,48.53 236.26,48.82 236.29,49.11 236.33,49.41 236.35,49.72 236.35,49.64 236.48,49.49 236.74,49.26 236.99,49.03 237.34,48.8 237.77,48.55 238.21,48.31 238.72,48.09 239.3,47.89 239.89,47.68 240.53,47.58 241.22,47.58 242.3,47.58 243.31,47.78 244.25,48.17 245.2,48.57 246.01,49.11 246.7,49.79 247.39,50.48 247.94,51.27 248.33,52.18 248.73,53.08 248.93,54.04 248.93,55.05 Z M 256.52,62.22 L 253.34,62.22 253.34,33.63 256.52,33.63 256.52,62.22 Z M 267.6,50.67 C 266.58,50.67 265.7,50.92 264.96,51.43 264.21,51.94 263.69,52.6 263.38,53.41 263.26,53.8 263.17,54.24 263.12,54.75 264.32,54.32 265.51,53.88 266.7,53.43 267.89,52.99 269.08,52.55 270.28,52.12 269.93,51.69 269.52,51.34 269.08,51.07 268.63,50.8 268.14,50.67 267.6,50.67 Z M 274.35,53.91 C 272.61,54.55 270.88,55.18 269.15,55.82 267.43,56.45 265.7,57.09 263.96,57.72 264.34,58.26 264.85,58.68 265.47,59 266.1,59.32 266.81,59.48 267.6,59.48 268.78,59.48 269.75,59.07 270.52,58.26 L 272.47,60.54 C 271.83,61.18 271.1,61.67 270.28,62.03 269.47,62.38 268.57,62.56 267.6,62.56 266.53,62.56 265.52,62.37 264.59,61.97 263.66,61.58 262.85,61.04 262.16,60.35 261.47,59.67 260.92,58.87 260.53,57.97 260.13,57.07 259.93,56.1 259.93,55.05 259.93,54.04 260.13,53.07 260.53,52.16 260.92,51.24 261.47,50.45 262.16,49.77 262.85,49.1 263.66,48.57 264.59,48.17 265.52,47.78 266.53,47.58 267.6,47.58 268.39,47.58 269.15,47.74 269.88,48.06 270.61,48.38 271.26,48.82 271.84,49.37 272.41,49.93 272.92,50.6 273.35,51.38 273.79,52.15 274.12,53 274.35,53.91 Z M 279.99,38.63 L 283.17,38.63 283.17,47.58 286.93,47.58 286.93,50.67 283.17,50.67 283.17,62.22 279.99,62.22 279.99,50.67 276.76,50.67 276.76,47.58 279.99,47.58 279.99,38.63 Z M 296.4,50.67 C 295.37,50.67 294.49,50.92 293.75,51.43 293.01,51.94 292.48,52.6 292.18,53.41 292.05,53.8 291.96,54.24 291.91,54.75 293.11,54.32 294.31,53.88 295.49,53.43 296.68,52.99 297.88,52.55 299.08,52.12 298.72,51.69 298.32,51.34 297.87,51.07 297.42,50.8 296.93,50.67 296.4,50.67 Z M 303.14,53.91 C 301.41,54.55 299.67,55.18 297.95,55.82 296.22,56.45 294.49,57.09 292.75,57.72 293.14,58.26 293.64,58.68 294.27,59 294.89,59.32 295.6,59.48 296.4,59.48 297.57,59.48 298.54,59.07 299.31,58.26 L 301.27,60.54 C 300.63,61.18 299.9,61.67 299.08,62.03 298.26,62.38 297.37,62.56 296.4,62.56 295.32,62.56 294.32,62.37 293.39,61.97 292.45,61.58 291.64,61.04 290.95,60.35 290.26,59.67 289.72,58.87 289.32,57.97 288.93,57.07 288.73,56.1 288.73,55.05 288.73,54.04 288.93,53.07 289.32,52.16 289.72,51.24 290.26,50.45 290.95,49.77 291.64,49.1 292.45,48.57 293.39,48.17 294.32,47.78 295.32,47.58 296.4,47.58 297.19,47.58 297.95,47.74 298.68,48.06 299.41,48.38 300.06,48.82 300.63,49.37 301.21,49.93 301.71,50.6 302.15,51.38 302.58,52.15 302.91,53 303.14,53.91 Z M 308.47,62.22 C 307.96,62.22 307.5,62.03 307.09,61.65 306.68,61.27 306.48,60.78 306.48,60.2 306.48,59.62 306.68,59.14 307.09,58.77 307.5,58.4 307.96,58.22 308.47,58.22 308.96,58.22 309.41,58.4 309.82,58.77 310.22,59.14 310.43,59.62 310.43,60.2 310.43,60.78 310.22,61.27 309.82,61.65 309.41,62.03 308.96,62.22 308.47,62.22 Z M 306.86,33.63 L 310.05,33.63 310.05,55.89 306.86,55.89 306.86,33.63 Z M 306.86,33.63')
							]),
						_List_Nil)
					]))
			]));
};
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$SVGs$Elements$Loading$animateCircleWithDelay = function (delay) {
	return A2(
		$elm$svg$Svg$animate,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$attributeName('opacity'),
				$elm$svg$Svg$Attributes$dur('1.5s'),
				$elm$svg$Svg$Attributes$values('0;1;0'),
				$elm$svg$Svg$Attributes$repeatCount('indefinite'),
				$elm$svg$Svg$Attributes$begin(
				$elm$core$String$fromFloat(delay))
			]),
		_List_Nil);
};
var $author$project$SVGs$Elements$Loading$animatedCircle = F2(
	function (cx, delay) {
		return A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$cx(
					$elm$core$String$fromFloat(cx)),
					$elm$svg$Svg$Attributes$cy('50'),
					$elm$svg$Svg$Attributes$r('6')
				]),
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Loading$animateCircleWithDelay(delay)
				]));
	});
var $elm$svg$Svg$Attributes$enableBackground = _VirtualDom_attribute('enable-background');
var $author$project$Services$Time$loadingCircleOneDelay = 0.1;
var $author$project$Services$Time$loadingCircleThreeDelay = 3 * $author$project$Services$Time$loadingCircleOneDelay;
var $author$project$Services$Time$loadingCircleTwoDelay = 2 * $author$project$Services$Time$loadingCircleOneDelay;
var $elm$svg$Svg$Attributes$overflow = _VirtualDom_attribute('overflow');
var $author$project$Extras$Svg$translateString = F2(
	function (translateX, translateY) {
		return 'translate(' + ($elm$core$String$fromFloat(translateX) + (' ' + ($elm$core$String$fromFloat(translateY) + ')')));
	});
var $author$project$Extras$Svg$translateAttribute = F2(
	function (translateX, translateY) {
		return $elm$svg$Svg$Attributes$transform(
			A2($author$project$Extras$Svg$translateString, translateX, translateY));
	});
var $author$project$SVGs$Elements$Loading$animatedDots = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('animatedDots'),
			$elm$svg$Svg$Attributes$x('50%'),
			$elm$svg$Svg$Attributes$y('50%'),
			$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
			$elm$svg$Svg$Attributes$enableBackground('new 0 0 0 0'),
			$elm$svg$Svg$Attributes$width('75'),
			$elm$svg$Svg$Attributes$height('75'),
			$elm$svg$Svg$Attributes$overflow('visible')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					A2($author$project$Extras$Svg$translateAttribute, -27.5, -27.5)
				]),
			_List_fromArray(
				[
					A2($author$project$SVGs$Elements$Loading$animatedCircle, 6, $author$project$Services$Time$loadingCircleOneDelay),
					A2($author$project$SVGs$Elements$Loading$animatedCircle, 26, $author$project$Services$Time$loadingCircleTwoDelay),
					A2($author$project$SVGs$Elements$Loading$animatedCircle, 46, $author$project$Services$Time$loadingCircleThreeDelay)
				]))
		]));
var $author$project$SVGs$Elements$Loading$definitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasLoading-gradient2-rectangle'),
					$elm$svg$Svg$Attributes$x1('214'),
					$elm$svg$Svg$Attributes$y1('-0'),
					$elm$svg$Svg$Attributes$x2('214'),
					$elm$svg$Svg$Attributes$y2('926'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(150, 50, 226)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(245, 157, 13)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Elements$Loading$showLoadingOverlay = function (model) {
	return A2(
		$author$project$Extras$List$contains,
		model.by,
		_List_fromArray(
			[3, 2]));
};
var $author$project$SVGs$Elements$Loading$loadingOpacity = function (model) {
	return $author$project$SVGs$Elements$Loading$showLoadingOverlay(model) ? $elm$svg$Svg$Attributes$opacity('1') : $elm$svg$Svg$Attributes$opacity('0');
};
var $author$project$Services$TransitionProperty$opacity = 'opacity';
var $author$project$SVGs$Elements$Loading$transitionAttribute = F3(
	function (message, model, attributes) {
		return $author$project$SVGs$Elements$Loading$showLoadingOverlay(model) ? A2(
			$author$project$Extras$List$appendElement,
			A2($author$project$Extras$Events$onTransitionEnd, $author$project$Services$TransitionProperty$opacity, message),
			attributes) : attributes;
	});
var $author$project$SVGs$Elements$Loading$loading = function (model) {
	return A2(
		$elm$svg$Svg$svg,
		A3(
			$author$project$SVGs$Elements$Loading$transitionAttribute,
			$author$project$Domain$Types$LoadingMessage($author$project$Domain$Types$UpdateLoadingState),
			model,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('loading'),
					$elm$svg$Svg$Attributes$height('100vh'),
					$elm$svg$Svg$Attributes$width('100vw'),
					$author$project$SVGs$Elements$Loading$loadingOpacity(model)
				])),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$Loading$definitions,
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill('url(#canvasLoading-gradient2-rectangle)'),
						$elm$svg$Svg$Attributes$x('0'),
						$elm$svg$Svg$Attributes$y('0'),
						$elm$svg$Svg$Attributes$width('100%'),
						$elm$svg$Svg$Attributes$height('100%')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'text',
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
						$elm$svg$Svg$Attributes$fontFamily('AvenirNext-Regular, \'Avenir Next\', sans-serif'),
						$elm$svg$Svg$Attributes$fontSize('30'),
						$elm$svg$Svg$Attributes$x('152.92'),
						$elm$svg$Svg$Attributes$y('417'),
						$elm$svg$Svg$Attributes$textAnchor('middle')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$tspan,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x('50%'),
								$elm$svg$Svg$Attributes$y('50%')
							]),
						_List_fromArray(
							[
								$elm$svg$Svg$text('Loading')
							]))
					])),
				$author$project$SVGs$Elements$Loading$animatedDots
			]));
};
var $author$project$View$showModalBackground = function (_v0) {
	var modals = _v0.cQ;
	return A2(
		$author$project$Extras$List$contains,
		0,
		_List_fromArray(
			[modals.dH, modals.b_, modals.b4, modals.df, modals.cM.aO, modals.cL]));
};
var $author$project$View$modalBackground = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('modal-background'),
				$author$project$View$showModalBackground(model) ? $elm$svg$Svg$Attributes$class('active') : $elm$svg$Svg$Attributes$class('dismissed')
			]),
		_List_Nil);
};
var $author$project$Services$CssSelector$moves = $elm$svg$Svg$Attributes$class('moves');
var $author$project$Services$CssSelector$movesContainer = $elm$svg$Svg$Attributes$class('moves-container');
var $author$project$View$remainingWordsText = function (model) {
	return $elm$core$String$fromInt(model.ct.bT) + ('/' + $elm$core$String$fromInt(
		$elm$core$List$length(model.cK.cI)));
};
var $author$project$SVGs$Elements$Score$transformOriginString = F2(
	function (translateX, translateY) {
		return $elm$core$String$fromFloat(translateX) + ('px ' + ($elm$core$String$fromFloat(translateY) + 'px'));
	});
var $author$project$SVGs$Elements$Score$transformOrigin = F2(
	function (translateX, translateY) {
		return A2(
			$elm$html$Html$Attributes$attribute,
			'transform-origin',
			A2($author$project$SVGs$Elements$Score$transformOriginString, translateX, translateY));
	});
var $author$project$SVGs$Elements$Score$translateString = F2(
	function (translateX, translateY) {
		return 'translate(' + ($elm$core$String$fromFloat(translateX) + (', ' + ($elm$core$String$fromFloat(translateY) + ')')));
	});
var $author$project$SVGs$Elements$Score$translateAttribute = F2(
	function (translateX, translateY) {
		return $elm$svg$Svg$Attributes$transform(
			A2($author$project$SVGs$Elements$Score$translateString, translateX, translateY));
	});
var $author$project$SVGs$Elements$Score$whiteFill = $elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)');
var $author$project$SVGs$Elements$Score$progressCircle = F4(
	function (isVisible, translateX, translateY, elements) {
		return isVisible ? _Utils_ap(
			elements,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$author$project$SVGs$Elements$Score$whiteFill,
							$elm$svg$Svg$Attributes$r('12.03'),
							$elm$svg$Svg$Attributes$class('animatedScoreCircle'),
							A2($author$project$SVGs$Elements$Score$translateAttribute, translateX, translateY),
							A2($author$project$SVGs$Elements$Score$transformOrigin, translateX, translateY)
						]),
					_List_Nil)
				])) : elements;
	});
var $author$project$SVGs$Elements$Score$circleOne = F2(
	function (isVisible, elements) {
		return A4($author$project$SVGs$Elements$Score$progressCircle, isVisible, 126.5, 18.5, elements);
	});
var $author$project$SVGs$Elements$Score$circleThree = F2(
	function (isVisible, elements) {
		return A4($author$project$SVGs$Elements$Score$progressCircle, isVisible, 353.8, 18.5, elements);
	});
var $author$project$SVGs$Elements$Score$circleTwo = F2(
	function (isVisible, elements) {
		return A4($author$project$SVGs$Elements$Score$progressCircle, isVisible, 240.2, 18.5, elements);
	});
var $author$project$SVGs$Elements$Score$circleBackground = A2(
	$elm$svg$Svg$circle,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$stroke('none'),
			$elm$svg$Svg$Attributes$fill('rgb(0, 0, 0)'),
			$elm$svg$Svg$Attributes$cx('341.79'),
			$elm$svg$Svg$Attributes$cy('50.7'),
			$elm$svg$Svg$Attributes$r('32.5')
		]),
	_List_Nil);
var $author$project$SVGs$Elements$Score$progressClipPath = $elm$svg$Svg$Attributes$d('M 44.08,40.7 L 309.29,40.7 C 314.82,40.7 319.29,45.17 319.29,50.7 319.29,56.22 314.82,60.7 309.29,60.7 L 44.08,60.7 C 38.56,60.7 34.08,56.22 34.08,50.7 34.08,45.17 38.56,40.7 44.08,40.7 Z M 44.08,40.7');
var $author$project$SVGs$Elements$Score$progressBackground = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$stroke('none'),
			$elm$svg$Svg$Attributes$fill('rgb(0, 0, 0)'),
			$author$project$SVGs$Elements$Score$progressClipPath
		]),
	_List_Nil);
var $author$project$SVGs$Elements$Score$progressClipPathElement = A2(
	$elm$svg$Svg$clipPath,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('canvasStars-bezierProgressClip')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[$author$project$SVGs$Elements$Score$progressClipPath]),
			_List_Nil)
		]));
var $author$project$SVGs$Elements$Score$dashMax = 278;
var $author$project$SVGs$Elements$Score$percentCompleteToStrokeDash = function (percentComplete) {
	return $elm$svg$Svg$Attributes$strokeDasharray(
		A2(
			$elm$core$String$join,
			',',
			_List_fromArray(
				[
					$elm$core$String$fromFloat($author$project$SVGs$Elements$Score$dashMax * percentComplete),
					$elm$core$String$fromFloat($author$project$SVGs$Elements$Score$dashMax)
				])));
};
var $author$project$SVGs$Elements$Score$progressPath = $elm$svg$Svg$Attributes$d('M 33.69,50.7 L 311.21,50.7');
var $elm$svg$Svg$Attributes$strokeDashoffset = _VirtualDom_attribute('stroke-dashoffset');
var $author$project$SVGs$Elements$Score$progressElement = function (percentComplete) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke('rgb(255, 255, 255)'),
				$elm$svg$Svg$Attributes$strokeWidth('20'),
				$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
				$author$project$SVGs$Elements$Score$percentCompleteToStrokeDash(percentComplete),
				$elm$svg$Svg$Attributes$strokeDashoffset('0'),
				$elm$svg$Svg$Attributes$fill('none'),
				$author$project$SVGs$Elements$Score$progressPath
			]),
		_List_Nil);
};
var $author$project$SVGs$Elements$Score$progressBarClipPath = function (percentComplete) {
	return A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$clipPath('url(#canvasStars-bezierProgressClip)')
			]),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$Score$progressClipPathElement,
				$author$project$SVGs$Elements$Score$progressElement(percentComplete)
			]));
};
var $author$project$SVGs$Elements$Score$translateAndScaleString = F3(
	function (translateX, translateY, scale) {
		return 'translate(' + ($elm$core$String$fromFloat(translateX) + (', ' + ($elm$core$String$fromFloat(translateY) + (') ' + ('scale(' + ($elm$core$String$fromFloat(scale) + (', ' + ($elm$core$String$fromFloat(scale) + ')'))))))));
	});
var $author$project$SVGs$Elements$Score$translateAndScaleAttribute = F3(
	function (translateX, translateY, scale) {
		return $elm$svg$Svg$Attributes$transform(
			A3($author$project$SVGs$Elements$Score$translateAndScaleString, translateX, translateY, scale));
	});
var $author$project$SVGs$Elements$Score$progressBar = F4(
	function (percentComplete, translateX, translateY, scale) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					A3($author$project$SVGs$Elements$Score$translateAndScaleAttribute, translateX, translateY, scale)
				]),
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Score$progressBackground,
					$author$project$SVGs$Elements$Score$progressBarClipPath(percentComplete),
					$author$project$SVGs$Elements$Score$circleBackground
				]));
	});
var $author$project$SVGs$Elements$Score$oneStarProgress = function (oneStarPercentComplete) {
	return A4($author$project$SVGs$Elements$Score$progressBar, oneStarPercentComplete, 0, 0, 0.37);
};
var $author$project$SVGs$Elements$Score$threeStarProgress = function (threeStarPercentComplete) {
	return A4($author$project$SVGs$Elements$Score$progressBar, threeStarPercentComplete, 227.4, 0, 0.37);
};
var $author$project$SVGs$Elements$Score$twoStarProgress = function (twoStarPercentComplete) {
	return A4($author$project$SVGs$Elements$Score$progressBar, twoStarPercentComplete, 113.73, 0, 0.37);
};
var $author$project$SVGs$Elements$Score$progressGroup = function (score) {
	return A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				A2($author$project$SVGs$Elements$Score$translateAttribute, 12, 63.08)
			]),
		A2(
			$author$project$SVGs$Elements$Score$circleThree,
			score.bs,
			A2(
				$author$project$SVGs$Elements$Score$circleTwo,
				score.bt,
				A2(
					$author$project$SVGs$Elements$Score$circleOne,
					score.br,
					_List_fromArray(
						[
							$author$project$SVGs$Elements$Score$threeStarProgress(score.dt),
							$author$project$SVGs$Elements$Score$twoStarProgress(score.dD),
							$author$project$SVGs$Elements$Score$oneStarProgress(score.c_)
						])))));
};
var $author$project$SVGs$Elements$Score$scoreViewBox = $elm$svg$Svg$Attributes$viewBox('0 0 400 100');
var $author$project$SVGs$Elements$Score$starDefinitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasStarOneAnimation-shadowStar-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('1'),
							$elm$svg$Svg$Attributes$dy('1'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Elements$Score$backgroundStarPath = $elm$svg$Svg$Attributes$d('M 25.06,0.56 L 32.65,15.84 49.47,18.36 37.34,30.33 40.14,47.17 25.06,39.29 9.97,47.17 12.77,30.33 0.64,18.36 17.46,15.84 25.06,0.56 Z M 25.06,0.56');
var $author$project$SVGs$Elements$Score$backgroundStarCompletePathElement = F2(
	function (translateX, translateY) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					A2($author$project$SVGs$Elements$Score$translateAttribute, translateX, translateY),
					$elm$svg$Svg$Attributes$opacity('0.3'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('rgb(0, 0, 0)'),
					$elm$svg$Svg$Attributes$strokeWidth('0.5'),
					$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
					$elm$svg$Svg$Attributes$fill('rgb(0, 0, 0)'),
					$author$project$SVGs$Elements$Score$backgroundStarPath
				]),
			_List_Nil);
	});
var $author$project$SVGs$Elements$Score$starOne = A2($author$project$SVGs$Elements$Score$backgroundStarCompletePathElement, 0, 0);
var $author$project$SVGs$Elements$Score$starPath = $elm$svg$Svg$Attributes$d('M 0.06,-24.44 L 7.65,-9.16 24.47,-6.64 12.34,5.33 15.14,22.17 0.06,14.29 -15.03,22.17 -12.23,5.33 -24.36,-6.64 -7.54,-9.16 0.06,-24.44 Z M 0.06,-24.44');
var $author$project$SVGs$Elements$Score$starComplete = F4(
	function (isVisible, translateX, translateY, elements) {
		return (!isVisible) ? elements : _Utils_ap(
			elements,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							A2($author$project$SVGs$Elements$Score$translateAttribute, translateX, translateY),
							A2($author$project$SVGs$Elements$Score$transformOrigin, translateX, translateY),
							$elm$svg$Svg$Attributes$class('animatedStar')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$filter('url(#canvasStarOneAnimation-shadowStar-outer)'),
									$author$project$SVGs$Elements$Score$whiteFill,
									$author$project$SVGs$Elements$Score$starPath
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('rgb(0, 0, 0)'),
									$elm$svg$Svg$Attributes$strokeWidth('0.5'),
									$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
									$elm$svg$Svg$Attributes$fill('none'),
									$author$project$SVGs$Elements$Score$starPath
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$SVGs$Elements$Score$starOneComplete = F2(
	function (isVisible, elements) {
		return A4($author$project$SVGs$Elements$Score$starComplete, isVisible, 25, 25, elements);
	});
var $author$project$SVGs$Elements$Score$starThree = A2($author$project$SVGs$Elements$Score$backgroundStarCompletePathElement, 227.26, 0);
var $author$project$SVGs$Elements$Score$starThreeComplete = F2(
	function (isVisible, elements) {
		return A4($author$project$SVGs$Elements$Score$starComplete, isVisible, 252, 25, elements);
	});
var $author$project$SVGs$Elements$Score$starTwo = A2($author$project$SVGs$Elements$Score$backgroundStarCompletePathElement, 112.97, 0);
var $author$project$SVGs$Elements$Score$starTwoComplete = F2(
	function (isVisible, elements) {
		return A4($author$project$SVGs$Elements$Score$starComplete, isVisible, 138, 25, elements);
	});
var $author$project$SVGs$Elements$Score$starsGroup = function (score) {
	return A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				A2($author$project$SVGs$Elements$Score$translateAttribute, 61, 15)
			]),
		A2(
			$author$project$SVGs$Elements$Score$starThreeComplete,
			score.bs,
			A2(
				$author$project$SVGs$Elements$Score$starTwoComplete,
				score.bt,
				A2(
					$author$project$SVGs$Elements$Score$starOneComplete,
					score.br,
					_List_fromArray(
						[$author$project$SVGs$Elements$Score$starDefinitions, $author$project$SVGs$Elements$Score$starThree, $author$project$SVGs$Elements$Score$starTwo, $author$project$SVGs$Elements$Score$starOne])))));
};
var $author$project$SVGs$Elements$Score$scoreView = function (score) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[$author$project$SVGs$Elements$Score$scoreViewBox]),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$Score$starsGroup(score),
				$author$project$SVGs$Elements$Score$progressGroup(score)
			]));
};
var $author$project$Services$CssSelector$scoreViewContainer = $elm$svg$Svg$Attributes$class('score-view-container');
var $author$project$Services$CssSelector$words = $elm$svg$Svg$Attributes$class('words');
var $author$project$View$movesAndWordsLabels = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Services$CssSelector$movesContainer]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Services$CssSelector$moves]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Moves')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(model.cK.cU))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Services$CssSelector$scoreViewContainer]),
						_List_fromArray(
							[
								$author$project$SVGs$Elements$Score$scoreView(model.da),
								$elm$html$Html$text(
								$elm$core$String$fromInt(model.da.cf))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Services$CssSelector$words]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Words')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$View$remainingWordsText(model))
									]))
							]))
					])),
			viewElements);
	});
var $author$project$SVGs$Elements$StarBanner$BannerAttributes = F4(
	function (score, stars, x, y) {
		return {da: score, a9: stars, bl: x, bm: y};
	});
var $author$project$Domain$Types$LevelPreviewCloseClicked = {$: 12};
var $author$project$SVGs$Elements$StarBanner$None = 0;
var $author$project$Domain$Types$PreviousImageClicked = {$: 10};
var $author$project$SVGs$Elements$Carousel$arrowBackgroundCircle = A2(
	$elm$svg$Svg$circle,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$cx('50'),
			$elm$svg$Svg$Attributes$cy('50'),
			$elm$svg$Svg$Attributes$r('75'),
			$elm$svg$Svg$Attributes$fill('hsla(0, 0%, 100%, 0.75)')
		]),
	_List_Nil);
var $author$project$SVGs$Elements$Carousel$arrowPath = $elm$svg$Svg$Attributes$d('M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z');
var $author$project$SVGs$Elements$Carousel$arrowLeft = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
			$elm$svg$Svg$Attributes$width('20'),
			$elm$svg$Svg$Attributes$x('25'),
			$elm$svg$Svg$Attributes$y('50'),
			$elm$svg$Svg$Attributes$overflow('visible'),
			$elm$svg$Svg$Attributes$class('arrow'),
			$elm$svg$Svg$Attributes$fillOpacity('50%'),
			$elm$html$Html$Events$onClick(
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$PreviousImageClicked))
		]),
	_List_fromArray(
		[
			$author$project$SVGs$Elements$Carousel$arrowBackgroundCircle,
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Carousel$arrowPath,
					$elm$svg$Svg$Attributes$fill('rgb(39, 90, 80)'),
					$elm$svg$Svg$Attributes$fillOpacity('100%')
				]),
			_List_Nil)
		]));
var $author$project$Domain$Types$NextImageClicked = {$: 9};
var $author$project$SVGs$Elements$Carousel$arrowRight = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
			$elm$svg$Svg$Attributes$x('225'),
			$elm$svg$Svg$Attributes$y('50'),
			$elm$svg$Svg$Attributes$width('20'),
			$elm$svg$Svg$Attributes$transform('translate(100, 100) rotate(180)'),
			$elm$svg$Svg$Attributes$overflow('visible'),
			$elm$svg$Svg$Attributes$class('arrow'),
			$elm$svg$Svg$Attributes$fillOpacity('50%'),
			$elm$html$Html$Events$onClick(
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$NextImageClicked))
		]),
	_List_fromArray(
		[
			$author$project$SVGs$Elements$Carousel$arrowBackgroundCircle,
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Carousel$arrowPath,
					$elm$svg$Svg$Attributes$transform('translate(100, 100) rotate(180)'),
					$elm$svg$Svg$Attributes$fill('rgb(39, 90, 80)'),
					$elm$svg$Svg$Attributes$fillOpacity('100%')
				]),
			_List_Nil)
		]));
var $author$project$Domain$Types$CarouselDotClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$SVGs$Elements$Carousel$dot = F4(
	function (clickEvent, isSelected, x, y) {
		return A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx(
					$elm$core$String$fromInt(x)),
					$elm$svg$Svg$Attributes$cy(
					$elm$core$String$fromInt(y)),
					$elm$svg$Svg$Attributes$r('4'),
					$elm$svg$Svg$Attributes$fill('white'),
					$elm$html$Html$Events$onClick(clickEvent),
					$elm$svg$Svg$Attributes$class('dot'),
					isSelected ? $elm$svg$Svg$Attributes$fillOpacity('100%') : $elm$svg$Svg$Attributes$fillOpacity('50%')
				]),
			_List_Nil);
	});
var $author$project$SVGs$Elements$Carousel$dotMargin = 20;
var $author$project$SVGs$Elements$Carousel$dots = F3(
	function (imageIndex, x, y) {
		return A2(
			$elm$svg$Svg$svg,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$SVGs$Elements$Carousel$dot,
					$author$project$Domain$Types$ModalMessage(
						$author$project$Domain$Types$CarouselDotClicked(0)),
					!imageIndex,
					x,
					y),
					A4(
					$author$project$SVGs$Elements$Carousel$dot,
					$author$project$Domain$Types$ModalMessage(
						$author$project$Domain$Types$CarouselDotClicked(1)),
					imageIndex === 1,
					x + $author$project$SVGs$Elements$Carousel$dotMargin,
					y),
					A4(
					$author$project$SVGs$Elements$Carousel$dot,
					$author$project$Domain$Types$ModalMessage(
						$author$project$Domain$Types$CarouselDotClicked(2)),
					imageIndex === 2,
					x + ($author$project$SVGs$Elements$Carousel$dotMargin * 2),
					y),
					A4(
					$author$project$SVGs$Elements$Carousel$dot,
					$author$project$Domain$Types$ModalMessage(
						$author$project$Domain$Types$CarouselDotClicked(3)),
					imageIndex === 3,
					x + ($author$project$SVGs$Elements$Carousel$dotMargin * 3),
					y)
				]));
	});
var $author$project$SVGs$Elements$Carousel$scrollLength = 235;
var $author$project$SVGs$Elements$Carousel$selectedWordSelectorByImageIndex = function (selectedImageIndex) {
	return 'word-' + ($elm$core$String$fromInt(1 + selectedImageIndex) + '-selected');
};
var $author$project$SVGs$Elements$Carousel$tileLength = 45;
var $author$project$SVGs$Elements$Carousel$wideTileLength = 75;
var $author$project$SVGs$Elements$Carousel$wordLength = function (kanaRecords) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (kanaRecord, totalLength) {
				return $author$project$Services$Kana$isYoonKana(kanaRecord) ? (totalLength + $author$project$SVGs$Elements$Carousel$wideTileLength) : (totalLength + $author$project$SVGs$Elements$Carousel$tileLength);
			}),
		0,
		kanaRecords);
};
var $author$project$SVGs$Elements$Carousel$wordsPadding = 20;
var $author$project$SVGs$Elements$Carousel$halfWordLength = function (kanaRecords) {
	return $elm$core$String$fromFloat(
		($author$project$SVGs$Elements$Carousel$wordLength(kanaRecords) + ($author$project$SVGs$Elements$Carousel$wordsPadding / 2)) / 2);
};
var $author$project$SVGs$Elements$Carousel$clipPathId = F2(
	function (name, strokeIndex) {
		return name + ('Stroke' + ($elm$core$String$fromInt(strokeIndex) + 'ClipPath'));
	});
var $author$project$SVGs$Elements$Carousel$solidPath = F4(
	function (pathString, name, currentStrokeIndex, strokeWidth) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke('rgb(0, 0, 0)'),
					$elm$svg$Svg$Attributes$clipPath(
					'url(#' + (A2($author$project$SVGs$Elements$Carousel$clipPathId, name, currentStrokeIndex) + ')')),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(strokeWidth)),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$d(pathString)
				]),
			_List_Nil);
	});
var $author$project$SVGs$Elements$Carousel$solidPathsInternal = F2(
	function (currentStrokeIndex, animatedKanaRecord) {
		var strokePathStringList = animatedKanaRecord.dp;
		var name = animatedKanaRecord.cV;
		if (strokePathStringList.b) {
			var _v1 = strokePathStringList.a;
			var pathString = _v1.a;
			var strokeWidth = _v1.c;
			var remainingStrings = strokePathStringList.b;
			return A2(
				$elm$core$List$cons,
				A4($author$project$SVGs$Elements$Carousel$solidPath, pathString, name, currentStrokeIndex, strokeWidth),
				A2(
					$author$project$SVGs$Elements$Carousel$solidPathsInternal,
					currentStrokeIndex + 1,
					_Utils_update(
						animatedKanaRecord,
						{dp: remainingStrings})));
		} else {
			return _List_Nil;
		}
	});
var $author$project$SVGs$Elements$Carousel$solidPaths = F2(
	function (attributes, animatedKanaRecord) {
		return A2(
			$elm$svg$Svg$g,
			attributes,
			A2($author$project$SVGs$Elements$Carousel$solidPathsInternal, 1, animatedKanaRecord));
	});
var $author$project$SVGs$Elements$Carousel$tileClickAttribute = F2(
	function (kanaRecord, attributes) {
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$Events$onClick(
				$author$project$Domain$Types$SoundMessage(
					A2(
						$author$project$Domain$Types$PlaySoundEffect,
						1,
						$elm$core$String$fromInt(kanaRecord.bB)))),
			attributes);
	});
var $author$project$SVGs$Elements$Carousel$kanaTileWithAudio = F4(
	function (xPositions, wordIndex, tileIndex, kanaRecord) {
		return A4(
			$author$project$SVGs$Elements$KanaBackgroundTile$kanaBackgroundTile,
			A2(
				$author$project$SVGs$Elements$Carousel$tileClickAttribute,
				kanaRecord,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x(
						$elm$core$String$fromFloat(
							($author$project$SVGs$Elements$Carousel$scrollLength * wordIndex) + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($author$project$Extras$List$elementAt, tileIndex, xPositions)))),
						$elm$svg$Svg$Attributes$class('kana-tile')
					])),
			_List_fromArray(
				[
					A2($author$project$SVGs$Elements$Carousel$solidPaths, _List_Nil, kanaRecord)
				]),
			false,
			kanaRecord.cV);
	});
var $author$project$Extras$List$lastElement = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$always),
	$elm$core$Maybe$Nothing);
var $author$project$SVGs$Elements$Carousel$tilePositions = function (kanaRecords) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (kanaRecord, xPositions) {
				return $author$project$Services$Kana$isYoonKana(kanaRecord) ? A2(
					$elm$core$List$append,
					xPositions,
					_List_fromArray(
						[
							$author$project$SVGs$Elements$Carousel$wideTileLength + A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Extras$List$lastElement(xPositions))
						])) : A2(
					$elm$core$List$append,
					xPositions,
					_List_fromArray(
						[
							$author$project$SVGs$Elements$Carousel$tileLength + A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Extras$List$lastElement(xPositions))
						]));
			}),
		_List_fromArray(
			[0]),
		kanaRecords);
};
var $author$project$SVGs$Elements$Carousel$wordTilesWithAudio = F2(
	function (index, kanaRecords) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('kana-word'),
					$elm$svg$Svg$Attributes$x('50%')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$style(
							'transform: translateX(-' + ($author$project$SVGs$Elements$Carousel$halfWordLength(kanaRecords) + 'px)'))
						]),
					A2(
						$elm$core$List$indexedMap,
						A2(
							$author$project$SVGs$Elements$Carousel$kanaTileWithAudio,
							$author$project$SVGs$Elements$Carousel$tilePositions(kanaRecords),
							index),
						kanaRecords))
				]));
	});
var $author$project$SVGs$Elements$Carousel$kanaTilesWithAudio = F2(
	function (selectedImageIndex, kanaStrings) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromInt($author$project$SVGs$Elements$Carousel$wordsPadding)),
					$elm$svg$Svg$Attributes$y('170'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat($author$project$SVGs$Elements$Carousel$scrollLength)),
					$elm$svg$Svg$Attributes$class('kana-words')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class(
							$author$project$SVGs$Elements$Carousel$selectedWordSelectorByImageIndex(selectedImageIndex))
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$SVGs$Elements$Carousel$wordTilesWithAudio,
						A2($elm$core$List$map, $author$project$Services$Kana$toAnimatedKanaList, kanaStrings)))
				]));
	});
var $author$project$SVGs$Elements$Carousel$carousel = F2(
	function (selectedImageIndex, kanaWords) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('carousel'),
					$elm$svg$Svg$Attributes$y('10')
				]),
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Carousel$arrowLeft,
					$author$project$SVGs$Elements$Carousel$arrowRight,
					A3($author$project$SVGs$Elements$Carousel$dots, selectedImageIndex, 110, 375),
					A2(
					$author$project$SVGs$Elements$Carousel$kanaTilesWithAudio,
					selectedImageIndex,
					A2(
						$elm$core$List$map,
						function (word) {
							return word.cH;
						},
						kanaWords))
				]));
	});
var $author$project$Domain$Types$ImageClicked = function (a) {
	return {$: 8, a: a};
};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$SVGs$Modals$PreviewLevel$imageURL = function (imageID) {
	return '../Images/KanaWords/' + ($elm$core$String$fromInt(imageID) + '.svg');
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$SVGs$Modals$PreviewLevel$image = function (imageID) {
	return A2(
		$elm$html$Html$object,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'data',
				$author$project$SVGs$Modals$PreviewLevel$imageURL(imageID)),
				$elm$html$Html$Attributes$type_('image/svg+xml'),
				$elm$html$Html$Attributes$width(200),
				$elm$html$Html$Attributes$height(200),
				$elm$svg$Svg$Attributes$class('svg-image'),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
			]),
		_List_Nil);
};
var $author$project$SVGs$Modals$PreviewLevel$imageFrame = A2(
	$elm$html$Html$object,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'data', '../Images/ImageMatchBorder.svg'),
			$elm$html$Html$Attributes$type_('image/svg+xml'),
			$elm$html$Html$Attributes$width(215),
			$elm$html$Html$Attributes$height(215),
			$elm$svg$Svg$Attributes$class('svg-image-frame')
		]),
	_List_Nil);
var $author$project$SVGs$Modals$PreviewLevel$imageLeftPosition = function (imageIndex) {
	return (imageIndex > 0) ? ('calc(' + ($elm$core$String$fromInt(imageIndex) + (' * var(--carousel-image-width) ' + ')'))) : '0px';
};
var $author$project$SVGs$Modals$PreviewLevel$speakerCircleDefinitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('circle-shadow'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('2.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('3'),
							$elm$svg$Svg$Attributes$dy('3'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(85, 85, 85)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Modals$PreviewLevel$speaker = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('20.625'),
			$elm$svg$Svg$Attributes$height('15'),
			$elm$svg$Svg$Attributes$viewBox('0 0 110 80'),
			$elm$svg$Svg$Attributes$id('image-speaker-icon')
		]),
	_List_fromArray(
		[
			$author$project$SVGs$Modals$PreviewLevel$speakerCircleDefinitions,
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$r('75'),
					$elm$svg$Svg$Attributes$cx('50'),
					$elm$svg$Svg$Attributes$cy('35'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('rgb(251, 251, 248)'),
					$elm$svg$Svg$Attributes$filter('url(#circle-shadow)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$fill('rgb(1, 117, 227)'),
					$elm$svg$Svg$Attributes$d('M 91.58,74.22 C 93.1,75.34 95.25,74.9 96.42,73.15 103.25,63.53 107.06,50.93 107.06,37.75 107.06,24.56 103.11,12.01 96.42,2.35 95.25,0.54 93.1,0.15 91.58,1.27 89.97,2.39 89.73,4.45 90.95,6.25 96.86,14.8 100.37,25.98 100.37,37.75 100.37,49.46 96.86,60.74 90.95,69.24 89.73,71.05 89.97,73.1 91.58,74.22 Z M 44.22,71.97 C 46.91,71.97 48.96,70.02 48.96,67.29 L 48.96,8.55 C 48.96,5.86 46.91,3.62 44.12,3.62 42.17,3.62 40.85,4.45 38.66,6.54 L 22.59,21.49 C 22.4,21.68 22.1,21.83 21.81,21.83 L 11.12,21.83 C 5.5,21.83 2.62,24.71 2.62,30.76 L 2.62,44.87 C 2.62,50.88 5.5,53.81 11.12,53.81 L 21.81,53.81 C 22.1,53.81 22.4,53.91 22.59,54.1 L 38.66,69.34 C 40.66,71.19 42.27,71.97 44.22,71.97 Z M 76.79,64.11 C 78.4,65.19 80.4,64.85 81.58,63.14 86.46,56.35 89.29,47.12 89.29,37.75 89.29,28.37 86.51,19.04 81.58,12.36 80.4,10.65 78.4,10.3 76.79,11.38 75.18,12.45 74.89,14.5 76.16,16.31 80.21,22.07 82.5,29.84 82.5,37.75 82.5,45.66 80.11,53.37 76.16,59.18 74.93,60.99 75.18,63.04 76.79,64.11 Z M 62.09,54.2 C 63.56,55.18 65.61,54.88 66.78,53.18 69.71,49.27 71.42,43.51 71.42,37.75 71.42,31.98 69.71,26.27 66.78,22.32 65.61,20.61 63.56,20.31 62.09,21.34 60.34,22.56 60.04,24.71 61.41,26.52 63.46,29.3 64.63,33.55 64.63,37.75 64.63,41.95 63.41,46.14 61.41,48.98 60.09,50.83 60.34,52.93 62.09,54.2 Z M 62.09,54.2')
				]),
			_List_Nil)
		]));
var $author$project$SVGs$Modals$PreviewLevel$imageMatchImage = F2(
	function (index, imageID) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'width', '215px'),
					A2($elm$html$Html$Attributes$style, 'height', '215px'),
					$elm$html$Html$Events$onClick(
					$author$project$Domain$Types$ModalMessage(
						$author$project$Domain$Types$ImageClicked(imageID))),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$author$project$SVGs$Modals$PreviewLevel$imageLeftPosition(index))
				]),
			_List_fromArray(
				[
					$author$project$SVGs$Modals$PreviewLevel$imageFrame,
					$author$project$SVGs$Modals$PreviewLevel$image(imageID),
					$author$project$SVGs$Modals$PreviewLevel$speaker
				]));
	});
var $author$project$SVGs$Modals$PreviewLevel$selectedImageSelectorByImageIndex = function (selectedImageIndex) {
	return $elm$svg$Svg$Attributes$class(
		'image-' + ($elm$core$String$fromInt(1 + selectedImageIndex) + '-selected'));
};
var $author$project$SVGs$Modals$PreviewLevel$imageMatchImages = F2(
	function (selectedImageIndex, imageIDs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2($elm$html$Html$Attributes$style, 'top', '318.5px'),
					A2($elm$html$Html$Attributes$style, 'z-index', '100'),
					A2($elm$html$Html$Attributes$style, 'width', '215px'),
					A2($elm$html$Html$Attributes$style, 'height', '215px'),
					A2($elm$html$Html$Attributes$style, 'left', 'calc(50% - 5px)'),
					A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-50%)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('image-group'),
							$author$project$SVGs$Modals$PreviewLevel$selectedImageSelectorByImageIndex(selectedImageIndex)
						]),
					A2($elm$core$List$indexedMap, $author$project$SVGs$Modals$PreviewLevel$imageMatchImage, imageIDs))
				]));
	});
var $author$project$SVGs$Modals$PreviewLevel$levelLabel = function (levelNumber) {
	return A3(
		$elm$svg$Svg$node,
		'text',
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(39, 90, 80)'),
				$elm$svg$Svg$Attributes$fontFamily('Josefin Sans, sans-serif'),
				$elm$svg$Svg$Attributes$fontWeight('100'),
				$elm$svg$Svg$Attributes$fontSize('30'),
				$elm$svg$Svg$Attributes$textAnchor('middle'),
				$elm$svg$Svg$Attributes$class('level-label')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$tspan,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('140'),
						$elm$svg$Svg$Attributes$y('75')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(
						'Level ' + $elm$core$String$fromInt(levelNumber))
					]))
			]));
};
var $author$project$Domain$Types$PlayLevelClicked = {$: 2};
var $author$project$SVGs$Elements$Button$playButtonTriangle = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fillRule('evenodd'),
			$elm$svg$Svg$Attributes$stroke('rgb(255, 255, 255)'),
			$elm$svg$Svg$Attributes$strokeWidth('3'),
			$elm$svg$Svg$Attributes$strokeLinecap('round'),
			$elm$svg$Svg$Attributes$strokeLinejoin('round'),
			$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
			$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
			$elm$svg$Svg$Attributes$d('M 118.65,29.5 L 98.65,39.5 98.65,19.5 118.65,29.5 Z M 118.65,29.5')
		]),
	_List_Nil);
var $author$project$SVGs$Elements$Button$playButton = function (buttonAttributes) {
	return A3(
		$author$project$SVGs$Elements$Button$modalButton,
		buttonAttributes,
		$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$PlayLevelClicked),
		_List_fromArray(
			[$author$project$SVGs$Elements$Button$playButtonTriangle]));
};
var $author$project$SVGs$Elements$StarBanner$One = 1;
var $author$project$SVGs$Elements$StarBanner$Three = 3;
var $author$project$SVGs$Elements$StarBanner$Two = 2;
var $author$project$Services$Score$scoreToNumberOfStars = F2(
	function (score, _v0) {
		var oneStarScore = _v0.c$;
		var twoStarScore = _v0.dE;
		var threeStarScore = _v0.du;
		return (_Utils_cmp(score, threeStarScore) > -1) ? 3 : ((_Utils_cmp(score, twoStarScore) > -1) ? 2 : ((_Utils_cmp(score, oneStarScore) > -1) ? 1 : 0));
	});
var $author$project$SVGs$Elements$StarBanner$bannerDefinitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasBannerDrawing-gradient2-rectangle'),
					$elm$svg$Svg$Attributes$x1('41.57'),
					$elm$svg$Svg$Attributes$y1('32.2'),
					$elm$svg$Svg$Attributes$x2('232.07'),
					$elm$svg$Svg$Attributes$y2('32.2'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(122, 189, 144)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.3'),
							$elm$svg$Svg$Attributes$stopColor('rgb(133, 195, 146)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.5'),
							$elm$svg$Svg$Attributes$stopColor('rgb(145, 202, 147)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0.99'),
							$elm$svg$Svg$Attributes$stopColor('rgb(122, 189, 144)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$filter,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvasBannerDrawing-starShadow-outer'),
					$elm$svg$Svg$Attributes$filterUnits('objectBoundingBox')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$feGaussianBlur,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$stdDeviation('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feOffset,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$dx('0'),
							$elm$svg$Svg$Attributes$dy('3'),
							$elm$svg$Svg$Attributes$result('blur')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feFlood,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$floodColor('rgb(0, 0, 0)'),
							$elm$svg$Svg$Attributes$floodOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in2('blur'),
							$elm$svg$Svg$Attributes$operator('in'),
							$elm$svg$Svg$Attributes$result('colorShadow')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$feComposite,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$in_('SourceGraphic'),
							$elm$svg$Svg$Attributes$in2('colorShadow'),
							$elm$svg$Svg$Attributes$operator('over')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Elements$StarBanner$bannerBackground = _List_fromArray(
	[
		$author$project$SVGs$Elements$StarBanner$bannerDefinitions,
		A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-bezier2'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(85, 170, 144)'),
				$elm$svg$Svg$Attributes$d('M 222.48,66.9 L 264.5,66.9 247.92,44.52 264.5,20.4 222.48,20.4 222.48,66.9 Z M 222.48,66.9')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-rectangle5'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(78, 141, 116)'),
				$elm$svg$Svg$Attributes$x('222.5'),
				$elm$svg$Svg$Attributes$y('20.5'),
				$elm$svg$Svg$Attributes$width('19'),
				$elm$svg$Svg$Attributes$height('46.5')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-bezier'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(49, 104, 90)'),
				$elm$svg$Svg$Attributes$d('M 233.72,55.83 L 222.48,66.9 222.73,55.83 233.72,55.83 Z M 233.72,55.83')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-bezier5'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(85, 170, 144)'),
				$elm$svg$Svg$Attributes$d('M 51.52,66.9 L 9.5,66.9 26.08,44.52 9.5,20.4 51.52,20.4 51.52,66.9 Z M 51.52,66.9')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-rectangle4'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(78, 141, 116)'),
				$elm$svg$Svg$Attributes$x('34'),
				$elm$svg$Svg$Attributes$y('20.5'),
				$elm$svg$Svg$Attributes$width('17'),
				$elm$svg$Svg$Attributes$height('46')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-bezier12'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(49, 104, 90)'),
				$elm$svg$Svg$Attributes$d('M 40.28,55.83 L 51.52,66.9 51.27,55.83 40.28,55.83 Z M 40.28,55.83')
			]),
		_List_Nil),
		A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasBannerDrawing-rectangle'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('url(#canvasBannerDrawing-gradient2-rectangle)'),
				$elm$svg$Svg$Attributes$x('40'),
				$elm$svg$Svg$Attributes$y('9'),
				$elm$svg$Svg$Attributes$width('194'),
				$elm$svg$Svg$Attributes$height('46.4')
			]),
		_List_Nil)
	]);
var $author$project$SVGs$Elements$StarBanner$bannerScore = F2(
	function (score, svgs) {
		if (!score.$) {
			var value = score.a;
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvasBannerDrawing-rectangle2'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(71, 148, 129)'),
							$elm$svg$Svg$Attributes$d('M 65,87 C 65,89.76 67.24,92 70,92 L 204,92 C 206.76,92 209,89.76 209,87 L 209,53 65,53 Z M 65,87')
						]),
					_List_Nil),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('canvasBannerDrawing-rectangle3'),
								$elm$svg$Svg$Attributes$stroke('none'),
								$elm$svg$Svg$Attributes$fill('rgb(49, 104, 90)'),
								$elm$svg$Svg$Attributes$d('M 65,60 L 209,60 209,49 C 209,46.24 206.76,44 204,44 L 70,44 C 67.24,44 65,46.24 65,49 Z M 65,60')
							]),
						_List_Nil),
					A2(
						$elm$core$List$cons,
						A3(
							$elm$svg$Svg$node,
							'text',
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
									$elm$svg$Svg$Attributes$fontFamily('Josefin Sans, sans-serif'),
									$elm$svg$Svg$Attributes$fontSize('17'),
									$elm$svg$Svg$Attributes$x('123'),
									$elm$svg$Svg$Attributes$y('60'),
									$elm$svg$Svg$Attributes$textAnchor('middle')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$tspan,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$x('140'),
											$elm$svg$Svg$Attributes$y('82')
										]),
									_List_fromArray(
										[
											$elm$svg$Svg$text(
											$elm$core$String$fromInt(value))
										]))
								])),
						svgs)));
		} else {
			return svgs;
		}
	});
var $author$project$SVGs$Elements$StarBanner$StarAttributes = F3(
	function (translateX, translateY, scale) {
		return {ap: scale, bf: translateX, bg: translateY};
	});
var $author$project$Extras$Svg$translateAndScaleString = F3(
	function (translateX, translateY, scale) {
		return 'translate(' + ($elm$core$String$fromFloat(translateX) + (', ' + ($elm$core$String$fromFloat(translateY) + (') ' + ('scale(' + ($elm$core$String$fromFloat(scale) + (', ' + ($elm$core$String$fromFloat(scale) + ')'))))))));
	});
var $author$project$Extras$Svg$translateAndScaleAttribute = F3(
	function (translateX, translateY, scale) {
		return $elm$svg$Svg$Attributes$transform(
			A3($author$project$Extras$Svg$translateAndScaleString, translateX, translateY, scale));
	});
var $author$project$SVGs$Elements$StarBanner$bannerBackgroundStar = function (_v0) {
	var translateX = _v0.bf;
	var translateY = _v0.bg;
	var scale = _v0.ap;
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$elm$svg$Svg$Attributes$fill('rgb(78, 141, 116)'),
				$elm$svg$Svg$Attributes$fillOpacity('0.41'),
				A3($author$project$Extras$Svg$translateAndScaleAttribute, translateX, translateY, scale),
				$elm$svg$Svg$Attributes$d('M 25.07,0.56 L 32.67,15.95 49.5,18.49 37.36,30.54 40.17,47.5 25.07,39.57 9.97,47.5 12.78,30.54 0.64,18.49 17.47,15.95 25.07,0.56 Z M 25.07,0.56')
			]),
		_List_Nil);
};
var $author$project$SVGs$Elements$StarBanner$backgroundStarOne = $author$project$SVGs$Elements$StarBanner$bannerBackgroundStar(
	A3($author$project$SVGs$Elements$StarBanner$StarAttributes, 0, 0, 0.64));
var $author$project$SVGs$Elements$StarBanner$backgroundStarThree = $author$project$SVGs$Elements$StarBanner$bannerBackgroundStar(
	A3($author$project$SVGs$Elements$StarBanner$StarAttributes, 90, 0, 0.64));
var $author$project$SVGs$Elements$StarBanner$backgroundStarTwo = $author$project$SVGs$Elements$StarBanner$bannerBackgroundStar(
	A3($author$project$SVGs$Elements$StarBanner$StarAttributes, 45, 0, 0.64));
var $author$project$SVGs$Elements$StarBanner$bannerStar = F3(
	function (hasStar, _v0, svgs) {
		var translateX = _v0.bf;
		var translateY = _v0.bg;
		var scale = _v0.ap;
		return hasStar ? A2(
			$author$project$Extras$List$appendElement,
			A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
						$elm$svg$Svg$Attributes$transform('scale(0.64, 0.64)'),
						A3($author$project$Extras$Svg$translateAndScaleAttribute, translateX, translateY, scale),
						$elm$svg$Svg$Attributes$filter('url(#canvasBannerDrawing-starShadow-outer)'),
						$elm$svg$Svg$Attributes$d('M 25.06,0.56 L 32.65,15.84 49.47,18.36 37.34,30.33 40.14,47.17 25.06,39.29 9.97,47.17 12.77,30.33 0.64,18.36 17.46,15.84 25.06,0.56 Z M 25.06,0.56')
					]),
				_List_Nil),
			svgs) : svgs;
	});
var $author$project$SVGs$Elements$StarBanner$hasOneStar = function (stars) {
	return (stars === 1) || ((stars === 2) || (stars === 3));
};
var $author$project$SVGs$Elements$StarBanner$starOne = function (stars) {
	return A2(
		$author$project$SVGs$Elements$StarBanner$bannerStar,
		$author$project$SVGs$Elements$StarBanner$hasOneStar(stars),
		A3($author$project$SVGs$Elements$StarBanner$StarAttributes, 0, 0, 0.64));
};
var $author$project$SVGs$Elements$StarBanner$hasThreeStars = function (stars) {
	return stars === 3;
};
var $author$project$SVGs$Elements$StarBanner$starThree = function (stars) {
	return A2(
		$author$project$SVGs$Elements$StarBanner$bannerStar,
		$author$project$SVGs$Elements$StarBanner$hasThreeStars(stars),
		A3($author$project$SVGs$Elements$StarBanner$StarAttributes, 90, 0, 0.64));
};
var $author$project$SVGs$Elements$StarBanner$hasTwoStars = function (stars) {
	return (stars === 2) || (stars === 3);
};
var $author$project$SVGs$Elements$StarBanner$starTwo = function (stars) {
	return A2(
		$author$project$SVGs$Elements$StarBanner$bannerStar,
		$author$project$SVGs$Elements$StarBanner$hasTwoStars(stars),
		A3($author$project$SVGs$Elements$StarBanner$StarAttributes, 45, 0, 0.64));
};
var $author$project$SVGs$Elements$StarBanner$bannerStars = function (stars) {
	return _List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$transform('translate(77, 15)')
				]),
			A2(
				$author$project$SVGs$Elements$StarBanner$starThree,
				stars,
				A2(
					$author$project$SVGs$Elements$StarBanner$starTwo,
					stars,
					A2(
						$author$project$SVGs$Elements$StarBanner$starOne,
						stars,
						_List_fromArray(
							[$author$project$SVGs$Elements$StarBanner$backgroundStarOne, $author$project$SVGs$Elements$StarBanner$backgroundStarTwo, $author$project$SVGs$Elements$StarBanner$backgroundStarThree])))))
		]);
};
var $author$project$SVGs$Elements$StarBanner$starBanner = function (_v0) {
	var score = _v0.da;
	var stars = _v0.a9;
	var x = _v0.bl;
	var y = _v0.bm;
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(x)),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(y)),
				$elm$svg$Svg$Attributes$width('250'),
				$elm$svg$Svg$Attributes$height('100'),
				$elm$svg$Svg$Attributes$id('starBanner'),
				$elm$svg$Svg$Attributes$viewBox('0 0 275 100')
			]),
		A2(
			$author$project$SVGs$Elements$StarBanner$bannerScore,
			score,
			_Utils_ap(
				$author$project$SVGs$Elements$StarBanner$bannerBackground,
				$author$project$SVGs$Elements$StarBanner$bannerStars(stars))));
};
var $author$project$SVGs$Modals$PreviewLevel$previewLevel = function (_v0) {
	var modals = _v0.cQ;
	var level = _v0.cK;
	var randomSeeds = _v0.c4;
	var score = _v0.da;
	return $author$project$SVGs$Modals$Modal$modal(
		A7(
			$author$project$SVGs$Modals$Modal$Modal,
			'previewLevelModal',
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$LevelPreviewCloseClicked),
			modals.cM.aO,
			460,
			A4($author$project$Extras$Svg$ViewBox, 0, 0, '275', '480'),
			_List_fromArray(
				[
					$author$project$SVGs$Modals$PreviewLevel$levelLabel(level.cp),
					$author$project$SVGs$Elements$StarBanner$starBanner(
					A4(
						$author$project$SVGs$Elements$StarBanner$BannerAttributes,
						score.cn,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$andThen,
								function (scoreValue) {
									return $elm$core$Maybe$Just(
										A2($author$project$Services$Score$scoreToNumberOfStars, scoreValue, level));
								},
								score.cn)),
						12,
						80)),
					$author$project$SVGs$Elements$Button$playButton(
					A4($author$project$SVGs$Elements$Button$ButtonAttributes, 30, 395, 220, 60)),
					A2(
					$author$project$SVGs$Elements$Carousel$carousel,
					modals.cM.cr,
					A2($author$project$Extras$List$shuffle, randomSeeds.cJ, level.cI))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$SVGs$Modals$PreviewLevel$imageMatchImages,
					modals.cM.cr,
					A2(
						$elm$core$List$map,
						function (kanaword) {
							return kanaword.cp;
						},
						A2($author$project$Extras$List$shuffle, randomSeeds.cJ, level.cI)))
				])));
};
var $author$project$SVGs$Elements$SelectedBoardItem$coordinatesToSelector = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return 'selected-board-item' + (' row' + ($elm$core$String$fromInt(row) + (' column' + $elm$core$String$fromInt(column))));
};
var $author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemAttributes = function (coordinates) {
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$class(
			$author$project$SVGs$Elements$SelectedBoardItem$coordinatesToSelector(coordinates)),
			$elm$svg$Svg$Attributes$viewBox('0 0 100 100')
		]);
};
var $author$project$SVGs$Elements$SelectedBoardItem$fill = $elm$svg$Svg$Attributes$fill('none');
var $author$project$SVGs$Elements$SelectedBoardItem$strokeColor = $elm$svg$Svg$Attributes$stroke('#FF00FF');
var $author$project$SVGs$Elements$SelectedBoardItem$strokeLinejoin = $elm$svg$Svg$Attributes$strokeLinejoin('round');
var $author$project$SVGs$Elements$SelectedBoardItem$strokeMiterlimit = $elm$svg$Svg$Attributes$strokeMiterlimit('10');
var $author$project$SVGs$Elements$SelectedBoardItem$strokeWidth = $elm$svg$Svg$Attributes$strokeWidth('5');
var $author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPath = function (stroke) {
	return A2(
		$elm$svg$Svg$path,
		A2(
			$author$project$Extras$List$appendElement,
			$elm$svg$Svg$Attributes$d(stroke),
			_List_fromArray(
				[$author$project$SVGs$Elements$SelectedBoardItem$strokeColor, $author$project$SVGs$Elements$SelectedBoardItem$strokeWidth, $author$project$SVGs$Elements$SelectedBoardItem$strokeLinejoin, $author$project$SVGs$Elements$SelectedBoardItem$strokeMiterlimit, $author$project$SVGs$Elements$SelectedBoardItem$fill])),
		_List_Nil);
};
var $author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPaths = _List_fromArray(
	[
		$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPath('M 9,8 C 12.75,4.25 27.28,4 19,4 10.72,4 4,10.72 4,19 4,27.28 5.25,11.75 9,8 Z M 9,8'),
		$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPath('M 91.01,8 C 87.26,4.25 72.73,4 81.01,4 89.3,4 96.01,10.72 96.01,19 96.01,27.28 94.76,11.75 91.01,8 Z M 91.01,8'),
		$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPath('M 91.01,91.4 C 87.26,95.15 72.73,95.4 81.01,95.4 89.3,95.4 96.01,88.68 96.01,80.4 96.01,72.11 94.76,87.65 91.01,91.4 Z M 91.01,91.4'),
		$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPath('M 9,91.4 C 12.75,95.15 27.28,95.4 19,95.4 10.72,95.4 4,88.68 4,80.4 4,72.11 5.25,87.65 9,91.4 Z M 9,91.4')
	]);
var $author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItem = function (coordinates) {
	return A2(
		$elm$svg$Svg$svg,
		$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemAttributes(coordinates),
		$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItemPaths);
};
var $author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItems = function (model) {
	return A3(
		$author$project$Services$Matrix$foldLeft,
		F3(
			function (coordinates, selectedItemsList, tile) {
				return A3(
					$author$project$Extras$List$appendElementIf,
					(tile === 1) && _Utils_eq(
						model.ds.cd,
						$elm$core$Maybe$Just(coordinates)),
					$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItem(coordinates),
					selectedItemsList);
			}),
		_List_Nil,
		model.cK.dw);
};
var $author$project$View$selectedItemLayer = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('selectedItemsContainer'),
						$author$project$Services$CssSelector$opacity(model.by === 5)
					]),
				$author$project$SVGs$Elements$SelectedBoardItem$selectedBoardItems(model)),
			viewElements);
	});
var $author$project$Domain$Types$SettingsCloseClicked = {$: 11};
var $author$project$Domain$Types$SettingsOkClicked = {$: 6};
var $author$project$SVGs$Elements$Button$okButton = F2(
	function (message, buttonAttributes) {
		return A3(
			$author$project$SVGs$Elements$Button$modalButton,
			buttonAttributes,
			message,
			_List_fromArray(
				[
					$author$project$SVGs$Elements$Button$buttonText('Ok')
				]));
	});
var $author$project$Domain$Types$SettingToggled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Types$SoundEffects = 0;
var $author$project$SVGs$Modals$Settings$toggleAnimationDuration = 0.25;
var $author$project$SVGs$Modals$Settings$toggleAnimationDurationString = ' ' + ($elm$core$String$fromFloat($author$project$SVGs$Modals$Settings$toggleAnimationDuration) + 's');
var $author$project$SVGs$Modals$Settings$toggleBackgroundColor = function (enabled) {
	return enabled ? 'rgb(60, 171, 72)' : 'rgb(218, 56, 54)';
};
var $author$project$SVGs$Modals$Settings$toggleButtonBackground = function (enabled) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill(
				$author$project$SVGs$Modals$Settings$toggleBackgroundColor(enabled)),
				$elm$svg$Svg$Attributes$style('transition: fill' + ($author$project$SVGs$Modals$Settings$toggleAnimationDurationString + ' ease;')),
				$elm$svg$Svg$Attributes$d('M 72.64,45.68 L 26.69,45.68 C 15.26,45.68 6,36.57 6,25.34 6,14.11 15.26,5 26.69,5 L 72.64,5 C 84.07,5 93.33,14.11 93.33,25.34 93.33,36.57 84.07,45.68 72.64,45.68 Z M 72.64,45.68')
			]),
		_List_Nil);
};
var $author$project$SVGs$Modals$Settings$toggleCirclePosition = function (enabled) {
	return enabled ? '70.9' : '28.05';
};
var $author$project$SVGs$Modals$Settings$toggleButtonCircle = function (enabled) {
	return A2(
		$elm$svg$Svg$circle,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(255, 255, 254)'),
				$elm$svg$Svg$Attributes$cy('25.33'),
				$elm$svg$Svg$Attributes$r('16'),
				$elm$svg$Svg$Attributes$cx(
				$author$project$SVGs$Modals$Settings$toggleCirclePosition(enabled)),
				$elm$svg$Svg$Attributes$style('transition: cx' + ($author$project$SVGs$Modals$Settings$toggleAnimationDurationString + ' ease;'))
			]),
		_List_Nil);
};
var $author$project$SVGs$Modals$Settings$toggleTextLabel = function (text) {
	return A3(
		$elm$svg$Svg$node,
		'text',
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
				$elm$svg$Svg$Attributes$fontFamily('Josefin Sans, sans-serif'),
				$elm$svg$Svg$Attributes$fontSize('32'),
				$elm$svg$Svg$Attributes$textAnchor('start')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$tspan,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('-225'),
						$elm$svg$Svg$Attributes$y('35')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text(text)
					]))
			]));
};
var $author$project$SVGs$Modals$Settings$toggleButton = F4(
	function (labelText, onClickMessage, enabled, buttonAttributes) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(buttonAttributes.bk)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(buttonAttributes.aE)),
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(buttonAttributes.bl)),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromFloat(buttonAttributes.bm)),
					$elm$svg$Svg$Attributes$viewBox('0 0 100 50'),
					$elm$svg$Svg$Attributes$style('cursor: pointer; overflow: visible;'),
					$elm$svg$Svg$Events$onClick(onClickMessage)
				]),
			_List_fromArray(
				[
					$author$project$SVGs$Modals$Settings$toggleButtonBackground(enabled),
					$author$project$SVGs$Modals$Settings$toggleButtonCircle(enabled),
					$author$project$SVGs$Modals$Settings$toggleTextLabel(labelText)
				]));
	});
var $author$project$SVGs$Modals$Settings$soundEffectsToggle = function (model) {
	return A4(
		$author$project$SVGs$Modals$Settings$toggleButton,
		'Sound Effects:',
		$author$project$Domain$Types$LocalStorageMessage(
			$author$project$Domain$Types$SettingToggled(0)),
		model.de.a8,
		A4($author$project$SVGs$Elements$Button$ButtonAttributes, 180, 100, 60, 30));
};
var $author$project$Domain$Types$TextAudio = 2;
var $author$project$SVGs$Modals$Settings$textAudioToggle = function (model) {
	return A4(
		$author$project$SVGs$Modals$Settings$toggleButton,
		'Text Audio:',
		$author$project$Domain$Types$LocalStorageMessage(
			$author$project$Domain$Types$SettingToggled(2)),
		model.de.bd,
		A4($author$project$SVGs$Elements$Button$ButtonAttributes, 180, 140, 60, 30));
};
var $author$project$SVGs$Modals$Settings$title = A3(
	$elm$svg$Svg$node,
	'text',
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('rgb(39, 90, 80)'),
			$elm$svg$Svg$Attributes$fontSize('32'),
			$elm$svg$Svg$Attributes$textAnchor('middle')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$tspan,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('50%'),
					$elm$svg$Svg$Attributes$y('75')
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text('Settings')
				]))
		]));
var $author$project$SVGs$Modals$Settings$settings = function (model) {
	var modals = model.cQ;
	return $author$project$SVGs$Modals$Modal$modal(
		A7(
			$author$project$SVGs$Modals$Modal$Modal,
			'settingsModal',
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$SettingsCloseClicked),
			modals.df,
			325,
			A4($author$project$Extras$Svg$ViewBox, 0, 0, '275', '300'),
			_List_fromArray(
				[
					$author$project$SVGs$Modals$Settings$title,
					$author$project$SVGs$Modals$Settings$soundEffectsToggle(model),
					$author$project$SVGs$Modals$Settings$textAudioToggle(model),
					A2(
					$author$project$SVGs$Elements$Button$okButton,
					$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$SettingsOkClicked),
					A4($author$project$SVGs$Elements$Button$ButtonAttributes, 30, 260, 220, 60))
				]),
			_List_Nil));
};
var $author$project$Services$CssSelector$shrinkAnimationSelector = $elm$svg$Svg$Attributes$class('shrink-animation');
var $author$project$Services$Shape$shrinkAttributes = F2(
	function (viewBox, _v0) {
		var coordinates = _v0.aw;
		var _v1 = coordinates;
		var rowIndex = _v1.a;
		var columnIndex = _v1.b;
		return _List_fromArray(
			[
				$author$project$Extras$Svg$viewBoxAttribute(viewBox),
				$author$project$Services$CssSelector$boardItemSelector,
				$author$project$Services$CssSelector$shrinkAnimationSelector,
				$author$project$Services$CssSelector$rowToSelector(rowIndex),
				$author$project$Services$CssSelector$columnToSelector(columnIndex)
			]);
	});
var $author$project$Services$SVGConversion$shrinkingBoardItemToHtml = function (boardItem) {
	return $elm$core$Array$toList(
		A3(
			$author$project$Services$SVGConversion$generateBoardItemHtml,
			boardItem,
			$elm$core$Basics$always(true),
			$elm$core$Basics$always(
				A2($author$project$Services$Shape$shrinkAttributes, $author$project$Services$Shape$boardItemViewBox, boardItem))));
};
var $author$project$View$shrinkingKanaLayer = F2(
	function (model, viewElements) {
		var shrinkingBoardItems = model.dg;
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('shrinkingBoardItems')
					]),
				A2($elm$core$List$concatMap, $author$project$Services$SVGConversion$shrinkingBoardItemToHtml, shrinkingBoardItems)),
			viewElements);
	});
var $author$project$Services$Dimensions$tileWidthAndHeight = 'var(--tileWidthAndHeight)';
var $author$project$SVGs$Tiles$Tile$maskRectAtCoordiantes = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('tile-mask-rect'),
				$elm$svg$Svg$Attributes$style(
				'transform: translate(calc(' + ($elm$core$String$fromInt(column) + (' * ' + ($author$project$Services$Dimensions$tileWidthAndHeight + ('), ' + ('calc(' + ($elm$core$String$fromInt(row) + (' * ' + ($author$project$Services$Dimensions$tileWidthAndHeight + '));')))))))))
			]),
		_List_Nil);
};
var $author$project$SVGs$Tiles$Tile$rectMaskByTiles = function (tiles) {
	return A3(
		$author$project$Services$Matrix$foldLeft,
		F3(
			function (coordinates, polygonList, tile) {
				return (tile === 1) ? A2(
					$elm$core$List$cons,
					$author$project$SVGs$Tiles$Tile$maskRectAtCoordiantes(coordinates),
					polygonList) : polygonList;
			}),
		_List_Nil,
		tiles);
};
var $author$project$SVGs$Tiles$Tile$tileMask = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('tileMaskContainer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$clipPath,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('tileMask')
									]),
								$author$project$SVGs$Tiles$Tile$rectMaskByTiles(model.cK.dw))
							]))
					])),
			viewElements);
	});
var $author$project$Domain$Types$Tile = F2(
	function (coordinates, tileType) {
		return {aw: coordinates, dv: tileType};
	});
var $author$project$Domain$Types$Dark = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Types$Empty = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Domain$Types$Light = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Types$Border = F4(
	function (hasTopBorder, hasBottomBorder, hasLeftBorder, hasRightBorder) {
		return {ci: hasBottomBorder, cj: hasLeftBorder, ck: hasRightBorder, cl: hasTopBorder};
	});
var $author$project$Domain$Types$Bottom = 2;
var $author$project$Services$Tile$hasBorder = F3(
	function (tiles, coordinates, direction) {
		switch (direction) {
			case 1:
				return A2(
					$author$project$Services$Tile$hasTileAtCoordinates,
					$author$project$Services$Matrix$leftOf(coordinates),
					tiles);
			case 3:
				return A2(
					$author$project$Services$Tile$hasTileAtCoordinates,
					$author$project$Services$Matrix$rightOf(coordinates),
					tiles);
			case 0:
				return A2(
					$author$project$Services$Tile$hasTileAtCoordinates,
					$author$project$Services$Matrix$above(coordinates),
					tiles);
			default:
				return A2(
					$author$project$Services$Tile$hasTileAtCoordinates,
					$author$project$Services$Matrix$below(coordinates),
					tiles);
		}
	});
var $author$project$Services$Tile$hasBottomBorder = F2(
	function (coordinates, tiles) {
		return A3($author$project$Services$Tile$hasBorder, tiles, coordinates, 2);
	});
var $author$project$Domain$Types$Left = 1;
var $author$project$Services$Tile$hasLeftBorder = F2(
	function (coordinates, tiles) {
		return A3($author$project$Services$Tile$hasBorder, tiles, coordinates, 1);
	});
var $author$project$Domain$Types$Right = 3;
var $author$project$Services$Tile$hasRightBorder = F2(
	function (coordinates, tiles) {
		return A3($author$project$Services$Tile$hasBorder, tiles, coordinates, 3);
	});
var $author$project$Domain$Types$Top = 0;
var $author$project$Services$Tile$hasTopBorder = F2(
	function (coordinates, tiles) {
		return A3($author$project$Services$Tile$hasBorder, tiles, coordinates, 0);
	});
var $author$project$Services$Tile$getBorder = F2(
	function (tiles, coordinates) {
		return A4(
			$author$project$Domain$Types$Border,
			A2($author$project$Services$Tile$hasTopBorder, coordinates, tiles),
			A2($author$project$Services$Tile$hasBottomBorder, coordinates, tiles),
			A2($author$project$Services$Tile$hasLeftBorder, coordinates, tiles),
			A2($author$project$Services$Tile$hasRightBorder, coordinates, tiles));
	});
var $author$project$Domain$Types$Corners = F4(
	function (topLeftCorner, topRightCorner, bottomLeftCorner, bottomRightCorner) {
		return {bK: bottomLeftCorner, bL: bottomRightCorner, dA: topLeftCorner, dB: topRightCorner};
	});
var $author$project$Domain$Types$None = 3;
var $author$project$Domain$Types$Outer = 2;
var $author$project$Domain$Types$InnerDark = 0;
var $author$project$Domain$Types$InnerLight = 1;
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Services$Tile$getInnerCornerType = function (_v0) {
	var row = _v0.a;
	var column = _v0.b;
	return (!A2($elm$core$Basics$modBy, 2, row + column)) ? 1 : 0;
};
var $author$project$Services$Tile$getCorner = F4(
	function (coordinates, tiles, hasOuterCornerFunction, hasInnerCornerFunction) {
		return A2(hasOuterCornerFunction, coordinates, tiles) ? 2 : (A2(hasInnerCornerFunction, coordinates, tiles) ? $author$project$Services$Tile$getInnerCornerType(coordinates) : 3);
	});
var $author$project$Services$Tile$hasBottomLeftInnerCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$below(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$leftOf(coordinates),
			tiles);
	});
var $author$project$Services$Tile$bottomLeftOf = A2($elm$core$Basics$composeR, $author$project$Services$Matrix$below, $author$project$Services$Matrix$leftOf);
var $author$project$Services$Tile$hasBottomLeftOuterCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Tile$bottomLeftOf(coordinates),
			tiles) && (A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$leftOf(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$below(coordinates),
			tiles));
	});
var $author$project$Services$Tile$getBottomLeftCorner = F2(
	function (coordinates, tiles) {
		return A4($author$project$Services$Tile$getCorner, coordinates, tiles, $author$project$Services$Tile$hasBottomLeftOuterCorner, $author$project$Services$Tile$hasBottomLeftInnerCorner);
	});
var $author$project$Services$Tile$hasBottomRightInnerCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$below(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$rightOf(coordinates),
			tiles);
	});
var $author$project$Services$Tile$bottomRightOf = A2($elm$core$Basics$composeR, $author$project$Services$Matrix$below, $author$project$Services$Matrix$rightOf);
var $author$project$Services$Tile$hasBottomRightOuterCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Tile$bottomRightOf(coordinates),
			tiles) && (A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$rightOf(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$below(coordinates),
			tiles));
	});
var $author$project$Services$Tile$getBottomRightCorner = F2(
	function (coordinates, tiles) {
		return A4($author$project$Services$Tile$getCorner, coordinates, tiles, $author$project$Services$Tile$hasBottomRightOuterCorner, $author$project$Services$Tile$hasBottomRightInnerCorner);
	});
var $author$project$Services$Tile$hasTopLeftInnerCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$above(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$leftOf(coordinates),
			tiles);
	});
var $author$project$Services$Tile$topLeftOf = A2($elm$core$Basics$composeR, $author$project$Services$Matrix$above, $author$project$Services$Matrix$leftOf);
var $author$project$Services$Tile$hasTopLeftOuterCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Tile$topLeftOf(coordinates),
			tiles) && (A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$leftOf(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$above(coordinates),
			tiles));
	});
var $author$project$Services$Tile$getTopLeftCorner = F2(
	function (coordinates, tiles) {
		return A4($author$project$Services$Tile$getCorner, coordinates, tiles, $author$project$Services$Tile$hasTopLeftOuterCorner, $author$project$Services$Tile$hasTopLeftInnerCorner);
	});
var $author$project$Services$Tile$hasTopRightInnerCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$above(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Matrix$rightOf(coordinates),
			tiles);
	});
var $author$project$Services$Tile$topRightOf = A2($elm$core$Basics$composeR, $author$project$Services$Matrix$above, $author$project$Services$Matrix$rightOf);
var $author$project$Services$Tile$hasTopRightOuterCorner = F2(
	function (coordinates, tiles) {
		return A2(
			$author$project$Services$Tile$hasTileAtCoordinates,
			$author$project$Services$Tile$topRightOf(coordinates),
			tiles) && (A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$rightOf(coordinates),
			tiles) && A2(
			$author$project$Services$Tile$isBlankTileAt,
			$author$project$Services$Matrix$above(coordinates),
			tiles));
	});
var $author$project$Services$Tile$getTopRightCorner = F2(
	function (coordinates, tiles) {
		return A4($author$project$Services$Tile$getCorner, coordinates, tiles, $author$project$Services$Tile$hasTopRightOuterCorner, $author$project$Services$Tile$hasTopRightInnerCorner);
	});
var $author$project$Services$Tile$getCorners = F2(
	function (tiles, coordinates) {
		return A4(
			$author$project$Domain$Types$Corners,
			A2($author$project$Services$Tile$getTopLeftCorner, coordinates, tiles),
			A2($author$project$Services$Tile$getTopRightCorner, coordinates, tiles),
			A2($author$project$Services$Tile$getBottomLeftCorner, coordinates, tiles),
			A2($author$project$Services$Tile$getBottomRightCorner, coordinates, tiles));
	});
var $author$project$SVGs$Tiles$Tile$getTileType = F3(
	function (tileTypeInt, matrix, coordinates) {
		var row = coordinates.a;
		var column = coordinates.b;
		if (!tileTypeInt) {
			return A3(
				$author$project$Domain$Types$Empty,
				coordinates,
				A2($author$project$Services$Tile$getBorder, matrix, coordinates),
				A2($author$project$Services$Tile$getCorners, matrix, coordinates));
		} else {
			return (!A2($elm$core$Basics$modBy, 2, row + column)) ? $author$project$Domain$Types$Dark(coordinates) : $author$project$Domain$Types$Light(coordinates);
		}
	});
var $author$project$Domain$Types$EmptyTile = F2(
	function (border, corner) {
		return {bJ: border, bU: corner};
	});
var $author$project$Domain$Types$MouseDown = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Domain$Types$MouseUp = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Domain$Types$TileClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Extras$List$appendIf = F3(
	function (shouldAppend, newElements, existingList) {
		return shouldAppend ? A2($elm$core$List$append, newElements, existingList) : existingList;
	});
var $author$project$Domain$Types$Color = F3(
	function (red, green, blue) {
		return {bE: blue, ch: green, c6: red};
	});
var $author$project$SVGs$Tiles$Tile$darkTileColorAttribute = function (attributeFunction) {
	return attributeFunction(
		$author$project$Services$ShapeColor$getColorString(
			A3($author$project$Domain$Types$Color, 115, 230, 115)));
};
var $author$project$SVGs$Tiles$Tile$darkTile = _List_fromArray(
	[
		A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('canvasKanaTile-rectangleDarker'),
						$elm$svg$Svg$Attributes$stroke('none'),
						$author$project$SVGs$Tiles$Tile$darkTileColorAttribute($elm$svg$Svg$Attributes$fill),
						$elm$svg$Svg$Attributes$d('M 0,100 L 100,100 100,-0 0,-0 0,100 Z M 0,100')
					]),
				_List_Nil)
			]))
	]);
var $author$project$SVGs$Tiles$Tile$borderColorAttribute = function (attributeFunction) {
	return attributeFunction(
		$author$project$Services$ShapeColor$getColorString(
			A3($author$project$Domain$Types$Color, 2, 204, 157)));
};
var $author$project$SVGs$Tiles$Tile$svgIf = F2(
	function (include, item) {
		return include ? _List_fromArray(
			[item]) : _List_Nil;
	});
var $author$project$SVGs$Tiles$Tile$bottomBorder = function (_v0) {
	var hasBottomBorder = _v0.ci;
	return A2(
		$author$project$SVGs$Tiles$Tile$svgIf,
		hasBottomBorder,
		A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('rightBorder'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
					$elm$svg$Svg$Attributes$d('M 0,100 L 100,100 100,94 0,94 0,100 Z M 0,100')
				]),
			_List_Nil));
};
var $author$project$SVGs$Tiles$Tile$bottomLeftInnerCorner = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('rightBorder'),
				$elm$svg$Svg$Attributes$stroke('none'),
				color($elm$svg$Svg$Attributes$fill),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$d('M 6,100 C 4.41,100 2.88,99.37 1.76,98.24 0.63,97.12 0,95.59 0,94 L 0,94 0,100 6,100 6,100 Z M 6,100')
			]),
		_List_Nil);
};
var $author$project$SVGs$Tiles$Tile$bottomLeftOuterCorner = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('rightBorder'),
			$elm$svg$Svg$Attributes$stroke('none'),
			$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
			$elm$svg$Svg$Attributes$d('M 6,100 C 6,98.41 5.37,96.88 4.24,95.76 3.12,94.63 1.59,94 0,94 L 0,94 0,100 6,100 6,100 Z M 6,100')
		]),
	_List_Nil);
var $author$project$SVGs$Tiles$Tile$lightTileColorAttribute = function (attributeFunction) {
	return attributeFunction(
		$author$project$Services$ShapeColor$getColorString(
			A3($author$project$Domain$Types$Color, 170, 255, 170)));
};
var $author$project$SVGs$Tiles$Tile$bottomLeftCornerSVG = function (_v0) {
	var bottomLeftCorner = _v0.bK;
	switch (bottomLeftCorner) {
		case 2:
			return _List_fromArray(
				[$author$project$SVGs$Tiles$Tile$bottomLeftOuterCorner]);
		case 0:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$bottomLeftInnerCorner($author$project$SVGs$Tiles$Tile$darkTileColorAttribute)
				]);
		case 1:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$bottomLeftInnerCorner($author$project$SVGs$Tiles$Tile$lightTileColorAttribute)
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$SVGs$Tiles$Tile$bottomRightInnerCorner = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('rightBorder'),
				$elm$svg$Svg$Attributes$stroke('none'),
				color($elm$svg$Svg$Attributes$fill),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$d('M 94,100 C 95.59,100 97.12,99.37 98.24,98.24 99.37,97.12 100,95.59 100,94 L 100,94 100,100 94,100 94,100 Z M 94,100')
			]),
		_List_Nil);
};
var $author$project$SVGs$Tiles$Tile$bottomRightOuterCorner = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('rightBorder'),
			$elm$svg$Svg$Attributes$stroke('none'),
			$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
			$elm$svg$Svg$Attributes$d('M 99.98,100 L 94,100 C 94,99.03 94.23,98.11 94.64,97.3 95.62,95.36 97.67,94.02 99.98,94 100.03,95.98 99.98,97.99 99.98,100 Z M 99.98,100')
		]),
	_List_Nil);
var $author$project$SVGs$Tiles$Tile$bottomRightCornerSVG = function (_v0) {
	var bottomRightCorner = _v0.bL;
	switch (bottomRightCorner) {
		case 2:
			return _List_fromArray(
				[$author$project$SVGs$Tiles$Tile$bottomRightOuterCorner]);
		case 0:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$bottomRightInnerCorner($author$project$SVGs$Tiles$Tile$darkTileColorAttribute)
				]);
		case 1:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$bottomRightInnerCorner($author$project$SVGs$Tiles$Tile$lightTileColorAttribute)
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$SVGs$Tiles$Tile$leftBorder = function (_v0) {
	var hasLeftBorder = _v0.cj;
	return A2(
		$author$project$SVGs$Tiles$Tile$svgIf,
		hasLeftBorder,
		A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('leftBorder'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
					$elm$svg$Svg$Attributes$d('M 0,100 L 6,100 6,-0 0,-0 0,100 Z M 0,100')
				]),
			_List_Nil));
};
var $author$project$SVGs$Tiles$Tile$rightBorder = function (_v0) {
	var hasRightBorder = _v0.ck;
	return A2(
		$author$project$SVGs$Tiles$Tile$svgIf,
		hasRightBorder,
		A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('rightBorder'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
					$elm$svg$Svg$Attributes$d('M 94,100 L 100,100 100,-0 94,-0 94,100 Z M 94,100')
				]),
			_List_Nil));
};
var $author$project$SVGs$Tiles$Tile$topBorder = function (_v0) {
	var hasTopBorder = _v0.cl;
	return A2(
		$author$project$SVGs$Tiles$Tile$svgIf,
		hasTopBorder,
		A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('rightBorder'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
					$elm$svg$Svg$Attributes$d('M 0,6 L 100,6 100,-0 0,-0 0,6 Z M 0,6')
				]),
			_List_Nil));
};
var $author$project$SVGs$Tiles$Tile$topLeftInnerCorner = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('rightBorder'),
				$elm$svg$Svg$Attributes$stroke('none'),
				color($elm$svg$Svg$Attributes$fill),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$d('M 6,0 C 4.41,0 2.88,0.63 1.76,1.76 0.63,2.88 0,4.41 0,6 L 0,6 0,-0 6,-0 6,0 Z M 6,0')
			]),
		_List_Nil);
};
var $author$project$SVGs$Tiles$Tile$topLeftOuterCorner = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('rightBorder'),
			$elm$svg$Svg$Attributes$stroke('none'),
			$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
			$elm$svg$Svg$Attributes$d('M 0.02,-0 L 6,-0 C 6,0.97 5.77,1.89 5.36,2.7 4.38,4.64 2.33,5.98 0.02,6 -0.03,4.02 0.02,2.01 0.02,-0 Z M 0.02,-0')
		]),
	_List_Nil);
var $author$project$SVGs$Tiles$Tile$topLeftCornerSVG = function (_v0) {
	var topLeftCorner = _v0.dA;
	switch (topLeftCorner) {
		case 2:
			return _List_fromArray(
				[$author$project$SVGs$Tiles$Tile$topLeftOuterCorner]);
		case 0:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$topLeftInnerCorner($author$project$SVGs$Tiles$Tile$darkTileColorAttribute)
				]);
		case 1:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$topLeftInnerCorner($author$project$SVGs$Tiles$Tile$lightTileColorAttribute)
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$SVGs$Tiles$Tile$topRightInnerCorner = function (color) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('rightBorder'),
				$elm$svg$Svg$Attributes$stroke('none'),
				color($elm$svg$Svg$Attributes$fill),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$d('M 94,0 C 95.59,0 97.12,0.63 98.24,1.76 99.37,2.88 100,4.41 100,6 L 100,6 100,-0 94,-0 94,0 Z M 94,0')
			]),
		_List_Nil);
};
var $author$project$SVGs$Tiles$Tile$topRightOuterCorner = A2(
	$elm$svg$Svg$path,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$id('rightBorder'),
			$elm$svg$Svg$Attributes$stroke('none'),
			$author$project$SVGs$Tiles$Tile$borderColorAttribute($elm$svg$Svg$Attributes$fill),
			$elm$svg$Svg$Attributes$d('M 99.98,-0 L 94,-0 C 94,0.97 94.23,1.89 94.64,2.7 95.62,4.64 97.67,5.98 99.98,6 100.03,4.02 99.98,2.01 99.98,-0 Z M 99.98,-0')
		]),
	_List_Nil);
var $author$project$SVGs$Tiles$Tile$topRightCornerSVG = function (_v0) {
	var topRightCorner = _v0.dB;
	switch (topRightCorner) {
		case 2:
			return _List_fromArray(
				[$author$project$SVGs$Tiles$Tile$topRightOuterCorner]);
		case 0:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$topRightInnerCorner($author$project$SVGs$Tiles$Tile$darkTileColorAttribute)
				]);
		case 1:
			return _List_fromArray(
				[
					$author$project$SVGs$Tiles$Tile$topRightInnerCorner($author$project$SVGs$Tiles$Tile$lightTileColorAttribute)
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$SVGs$Tiles$Tile$emptyTile = function (_v0) {
	var border = _v0.bJ;
	var corner = _v0.bU;
	return A2(
		$elm$core$List$append,
		$author$project$SVGs$Tiles$Tile$rightBorder(border),
		A2(
			$elm$core$List$append,
			$author$project$SVGs$Tiles$Tile$leftBorder(border),
			A2(
				$elm$core$List$append,
				$author$project$SVGs$Tiles$Tile$bottomBorder(border),
				A2(
					$elm$core$List$append,
					$author$project$SVGs$Tiles$Tile$topBorder(border),
					A2(
						$elm$core$List$append,
						$author$project$SVGs$Tiles$Tile$bottomRightCornerSVG(corner),
						A2(
							$elm$core$List$append,
							$author$project$SVGs$Tiles$Tile$bottomLeftCornerSVG(corner),
							A2(
								$elm$core$List$append,
								$author$project$SVGs$Tiles$Tile$topRightCornerSVG(corner),
								$author$project$SVGs$Tiles$Tile$topLeftCornerSVG(corner))))))));
};
var $author$project$Services$Tile$isEmpty = function (tileType) {
	if (tileType.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Services$Tile$isNotEmpty = function (tileType) {
	return !$author$project$Services$Tile$isEmpty(tileType);
};
var $author$project$SVGs$Tiles$Tile$lightTile = _List_fromArray(
	[
		A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id('canvasKanaTile-rectangleLighter'),
				$elm$svg$Svg$Attributes$stroke('none'),
				$author$project$SVGs$Tiles$Tile$lightTileColorAttribute($elm$svg$Svg$Attributes$fill),
				$elm$svg$Svg$Attributes$d('M 0,100 L 100,100 100,-0 0,-0 0,100 Z M 0,100')
			]),
		_List_Nil)
	]);
var $author$project$Extras$Events$onMouseDown = function (message) {
	return A2(
		$elm$svg$Svg$Events$on,
		'mousedown',
		A3(
			$elm$json$Json$Decode$map2,
			message,
			A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float)));
};
var $author$project$Extras$Events$onMouseUp = function (message) {
	return A2(
		$elm$svg$Svg$Events$on,
		'mouseup',
		A3(
			$elm$json$Json$Decode$map2,
			message,
			A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float)));
};
var $author$project$Domain$Types$Swipe = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Types$SwipeEnd = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Services$Swipe$End = 2;
var $author$project$Services$Swipe$Touch = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Services$Swipe$Position = F2(
	function (x, y) {
		return {bl: x, bm: y};
	});
var $author$project$Services$Swipe$decodeTouchWithOptions = F3(
	function (fieldName, options, tagger) {
		return A2(
			$elm$json$Json$Decode$map,
			function (p) {
				return {
					cN: tagger(p),
					ao: options.ao,
					as: options.as
				};
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					[fieldName, '0']),
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (x, y) {
							return A2($author$project$Services$Swipe$Position, x, y);
						}),
					A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))));
	});
var $author$project$Services$Swipe$onEndWithOptions = F2(
	function (options, tagger) {
		return A2(
			$elm$html$Html$Events$custom,
			'touchend',
			A3(
				$author$project$Services$Swipe$decodeTouchWithOptions,
				'changedTouches',
				options,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Services$Swipe$Touch(2),
					tagger)));
	});
var $author$project$Services$Swipe$onEnd = $author$project$Services$Swipe$onEndWithOptions(
	{ao: true, as: false});
var $author$project$Services$Swipe$Move = 1;
var $author$project$Services$Swipe$decodeTouch = F2(
	function (fieldName, tagger) {
		return A2(
			$elm$json$Json$Decode$map,
			tagger,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					[fieldName, '0']),
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$Services$Swipe$Position,
					A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))));
	});
var $author$project$Services$Swipe$onMove = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'touchmove',
		A2(
			$author$project$Services$Swipe$decodeTouch,
			'changedTouches',
			A2(
				$elm$core$Basics$composeR,
				$author$project$Services$Swipe$Touch(1),
				tagger)));
};
var $author$project$Services$Swipe$Start = 0;
var $author$project$Services$Swipe$onStart = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'touchstart',
		A2(
			$author$project$Services$Swipe$decodeTouch,
			'touches',
			A2(
				$elm$core$Basics$composeR,
				$author$project$Services$Swipe$Touch(0),
				tagger)));
};
var $author$project$Services$Tile$svgTileAttributes = F3(
	function (viewBox, cssSelector, _v0) {
		var row = _v0.a;
		var column = _v0.b;
		return _List_fromArray(
			[
				$author$project$Extras$Svg$viewBoxAttribute(viewBox),
				cssSelector,
				$author$project$Services$CssSelector$rowToSelector(row),
				$author$project$Services$CssSelector$columnToSelector(column),
				$author$project$Services$Swipe$onStart(
				function (touch) {
					return $author$project$Domain$Types$SwapMessage(
						$author$project$Domain$Types$Swipe(touch));
				}),
				$author$project$Services$Swipe$onMove(
				function (touch) {
					return $author$project$Domain$Types$SwapMessage(
						$author$project$Domain$Types$Swipe(touch));
				}),
				$author$project$Services$Swipe$onEnd(
				function (touch) {
					return $author$project$Domain$Types$SwapMessage(
						A3($author$project$Domain$Types$SwipeEnd, row, column, touch));
				})
			]);
	});
var $author$project$SVGs$Tiles$Tile$tileHtmlByType = function (tileType) {
	switch (tileType.$) {
		case 0:
			return $author$project$SVGs$Tiles$Tile$lightTile;
		case 1:
			return $author$project$SVGs$Tiles$Tile$darkTile;
		default:
			var border = tileType.b;
			var corner = tileType.c;
			return $author$project$SVGs$Tiles$Tile$emptyTile(
				A2($author$project$Domain$Types$EmptyTile, border, corner));
	}
};
var $author$project$Services$CssSelector$tileSelector = $elm$svg$Svg$Attributes$class('tile');
var $author$project$Services$Tile$tileViewBox = A4($author$project$Extras$Svg$ViewBox, 0, 0, '100', '100');
var $author$project$SVGs$Tiles$Tile$tileHtml = F2(
	function (isBoardAnimating, _v0) {
		var tileType = _v0.dv;
		var coordinates = _v0.aw;
		var _v1 = $author$project$SVGs$Tiles$Tile$tileHtmlByType(tileType);
		if (!_v1.b) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					A3(
						$author$project$Extras$List$appendIf,
						(!isBoardAnimating) && $author$project$Services$Tile$isNotEmpty(tileType),
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Domain$Types$SwapMessage(
									$author$project$Domain$Types$TileClicked(coordinates))),
								$author$project$Extras$Events$onMouseDown(
								F2(
									function (clientX, clientY) {
										return $author$project$Domain$Types$SwapMessage(
											A3($author$project$Domain$Types$MouseDown, coordinates, clientX, clientY));
									})),
								$author$project$Extras$Events$onMouseUp(
								F2(
									function (clientX, clientY) {
										return $author$project$Domain$Types$SwapMessage(
											A2($author$project$Domain$Types$MouseUp, clientX, clientY));
									}))
							]),
						A3($author$project$Services$Tile$svgTileAttributes, $author$project$Services$Tile$tileViewBox, $author$project$Services$CssSelector$tileSelector, coordinates)),
					function () {
						switch (tileType.$) {
							case 0:
								return $author$project$SVGs$Tiles$Tile$lightTile;
							case 1:
								return $author$project$SVGs$Tiles$Tile$darkTile;
							default:
								var border = tileType.b;
								var corner = tileType.c;
								return $author$project$SVGs$Tiles$Tile$emptyTile(
									A2($author$project$Domain$Types$EmptyTile, border, corner));
						}
					}())
				]);
		}
	});
var $author$project$SVGs$Tiles$Tile$rowColumnHtml = F5(
	function (isBoardAnimating, matrix, row, column, tileTypeInt) {
		return $elm$core$Array$fromList(
			A2(
				$author$project$SVGs$Tiles$Tile$tileHtml,
				isBoardAnimating,
				A2(
					$author$project$Domain$Types$Tile,
					_Utils_Tuple2(row, column),
					A3(
						$author$project$SVGs$Tiles$Tile$getTileType,
						tileTypeInt,
						matrix,
						_Utils_Tuple2(row, column)))));
	});
var $author$project$SVGs$Tiles$Tile$rowHtml = F4(
	function (isBoardAnimating, matrix, row, rowIndex) {
		return A3(
			$author$project$Extras$Array$indexedFoldLeft,
			F3(
				function (columnIndex, htmlArray, value) {
					return A2(
						$elm$core$Array$append,
						htmlArray,
						A5($author$project$SVGs$Tiles$Tile$rowColumnHtml, isBoardAnimating, matrix, rowIndex, columnIndex, value));
				}),
			$elm$core$Array$empty,
			row);
	});
var $author$project$SVGs$Tiles$Tile$rowDiv = F4(
	function (isBoardAnimating, matrix, rowIndex, row) {
		return $elm$core$Array$toList(
			A4($author$project$SVGs$Tiles$Tile$rowHtml, isBoardAnimating, matrix, row, rowIndex));
	});
var $author$project$SVGs$Tiles$Tile$tilesHtml = function (_v0) {
	var level = _v0.cK;
	var isBoardAnimating = _v0.cA;
	return $elm$core$List$concat(
		$elm$core$Array$toList(
			A2(
				$elm$core$Array$indexedMap,
				A2($author$project$SVGs$Tiles$Tile$rowDiv, isBoardAnimating, level.dw),
				level.dw)));
};
var $author$project$View$tilesLayer = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('tilesContainer'),
						$author$project$Services$CssSelector$opacity(model.by === 5)
					]),
				$author$project$SVGs$Tiles$Tile$tilesHtml(model)),
			viewElements);
	});
var $author$project$Services$CssSelector$dropAnimationSelector = $elm$svg$Svg$Attributes$class('drop-animation');
var $author$project$Services$Gravity$gravity = 15;
var $author$project$Services$Gravity$applyGravity = function (fallDistance) {
	return fallDistance / $author$project$Services$Gravity$gravity;
};
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $author$project$Services$Gravity$fallDistanceToFallDuration = function (fallDistance) {
	return $elm$core$Basics$sqrt(
		$author$project$Services$Gravity$applyGravity(
			$elm$core$Basics$abs(fallDistance)));
};
var $author$project$Services$Shape$animationDurationByFallDistance = function (fallDistance) {
	return 'animation-duration: ' + ($elm$core$String$fromFloat(
		$author$project$Services$Gravity$fallDistanceToFallDuration(fallDistance)) + 's;');
};
var $author$project$Services$Shape$rowToAnimationStyleSelector = F3(
	function (rowStartIndex, rowDestinationIndex, fallDistance) {
		return $elm$svg$Svg$Attributes$style(
			'--top-start: calc( ' + ($elm$core$String$fromInt(rowStartIndex) + (' * ' + ($author$project$Services$Dimensions$tileWidthAndHeight + (');' + ('--top-finish: calc(' + ($elm$core$String$fromInt(rowDestinationIndex) + (' * ' + ($author$project$Services$Dimensions$tileWidthAndHeight + (');' + $author$project$Services$Shape$animationDurationByFallDistance(fallDistance)))))))))));
	});
var $author$project$Services$Shape$fillSwapAttributes = F2(
	function (viewBox, _v0) {
		var _v1 = _v0.a;
		var originRowIndex = _v1.a;
		var _v2 = _v0.b;
		var destinationRow = _v2.a;
		var destinationColumn = _v2.b;
		var fallDistance = destinationRow - originRowIndex;
		return _List_fromArray(
			[
				$author$project$Extras$Svg$viewBoxAttribute(viewBox),
				$author$project$Services$CssSelector$boardItemSelector,
				$author$project$Services$CssSelector$dropAnimationSelector,
				$author$project$Services$CssSelector$rowToSelector(destinationRow),
				$author$project$Services$CssSelector$columnToSelector(destinationColumn),
				A3($author$project$Services$Shape$rowToAnimationStyleSelector, originRowIndex, destinationRow, fallDistance)
			]);
	});
var $author$project$Services$SVGConversion$fillSwapToHtml = F2(
	function (swap, boardItem) {
		return $elm$core$Array$toList(
			A3(
				$author$project$Services$SVGConversion$generateBoardItemHtml,
				boardItem,
				$elm$core$Basics$always(true),
				$elm$core$Basics$always(
					A2($author$project$Services$Shape$fillSwapAttributes, $author$project$Services$Shape$boardItemViewBox, swap))));
	});
var $author$project$View$fillSwapsToHtml = function (_v0) {
	var boardItems = _v0.bG;
	var fillSwaps = _v0.ca;
	return A3(
		$elm$core$List$foldl,
		F2(
			function (swap, newList) {
				var originCoordinates = swap.a;
				var _v1 = A2($author$project$Services$Board$valueAtRowAndColumn, originCoordinates, boardItems);
				if (!_v1.$) {
					var boardItem = _v1.a;
					return _Utils_ap(
						newList,
						A2($author$project$Services$SVGConversion$fillSwapToHtml, swap, boardItem));
				} else {
					return newList;
				}
			}),
		_List_Nil,
		fillSwaps);
};
var $author$project$Services$CssSelector$kanaAnimations = $elm$svg$Svg$Attributes$id('kanaAnimations');
var $author$project$Services$CssSelector$tileMask = $elm$svg$Svg$Attributes$class('tileMask');
var $author$project$Services$Shape$topUpAttributes = F3(
	function (viewBox, aboveCoordinates, _v0) {
		var coordinates = _v0.aw;
		var _v1 = coordinates;
		var rowIndex = _v1.a;
		var columnIndex = _v1.b;
		var _v2 = aboveCoordinates;
		var aboveRowIndex = _v2.a;
		var fallDistance = rowIndex - aboveRowIndex;
		return _List_fromArray(
			[
				$author$project$Extras$Svg$viewBoxAttribute(viewBox),
				$author$project$Services$CssSelector$boardItemSelector,
				$author$project$Services$CssSelector$dropAnimationSelector,
				$author$project$Services$CssSelector$rowToSelector(rowIndex),
				$author$project$Services$CssSelector$columnToSelector(columnIndex),
				A3($author$project$Services$Shape$rowToAnimationStyleSelector, aboveRowIndex, rowIndex, fallDistance)
			]);
	});
var $author$project$Services$SVGConversion$topUpBoardItemToHtml = F3(
	function (boardItem, hasTileAt, aboveCoordinates) {
		return A3(
			$author$project$Services$SVGConversion$generateBoardItemHtml,
			boardItem,
			hasTileAt,
			A2($author$project$Services$Shape$topUpAttributes, $author$project$Services$Shape$boardItemViewBox, aboveCoordinates));
	});
var $author$project$View$topUpBoardItemsToHtml = function (_v0) {
	var topUpBoardItems = _v0.dC;
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var boardItem = _v1.a;
				var aboveCoordinates = _v1.b;
				return $elm$core$Array$toList(
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Array$empty,
						A2(
							$elm$core$Maybe$andThen,
							function (item) {
								return $elm$core$Maybe$Just(
									A3(
										$author$project$Services$SVGConversion$topUpBoardItemToHtml,
										item,
										$elm$core$Basics$always(true),
										aboveCoordinates));
							},
							boardItem)));
			},
			topUpBoardItems));
};
var $author$project$View$topUpLayer = F2(
	function (model, viewElements) {
		return A3(
			$author$project$Extras$List$appendElementIf,
			A2(
				$author$project$Extras$List$contains,
				model.by,
				_List_fromArray(
					[5, 6])),
			A2(
				$author$project$Extras$Html$keyedDiv,
				_List_fromArray(
					[$author$project$Services$CssSelector$kanaAnimations, $author$project$Services$CssSelector$tileMask]),
				_Utils_ap(
					$author$project$View$topUpBoardItemsToHtml(model),
					$author$project$View$fillSwapsToHtml(model))),
			viewElements);
	});
var $author$project$Domain$Types$VictoryCloseClicked = {$: 15};
var $elm$svg$Svg$ellipse = $elm$svg$Svg$trustedNode('ellipse');
var $author$project$SVGs$Modals$Victory$happyBoyDefinitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient7-bezier138'),
					$elm$svg$Svg$Attributes$cx('114.72'),
					$elm$svg$Svg$Attributes$cy('173.63'),
					$elm$svg$Svg$Attributes$r('10.25'),
					$elm$svg$Svg$Attributes$fx('114.72'),
					$elm$svg$Svg$Attributes$fy('173.63'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(244, 151, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient7-clip'),
					$elm$svg$Svg$Attributes$cx('114.72'),
					$elm$svg$Svg$Attributes$cy('173.63'),
					$elm$svg$Svg$Attributes$r('10.25'),
					$elm$svg$Svg$Attributes$fx('114.72'),
					$elm$svg$Svg$Attributes$fy('173.63'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(244, 151, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval17'),
					$elm$svg$Svg$Attributes$cx('114.82'),
					$elm$svg$Svg$Attributes$cy('173.78'),
					$elm$svg$Svg$Attributes$r('10.63'),
					$elm$svg$Svg$Attributes$fx('114.82'),
					$elm$svg$Svg$Attributes$fy('173.78'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip2'),
					$elm$svg$Svg$Attributes$cx('114.82'),
					$elm$svg$Svg$Attributes$cy('173.78'),
					$elm$svg$Svg$Attributes$r('10.63'),
					$elm$svg$Svg$Attributes$fx('114.82'),
					$elm$svg$Svg$Attributes$fy('173.78'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval19'),
					$elm$svg$Svg$Attributes$cx('115.22'),
					$elm$svg$Svg$Attributes$cy('174.56'),
					$elm$svg$Svg$Attributes$r('13.6'),
					$elm$svg$Svg$Attributes$fx('115.22'),
					$elm$svg$Svg$Attributes$fy('174.56'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip3'),
					$elm$svg$Svg$Attributes$cx('115.22'),
					$elm$svg$Svg$Attributes$cy('174.56'),
					$elm$svg$Svg$Attributes$r('13.6'),
					$elm$svg$Svg$Attributes$fx('115.22'),
					$elm$svg$Svg$Attributes$fy('174.56'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval21'),
					$elm$svg$Svg$Attributes$cx('114.91'),
					$elm$svg$Svg$Attributes$cy('173.82'),
					$elm$svg$Svg$Attributes$r('10.63'),
					$elm$svg$Svg$Attributes$fx('114.91'),
					$elm$svg$Svg$Attributes$fy('173.82'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip4'),
					$elm$svg$Svg$Attributes$cx('114.91'),
					$elm$svg$Svg$Attributes$cy('173.82'),
					$elm$svg$Svg$Attributes$r('10.63'),
					$elm$svg$Svg$Attributes$fx('114.91'),
					$elm$svg$Svg$Attributes$fy('173.82'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval23'),
					$elm$svg$Svg$Attributes$cx('114.21'),
					$elm$svg$Svg$Attributes$cy('174.23'),
					$elm$svg$Svg$Attributes$r('13.35'),
					$elm$svg$Svg$Attributes$fx('114.21'),
					$elm$svg$Svg$Attributes$fy('174.23'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip5'),
					$elm$svg$Svg$Attributes$cx('114.21'),
					$elm$svg$Svg$Attributes$cy('174.23'),
					$elm$svg$Svg$Attributes$r('13.35'),
					$elm$svg$Svg$Attributes$fx('114.21'),
					$elm$svg$Svg$Attributes$fy('174.23'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval25'),
					$elm$svg$Svg$Attributes$cx('116.22'),
					$elm$svg$Svg$Attributes$cy('173.75'),
					$elm$svg$Svg$Attributes$r('13.35'),
					$elm$svg$Svg$Attributes$fx('116.22'),
					$elm$svg$Svg$Attributes$fy('173.75'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip6'),
					$elm$svg$Svg$Attributes$cx('116.22'),
					$elm$svg$Svg$Attributes$cy('173.75'),
					$elm$svg$Svg$Attributes$r('13.35'),
					$elm$svg$Svg$Attributes$fx('116.22'),
					$elm$svg$Svg$Attributes$fy('173.75'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval27'),
					$elm$svg$Svg$Attributes$cx('115.49'),
					$elm$svg$Svg$Attributes$cy('173.75'),
					$elm$svg$Svg$Attributes$r('13.6'),
					$elm$svg$Svg$Attributes$fx('115.49'),
					$elm$svg$Svg$Attributes$fy('173.75'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip7'),
					$elm$svg$Svg$Attributes$cx('115.49'),
					$elm$svg$Svg$Attributes$cy('173.75'),
					$elm$svg$Svg$Attributes$r('13.6'),
					$elm$svg$Svg$Attributes$fx('115.49'),
					$elm$svg$Svg$Attributes$fy('173.75'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient7-bezier140'),
					$elm$svg$Svg$Attributes$cx('171.49'),
					$elm$svg$Svg$Attributes$cy('173.35'),
					$elm$svg$Svg$Attributes$r('10.49'),
					$elm$svg$Svg$Attributes$fx('171.49'),
					$elm$svg$Svg$Attributes$fy('173.35'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(244, 151, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient7-clip8'),
					$elm$svg$Svg$Attributes$cx('171.49'),
					$elm$svg$Svg$Attributes$cy('173.35'),
					$elm$svg$Svg$Attributes$r('10.49'),
					$elm$svg$Svg$Attributes$fx('171.49'),
					$elm$svg$Svg$Attributes$fy('173.35'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(244, 151, 124)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient9-bezier142'),
					$elm$svg$Svg$Attributes$cx('170.55'),
					$elm$svg$Svg$Attributes$cy('173.35'),
					$elm$svg$Svg$Attributes$r('10.21'),
					$elm$svg$Svg$Attributes$fx('170.55'),
					$elm$svg$Svg$Attributes$fy('173.35'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(78, 24, 11)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(81, 33, 15)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient9-clip9'),
					$elm$svg$Svg$Attributes$cx('170.55'),
					$elm$svg$Svg$Attributes$cy('173.35'),
					$elm$svg$Svg$Attributes$r('10.21'),
					$elm$svg$Svg$Attributes$fx('170.55'),
					$elm$svg$Svg$Attributes$fy('173.35'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(78, 24, 11)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(81, 33, 15)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval35'),
					$elm$svg$Svg$Attributes$cx('170.07'),
					$elm$svg$Svg$Attributes$cy('173.91'),
					$elm$svg$Svg$Attributes$r('13.14'),
					$elm$svg$Svg$Attributes$fx('170.07'),
					$elm$svg$Svg$Attributes$fy('173.91'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip10'),
					$elm$svg$Svg$Attributes$cx('170.07'),
					$elm$svg$Svg$Attributes$cy('173.91'),
					$elm$svg$Svg$Attributes$r('13.14'),
					$elm$svg$Svg$Attributes$fx('170.07'),
					$elm$svg$Svg$Attributes$fy('173.91'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval37'),
					$elm$svg$Svg$Attributes$cx('171.33'),
					$elm$svg$Svg$Attributes$cy('172.94'),
					$elm$svg$Svg$Attributes$r('11.56'),
					$elm$svg$Svg$Attributes$fx('171.33'),
					$elm$svg$Svg$Attributes$fy('172.94'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip11'),
					$elm$svg$Svg$Attributes$cx('171.33'),
					$elm$svg$Svg$Attributes$cy('172.94'),
					$elm$svg$Svg$Attributes$r('11.56'),
					$elm$svg$Svg$Attributes$fx('171.33'),
					$elm$svg$Svg$Attributes$fy('172.94'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval39'),
					$elm$svg$Svg$Attributes$cx('171.18'),
					$elm$svg$Svg$Attributes$cy('173.66'),
					$elm$svg$Svg$Attributes$r('10.63'),
					$elm$svg$Svg$Attributes$fx('171.18'),
					$elm$svg$Svg$Attributes$fy('173.66'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip12'),
					$elm$svg$Svg$Attributes$cx('171.18'),
					$elm$svg$Svg$Attributes$cy('173.66'),
					$elm$svg$Svg$Attributes$r('10.63'),
					$elm$svg$Svg$Attributes$fx('171.18'),
					$elm$svg$Svg$Attributes$fy('173.66'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval41'),
					$elm$svg$Svg$Attributes$cx('171.51'),
					$elm$svg$Svg$Attributes$cy('174.47'),
					$elm$svg$Svg$Attributes$r('13.35'),
					$elm$svg$Svg$Attributes$fx('171.51'),
					$elm$svg$Svg$Attributes$fy('174.47'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip13'),
					$elm$svg$Svg$Attributes$cx('171.51'),
					$elm$svg$Svg$Attributes$cy('174.47'),
					$elm$svg$Svg$Attributes$r('13.35'),
					$elm$svg$Svg$Attributes$fx('171.51'),
					$elm$svg$Svg$Attributes$fy('174.47'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval43'),
					$elm$svg$Svg$Attributes$cx('170.07'),
					$elm$svg$Svg$Attributes$cy('173'),
					$elm$svg$Svg$Attributes$r('12.76'),
					$elm$svg$Svg$Attributes$fx('170.07'),
					$elm$svg$Svg$Attributes$fy('173'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip14'),
					$elm$svg$Svg$Attributes$cx('170.07'),
					$elm$svg$Svg$Attributes$cy('173'),
					$elm$svg$Svg$Attributes$r('12.76'),
					$elm$svg$Svg$Attributes$fx('170.07'),
					$elm$svg$Svg$Attributes$fy('173'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-oval45'),
					$elm$svg$Svg$Attributes$cx('170.72'),
					$elm$svg$Svg$Attributes$cy('174.56'),
					$elm$svg$Svg$Attributes$r('13.6'),
					$elm$svg$Svg$Attributes$fx('170.72'),
					$elm$svg$Svg$Attributes$fy('174.56'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$radialGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('canvas2-gradient8-clip15'),
					$elm$svg$Svg$Attributes$cx('170.72'),
					$elm$svg$Svg$Attributes$cy('174.56'),
					$elm$svg$Svg$Attributes$r('13.6'),
					$elm$svg$Svg$Attributes$fx('170.72'),
					$elm$svg$Svg$Attributes$fy('174.56'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(184, 96, 80)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]));
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $author$project$SVGs$Modals$Victory$happyBoy = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 312 335'),
			$elm$svg$Svg$Attributes$width('156'),
			$elm$svg$Svg$Attributes$height('167.5'),
			$elm$svg$Svg$Attributes$x('65'),
			$elm$svg$Svg$Attributes$y('90')
		]),
	_List_fromArray(
		[
			$author$project$SVGs$Modals$Victory$happyBoyDefinitions,
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier68'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$d('M 119.47,198.74 L 111.01,211.47 104.69,221 C 98.81,216.84 89.55,207.95 84.65,203.18 80.42,199.06 62.01,177.28 58.6,169.43 55.09,166.97 48.65,163.86 45.62,160.88 42.59,157.9 38.75,156.43 36.95,154.92 35.43,153.64 32.76,151.69 32.65,149.95 32.64,149.63 32.7,149.31 32.88,149.01 34.02,147.08 42.4,153.03 46.85,154.12 45.71,152.46 42.59,149.91 40.36,148.02 38.14,146.13 33.11,141.5 34.44,139.7 35.77,137.91 42.87,143.58 44.29,144.71 45.71,145.85 49.93,148.49 50.07,148.64 47.56,145.37 45.26,143.84 44.15,142.58 41.17,139.23 37.09,134.22 38.66,132.42 40.22,130.63 46.33,136.77 48.37,138.47 50.4,140.17 53.77,143.58 54.43,143.86 53.72,142.02 51.07,138.99 49.55,136.77 48.04,134.55 43.82,130.63 45.95,128.73 48.08,126.84 52.96,134.41 55.05,136.68 57.13,138.94 60.64,142.68 61.58,144.29 62.3,145.51 64.96,151.52 67.53,154.97 68.34,156.06 69.14,156.89 69.87,157.24 71.04,157.78 75,160.91 79.74,164.94 87.29,171.37 96.82,180.09 100.14,184.27 105.54,191.08 119.47,198.74 119.47,198.74 Z M 119.47,198.74')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier69'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 52.32,146.06 C 47.85,144.36 38.93,133.58 38.93,132.27 38.36,133.08 38.25,135.92 42.38,140.46 46.5,145 50.12,148.5 50.12,148.5 L 52.32,146.06 Z M 52.32,146.06')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier70'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 57.15,144.36 C 56.19,142.05 53.85,139.32 52.29,137.02 50.72,134.71 46.18,129.36 46.64,128.51 45.11,129.43 44.72,131.06 46.96,133.83 49.2,136.59 54.77,144.53 54.77,144.53 L 57.15,144.36 Z M 57.15,144.36')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier71'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 34.96,139.63 C 35.55,141.71 46.33,150.79 47.75,151.19 47.59,152.01 46.71,153.88 46.71,153.88 45.38,152.46 40.91,148.19 39.04,146.65 37.16,145.11 32.76,140.53 34.96,139.63 Z M 34.96,139.63')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier72'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 111.01,211.47 L 104.69,221 C 98.81,216.84 89.55,207.95 84.65,203.18 80.42,199.06 62.01,177.28 58.6,169.43 55.09,166.97 48.65,163.86 45.62,160.88 42.59,157.9 38.75,156.43 36.95,154.92 35.43,153.64 32.76,151.69 32.65,149.95 35.36,152.63 42.36,155.92 45.71,157 46.47,158.94 55.28,165.08 60.87,165.65 63.15,175.39 93.18,206.49 107.67,205.26 L 111.01,211.47 Z M 111.01,211.47')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier73'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 79.74,164.94 C 74.84,162.48 68.04,159.02 66.27,159.55 67.13,158.59 67.49,156.88 67.53,154.97 68.34,156.06 69.14,156.89 69.87,157.24 71.04,157.78 75,160.91 79.74,164.94 Z M 79.74,164.94')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier74'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 100.64,183.88 C 95.3,177.14 73.39,158.18 70.14,156.66 67.93,155.63 64.68,149.04 63.12,145.88 62.66,144.97 62.34,144.31 62.13,143.96 61.25,142.47 58.34,139.31 56.22,137 55.97,136.74 55.74,136.48 55.52,136.24 55.06,135.75 54.47,134.99 53.78,134.11 51.06,130.64 48.83,127.98 46.93,127.81 46.4,127.76 45.91,127.91 45.53,128.26 43.41,130.14 45.92,133.24 47.76,135.51 48.25,136.1 48.71,136.67 49.02,137.13 49.54,137.89 50.17,138.71 50.83,139.58 51.03,139.85 51.23,140.11 51.43,140.37 50.49,139.5 49.55,138.63 48.78,137.98 48.44,137.7 47.99,137.3 47.46,136.82 44.25,133.93 41.21,131.35 39.31,131.46 38.85,131.49 38.46,131.68 38.17,132 36.71,133.69 38.4,137.08 43.67,143.01 44.07,143.45 44.6,143.92 45.2,144.47 45.43,144.67 45.66,144.87 45.91,145.1 45.42,144.76 44.99,144.45 44.69,144.21 39.87,140.36 36.6,138.52 34.98,138.73 34.53,138.79 34.17,139 33.93,139.32 32.4,141.39 36.36,145.46 39.95,148.51 40.2,148.72 40.46,148.94 40.72,149.16 42.04,150.27 43.55,151.55 44.73,152.7 43.42,152.14 41.96,151.4 40.54,150.68 36.34,148.55 33.31,147.02 32.33,148.69 31.03,150.9 33.87,153.22 35.94,154.91 36.15,155.09 36.35,155.25 36.54,155.41 37.27,156.02 38.27,156.6 39.43,157.28 41.27,158.34 43.36,159.55 45.17,161.33 47.15,163.28 50.42,165.21 53.58,167.07 55.26,168.06 56.85,169 58.09,169.85 60.18,174.51 66.94,183.26 70.82,188.1 76.5,195.2 82.09,201.58 84.2,203.64 93.43,212.62 100,218.47 104.32,221.52 L 105.06,220.48 C 100.8,217.47 94.27,211.66 85.1,202.72 80.56,198.31 62.49,176.78 59.19,169.18 L 59.11,169.01 58.97,168.91 C 57.67,168 56,167.02 54.23,165.97 51.28,164.23 47.94,162.26 46.07,160.42 44.14,158.53 41.89,157.22 40.08,156.17 38.97,155.53 38.01,154.98 37.36,154.43 37.17,154.27 36.97,154.1 36.75,153.93 35.23,152.68 32.69,150.6 33.43,149.33 33.43,149.33 33.68,149.05 35.3,149.64 36.59,150.11 38.23,150.94 39.96,151.82 42.35,153.03 44.82,154.28 46.7,154.74 L 47.38,153.76 C 46.32,152.22 43.79,150.08 41.55,148.19 41.28,147.96 41.02,147.75 40.78,147.53 36.21,143.65 34.39,140.85 34.96,140.08 34.97,140.06 35,140.02 35.14,140 35.59,139.94 37.55,140.14 43.89,145.21 44.87,145.99 47.07,147.42 48.52,148.37 49.04,148.71 49.58,149.06 49.66,149.12 49.64,149.11 49.63,149.09 49.62,149.09 L 50.58,148.25 C 48.87,146.03 47.24,144.58 46.06,143.51 45.48,143 44.98,142.55 44.63,142.16 38.43,135.18 38.72,133.32 39.14,132.84 39.18,132.79 39.24,132.75 39.39,132.74 39.41,132.73 39.43,132.73 39.45,132.73 41.01,132.73 44.78,136.13 46.61,137.77 47.14,138.25 47.61,138.67 47.96,138.96 48.83,139.69 49.94,140.73 51.02,141.74 52.93,143.52 54.25,144.88 54.68,145.07 L 55.77,144.85 C 55.77,144.85 53.16,140.54 51.85,138.81 51.2,137.95 50.58,137.14 50.08,136.41 49.73,135.9 49.26,135.32 48.76,134.7 47.24,132.84 45.17,130.28 46.38,129.21 46.5,129.1 46.63,129.06 46.81,129.08 48.31,129.21 51,132.63 52.77,134.9 53.48,135.8 54.09,136.58 54.57,137.11 54.79,137.35 55.03,137.6 55.28,137.87 57.24,140 60.22,143.23 61.03,144.61 61.21,144.92 61.55,145.59 61.97,146.45 64.4,151.36 67.19,156.69 69.6,157.81 72.61,159.22 94.46,178.14 99.64,184.67 105.06,191.5 118.58,198.98 119.16,199.3 L 119.77,198.18 C 119.64,198.1 105.9,190.5 100.64,183.88 Z M 100.64,183.88')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier75'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 46.4,156.45 C 47.74,151.98 51.72,146.28 57.3,144.32 57.3,144.32 53.14,144.11 49.57,148.31 45.68,152.87 46.4,156.45 46.4,156.45 Z M 46.4,156.45')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier76'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$d('M 68.55,158.51 L 67.11,159.53 61.58,163.43 C 58.22,159.17 58.55,152.04 61.58,147.08 61.96,143.43 59.64,141.21 61.06,137.53 61.79,135.62 63.27,135.02 64.56,135.15 65.77,135.27 66.82,136.05 66.93,137.01 67.17,138.99 66.27,141.64 67.41,144.14 68.55,146.65 71.25,153.98 68.55,158.51 Z M 68.55,158.51')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier77'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 68.55,158.51 L 67.11,159.53 C 66.77,159.48 66.48,159.49 66.27,159.55 68.74,156.76 67.13,147.88 65.32,145.42 63.52,142.96 65.99,137.01 64.19,135.45 L 64.56,135.15 C 65.77,135.27 66.82,136.05 66.93,137.01 67.17,138.99 66.27,141.64 67.41,144.14 68.55,146.65 71.25,153.98 68.55,158.51 Z M 68.55,158.51')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier78'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 67.54,139.34 C 67.6,138.49 67.66,137.69 67.57,136.93 67.43,135.73 66.23,134.71 64.72,134.53 63.25,134.34 61.36,134.97 60.46,137.3 59.58,139.6 60.03,141.39 60.47,143.12 60.78,144.34 61.08,145.49 60.96,146.87 58.85,150.4 58.11,154.69 58.77,158.42 59.38,161.82 62.08,163.03 62.08,163.03 59.03,159.17 59.05,152.45 62.13,147.41 L 62.2,147.28 62.22,147.14 C 62.39,145.48 62.05,144.12 61.71,142.81 61.29,141.13 60.92,139.68 61.66,137.76 62.45,135.7 64.08,135.73 64.56,135.79 65.46,135.9 66.23,136.47 66.3,137.08 66.38,137.72 66.32,138.46 66.26,139.25 66.15,140.84 66.02,142.63 66.83,144.41 67.24,145.32 70.8,153.48 68,158.19 68,158.19 70.12,157.86 70.33,154.27 70.6,149.8 68.52,145.05 67.99,143.88 67.32,142.4 67.43,140.84 67.54,139.34 Z M 67.54,139.34')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier79'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$d('M 280.14,169.15 C 278.13,170.37 274.12,171.24 270.67,173.72 267.22,176.21 260.38,178.32 256.54,180.22 251.98,187.46 230.4,206.09 225.66,209.63 220.14,213.77 211.59,219.62 205.24,223.11 204.51,223.52 203.81,223.88 203.15,224.22 L 191.93,199.98 C 191.93,199.98 206.85,194.51 213.23,188.6 219.6,182.69 244.04,167.4 247.25,166.46 250.46,165.51 256.23,156.36 257.41,154.91 258.59,153.46 262.62,150.3 265.03,148.38 267.25,146.6 272.5,140.72 274.73,141.55 L 274.74,141.55 C 274.92,141.62 275.09,141.74 275.23,141.9 277.04,144.1 272.28,147.34 270.45,149.3 268.61,151.27 265.53,153.85 264.55,155.57 L 264.55,155.57 C 265.24,155.39 269.09,152.54 271.36,151.16 273.39,149.94 279.16,145.7 281.28,146.24 281.54,146.3 281.74,146.44 281.88,146.65 283.15,148.66 278.36,153 274.9,155.86 273.67,156.88 271.33,158 268.53,160.57 268.4,160.69 268.27,160.82 268.13,160.95 268.29,160.83 272.86,158.85 274.44,157.95 275.83,157.15 282.16,153.51 284.32,154.04 284.6,154.11 284.82,154.26 284.94,154.48 285.97,156.46 280.31,160.28 277.82,161.81 275.65,163.15 272.73,164.87 271.11,166.27 270.87,166.47 270.66,166.67 270.48,166.86 274.58,166.5 282.39,162.75 284.56,163.48 284.81,163.57 284.98,163.71 285.07,163.93 285.9,166.01 282.15,167.93 280.14,169.15 Z M 280.14,169.15')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier80'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 263.52,156.39 C 263.52,156.39 262.33,155.79 261.64,155.59 262.43,155.4 265.19,151.96 266.97,150.38 268.74,148.81 274.36,143.26 274.61,141.7 L 274.73,141.55 274.74,141.55 C 274.92,141.62 275.09,141.74 275.23,141.9 277.04,144.1 272.28,147.34 270.45,149.3 268.61,151.27 265.53,153.85 264.55,155.57 L 263.52,156.39 Z M 263.52,156.39')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier81'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 281.29,146.86 C 281.3,146.84 281.3,146.57 281.28,146.24 281.54,146.3 281.74,146.44 281.88,146.65 283.15,148.66 278.36,153 274.9,155.86 273.67,156.88 271.33,158 268.53,160.57 268.46,160.62 268.39,160.66 268.32,160.7 268.32,160.7 266.83,158.89 266.22,158.29 270.7,156.98 280.54,147.95 281.29,146.86 Z M 281.29,146.86')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier82'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 269.34,163.14 C 273.36,162.25 283.59,155.91 284.3,154.17 284.31,154.15 284.32,154.11 284.32,154.04 284.6,154.11 284.82,154.26 284.94,154.48 285.97,156.46 280.31,160.28 277.82,161.81 275.65,163.15 272.73,164.87 271.11,166.27 270.93,166.33 270.76,166.39 270.63,166.44 270.63,166.44 269.71,163.67 269.34,163.14 Z M 269.34,163.14')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier83'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 280.14,169.15 C 278.13,170.37 274.12,171.24 270.67,173.72 267.22,176.21 260.38,178.32 256.54,180.22 251.98,187.46 230.4,206.09 225.66,209.63 220.14,213.77 211.59,219.62 205.24,223.11 204.59,217.69 203.84,211.14 203.64,208.19 224.67,205.73 252.14,179.07 253.56,174.63 261.8,174.25 269.49,171.4 270.59,169.63 276.2,169 283.59,164.95 284.3,163.89 284.36,163.77 284.46,163.63 284.56,163.48 284.81,163.57 284.98,163.71 285.07,163.93 285.9,166.01 282.15,167.93 280.14,169.15 Z M 280.14,169.15')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier84'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 277.24,164.41 C 275.72,164.91 274.17,165.42 272.79,165.77 274.13,164.82 275.82,163.78 277.29,162.89 277.59,162.7 277.88,162.53 278.16,162.36 282.17,159.88 286.7,156.46 285.5,154.19 285.31,153.83 284.99,153.57 284.55,153.45 282.98,152.99 279.47,154.32 274.12,157.39 273.79,157.58 273.32,157.82 272.79,158.08 273.06,157.9 273.32,157.73 273.58,157.57 274.26,157.12 274.85,156.74 275.31,156.36 281.42,151.3 283.61,148.2 282.42,146.31 282.19,145.95 281.82,145.7 281.37,145.6 279.52,145.2 276.12,147.3 272.5,149.67 271.91,150.06 271.4,150.39 271.03,150.62 270.16,151.14 269.1,151.85 268.04,152.58 268.28,152.35 268.52,152.12 268.75,151.89 269.54,151.13 270.29,150.41 270.91,149.74 271.3,149.33 271.84,148.84 272.41,148.32 274.57,146.36 277.53,143.68 275.72,141.5 275.39,141.1 274.93,140.87 274.4,140.84 272.49,140.72 269.89,143.02 266.67,146.04 265.86,146.8 265.15,147.46 264.63,147.88 264.38,148.08 264.11,148.3 263.82,148.53 261.37,150.48 258.02,153.16 256.92,154.51 256.66,154.82 256.24,155.42 255.66,156.26 253.63,159.15 249.41,165.16 247.07,165.85 243.63,166.86 219.1,182.29 212.79,188.14 206.59,193.89 191.85,199.32 191.71,199.38 L 192.15,200.58 C 192.76,200.35 207.27,195 213.66,189.07 219.77,183.4 244.25,168 247.43,167.07 249.99,166.32 253.56,161.47 256.7,156.99 257.25,156.21 257.68,155.59 257.91,155.31 258.92,154.07 262.35,151.33 264.62,149.52 264.9,149.29 265.18,149.08 265.43,148.88 265.99,148.43 266.71,147.75 267.55,146.96 269.65,145 272.82,142.02 274.32,142.11 274.5,142.12 274.63,142.18 274.73,142.31 275.76,143.55 273.33,145.76 271.54,147.38 270.96,147.91 270.4,148.42 269.98,148.87 269.37,149.51 268.64,150.22 267.86,150.97 266.3,152.48 264.01,154.92 263.31,156.14 L 264.14,156.55 C 264.6,156.43 266.09,155.46 268.24,153.99 269.46,153.16 270.71,152.3 271.69,151.71 272.08,151.47 272.6,151.13 273.21,150.73 275.29,149.37 279.61,146.53 281.1,146.85 281.25,146.88 281.3,146.94 281.33,146.99 281.67,147.53 281.68,149.42 274.49,155.37 274.09,155.71 273.53,156.07 272.88,156.5 271.54,157.37 269.71,158.56 267.69,160.49 L 268.51,161.46 C 268.5,161.47 268.48,161.48 268.46,161.49 268.56,161.44 269.14,161.18 269.71,160.92 271.29,160.21 273.67,159.13 274.76,158.5 281.8,154.45 283.76,154.55 284.2,154.67 284.33,154.71 284.36,154.76 284.37,154.78 284.81,155.63 282.59,158.12 277.48,161.27 277.21,161.44 276.92,161.62 276.62,161.8 274.12,163.33 271.29,165.06 270.01,166.42 L 270.54,167.49 C 272.46,167.32 275.1,166.46 277.64,165.62 279.49,165.02 281.23,164.45 282.58,164.18 284.26,163.84 284.47,164.16 284.47,164.16 285.01,165.52 282.18,167.2 280.49,168.2 280.25,168.34 280.02,168.48 279.81,168.6 279.09,169.04 278.06,169.45 276.87,169.91 274.92,170.68 272.49,171.63 270.3,173.21 268.17,174.74 264.56,176.18 261.38,177.46 259.48,178.22 257.68,178.94 256.26,179.65 L 256.1,179.73 256,179.88 C 251.51,187 229.78,205.76 225.28,209.12 218.85,213.93 209.1,220.52 202.86,223.65 L 203.44,224.79 C 209.74,221.63 219.58,214.98 226.05,210.15 230.7,206.66 252.13,188.2 256.98,180.71 258.34,180.05 260.05,179.37 261.86,178.64 265.26,177.28 268.79,175.87 271.04,174.24 273.11,172.76 275.35,171.88 277.33,171.1 278.58,170.61 279.66,170.19 280.48,169.69 280.68,169.57 280.91,169.43 281.15,169.29 283.45,167.93 286.6,166.07 285.66,163.69 284.95,161.89 281.72,162.95 277.24,164.41 Z M 277.24,164.41')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier85'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 261.64,155.59 C 266.85,158.38 269.92,164.61 270.57,169.23 270.57,169.23 271.92,166.08 268.98,161.19 265.76,155.84 261.64,155.59 261.64,155.59 Z M 261.64,155.59')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier86'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$d('M 253.23,146.91 C 252.69,148.83 253.18,151.58 251.68,153.89 250.17,156.19 246.39,163.03 248.37,167.92 L 254.5,173.83 C 258.47,170.14 259.23,163.03 256.99,157.67 257.17,154.01 259.8,152.17 258.95,148.31 258.11,144.45 253.76,144.98 253.23,146.91 Z M 253.23,146.91')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier87'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 255.17,145.51 C 258.58,146.98 255.27,155.16 254.04,157.66 256.59,159.79 256.09,170.49 254.07,173.37 256.36,171.94 258.11,168.72 258.39,165.89 258.68,163.05 256.97,158.04 256.97,157.43 258.3,154.68 261.66,145.47 255.17,145.51 Z M 255.17,145.51')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier88'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 259.58,148.17 C 259.05,145.74 257.28,144.83 255.8,144.79 254.28,144.75 252.94,145.57 252.61,146.74 252.41,147.47 252.34,148.27 252.28,149.12 252.15,150.62 252.03,152.18 251.14,153.54 250.48,154.55 247.8,158.45 247.36,162.65 246.91,166.93 248.96,167.68 248.96,167.68 246.91,162.6 251.66,155.08 252.21,154.24 253.28,152.6 253.42,150.81 253.55,149.22 253.61,148.44 253.67,147.69 253.84,147.08 254.01,146.48 254.86,146.04 255.76,146.06 256.24,146.08 257.86,146.29 258.33,148.44 258.77,150.46 258.19,151.84 257.51,153.43 256.98,154.68 256.43,155.96 256.35,157.64 L 256.34,157.78 256.4,157.91 C 258.68,163.36 257.67,170.01 254.07,173.37 254.07,173.37 257.38,172.36 258.4,168.06 259.2,164.74 259.01,160.94 257.64,157.56 257.73,156.18 258.19,155.09 258.68,153.93 259.38,152.29 260.11,150.58 259.58,148.17 Z M 259.58,148.17')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier89'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(132, 193, 40)'),
							$elm$svg$Svg$Attributes$d('M 188.1,237.31 C 185.45,241.84 188.01,254.23 189.05,262.83 190.09,271.43 196.34,283.16 196.25,287.03 196.15,290.91 179.39,301.02 153.05,301.4 149.49,301.45 146.15,301.36 143.04,301.16 123.1,299.87 112.07,293.94 107.48,290.34 102.18,286.18 106.25,269.92 108.81,268.12 108.81,263.78 118.19,235.7 119.42,233.34 113.73,231.92 102.65,227.85 100.09,223.6 100.66,214.05 107.77,196.28 112.6,193.07 116.39,197.6 139.31,205.64 146.42,205.17 L 146.32,205.54 C 146.32,205.54 142.49,213.03 149.59,213.44 159.49,214.01 162.99,207.53 165.27,203.65 168.21,202.33 196.53,194.11 198.9,193.92 202,196.93 207.55,213.87 208.38,222.15 208.51,223.49 208.52,224.61 208.37,225.4 205.06,228.14 190.75,232.77 188.1,237.31 Z M 188.1,237.31')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier90'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(108, 166, 18)'),
							$elm$svg$Svg$Attributes$d('M 188.1,237.31 C 185.45,241.84 188.01,254.23 189.05,262.83 190.09,271.43 196.34,283.16 196.25,287.03 196.15,290.91 179.39,301.02 153.05,301.4 149.49,301.45 146.15,301.36 143.04,301.16 182.92,293.23 180.38,279.12 177.73,277.93 172.33,280.98 160.75,281.76 158.54,280.34 176.31,278.07 182.42,259.57 180.21,255.24 175.17,261.13 165.15,266.8 161.6,266.52 178.65,260.21 182.56,233.41 181.21,230.43 180.5,232.77 179.15,236.24 176.38,236.95 180.5,231.99 179.15,220.86 177.44,219.65 187.82,220.29 196.56,214.9 197.76,210.6 L 208.38,222.15 C 208.51,223.49 208.52,224.61 208.37,225.4 205.06,228.14 190.75,232.77 188.1,237.31 Z M 188.1,237.31')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier91'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(108, 166, 18)'),
							$elm$svg$Svg$Attributes$d('M 118.9,233.41 C 118.9,233.41 124.15,222.09 128.32,217.69 120.13,215.38 110.61,209.51 110.75,208.14 109.71,210.46 105.07,225.4 105.07,227.85 107.01,228.89 118.9,233.41 118.9,233.41 Z M 118.9,233.41')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier92'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(108, 166, 18)'),
							$elm$svg$Svg$Attributes$d('M 159.68,216.75 C 172.61,211.78 189.88,199.8 191.72,196.11 186.54,197.18 167.68,204.06 167.68,204.06 L 159.68,216.75 Z M 159.68,216.75')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier93'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(73, 107, 22)'),
							$elm$svg$Svg$Attributes$d('M 207.78,225.05 C 206.5,226.01 203.78,227.28 200.9,228.61 195.46,231.13 189.3,233.98 187.55,236.99 185.29,240.84 186.57,249.75 187.69,257.61 187.96,259.49 188.21,261.26 188.41,262.91 188.99,267.66 191.07,273.19 192.91,278.07 194.38,281.99 195.65,285.37 195.61,287.02 195.58,288.39 192.03,291.76 184.25,294.94 175.44,298.53 164.36,300.6 153.04,300.76 152.39,300.77 151.73,300.78 151.09,300.78 140.13,300.78 130.35,299.44 122.02,296.79 114.3,294.34 109.85,291.38 107.88,289.84 105.81,288.22 105.47,284.59 105.54,281.83 105.69,275.96 107.88,269.56 109.18,268.65 L 109.45,268.46 109.45,268.13 C 109.45,266.37 111.25,259.66 114.26,250.18 116.27,243.87 118.26,238.07 119.32,235.27 119.63,234.44 120.18,232.86 120.18,232.86 L 119.57,232.72 C 113.19,231.13 103.23,227.22 100.74,223.44 101.38,214.1 107.98,197.68 112.52,193.92 117.34,198.6 137.86,205.65 145.49,205.82 144.99,207.02 144.04,209.85 145.22,211.9 145.98,213.22 147.44,213.95 149.55,214.07 149.97,214.1 150.39,214.11 150.79,214.11 159.9,214.11 163.49,207.96 165.64,204.29 L 165.72,204.16 C 169.4,202.64 194.98,195.23 198.66,194.59 200.24,196.4 202.66,202.1 204.77,209.03 206.96,216.22 208.12,222.44 207.78,225.05 Z M 199.35,193.46 L 199.14,193.26 198.85,193.28 C 196.51,193.47 168.04,201.7 165.01,203.07 L 164.82,203.16 164.53,203.65 C 162.39,207.3 159.16,212.83 150.79,212.83 L 150.79,212.83 C 150.41,212.83 150.02,212.82 149.63,212.8 147.97,212.7 146.86,212.19 146.33,211.27 145.17,209.26 146.88,205.87 146.89,205.83 L 146.93,205.77 147.25,204.47 146.37,204.53 C 146.19,204.54 145.99,204.55 145.78,204.55 137.91,204.55 116.52,196.77 113.09,192.66 L 112.72,192.22 112.24,192.53 C 109.89,194.1 106.87,199.03 104.15,205.72 101.52,212.19 99.72,219.03 99.45,223.56 L 99.44,223.76 99.54,223.93 C 102.34,228.58 113.79,232.48 118.54,233.77 116.6,238.61 108.52,262.7 108.18,267.82 106.33,269.59 104.4,276.37 104.26,281.79 104.18,284.85 104.6,288.9 107.09,290.84 109.12,292.44 113.72,295.5 121.63,298.01 130.08,300.69 139.99,302.05 151.09,302.05 151.74,302.05 152.4,302.05 153.06,302.04 164.54,301.87 175.78,299.77 184.73,296.12 191.94,293.18 196.83,289.53 196.89,287.05 196.93,285.15 195.68,281.83 194.1,277.63 192.29,272.81 190.24,267.35 189.68,262.75 189.48,261.09 189.23,259.32 188.96,257.43 187.86,249.78 186.62,241.1 188.65,237.63 190.21,234.97 196.43,232.09 201.44,229.77 204.67,228.27 207.47,226.97 208.78,225.89 L 208.96,225.74 209,225.51 C 209.59,222.31 207.83,214.7 205.99,208.65 204.24,202.93 201.46,195.51 199.35,193.46 Z M 199.35,193.46')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier94'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(73, 107, 22)'),
							$elm$svg$Svg$Attributes$d('M 117.78,235.86 L 119.01,236.07 C 119.57,234.24 123.27,225.32 124.51,223 124.51,223 121.9,225.32 119.71,230.79 118.81,233.06 118.02,235.07 117.78,235.86 Z M 117.78,235.86')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier95'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(230, 230, 230)'),
							$elm$svg$Svg$Attributes$d('M 112.6,193.07 C 107.77,196.28 100.66,214.05 100.09,223.6 100.93,225 102.69,226.37 104.88,227.64 107.49,214.03 112.84,203.76 117.44,196.41 115.16,195.21 113.42,194.05 112.6,193.07 Z M 112.6,193.07')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier96'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(179, 179, 179)'),
							$elm$svg$Svg$Attributes$d('M 104.73,205.19 C 106.34,207.55 109.04,208.99 110.99,208.62 109.9,210.22 105.07,224.45 105.07,227.1 103.83,227.19 100.42,225.21 100.09,223.6 99.81,221.61 103.41,207.69 104.73,205.19 Z M 104.73,205.19')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier97'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(102, 102, 102)'),
							$elm$svg$Svg$Attributes$d('M 104.43,226.63 C 102.64,225.51 101.41,224.44 100.74,223.44 101.38,214.1 107.98,197.68 112.52,193.92 113.36,194.74 114.71,195.65 116.54,196.65 112.56,203.09 107.19,213 104.43,226.63 Z M 113.09,192.66 L 112.72,192.22 112.24,192.53 C 109.89,194.1 106.87,199.03 104.15,205.72 101.52,212.19 99.72,219.03 99.45,223.56 L 99.44,223.76 99.54,223.93 C 100.37,225.31 102.06,226.74 104.56,228.19 L 105.33,228.65 105.5,227.76 C 108.25,213.46 113.94,203.21 117.98,196.74 L 118.35,196.16 117.74,195.84 C 114.81,194.31 113.59,193.26 113.09,192.66 Z M 113.09,192.66')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier98'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(230, 230, 230)'),
							$elm$svg$Svg$Attributes$d('M 149.59,213.44 C 142.49,213.03 146.32,205.54 146.32,205.54 L 146.42,205.17 C 145.08,205.25 143.19,205.04 140.96,204.61 138.65,210.12 137.82,217.92 145.56,219.72 156.67,222.31 166.33,216.86 169.95,202.06 167.6,202.8 165.88,203.38 165.27,203.65 163,207.53 159.49,214.01 149.59,213.44 Z M 149.59,213.44')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier99'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(179, 179, 179)'),
							$elm$svg$Svg$Attributes$d('M 156.27,212.44 C 162.52,210.03 164.28,215.38 157.03,219.06 164.04,216.04 168.11,210.55 169.44,204.22 165.55,203.94 163.66,205.73 163.66,205.73 163.56,208.1 159.82,211.07 156.27,212.44 Z M 156.27,212.44')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier100'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(60, 92, 10)'),
							$elm$svg$Svg$Attributes$d('M 148.24,206.16 C 148.67,208.69 147.15,211.78 146.13,212.35 145.16,210.7 145.8,207.25 145.8,207.25 L 148.24,206.16 Z M 148.24,206.16')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier101'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 148.41,206.73 C 148.41,209.51 146.8,211.88 146.32,212.49 148.03,213.72 151.06,214.67 155.28,212.87 159.49,211.07 162,209.37 163.66,205.73 160.15,204.22 148.41,206.73 148.41,206.73 Z M 148.41,206.73')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier102'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 147.08,202.09 C 147.99,204.43 147.93,209.54 145.75,212.23 L 146.75,213.03 C 149.34,209.82 149.29,204.25 148.27,201.63 L 147.08,202.09 Z M 147.08,202.09')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier103'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(102, 102, 102)'),
							$elm$svg$Svg$Attributes$d('M 150.73,219.71 C 149.12,219.71 147.43,219.5 145.71,219.1 143.36,218.56 141.72,217.39 140.82,215.63 139.07,212.23 140.47,207.59 141.36,205.33 142.99,205.63 144.38,205.8 145.49,205.82 144.99,207.02 144.04,209.85 145.22,211.9 145.98,213.22 147.44,213.95 149.55,214.07 149.97,214.1 150.39,214.11 150.79,214.11 L 150.79,214.11 C 159.9,214.11 163.49,207.96 165.64,204.29 L 165.72,204.16 C 166.15,203.98 167.09,203.65 169.04,203.02 166.09,213.79 159.62,219.71 150.73,219.71 Z M 165.01,203.07 L 164.82,203.16 164.53,203.65 C 162.39,207.3 159.16,212.83 150.79,212.83 L 150.79,212.83 C 150.41,212.83 150.02,212.82 149.63,212.8 147.97,212.7 146.86,212.19 146.33,211.27 145.17,209.26 146.88,205.87 146.89,205.83 L 146.93,205.77 147.25,204.47 146.37,204.53 C 146.19,204.54 145.99,204.55 145.78,204.55 144.59,204.55 143.01,204.36 141.09,203.98 L 140.57,203.88 140.37,204.36 C 139.46,206.55 137.55,212.07 139.68,216.21 140.76,218.32 142.69,219.71 145.42,220.35 147.23,220.77 149.02,220.98 150.73,220.98 L 150.73,220.98 C 155.45,220.98 159.56,219.42 162.95,216.34 166.5,213.11 169.07,208.36 170.57,202.21 L 170.84,201.11 169.76,201.45 C 167.21,202.25 165.61,202.8 165.01,203.07 Z M 165.01,203.07')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier104'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(230, 230, 230)'),
							$elm$svg$Svg$Attributes$d('M 192.37,195.52 C 196.08,201.77 200.71,218.89 200.66,229.42 204.02,227.87 207.06,226.48 208.37,225.4 209.42,219.72 202.5,197.41 198.9,193.92 198.26,193.97 195.75,194.6 192.37,195.52 Z M 192.37,195.52')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier105'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(179, 179, 179)'),
							$elm$svg$Svg$Attributes$d('M 205.39,207.86 C 203.64,211.88 199.99,211.64 197.76,210.6 198.62,212.16 200.8,226.34 200.61,228.66 203.12,228.94 208.42,225.92 208.75,224.78 209.08,223.65 205.39,207.86 205.39,207.86 Z M 205.39,207.86')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier106'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(102, 102, 102)'),
							$elm$svg$Svg$Attributes$d('M 207.78,225.05 C 206.56,225.97 204.02,227.16 201.29,228.43 201.19,223.63 200.2,217.25 198.55,210.71 197,204.6 195.08,199.17 193.33,195.92 196.75,195 198.12,194.69 198.66,194.59 200.24,196.41 202.66,202.1 204.77,209.03 206.96,216.22 208.12,222.44 207.78,225.05 Z M 199.35,193.46 L 199.14,193.26 198.85,193.28 C 198.21,193.33 195.97,193.88 192.2,194.9 L 191.39,195.12 191.82,195.84 C 195.47,201.99 200.07,219.03 200.02,229.42 L 200.02,230.42 201.44,229.77 C 204.67,228.27 207.47,226.97 208.78,225.89 L 208.96,225.74 209,225.51 C 209.59,222.31 207.83,214.7 205.99,208.65 204.24,202.93 201.46,195.51 199.35,193.46 Z M 199.35,193.46')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier107'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(73, 107, 22)'),
							$elm$svg$Svg$Attributes$d('M 185.25,227.19 C 185.62,228.81 186.79,236.17 186.4,241.37 L 187.6,241.74 C 187.71,240.35 187.69,238.79 187.65,237.21 187.46,230.15 185.25,227.19 185.25,227.19 Z M 185.25,227.19')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier108'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(73, 107, 22)'),
							$elm$svg$Svg$Attributes$d('M 175.41,258.86 C 167.95,264.96 155.6,270.61 143.32,268.16 143.32,268.16 145.8,270.02 149.33,270.02 159.85,270.04 169.8,265.1 176.22,259.85 179.11,257.48 181.39,255.05 182.74,252.76 184.1,250.46 183.1,247.99 183.1,247.99 183.1,250.77 180.08,255.03 175.41,258.86 Z M 175.41,258.86')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier109'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(73, 107, 22)'),
							$elm$svg$Svg$Attributes$d('M 114,280.23 C 111.18,277.4 110.12,273.45 109.72,270.76 109.47,269.07 109.45,267.81 109.46,267.68 L 108.2,267.74 C 108.15,270.84 109.13,277.16 113.09,281.13 114.22,282.26 115.5,283.18 116.97,283.78 120.48,285.21 123.38,283.7 123.38,283.7 119.49,283.75 116.33,282.57 114,280.23 Z M 114,280.23')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier110'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(73, 107, 22)'),
							$elm$svg$Svg$Attributes$d('M 141.31,275.4 C 132,270.33 125.62,261.78 122.88,250.67 122.88,250.67 122.34,254.93 125.31,260.8 128.73,267.59 134.03,272.89 140.7,276.52 146.83,279.85 153.93,281.53 161.37,281.53 164.48,281.53 167.66,281.33 170.81,280.65 176.22,279.48 178.32,277.35 178.32,277.35 165.3,281.82 151.81,281.11 141.31,275.4 Z M 141.31,275.4')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier111'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 227.61,83.74 C 235.42,86.57 244.94,100.47 242.38,114.37 239.84,128.18 230.98,147.59 207.44,168.7 207.3,168.84 207.15,168.97 207,169.1 L 203.42,168.89 198.37,168.6 99.43,162.86 C 86.92,153.93 78.68,135.78 79.25,113.66 79.82,91.54 111.84,35.86 118.38,34.72 133.63,21.2 170.39,30.18 183.08,35.76 188.04,37.94 193.87,42.38 199.08,47.48 207.21,55.44 213.84,65 213.32,70.05 221.64,53.89 235.21,55.38 241.96,65.44 233.36,61.4 221.28,71.12 218.94,76.72 231.58,67.64 244.59,77.85 244.09,89.27 242.17,83.45 229.88,80.47 227.61,83.74 Z M 227.61,83.74')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier112'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 227.61,83.74 C 235.42,86.57 244.94,100.47 242.38,114.37 239.84,128.18 230.98,147.59 207.44,168.7 206.06,168.81 204.71,168.88 203.42,168.89 201.62,168.92 199.92,168.85 198.33,168.68 198.35,168.65 198.36,168.63 198.37,168.6 205.04,156.96 212.39,136.61 209.56,126.84 210.69,127.27 213.68,137.34 215.38,142.58 216.24,132.94 223.13,117.2 221.07,109.76 223.27,111.03 226.68,124.01 223.7,129.25 233.86,119.12 233.29,95.93 227.68,93.45 229.1,93.1 233.5,94.09 235.92,96.78 234.07,92.74 225.47,85.86 219.65,88.77 224.98,78.7 231.37,78.07 240.54,82.39 232.51,70.55 222.77,76.08 214.32,82.04 216.8,70.76 224.27,65.23 236.7,62.47 230.3,61.19 222.84,63.03 218.58,69.98 218.65,69.77 219.36,65.16 220.14,64.03 214.6,65.87 213.39,77.64 205.86,86.43 209.89,74.02 206.31,58.76 199.08,47.48 207.21,55.44 213.84,65 213.32,70.05 221.64,53.89 235.21,55.38 241.96,65.44 233.36,61.4 221.28,71.12 218.94,76.72 231.58,67.64 244.59,77.85 244.09,89.27 242.17,83.45 229.88,80.47 227.61,83.74 Z M 227.61,83.74')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier113'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(31, 16, 8)'),
							$elm$svg$Svg$Attributes$d('M 236.18,74.42 C 231.39,71.84 225.9,72 220.8,74.79 223.08,71.65 227.45,68 232.06,66.23 234.58,65.26 238.31,64.44 241.68,66.02 L 243.77,67 242.49,65.09 C 239,59.88 233.73,56.95 228.4,57.26 222.8,57.58 217.68,61.32 213.82,67.84 213,63.72 209.42,57.83 203.76,51.46 197.18,44.06 189.35,37.82 183.34,35.18 176.6,32.22 164.22,28.68 151.75,27.45 141.08,26.39 126.6,26.7 118.07,34.14 116.27,34.64 113.23,37.98 109.06,44.06 105.02,49.95 100.38,57.75 96.01,66.02 91.21,75.11 87.08,84.07 84.09,91.92 80.59,101.1 78.75,108.4 78.61,113.64 78.34,124.37 80.15,134.68 83.85,143.45 87.43,151.94 92.69,158.83 99.06,163.38 L 99.8,162.34 C 86.98,153.19 79.35,134.54 79.89,113.67 80.13,104.19 86.58,86.59 97.14,66.62 107.05,47.87 115.93,35.79 118.49,35.35 L 118.66,35.32 118.8,35.2 C 126.96,27.97 141.15,27.68 151.62,28.71 163.95,29.93 176.17,33.42 182.82,36.35 188.68,38.92 196.33,45.04 202.8,52.31 209.27,59.59 213.06,66.36 212.69,69.99 L 212.34,73.36 213.89,70.34 C 217.64,63.05 222.82,58.86 228.47,58.53 232.76,58.29 237.03,60.36 240.2,64.16 237.63,63.55 234.7,63.85 231.6,65.04 225.37,67.43 219.87,72.84 218.35,76.47 L 217.48,78.55 219.31,77.24 C 224.6,73.44 230.52,72.83 235.57,75.55 239.77,77.81 242.68,82.11 243.33,86.72 241.14,84.17 237.13,82.43 233.56,81.91 230.41,81.45 228.05,81.98 227.08,83.37 L 226.6,84.05 227.39,84.34 C 231.23,85.73 235.42,89.9 238.32,95.21 241.67,101.34 242.89,108.1 241.75,114.25 239.44,126.82 231.46,146.45 206.57,168.63 L 207.43,169.58 C 232.58,147.16 240.66,127.25 243.01,114.48 244.2,108.04 242.93,100.98 239.45,94.6 236.64,89.46 232.64,85.33 228.8,83.54 229.75,83.03 231.4,82.89 233.37,83.17 237.46,83.77 242.4,86.18 243.48,89.47 L 244.58,92.78 244.73,89.29 C 244.86,86.29 244.1,83.29 242.54,80.61 241,77.98 238.8,75.84 236.18,74.42 Z M 236.18,74.42')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier114'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$d('M 86.51,147.66 C 84.3,159.3 94.58,170.91 102.78,167.76 102.46,162.73 101.63,148.6 101.63,148.6 101.63,148.6 88.71,136.02 86.51,147.66 Z M 86.51,147.66')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier115'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 87.76,144.41 C 95.99,143.72 98.38,153.93 96.58,160.52 96.06,162.45 94.79,164.67 92.67,165.23 95.73,167.87 99.43,169.05 102.78,167.76 102.46,162.73 101.63,148.6 101.63,148.6 101.63,148.6 91.69,138.92 87.76,144.41 Z M 87.76,144.41')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier116'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 90.99,146.85 C 88.21,147.49 88.65,151.12 88.65,151.12 88.66,151.1 88.76,148.4 91.17,147.89 92.33,147.64 94.16,148.89 95.75,151.13 L 96.22,149.99 C 94.35,147.64 92.57,146.49 90.99,146.85 Z M 90.99,146.85')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier117'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 92.59,149.28 C 91.06,150.48 91.1,153.15 91.1,153.27 91.1,153.27 91.68,150.44 93.19,149.83 93.73,149.61 94.31,149.67 95.1,149.88 L 95.37,148.87 C 94.26,148.57 93.32,148.71 92.59,149.28 Z M 92.59,149.28')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier118'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 99.94,167.76 L 99.94,167.76 C 96.91,167.76 93.68,165.97 91.1,162.86 87.56,158.6 86.04,152.96 87.02,147.76 87.6,144.72 88.92,143.25 91.07,143.25 94.95,143.25 100.19,147.97 101.12,148.84 101.22,150.56 101.92,162.48 102.23,167.4 101.49,167.64 100.73,167.76 99.94,167.76 Z M 102.16,148.57 L 102.15,148.37 102,148.23 C 101.75,147.98 95.75,142.2 91.07,142.2 89.22,142.2 86.83,143.13 85.99,147.56 84.95,153.06 86.55,159.03 90.29,163.53 93.07,166.89 96.59,168.81 99.94,168.81 L 99.94,168.81 C 100.98,168.81 102,168.62 102.96,168.25 L 103.32,168.11 103.3,167.73 C 102.99,162.76 102.17,148.71 102.16,148.57 Z M 102.16,148.57')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier119'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 91.08,141.7 C 93.71,143.82 96.94,150.67 97.01,155.84 98.97,152.33 97.83,144.5 97.83,144.04 97.83,143.58 92.86,141.13 91.08,141.7 Z M 91.08,141.7')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier120'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(31, 16, 8)'),
							$elm$svg$Svg$Attributes$d('M 91.27,141.94 C 93.59,143.91 95.24,147.88 96.02,153.42 96.65,157.8 96.62,162.57 96.31,165.34 L 97.58,165.48 C 97.87,162.84 97.97,158.04 97.29,153.24 96.92,150.6 96.46,148.27 95.63,146.4 94.03,142.77 91.27,141.94 91.27,141.94 Z M 91.27,141.94')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier121'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 174.97,46.89 L 86.92,107.42 C 86.82,107.48 86.69,107.57 86.55,107.68 83.93,109.64 75.15,118.24 75.41,129.25 75.11,128.61 74.82,127.97 74.56,127.33 68.02,111.6 72.82,96.6 79.41,88.08 79.08,88.19 78.74,88.31 78.41,88.44 69.88,91.78 61.93,102.61 60.64,107.28 60.42,105.54 60.31,103.85 60.27,102.19 59.88,82.28 71.82,67.69 85.95,58.67 80.6,58.79 73.62,59.99 69.25,62.84 102.07,23.92 160.26,30.3 174.97,46.89 Z M 174.97,46.89')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier122'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 78.41,88.44 C 69.88,91.78 61.93,102.61 60.64,107.28 60.42,105.54 60.31,103.85 60.27,102.19 66.08,90.55 80.87,82.37 85.57,83.24 82.59,84.38 78.47,88.35 78.47,88.35 78.47,88.35 78.45,88.38 78.41,88.44 Z M 78.41,88.44')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier123'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 88.06,101.93 C 87.07,104.55 86.59,107.43 86.55,107.68 83.93,109.64 75.15,118.24 75.41,129.25 75.11,128.61 74.82,127.97 74.56,127.33 74.89,112.73 83.03,104.4 88.06,101.93 Z M 88.06,101.93')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier124'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(31, 16, 8)'),
							$elm$svg$Svg$Attributes$d('M 169.15,41.39 C 166.21,39.63 162.7,38.08 158.72,36.81 151.08,34.38 142.24,33.15 133.15,33.26 121.52,33.4 109.87,35.76 99.47,40.07 87.37,45.09 77.04,52.61 68.76,62.43 L 65.95,65.76 69.6,63.38 C 73.13,61.07 78.65,59.82 83.52,59.43 79.53,62.2 75.92,65.36 72.81,68.72 68.04,73.87 64.51,79.57 62.31,85.66 59.86,92.47 59.08,99.77 60,107.35 L 60.39,110.55 61.25,107.45 C 61.86,105.28 64.29,101 68.21,96.75 71.3,93.41 74.54,90.92 77.61,89.48 75.51,92.59 73.8,96.18 72.64,99.93 70.5,106.81 69.15,117.53 74.84,129.53 L 76.13,132.25 76.05,129.24 C 75.91,123.25 78.58,118.09 80.84,114.82 83.42,111.09 86.29,108.59 87.27,107.95 L 86.58,106.88 C 84.74,108.06 76.03,115.83 74.89,126.46 70.68,115.86 71.94,106.49 73.86,100.3 76.17,92.84 80.82,86.04 85.7,83 85.7,83 82.4,83.41 79.02,87.54 73.98,89.22 69.57,93.39 67.27,95.89 64.64,98.75 62.35,101.97 61.02,104.62 58.76,72.89 87.38,55.82 105.08,50.67 105.08,50.67 100.23,50.77 94.15,53.44 91.16,54.76 88.29,56.31 85.58,58.05 81.38,58.17 76.22,58.92 72.01,60.68 87.13,44.32 109.22,34.83 133.17,34.54 142.12,34.43 150.82,35.63 158.33,38.02 165.55,40.33 171.14,43.54 174.49,47.31 174.49,47.31 173.71,44.14 169.15,41.39 Z M 169.15,41.39')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier125'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(254, 209, 167)'),
							$elm$svg$Svg$Attributes$d('M 197.14,189.89 C 185.63,205.2 149.55,207.65 139.88,207.86 133.84,207.99 120.28,202.26 110.28,194.3 105.7,190.64 101.87,186.53 99.86,182.29 93.79,169.51 99.52,150.19 97.16,141.21 95.87,136.33 95.28,130.64 95.32,125.41 95.35,121.03 95.82,116.96 96.68,113.99 L 122.54,94.39 199.27,93.54 207.37,128.64 C 208.86,135.23 208.65,174.58 197.14,189.89 Z M 197.14,189.89')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier126'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 135.16,200.64 C 135.16,200.64 139.86,205.01 145.62,200.62 144.88,202.93 142.4,204.52 140.37,204.47 137.88,204.4 136,202.48 135.16,200.64 Z M 135.16,200.64')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier127'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 140.27,203.09 C 136.95,202.96 135.24,200.63 135.24,200.63 138.36,202.52 142.35,202.48 145.66,200.52 145.66,200.52 143.62,203.23 140.27,203.09 Z M 140.27,203.09')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier128'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 181.34,139.15 C 181.34,139.15 173.65,125.68 158.1,131.17 159.39,129.05 166.48,124.54 173.8,128.62 179.41,131.75 181.34,139.15 181.34,139.15 Z M 181.34,139.15')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier129'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$d('M 154.57,164.56 C 154.57,164.56 152.66,152.8 161.65,145.74 169.03,139.94 176.42,144.25 176.38,153.97 176.34,162.09 171.37,168.09 154.57,164.56 Z M 154.57,164.56')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier130'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(229, 229, 229)'),
							$elm$svg$Svg$Attributes$d('M 161.65,145.74 C 152.66,152.8 154.57,164.56 154.57,164.56 155.36,161.33 156.07,159.22 157.01,156.96 159.98,149.9 166.77,145.01 172.58,148.45 175.59,150.31 176.23,156.75 174.08,160.76 174.77,159.15 176.38,158.11 176.38,153.97 176.37,144.25 169.03,139.94 161.65,145.74 Z M 161.65,145.74')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval7'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(96, 75, 59)'),
							$elm$svg$Svg$Attributes$cx('166.2'),
							$elm$svg$Svg$Attributes$cy('157.57'),
							$elm$svg$Svg$Attributes$rx('6.65'),
							$elm$svg$Svg$Attributes$ry('7.4')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier131'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(72, 56, 44)'),
							$elm$svg$Svg$Attributes$d('M 163.55,152.72 C 161.96,153.04 160.64,153.81 159.58,154.91 160.5,151.81 163.1,149.56 166.17,149.56 169.53,149.56 172.33,152.25 172.96,155.82 171.09,152.65 167.04,151.98 163.55,152.72 Z M 163.55,152.72')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier132'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 183, 177)'),
							$elm$svg$Svg$Attributes$d('M 169.22,157.52 C 169.22,157.52 171.82,157.91 170.64,160.77 169.47,163.64 165.28,164.78 162.77,162.5 160.25,160.22 161.34,157.56 162.75,157.48 164.16,157.41 169.22,157.52 169.22,157.52 Z M 169.22,157.52')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier133'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(48, 38, 30)'),
							$elm$svg$Svg$Attributes$d('M 159.73,157.35 C 159.73,161.35 162.61,164.59 166.17,164.59 169.72,164.59 172.61,161.35 172.61,157.35 172.61,153.36 169.72,150.12 166.17,150.12 162.61,150.12 159.73,153.36 159.73,157.35 Z M 158.74,157.35 C 158.74,152.75 162.07,149.01 166.17,149.01 170.26,149.01 173.59,152.75 173.59,157.35 173.59,161.95 170.26,165.7 166.17,165.7 162.07,165.7 158.74,161.95 158.74,157.35 Z M 158.74,157.35')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval8'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(26, 26, 26)'),
							$elm$svg$Svg$Attributes$cx('166.25'),
							$elm$svg$Svg$Attributes$cy('157.52'),
							$elm$svg$Svg$Attributes$rx('4.4'),
							$elm$svg$Svg$Attributes$ry('4.75')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval9'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$cx('-0'),
							$elm$svg$Svg$Attributes$cy('0'),
							$elm$svg$Svg$Attributes$rx('1.67'),
							$elm$svg$Svg$Attributes$ry('1.88'),
							$elm$svg$Svg$Attributes$transform('translate(163.6, 154.69) rotate(0.05)')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval10'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$cx('168.2'),
							$elm$svg$Svg$Attributes$cy('160.77'),
							$elm$svg$Svg$Attributes$rx('0.85'),
							$elm$svg$Svg$Attributes$ry('1.05')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier134'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(81, 33, 15)'),
							$elm$svg$Svg$Attributes$d('M 161.99,146.17 C 154.25,152.25 154.86,162.07 155.07,164.1 158.15,164.72 160.92,165.04 163.32,165.04 L 163.32,165.04 C 171.59,165.04 175.79,161.32 175.82,153.97 175.84,150.45 174.84,147.49 173,145.65 171.71,144.36 170.08,143.68 168.27,143.68 166.24,143.68 164.07,144.54 161.99,146.17 Z M 154.46,165.1 L 154.09,165.02 154.03,164.65 C 154.01,164.52 153.54,161.57 154.19,157.7 154.8,154.12 156.52,149.06 161.3,145.31 163.58,143.52 165.99,142.57 168.27,142.57 170.38,142.57 172.28,143.37 173.78,144.87 175.83,146.92 176.95,150.16 176.93,153.98 176.89,161.94 172.19,166.14 163.32,166.14 L 163.32,166.14 C 160.74,166.14 157.76,165.79 154.46,165.1 Z M 154.46,165.1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier135'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 177.77,144.82 C 177.77,144.82 172.46,137.42 164.56,139.71 159.2,141.26 156.4,146.84 156.4,146.84 156.4,146.84 165.88,133.51 177.77,144.82 Z M 177.77,144.82')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier136'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 103.45,140.92 C 103.45,140.92 106.53,128.25 121.88,131.84 120.83,128.66 113,125.93 107.05,132.3 102.77,136.88 103.45,140.92 103.45,140.92 Z M 103.45,140.92')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier137'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 105.38,148.82 C 105.38,148.82 107.1,139 116.22,140.75 122.91,142.04 124.12,147.51 124.12,147.51 122.48,142.42 109.94,136.38 105.38,148.82 Z M 105.38,148.82')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval11'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('109.35'),
							$elm$svg$Svg$Attributes$cy('170.37'),
							$elm$svg$Svg$Attributes$rx('0.9'),
							$elm$svg$Svg$Attributes$ry('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval12'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('114.75'),
							$elm$svg$Svg$Attributes$cy('170.42'),
							$elm$svg$Svg$Attributes$r('0.75')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval13'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('120.2'),
							$elm$svg$Svg$Attributes$cy('171.17'),
							$elm$svg$Svg$Attributes$rx('0.5'),
							$elm$svg$Svg$Attributes$ry('0.9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval14'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('117.6'),
							$elm$svg$Svg$Attributes$cy('173.42'),
							$elm$svg$Svg$Attributes$r('0.55')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval15'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('111.55'),
							$elm$svg$Svg$Attributes$cy('174.87'),
							$elm$svg$Svg$Attributes$r('0.55')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval16'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('113.95'),
							$elm$svg$Svg$Attributes$cy('173.02'),
							$elm$svg$Svg$Attributes$r('0.75')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group2'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M 116.9,181.66 C 115.76,181.66 114.57,181.56 113.36,181.36 106.17,180.18 100.95,175.75 101.71,171.48 102.33,167.93 106.88,165.6 112.53,165.6 113.68,165.6 114.87,165.7 116.08,165.9 123.26,167.08 128.48,171.51 127.73,175.78 127.1,179.33 122.55,181.66 116.9,181.66 Z M 111.1,174.06 C 110.86,174.06 110.67,174.24 110.67,174.47 110.67,174.7 110.86,174.88 111.1,174.88 111.33,174.88 111.52,174.7 111.52,174.47 111.52,174.24 111.33,174.06 111.1,174.06 Z M 113.55,172.54 C 113.23,172.54 112.98,172.79 112.98,173.09 112.98,173.4 113.23,173.65 113.55,173.65 113.86,173.65 114.11,173.4 114.11,173.09 114.11,172.79 113.86,172.54 113.55,172.54 Z M 117.34,172.61 C 117.11,172.61 116.92,172.8 116.92,173.03 116.92,173.25 117.11,173.44 117.34,173.44 117.58,173.44 117.77,173.25 117.77,173.03 117.77,172.8 117.58,172.61 117.34,172.61 Z M 119.86,170.44 C 119.47,170.44 119.15,170.75 119.15,171.13 119.15,171.51 119.47,171.82 119.86,171.82 120.25,171.82 120.57,171.51 120.57,171.13 120.57,170.75 120.25,170.44 119.86,170.44 Z M 114.36,170.03 C 114.05,170.03 113.8,170.28 113.8,170.58 113.8,170.89 114.05,171.13 114.36,171.13 114.68,171.13 114.93,170.89 114.93,170.58 114.93,170.28 114.68,170.03 114.36,170.03 Z M 109.4,169.72 C 109,169.72 108.69,170.03 108.69,170.41 108.69,170.79 109,171.1 109.4,171.1 109.79,171.1 110.11,170.79 110.11,170.41 110.11,170.03 109.79,169.72 109.4,169.72 Z M 109.4,169.72')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-bezier138'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient7-bezier138)'),
									$elm$svg$Svg$Attributes$d('M 116.9,181.66 C 115.76,181.66 114.57,181.56 113.36,181.36 106.17,180.18 100.95,175.75 101.71,171.48 102.33,167.93 106.88,165.6 112.53,165.6 113.68,165.6 114.87,165.7 116.08,165.9 123.26,167.08 128.48,171.51 127.73,175.78 127.1,179.33 122.55,181.66 116.9,181.66 Z M 111.1,174.06 C 110.86,174.06 110.67,174.24 110.67,174.47 110.67,174.7 110.86,174.88 111.1,174.88 111.33,174.88 111.52,174.7 111.52,174.47 111.52,174.24 111.33,174.06 111.1,174.06 Z M 113.55,172.54 C 113.23,172.54 112.98,172.79 112.98,173.09 112.98,173.4 113.23,173.65 113.55,173.65 113.86,173.65 114.11,173.4 114.11,173.09 114.11,172.79 113.86,172.54 113.55,172.54 Z M 117.34,172.61 C 117.11,172.61 116.92,172.8 116.92,173.03 116.92,173.25 117.11,173.44 117.34,173.44 117.58,173.44 117.77,173.25 117.77,173.03 117.77,172.8 117.58,172.61 117.34,172.61 Z M 119.86,170.44 C 119.47,170.44 119.15,170.75 119.15,171.13 119.15,171.51 119.47,171.82 119.86,171.82 120.25,171.82 120.57,171.51 120.57,171.13 120.57,170.75 120.25,170.44 119.86,170.44 Z M 114.36,170.03 C 114.05,170.03 113.8,170.28 113.8,170.58 113.8,170.89 114.05,171.13 114.36,171.13 114.68,171.13 114.93,170.89 114.93,170.58 114.93,170.28 114.68,170.03 114.36,170.03 Z M 109.4,169.72 C 109,169.72 108.69,170.03 108.69,170.41 108.69,170.79 109,171.1 109.4,171.1 109.79,171.1 110.11,170.79 110.11,170.41 110.11,170.03 109.79,169.72 109.4,169.72 Z M 109.4,169.72')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group3'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip2)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$ellipse,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('109.35'),
											$elm$svg$Svg$Attributes$cy('170.37'),
											$elm$svg$Svg$Attributes$rx('0.9'),
											$elm$svg$Svg$Attributes$ry('0.5')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$ellipse,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval17'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval17)'),
									$elm$svg$Svg$Attributes$cx('109.35'),
									$elm$svg$Svg$Attributes$cy('170.37'),
									$elm$svg$Svg$Attributes$rx('0.9'),
									$elm$svg$Svg$Attributes$ry('0.5')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group4'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip3)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('114.75'),
											$elm$svg$Svg$Attributes$cy('170.42'),
											$elm$svg$Svg$Attributes$r('0.75')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval19'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval19)'),
									$elm$svg$Svg$Attributes$cx('114.75'),
									$elm$svg$Svg$Attributes$cy('170.42'),
									$elm$svg$Svg$Attributes$r('0.75')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group5'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip4)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$ellipse,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('120.2'),
											$elm$svg$Svg$Attributes$cy('171.17'),
											$elm$svg$Svg$Attributes$rx('0.5'),
											$elm$svg$Svg$Attributes$ry('0.9')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$ellipse,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval21'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval21)'),
									$elm$svg$Svg$Attributes$cx('120.2'),
									$elm$svg$Svg$Attributes$cy('171.17'),
									$elm$svg$Svg$Attributes$rx('0.5'),
									$elm$svg$Svg$Attributes$ry('0.9')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group6'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip5)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('117.6'),
											$elm$svg$Svg$Attributes$cy('173.42'),
											$elm$svg$Svg$Attributes$r('0.55')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval23'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval23)'),
									$elm$svg$Svg$Attributes$cx('117.6'),
									$elm$svg$Svg$Attributes$cy('173.42'),
									$elm$svg$Svg$Attributes$r('0.55')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group7'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip6)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip6')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('111.55'),
											$elm$svg$Svg$Attributes$cy('174.87'),
											$elm$svg$Svg$Attributes$r('0.55')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval25'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval25)'),
									$elm$svg$Svg$Attributes$cx('111.55'),
									$elm$svg$Svg$Attributes$cy('174.87'),
									$elm$svg$Svg$Attributes$r('0.55')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group8'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip7)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip7')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('113.95'),
											$elm$svg$Svg$Attributes$cy('173.02'),
											$elm$svg$Svg$Attributes$r('0.75')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval27'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval27)'),
									$elm$svg$Svg$Attributes$cx('113.95'),
									$elm$svg$Svg$Attributes$cy('173.02'),
									$elm$svg$Svg$Attributes$r('0.75')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval29'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('175.3'),
							$elm$svg$Svg$Attributes$cy('170.32'),
							$elm$svg$Svg$Attributes$r('0.9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval30'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('168.75'),
							$elm$svg$Svg$Attributes$cy('174.47'),
							$elm$svg$Svg$Attributes$rx('0.75'),
							$elm$svg$Svg$Attributes$ry('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval31'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('164.65'),
							$elm$svg$Svg$Attributes$cy('171.52'),
							$elm$svg$Svg$Attributes$rx('0.5'),
							$elm$svg$Svg$Attributes$ry('0.9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval32'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('168.85'),
							$elm$svg$Svg$Attributes$cy('172.02'),
							$elm$svg$Svg$Attributes$r('0.55')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval33'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('172'),
							$elm$svg$Svg$Attributes$cy('173.02'),
							$elm$svg$Svg$Attributes$rx('0.55'),
							$elm$svg$Svg$Attributes$ry('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval34'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 133, 108)'),
							$elm$svg$Svg$Attributes$cx('171.05'),
							$elm$svg$Svg$Attributes$cy('169.07'),
							$elm$svg$Svg$Attributes$r('0.75')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group9'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip8)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip8')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M 170.49,181.6 C 163.82,181.6 158.43,178.51 158.12,174.32 157.85,170.57 161.75,167.1 167.3,165.73 167.91,165.64 168.5,165.52 169.06,165.38 169.66,165.28 170.27,165.21 170.89,165.17 171.43,165.13 171.96,165.11 172.48,165.11 179.15,165.11 184.54,168.2 184.85,172.39 185.17,176.91 179.46,181.01 172.08,181.54 171.54,181.58 171.01,181.6 170.49,181.6 Z M 169.15,174.16 C 168.83,174.16 168.57,174.42 168.57,174.74 168.57,175.06 168.83,175.32 169.15,175.32 169.46,175.32 169.72,175.06 169.72,174.74 169.72,174.42 169.46,174.16 169.15,174.16 Z M 173.07,172.94 C 172.83,172.94 172.64,173.13 172.64,173.37 172.64,173.61 172.83,173.8 173.07,173.8 173.31,173.8 173.5,173.61 173.5,173.37 173.5,173.13 173.31,172.94 173.07,172.94 Z M 165.04,170.53 C 164.64,170.53 164.32,170.85 164.32,171.25 164.32,171.64 164.64,171.97 165.04,171.97 165.44,171.97 165.76,171.64 165.76,171.25 165.76,170.85 165.44,170.53 165.04,170.53 Z M 169.4,170.99 C 169.16,170.99 168.96,171.19 168.96,171.43 168.96,171.67 169.16,171.86 169.4,171.86 169.64,171.86 169.83,171.67 169.83,171.43 169.83,171.19 169.64,170.99 169.4,170.99 Z M 175.66,169.77 C 175.27,169.77 174.94,170.09 174.94,170.49 174.94,170.89 175.27,171.21 175.66,171.21 176.06,171.21 176.38,170.89 176.38,170.49 176.38,170.09 176.06,169.77 175.66,169.77 Z M 171.74,168.55 C 171.42,168.55 171.16,168.81 171.16,169.12 171.16,169.44 171.42,169.7 171.74,169.7 172.06,169.7 172.31,169.44 172.31,169.12 172.31,168.81 172.06,168.55 171.74,168.55 Z M 171.74,168.55')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-bezier140'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient7-bezier140)'),
									$elm$svg$Svg$Attributes$d('M 170.49,181.6 C 163.82,181.6 158.43,178.51 158.12,174.32 157.85,170.57 161.75,167.1 167.3,165.73 167.91,165.64 168.5,165.52 169.06,165.38 169.66,165.28 170.27,165.21 170.89,165.17 171.43,165.13 171.96,165.11 172.48,165.11 179.15,165.11 184.54,168.2 184.85,172.39 185.17,176.91 179.46,181.01 172.08,181.54 171.54,181.58 171.01,181.6 170.49,181.6 Z M 169.15,174.16 C 168.83,174.16 168.57,174.42 168.57,174.74 168.57,175.06 168.83,175.32 169.15,175.32 169.46,175.32 169.72,175.06 169.72,174.74 169.72,174.42 169.46,174.16 169.15,174.16 Z M 173.07,172.94 C 172.83,172.94 172.64,173.13 172.64,173.37 172.64,173.61 172.83,173.8 173.07,173.8 173.31,173.8 173.5,173.61 173.5,173.37 173.5,173.13 173.31,172.94 173.07,172.94 Z M 165.04,170.53 C 164.64,170.53 164.32,170.85 164.32,171.25 164.32,171.64 164.64,171.97 165.04,171.97 165.44,171.97 165.76,171.64 165.76,171.25 165.76,170.85 165.44,170.53 165.04,170.53 Z M 169.4,170.99 C 169.16,170.99 168.96,171.19 168.96,171.43 168.96,171.67 169.16,171.86 169.4,171.86 169.64,171.86 169.83,171.67 169.83,171.43 169.83,171.19 169.64,170.99 169.4,170.99 Z M 175.66,169.77 C 175.27,169.77 174.94,170.09 174.94,170.49 174.94,170.89 175.27,171.21 175.66,171.21 176.06,171.21 176.38,170.89 176.38,170.49 176.38,170.09 176.06,169.77 175.66,169.77 Z M 171.74,168.55 C 171.42,168.55 171.16,168.81 171.16,169.12 171.16,169.44 171.42,169.7 171.74,169.7 172.06,169.7 172.31,169.44 172.31,169.12 172.31,168.81 172.06,168.55 171.74,168.55 Z M 171.74,168.55')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group10'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip9)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip9')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M 166.59,166.22 C 167.07,165.85 167.57,165.55 168.08,165.3 167.61,165.67 167.11,165.98 166.59,166.22 Z M 166.59,166.22')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-bezier142'),
									$elm$svg$Svg$Attributes$fillRule('evenodd'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient9-bezier142)'),
									$elm$svg$Svg$Attributes$d('M 166.59,166.22 C 167.07,165.85 167.57,165.55 168.08,165.3 167.61,165.67 167.11,165.98 166.59,166.22 Z M 166.59,166.22')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group11'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip10)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip10')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('175.3'),
											$elm$svg$Svg$Attributes$cy('170.32'),
											$elm$svg$Svg$Attributes$r('0.9')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval35'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval35)'),
									$elm$svg$Svg$Attributes$cx('175.3'),
									$elm$svg$Svg$Attributes$cy('170.32'),
									$elm$svg$Svg$Attributes$r('0.9')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group12'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip11)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip11')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$ellipse,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('168.75'),
											$elm$svg$Svg$Attributes$cy('174.47'),
											$elm$svg$Svg$Attributes$rx('0.75'),
											$elm$svg$Svg$Attributes$ry('0.5')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$ellipse,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval37'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval37)'),
									$elm$svg$Svg$Attributes$cx('168.75'),
									$elm$svg$Svg$Attributes$cy('174.47'),
									$elm$svg$Svg$Attributes$rx('0.75'),
									$elm$svg$Svg$Attributes$ry('0.5')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group13'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip12)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip12')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$ellipse,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('164.65'),
											$elm$svg$Svg$Attributes$cy('171.52'),
											$elm$svg$Svg$Attributes$rx('0.5'),
											$elm$svg$Svg$Attributes$ry('0.9')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$ellipse,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval39'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval39)'),
									$elm$svg$Svg$Attributes$cx('164.65'),
									$elm$svg$Svg$Attributes$cy('171.52'),
									$elm$svg$Svg$Attributes$rx('0.5'),
									$elm$svg$Svg$Attributes$ry('0.9')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group14'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip13)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip13')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('168.85'),
											$elm$svg$Svg$Attributes$cy('172.02'),
											$elm$svg$Svg$Attributes$r('0.55')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval41'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval41)'),
									$elm$svg$Svg$Attributes$cx('168.85'),
									$elm$svg$Svg$Attributes$cy('172.02'),
									$elm$svg$Svg$Attributes$r('0.55')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group15'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip14)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip14')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$ellipse,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('172'),
											$elm$svg$Svg$Attributes$cy('173.02'),
											$elm$svg$Svg$Attributes$rx('0.55'),
											$elm$svg$Svg$Attributes$ry('0.5')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$ellipse,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval43'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval43)'),
									$elm$svg$Svg$Attributes$cx('172'),
									$elm$svg$Svg$Attributes$cy('173.02'),
									$elm$svg$Svg$Attributes$rx('0.55'),
									$elm$svg$Svg$Attributes$ry('0.5')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-group16'),
							$elm$svg$Svg$Attributes$clipPath('url(#canvas2-clip15)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$clipPath,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-clip15')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$circle,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$cx('171.05'),
											$elm$svg$Svg$Attributes$cy('169.07'),
											$elm$svg$Svg$Attributes$r('0.75')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('canvas2-oval45'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('url(#canvas2-gradient8-oval45)'),
									$elm$svg$Svg$Attributes$cx('171.05'),
									$elm$svg$Svg$Attributes$cy('169.07'),
									$elm$svg$Svg$Attributes$r('0.75')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier144'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$d('M 126.38,165.49 C 126.38,165.49 127.18,151.35 120.12,146.5 113.06,141.64 105.69,147.19 107.45,155.32 108.44,159.87 111.47,170.4 126.38,165.49 Z M 126.38,165.49')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier145'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(229, 229, 229)'),
							$elm$svg$Svg$Attributes$d('M 120.12,146.5 C 116.89,144.28 112.11,143.86 108.88,147.51 111.5,145.58 115.57,145.97 117.13,147.37 122.08,151.67 126.24,158.9 120.43,164.12 116.08,165.02 111.96,164.33 109.25,160.65 111.46,164.92 116.1,168.87 126.38,165.49 126.38,165.49 127.18,151.35 120.12,146.5 Z M 120.12,146.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval47'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(96, 75, 59)'),
							$elm$svg$Svg$Attributes$cx('119.35'),
							$elm$svg$Svg$Attributes$cy('158.52'),
							$elm$svg$Svg$Attributes$rx('6.6'),
							$elm$svg$Svg$Attributes$ry('8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier146'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(72, 56, 44)'),
							$elm$svg$Svg$Attributes$d('M 112.4,156.64 C 112.4,156.64 119.03,150.31 125.27,155.89 124.63,153.2 123.06,149.64 118.17,150.41 113.19,151.2 112.4,156.64 112.4,156.64 Z M 112.4,156.64')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier147'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(48, 38, 30)'),
							$elm$svg$Svg$Attributes$d('M 119.21,150.99 C 115.79,150.99 113,154.31 113,158.38 113,162.45 115.79,165.77 119.21,165.77 122.63,165.77 125.41,162.45 125.41,158.38 125.41,154.31 122.63,150.99 119.21,150.99 Z M 119.21,166.84 C 115.19,166.84 111.93,163.04 111.93,158.38 111.93,153.71 115.19,149.92 119.21,149.92 123.22,149.92 126.49,153.71 126.49,158.38 126.49,163.04 123.22,166.84 119.21,166.84 Z M 119.21,166.84')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier148'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(191, 183, 177)'),
							$elm$svg$Svg$Attributes$d('M 115.64,159.86 C 115.64,159.86 114.19,159.27 114.62,161.2 115.05,163.14 117.09,165.36 120.54,164.59 123.39,163.94 125.81,159.43 123.57,158.72 122.98,160.76 115.64,159.86 115.64,159.86 Z M 115.64,159.86')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval48'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(26, 26, 26)'),
							$elm$svg$Svg$Attributes$cx('-0'),
							$elm$svg$Svg$Attributes$cy('-0'),
							$elm$svg$Svg$Attributes$rx('4.18'),
							$elm$svg$Svg$Attributes$ry('4.7'),
							$elm$svg$Svg$Attributes$transform('translate(119.39, 158.66) rotate(-3.25)')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval49'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$cx('116.65'),
							$elm$svg$Svg$Attributes$cy('155.57'),
							$elm$svg$Svg$Attributes$rx('2.05'),
							$elm$svg$Svg$Attributes$ry('1.9')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-oval50'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$cx('-0'),
							$elm$svg$Svg$Attributes$cy('-0'),
							$elm$svg$Svg$Attributes$rx('1.2'),
							$elm$svg$Svg$Attributes$ry('1.35'),
							$elm$svg$Svg$Attributes$transform('translate(121.89, 162.07) rotate(-0.05)')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier149'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(81, 33, 15)'),
							$elm$svg$Svg$Attributes$d('M 114.75,145.22 C 112.65,145.22 110.77,146.12 109.45,147.74 107.9,149.66 107.36,152.38 107.98,155.2 108.57,157.93 110.36,166.23 119.36,166.23 L 119.36,166.23 C 121.29,166.23 123.48,165.85 125.85,165.1 125.91,162.87 125.92,151.14 119.81,146.94 118.18,145.81 116.43,145.22 114.75,145.22 Z M 119.36,167.3 L 119.36,167.3 C 115.32,167.3 112.14,165.77 109.93,162.76 108.13,160.31 107.35,157.4 106.92,155.43 106.24,152.29 106.86,149.24 108.61,147.07 110.12,145.21 112.35,144.15 114.75,144.15 116.64,144.15 118.61,144.81 120.42,146.06 127.65,151.02 126.95,164.93 126.91,165.52 L 126.89,165.89 126.55,166 C 123.92,166.86 121.5,167.3 119.36,167.3 Z M 119.36,167.3')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier150'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 130.58,173.28 C 130.58,173.28 134.2,179.47 139.22,174.36 143.08,170.44 138.22,166.7 138.22,166.7 139.94,167.59 143.46,172.1 141.95,175.57 141.02,177.72 140.19,178.54 137.68,178.83 135.17,179.11 131.62,177.07 130.58,173.28 Z M 130.58,173.28')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier151'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 136.93,178.08 C 135.67,178.08 134.42,177.9 133.35,177.49 130.43,176.39 129.18,174.01 129.83,170.78 130.38,168.07 132.55,166.14 135.35,165.81 140.01,165.27 140.95,169.93 140.95,169.93 140,167.81 137.85,166.61 135.47,166.88 133.61,167.08 131.44,168.27 130.89,171 130.2,174.39 132.05,175.86 133.73,176.49 136.97,177.71 141.29,176.67 142.05,175.35 142.05,175.35 140.8,177.86 136.93,178.08 Z M 136.93,178.08')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier152'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(88, 9, 13)'),
							$elm$svg$Svg$Attributes$d('M 158.42,179.65 C 155.04,184.01 153.32,190.39 149.9,194.67 147.73,197.39 144.88,199.26 140.49,199.26 135.95,199.26 133.82,198.09 132.25,195.48 131.51,194.26 130.9,192.71 130.23,190.82 128.17,185.03 126.02,183.42 125.58,183.14 128.28,184.66 143.16,188.29 158.42,179.65 Z M 158.42,179.65')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier153'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(66, 7, 10)'),
							$elm$svg$Svg$Attributes$d('M 147.86,196.77 C 146.29,197.49 144.4,197.9 142.35,197.9 137,197.9 132.67,195.04 132.67,191.5 132.67,187.96 137,185.09 142.35,185.09 147.66,185.09 151.98,187.92 152.04,191.42 L 147.86,196.77 Z M 147.86,196.77')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier154'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 102, 102)'),
							$elm$svg$Svg$Attributes$d('M 149.84,195.07 C 147.68,197.78 144.83,199.66 140.43,199.66 135.9,199.66 133.76,198.48 132.2,195.88 132.14,195.69 132.43,195.19 132.97,194.61 134.58,192.86 138.33,190.39 140.92,193.4 145.6,190.66 148.35,191.42 149.65,193.97 149.71,194.1 149.77,194.23 149.83,194.36 149.85,194.57 149.86,194.81 149.84,195.07 Z M 149.84,195.07')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier155'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(234, 92, 92)'),
							$elm$svg$Svg$Attributes$d('M 149.65,193.97 C 148.18,192.13 145.19,191.53 142.21,193.49 140.26,194.77 139.49,198.21 139.49,198.21 139.49,198.21 139.14,196.63 139.76,195.13 140.38,193.63 140.14,193.36 138.44,192.79 136.79,192.24 133.7,194.1 132.97,194.61 134.58,192.86 138.33,190.39 140.92,193.4 145.6,190.66 148.35,191.42 149.65,193.97 Z M 149.65,193.97')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier156'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
							$elm$svg$Svg$Attributes$d('M 130.32,184.55 C 130.32,184.55 129.71,188.13 137.76,188.6 141.22,188.8 151.89,187.81 153.04,182.23 148.93,183.65 140.86,186.49 130.32,184.55 Z M 130.32,184.55')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier157'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(204, 204, 204)'),
							$elm$svg$Svg$Attributes$d('M 153.04,182.23 C 148.93,183.65 140.86,186.49 130.32,184.55 130.32,184.55 130.04,186.22 132.41,187.42 131.99,186.77 132.22,186.06 132.53,186.09 137.69,186.67 143.57,186.09 149.7,184.7 149.83,184.67 150.42,184.98 149.81,186.15 151.46,185.2 152.69,183.93 153.04,182.23 Z M 153.04,182.23')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier158'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 127.67,184.5 C 128.57,185.71 129.66,187.62 130.74,190.64 132.83,196.51 134.21,198.73 140.49,198.73 148.06,198.73 150.82,192.95 153.75,186.84 154.66,184.92 155.61,182.95 156.72,181.17 149.23,184.92 142.17,185.74 137.42,185.74 133.32,185.74 129.9,185.15 127.67,184.5 Z M 140.49,199.8 C 133.58,199.8 131.9,197.12 129.72,191 127.69,185.28 125.57,183.77 125.29,183.59 125.27,183.58 125.24,183.56 125.22,183.55 L 125.74,182.61 C 125.74,182.61 125.78,182.63 125.85,182.67 127.01,183.33 131.34,184.67 137.42,184.67 142.46,184.67 150.15,183.72 158.15,179.18 L 160.27,178.03 158.85,179.98 C 157.21,182.08 155.94,184.74 154.72,187.31 151.78,193.45 148.74,199.8 140.49,199.8 Z M 140.49,199.8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier159'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 122.74,184.18 C 122.74,184.18 126.36,184.81 126.57,180.78 125.86,182.34 123.76,184.13 122.74,184.18 Z M 122.74,184.18')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier160'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 159.18,175.83 C 159.18,175.83 158.37,179.24 162.42,179.87 160.88,178.94 159.35,176.93 159.18,175.83 Z M 159.18,175.83')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier161'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 197.14,189.89 C 185.63,205.2 149.55,207.65 139.88,207.86 133.84,207.99 120.28,202.26 110.28,194.3 119.43,200.27 133.71,206.58 140.57,206.25 149.59,205.83 169.91,202.9 184.12,194.77 198.33,186.64 200.13,165.84 199.28,156.01 198.43,146.18 193.5,115.93 188.39,112.14 167.83,120.08 140.64,113.28 136.56,109.97 136.66,109.69 154.09,101.93 154,99.48 131.45,101.46 107.67,122.64 101.11,131.12 100.9,127.21 102.27,116.11 102.56,113.85 101.12,114.92 97.98,118.88 95.32,125.41 95.35,121.03 95.82,116.96 96.68,113.99 L 122.54,94.39 199.27,93.54 207.37,128.64 C 208.86,135.23 208.65,174.58 197.14,189.89 Z M 197.14,189.89')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier162'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 206.74,128.92 C 207.46,132.1 207.79,143.59 206.49,156.07 205.37,166.9 202.74,181.51 196.62,189.65 191.8,196.06 182.06,200.91 167.68,204.06 154.61,206.92 142.22,207.31 139.87,207.36 139.8,207.37 139.74,207.37 139.67,207.37 131.01,207.37 106.71,195.38 100.43,182.16 96.84,174.58 97.47,164.63 98.03,155.85 98.41,149.94 98.74,144.84 97.77,141.19 95.53,132.67 95.32,121.11 97.3,114.31 L 96.07,113.95 C 94.04,120.95 94.24,132.8 96.54,141.52 97.45,144.97 97.11,150.21 96.76,155.77 96.19,164.7 95.54,174.83 99.28,182.7 103.21,190.99 113.1,197.65 118.64,200.89 126.62,205.55 135.03,208.64 139.68,208.64 139.75,208.64 139.82,208.64 139.89,208.64 142.27,208.59 154.77,208.19 167.95,205.31 182.65,202.09 192.64,197.08 197.65,190.41 203.94,182.04 206.62,167.19 207.76,156.2 209.09,143.42 208.75,131.98 207.99,128.64 L 206.74,128.92 Z M 206.74,128.92')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier163'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 113.07,101.6 C 108.57,103.04 104.49,107.04 101.2,111.43 96.38,117.87 95.14,123.79 95.02,125.14 L 95.4,128.34 C 94.93,131.77 95.87,135.12 96.64,138.46 90.64,132.14 87.6,124.59 86.82,116.96 85.36,102.59 91.94,87.95 101.99,80.76 L 113.07,101.6 Z M 113.07,101.6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier164'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(102, 52, 25)'),
							$elm$svg$Svg$Attributes$d('M 184.03,38.6 C 168.78,31.22 142.15,26.5 124.44,32.55 147.74,31.7 169.06,35.01 177.68,46.44 176.45,40.96 163.66,33.96 157.12,33.11 167.07,32.17 182.23,37.93 184.03,38.6 Z M 184.03,38.6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier165'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(102, 52, 25)'),
							$elm$svg$Svg$Attributes$d('M 81.19,54.76 C 95.04,45.19 133.83,23.07 172.62,49.44 155.57,42.85 129.18,43.8 123.78,45.97 146.04,47.1 170.39,55.05 174.27,59.11 141.3,59.02 122.73,62.89 118.38,66.58 131.54,63.18 149.73,64.31 154.85,64.97 138.84,65.26 104.42,84.11 94.83,109.85 94.83,94.32 107.48,76.6 126.05,69.98 115.82,68.47 93.56,81.52 85.98,92.2 92.04,77.17 106.55,55.4 147.26,55.82 113.58,52.42 82.89,70.5 76.71,77.94 83.99,66.11 101.23,55.14 128.13,50.79 117.9,48.15 100.94,49.37 99.81,50.22 107.77,45.21 133.82,39.26 146.32,41.91 121.69,36.52 87.01,49.94 81.19,54.76 Z M 81.19,54.76')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier166'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 103.31,105.34 C 103.31,105.34 101.61,110.25 101.32,111.01 101.3,111.06 101.26,111.21 101.2,111.43 96.38,117.87 95.24,123.08 95.13,124.43 L 95.4,128.34 C 94.93,131.77 95.87,135.12 96.64,138.46 90.64,132.14 87.6,124.59 86.82,116.96 86.82,116.93 86.83,116.9 86.83,116.87 86.83,118.67 89.58,124.62 92.61,125.85 91.85,122.07 95.17,110.63 103.31,105.34 Z M 103.31,105.34')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier167'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(31, 16, 8)'),
							$elm$svg$Svg$Attributes$d('M 87.31,110.83 C 87.93,98.97 93.84,87.37 102.36,81.28 102.36,81.28 98.51,82.34 94.83,86.83 93.27,88.73 91.95,90.9 90.77,93.2 87.99,98.63 86.35,104.7 86.04,110.76 85.46,121.78 89.24,131.87 96.72,139.46 L 96.06,136.87 C 89.88,129.76 86.8,120.68 87.31,110.83 Z M 87.31,110.83')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier168'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 96.24,119.98 L 94.76,122.52 C 94.44,128.43 94.98,135.19 96.35,140.78 L 97.69,140.84 C 96.05,134.44 95.55,126.42 96.24,119.98 Z M 96.24,119.98')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier169'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(31, 16, 8)'),
							$elm$svg$Svg$Attributes$d('M 113.27,102.21 L 112.88,101 C 105.71,103.29 99.46,111.73 95.98,118.41 93.6,122.98 93.95,125.98 93.95,125.98 94.48,124.25 96.48,119.67 99.58,114.88 102.67,110.11 107.55,104.04 113.27,102.21 Z M 113.27,102.21')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier170'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(70, 37, 16)'),
							$elm$svg$Svg$Attributes$d('M 218.32,152.04 C 212.18,155.92 209.91,164.15 206.31,168.78 205.97,169.22 205.62,169.63 205.25,170 205.25,169.62 205.24,169.24 205.23,168.84 205.13,165.69 204.64,161.85 203.67,157.75 201.98,150.66 198.84,142.8 193.78,136.44 188.63,129.95 187.42,121.28 188.62,113.37 189.06,110.5 189.81,107.73 190.81,105.21 174.3,113.59 144.89,114.16 136.3,109.59 135.62,109.23 135.07,108.83 134.67,108.41 141.54,107.08 150.66,101.69 156.42,97.06 L 156.3,97.06 C 131.28,97.07 104.64,119.45 101.28,128.69 101.25,128.53 101.22,128.37 101.2,128.21 96.41,98.86 119.85,81.17 139.5,78.35 L 203.8,92.46 C 203.13,93.11 211.12,124.35 215.52,141.32 217.17,147.68 218.32,152.04 218.32,152.04 Z M 218.32,152.04')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier171'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 156.3,97.06 C 131.28,97.07 104.64,119.45 101.28,128.69 101.25,128.53 101.22,128.37 101.2,128.21 104.16,118.2 112.56,105.71 121.69,100.99 121.31,101.75 116.77,105.9 117.62,108.55 121.69,103.64 137.61,94.37 146.42,93.14 145.57,93.62 139.88,95.79 140.35,97.4 144.24,95.13 156.84,94.28 161.39,90.97 161.1,92.74 158.41,95.92 156.3,97.06 Z M 156.3,97.06')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier172'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 188.62,113.37 C 189.06,110.5 189.81,107.73 190.81,105.21 174.3,113.59 144.89,114.16 136.3,109.59 163.68,112.36 181.78,103.15 186.49,99.71 186.25,100.75 183.88,105.2 180.76,106.9 187.39,104.91 193.97,100.61 199.18,94.47 199.45,101.98 196.47,106.99 188.62,113.37 Z M 188.62,113.37')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier173'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(53, 28, 12)'),
							$elm$svg$Svg$Attributes$d('M 218.95,142.3 C 218.78,141.61 215.72,142.07 215.52,141.32 215.47,141.75 215.42,142.17 215.38,142.58 213.68,137.34 210.69,127.27 209.56,126.84 211.64,133.99 208.25,146.82 203.67,157.75 203.65,157.8 203.63,157.84 203.61,157.89 204.47,161.48 205.27,165.15 205.51,168.83 205.77,168.81 206.04,168.8 206.31,168.78 209.91,164.15 212.18,155.92 218.32,152.04 218.32,152.04 220.3,147.47 218.95,142.3 Z M 218.95,142.3')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier174'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(31, 16, 8)'),
							$elm$svg$Svg$Attributes$d('M 217.98,151.5 C 213.8,154.14 211.36,158.71 209.2,162.75 208.09,164.81 207.04,166.79 205.85,168.33 205.66,163.88 204.74,158.67 203.25,153.78 201.19,146.96 198.08,140.83 194.29,136.04 187.69,127.74 187.65,115.18 191.32,105.66 196.41,102.97 197.23,100.06 197.23,100.06 188.28,108.63 167.72,112.14 152.41,111.77 144.86,111.59 138.86,110.46 136.11,108.74 142.64,107.1 149.63,102.68 152.45,100.77 154.79,99.18 157.39,97.23 159.35,95.37 161.76,93.08 161.32,90.8 161.32,90.8 161.18,91.73 159.4,93.8 156.25,96.37 141.58,96.42 127.79,103.99 120.77,108.57 112.03,114.29 104.59,121.32 101.66,126.48 100.26,115.69 102.71,105.64 108.78,97.31 115.78,87.7 127.61,80.66 139.65,78.93 139.65,78.93 136.23,77.89 131.02,79.73 128.04,80.78 125.1,82.08 122.31,83.68 116.49,87.02 111.45,91.47 107.74,96.56 101.08,105.7 98.65,116.83 100.71,128.75 L 101.11,131.12 101.94,128.86 C 103.47,124.66 110.67,116.7 121.47,109.64 128.1,105.31 140.86,98.27 154.57,97.69 153.7,98.34 152.76,99.02 151.74,99.71 145.59,103.88 139.16,106.89 134.55,107.78 L 133.4,108 134.21,108.85 C 136.53,111.3 143.15,112.83 152.38,113.05 153.1,113.06 153.82,113.07 154.56,113.07 162.18,113.07 170.43,112.16 177.52,110.5 182.12,109.43 186.2,108.07 189.66,106.47 188.41,110.1 187.67,114.07 187.57,117.98 187.43,123.12 188.31,130.57 193.28,136.84 202.22,148.09 204.61,162.98 204.61,170 L 204.61,171.54 205.7,170.45 C 207.48,168.68 208.86,166.09 210.32,163.35 212.51,159.26 214.77,155.04 218.66,152.58 L 217.98,151.5 Z M 217.98,151.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier175'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(255, 177, 144)'),
							$elm$svg$Svg$Attributes$d('M 202.28,164.22 L 203.4,175.34 C 217.12,179.39 229.45,162.76 222.03,153.25 213.57,142.43 203.26,158.21 202.28,164.22 Z M 202.28,164.22')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier176'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 213.69,149.09 C 207.36,150.87 202.68,160.36 202.11,164.65 202.11,164.65 207.46,151.71 213.95,150.11 216.7,149.43 219.27,150.57 221.61,153.57 225.25,158.23 223.93,164.24 221.03,167.98 213.91,177.15 202.7,175.33 202.7,175.33 204,175.98 205.3,176.19 206.73,176.19 212.79,176.18 218.97,172.85 221.9,168.57 225.57,163.19 225.78,157.2 222.44,152.93 219.17,148.75 215.87,148.48 213.69,149.09 Z M 213.69,149.09')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier177'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 216.63,154.6 C 215.58,154.02 213.65,153.73 211.61,155.45 207.2,159.15 204.99,166.07 204.99,166.07 208.02,159.75 212.86,154.01 216.21,155.56 218.61,156.67 220.14,159.74 219.02,163.26 219.31,163.26 221.86,157.44 216.63,154.6 Z M 216.63,154.6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('canvas2-bezier178'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('rgb(161, 65, 29)'),
							$elm$svg$Svg$Attributes$d('M 214.09,157.73 C 212.28,157.14 210.08,158.25 207.76,160.18 L 207.57,161.38 C 209.64,159.66 211.88,158.1 213.98,158.56 216.15,159.02 216.68,160.4 216.71,160.44 216.71,160.44 216.43,158.49 214.09,157.73 Z M 214.09,157.73')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Domain$Types$NextLevelClicked = {$: 4};
var $author$project$SVGs$Elements$Button$nextLevelButton = function (buttonAttributes) {
	return A3(
		$author$project$SVGs$Elements$Button$modalButton,
		buttonAttributes,
		$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$NextLevelClicked),
		_List_fromArray(
			[
				$author$project$SVGs$Elements$Button$buttonText('Next')
			]));
};
var $author$project$SVGs$Modals$Victory$partyPopperDefinitions = A2(
	$elm$svg$Svg$defs,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('-18.79'),
					$elm$svg$Svg$Attributes$y1('-11.31'),
					$elm$svg$Svg$Attributes$x2('18.78'),
					$elm$svg$Svg$Attributes$y2('11.31'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(52, 0, 38)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(19, 157, 235)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$linearGradient,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$id('partyPopperDrawing-gradient5-clip'),
					$elm$svg$Svg$Attributes$x1('-18.79'),
					$elm$svg$Svg$Attributes$y1('-11.31'),
					$elm$svg$Svg$Attributes$x2('18.78'),
					$elm$svg$Svg$Attributes$y2('11.31'),
					$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('0'),
							$elm$svg$Svg$Attributes$stopColor('rgb(52, 0, 38)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$stop,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$offset('1'),
							$elm$svg$Svg$Attributes$stopColor('rgb(19, 157, 235)'),
							$elm$svg$Svg$Attributes$stopOpacity('1')
						]),
					_List_Nil)
				]))
		]));
var $author$project$SVGs$Modals$Victory$partyPopper = F5(
	function (x, y, width, height, rotate) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromFloat(y)),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(width)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(height)),
					$elm$svg$Svg$Attributes$viewBox('0 0 202 220'),
					$elm$svg$Svg$Attributes$style('overflow:visible')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$transform(
							'rotate(' + ($elm$core$String$fromFloat(rotate) + ')'))
						]),
					_List_fromArray(
						[
							$author$project$SVGs$Modals$Victory$partyPopperDefinitions,
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(239, 15, 122)'),
									$elm$svg$Svg$Attributes$d('M 95.24,38.18 C 95.31,35.42 95.15,32.66 95.08,29.9 95.01,27.12 95.13,24.36 95.25,21.59 95.37,18.93 95.69,16.19 97.4,14.05 97.91,13.41 98.65,13.04 99.36,12.67 99.84,12.42 100.65,12.21 101.03,11.81 101.23,11.59 101.03,10.79 100.99,10.59 100.84,9.65 100.61,8.72 100.36,7.79 100.11,6.87 99.84,5.95 99.5,5.06 99.54,5.16 99.03,3.86 98.91,3.98 98.58,4.33 97.88,4.52 97.46,4.73 96.78,5.07 96.05,5.42 95.52,5.96 93.7,7.77 93.26,10.64 93.07,13.07 92.63,18.7 93.04,24.3 93,29.94 92.96,35.43 91.69,40.48 88.74,45.14 85.91,49.61 81.95,53.27 77.92,56.64 77.7,56.82 77.93,57.72 77.95,57.86 78.11,58.8 78.33,59.74 78.58,60.66 78.64,60.86 79.87,64.6 80.03,64.47 84,61.16 87.8,57.58 90.67,53.25 93.68,48.71 95.09,43.6 95.24,38.18 Z M 95.24,38.18')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier2'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(0, 174, 239)'),
									$elm$svg$Svg$Attributes$d('M 6.72,164.99 C 22.57,159.45 117.87,126.12 118.17,125.88 121.78,123.02 113.68,106.83 100.09,89.74 86.49,72.65 72.55,61.12 68.94,63.98 68.61,64.24 4.48,165.77 4.48,165.77 4.48,165.77 4.51,165.76 4.55,165.75 3.93,166.37 3.31,166.97 2.79,167.61 1.56,169.12 1.13,171.21 0.7,173.06 -0.32,177.43 -0.34,182.61 1.39,186.8 3.17,191.07 7.18,193.93 9.16,198.11 12.19,204.51 9.78,212.09 11.37,218.81 11.58,219.73 12.99,219.55 12.84,218.59 11.9,212.66 12.8,206.63 11.64,200.73 10.79,196.41 7.96,193.36 5.26,190.08 1.43,185.42 1.05,180 1.9,174.21 2.32,171.37 3.21,168.98 5.11,166.81 5.66,166.18 6.23,165.6 6.72,164.99 Z M 6.72,164.99')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-group'),
									$elm$svg$Svg$Attributes$clipPath('url(#partyPopperDrawing-clip)')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$clipPath,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('partyPopperDrawing-clip')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$ellipse,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$cx('0'),
													$elm$svg$Svg$Attributes$cy('-0'),
													$elm$svg$Svg$Attributes$rx('9'),
													$elm$svg$Svg$Attributes$ry('39.8'),
													$elm$svg$Svg$Attributes$transform('translate(94.6, 94.56) rotate(-39.55)')
												]),
											_List_Nil)
										])),
									A2(
									$elm$svg$Svg$ellipse,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('partyPopperDrawing-oval'),
											$elm$svg$Svg$Attributes$stroke('none'),
											$elm$svg$Svg$Attributes$fill('url(#partyPopperDrawing-gradient5-oval)'),
											$elm$svg$Svg$Attributes$cx('0'),
											$elm$svg$Svg$Attributes$cy('-0'),
											$elm$svg$Svg$Attributes$rx('9'),
											$elm$svg$Svg$Attributes$ry('39.8'),
											$elm$svg$Svg$Attributes$transform('translate(94.6, 94.56) rotate(-39.55)')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star2'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
									$elm$svg$Svg$Attributes$points('0,-8.9 2.62,-3.6 8.46,-2.75 4.23,1.38 5.23,7.2 0,4.45 -5.23,7.2 -4.23,1.38 -8.46,-2.75 -2.62,-3.6'),
									$elm$svg$Svg$Attributes$transform('translate(65.6, 99.06) rotate(-69.2)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star3'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
									$elm$svg$Svg$Attributes$points('0,-4.4 1.29,-1.78 4.18,-1.36 2.09,0.68 2.59,3.56 0,2.2 -2.59,3.56 -2.09,0.68 -4.18,-1.36 -1.29,-1.78'),
									$elm$svg$Svg$Attributes$transform('translate(82.9, 115.91) rotate(-3.15)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star4'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
									$elm$svg$Svg$Attributes$points('0,-4.4 1.29,-1.78 4.18,-1.36 2.09,0.68 2.59,3.56 0,2.2 -2.59,3.56 -2.09,0.68 -4.18,-1.36 -1.29,-1.78'),
									$elm$svg$Svg$Attributes$transform('translate(46.7, 117.61) rotate(-3.15)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star5'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
									$elm$svg$Svg$Attributes$points('0,-8 2.35,-3.24 7.61,-2.47 3.8,1.24 4.7,6.47 0,4 -4.7,6.47 -3.8,1.24 -7.61,-2.47 -2.35,-3.24'),
									$elm$svg$Svg$Attributes$transform('translate(62.15, 129.91) rotate(-17.9)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star6'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(255, 255, 255)'),
									$elm$svg$Svg$Attributes$points('0,-8 2.35,-3.24 7.61,-2.47 3.8,1.24 4.7,6.47 0,4 -4.7,6.47 -3.8,1.24 -7.61,-2.47 -2.35,-3.24'),
									$elm$svg$Svg$Attributes$transform('translate(38.45, 140.41) rotate(-17.9)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier3'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(239, 65, 54)'),
									$elm$svg$Svg$Attributes$d('M 121.94,108.66 C 123.77,113.09 127.8,113.43 132.16,113.97 137.06,114.57 140.55,113.13 144.75,110.71 146.92,109.46 149,108.24 151.43,107.58 150.85,107.46 150.27,107.34 149.69,107.23 150.48,107.48 151.27,107.73 152.06,107.99 153.37,108.41 154.72,108.81 156.08,109.08 160.24,109.9 165.71,111.47 169.53,108.95 169.37,109.05 165.11,107.78 164.66,107.71 163.52,107.54 160.71,106.75 159.64,107.46 157.18,108.33 157.53,108.76 160.67,108.77 159.88,108.52 159.09,108.26 158.3,108.01 156.55,107.45 154.77,107.01 152.96,106.67 149.85,106.08 146.34,105.34 143.15,105.73 140.05,106.11 137.52,107.68 134.86,109.22 132.94,110.34 131.03,111.37 128.94,112.09 125.97,112.7 127.69,113.13 134.1,113.38 132.84,112.83 132.3,111.28 131.83,110.15 130.96,108.04 122.31,109.57 121.94,108.66 Z M 121.94,108.66')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier4'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(247, 148, 30)'),
									$elm$svg$Svg$Attributes$d('M 112.81,85.2 C 118.34,87.44 118.55,78.55 120.49,75.47 123.55,70.59 129.88,77.9 133.83,73.69 135.25,72.18 134.92,69.18 134.99,67.3 135.11,63.87 136.04,60.02 138.9,57.84 140.72,56.44 143.4,56.43 145.58,56.28 149,56.03 152.58,55.69 155.41,53.56 160.3,49.89 155.02,41.94 158.58,37.8 159.73,36.46 162.78,37.4 164.23,37.52 167.66,37.79 170.14,36.35 171.79,33.4 173.16,30.94 173.81,28.23 175.97,26.27 177.64,24.76 180.14,25.11 182.2,25.3 184.02,25.48 186.05,25.85 187.77,25.04 189.62,24.17 189.24,21.31 189.06,19.71 189,19.22 188.93,18.72 188.85,18.23 188.68,17.07 188.57,15.53 187.97,14.48 187.83,14.25 187.93,16.45 187.97,16.7 188.6,20.91 179.91,18.95 178,19 172.33,19.15 172.02,26.81 168.66,29.91 166.54,31.87 163.4,31.43 160.8,31.12 158.89,30.89 157.51,31.07 156.72,32.97 154.48,38.37 159.03,45.27 152.44,48.56 147.66,50.93 141.05,48.66 136.96,52.4 134.91,54.28 134.13,57.58 133.85,60.21 133.59,62.69 134.26,65.93 132.4,67.91 128.58,71.97 122.9,64.62 119.4,69.32 117.14,72.36 117.41,81.35 111.73,79.05 112.33,79.3 111.47,84.66 112.81,85.2 Z M 112.81,85.2')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier5'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(0, 174, 239)'),
									$elm$svg$Svg$Attributes$d('M 115,52.24 C 118.21,51.99 116.18,47.64 116.37,45.69 116.69,42.59 121.5,44.61 122.4,41.63 122.72,40.56 121.84,39.19 121.42,38.26 120.66,36.57 120.19,34.49 121.04,32.75 121.59,31.63 122.88,30.99 123.9,30.39 125.49,29.45 127.14,28.42 128,26.71 129.49,23.77 125.02,21.19 125.75,18.33 125.98,17.41 127.68,17.13 128.41,16.84 130.14,16.15 130.99,14.86 131.08,13.04 131.15,11.52 130.81,10.05 131.39,8.59 131.84,7.45 133.13,7.02 134.17,6.62 135.09,6.27 136.16,5.96 136.8,5.16 137.49,4.29 136.62,3 136.14,2.27 135.99,2.05 135.84,1.82 135.69,1.6 135.32,1.08 134.9,0.36 134.36,0 134.24,-0.08 134.81,0.96 134.89,1.08 136.21,2.96 131.53,4.1 130.62,4.58 127.92,6.01 129.61,9.79 128.73,12.1 128.18,13.55 126.55,14.1 125.22,14.57 124.24,14.92 123.62,15.33 123.69,16.44 123.9,19.6 127.76,21.83 125.36,25.01 123.62,27.3 119.88,27.79 118.8,30.58 118.26,31.98 118.67,33.76 119.17,35.1 119.64,36.37 120.74,37.77 120.32,39.17 119.45,42.06 114.94,39.87 114.37,42.98 114.01,44.99 116.3,49.27 113,49.52 113.35,49.5 114.22,52.3 115,52.24 Z M 115,52.24')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier6'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(238, 42, 123)'),
									$elm$svg$Svg$Attributes$d('M 133.49,93.75 C 135.73,96.06 137.78,91.71 139.4,90.62 141.98,88.87 143.51,93.86 146.38,92.64 147.41,92.21 147.9,90.66 148.34,89.74 149.15,88.07 150.45,86.37 152.34,85.92 153.54,85.63 154.87,86.2 155.97,86.6 157.72,87.22 159.56,87.84 161.42,87.4 164.64,86.66 163.76,81.58 166.42,80.31 167.28,79.9 168.58,81.03 169.27,81.4 170.91,82.28 172.45,82.11 173.9,81.02 175.12,80.1 176.03,78.9 177.52,78.41 178.68,78.02 179.84,78.74 180.81,79.28 181.67,79.77 182.59,80.4 183.62,80.37 184.73,80.34 185.16,78.84 185.42,78.02 185.5,77.76 185.57,77.5 185.64,77.24 185.81,76.63 186.09,75.84 186.02,75.2 186,75.05 185.57,76.16 185.53,76.29 184.93,78.51 181.07,75.64 180.11,75.25 177.28,74.09 175.45,77.81 173.12,78.61 171.65,79.12 170.19,78.21 168.98,77.49 168.08,76.96 167.36,76.75 166.56,77.52 164.27,79.7 165.02,84.1 161.05,84.28 158.17,84.42 155.4,81.85 152.57,82.81 151.14,83.29 150.04,84.75 149.33,85.99 148.66,87.16 148.28,88.9 146.93,89.47 144.16,90.65 142.96,85.78 140.21,87.34 138.43,88.35 136.6,92.85 134.3,90.47 134.54,90.73 132.95,93.19 133.49,93.75 Z M 133.49,93.75')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier7'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(0, 166, 81)'),
									$elm$svg$Svg$Attributes$d('M 115.09,97.97 C 115.97,98.21 116.84,97.92 117.66,97.63 118.84,97.21 119.97,96.66 121.14,96.24 121.43,96.14 119.48,93.18 119.37,93.02 119.17,92.73 117.5,90.03 116.99,90.21 115.91,90.6 114.87,91.07 113.81,91.49 112.92,91.83 111.9,92.21 110.93,91.95 110.81,91.91 111.39,93.08 111.33,92.97 111.74,93.72 112.22,94.45 112.71,95.16 113.2,95.87 113.71,96.57 114.27,97.23 114.47,97.47 114.75,97.88 115.09,97.97 Z M 115.09,97.97')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier8'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(0, 166, 81)'),
									$elm$svg$Svg$Attributes$d('M 98.63,72.69 C 99.51,72.93 100.38,72.64 101.2,72.35 102.39,71.93 103.51,71.38 104.69,70.96 104.97,70.86 103.03,67.9 102.92,67.74 102.71,67.45 101.05,64.75 100.54,64.93 99.46,65.32 98.42,65.79 97.35,66.21 96.47,66.56 95.45,66.93 94.48,66.67 94.35,66.63 94.93,67.8 94.87,67.69 95.29,68.44 95.76,69.17 96.25,69.88 96.74,70.59 97.25,71.29 97.81,71.95 98.01,72.19 98.3,72.6 98.63,72.69 Z M 98.63,72.69')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier9'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(38, 34, 98)'),
									$elm$svg$Svg$Attributes$d('M 99.37,92.33 C 99.92,92.46 100.52,92.1 101.08,91.76 101.89,91.26 102.68,90.64 103.49,90.13 103.68,90.02 102.72,87.52 102.66,87.39 102.56,87.14 101.75,84.85 101.4,85.06 100.66,85.53 99.94,86.06 99.2,86.55 98.59,86.96 97.89,87.4 97.29,87.26 97.21,87.24 97.46,88.25 97.44,88.16 97.63,88.8 97.87,89.42 98.11,90.01 98.36,90.61 98.62,91.2 98.91,91.74 99.02,91.94 99.17,92.29 99.37,92.33 Z M 99.37,92.33')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier10'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(38, 34, 98)'),
									$elm$svg$Svg$Attributes$d('M 115.77,7.31 C 116.32,7.43 116.92,7.08 117.48,6.73 118.29,6.23 119.08,5.61 119.89,5.11 120.08,4.99 119.12,2.49 119.06,2.36 118.96,2.11 118.16,-0.18 117.8,0.04 117.06,0.5 116.34,1.04 115.6,1.53 114.99,1.94 114.29,2.38 113.69,2.24 113.61,2.22 113.87,3.22 113.84,3.13 114.03,3.78 114.27,4.39 114.51,4.99 114.76,5.58 115.02,6.17 115.31,6.71 115.42,6.91 115.56,7.26 115.77,7.31 Z M 115.77,7.31')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier11'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(38, 34, 98)'),
									$elm$svg$Svg$Attributes$d('M 139.85,36.11 C 140.4,36.24 140.99,35.88 141.56,35.54 142.37,35.04 143.16,34.42 143.97,33.92 144.16,33.79 143.19,31.3 143.14,31.17 143.04,30.92 142.23,28.63 141.88,28.85 141.14,29.31 140.41,29.84 139.68,30.33 139.06,30.74 138.37,31.18 137.76,31.04 137.68,31.03 137.94,32.03 137.91,31.94 138.11,32.58 138.34,33.2 138.59,33.79 138.83,34.39 139.09,34.98 139.39,35.52 139.5,35.72 139.64,36.07 139.85,36.11 Z M 139.85,36.11')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier12'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(38, 34, 98)'),
									$elm$svg$Svg$Attributes$d('M 197.32,66 C 197.87,66.13 198.46,65.77 199.03,65.43 199.84,64.93 200.63,64.31 201.44,63.8 201.63,63.69 200.66,61.19 200.61,61.06 200.51,60.81 199.7,58.51 199.35,58.73 198.61,59.2 197.88,59.73 197.15,60.22 196.53,60.63 195.83,61.07 195.23,60.93 195.15,60.92 195.41,61.92 195.38,61.83 195.58,62.47 195.81,63.09 196.06,63.68 196.3,64.28 196.56,64.87 196.86,65.41 196.96,65.61 197.11,65.96 197.32,66 Z M 197.32,66')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier13'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(38, 34, 98)'),
									$elm$svg$Svg$Attributes$d('M 77.04,41.66 C 77.59,41.79 78.19,41.43 78.75,41.08 79.56,40.58 80.35,39.96 81.16,39.46 81.35,39.34 80.39,36.84 80.34,36.71 80.23,36.46 79.43,34.17 79.07,34.39 78.33,34.85 77.61,35.39 76.87,35.88 76.26,36.29 75.56,36.73 74.96,36.59 74.88,36.57 75.14,37.57 75.11,37.48 75.3,38.13 75.54,38.74 75.78,39.34 76.03,39.93 76.29,40.52 76.59,41.07 76.69,41.26 76.84,41.61 77.04,41.66 Z M 77.04,41.66')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-bezier14'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(146, 39, 143)'),
									$elm$svg$Svg$Attributes$d('M 174.55,66.17 C 175.1,66.3 175.7,65.94 176.26,65.6 177.07,65.1 177.86,64.48 178.67,63.97 178.86,63.86 177.9,61.36 177.85,61.22 177.74,60.97 176.94,58.68 176.58,58.9 175.84,59.36 175.12,59.9 174.38,60.39 173.77,60.8 173.07,61.24 172.47,61.1 172.39,61.08 172.65,62.09 172.62,61.99 172.81,62.64 173.05,63.25 173.29,63.85 173.54,64.45 173.8,65.04 174.1,65.58 174.2,65.78 174.35,66.12 174.55,66.17 Z M 174.55,66.17')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star7'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(238, 42, 123)'),
									$elm$svg$Svg$Attributes$points('0,-4.4 1.29,-1.78 4.18,-1.36 2.09,0.68 2.59,3.56 0,2.2 -2.59,3.56 -2.09,0.68 -4.18,-1.36 -1.29,-1.78'),
									$elm$svg$Svg$Attributes$transform('translate(120.05, 55.76) rotate(-0.55)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star8'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(238, 42, 123)'),
									$elm$svg$Svg$Attributes$points('0,-2.05 0.59,-0.81 1.95,-0.63 0.95,0.31 1.2,1.66 0,1 -1.2,1.66 -0.95,0.31 -1.95,-0.63 -0.59,-0.81'),
									$elm$svg$Svg$Attributes$transform('translate(153.6, 10.16) rotate(-17)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star9'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(238, 42, 123)'),
									$elm$svg$Svg$Attributes$points('0,-2 0.59,-0.81 1.9,-0.62 0.95,0.31 1.18,1.62 0,1 -1.18,1.62 -0.95,0.31 -1.9,-0.62 -0.59,-0.81'),
									$elm$svg$Svg$Attributes$transform('translate(151.4, 71.06) rotate(-35)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star10'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(238, 42, 123)'),
									$elm$svg$Svg$Attributes$points('0,-4.5 1.32,-1.82 4.28,-1.39 2.14,0.7 2.65,3.64 0,2.25 -2.65,3.64 -2.14,0.7 -4.28,-1.39 -1.32,-1.82'),
									$elm$svg$Svg$Attributes$transform('translate(177.75, 100.26) rotate(-69.35)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star11'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(247, 148, 30)'),
									$elm$svg$Svg$Attributes$points('0,-2.3 0.68,-0.93 2.19,-0.71 1.09,0.36 1.35,1.86 0,1.15 -1.35,1.86 -1.09,0.36 -2.19,-0.71 -0.68,-0.93'),
									$elm$svg$Svg$Attributes$transform('translate(106.45, 27.06) rotate(-17.05)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('partyPopperDrawing-star12'),
									$elm$svg$Svg$Attributes$stroke('none'),
									$elm$svg$Svg$Attributes$fill('rgb(238, 42, 123)'),
									$elm$svg$Svg$Attributes$points('0,-3.3 0.97,-1.33 3.14,-1.02 1.57,0.51 1.94,2.67 0,1.65 -1.94,2.67 -1.57,0.51 -3.14,-1.02 -0.97,-1.33'),
									$elm$svg$Svg$Attributes$transform('translate(190, 41.81) rotate(-65.6)')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$SVGs$Modals$Victory$victory = function (model) {
	return $author$project$SVGs$Modals$Modal$modal(
		A7(
			$author$project$SVGs$Modals$Modal$Modal,
			'victoryModal',
			$author$project$Domain$Types$ModalMessage($author$project$Domain$Types$VictoryCloseClicked),
			model.cQ.dH,
			380,
			A4($author$project$Extras$Svg$ViewBox, 0, 0, '275', '400'),
			_List_fromArray(
				[
					$author$project$SVGs$Modals$Modal$levelLabel(model.cK.cp),
					$author$project$SVGs$Modals$Victory$happyBoy,
					A5($author$project$SVGs$Modals$Victory$partyPopper, 200, 100, 50.5, 55, 0),
					A5($author$project$SVGs$Modals$Victory$partyPopper, 35, 140, 50.5, 55, 270),
					$author$project$SVGs$Elements$StarBanner$starBanner(
					A4(
						$author$project$SVGs$Elements$StarBanner$BannerAttributes,
						$elm$core$Maybe$Just(model.da.cf),
						A2($author$project$Services$Score$scoreToNumberOfStars, model.da.cf, model.cK),
						12,
						220)),
					$author$project$SVGs$Elements$Button$nextLevelButton(
					A4($author$project$SVGs$Elements$Button$ButtonAttributes, 30, 320, 220, 60))
				]),
			_List_Nil));
};
var $author$project$View$view = F2(
	function (_v0, model) {
		return {
			bI: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$author$project$SVGs$Elements$Fireworks$fireworks,
						!model.cQ.cL,
						A2(
							$author$project$SVGs$Tiles$Tile$tileMask,
							model,
							A2(
								$author$project$View$ImageMatch$imagesLayer,
								model,
								A2(
									$author$project$View$animatedScoresLayer,
									model,
									A2(
										$author$project$View$kanaExplosionsLayer,
										model,
										A2(
											$author$project$View$shrinkingKanaLayer,
											model,
											A2(
												$author$project$View$kanaToKanawordAnimationsLayer,
												model,
												A2(
													$author$project$View$topUpLayer,
													model,
													A2(
														$author$project$View$selectedItemLayer,
														model,
														A2(
															$author$project$View$boardItemsLayer,
															model,
															A2(
																$author$project$View$tilesLayer,
																model,
																A2(
																	$author$project$View$Kanaword$kanaWordView,
																	model,
																	A2(
																		$author$project$View$movesAndWordsLabels,
																		model,
																		A2(
																			$author$project$View$background,
																			model,
																			_List_fromArray(
																				[
																					$author$project$View$modalBackground(model),
																					$author$project$SVGs$Modals$PreviewLevel$previewLevel(model),
																					$author$project$SVGs$Modals$Victory$victory(model),
																					$author$project$SVGs$Elements$Loading$loading(model),
																					$author$project$SVGs$Modals$Defeat$defeat(model),
																					$author$project$SVGs$Modals$Error$error(model),
																					$author$project$SVGs$Modals$Settings$settings(model),
																					$author$project$SVGs$Elements$LevelComplete$levelComplete(!model.cQ.cL)
																				]))))))))))))))))
				]),
			dy: 'Kana Party'
		};
	});
var $author$project$Main$main = $MartinSStewart$elm_audio$Audio$applicationWithAudio(
	{
		bA: $author$project$Main$audio,
		bD: {ce: $author$project$Subscriptions$audioPortFromJS, dz: $author$project$Subscriptions$audioPortToJS},
		cv: $author$project$Init$init,
		cY: $author$project$Domain$Types$UrlChanged,
		cZ: $author$project$Domain$Types$LinkClicked,
		dq: $author$project$Subscriptions$subscriptions,
		dF: $author$project$Update$update,
		dI: $author$project$View$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$succeed(0))(0)}});}(this));